(function() {
    'use strict';

    angular
        .module('vobeApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ngAnimate',
            'ngSanitize',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            'duScroll',
            'slickCarousel',
            'payment',
            'ui.select',
            'angular-loading-bar',
            'angular-google-analytics',
            'rzSlider',
            "oc.lazyLoad",
            'currencyExchangeModule',
            'ngAria'
            //'wu.masonry'
            //'ngHandsontable',//I want this to be loaded ASYNC -> not in the webpack vendor.js or main.js, so using "oc.lazyLoad"
            // jhipster-needle-angularjs-add-module JHipster will add new module here

        ])
        .config(config)
        .config(analytics)
        .config(tagmanager)
        .config(stripeElements)
        .config(configLazyLoad)
        .run(run);

    stripeElements.$inject = ['StripeElementsProvider'];
    function stripeElements(StripeElementsProvider) {
        console.log('stripe elements provider init');
    }

    angular.element(function() {
        angular.bootstrap(document, ['vobeApp']);
    });

    function run(stateHandler, translationHandler, $rootScope, $timeout, $uibModalStack, $http, ENV, $transitions, $window, CookiesConsentStorageService, IN1_CONSENT) {
        'ngInject';
        stateHandler.initialize();
        translationHandler.initialize();

        //very important, this will enable analytics to pick up proper page tile which is ASYNC
        $transitions.onSuccess({}, function(transition) {
            $timeout(function() {
                $rootScope.$broadcast('$stateChangeSuccessAnalytics');
                if (typeof posthog !== 'undefined') {
                    posthog.capture('$pageview');
                }

            }, 10);

        });
    }

    function config($locationProvider, $qProvider, $sceDelegateProvider) {
        'ngInject';
        $locationProvider.hashPrefix('');
        $locationProvider.html5Mode({ enabled: true, requireBase: true });
        $qProvider.errorOnUnhandledRejections(false); //this stops errors being throws for unhandled rejections.
        $sceDelegateProvider.resourceUrlWhitelist([
            // Allow same origin resource loads.
            'self',
            // Allow loading from our assets domain. **.
            'https://go.mips.mu/**'
        ]);
    }

    tagmanager.$inject = ['TagManagerProvider'];

    function tagmanager(TagManagerProvider) {

        TagManagerProvider.setPageEvent('$stateChangeSuccessAnalytics');
        TagManagerProvider.ignoreFirstPageLoad(false);
        TagManagerProvider.delayScriptTag(true);
        TagManagerProvider.trackUrlParams(true);
    }

    function configLazyLoad($ocLazyLoadProvider) {
        'ngInject';
        $ocLazyLoadProvider.config({
            debug: true,
            serie: true,
            modules: [{
                name: 'ngHandsontable',
                files: [
                    'content/lazyload/handsontable/handsontable.full.min.js',
                    'content/lazyload/handsontable/handsontable.full.min.css',
                    'content/lazyload/handsontable/ngHandsontable.js'
                ],
                serie: true
            }]
        });

        $ocLazyLoadProvider.config({
            modules: [{
                name: 'zapper',
                files: [
                    'content/lazyload/zapper/zapper.ecommerce-2.0.2.min.js'
                ]
            }]
        });
    }

    analytics.$inject = ['AnalyticsProvider','$windowProvider'];

    function analytics(AnalyticsProvider, $windowProvider) {

        var $window = $windowProvider.$get();


        //no GTM and GA in China!
        var lang = $window.navigator.language || $window.navigator.userLanguage;
        if(lang && (lang.toLowerCase()=='zh-cn' || lang.toLowerCase()=='zh') &&  new Date().getTimezoneOffset()/60 == -8){
            //console.log("detected chinese user");
            //AnalyticsProvider.startOffline(true);
        }

        //AnalyticsProvider.logAllCalls(true);
        //AnalyticsProvider.enterDebugMode(true);
        AnalyticsProvider.delayScriptTag(true);

        //default values for above trackers, if they don't set those properties
        AnalyticsProvider.setAccount([]);
        AnalyticsProvider.useAnalytics(true); //Use analytics.js (universal)  instead of  ga.js (classic)
        AnalyticsProvider.useECommerce(true, true); //uses enhanced es.js (not ecommerce.js)
        AnalyticsProvider.trackUrlParams(true);
        AnalyticsProvider.trackPages(true);
        AnalyticsProvider.setDomainName('none');
        AnalyticsProvider.setPageEvent('$stateChangeSuccessAnalytics'); //$stateChangeSuccess
        AnalyticsProvider.useCrossDomainLinker(true);
        //AnalyticsProvider.setCrossLinkDomains(['bookin1.com']);

        // Ignore first page view (default is false).
        // Helpful when using hashes and whenever your bounce rate looks obscenely low.
        AnalyticsProvider.ignoreFirstPageLoad(true);

        //big HACK to make currency mutable
        var currency = new MutableString('USD');
        AnalyticsProvider.setCurrency(currency);
    }

    var MutableString = function(value) {
        String.call(this, value);
        this.text = value;
    };

    var tmp = function() {};
    tmp.prototype = String.prototype;
    MutableString.prototype = new tmp();
    MutableString.prototype.constructor = MutableString;

    MutableString.prototype.setText = function(text) {
        this.text = text;
    };
    MutableString.prototype.toString = function() {
        return this.text;
    };
    MutableString.prototype.valueOf = function() {
        return this.text;
    };
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('theguestbookfatal', {
            parent: 'app',
            url: '/theguestbook/fatal',
            data: {
                authorities: [],
                pageTitle : 'global.error'
            },
            views: {
                'content@': {
                    templateUrl: 'app/site/fatal/theguestbook-fatal.html',
                    controller: 'TheGuestbookFatalController',
                    controllerAs: 'vm'
                },
                'header@': {
                    //templateUrl: 'app/layouts/header/header.html',
                    //controller: 'BrandedHeaderController',
                    //controllerAs: 'vm'
                },
                'footer@': {
                    //templateUrl: 'app/layouts/footer/footer.html',
                    //controller: 'BrandedFooterController',
                    //controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                   // console.log("here fatal global");
                }]
            }
        })
        .state('site', {
            abstract: true,
            parent: 'app',
            /*views: {
            	//shopping cart view is in the navbar.html (in navbar ui-view of 'app' state)
                'shoppingCart@app': {
                    templateUrl: 'app/site/shoppingcart/shopping-cart-dropdown.html',
                    controller: 'ShoppingCartDropdownController',
                    controllerAs: 'vm'
                }
            },*/
            resolve : {
                currentLanguage: ['$stateParams','$translate','JhiLanguageService','$q','translationStorageProvider',function($stateParams, $translate, JhiLanguageService, $q, translationStorageProvider){
                	//the below will work before stateHandler:
                	/*if($stateParams.lang){
                		//console.log("$stateParams.lang: "+$stateParams.lang.toLowerCase());
                		translationStorageProvider.put($translate.storageKey(),$stateParams.lang.toLowerCase());

                		return $translate.use($stateParams.lang.toLowerCase()).then(function(v){
                			//console.log("$translate.use: "+v);
                			return JhiLanguageService.getCurrent().then(function(v){
                    			//console.log("JhiLanguageService.getCurrent(): "+v);
                    			return v;
                    		});
                		});
                	}
                	else {
                		return JhiLanguageService.getCurrent().then(function(v){
                			//console.log("JhiLanguageService.getCurrent(): "+v);
                			return v;
                		});
                	}*/
                    return JhiLanguageService.getCurrent().then(function(v){
                        //console.log("JhiLanguageService.getCurrent(): "+v);
                        return v;
                    });
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .directive('onFinishRender', OnFinishRenderDirective);

    OnFinishRenderDirective.$inject = ['$timeout'];

    function OnFinishRenderDirective($timeout){
        return {
            restrict: 'A',
            compile: function(element, attributes){

                return {
                    post: function(scope, element, attr, controller, transcludeFn){
                        if (scope.$last === true) {
                            $timeout(function () {
                                console.log("fireing OnFinishRenderDirective",scope);
                                scope.$emit(attr.onFinishRender,{element:element, scopeId:scope.$id});
                                //scope.$broadcast(attr.onFinishRender,{scope:scope,element:scope,attr:attr});
                            },0);
                        }
                    }
                }
            }
            /*

            link: function (scope, element, attr) {
                if (scope.$last === true) {
                    $timeout(function () {
                        console.log("fireing OnFinishRenderDirective",scope);
                        scope.$emit(attr.onFinishRender,{element:element});
                        //scope.$broadcast(attr.onFinishRender,{scope:scope,element:scope,attr:attr});
                    },0);
                }
            }
            */
        }
	}

})();

(function() {
    'use strict';

    angular.module('vobeApp').factory('TermsService', TermsService);

    TermsService.$inject = ['$resource'];

    function TermsService($resource) {
        var service = $resource(
            'api/terms',
            {},
            {
                query: { method: 'GET', isArray: false },
                get: {
                    method: 'GET',
                    transformResponse: function(data) {
                        if(!data || (typeof data === 'string' && data.length==0)){
                            return data;
                        }
                        data = angular.fromJson(data);
                        return data;
                    }
                }
            }
        );

        return service;
    }
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('ShoppingCartTermsDialogController', ShoppingCartTermsDialogController);

    ShoppingCartTermsDialogController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', '$uibModalInstance', 'terms' ];

	function ShoppingCartTermsDialogController($scope, $rootScope, $state, $stateParams, $uibModalInstance, terms) {
	    var vm = this;

	    vm.terms = terms;
	    vm.clear = clear;
	    
	    function clear () {
            $uibModalInstance.dismiss('cancel');
        }

	}
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('ShoppingCartSummaryController', ShoppingCartSummaryController);

	function ShoppingCartSummaryController($scope, $rootScope, $state, $stateParams, ShoppingCartRemove, PromotionCodeService, CurrencyExchange, ShoppingCartService, $filter, $translate, $window) {
	    'ngInject';
	    var vm = this;

	    this.$onInit = function () {

            this.shoppingCartConfigs = this.shoppingCartConfigs || {};
            this.property = this.property || {};

            this.perBasketShipping = this.shoppingCartConfigs[''+this.property.hotelId].configMap.perBasketShipping === 'true';
            this.shoppingCart = this.shoppingCart || {};

            vm.removeItemFromCartAndRefresh = removeItemFromCartAndRefresh;
            vm.removeItemFromCartAndRefreshById = removeItemFromCartAndRefreshById;
            vm.removeItemFromCartAndRefreshByKey = removeItemFromCartAndRefreshByKey;
            vm.getAnyItemByPropertyId = getAnyItemByPropertyId;
            vm.getAnyItemByPropertyIdAndItemId = getAnyItemByPropertyIdAndItemId;
            vm.getAnyItemByPropertyIdAndItemUuid = getAnyItemByPropertyIdAndItemUuid;
            vm.countPropertyIds = countPropertyIds;

            vm.promotionCode = '';
            vm.addPromotionCode = addPromotionCode;
            vm.removePromotionCode = removePromotionCode;

            var propertyConfig = vm.shoppingCartConfigs[''+vm.property.hotelId];
            vm.showPromoControls = true;
            if(propertyConfig && propertyConfig.configMap && propertyConfig.configMap.hasActivePromotionCodes && propertyConfig.configMap.hasActivePromotionCodes=='false'){
                try {
                    vm.showPromoControls = false;
                } catch (e) {}
            }
            if(vm.forceHidePromoBox){
                vm.showPromoControls = false;
            }

            //currency
            vm.currentCurrency = {
                code : undefined
            }
            var currentCurrency = CurrencyExchange.currencies.current;//current currency might be NULL if this is group engine
            if(currentCurrency && currentCurrency!=null){
                vm.currentCurrency.code = currentCurrency.code;
            }

            $rootScope.$on('CurrencyExchangeProvider.changeCurrency', function(event, args) {
                vm.currentCurrency.code = args.code;
            });

            vm.applyOnceShipping = false;

            renderTotals();
            vm.updateShipping = updateShipping;


            var addPromotionCodeSuccessCallback = function(result){clearPromoCode()};
            var addPromotionCodeErrorCallback = function(reason){clearPromoCode()};
            var removePromotionCodeSuccessCallback = function(result){clearPromoCode()};
            var removePromotionCodeErrorCallback = function(reason){clearPromoCode()};
            vm.keyLength = keyLength;

            try {
                trackViewCart();
            } catch (e) {
                console.error(e);
            }

        }

        function trackViewCart() {

            //tag manager
            var dataLayer = $window.dataLayer = $window.dataLayer || [];

            var items = [];
            var totalValue = 0;

            angular.forEach(vm.shoppingCart.shoppingCartItems.items, function(item) {
                var itemData = {
                    item_id: item.itemId.toString(),
                    item_name: item.itemName,
                    affiliation: item.owningProperty.propertyName,
                    item_category: 'Gift Voucher',
                    discount: item.itemTotalPriceBeforeDiscount - item.itemTotalPrice,
                    item_brand: item.owningProperty.propertyName,
                    price: item.itemTotalPrice,
                    quantity: 1,
                    item_list_id: item.itemCategoryId ? item.itemCategoryId : 1,
                    item_list_name: item.itemCategoryName ? item.itemCategoryName : 'All',
                };

                items.push(itemData);
                totalValue += item.itemTotalPrice;
            });

            dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
            dataLayer.push({
                event: "view_cart",
                ecommerce: {
                    currency: vm.shoppingCart.shoppingCartItems.items[0].itemCurrency, // Assuming all items have the same currency
                    value: totalValue,
                    items: items
                }
            });

        }

        function renderTotals(){
            vm.totals = generateTotals(vm.shoppingCart.shoppingCartItems.items);
            vm.totalsPerPropertyInCurrentCurrency = generateTotalsPerPropertyInCurrentCurrency(vm.totals);
            vm.onUpdateTotals({value: {totals: vm.totals, totalsPerPropertyInCurrentCurrency: vm.totalsPerPropertyInCurrentCurrency}});
        }

        function generateTotals(shoppingCartItems) {
            var totalsMap = {};
            //group items per key
            angular.forEach(shoppingCartItems, function (item, index) {
                var key = item.itemId+'_'+$filter('number')(item.itemTotalPrice,2)+'_'+$filter('number')(item.itemTotalPriceBeforeDiscount,2)+'_'+item.recipient.deliveryMethodType+'_'+item.recipient.deliveryPersonType;
                //key = item.uuid;
                var totalValue = totalsMap[key] || {};
                totalValue.key = key;
                totalValue.currency = totalValue.currency || item.itemCurrency;
                totalValue.propertyId = totalValue.propertyId || item.owningProperty.propertyId;
                totalValue.deliveryPersonType = item.recipient.deliveryPersonType;
                totalValue.deliveryMethodType = item.recipient.deliveryMethodType;
                totalValue.itemName = totalValue.itemName || item.itemName;
                totalValue.itemId = totalValue.itemId || item.itemId;
                totalValue.items = totalValue.items || [];
                totalValue.items.push(item);
                totalValue.itemTotalPrice = totalValue.itemTotalPrice || item.itemTotalPrice;
                totalValue.itemTotalPriceBeforeDiscount = totalValue.itemTotalPriceBeforeDiscount || item.itemTotalPriceBeforeDiscount;

                //shipping

                //add total shipping per property
                totalValue.fulfillmentOptions = totalValue.fulfillmentOptions || (!vm.applyOnceShipping ? filterFulfillments(item, index) : []);

                //use fulfillment as priority over simple postage (id:0)
                let fulfillmentIds = [];
                if(totalValue.fulfillmentOptions){
                    angular.forEach(totalValue.fulfillmentOptions,function(fo){
                        fulfillmentIds.push(fo.id);
                    });
                }

                totalValue.fulfillmentOptionPrices = totalValue.fulfillmentOptionPrices || item.fulfillmentOptionPrices;

                let fulfillmentId = typeof item.recipient.fulfillmentId === 'undefined' || item.recipient.fulfillmentId==0 ? undefined : item.recipient.fulfillmentId;
                //if selected fulfillment is not on the list, reset it
                if(!fulfillmentIds.includes(fulfillmentId)){
                    fulfillmentId = undefined;
                }
                //if nothing selected, select the first one
                if(!fulfillmentId) {
                    fulfillmentId = fulfillmentIds[0];
                }
                totalValue.fulfillmentId = fulfillmentId;

                if (totalValue.fulfillmentOptions.length > 0) {
                    angular.forEach(totalValue.fulfillmentOptions, function (fo) {
                        if (fo.id === totalValue.fulfillmentId && fo.applyOnce) {
                            vm.applyOnceShipping = true;
                        }
                    });

                }
                totalsMap[key] = totalValue;
            });

            updateShippingPerItemKey(totalsMap);

            return totalsMap;
        }


        //this is to mitigate currency conversion rounding on the display
        function generateTotalsPerPropertyInCurrentCurrency() {
            var totalsMap = {};
            //group items per property
            angular.forEach(vm.shoppingCart.shoppingCartItems.items,function(item,index){
                var key = item.owningProperty.propertyId;
                var totalValue = totalsMap[key] || {};
                totalValue.key = key;
                totalValue.currency = totalValue.currency || vm.currentCurrency.code || item.itemCurrency;
                totalValue.itemCurrency = item.itemCurrency;
                totalValue.propertyName = totalValue.propertyName || item.owningProperty.propertyName;
                totalValue.propertyId = totalValue.propertyId || item.owningProperty.propertyId;
                totalValue.deliveryPersonType = item.recipient.deliveryPersonType;
                totalValue.deliveryMethodType = item.recipient.deliveryMethodType;

                totalValue.itemTotalPriceOriginal = totalValue.itemTotalPriceOriginal || 0;
                totalValue.itemTotalPriceOriginal += item.itemTotalPrice;

                totalValue.itemTotalPrice = totalValue.itemTotalPrice || 0;
                totalValue.itemTotalPrice += $filter('exchangenumber')(item.itemTotalPrice,item.itemCurrency,totalValue.currency);

                totalValue.itemTotalPriceBeforeDiscount = totalValue.itemTotalPriceBeforeDiscount || 0;
                totalValue.itemTotalPriceBeforeDiscount += $filter('exchangenumber')(item.itemTotalPriceBeforeDiscount,item.itemCurrency,totalValue.currency);

                //next add total shipping
                totalValue.totalShipping =  0;



                //next add total service fee
                totalValue.serviceFeeOriginal = 0;
                totalValue.serviceFee = 0;


                totalsMap[key] = totalValue;
            });

            //add shipping per property
            updateShippingPerProperty(totalsMap);


            //add service fee per property
            angular.forEach(totalsMap,function(totalValue,propertyId) {
                var serviceFeeOriginal = 0;
                var serviceFeeCurrency = totalValue.currency;//?
                if(typeof vm.propertyGroup!== 'undefined'){
                    //search for service fee among hotels
                    angular.forEach(vm.propertyGroup.hotels,function(hotel,hi){
                        if(hotel.hotelId==propertyId){
                            serviceFeeCurrency = hotel.hotelCurrency;
                            if(hotel.serviceFee && hotel.serviceFee.amount>0) {
                                var totalPrice = totalValue.itemTotalPriceOriginal;

                                if (hotel.serviceFee.percentage) {
                                    serviceFeeOriginal = totalValue.itemTotalPriceOriginal * hotel.serviceFee.amount / 100.0;
                                }
                                else {
                                    serviceFeeOriginal = hotel.serviceFee.amount
                                }
                            }
                        }

                    });
                } else {
                    serviceFeeCurrency = vm.property.hotelCurrency;
                    if(vm.property.serviceFee && vm.property.serviceFee.amount>0) {
                        var totalPrice = totalValue.itemTotalPriceOriginal;

                        if (vm.property.serviceFee.percentage) {
                            serviceFeeOriginal = totalValue.itemTotalPriceOriginal * vm.property.serviceFee.amount / 100.0;
                        }
                        else {
                            serviceFeeOriginal = vm.property.serviceFee.amount
                        }
                    }
                }
                totalValue.serviceFeeOriginal = serviceFeeOriginal;
                totalValue.serviceFee = $filter('exchangenumber')(serviceFeeOriginal,serviceFeeCurrency,totalValue.currency);
            });

            return totalsMap;
        }


        function updateShipping(){
            updateShippingPerItemKey(vm.totals);
            updateShippingPerProperty(vm.totalsPerPropertyInCurrentCurrency);
            vm.onUpdateTotals({value: {totals: vm.totals, totalsPerPropertyInCurrentCurrency: vm.totalsPerPropertyInCurrentCurrency}});
        }

        function updateShippingPerItemKey(totals){
            angular.forEach(totals, function (totalValue, totalItemKey) {
                totalValue.shipping = 0;

                if (totalValue.fulfillmentOptions && typeof totalValue.fulfillmentId !== 'undefined') {
                    totalValue.shipping = totalValue.fulfillmentOptionPrices[totalValue.fulfillmentId];
                }

                if (vm.customer && totalValue.fulfillmentOptions.length > 0) {
                    vm.customer.fulfillmentOptions = vm.customer.fulfillmentOptions || {};
                    vm.customer.fulfillmentOptions[totalItemKey] = totalValue.fulfillmentId;
                    angular.forEach(totalValue.fulfillmentOptions, function (fo) {
                        if (fo.id === totalValue.fulfillmentId) {
                            vm.customer.fulfillmentIdApplyOnce = fo.applyOnce;
                        }
                    });

                }
            });
        }

        function updateShippingPerProperty(totals) {

            angular.forEach(totals, function (totalValue, propertyId) {
                let totalShippingOriginal = 0;
                //convert propertyId to number
                propertyId = parseInt(propertyId);

                angular.forEach(vm.totals, function (totalItem, totalItemKey) {
                    if (totalItem.propertyId === propertyId && totalItem.fulfillmentOptions.length > 0) {
                        var applyOnce = false;
                        angular.forEach(totalItem.fulfillmentOptions, function (fo) {
                            if (fo.id === totalItem.fulfillmentId) {
                                applyOnce = fo.applyOnce;
                            }
                        });
                        totalShippingOriginal += totalItem.shipping * (applyOnce ? 1 : totalItem.items.length);
                        console.log('totalShippingOriginal', totalShippingOriginal)
                    }
                });
                totalValue.totalShippingOriginal = totalShippingOriginal;
                totalValue.totalShipping = $filter('exchangenumber')(totalShippingOriginal, vm.property.hotelCurrency, totalValue.currency);
            });
        }

	    function getAnyItemByPropertyId(propertyId){
	    	var anyItem;
	    	angular.forEach(vm.shoppingCart.shoppingCartItems.items,function(item,index){
                if (item.owningProperty.propertyId == propertyId) {
	    			anyItem = item;
	    		}
	    	});
	    	return anyItem;
	    }

        function getAnyItemByPropertyIdAndItemId(propertyId, itemId) {
            console.log('getAnyItemByPropertyIdAndItemId', propertyId, itemId)
            var anyItem;
            angular.forEach(vm.shoppingCart.shoppingCartItems.items, function (item, index) {
                console.log(item, item.owningProperty.propertyId)
                if (item.owningProperty.propertyId == propertyId && item.itemId == itemId) {
                    anyItem = item;
                }
            });
            return anyItem;
        }

        function getAnyItemByPropertyIdAndItemUuid(propertyId, itemUuid) {
            console.log('getAnyItemByPropertyIdAndItemId', propertyId, itemUuid)
            var anyItem;
            angular.forEach(vm.shoppingCart.shoppingCartItems.items, function (item, index) {
                if (item.uuid == itemUuid) {
                    anyItem = item;
                }
            });
            return anyItem;
        }

        function countPropertyIds(){
            var properties=[];
            angular.forEach(vm.shoppingCart.shoppingCartItems.items,function(item,index){
                if(!properties.includes(item.owningProperty.propertyId)){
                    properties.push(item.owningProperty.propertyId)
                }
            });
            return properties.length;
        }

        function removeItemFromCartAndRefreshById(event, itemId){

	        //find last item in totals and remove
            var removedTotalItemKey;//make sure we remove only one key
            angular.forEach(vm.totals,function(totalItem,totalItemKey){
                if(!removedTotalItemKey && totalItem.items){
                    angular.forEach(totalItem.items,function(item,i){
                        if(item.itemId == itemId){
                            removedTotalItemKey = totalItemKey;
                            var removedCartItem = totalItem.items.pop();
                            removeItemFromCartAndRefresh(event, removedCartItem.uuid);
                        }
                    });
                }

            });
        }

        function removeItemFromCartAndRefreshByKey(event, itemKey) {
            angular.forEach(vm.totals, function (totalItem, totalItemKey) {
                if (totalItemKey == itemKey) {
                    var itemsSize = totalItem.items.length;
                    angular.forEach(totalItem.items, function (item, i) {
                        if (i == itemsSize - 1) {
                            //refresh on the last item
                            removeItemFromCartAndRefresh(event, item.uuid);
                        } else {
                            console.log('>> removeItem', item.uuid);
                            removeItem(item.uuid);
                        }
                    });
                }
            });
        }

	    function removeItemFromCartAndRefresh(event, itemUUID){
	    	event.preventDefault();
	    	removeItem(itemUUID, refreshSite);
	    }

	    $scope.$watch('itemVM.promotionCode', function (value, oldValue) {
	        if(value=='' && value!=oldValue){
	        	clearPromoCode();
	        }
	    });

	    function clearPromoCode(){
	    	if(vm.promotionCodeForm){
	    		PromotionCodeService.clearPromoCode(vm.promotionCodeForm['promotionCode']);
	        }
	    	vm.promotionCode = '';
            vm.totals = generateTotals(vm.shoppingCart.shoppingCartItems.items);
            vm.totalsPerPropertyInCurrentCurrency = generateTotalsPerPropertyInCurrentCurrency();
	    }

		function addPromotionCode(event){
			event.preventDefault();
			PromotionCodeService.addPromocode(vm.shoppingCart, vm.promotionCodeForm['promotionCode'], vm.property.hotelId, vm.promotionCode)
                .then(addPromotionCodeSuccessCallback,addPromotionCodeErrorCallback);
			//clearPromoCode();
	    }

		function removePromotionCode(event, id){
			event.preventDefault();
			PromotionCodeService.removePromocode(vm.shoppingCart,vm.promotionCodeForm['promotionCode'], id)
                .then(removePromotionCodeSuccessCallback,removePromotionCodeErrorCallback);
	    }

	    function refreshSite(){
            console.log('>> refreshSite', $state.current, $stateParams);
		    $state.transitionTo($state.current, $stateParams, {
		    	  reload: 'site', inherit: true, notify: true
		    });
	    }

	    function removeItem(itemUUID, callback){
            console.log('>> removeItem', itemUUID, callback);

            var cb = callback || angular.noop;

            var item = getAnyItemByPropertyIdAndItemUuid(vm.property.hotelId, itemUUID);
            console.log('>> pre -- trackRemoveItemFromCart', item);

            return ShoppingCartRemove.remove({itemUUID : itemUUID},
                function (response) {
                    trackRemoveItemFromCart(item);
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
	    }

        function trackRemoveItemFromCart(item){
            console.log('trackRemoveItemFromCart', item);
            //ga4
            var dataLayer = window.dataLayer || [];
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "remove_from_cart",
                ecommerce: {
                    currency: item.itemCurrency,
                    value: item.itemTotalPrice,
                    items: [
                        {
                            item_id: item.itemId,
                            item_name: item.itemName,
                            discount: item.itemTotalPriceBeforeDiscount - item.itemTotalPrice,
                            index: 0,
                            item_brand: item.owningProperty.propertyName,
                            price: item.itemTotalPrice,
                            quantity: 1
                        }
                    ]
                }
            });
        }

        function keyLength(obj) {
            return Object.keys(obj).length;
        }


        function filterFulfillments(item, itemIndex) {
            let fulfillments = [];
            if(item.fulfillmentOptions){
                angular.forEach(item.fulfillmentOptions,function(fo){
                    if(item.recipient.deliveryMethodType=="post" && fo.postal){
                        fulfillments.push(fo);
                    } else if(item.recipient.deliveryMethodType=="collect" && fo.collection){
                        fulfillments.push(fo);
                    } else if (item.recipient.deliveryMethodType == "email" && fo.electronic) {
                        fulfillments.push(fo);
                    }
                });
            }

            if (fulfillments.length > 1) {
                //remove generic one
                for (let i = 0; i < fulfillments.length; i++) {
                    if (fulfillments[i].id == 0) {
                        fulfillments.splice(i, 1);
                        i--;
                    }
                }
            }

            return fulfillments.sort(compareFulfillments);
        }

        function compareFulfillments(a, b) {
            if (a.price<b.price) {
                return -1;
            }
            if (a.price>b.price) {
                return 1;
            }
            // a must be equal to b
            return 0;
        }


        vm.getFulfillmentNameInLang = function(fo) {
            let lang = ($translate.use() || 'en' ).split('_')[0].split('-')[0];
            let name = fo.name;
            if (lang!='en' && fo.fulfillmentOptionTranslations){
                angular.forEach(fo.fulfillmentOptionTranslations,function(t){
                    if(t.languageCode==lang){
                        name = t.name;
                    }
                });
            }
            return name;
        }

        vm.getFulfillmentDescriptionInLang = function(fo) {
            let lang = ($translate.use() || 'en' ).split('_')[0].split('-')[0];
            let description = fo.description;
            if (lang!='en' && fo.fulfillmentOptionTranslations){
                angular.forEach(fo.fulfillmentOptionTranslations,function(t){
                    if(t.languageCode==lang){
                        description = t.description;
                    }
                });
            }
            return description;
        }

	}
})();

(function() {
    'use strict';

    angular.module('vobeApp').component('shoppingCartSummary', {
        templateUrl: 'app/site/shoppingcart/shopping-cart-summary.html',
        controller: 'ShoppingCartSummaryController',
        controllerAs: 'itemVM',
        bindings: {
            shoppingCart: '<',
            shoppingCartConfigs: '<',
            property: '<',
            propertyGroup: '<',
            forceHidePromoBox: '<',
            customer: '<',
            paymentForm: '<',
            paymentFormInvalid: '<',
            onUpdateTotals: '&',
        }
    });

    angular.module('vobeApp').component('shoppingCartSummaryTgb', {
        templateUrl: 'app/site/shoppingcart/shopping-cart-summary.html',
        controller: 'ShoppingCartSummaryController',
        controllerAs: 'itemVM',
        bindings: {
            shoppingCart: '<',
            shoppingCartConfigs: '<',
            property: '<',
            propertyGroup: '<',
            forceHidePromoBox: '<',
            paymentForm: '<',
            paymentFormInvalid: '<',
            onUpdateTotals: '&',
        }
    });
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('ShoppingCartRemove', ShoppingCartRemove);

    ShoppingCartRemove.$inject = ['$resource'];

    function ShoppingCartRemove ($resource) {
        var service = $resource('api/shoppingcart/remove/:itemUUID', {}, {
            'remove': {
                method: 'DELETE',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .controller('ShoppingCartPreviewController', ShoppingCartPreviewController);


    function ShoppingCartPreviewController($scope, $rootScope, $state, $filter, $uibModalInstance, currentProperty, currentPropertyGroup, shoppingCart, $sce, currentLanguage, shoppingCartConfigs, templateItem, CurrencyExchange, params) {
        'ngInject';

        console.log('=> ShoppingCartPreviewController ...', params.uuid)

        var vm = this;
        vm.previewItem = {}
        vm.found = false;
        vm.clear = clear;

        if(templateItem && typeof templateItem !== 'string'){
            render(templateItem);
        } else {
            angular.forEach(shoppingCart.shoppingCartItems.items, function (v, i) {
                if (v.uuid === params.uuid) {
                    render(v);
                }
            });
        }



        //https://stackoverflow.com/questions/12793045/adding-months-to-a-date-in-javascript
        function addMonths(date, months) {
        	  var d = date.getDate();
        	  date.setMonth(date.getMonth() + +months);
        	  if (date.getDate() != d) {
        	    date.setDate(0);
        	  }
        	  return date;
        }

        function clear () {
            console.log('=> preview modal dismiss')
            $uibModalInstance.dismiss('cancel');
        }

        function render(v){
            console.log('=> preview render')

            //currency
            vm.currentCurrency = {
                code : undefined
            }
            var currentCurrency = CurrencyExchange.currencies.current;//current currency might be NULL if this is group engine
            if(currentCurrency && currentCurrency!=null){
                vm.currentCurrency.code = currentCurrency.code;
            }

            $rootScope.$on('CurrencyExchangeProvider.changeCurrency', function(event, args) {
                vm.currentCurrency.code = args.code;
            });


            vm.found = true;
            vm.previewItem = v;

            //fill in the values
            vm.voucherName = v.itemName;
            vm.voucherCurrency = v.itemCurrency;
            vm.voucherTotal = v.itemTotalPrice;
            vm.voucherTotalBeforeDiscount = v.itemTotalPriceBeforeDiscount && v.itemTotalPriceBeforeDiscount>0 ? v.itemTotalPriceBeforeDiscount : v.itemTotalPrice;
            if(v.itemType=='cash'){
                vm.voucherName = vm.voucherCurrency+' '+vm.voucherTotalBeforeDiscount;
            }

            var canUseDisplayCurrency = false;
            if (shoppingCartConfigs[currentProperty.hotelId] && shoppingCartConfigs[currentProperty.hotelId].configMap && shoppingCartConfigs[currentProperty.hotelId].configMap.canUseDisplayCurrency) {
                canUseDisplayCurrency = shoppingCartConfigs[currentProperty.hotelId].configMap.canUseDisplayCurrency;
            }
            if(canUseDisplayCurrency && vm.currentCurrency.code){
                vm.voucherCurrency = vm.currentCurrency.code;
                vm.voucherTotal = $filter('exchangenumber')(vm.voucherTotal,v.itemCurrency,vm.currentCurrency.code);
                vm.voucherTotalBeforeDiscount = $filter('exchangenumber')(vm.voucherTotalBeforeDiscount,v.itemCurrency,vm.currentCurrency.code);
                if(v.itemType=='cash'){
                    vm.voucherName = vm.voucherCurrency+' '+vm.voucherTotalBeforeDiscount;
                }
            }

            vm.dateOfPurchase = new Date();

            var expiryMonths = 12;
            if (v.itemMeta.validMonths && v.itemMeta.validMonths > 0) {
                expiryMonths = v.itemMeta.validMonths;
            } else if (v.owningProperty.propertyCode.toLowerCase() === 'mocouk') {
                expiryMonths = 24;
            } else if (v.owningProperty.propertyCode.toLowerCase() === 'iil') {
                expiryMonths = 18;
            } else if (shoppingCartConfigs && shoppingCartConfigs[v.owningProperty.propertyId] && shoppingCartConfigs[v.owningProperty.propertyId].configMap && shoppingCartConfigs[v.owningProperty.propertyId].configMap.validMonths) {
                var configExpiryMonths = 0;
                try {
                    configExpiryMonths = parseInt(shoppingCartConfigs[v.owningProperty.propertyId].configMap.validMonths);
                } catch (err) {
                }
                if (configExpiryMonths > 0) {
                    expiryMonths = configExpiryMonths;
                }
            }



            vm.expiryDate = addMonths(new Date(),expiryMonths);

            vm.voucherDescription = v.itemDescription;
            vm.recipientEmail = v.recipient.email;
            vm.senderName = '***';
            if(vm.previewItem.additionalFields && vm.previewItem.additionalFields['not_valid_before_date'] && vm.previewItem.additionalFields['not_valid_before_date']>0){
                vm.dateOfPurchase = new Date(vm.previewItem.additionalFields['not_valid_before_date']*1000);
            }
            if(vm.previewItem.additionalFields && vm.previewItem.additionalFields['not_valid_after_date'] && vm.previewItem.additionalFields['not_valid_after_date']>0){
                vm.expiryDate = new Date(vm.previewItem.additionalFields['not_valid_after_date']*1000);
            }

            vm.receiverName = '';
            if (v.recipient.firstName) {
                //console.log(v.recipient.firstName);
                vm.receiverName += v.recipient.firstName + ' ';
            }
            if (v.recipient.lastName) {
                //.log(v.recipient.lastName);
                vm.receiverName += v.recipient.lastName;
            }
            if (vm.receiverName == '') {
                vm.receiverName = '***  ';
            }

            //override if dedicationTo is set
            if (v.recipient.dedicationTo) {
                vm.receiverName = v.recipient.dedicationTo;
            }

            if (v.recipient.dedicationFrom) {
                vm.senderName = v.recipient.dedicationFrom;
            }


            vm.deliveryPersonType = v.recipient.deliveryPersonType;
            if(vm.deliveryPersonType === undefined){
                vm.deliveryPersonType = "customer";
            }

            vm.showValue = v.recipient.showValue;
            if(vm.showValue === undefined){
                vm.showValue = true;
            }
            if(vm.showValue === null){
                vm.showValue = true;
            }

            vm.receiverEmail = v.recipient.email;


            vm.message = '';
            if (!angular.isUndefined(v.recipient.message)) {
                vm.message = v.recipient.message;
            }

            vm.emailPropertyId = v.owningProperty.propertyId;

            var tgb = false;
            if(shoppingCart && shoppingCart.shoppingCartProperties && shoppingCart.shoppingCartProperties.additionalFields && shoppingCart.shoppingCartProperties.additionalFields['tgb_redemption_id']){
                tgb = true;
            }

            vm.templatePreview = '/assets/property/email/preview/sample?'+
                'propertyId='+vm.emailPropertyId+
                '&userLang='+(currentLanguage || 'en' ).split('_')[0].split('-')[0]+
                '&voucherType='+v.itemType+
                '&showValue='+vm.showValue+
                '&emailCategoryId='+params.emailCategoryId+
                '&deliveryPersonType='+vm.deliveryPersonType+
                '&voucherId='+v.itemId+
                '&source='+params.src+
                '&referrer='+params.ref+
                '&tgb='+tgb;

            if(params.channel){
                vm.templatePreview+='&channel='+params.channel;
            }
            if(typeof currentPropertyGroup !== 'undefined'){
                vm.templatePreview+='&groupCode='+currentPropertyGroup.code;
            }
        }

    }
})();

// (function() {
//     'use strict';
//
//     angular
//     .module('vobeApp')
//     .controller('ShoppingCartItemVoucherController', ShoppingCartItemVoucherController);
//
//     ShoppingCartItemVoucherController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'ShoppingCartRemove','CountriesService','CountriesWithoutPostcodeService','ExplainDeliveryPersonService', '$translate', '$uibModal', '$document', '$sce'];
//
// 	function ShoppingCartItemVoucherController($scope, $rootScope, $state, $stateParams, ShoppingCartRemove, CountriesService,CountriesWithoutPostcodeService, ExplainDeliveryPersonService, $translate, $uibModal, $document, $sce) {
// 	    var itemVM = this;
//
//
// 	    itemVM.shoppingCart = $scope.vm.shoppingCart;
// 	    itemVM.shoppingCartConfigs = $scope.vm.shoppingCartConfigs;
//         itemVM.emailConfig = $scope.vm.emailConfig;
//
// 	    itemVM.cartItem = $scope.cartItem;
//
//         itemVM.explicitlyTrustedItemDescription = $sce.trustAsHtml(itemVM.cartItem.itemDescription);
//
// 	    itemVM.getFullName = getFullName;
// 	    itemVM.copyRecipientFromPrevious = copyRecipientFromPrevious;
// 	    itemVM.copyDedicationFromPrevious = copyDedicationFromPrevious;
//
// 	    itemVM.removeItemFromCartAndRefresh = removeItemFromCartAndRefresh;
//         itemVM.previewVoucher = previewVoucher;
//
// 	    itemVM.configMap = {
// 	    		cashDefault : "1",
// 	    		customerIsRecipient : "false",
// 	    		disableDeliverToCustomer : "false",
// 	    		disableRecipientMessage : "false",
// 	    		disableAmountVisibilityOption : (itemVM.cartItem.itemType=='cash' || itemVM.cartItem.itemType=='cash-wildcard' ? 'true' : 'false'),
// 	    		emailOption : "true",
// 	    		postalOption : "false",
// 	    		limitQuantity : 999,
// 	    		confirmEmail: "false"
// 	    };
//
// 	    itemVM.emailConfigMap = {
// 	        emailPreview: "true"
//         };
//
// 	    itemVM.emailCategories = [];
//
// 	    //extend default config with property config
//         //TODO: group shopping cart and email config
// 	    var currentPropertyId = itemVM.cartItem.owningProperty.propertyId;
// 	    if(itemVM.shoppingCartConfigs && itemVM.shoppingCartConfigs[currentPropertyId]){
// 	    	angular.extend(itemVM.configMap,itemVM.shoppingCartConfigs[currentPropertyId].configMap);
// 	    }
//
// 	    //extend the emailConfig
// 	    if (itemVM.emailConfig && itemVM.emailConfig[currentPropertyId]) {
// 	        angular.extend(itemVM.emailConfigMap, itemVM.emailConfig[currentPropertyId].configMap);
// 	        //console.info('emailCategories', itemVM.emailConfig[currentPropertyId].emailCategories)
//             itemVM.emailCategories = itemVM.emailConfig[currentPropertyId].emailCategories;
//         }
//
// 	    function availableEmailCaregory(id){
// 	    	var matched = false;
// 	    	if(itemVM.emailCategories && id){
// 	    		angular.forEach(itemVM.emailCategories,function(c,i){
// 	    			if(c.id==id){
// 	    				matched= true;
// 	    			}
// 	    		});
// 	    	}
//
// 	    	return matched ? id : 1;
// 	    }
//
//
// 	    //gift cards can only be sent by post
// 	    if(itemVM.cartItem.itemGiftCardId && itemVM.cartItem.itemGiftCardId>0){
// 	    	itemVM.configMap.emailOption = "false";
// 	    	itemVM.configMap.postalOption = "true";
// 	    }
//
// 	    //the guest book has defaults
// 	    if($stateParams.channel==20 || $stateParams.channel=='20'){
// 	    	itemVM.configMap.emailOption = "true";
// 	    	itemVM.configMap.postalOption = "false";
// 	    	itemVM.configMap.customerIsRecipient = "false",
// 	    	itemVM.configMap.disableDeliverToCustomer = "true",
// 	    	itemVM.configMap.disableRecipientMessage = "true",
// 	    	itemVM.configMap.disableAmountVisibilityOption = "true";
// 	    	itemVM.configMap.showTAndC = "true";
// 	    	itemVM.cartItem.termsAgreed = false;
// 	    }
//
//
//
// 	    var baseRecipient = {
// 	    		firstName : itemVM.cartItem.recipient.firstName || undefined,
// 	    		lastName : itemVM.cartItem.recipient.lastName || undefined,
// 	    		country : '',
// 	    		message: itemVM.cartItem.recipient.message || undefined,
// 	    		deliveryMethodType : itemVM.cartItem.recipient.deliveryMethodType || defaultDeliveryMethodType(itemVM.cartItem),
// 	    		deliveryPersonType : itemVM.cartItem.recipient.deliveryPersonType || defaultDeliveryPersonType(itemVM.cartItem),
// 	    		showValue : itemVM.cartItem.recipient.showValue || (itemVM.cartItem.itemType=='cash' || itemVM.cartItem.itemType=='cash-wildcard' ? 'true' : defaultShowValue(itemVM.cartItem)),
// 				emailCategoryId: availableEmailCaregory(itemVM.cartItem.recipient.emailCategoryId)
// 	    };
//
//
// 	    if(!itemVM.cartItem.recipient || !itemVM.cartItem.recipient.uuid || itemVM.cartItem.recipient.uuid.length==0){
// 	    	angular.extend(itemVM.cartItem.recipient , baseRecipient);
// 	    }
//
//
// 	    itemVM.hideCustomizationBox = (
// 	    		   itemVM.configMap.customerIsRecipient==='true'
// 	    		&& (itemVM.configMap.disableRecipientMessage==='true'
// 	    			|| itemVM.configMap.disableRecipientMessage==='trueWithDefault'
// 	    			|| (itemVM.configMap.disableRecipientMessage == 'trueForPost' && itemVM.cartItem.recipient.deliveryMethodType=='post' )
// 	    			|| (itemVM.configMap.disableRecipientMessage == 'trueForEmail' && itemVM.cartItem.recipient.deliveryMethodType=='email' )
// 	    			)
// 	    	    && itemVM.configMap.disableAmountVisibilityOption==='true'
// 	    	    && (itemVM.cartItem.recipient.deliveryMethodType=='post' || itemVM.emailCategories.length==0)
// 	    );
//
// 	    function defaultDeliveryMethodType (item){
// 	    	if(item.itemGiftCardId && item.itemGiftCardId>0){
// 	    		return 'post';
// 	    	}
// 		    if(item.owningProperty.propertyId==297 /*IIL*/){
// 		    	return undefined;
// 		    }
// 		    if(['MDVHIE','CLYVIE','MDHVUK','CLYVUK','CWHVIE','CHSVIE','CHGVIE','MHSVIE'].indexOf(item.owningProperty.propertyCode.toUpperCase())!=-1){
// 		    	return undefined;
// 		    }
// 		    if(itemVM.configMap.emailOption=='false' && itemVM.configMap.postalOption=='false'){
// 		    	return 'email';
// 		    }
// 		    else if(itemVM.configMap.emailOption=='false'){
// 		    	return 'post';
// 		    }
// 		    return 'email';
// 	    }
//
// 	    function defaultDeliveryPersonType (item){
// 	    	if(['MDVHIE','CLYVIE','MDHVUK','CLYVUK','CWHVIE','CHSVIE','CHGVIE','MHSVIE'].indexOf(item.owningProperty.propertyCode.toUpperCase())!=-1){
// 		    	return undefined;
// 		    }
// 		    return 'customer';
// 	    }
//
// 	    function defaultShowValue(item){
// 	    	if(['MDVHIE','CLYVIE','MDHVUK','CLYVUK','CWHVIE','CHSVIE','CHGVIE','MHSVIE'].indexOf(item.owningProperty.propertyCode.toUpperCase())!=-1){
// 		    	return undefined;
// 		    }
//             if(['BSHVUK'].indexOf(item.owningProperty.propertyCode.toUpperCase())!=-1){
//                 return 'true';
//             }
//             if(item.itemType=='package'){
//                 return 'false';
//             }
// 		    return 'true';
// 	    }
//
//
// 	    function getFullName(firstName,lastName){
// 	    	var arr = [];
// 	    	if(firstName){
// 	    		arr.push(firstName);
// 	    	}
// 	    	if(lastName){
// 	    		arr.push(lastName);
// 	    	}
//
// 	    	return arr.join(' ');
// 	    }
//
//
// 	    function copyRecipientFromPrevious(event, currentIndex){
// 	    	event.preventDefault();
// 	    	var previousItem = itemVM.shoppingCart.shoppingCartItems.items[currentIndex-1];
//
// 	    	itemVM.cartItem.recipient.email = previousItem.recipient.email;
// 	    	itemVM.cartItem.recipient.address = previousItem.recipient.address;
// 	    	itemVM.cartItem.recipient.town = previousItem.recipient.town;
// 	    	itemVM.cartItem.recipient.county = previousItem.recipient.county;
// 	    	itemVM.cartItem.recipient.postcode = previousItem.recipient.postcode;
// 	    	itemVM.cartItem.recipient.country = previousItem.recipient.country;
// 	    	itemVM.cartItem.recipient.phone = previousItem.recipient.phone;
// 	    }
//
// 	    function copyDedicationFromPrevious(event, currentIndex){
// 	    	event.preventDefault();
// 	    	var previousItem = itemVM.shoppingCart.shoppingCartItems.items[currentIndex-1];
//
// 	    	itemVM.cartItem.recipient.message = previousItem.recipient.message;
// 	    	itemVM.cartItem.recipient.firstName = previousItem.recipient.firstName;
// 	    	itemVM.cartItem.recipient.lastName = previousItem.recipient.lastName;
// 	    	itemVM.cartItem.recipient.hideValue = previousItem.recipient.hideValue;
// 			itemVM.cartItem.recipient.emailCategoryId = previousItem.recipient.emailCategoryId;
//
// 	    }
//
//
// 	    itemVM.selectCountry = [];
// 	    itemVM.noPostcodeCountries = [];
// 	    itemVM.isPostCodeRequired = true;
//
// 	    loadCountries(loadCountriesCallback);
// 	    loadCountriesWithoutPostcode(loadCountriesWithoutPostcodeCallback);
//
// 	    function loadCountries(callback){
//
// 	    	var cb = callback || angular.noop;
//
// 	    	CountriesService.get(function (response) {
//                 return cb(response);
//             });
//
// 	    }
//
// 	    function loadCountriesWithoutPostcode(callback){
//
// 	    	var cb = callback || angular.noop;
//
// 	    	CountriesWithoutPostcodeService.get(function (response) {
//                 return cb(response);
//             });
//
// 	    }
//
// 	    function loadCountriesCallback(data){
//
// 	    	//get countries from shopping basket and make them a priority
// 	    	var alreadyUsedCountryNames = [];
//
// 	    	if(typeof itemVM.cartItem.recipient.country === 'string' && itemVM.cartItem.recipient.country.length>0){
// 	    		alreadyUsedCountryNames.push(itemVM.cartItem.recipient.country);
// 	    	}
//
// 	    	angular.forEach(itemVM.shoppingCart.shoppingCartItems.items ,function(item, index){
// 	    		if(item.recipient.country){
// 	    			alreadyUsedCountryNames.unshift(item.recipient.country);
// 	    		}
// 	    		if(item.owningProperty.propertyCountry){
// 	    			alreadyUsedCountryNames.push(item.owningProperty.propertyCountry);
// 	    		}
// 	    	});
//
//
// 	    	//add priorities to countries
// 	    	angular.forEach(data.countries.country ,function(c, index){
// 	    		//add country priority
// 	    		var aIndex = alreadyUsedCountryNames.indexOf(c.countryName);
// 	    		var isPriority = aIndex>-1;
// 	    		var priorityIndex = aIndex-alreadyUsedCountryNames.length;
// 	    		if(isPriority){
// 	    			if(itemVM.cartItem.recipient.country && (typeof itemVM.cartItem.recipient.country==='string' || priorityIndex<itemVM.cartItem.recipient.country.priorityCountryIndex)){
// 	    				itemVM.cartItem.recipient.country = c;
// 	    	    	}
// 	    			var copy = angular.copy(c, {});
// 	    			copy.priorityGroupIndex = 1;//like any other
// 	    			copy.priorityCountryIndex = 1;//like any other
// 	    			data.countries.country.push(copy);
// 	    		}
// 	    		c.priorityCountryIndex = isPriority ? priorityIndex : 1;
// 	    		c.priorityGroupIndex = isPriority ? priorityIndex : 1;
//
// 	    	});
//
// 	    	itemVM.selectCountry = data.countries.country;
//
// 	    }
//
// 	    function loadCountriesWithoutPostcodeCallback(data){
//
// 	    	itemVM.noPostcodeCountries = data.countries.country;
// 	    	isPostCodeRequired();
// 	    }
//
// 	    function isPostCodeRequired(){
//
// 	    	var isPostCodeRequired = true;
// 	    	if(itemVM.cartItem.recipient === undefined || itemVM.cartItem.recipient === null){
// 	    		isPostCodeRequired = true;
// 	    	}
// 	    	else if(itemVM.cartItem.recipient.country === undefined || itemVM.cartItem.recipient.country === null){
// 	    		isPostCodeRequired = true;
// 	    	}
// 	    	else if(typeof itemVM.cartItem.recipient.country === 'string' && itemVM.cartItem.recipient.country.length==0){
// 	    		isPostCodeRequired = false;
// 	    	}
// 	    	else if(typeof itemVM.cartItem.recipient.country === 'string' && itemVM.cartItem.recipient.country.length>0){
// 		    	angular.forEach(itemVM.noPostcodeCountries ,function(c, index){
// 		    		if(c[0]==itemVM.cartItem.recipient.country){
// 		    			isPostCodeRequired = false;
// 		    		}
// 		    	});
// 	    	}
// 	    	else {
// 		    	angular.forEach(itemVM.noPostcodeCountries ,function(c, index){
// 		    		if(c[0]==itemVM.cartItem.recipient.country.countryName){
// 		    			isPostCodeRequired = false;
// 		    		}
// 		    	});
// 	    	}
//
// 	    	itemVM.isPostCodeRequired = isPostCodeRequired;
//
// 	    }
//
// 		$scope.$watch("itemVM.cartItem.recipient.country", function (newValue, oldValue) {
// 			isPostCodeRequired();
// 		});
//
//
// 	    function removeItemFromCartAndRefresh(event){
// 	    	event.preventDefault();
// 	    	removeItem(refreshSite);
//
// 	    }
//
// 	    function refreshSite(){
// 		    $state.transitionTo($state.current, $stateParams, {
// 		    	  reload: 'site', inherit: true, notify: true
// 		    });
// 	    }
//
//
// 	    function removeItem(callback){
//
//             var cb = callback || angular.noop;
//
//             return ShoppingCartRemove.remove({itemUUID : itemVM.cartItem.uuid},
//                 function (response) {
//                     return cb(response);
//                 },
//                 function (err) {
//                     return cb(err);
//                 }.bind(this)).$promise;
//
// 	    }
//
// 	    function previewVoucher() {
// 	        //console.info('preview voucher');
//             $state.go('shopping-cart.preview', {'uuid': itemVM.cartItem.uuid, 'emailCategoryId' : itemVM.cartItem.recipient.emailCategoryId });
//         }
//
// 	    $scope.$watch('itemVM.cartItem.recipient.deliveryMethodType', function() {
// 	    	itemVM.cartItem.termsAgreed = false;
// 	    });
//
//
// 	    itemVM.customExplain = {
// 	    		post: {
// 	    			customer : false,
// 	    			recipient : false
// 	    		},
// 	    		email : {
// 	    			customer : false,
// 	    			recipient : false
// 	    		}
// 	    };
//
// 	    updateExplainDescriptions('customer','email');
// 	    updateExplainDescriptions('customer','post');
// 	    updateExplainDescriptions('recipient','email');
// 	    updateExplainDescriptions('recipient','post');
//
// 	    function updateExplainDescriptions(person,type){
// 	    	ExplainDeliveryPersonService.get({
// 		    	id : itemVM.cartItem.owningProperty.propertyId,
// 		    	deliveryPerson : person,
// 		    	deliveryMethod : type,
// 		    	language : $translate.use()
// 		    }).$promise.then(function(response){
// 		    	//console.log("RESPONSE",response);
// 		    	if(response.text){
//     				itemVM.customExplain[type][person] = response.text;
//     			}
// 	    	});
// 	    }
//
//
// 	    var defaultModalOptions = {
//           animation: true,
//           ariaLabelledBy: 'modal-title',
//           ariaDescribedBy: 'modal-body',
//           templateUrl: 'app/site/shoppingcart/explain/explain-delivery-modal.html',
//           controller: 'ExplainModalInstanceCtrl',
//           controllerAs: '$ctrl',
//           size: 'lg',
//           appendTo: 'body',
//           resolve: {
//         	  customExplain: function () {
//               return itemVM.customExplain;
//             }
//           }
// 		}
//
// 	    itemVM.openExplainDeliveryModal = function (size, parentSelector) {
// 	        var parentElem = parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;
// 	        var modalOptions = angular.extend({},defaultModalOptions);
// 	        modalOptions.templateUrl = 'app/site/shoppingcart/explain/explain-delivery-modal.html';
// 	        modalOptions.appendTo = parentElem || modalOptions.appendTo;
// 	        modalOptions.size = size || modalOptions.size;
// 	        var modalInstance = $uibModal.open(modalOptions);
// 	        //modalInstance.result.then(function (something) {
// 	        //}, function () {
// 	        //  console.info('Modal dismissed at: ' + new Date());
// 	        //});
// 	    };
//
// 	    itemVM.openExplainDedicationModal = function (size, parentSelector) {
// 	        var parentElem = parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;
// 	        var modalOptions = angular.extend({},defaultModalOptions);
// 	        modalOptions.templateUrl = 'app/site/shoppingcart/explain/explain-dedication-modal.html';
// 	        modalOptions.appendTo = parentElem || modalOptions.appendTo;
// 	        modalOptions.size = size || modalOptions.size;
// 	        var modalInstance = $uibModal.open(modalOptions);
// 	    };
//
// 	    itemVM.openExplainValueModal = function (size, parentSelector) {
// 	    	var parentElem = parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;
// 	        var modalOptions = angular.extend({},defaultModalOptions);
// 	        modalOptions.templateUrl = 'app/site/shoppingcart/explain/explain-value-modal.html';
// 	        modalOptions.appendTo = parentElem || modalOptions.appendTo;
// 	        modalOptions.size = size || modalOptions.size;
// 	        var modalInstance = $uibModal.open(modalOptions);
// 	    };
//
// 	    itemVM.openExplainCopyModal = function (size, parentSelector) {
// 	    	var parentElem = parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;
// 	        var modalOptions = angular.extend({},defaultModalOptions);
// 	        modalOptions.templateUrl = 'app/site/shoppingcart/explain/explain-copy-modal.html';
// 	        modalOptions.appendTo = parentElem || modalOptions.appendTo;
// 	        modalOptions.size = size || modalOptions.size;
// 	        var modalInstance = $uibModal.open(modalOptions);
// 	    };
//
// 	}
// })();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('ShoppingCartEmptyController', ShoppingCartEmptyController);


	function ShoppingCartEmptyController($scope, $rootScope, $state, $stateParams, previousState, $anchorScroll, shoppingCart, shoppingCartConfigs, DetermineShopMoreState, currentProperty) {
	    'ngInject';
	    var vm = this;

	    vm.shoppingCart = shoppingCart;
	    vm.property=currentProperty;
	    vm.browseMore = browseMore;


	    function browseMore(event){
	    	event.preventDefault();
	    	var shopMoreState = DetermineShopMoreState.getShopMoreState();
	    	console.log('shopMoreState.name', shopMoreState.name)
	    	$state.go(shopMoreState.name, shopMoreState.params);
	    }

	}
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('ShoppingCartEditController', ShoppingCartEditController);

    function ShoppingCartEditController($scope, $rootScope, $state, $stateParams, previousState, $anchorScroll, shoppingCart, shoppingCartConfigs, ShoppingCartAddRecipients, ShoppingCartRemove, DetermineShopMoreState, emailConfig, currentProperty, currentPropertyGroup, currentLanguage, Analytics, $window) {
	    'ngInject';
	    var vm = this;

	    this.$onInit = function() {
            vm.shoppingCart = shoppingCart;

            if(shoppingCart.shoppingCartItems.items.length==0){
                console.log('go to empty shopping cart...')
                goToEmptyShoppingCart();
            }

            vm.currentProperty = currentProperty;
            vm.currentPropertyGroup = currentPropertyGroup;
            vm.currentLanguage = currentLanguage;
            vm.property = currentProperty;
            $rootScope.$broadcast('propertySelected', { 'property': vm.property });

            vm.channel = $stateParams.channel;


            vm.shoppingCartConfigs = shoppingCartConfigs;
            vm.emailConfig = emailConfig;
            vm.checkoutFormInvalid = false;

            vm.removeItemFromCartAndRefresh = removeItemFromCartAndRefresh;

            vm.browseMore = browseMore;
            vm.goToPayment = goToPayment;
            vm.goToConfirmation = goToConfirmation;

            $anchorScroll();

            trackCheckout();

            if($stateParams.revalidate){
                vm.checkoutFormInvalid = true;
            }
            sendDataLayerCheckoutStep();
        }


	    function browseMore(event){
	    	event.preventDefault();
	    	var shopMoreState = DetermineShopMoreState.getShopMoreState();
	    	$state.go(shopMoreState.name, shopMoreState.params);
	    }

	    function goToConfirmation(event){
	    	event.preventDefault();

	    	if(vm.checkoutForm.$invalid){
	    		vm.checkoutFormInvalid = true;
	    		return;
	    	}
	    	else {
	    		vm.checkoutFormInvalid = false;
	    		addRecipients(goToPaymentTransactionsState,refreshAndRevalidate);
	    	}
	    }


	    function goToPayment(event){
	    	event.preventDefault();

	    	if(vm.checkoutForm.$invalid){
	    		vm.checkoutFormInvalid = true;
	    		return;
	    	}
	    	else {
	    		vm.checkoutFormInvalid = false;
	    		addRecipients(goToPaymentState,refreshAndRevalidate);
	    	}
	    }


	    function goToEmptyShoppingCart(){
		    $state.go("shopping-cart-empty");
	    }

	    function goToPaymentState(){
		    $state.transitionTo("payment", $stateParams, {
		    	  reload: 'site', inherit: true, notify: true
		    });
	    }

	    //this is used by TGB to skip payments page
	    function goToPaymentTransactionsState(){
		    $state.transitionTo("transactions", $stateParams, {
		    	  reload: 'site', inherit: true, notify: true
		    });
	    };

	    function refreshAndRevalidate(){
	    	$stateParams.revalidate = true;
		    $state.transitionTo($state.current, $stateParams, {
		    	  reload: 'site', inherit: false, notify: true
		    });
	    };

        function addRecipients (callback, errorCallback) {
            var cb = callback || angular.noop;
            var ecb = errorCallback || angular.noop;

            var recipients = {
            		item : {}
            }

            angular.forEach(shoppingCart.shoppingCartItems.items, function(value, key) {

            	recipients.item[value.uuid] = value.recipient;
            	if(value.recipient && value.recipient.country && value.recipient.country.countryName){
            		if(value.recipient.deliveryMethodType=="post"){
            			recipients.item[value.uuid].country =  value.recipient.country.countryName;
            		}
            		else {
            			//nullify pre-selected recipient country
            			recipients.item[value.uuid].country = null;
            		}
            	}


            });

            return ShoppingCartAddRecipients.add(recipients,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return ecb(err);
                }.bind(this)).$promise;
        }


	    function removeItemFromCartAndRefresh(event, itemUUID){
	    	event.preventDefault();
	    	removeItem(itemUUID, refreshSite);

	    }

	    function refreshSite(){
		    $state.transitionTo($state.current, $stateParams, {
		    	  reload: 'site', inherit: true, notify: true
		    });
	    }


	    function removeItem(itemUUID, callback){

            var cb = callback || angular.noop;

            return ShoppingCartRemove.remove({itemUUID : itemUUID},
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;

	    }

        function trackCheckout(){

        	angular.forEach(shoppingCart.shoppingCartItems.items, function(item,index){
        		Analytics.addProduct(
	    				item.itemId,//productId
	    				item.itemName,//name
	    				item.itemType,//category
	    				item.owningProperty.propertyCode,//brand
	    				'',//variant
	    				item.itemTotalPrice,//price
	    				'1',//quantity
	    				'',//coupon
	    				''//position
	    				);
    	    });
        	Analytics.trackCheckout(1, 'Details');
        }

        var sendDataLayerCheckoutStep = function() {
            var dataLayer = $window.dataLayer = $window.dataLayer || [];

            var productsInCartGa4 = [];
            var overallRevenue = 0;
            angular.forEach(shoppingCart.shoppingCartItems.items, function (cartItem, index) {

                var itemData = {
                    item_id: cartItem.itemId.toString(),
                    item_name: cartItem.itemName,
                    index: index + 1,
                    price: cartItem.itemTotalPrice,
                    quantity: 1,
                    affiliation: cartItem.owningProperty.propertyName,
                };

                if (cartItem.itemCategoryId) {
                    itemData.item_list_id = cartItem.itemCategoryId;
                }

                if (cartItem.itemCategoryName) {
                    itemData.item_list_name = cartItem.itemCategoryName;
                }

                productsInCartGa4.push(itemData);
                overallRevenue += cartItem.itemTotalPrice;
            });

            //ga4
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "begin_checkout",
                ecommerce: {
                    currency: vm.currentProperty.hotelCurrency,
                    value: overallRevenue,
                    items: productsInCartGa4
                }
            });
        };

	}
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('ShoppingCartDropdownController', ShoppingCartDropdownController);

    ShoppingCartDropdownController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'shoppingCart', 'ShoppingCartRemove', '$translate'];

	function ShoppingCartDropdownController($scope, $rootScope, $state, $stateParams, shoppingCart, ShoppingCartRemove, $translate) {
	    var vm = this;

	    vm.shoppingCart = shoppingCart;
	    vm.removeItemFromCartAndRefresh = removeItemFromCartAndRefresh;
	    vm.getAnyItemByPropertyId = getAnyItemByPropertyId;
	    vm.goToShoppingCart = goToShoppingCart;
	    vm.maxHeighStyle = maxHeighStyle();

        vm.shoppingCartOpen = false;
        vm.shoppingCartToggled = shoppingCartToggled;
        vm.perishableAlerts = [];

	    function maxHeighStyle(){
	    	var viewportHeight = $(window).height();
	    	return {'max-height':(viewportHeight - 50)+'px'};
	    }

	    function getAnyItemByPropertyId(propertyId){
	    	var anyItem;
	    	angular.forEach(vm.shoppingCart.shoppingCartItems.items,function(item,index){
	    		if(item.owningProperty.propertyId==propertyId){
	    			anyItem = item;
	    		}
	    	});
	    	return anyItem;
	    }


	    function removeItemFromCartAndRefresh(event, itemUUID){
	    	event.preventDefault();
	    	removeItem(itemUUID, backToCurrent);

	    }

	    function backToCurrent(shoppingCart){
	    	$rootScope.$broadcast('itemRemovedFromCart', {shoppingCart : shoppingCart, openShoppingCartDropdown : true});
	    	if(!$state.includes('property.list')){
	    		$state.go($state.current,{}, { reload: true }).then(function() {
	    			vm.shoppingCartOpen = true;
	    		});
	    	}

	    }

	    function goToShoppingCart(event){
	    	event.preventDefault();
	    	//console.log("State params is shopping cart dropdown");
	    	///console.log($stateParams);
	    	//console.log($state);
	    	vm.shoppingCartOpen = false;
	    	//we need to reload
	    	$state.go('shopping-cart',{}, { reload: true });

	    }


	    function removeItem(itemUUID, callback){

            var cb = callback || angular.noop;

            return ShoppingCartRemove.remove({itemUUID : itemUUID},
                function (shoppingCart) {
                    return cb(shoppingCart);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;

	    }

        $scope.$on('itemAddedToCart',function(event, args){
        	vm.shoppingCart = args.shoppingCart;
        	vm.shoppingCartOpen = args.openShoppingCartDropdown ? true : false;
        	//vm.perishableAlerts.push({
        	//	msg : $translate.instant('shopping-cart.alert.added.success'),
        	//	type : "success"
        	//});
        	if($('#snackbar').length>0) {
                angular.element($("#snackbar")).parent().data('propertyAlertErrorScope').vm.addSuccessAlert('Added', 'shopping-cart.alert.added.success');
            }
        });

        $scope.$on('itemAddedToCartError',function(event, args) {
            if($('#snackbar').length>0) {
                angular.element($("#snackbar")).parent().data('propertyAlertErrorScope').vm.addErrorAlert('Error');
            }
        });

        $scope.$on('itemRemovedFromCart',function(event, args){
        	vm.shoppingCart = args.shoppingCart;
        	vm.shoppingCartOpen = args.openShoppingCartDropdown ? true : false;
        	//vm.perishableAlerts.push({
        	//	msg : $translate.instant('shopping-cart.alert.removed.success'),
        	//	type : "success"
        	//});
            if($('#snackbar').length>0) {
                angular.element($("#snackbar")).parent().data('propertyAlertErrorScope').vm.addSuccessAlert('Removed', 'shopping-cart.alert.removed.success');
            }
        });

        $rootScope.$on('openShoppingCartDropdown',function(){
        	if(!vm.shoppingCartOpen){
        		vm.shoppingCartOpen = true;
        	}
        });

        function shoppingCartToggled(open){
        	//when dropdown is closed, clear perishable alerts
        	//console.log("Cart is open: "+open);
        	if(!open){
        		vm.perishableAlerts = [];
        	}
        }

	}
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('ShoppingCartAddRecipients', ShoppingCartAddRecipients);

    ShoppingCartAddRecipients.$inject = ['$resource'];

    function ShoppingCartAddRecipients ($resource) {
        var service = $resource('api/shoppingcart/addRecipients', {}, {
            'add': {
                method: 'PUT',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('ShoppingCartAdd', ShoppingCartAdd);

    ShoppingCartAdd.$inject = ['$resource','AlertService'];

    function ShoppingCartAdd ($resource,AlertService) {
        var service = $resource('api/shoppingcart/add', {
            ref: '@requestParams.ref',
            src: '@requestParams.src',
            lang: '@requestParams.lang',
            contextType: '@requestParams.contextType',
            propertyType: '@requestParams.propertyType',
            propertyCode: '@requestParams.propertyCode',
            customerRef: '@requestParams.customerRef'
        }, {
            'add': {
                method: 'PUT',
                transformResponse: function (data, headers) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    if (headers('X-vobeApp-error-property') || headers('x-vobeapp-error-property') ) {
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('ShoppingCartAddBulkRecipientsAndItem', ShoppingCartAddBulkRecipientsAndItem);

    ShoppingCartAddBulkRecipientsAndItem.$inject = ['$resource'];

    function ShoppingCartAddBulkRecipientsAndItem ($resource) {
        var service = $resource('api/shoppingcart/addBulk', {
            ref: '@ref',
            src: '@src',
            lang: '@lang',
            contextType: '@contextType',
            propertyType: '@propertyType',
            propertyCode: '@propertyCode',
            customerRef: '@customerRef'
        }, {
            'add': {
                method: 'PUT',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('shopping-cart', {
            parent: 'property',
            url: '/shopping-cart?revalidate',
            data: {
                authorities: [],
                autoscroll : true,
                pageTitle: "shopping-cart.page.title"
            },
            views: {
                'content@': {
                    templateUrl: 'app/site/shoppingcart/shopping-cart-edit.html',
                    controller: 'ShoppingCartEditController',
                    controllerAs: 'vm'
                },
                'header@': {
                    templateUrl: 'app/layouts/header/header.html',
                    controller: 'BrandedHeaderController',
                    controllerAs: 'vm'
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.html',
                    controller: 'BrandedFooterController',
                    controllerAs: 'vm'
                },
                'cookies@': {
                    templateUrl: 'app/components/cookies-consent/cookies-banner.html',
                    controller: 'CookiesBannerController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'shopping-cart',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }],
                brandingTemplateUUID : ['brandingTemplateUUID',function(brandingTemplateUUID){
                	return brandingTemplateUUID;
                }],
                shoppingCartConfigs : ['shoppingCartConfigs',function(shoppingCartConfigs){
                    //from property state
                    return shoppingCartConfigs;
                }],
                emailConfig: ['VobeConfig', 'shoppingCart', function(vobeConfig, shoppingCart) {
                    var propertyIds = [];
                    angular.forEach(shoppingCart.shoppingCartItems.items, function(value, key) {
                        if(jQuery.inArray(value.owningProperty.propertyId, this) < 0 ){
                            this.push(value.owningProperty.propertyId);
                        }

                    }, propertyIds);
                    return vobeConfig.emailConfig.get({propertyIds : propertyIds}).$promise;
                }],
                currentProperty : ['currentProperty',function(currentProperty){
                	return currentProperty;
                }],
                currentPropertyGroup : ['currentPropertyGroup',function(currentPropertyGroup){
                    return currentPropertyGroup;
                }],
                currentLanguage : ['currentLanguage',function(currentLanguage){
                    return currentLanguage;
                }],
            	mainTranslatePartialLoader: ['$translate', '$translatePartialLoader','shoppingCart','currentProperty', '$stateParams', function ($translate,$translatePartialLoader,shoppingCart,currentProperty,$stateParams) {
            		var variant = "";
                	if($stateParams.contextType){
                		variant = "_"+$stateParams.contextType;
                	}
                	variant += "_"+currentProperty.hotelId;

            		$translatePartialLoader.addPart('vouchers'+variant);
	                var includeGiftCards = false;
                    var includeItems = false;
	                angular.forEach(shoppingCart.shoppingCartItems.items, function(value, key) {
	                	if(value.itemGiftCardId && value.itemGiftCardId>0 ){
	          			  includeGiftCards = true;
	                	}
	                	if(value.itemType=='package-product'){
                            includeItems = true;
                        }
	                });
	                if(includeGiftCards){
	                	$translatePartialLoader.addPart('giftcards'+variant);
	                }
                    if(includeItems){
                        $translatePartialLoader.addPart('items'+variant);
                    }
	                return $translate.refresh();
	            }]
            }
        })
        .state('shopping-cart.preview', {
            url: '/preview?uuid&emailCategoryId',
            data: {
                authorities: [],
                autoscroll : true
            },
            onEnter: function($transition$, $state, $uibModal, currentProperty, currentPropertyGroup, shoppingCart, currentLanguage, shoppingCartConfigs) {
                'ngInject';
                var params = $transition$.params();
                var modal = $uibModal.open({
                    templateUrl: 'app/site/shoppingcart/shopping-cart-preview.html',
                    controller: 'ShoppingCartPreviewController',
                    controllerAs: 'vm',
                    backdrop: 'true',
                    animation: false,
                    windowClass : '',
                    size: 'lg',
                    resolve : {
                        currentProperty: function(){
                            return currentProperty;
                        },
                        currentPropertyGroup: function(){
                            return currentPropertyGroup;
                        },
                        shoppingCart: function(){
                        	return shoppingCart;
                        },
                        currentLanguage: function(){
                        	return currentLanguage;
                        },
                        shoppingCartConfigs: function(){
                            return shoppingCartConfigs;
                        },
                        templateItem : function(){
                            return '';
                        },
                        params: function () {
                            return {
                                uuid: params.uuid,
                                src: params.src,
                                ref: params.ref,
                                emailCategoryId: params.emailCategoryId,
                                channel: params.channel
                            };
                        }
                    }
                });

                modal.result.then(function() {
                    var stillInShoppingCartPreview = $state.is('shopping-cart.preview');
                    if(stillInShoppingCartPreview){
                        $state.go('^', {}, { reload: false,location: 'replace' });
                    }
                }, function() {
                    var stillInShoppingCartPreview = $state.is('shopping-cart.preview');
                    if(stillInShoppingCartPreview){
                        $state.go('^', {}, { reload: false,location: 'replace' });
                    }
                });

                $state.currentModal = modal;

            },
            onExit: ['$state',function($state){
                $state.currentModal.close();
            }]
        })
        .state('shopping-cart.terms', {
            url: '/terms?uuid',
            data: {
                authorities: [],
                autoscroll : true
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'shoppingCart','currentLanguage', function($stateParams, $state, $uibModal, shoppingCart, currentLanguage) {
                var modal = $uibModal.open({
                    templateUrl: 'app/site/shoppingcart/shopping-cart-terms-dialog.html',
                    controller: 'ShoppingCartTermsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'false',
                    animation: false,
                    windowClass : '',
                    size: 'lg',
                    resolve : {
                        shoppingCart: shoppingCart,
                        terms : ['TermsService',function(TermsService){

                        	var cartItem;
                        	angular.forEach(shoppingCart.shoppingCartItems.items, function(value, key) {
                                if(value.uuid == $stateParams.uuid){
                                	cartItem = value;
                                }
                            });


                        	var language = currentLanguage;
                        	var delivery = cartItem.recipient.deliveryMethodType;
                		    var cb = angular.noop;

                            return TermsService.get(
                            		{propertyId : cartItem.owningProperty.propertyId,
                                     voucherId : cartItem.itemId,
                            		 lang : (language || 'en' ).split('_')[0].split('-')[0],
                            		 termsType : delivery
                            		},
                                    function (response) {
                                        return cb(response);
                                    },
                                    function (err) {
                                        return cb(err);
                                    }.bind(this)).$promise;
                        }]
                    }
                });

                modal.result.then(function() {
                    var stillIn = $state.is('shopping-cart.terms');
                    if(stillIn){
                        $state.go('^', {}, { reload: false });
                    }
                }, function() {
                    var stillIn = $state.is('shopping-cart.terms');
                    if(stillIn){
                        $state.go('^', {}, { reload: false });
                    }
                });

                $state.currentModal = modal;

            }],
            onExit: ['$state',function($state){
                $state.currentModal.close();
            }]
        })
        .state('shopping-cart-empty', {
            parent: 'shopping-cart',
            url: '/empty',
            data: {
                authorities: [],
                autoscroll : true
            },
            views: {
                'content@': {
                    templateUrl: 'app/site/shoppingcart/shopping-cart-empty.html',
                    controller: 'ShoppingCartEmptyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$stateParams','$translate', '$translatePartialLoader','currentProperty', function ($stateParams,$translate,$translatePartialLoader,currentProperty) {
                	var variant = "";
                	if($stateParams.contextType){
                		variant = "_"+$stateParams.contextType;
                	}
                	variant += "_"+currentProperty.hotelId;

                	$translatePartialLoader.addPart('shopping-cart'+variant);
                    return $translate.refresh();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'shopping-cart',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular.module('vobeApp').service('ShoppingCartService', function ($filter) {
        'ngInject';
        this.sharedFunction = function (param) {
            console.log('shared function called with param: ' + param)
        };

        this.generateTotals = function (shoppingCartItems) {
            var totalsMap = {};
            //group items per property
            angular.forEach(shoppingCartItems,function(item,index){
                var key = item.owningProperty.propertyId;
                var totalValue = totalsMap[key] || {};
                totalValue.key = key;
                totalValue.currency = totalValue.currency || vm.currentCurrency.code || item.itemCurrency;
                totalValue.itemCurrency = item.itemCurrency;
                totalValue.propertyName = totalValue.propertyName || item.owningProperty.propertyName;
                totalValue.propertyId = totalValue.propertyId || item.owningProperty.propertyId;
                totalValue.deliveryPersonType = item.recipient.deliveryPersonType;
                totalValue.deliveryMethodType = item.recipient.deliveryMethodType;

                totalValue.itemTotalPriceOriginal = totalValue.itemTotalPriceOriginal || 0;
                totalValue.itemTotalPriceOriginal += item.itemTotalPrice;

                totalValue.itemTotalPrice = totalValue.itemTotalPrice || 0;
                totalValue.itemTotalPrice += $filter('exchangenumber')(item.itemTotalPrice,item.itemCurrency,totalValue.currency);

                totalValue.itemTotalPriceBeforeDiscount = totalValue.itemTotalPriceBeforeDiscount || 0;
                totalValue.itemTotalPriceBeforeDiscount += $filter('exchangenumber')(item.itemTotalPriceBeforeDiscount,item.itemCurrency,totalValue.currency);

                //next add total shipping
                totalValue.totalShipping =  0;

                //next add total service fee
                totalValue.serviceFeeOriginal = 0;
                totalValue.serviceFee = 0;

                totalsMap[key] = totalValue;
            });

            //add shipping per property
            updateShippingPerProperty(totalsMap);


            //add service fee per property
            angular.forEach(totalsMap, function (totalValue, propertyId) {
                var serviceFeeOriginal = 0;
                var serviceFeeCurrency = totalValue.currency;//?
                if (typeof vm.propertyGroup !== 'undefined') {
                    //search for service fee among hotels
                    angular.forEach(vm.propertyGroup.hotels, function (hotel, hi) {
                        if (hotel.hotelId == propertyId) {
                            serviceFeeCurrency = hotel.hotelCurrency;
                            if (hotel.serviceFee && hotel.serviceFee.amount > 0) {
                                var totalPrice = totalValue.itemTotalPriceOriginal;

                                if (hotel.serviceFee.percentage) {
                                    serviceFeeOriginal = totalValue.itemTotalPriceOriginal * hotel.serviceFee.amount / 100.0;
                                } else {
                                    serviceFeeOriginal = hotel.serviceFee.amount
                                }
                            }
                        }

                    });
                } else {
                    serviceFeeCurrency = vm.property.hotelCurrency;
                    if (vm.property.serviceFee && vm.property.serviceFee.amount > 0) {
                        var totalPrice = totalValue.itemTotalPriceOriginal;

                        if (vm.property.serviceFee.percentage) {
                            serviceFeeOriginal = totalValue.itemTotalPriceOriginal * vm.property.serviceFee.amount / 100.0;
                        } else {
                            serviceFeeOriginal = vm.property.serviceFee.amount
                        }
                    }
                }
                totalValue.serviceFeeOriginal = serviceFeeOriginal;
                totalValue.serviceFee = $filter('exchangenumber')(serviceFeeOriginal, serviceFeeCurrency, totalValue.currency);
            });

            return totalsMap;
        }

        function updateShippingPerProperty(map) {

            angular.forEach(map, function (totalValue, propertyId) {
                let totalShippingOriginal = 0;
                angular.forEach(vm.totals, function (totalItem, totalItemKey) {
                    if (totalItem.propertyId == propertyId) {
                        totalShippingOriginal += totalItem.shipping * totalItem.items.length;
                    }
                });
                totalValue.totalShippingOriginal = totalShippingOriginal;
                totalValue.totalShipping = $filter('exchangenumber')(totalShippingOriginal, vm.property.hotelCurrency, totalValue.currency);
            });
        }

    });

})();

(function() {
    'use strict';

    angular.module('vobeApp').factory('ShoppingCart', ShoppingCart);

    function ShoppingCart($resource) {
        'ngInject';
        var service = $resource(
            'api/shoppingcart',
            {},
            {
                query: { method: 'GET', isArray: false },
                get: {
                    method: 'GET',
                    transformResponse: function(data) {
                        if(!data || (typeof data === 'string' && data.length==0)){
                            return data;
                        }
                        data = angular.fromJson(data);
                        return data;
                    }
                }
            }
        );


        return {
            api: service
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('ExplainDeliveryPersonService', ExplainDeliveryPersonService);

    ExplainDeliveryPersonService.$inject = ['$resource'];

    function ExplainDeliveryPersonService($resource) {
        var service = $resource('api/property/popup/:id/explain/deliveryPerson', {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;

    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('ExplainDeliveryMethodService', ExplainDeliveryMethodService);

    ExplainDeliveryMethodService.$inject = ['$resource'];

    function ExplainDeliveryMethodService($resource) {
        var service = $resource('api/property/popup/:id/explain/deliveryMethod', {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;

    }
})();

(function() {
	'use strict';

	angular.module('vobeApp').controller('ExplainModalInstanceCtrl', ExplainModalInstanceCtrl);

	function ExplainModalInstanceCtrl($uibModalInstance, customExplain, config) {
        'ngInject';
		var $ctrl = this;

		$ctrl.customExplain = customExplain;
        $ctrl.postalOption = (config.postalOption === 'true');


		$ctrl.ok = function() {
			$uibModalInstance.close();
		};

		$ctrl.cancel = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PromotionCodeRemove', PromotionCodeRemove);

    PromotionCodeRemove.$inject = ['$resource'];

    function PromotionCodeRemove ($resource) {
        var service = $resource('api/shoppingcart/promotionCode/:id', {}, {
            'remove': {
                method: 'DELETE',
                transformResponse: function (data, headers, status) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                	data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }

    angular
    .module('vobeApp')
    .factory('PromotionCodeAdd', PromotionCodeAdd);

    PromotionCodeAdd.$inject = ['$resource'];

    function PromotionCodeAdd ($resource) {
        var service = $resource('api/shoppingcart/promotionCode', {}, {
            'add': {
                method: 'POST',
                transformResponse: function (data, headers, status) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                	data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }

})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PromotionCodeService', PromotionCodeService);

    PromotionCodeService.$inject = ['PromotionCodeAdd', 'PromotionCodeRemove'];

    function PromotionCodeService (PromotionCodeAdd, PromotionCodeRemove) {

		var promotionCodeErrorCallback = function(httpResponse, shoppingCart, ngModel){
            switch (httpResponse.status) {
	            case 400:
	                var errorHeader = httpResponse.headers('X-vobeApp-error') || httpResponse.headers('x-vobeapp-error') ;
	                if (ngModel && errorHeader=='error.promocodeinvalid') {
	                	ngModel.$setValidity(errorHeader, false);

	                }
	                else if (ngModel && errorHeader=='error.promocodeexists') {
	                	ngModel.$setValidity(errorHeader, false);
	                }
	                break;
	            default :
	            	if(ngModel){
	            		ngModel.$setValidity('error.promocodeinvalid', false);
	            	}

            }
		}

		var promotionCodeSuccessCallback = function(response, shoppingCart, ngModel){
			shoppingCart.shoppingCartDiscounts = response.shoppingCartDiscounts;
			shoppingCart.shoppingCartItems = response.shoppingCartItems;
			shoppingCart.shoppingCartPaymentTransactions = response.shoppingCartPaymentTransactions;
		}



        var service = {
        	addPromocode: addPromocode,
            removePromocode: removePromocode,
            clearPromoCode: clearPromoCode,
            findApplicablePromo: findApplicablePromo
        };

        return service;

	    function clearPromoCode(ngModel){

	    	if(ngModel){
	    		ngModel.$setValidity('error.promocodeinvalid', null);
	    		ngModel.$setValidity('error.promocodeexists', null);
	        }

	    }

        function addPromocode(shoppingCart, ngModel, hotelId, code, callback, errCallback) {
            var cb = callback || promotionCodeSuccessCallback;
            var ecb = errCallback || promotionCodeErrorCallback;

            var promotionCodeVM = {
            		propertyId : hotelId,
            		code : code
            }

            return PromotionCodeAdd.add(promotionCodeVM,
                function (response) {
                    return cb(response, shoppingCart, ngModel);
                },
                function (err) {
                    return ecb(err, shoppingCart, ngModel);
                }.bind(this)).$promise;
        }

        function removePromocode(shoppingCart, ngModel, id, callback, errCallback) {
            var cb = callback || promotionCodeSuccessCallback;
            var ecb = errCallback || promotionCodeErrorCallback;

            var promotionCodeVM = {
            		id : id
            }

            return PromotionCodeRemove.remove(promotionCodeVM,
                function (response) {
                    return cb(response, shoppingCart, ngModel);
                },
                function (err) {
                    return ecb(err, shoppingCart, ngModel);
                }.bind(this)).$promise;
        }

        function findApplicablePromo(shoppingCart, currentProperty, isGroup, currentVoucher){
            console.log('findApplicablePromo')
            var appliedPromotionCodeForVoucher;
            if (
                shoppingCart &&
                shoppingCart.shoppingCartDiscounts &&
                shoppingCart.shoppingCartDiscounts.promotionCodeIds &&
                shoppingCart.shoppingCartDiscounts.promotionCodeIds.length > 0
            ) {

                //var promotionCodeId = shoppingCart.shoppingCartDiscounts.promotionCodeIds[0];
                var promotionCodeIds = shoppingCart.shoppingCartDiscounts.promotionCodeIds;

                angular.forEach(shoppingCart.shoppingCartDiscounts.discounts, function(d, i) {
                    if (!appliedPromotionCodeForVoucher){
                        //console.log('discount propertyId vs currentVoucher..., ', d.propertyId, currentVoucher)
                        if (d.discountType=="TGB") {
                            appliedPromotionCodeForVoucher = d;
                        } else if (d.discountType=="PROMO" && promotionCodeIds.includes(d.id) && d.propertyId == currentVoucher.hotelId && !isGroup) {
                            if(!d.filteredItemIds || typeof d.filteredItemIds === 'undefined'){
                                appliedPromotionCodeForVoucher = d;
                            } else if (d.filteredItemIds.includes(currentVoucher.id)) {
                                appliedPromotionCodeForVoucher = d;
                            }
                        }
                        //TODO: please test
                        else if (d.discountType=="PROMO" && promotionCodeIds.includes(d.id) && d.propertyId == currentVoucher.hotelId && isGroup){
                            if(!d.filteredItemIds || typeof d.filteredItemIds === 'undefined'){
                                appliedPromotionCodeForVoucher = d;
                            } else if (d.filteredItemIds.includes(currentVoucher.id)) {
                                appliedPromotionCodeForVoucher = d;
                            }
                        }
                    }

                });
            }
            return appliedPromotionCodeForVoucher;
        }
    }
})();

(function() {
    'use strict';

    angular.module('vobeApp').controller('PropertyVoucherPackageDetailDialogController', PropertyVoucherPackageDetailDialogController);

    function PropertyVoucherPackageDetailDialogController(
        $scope,
        $rootScope,
        $uiRouterGlobals,
        $state,
        $uibModalInstance,
        currentProperty,
        currentPropertyGroup,
        allVouchers,
        ShoppingCartAdd,
        $q,
        DetermineItemLanguage,
        Analytics,
        voucherConfig,
        shoppingCart,
        $sce,
        ModalService,
        voucherPool,
        $window,
        $timeout,
        ENV,
        PromotionCodeService,
        ShoppingCartItemDetailsService,
        CurrencyExchange,
        $filter,
        currentLanguage,
        voucherId,
        propertyCategories,
        groupCategories,
        contextType
    ) {
        'ngInject';
        var vm = this;


        vm.$onInit = function(){
            /**
             * resolved values from parent state
             */
            vm.addToCartProgress = false;
            vm.shoppingCart = shoppingCart;
            vm.currentProperty = currentProperty;
            vm.currentPropertyGroup = currentPropertyGroup;
            var isGroup = typeof vm.currentPropertyGroup !== 'undefined';
            vm.allVouchers = allVouchers;//unused

            /**
             * resolved values from this state
             */
            vm.voucherPool = voucherPool;

            /**
             * params from URL
             */
            vm.voucherId = voucherId;

            /**
             * variables used in modal
             */
            //populate dropdown default selection
            vm.$stateParams = $uiRouterGlobals.params;
            vm.currentVoucher;
            vm.voucherClassActive = $uiRouterGlobals.params.cat || ($uiRouterGlobals.current.data ? $uiRouterGlobals.current.data.voucherClassActive : 'all');
            vm.selectedAmount = 0;
            vm.selectedAmountAfterDiscount = 0;
            getDefaultVoucher(); //this will set vm.currentVoucher, also this will set vm.voucherPool if not already set
            vm.selectedTypedAmount='';//this is in current currency
            vm.selectedTypedAmountAfterDiscount = '';//this is in current currency
            //
            vm.voucherProperty = (typeof vm.currentPropertyGroup === 'undefined') ? getVoucherPropertyForIndividualSite() : getVoucherPropertyForGroupSite();
            vm.isBulk = ($uiRouterGlobals.params.bulk || $uiRouterGlobals.params.contextType == 'refunds' || voucherConfig[currentProperty.hotelId].configMap.isBulk === 'true');

            vm.addItemToCartAndRefresh = addItemToCartAndRefresh;
            vm.addItemToCartAndCheckout = addItemToCartAndCheckout;
            vm.buyInBulk = buyInBulk;
            vm.clear = clear;
            vm.updateSelectedAmountAfterDiscount = updateSelectedAmountAfterDiscount;
            vm.updateSelectedTypedAmountAfterDiscount = updateSelectedTypedAmountAfterDiscount;
            vm.getSelectedAmountInContext = getSelectedAmountInContext;
            vm.getSelectedAmountAfterDiscountInContext = getSelectedAmountAfterDiscountInContext;
            vm.isRefunds = contextType == 'refunds';

            //currency
            vm.baseCurrency = {
                code : vm.currentVoucher.currency
            };

            vm.currentCurrency = {
                code : vm.baseCurrency.code
            };

            var currentCurrency = CurrencyExchange.currencies.current;//current currency might be NULL if this is group engine
            if (currentCurrency) {
                vm.currentCurrency.code = currentCurrency.code;
            }

            $rootScope.$on('CurrencyExchangeProvider.changeCurrency', function(event, args) {
                vm.currentCurrency.code = args.code;
            });

            vm.appliedPromotionCode = PromotionCodeService.findApplicablePromo(vm.shoppingCart, vm.currentProperty, isGroup, vm.currentVoucher);

            vm.getImageFileName = getImageFileName;

            vm.range = [];

            if (vm.currentVoucher.totalRate.increment > 0) {
                vm.range = range(vm.currentVoucher.totalRate.priceMin, vm.currentVoucher.totalRate.priceMax, vm.currentVoucher.totalRate.increment);
            }

            vm.disableGeneratedAmounts = (vm.currentVoucher && vm.currentVoucher.meta && vm.currentVoucher.meta.disableGeneratedAmounts);
            if(!vm.voucherPool.enableTypedAmounts && vm.disableGeneratedAmounts){
                vm.disableGeneratedAmounts = false;
            }
            if(vm.disableGeneratedAmounts){
                vm.selectedTypedAmount = $filter('exchangenumber')(vm.currentVoucher.totalRate.priceMin,vm.currentVoucher.currency,vm.currentCurrency.code);
                vm.updateSelectedTypedAmountAfterDiscount();
            }

            vm.displayActionButtons = {
                display : true,
                errorCode : undefined,
                errorValue : undefined
            };
            vm.maxTransactionLimit = parseInt(voucherConfig[currentProperty.hotelId].configMap.maxTransactionLimit) || 0;
            vm.limitQuantity = parseInt(voucherConfig[currentProperty.hotelId].configMap.limitQuantity) || 0;


            if (vm.maxTransactionLimit > 0 || vm.limitQuantity > 0) {
                //console.log('test', vm.shoppingCart.shoppingCartItems.totalPerProperty[currentProperty.hotelId]);
                displayActionButtons(
                    vm.maxTransactionLimit,
                    vm.limitQuantity,
                    vm.selectedAmountAfterDiscount,
                    vm.shoppingCart.shoppingCartItems.totalPerProperty[currentProperty.hotelId],
                    vm.shoppingCart.shoppingCartItems.items.length
                );
            }


            /**
             * variables needed for pools
             */
            vm.voucherPoolObjectVouchersArray = [];
            angular.forEach(vm.voucherPool.vouchers,function(voucher,vkey){
                vm.voucherPoolObjectVouchersArray.push(voucher);
            });
            vm.refresh = refresh;
            vm.homogeneous = isVoucherPoolHomogeneous();
            vm.propertyCategories = propertyCategories;
            vm.groupCategories = groupCategories;
            vm.poolCategory = getPoolCategoryFromVoucherPool(vm.voucherPool);

            /**
             * analytics
             */
            try {
                trackProductDetail();
            } catch (e) {
                console.error(e);
            }
        };

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getActiveVoucherCategory() {

            var category = {
                id: 1,
                friendlyName: 'all',
                name: 'All'
            };

            //some vouchers don't have categories, so we need to check if there are any categories at all
            if (vm.currentVoucher && vm.currentVoucher.categories && Object.keys(vm.currentVoucher.categories).length > 0) {
                Object.keys(vm.currentVoucher.categories).forEach(function (key) {
                    var currentCategory = vm.currentVoucher.categories[key].category;
                    if (currentCategory && currentCategory.friendlyName === vm.voucherClassActive) {
                        category = currentCategory;
                        return;
                    }
                });
            }
            return category;
        }

        function getPoolCategoryFromVoucherPool(voucherPool) {
            var categories = typeof vm.currentPropertyGroup !== 'undefined' ? vm.groupCategories : vm.propertyCategories;
            var poolCategory;
            angular.forEach(categories, function (c, cKey) {
                if (c.id === voucherPool.poolId) {
                    poolCategory = c;
                }
            });
            return poolCategory;
        }

        function getPoolCategory(voucher) {
            var categories = typeof vm.currentPropertyGroup !== 'undefined' ? vm.groupCategories : vm.propertyCategories;
            var poolCategory;
            angular.forEach(categories, function (c, cKey) {
                if (c.id === voucher.pool) {
                    poolCategory = c;
                }
            });
            return poolCategory;
        }


        function getDefaultVoucher() {

            var useFirst = !vm.voucherId || vm.voucherId.length === 0;
            var defaultVoucher;
            angular.forEach(vm.allVouchers.wrapper.voucherPools, function (pool, key) {
                angular.forEach(pool.vouchers, function (voucher, voucherKey) {
                    if (useFirst && !defaultVoucher) {
                        defaultVoucher = voucher;
                        vm.voucherPool = pool;
                    } else if (voucher.id === parseInt(vm.voucherId, 10)) {
                        defaultVoucher = voucher;
                        vm.voucherPool = pool;
                    }
                });
            });

            if(!defaultVoucher && vm.voucherPool) {
                //it could be distant page of a group
                angular.forEach(vm.voucherPool.vouchers, function (voucher, voucherKey) {
                    if (useFirst && !defaultVoucher) {
                        defaultVoucher = voucher;
                    } else if (voucher.id === parseInt(vm.voucherId, 10)) {
                        defaultVoucher = voucher;
                    }
                });
            }

            if (defaultVoucher) {
                vm.currentVoucher = defaultVoucher;
                vm.currentVoucher.voucherDescriptionTrustedHtml = $sce.trustAsHtml(defaultVoucher.voucherDescription);
                vm.currentVoucher.voucherDescription2TrustedHtml = !defaultVoucher.voucherDescription2 || defaultVoucher.voucherDescription2 == null ? $sce.trustAsHtml('<span></span>') : $sce.trustAsHtml(defaultVoucher.voucherDescription2);
                //TODO: selected amounts
                vm.selectedAmount = defaultVoucher.totalRate.priceMin;
                vm.selectedAmountAfterDiscount = defaultVoucher.totalRateAfterDiscount.priceMin;
            } else {
                $state.transitionTo('list', $uiRouterGlobals.params, {inherit: true, notify: true, reload: true});
            }
        }

        function updateSelectedAmountAfterDiscount() {
            //reset typed amounts
            vm.selectedTypedAmount='';
            vm.selectedTypedAmountAfterDiscount='';
            //calculate after discount
            var beforeDiscountAmount = vm.selectedAmount;
            var newSelectedAmountAfterDiscount = ShoppingCartItemDetailsService.calculateSelectedAmountAfterDiscount(beforeDiscountAmount,vm.appliedPromotionCode);

            if (vm.maxTransactionLimit > 0 || vm.limitQuantity > 0) {
                //console.log('test', vm.shoppingCart.shoppingCartItems.totalPerProperty[currentProperty.hotelId]);
                displayActionButtons(
                    vm.maxTransactionLimit,
                    vm.limitQuantity,
                    newSelectedAmountAfterDiscount,
                    vm.shoppingCart.shoppingCartItems.totalPerProperty[currentProperty.hotelId],
                    vm.shoppingCart.shoppingCartItems.items.length
                );
            }
            vm.selectedAmountAfterDiscount = newSelectedAmountAfterDiscount;
        }

        function updateSelectedTypedAmountAfterDiscount() {

            //calculate after discount
            var beforeDiscountAmount = $filter('exchangenumber')(vm.selectedTypedAmount,vm.currentCurrency.code,vm.currentVoucher.currency);
            var newSelectedAmountAfterDiscount = ShoppingCartItemDetailsService.calculateSelectedAmountAfterDiscount(beforeDiscountAmount,vm.appliedPromotionCode);

            if (vm.maxTransactionLimit > 0 || vm.limitQuantity > 0) {
                //console.log('test', vm.shoppingCart.shoppingCartItems.totalPerProperty[currentProperty.hotelId]);
                displayActionButtons(
                    vm.maxTransactionLimit,
                    vm.limitQuantity,
                    newSelectedAmountAfterDiscount,
                    vm.shoppingCart.shoppingCartItems.totalPerProperty[currentProperty.hotelId],
                    vm.shoppingCart.shoppingCartItems.items.length
                );
            }
            vm.selectedTypedAmountAfterDiscount = $filter('exchangenumber')(newSelectedAmountAfterDiscount,vm.currentVoucher.currency,vm.currentCurrency.code);
        }

        function getSelectedAmountInContext(){
            if(vm.selectedTypedAmount && vm.selectedTypedAmount>0){
                return $filter('exchangenumber')(vm.selectedTypedAmount,vm.currentCurrency.code,vm.currentVoucher.currency);
            }
            return vm.selectedAmount;
        }

        function getSelectedAmountAfterDiscountInContext(){
            if(vm.selectedTypedAmountAfterDiscount && vm.selectedTypedAmountAfterDiscount>0){
                return $filter('exchangenumber')(vm.selectedTypedAmountAfterDiscount,vm.currentCurrency.code,vm.currentVoucher.currency);
            }
            return vm.selectedAmountAfterDiscount;
        }

        function getVoucherPropertyForIndividualSite(){
            var voucher = vm.currentVoucher;
            var property = vm.currentProperty;
            console.log('getVoucherPropertyForIndividualSite', voucher, property)
            if(voucher.hotelId != property.hotelId){
                //try among master hotels
                if(vm.currentProperty.masterProperties && vm.currentProperty.masterProperties!=null){
                    angular.forEach(vm.currentProperty.masterProperties,function(hotel,hkey){
                        if(hotel.hotelId==voucher.hotelId){
                            property = hotel;
                        }
                    });
                }
            }

            return property;
        }

        function getVoucherPropertyForGroupSite(){
            if(!vm.currentVoucher){
                return undefined;
            }
            if(!vm.currentPropertyGroup || !vm.currentPropertyGroup.hotels){
                return undefined;
            }
            var property = undefined;
            angular.forEach(vm.currentPropertyGroup.hotels,function(hotel,hkey){
                if(hotel.hotelId==vm.currentVoucher.hotelId){
                    property = hotel;
                }
            })
            return property;
        }

        function isVoucherPoolHomogeneous(){

            var voucherIds = [];
            angular.forEach( vm.voucherPool.vouchers,function(voucher,vkey){
                if(!voucherIds.includes(voucher.id)){
                    voucherIds.push(voucher.id);
                }
            });
            return voucherIds.length<=1;
        }

        function trackProductDetail() {
            if(!vm.currentVoucher){
                return;
            }
            Analytics.addProduct(
                vm.currentVoucher.id, //productId
                vm.currentVoucher.voucherName, //name
                'cash', //category
                vm.voucherProperty.hotelCode, //brand
                '', //variant
                getSelectedAmountAfterDiscountInContext(), //price
                '1', //quantity
                '', //coupon
                '' //position
            );
            Analytics.trackDetail();

            //tag manager
            var dataLayer = $window.dataLayer = $window.dataLayer || [];
            var voucherCategory = {
                id: 1,
                name: 'All'
            }
            //get the voucher category
            if (vm.voucherClassActive.toLowerCase() !== 'all') {
                voucherCategory = vm.currentVoucher.categories[vm.voucherClassActive] ? vm.currentVoucher.categories[vm.voucherClassActive].category : undefined;
            }

            //ga4
            dataLayer.push({
                event: "view_item",
                ecommerce: {
                    currency: vm.currentVoucher.currency,
                    value: getSelectedAmountAfterDiscountInContext(),
                    items: [
                        {
                            item_id: vm.currentVoucher.id,
                            item_name: vm.currentVoucher.voucherName,
                            affiliation: vm.currentProperty.hotelName,
                            item_list_id: voucherCategory.id,
                            item_list_name: voucherCategory.name,
                            discount: getSelectedAmountInContext() - getSelectedAmountAfterDiscountInContext(),
                            index: 0,
                            item_category: "Gift Voucher",
                            price: getSelectedAmountAfterDiscountInContext(),
                            quantity: 1
                        }
                    ]
                }
            });


        }

        function trackAddToCart(itemVm) {

            Analytics.addProduct(
                vm.currentVoucher.id, //productId
                vm.currentVoucher.voucherName, //name
                'package', //category
                vm.voucherProperty.hotelCode, //brand
                '', //variant
                getSelectedAmountAfterDiscountInContext(), //price
                '1', //quantity
                '', //coupon
                '' //position
            );
            Analytics.trackCart('add');

            //tag manager
            var dataLayer = $window.dataLayer = $window.dataLayer || [];

            //ga4_event
            dataLayer.push({
                event: "add_to_cart",
                ecommerce: {
                    currency: itemVm.itemCurrency,
                    value: itemVm.itemTotalPriceWithDiscount,
                    affiliation: "In1Solutions Gift Voucher App",
                    items: [
                        {
                            item_id: itemVm.itemId.toString(),
                            item_name: itemVm.itemName,
                            affiliation: currentProperty.hotelName,
                            item_category: 'Gift Voucher',
                            discount: (itemVm.itemTotalPrice - itemVm.itemTotalPriceWithDiscount),
                            item_brand: itemVm.propertyName,
                            price: itemVm.itemTotalPriceWithDiscount,
                            quantity: 1,
                            item_list_id: itemVm.itemCategoryId,
                            item_list_name: itemVm.itemCategoryName
                        }
                    ]
                }
            });

        }




        function getImageFileName(){

            var giftCard = vm.voucherPool.giftCard;
            if(giftCard && giftCard.imageUrl && giftCard.imageUrl.trim().length>0){
                return useImgix( giftCard.imageUrl);
            }

            var firstVoucher = undefined;
            angular.forEach(vm.voucherPool.vouchers,function(voucher,vkey){
                firstVoucher = firstVoucher || voucher;
            });
            if (firstVoucher && firstVoucher.images && firstVoucher!=null && firstVoucher.images[7]) {
                return useImgix(firstVoucher.images[7]);
            } else {
                return "//in1-image-library.imgix.net/no-image.jpg";
            }
        }

        function useImgix(imgUrl){
            var old_host = 'dddo4e1h8fdy4.cloudfront.net';
            var new_host = 'in1-image-library.imgix.net';
            return imgUrl.replace(old_host, new_host);
        }

        function displayActionButtons(maxTransactionLimit, maxItemLimit, selectedAmount, total, totalItems) {
            //console.log('displayActionButtons', maxTransactionLimit, selectedAmount, total);
            //1.
            var maxTransactionLimitPass = false;
            if (angular.isUndefined(selectedAmount) || angular.isUndefined(total) || maxTransactionLimit == 0) {
                maxTransactionLimitPass = true;
            }
            else if (total + selectedAmount <= maxTransactionLimit) {
                maxTransactionLimitPass = true;
            }
            //2.
            var maxItemsLimitPass = false;
            if (angular.isUndefined(totalItems) || maxItemLimit == 0) {
                maxItemsLimitPass = true;
            }
            else if (totalItems + 1 <= maxItemLimit) {
                maxItemsLimitPass = true;
            }

            if(!maxTransactionLimitPass){
                vm.displayActionButtons.display = false;
                vm.displayActionButtons.errorCode = "vouchers.maxtransactionlimit";
                vm.displayActionButtons.errorValue = maxTransactionLimit;
            }
            else if (!maxItemsLimitPass){
                vm.displayActionButtons.display = false;
                vm.displayActionButtons.errorCode = "vouchers.maxitemslimit";
                vm.displayActionButtons.errorValue = maxItemLimit;
            }

            return maxTransactionLimitPass && maxItemsLimitPass;
        }

        function range(min, max, step) {
            //console.log(min);
            //console.log(max);
            //console.log(step);

            step = step || 1;
            if (step == 0) {
                step = 1;
            }
            if (max == 0) {
                max = min;
            }

            //console.log("doing range again");

            var defaultAmount = voucherConfig[currentProperty.hotelId].configMap.cashDefault;
            var closestRank = Math.abs(vm.selectedAmount - defaultAmount);

            var input = [];
            for (var i = min; i <= max; i += step) {
                input.push(i);
                var valueRank = Math.abs(i - defaultAmount);
                if (valueRank <= closestRank) {
                    //if(vm.selectedAmount==0){
                    vm.selectedAmount = i;
                    updateSelectedAmountAfterDiscount(i);
                    //}
                    closestRank = valueRank;
                }
            }

            return input;
        }

        function addItemToCartAndCheckout(event) {
            console.log('=> addItemToCartAndCheckout...')
            vm.addToCartProgress = true;
            addItemToCart(event, goToShoppingCart);
        }

        function addItemToCartAndRefresh(event) {
            vm.addToCartProgress = true;
            addItemToCart(event, backToList);
        }

        function addItemToCart(event, callback) {
            console.log('=> addItemToCart...')
            var category = getActiveVoucherCategory();
            event.preventDefault();
            var itemVM = {
                propertyId: vm.voucherProperty.hotelId,
                propertyCode: vm.voucherProperty.hotelCode,
                propertyName: vm.voucherProperty.hotelName,
                propertyCountry: vm.voucherProperty.hotelCountry,
                itemId: vm.currentVoucher.id,
                itemName: vm.currentVoucher.voucherName,
                itemDescription: vm.currentVoucher.voucherDescription,
                collectionDescription: vm.currentVoucher.collectDescription,
                itemTotalPrice: getSelectedAmountInContext(),//discounts later ?
                itemTotalPriceWithDiscount: getSelectedAmountAfterDiscountInContext(),
                itemCurrency: vm.currentVoucher.currency,
                itemType: vm.currentVoucher.voucherType,
                itemEmailCategoryId: !vm.currentVoucher.meta ? null : vm.currentVoucher.meta.selectedEmailCategoryId,
                itemFixedDeliveryType: !vm.currentVoucher.meta ? null : vm.currentVoucher.meta.fixedDeliveryOption,
                itemMeta: !vm.currentVoucher.meta ? null : vm.currentVoucher.meta,
                itemImageFileName: getImageFileName(),
                passkey: $uiRouterGlobals.params.passkey || '',
                channelId: (typeof currentPropertyGroup !== 'undefined' ? currentPropertyGroup.masterProperty.hotelId : $uiRouterGlobals.params.channel) || 0,
                selectedCurrency: CurrencyExchange.currencies.current ? CurrencyExchange.currencies.current.code : vm.currentVoucher.currency,
                exchange : CurrencyExchange.currencies.current ? CurrencyExchange.currencies.current.rate : 1,
                itemCategoryName: category.name,
                itemCategoryId: category.id,
            };

            //build additional fields
            var additionalFields = {};
            if(vm.currentVoucher.meta && vm.currentVoucher.meta.redemptionEndDate && vm.currentVoucher.meta.redemptionEndDate!=null ){
                additionalFields['not_valid_after_date'] = new Date(vm.currentVoucher.meta.redemptionEndDate).getTime()/1000;
            }

            itemVM.additionalFields = additionalFields;

            itemVM.itemLanguage = DetermineItemLanguage.getLanguage(itemVM);

            var cb = callback || angular.noop;
            addItem(itemVM, cb);
            //we always dismiss the dialog =
            //vm.clear();
        }

        function buyInBulk(event) {
            vm.clear();
            $timeout(function () {
                var params = {};//angular.extend({},$uiRouterGlobals.params);
                params.voucherId = vm.currentVoucher.id;

                params.voucherPool = vm.voucherPool;
                params.focusedAmount = getSelectedAmountInContext();
                params.appliedPromotionCode = vm.appliedPromotionCode;
                $state.transitionTo('bulk-add', params, { inherit: true, notify: true, reload: false });
            },10);
        }

        function backToList(shoppingCart) {
            $uibModalInstance.close('addToCart');
            //.then(function() {
            //});
        }


        function refresh() {
            console.log('=> refresh ...', $uiRouterGlobals.params)
            var params = $uiRouterGlobals.params;
            params.voucherPool = vm.voucherPool;
            params.voucherId = vm.currentVoucher.id;//should be updated id after select pool
            params.doNotZoomIn = true;
            $uibModalInstance.close(false);
            $state.transitionTo($state.current.name, params, {
            	  reload: $state.current.name, inherit: true, notify: true
            });
        }

        function goToShoppingCart() {
            console.log('=> goToShoppingCart...', $uibModalInstance)
            $uibModalInstance.close('shoppingCart');
        }

        function addItem(itemVM, callback) {
            console.log('=> addItem...')
            var cb = callback || angular.noop;

            //params needed to create shopping cart from scratch
            //build shopping cart locale
            var variant = '';
            if ($uiRouterGlobals.params.contextType) {
                variant = '_' + $uiRouterGlobals.params.contextType;
            }
            variant += (variant.length === 0 ? '_' : '') + currentProperty.hotelId;

            var src = undefined;
            if (typeof currentPropertyGroup !== 'undefined') {
                src = currentPropertyGroup.code;
            }
            if ($uiRouterGlobals.params.src) {
                src = $uiRouterGlobals.params.src;
            }
            itemVM.requestParams = {};
            itemVM.requestParams.ref = $uiRouterGlobals.params.ref;
            itemVM.requestParams.src = src;
            itemVM.requestParams.lang = currentLanguage + variant;
            itemVM.requestParams.contextType = $uiRouterGlobals.params.contextType;
            itemVM.requestParams.propertyType = $uiRouterGlobals.params.propertyType;
            itemVM.requestParams.propertyCode = $uiRouterGlobals.params.propertyId;
            itemVM.requestParams.customerRef = $uiRouterGlobals.params.customerRef;

            return ShoppingCartAdd.add(
                itemVM,
                function(shoppingCart) {
                    trackAddToCart(itemVM);
                    vm.addToCartProgress = false;
                    $rootScope.$broadcast('itemAddedToCart', { shoppingCart: shoppingCart, openShoppingCartDropdown: true });
                    return cb(shoppingCart);
                },
                function(err) {
                    vm.addToCartProgress = false;
                    $rootScope.$broadcast('itemAddedToCartError', err);
                    return cb();
                }.bind(this)
            ).$promise;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PropertyVoucherCashDetailDialogController', PropertyVoucherCashDetailDialogController);

    function PropertyVoucherCashDetailDialogController(
        $scope,
        $rootScope,
        $uiRouterGlobals,
        $state,
        $filter,
        $uibModalInstance,
        currentProperty,
        currentPropertyGroup,
        voucherConfig,
        allVouchers,
        ShoppingCartAdd,
        $q,
        DetermineItemLanguage,
        $translate,
        Analytics,
        $timeout,
        shoppingCart,
        $sce,
        ModalService,
        voucherPool,
        $window,
        ENV,
        PromotionCodeService,
        CurrencyExchange,
        currentLanguage
    ) {
        'ngInject';
        var vm = this;



        vm.$onInit = function() {
            console.log('=> $onInit \t PropertyVoucherCashDetailDialogController')

            /**
             * resolved values from parent state
             */
            vm.addToCartProgress = false;
            vm.shoppingCart = shoppingCart;
            vm.voucherConfig = voucherConfig;
            vm.currentProperty = currentProperty;
            vm.currentPropertyGroup = currentPropertyGroup;
            var isGroup = typeof vm.currentPropertyGroup !== 'undefined';
            vm.allVouchers = allVouchers; //unused

            /**
             * resolved values from this state
             */
            vm.voucherPool = voucherPool;

            /**
             * params from URL
             */
            vm.focusedAmount = $uiRouterGlobals.params.focusedAmount;

            /**
             * variables used in modal
             */
            vm.isBulk = !!($uiRouterGlobals.params.bulk || $uiRouterGlobals.params.contextType == 'refunds' || voucherConfig[currentProperty.hotelId].configMap.isBulk === 'true');
            vm.dropdownVouchers = [];
            angular.forEach(voucherPool.vouchers, function(voucher, vkey) {
                vm.dropdownVouchers.push(voucher);
            });
            vm.dropdownVouchers.sort(function(v1, v2) {
                return v1.totalRate.priceMin - v2.totalRate.priceMin;
            });

            // because we can have dropdownVouchers populated with vouchers from pool
            // if we need to still select typed amount we need to keep separate 'typedAmountVoucher' entity
            vm.typedAmountVoucher;
            enableTypedAmounts(); //this will set vm.typedAmountVoucher
            vm.selectedTypedAmount;

            //populate dropdown default selection
            vm.selectedDefaultVoucher = getDefaultVoucher();

            //
            vm.voucherProperty =
                typeof vm.currentPropertyGroup === 'undefined'
                    ? getVoucherPropertyForIndividualSite()
                    : getVoucherPropertyForGroupSite();

            vm.addItemToCartAndRefresh = addItemToCartAndRefresh;
            vm.addItemToCartAndCheckout = addItemToCartAndCheckout;
            vm.buyInBulk = buyInBulk;
            vm.clear = clear;
            vm.hideClear = hideClear();
            vm.valueForDropdown = valueForDropdown;
            vm.valueForDropdownChanged = valueForDropdownChanged;
            vm.valueForInputChanged = valueForInputChanged;
            vm.giftCard = voucherPool.giftCard;
            vm.getGiftCardImageFileName = getGiftCardImageFileName;
            vm.getImageFileName = getImageFileName;
            vm.getSelectedVoucherDescription = getSelectedVoucherDescription;
            vm.getSelectedVoucherDescription2 = getSelectedVoucherDescription2;

            vm.getSelectedVoucherFirstApplicableCategoryImage = getSelectedVoucherFirstApplicableCategoryImage;

            vm.getVoucherInContext = getVoucherInContext;

            //just in case we go into full view of cash vouchers and skip list view
            $rootScope.$broadcast('propertySelected', { property: vm.currentProperty });

            //$timeout(function(){
            trackProductDetail();
            //}, 1000);

            vm.displayActionButtons = {
                display: true,
                errorCode: undefined,
                errorValue: undefined,
            };
            vm.maxTransactionLimit = parseInt(voucherConfig[currentProperty.hotelId].configMap.maxTransactionLimit) || 0;
            vm.limitQuantity = parseInt(voucherConfig[currentProperty.hotelId].configMap.limitQuantity) || 0;

            if (vm.maxTransactionLimit > 0 || vm.limitQuantity > 0) {
                displayActionButtons(
                    vm.maxTransactionLimit,
                    vm.limitQuantity,
                    vm.selectedDefaultVoucher.totalRateAfterDiscount.priceMin,
                    vm.shoppingCart.shoppingCartItems.totalPerProperty[currentProperty.hotelId],
                    vm.shoppingCart.shoppingCartItems.items.length
                );
            }

            vm.appliedPromotionCode = PromotionCodeService.findApplicablePromo(vm.shoppingCart, vm.currentProperty, isGroup, vm.selectedDefaultVoucher);

            //currency
            vm.baseCurrency = {
                code : vm.selectedDefaultVoucher.currency
            };

            vm.currentCurrency = {
                code : vm.baseCurrency.code
            }
            var currentCurrency = CurrencyExchange.currencies.current;//current currency might be NULL if this is group engine
            if(currentCurrency && currentCurrency!=null){
                vm.currentCurrency.code = currentCurrency.code;
            }

            $rootScope.$on('CurrencyExchangeProvider.changeCurrency', function(event, args) {
                vm.currentCurrency.code = args.code;
            });



            //need this to close modal on back button press.
            $scope.$on('$stateChangeStart', function(e, to, toParams, from, fromParams) {
                var currentModal = ModalService.getCurrentModal();
                console.log('$stateChangeStart', currentModal);
                var sameState = false;
                //if we stay in the same state do not go to parent
                if(to && from && to.name==from.name){
                    sameState = true;
                }

                if (angular.isDefined(currentModal)) {
                    if (sameState){
                        currentModal.dismiss('doNotGoToParent');
                    }
                    else if(toParams.voucherId!=fromParams.voucherId){
                        currentModal.dismiss('voucherIdChanged');//same result as doNotGoToParent
                    } else {
                        currentModal.dismiss('cancel');
                    }

                }
            });

            sendDataLayerProductImpression();

        }

        function enableTypedAmounts() {
            if (voucherPool.enableTypedAmounts) {
                //copy the details over to 'typedAmountVoucher'
                if (!vm.typedAmountVoucher) {
                    vm.typedAmountVoucher = angular.copy(vm.dropdownVouchers[0]);
                }
            }
        }

        function getVoucherInContext() {
            var v =
                vm.typedAmountVoucher && vm.selectedTypedAmount && vm.selectedTypedAmount > 0
                    ? vm.typedAmountVoucher
                    : vm.selectedDefaultVoucher;
            if (!vm.selectedDefaultVoucher) {
                v = vm.typedAmountVoucher; //???
            }
            return v;
        }

        function getDefaultVoucher() {
            var defaultSelection = vm.dropdownVouchers[0];
            if (
                !vm.focusedAmount &&
                (!voucherConfig ||
                    !voucherConfig[currentProperty.hotelId] ||
                    !voucherConfig[currentProperty.hotelId].configMap ||
                    !voucherConfig[currentProperty.hotelId].configMap.cashDefault)
            ) {
                return defaultSelection;
            }

            var defaultAmount = vm.focusedAmount || voucherConfig[currentProperty.hotelId].configMap.cashDefault;

            var closestRank = Math.abs(defaultSelection.totalRate.priceMin - defaultAmount);

            angular.forEach(vm.dropdownVouchers, function(value, key) {
                var valueRank = Math.abs(value.totalRate.priceMin - defaultAmount);
                if (valueRank <= closestRank) {
                    defaultSelection = value;
                    closestRank = valueRank;
                }
            });

            return defaultSelection;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function hideClear() {
            return $uiRouterGlobals.current.data ? $uiRouterGlobals.current.data.hideClear : false;
        }

        function valueForDropdown(voucher) {
            var valueFormatted = $filter('exchangenumber')(voucher.totalRate.priceMin, voucher.currency, voucher.currency, true);
            var fullValueFormatted = voucher.currency + ' ' + valueFormatted;
            if(voucher.currency==vm.currentCurrency.code){
                return fullValueFormatted;
            }
            var exchangedValueFormatted = $filter('exchangenumber')(voucher.totalRate.priceMin, voucher.currency, vm.currentCurrency.code, true);
            var fullExchangedValueFormatted = vm.currentCurrency.code + ' ' + exchangedValueFormatted;
            return fullExchangedValueFormatted;// + ' ('+ fullValueFormatted+')';
        }

        function valueForDropdownChanged() {
            if (vm.maxTransactionLimit > 0 || vm.limitQuantity > 0) {
                displayActionButtons(
                    vm.maxTransactionLimit,
                    vm.limitQuantity,
                    vm.selectedDefaultVoucher.totalRate.priceMin,
                    vm.shoppingCart.shoppingCartItems.totalPerProperty[currentProperty.hotelId],
                    vm.shoppingCart.shoppingCartItems.items.length
                );
            }
            vm.selectedTypedAmount = '';
            trackProductDetail();
        }

        function valueForInputChanged() {
            console.log('valueForInputChanged', vm.typedAmountVoucher,vm.selectedTypedAmount);
            //set prices on voucher
            var typedAmountInCurrentCurrency = vm.selectedTypedAmount;
            var typedAmountInVoucherCurrency = $filter('exchangenumber')(typedAmountInCurrentCurrency,vm.currentCurrency.code,vm.typedAmountVoucher.currency);
            console.log('typedAmountInVoucherCurrency', typedAmountInVoucherCurrency);
            vm.typedAmountVoucher.totalRate.priceMin = typedAmountInVoucherCurrency;
            vm.typedAmountVoucher.totalRateChannel.priceMin = typedAmountInVoucherCurrency;
            var beforeDiscountAmount = typedAmountInVoucherCurrency;
            if (!vm.appliedPromotionCode) {
                vm.typedAmountVoucher.totalRateAfterDiscount.priceMin = beforeDiscountAmount;
                vm.typedAmountVoucher.totalRateChannelAfterDiscount.priceMin = beforeDiscountAmount;
            } else {
                if (vm.appliedPromotionCode.amountPercentage) {
                    var afterDiscountAmount =
                        beforeDiscountAmount - beforeDiscountAmount * (vm.appliedPromotionCode.discountAmount / 100.0);
                    vm.typedAmountVoucher.totalRateAfterDiscount.priceMin = afterDiscountAmount;
                    vm.typedAmountVoucher.totalRateChannelAfterDiscount.priceMin = afterDiscountAmount;
                } else {
                    var afterDiscountAmount = beforeDiscountAmount - vm.appliedPromotionCode.discountAmount;
                    vm.typedAmountVoucher.totalRateAfterDiscount.priceMin = afterDiscountAmount;
                    vm.typedAmountVoucher.totalRateChannelAfterDiscount.priceMin = afterDiscountAmount;
                }
            }

            console.log('test display', vm.maxTransactionLimit, vm.typedAmountVoucher.totalRateAfterDiscount.priceMin);
            if (vm.maxTransactionLimit > 0 || vm.limitQuantity > 0) {
                displayActionButtons(
                    vm.maxTransactionLimit,
                    vm.limitQuantity,
                    vm.typedAmountVoucher.totalRateAfterDiscount.priceMin,
                    vm.shoppingCart.shoppingCartItems.totalPerProperty[currentProperty.hotelId],
                    vm.shoppingCart.shoppingCartItems.items.length
                );
            }
        }

        function displayActionButtons(maxTransactionLimit, maxItemLimit, selectedAmount, total, totalItems) {
            //console.log('displayActionButtons', maxTransactionLimit, selectedAmount, total);
            //1.
            var maxTransactionLimitPass = false;
            if (angular.isUndefined(selectedAmount) || angular.isUndefined(total) || maxTransactionLimit == 0) {
                maxTransactionLimitPass = true;
            } else if (total + selectedAmount <= maxTransactionLimit) {
                maxTransactionLimitPass = true;
            }
            //2.
            var maxItemsLimitPass = false;
            if (angular.isUndefined(totalItems) || maxItemLimit == 0) {
                maxItemsLimitPass = true;
            } else if (totalItems + 1 <= maxItemLimit) {
                maxItemsLimitPass = true;
            }

            if (!maxTransactionLimitPass) {
                vm.displayActionButtons.display = false;
                vm.displayActionButtons.errorCode = 'vouchers.maxtransactionlimit';
                vm.displayActionButtons.errorValue = maxTransactionLimit;
            } else if (!maxItemsLimitPass) {
                vm.displayActionButtons.display = false;
                vm.displayActionButtons.errorCode = 'vouchers.maxitemslimit';
                vm.displayActionButtons.errorValue = maxItemLimit;
            } else {
                vm.displayActionButtons.display = true;
                vm.displayActionButtons.errorCode = undefined;
                vm.displayActionButtons.errorValue = undefined;
            }

            return maxTransactionLimitPass && maxItemsLimitPass;
        }

        function getSelectedVoucherDescription(fallbackDescription) {
            var description;
            if (vm.giftCard) {
                description = $translate.instant('giftcards.cash.description');
            } else if (voucherPool.cashVoucherDescription && voucherPool.cashVoucherDescription != '') {
                description = voucherPool.cashVoucherDescription;
            } else {
                description = getVoucherInContext().voucherDescription;
            }
            if (description == null || description === undefined || description == '') {
                return $sce.trustAsHtml('<span></span>');
            }
            return $sce.trustAsHtml(description);
        }

        function getSelectedVoucherDescription2(fallbackDescription) {
            var description;
            if (!vm.giftCard) {
                description = getVoucherInContext().voucherDescription2;
            }
            if (description == null || description === undefined || description == '') {
                return $sce.trustAsHtml('<span></span>');
            }
            return $sce.trustAsHtml(description);
        }

        function getGiftCardImageFileName() {
            if (vm.giftCard && vm.giftCard.imageUrl && vm.giftCard.imageUrl.trim().length > 0) {
                return useImgix(vm.giftCard.imageUrl);
            }
            return getImageFileName();
        }

        function getImageFileName(){
            var giftCard = vm.giftCard;
            if(giftCard && giftCard.imageUrl && giftCard.imageUrl!=null && giftCard.imageUrl.trim().length>0){
                return useImgix( giftCard.imageUrl);
            }
            var firstVoucher = undefined;
            angular.forEach(voucherPool.vouchers, function(voucher, vkey) {
                firstVoucher = firstVoucher || voucher;
            });
            if (firstVoucher && firstVoucher.images && firstVoucher != null && firstVoucher.images[7]) {
                return useImgix(firstVoucher.images[7]);
            } else {
                return "//in1-image-library.imgix.net/no-image.jpg";
            }
        }

        function getSelectedVoucherFirstApplicableCategoryImage() {
            var firstVoucher = vm.dropdownVouchers[0];
            var firstCategory = undefined;
            angular.forEach(firstVoucher.categories, function(c, ckey) {
                firstCategory = firstCategory || c;
            });
            if (firstCategory && firstCategory.imageUrl) {
                return useImgix(firstCategory.imageUrl);
            }
            return null;
        }

        function useImgix(imgUrl) {
            var old_host = 'dddo4e1h8fdy4.cloudfront.net';
            var new_host = 'in1-image-library.imgix.net';
            return imgUrl.replace(old_host, new_host);
        }

        function getVoucherPropertyForIndividualSite() {
            var voucher = getVoucherInContext();
            var property = vm.currentProperty;
            if (voucher.hotelId != property.hotelId) {
                //try among master hotels
                if (vm.currentProperty.masterProperties && vm.currentProperty.masterProperties != null) {
                    angular.forEach(vm.currentProperty.masterProperties, function(hotel, hkey) {
                        if (hotel.hotelId == voucher.hotelId) {
                            property = hotel;
                        }
                    });
                }
            }

            return property;
        }

        function getVoucherPropertyForGroupSite() {
            if (!vm.dropdownVouchers || vm.dropdownVouchers.length == 0) {
                return undefined;
            }
            if (!vm.currentPropertyGroup || !vm.currentPropertyGroup.hotels) {
                return undefined;
            }
            var property = undefined;
            angular.forEach(vm.currentPropertyGroup.hotels, function(hotel, hkey) {
                if (hotel.hotelId == vm.dropdownVouchers[0].hotelId) {
                    property = hotel;
                }
            });
            return property;
        }

        function backToList(shoppingCart) {
            //we have to reload site to fetch new items in the nav bar
            //$state.transitionTo($state.current, $uiRouterGlobals.params, {
            //	  reload: false, inherit: true, notify: false
            //}).then(function() {
            $rootScope.$broadcast('itemAddedToCart', { shoppingCart: shoppingCart, openShoppingCartDropdown: true });
            //});
        }

        function goToShoppigCart() {
            //we have to reload site to fetch new items in the nav bar
            $state.transitionTo('shopping-cart', $uiRouterGlobals.params, { inherit: true, notify: true, reload: true });
        }

        function addItemToCartAndCheckout(event) {
            vm.addToCartProgress = true;
            addItemToCart(event, goToShoppigCart);
        }

        function addItemToCartAndRefresh(event) {
            vm.addToCartProgress = true;
            addItemToCart(event, backToList);
        }

        function addItemToCart(event, callback) {
            event.preventDefault();
            var voucher = getVoucherInContext();
            var itemVM = {
                propertyId: vm.voucherProperty.hotelId,
                propertyCode: vm.voucherProperty.hotelCode,
                propertyName: vm.voucherProperty.hotelName,
                propertyCountry: vm.voucherProperty.hotelCountry,
                itemId: voucher.id,
                itemName:
                    voucher.voucherType == 'cash-wildcard'
                        ? voucher.voucherName + ' ' + valueForDropdown(voucher)
                        : voucher.voucherName, //vm.currentProperty.hotelCurrency + ' ' + vm.selectedDefaultVoucher.totalRate,

                itemDescription: getSelectedVoucherDescription().$$unwrapTrustedValue(),
                collectionDescription: voucher.collectDescription,
                itemTotalPrice: voucher.totalRate.priceMin,
                itemCurrency: voucher.currency,
                itemType: voucher.voucherType,
                itemGiftCardId: vm.giftCard ? vm.giftCard.id : undefined,
                itemEmailCategoryId: !voucher.meta ? null : voucher.meta.selectedEmailCategoryId,
                itemFixedDeliveryType: !voucher.meta ? null : voucher.meta.fixedDeliveryOption,
                itemMeta: !voucher.meta ? null : voucher.meta,
                passkey: $uiRouterGlobals.params.passkey || '',
                channelId: (typeof currentPropertyGroup !== 'undefined' ? currentPropertyGroup.masterProperty.hotelId : $uiRouterGlobals.params.channel) || 0,
                selectedCurrency: CurrencyExchange.currencies.current ? CurrencyExchange.currencies.current.code : voucher.currency,
                exchange : CurrencyExchange.currencies.current ? CurrencyExchange.currencies.current.rate : 1
                //itemImageFileName : getImageFileName(vm.currentVoucher)//TODO
            };

            //build additional fields
            var additionalFields = {};
            if(voucher.meta && voucher.meta.redemptionEndDate && voucher.meta.redemptionEndDate!=null ){
                additionalFields['not_valid_after_date'] = new Date(voucher.meta.redemptionEndDate).getTime()/1000;
            }

            itemVM.additionalFields = additionalFields;

            //if we have vm.giftCardId, then we also have the image
            if (vm.giftCard && vm.giftCard.id) {
                itemVM.itemImageFileName = getGiftCardImageFileName();
            } else {
                itemVM.itemImageFileName = getImageFileName();
            }

            itemVM.itemLanguage = DetermineItemLanguage.getLanguage(itemVM);

            vm.clear();
            var cb = callback || angular.noop;
            addItem(itemVM, cb);
        }

        function addItem(itemVM, callback) {
            var cb = callback || angular.noop;

            //params needed to create shopping cart from scratch
            //build shopping cart locale
            var variant = '';
            if ($uiRouterGlobals.params.contextType) {
                variant = '_' + $uiRouterGlobals.params.contextType;
            }
            variant += (variant.length === 0 ? '_' : '') + currentProperty.hotelId;

            var src = undefined;
            if (typeof currentPropertyGroup !== 'undefined') {
                src = currentPropertyGroup.code;
            }
            if ($uiRouterGlobals.params.src) {
                src = $uiRouterGlobals.params.src;
            }
            itemVM.requestParams = {};
            itemVM.requestParams.ref = $uiRouterGlobals.params.ref;
            itemVM.requestParams.src = src;
            itemVM.requestParams.lang = currentLanguage + variant;
            itemVM.requestParams.contextType = $uiRouterGlobals.params.contextType;
            itemVM.requestParams.propertyType = $uiRouterGlobals.params.propertyType;
            itemVM.requestParams.propertyCode = $uiRouterGlobals.params.propertyId;
            itemVM.requestParams.customerRef = $uiRouterGlobals.params.customerRef;

            return ShoppingCartAdd.add(
                itemVM,
                function(shoppingCart) {
                    trackAddToCart(itemVM);
                    return cb(shoppingCart);
                },
                function(err) {
                    //return cb(err);
                    $rootScope.$broadcast('itemAddedToCartError', {});
                }
            ).$promise;
        }

        function buyInBulk(event) {
            vm.clear();
            var voucher = getVoucherInContext();
            $timeout(function () {
                var params = {};//angular.extend({},$uiRouterGlobals.params);
                params.voucherId = voucher.id;

                params.voucherPool = vm.voucherPool;
                params.focusedAmount = voucher.totalRate.priceMin;
                params.appliedPromotionCode = vm.appliedPromotionCode;
                $state.transitionTo('bulk-add', params, { inherit: true, notify: true, reload: false });
            },10);
        }

        function trackProductDetail() {
            var voucher = getVoucherInContext();

            Analytics.addProduct(
                voucher.id, //productId
                voucher.voucherName, //name
                'cash', //category
                vm.voucherProperty.hotelCode, //brand
                '', //variant
                voucher.totalRate.priceMin, //price
                '1', //quantity
                '', //coupon
                '' //position
            );
            Analytics.trackDetail();
        }

        function trackAddToCart(itemVm) {
            var voucher = getVoucherInContext();

            Analytics.addProduct(
                voucher.id, //productId
                voucher.voucherName, //name
                'cash', //category
                vm.voucherProperty.hotelCode, //brand
                '', //variant
                voucher.totalRate.priceMin, //price
                '1', //quantity
                '', //coupon
                '' //position
            );
            Analytics.trackCart('add');

            //tag manager
            console.log('sendDataLayerAddToCart', itemVm);
            var dataLayer = ($window.dataLayer = $window.dataLayer || []);
            dataLayer.push({
                event: 'eec:addToCart',
                ecommerce: {
                    currencyCode: itemVm.itemCurrency,
                    add: {
                        products: [
                            {
                                name: itemVm.itemName,
                                id: itemVm.itemId.toString(),
                                price: itemVm.itemTotalPrice,
                                quantity: 1,
                                brand: itemVm.propertyName,
                                category: itemVm.itemType,
                            },
                        ],
                    },
                },
            });
        }

        var sendDataLayerProductImpression = function() {
            var voucher = getVoucherInContext();
            console.log('sendDataLayerProductImpression', voucher);

            var dataLayer = ($window.dataLayer = $window.dataLayer || []);
            dataLayer.push({
                event: 'eec:detail',
                ecommerce: {
                    detail: {
                        products: [
                            {
                                name:
                                    voucher.voucherType == 'cash-wildcard'
                                        ? voucher.currency + ' ' + $filter('number')(voucher.totalRate.priceMin, 2)
                                        : voucher.voucherName,
                                id: voucher.id,
                                price: voucher.totalRate.priceMin,
                                category: 'cash',
                            },
                        ],
                    },
                },
            });

            //ga4
            dataLayer.push({ ecommerce: null });
            dataLayer.push({
                event: "view_item",
                ecommerce: {
                    currency: voucher.currency,
                    value: voucher.totalRate.priceMin,
                    items: [
                        {
                            item_id: voucher.id,
                            item_name: voucher.voucherType == 'cash-wildcard'
                                ? voucher.currency + ' ' + $filter('number')(voucher.totalRate.priceMin, 2)
                                : voucher.voucherName,
                            index: 0,
                            price: voucher.totalRate.priceMin,
                            item_category: 'Gift Voucher'
                        }
                    ]
                }
            });

        };
    }
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('PropertyVouchersClassController', PropertyVouchersClassController);

    PropertyVouchersClassController.$inject = ['$element', '$scope', '$rootScope', '$stateParams', 'User'];

	function PropertyVouchersClassController($element, $scope, $rootScope, $stateParams,  User) {
	    var vm = this;

	    vm.voucherClass = $scope.vc.classId;

	    $scope.$on('voucherClassActive', function(event, args) {
    		var _$element = $($element);
    		var categoryShortCodes = args.voucherClassActive ? args.voucherClassActive.split(',') : [];
	    	if(categoryShortCodes.includes(vm.voucherClass)){
	    		var _$parent = _$element.parent();
	    		//_$parent.prepend(_$element);
	    		//_$element.addClass("col-xs-12 col-sm-8 col-md-6",1000);
	    		//_$element.removeClass("col-xs-6 col-sm-4 col-md-3",1000);
	    		_$element.find('.voucher-class-card ').removeClass("");
	    		_$element.find('.voucher-class-card ').addClass("w3-card-4");

	    	}
	    	else {
	    		//_$element.removeClass("col-xs-12 col-sm-8 col-md-6",1000);
	    		//_$element.addClass("col-xs-6 col-sm-4 col-md-3",1000);
	    		_$element.find('.voucher-class-card ').addClass("");
	    		_$element.find('.voucher-class-card ').removeClass("w3-card-4");
	    	}
	    });





	}
})();

(function() {
    'use strict';

    angular.module('vobeApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        function isHotelIdInGroup(currentPropertyGroup, hotelId) {
            if (typeof currentPropertyGroup === 'undefined') {
                return false;
            }
            var found = false;
            angular.forEach(currentPropertyGroup.hotels, function(hotel, hotelIndex) {
                if (hotel.hotelId == hotelId) {
                    found = true;
                }
            });
            return found;
        }

        function isHotelIdInMasters(currentProperty, hotelId) {
            if (!currentProperty.masterProperties || currentProperty.masterProperties == null) {
                return false;
            }
            var found = false;
            angular.forEach(currentProperty.masterProperties, function(hotel, hotelIndex) {
                if (hotel.hotelId == hotelId) {
                    found = true;
                }
            });
            return found;
        }

        $stateProvider
            .state('property', {
                abstract: true,
                parent: 'site',
                url:
                    '/{propertyType:property|group}/:propertyId/{contextType:vouchers|items|events|giftcards|rewards|refunds}?descriptionLines&reset&currency&bulk&customerRef',
                data: {
                    authorities: [],
                    pageTitle: 'vouchers.page.title',
                },
                views: {

                    'legal@' : {
                        templateUrl: 'app/layouts/footer/legal-property.html',
                        controller: 'LegalFooterController',
                        controllerAs: 'vm'
                    }
                },
                onEnter: [
                    '$state',
                    '$stateParams',
                    '$timeout',
                    function($state, $stateParams, $timeout) {
                        //console.log("in property state");
                    },
                ],
                resolve: {
                    currentPropertyGroup: [
                        '$rootScope',
                        '$stateParams',
                        'PropertyGroup',
                        function($rootScope, $stateParams, PropertyGroup) {
                            if ($stateParams.propertyType !== 'group') {
                                return undefined;
                            }
                            var propertyGroup = PropertyGroup.get({ code: $stateParams.propertyId }, function() {
                                //broadcast property
                                $rootScope.$broadcast('propertyGroupSelected', { propertyGroup: propertyGroup });
                            });
                            return propertyGroup.$promise;
                        },
                    ],
                    currentProperty: [
                        'currentPropertyGroup',
                        '$rootScope',
                        '$stateParams',
                        'Property',
                        function(currentPropertyGroup, $rootScope, $stateParams, Property) {
                            if (typeof currentPropertyGroup !== 'undefined') {
                                $rootScope.$broadcast('propertySelected', {
                                    property: currentPropertyGroup.masterProperty,
                                });
                                return currentPropertyGroup.masterProperty;
                            }
                            var propertyId = $stateParams.propertyId;
                            var property = Property.get({ id: propertyId }, function() {
                                //broadcast property
                                $rootScope.$broadcast('propertySelected', { property: property });
                            });
                            return property.$promise;
                        },
                    ],
                    preShoppingCart: [
                        'ShoppingCart',
                        '$stateParams',
                        'currentLanguage',
                        'currentProperty',
                        'currentPropertyGroup',
                        'ENV',
                        function(ShoppingCart, $stateParams, currentLanguage, currentProperty, currentPropertyGroup, ENV) {

                            //build shopping cart locale
                            var variant = '';
                            if ($stateParams.contextType) {
                                variant = '_' + $stateParams.contextType;
                            }
                            variant += (variant.length === 0 ? '_' : '') + currentProperty.hotelId;

                            var src = undefined;
                            if (typeof currentPropertyGroup !== 'undefined') {
                                src = currentPropertyGroup.code;
                            }
                            if ($stateParams.src) {
                                src = $stateParams.src;
                            }

                            return ShoppingCart.api.get({
                                ref: $stateParams.ref,
                                src: src,
                                lang: currentLanguage + variant,
                                contextType: $stateParams.contextType,
                                propertyType: $stateParams.propertyType,
                                propertyCode: $stateParams.propertyId,
                                customerRef: $stateParams.customerRef,
                                reset : $stateParams.reset

                            }).$promise;
                        },
                    ],
                    shoppingCart: [
                        '$q',
                        '$stateParams',
                        'preShoppingCart',
                        'ShoppingCart',
                        'ShoppingCartRemove',
                        'currentProperty',
                        'currentPropertyGroup',
                        'currentLanguage',
                        function(
                            $q,
                            $stateParams,
                            preShoppingCart,
                            ShoppingCart,
                            ShoppingCartRemove,
                            currentProperty,
                            currentPropertyGroup,
                            currentLanguage
                        ) {
                            var variant = '';
                            if ($stateParams.contextType) {
                                variant = '_' + $stateParams.contextType;
                            }
                            variant += (variant.length === 0 ? '_' : '') + currentProperty.hotelId;

                            function removeItem(itemUUID, successcallback, errorcallback) {
                                var cb = successcallback || angular.noop;
                                var ecb = errorcallback || angular.noop;
                                return ShoppingCartRemove.remove(
                                    { itemUUID: itemUUID },
                                    function(response) {
                                        return cb(response);
                                    },
                                    function(err) {
                                        return ecb(err);
                                    }.bind(this)
                                ).$promise;
                            }
                            //remove unwanted items in shopping cart
                            var removedPromises = [];
                            angular.forEach(preShoppingCart.shoppingCartItems.items, function(value, key) {
                                if (
                                    ($stateParams.propertyType == 'property' &&
                                        currentProperty.hotelId !== value.owningProperty.propertyId &&
                                        !isHotelIdInMasters(currentProperty, value.owningProperty.propertyId)) ||
                                    ($stateParams.propertyType == 'group' &&
                                        (!currentPropertyGroup ||
                                            !isHotelIdInGroup(currentPropertyGroup, value.owningProperty.propertyId)))
                                ) {
                                    var removePromise = removeItem(value.uuid);
                                    removedPromises.push(removePromise);
                                }
                            });
                            if (removedPromises.length > 0) {
                                var singleRemovePromise = $q.all(removedPromises);
                                var shoppingCartPromise = singleRemovePromise.then(
                                    function() {
                                        return ShoppingCart.api.get({
                                            ref: $stateParams.ref,
                                            src: $stateParams.src,
                                            lang: currentLanguage + variant,
                                            contextType: $stateParams.contextType,
                                            propertyType: $stateParams.propertyType,
                                            propertyCode: $stateParams.propertyId,
                                            customerRef: $stateParams.customerRef
                                        }).$promise;
                                    },
                                    function(reason) {
                                        return $q.reject(reason);
                                    }
                                );
                                return shoppingCartPromise;
                            } else {
                                return preShoppingCart;
                            }
                        },
                    ],
                    shoppingCartConfigs: [
                        'shoppingCart',
                        'VobeConfig',
                        'currentProperty',
                        function(shoppingCart, VobeConfig, currentProperty) {
                            //gather property ids
                            var propertyIds = [];
                            if (currentProperty.hotelId) {
                                propertyIds.push(currentProperty.hotelId);
                            }
                            angular.forEach(
                                shoppingCart.shoppingCartItems.items,
                                function(value, key) {
                                    if (jQuery.inArray(value.owningProperty.propertyId, this) < 0) {
                                        this.push(value.owningProperty.propertyId);
                                    }
                                },
                                propertyIds
                            );
                            return VobeConfig.config.get({ propertyIds: propertyIds }).$promise;
                        },
                    ],
                    selectedCurrency: [
                        '$stateParams', '$q', 'currentProperty', 'CurrencyExchange', 'currentPropertyGroup', 'shoppingCartConfigs','$localStorage', function($stateParams, $q, currentProperty, CurrencyExchange, currentPropertyGroup, shoppingCartConfigs, $localStorage){
                            var isGroup = typeof currentPropertyGroup !== 'undefined';
                            var currencyApi = CurrencyExchange;
                            var currencySettings = $localStorage.currencySettings;
                            var userSelectedCurrency = currencySettings && currencySettings['displayCurrency_'+currentProperty.hotelId];
                            var finalCurrency = undefined;//currency can be undefined for groups!
                            var defaultDisplayCurrency = undefined;
                            if (shoppingCartConfigs[currentProperty.hotelId] && shoppingCartConfigs[currentProperty.hotelId].configMap && shoppingCartConfigs[currentProperty.hotelId].configMap.defaultDisplayCurrency) {
                                defaultDisplayCurrency = shoppingCartConfigs[currentProperty.hotelId].configMap.defaultDisplayCurrency;
                            }
                            if($stateParams.currency){
                                finalCurrency = $stateParams.currency.toUpperCase();//priority no.1
                            } else if(userSelectedCurrency) {
                                finalCurrency = userSelectedCurrency.toUpperCase();//priority no.2
                            } else if(defaultDisplayCurrency) {
                                finalCurrency = defaultDisplayCurrency.toUpperCase();//priority no.3 - IMC config
                            } else if(!isGroup) {
                                finalCurrency = currentProperty.hotelCurrency.toUpperCase();//safe to use if we have only one property, priority no.4
                            }

                            var activeCurrencyCodesArray = [];
                            if (shoppingCartConfigs[currentProperty.hotelId] && shoppingCartConfigs[currentProperty.hotelId].configMap && shoppingCartConfigs[currentProperty.hotelId].configMap.currencies) {
                                var currenciesString = shoppingCartConfigs[currentProperty.hotelId].configMap.currencies;
                                activeCurrencyCodesArray = currenciesString.replace(/\s/g, '').split(',');
                            }
                            if(!isGroup){
                                if(!activeCurrencyCodesArray.includes(currentProperty.hotelCurrency)){
                                    activeCurrencyCodesArray.push(currentProperty.hotelCurrency);
                                }
                            } else if(isGroup){
                                angular.forEach(currentPropertyGroup.hotels, function(hotel,i){
                                    if(!activeCurrencyCodesArray.includes(hotel.hotelCurrency)){
                                        activeCurrencyCodesArray.push(hotel.hotelCurrency);
                                    }
                                });
                            }

                            var alwaysTruePromise = $q.defer();
                            currencyApi.initCurrencies().then(
                                function(response){
                                    if(finalCurrency){
                                        currencyApi.addBaseCurrency(finalCurrency);
                                    }
                                    currencyApi.setActiveCurrencies(activeCurrencyCodesArray);
                                    //resolve it with finalCurrency;
                                    alwaysTruePromise.resolve(finalCurrency);
                                },
                                function(reason){
                                    if(finalCurrency){
                                        currencyApi.addBaseCurrency(finalCurrency);
                                    }
                                    currencyApi.setActiveCurrencies(activeCurrencyCodesArray);
                                    //even if currencies endpoint failed, resolve it with finalCurrency;
                                    alwaysTruePromise.resolve(finalCurrency);
                                }
                            );
                            return alwaysTruePromise.promise;
                        }
                    ],
                    brandingTemplateUUID: [
                        '$stateParams',
                        'shoppingCart',
                        'HeaderFooterService',
                        'currentProperty',
                        function($stateParams, shoppingCart, HeaderFooterService, currentProperty) {
                            //check state params in hope we find propertyId there
                            var propertyId = currentProperty.hotelId || 0;
                            //if we cannot determine propertyId from the state, we need to look at the shopping cart
                            if (propertyId == 0) {
                                var propertyIds = [];
                                angular.forEach(
                                    shoppingCart.shoppingCartItems.items,
                                    function(value, key) {
                                        if (jQuery.inArray(value.owningProperty.propertyId, this) < 0) {
                                            this.push(value.owningProperty.propertyId);
                                        }
                                    },
                                    propertyIds
                                );
                                if (propertyIds.length === 1) {
                                    propertyId = propertyIds[0];
                                }
                            }
                            return HeaderFooterService.get({
                                hotelId: propertyId,
                                ref: $stateParams.ref,
                                src: $stateParams.src,
                            }).$promise;
                        },
                    ],
                    previousState: function($state, $transition$, currentProperty, currentPropertyGroup, DetermineShopMoreState) {
                        var shopMoreState = DetermineShopMoreState.getShopMoreState();
                        if (
                            shopMoreState &&
                            shopMoreState.params &&
                            shopMoreState.params.propertyId &&
                            shopMoreState.params.propertyId.toLowerCase() != currentProperty.hotelCode.toLowerCase()
                        ) {
                            shopMoreState.params.propertyId =
                                $transition$.params().propertyType == 'group'
                                    ? currentPropertyGroup.code
                                    : currentProperty.hotelCode.toLowerCase();
                            DetermineShopMoreState.setShopMoreState(shopMoreState);
                        }
                        var currentStateData = {
                            name: $state.current.name || 'property',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params),
                        };
                        return currentStateData;
                    },
                    mainTranslatePartialLoader: [
                        '$stateParams',
                        '$translate',
                        '$translatePartialLoader',
                        'currentProperty',
                        function($stateParams, $translate, $translatePartialLoader, currentProperty) {
                            var variant = '';
                            if ($stateParams.contextType) {
                                variant = '_' + $stateParams.contextType;
                            }
                            variant += '_' + currentProperty.hotelId;
                            //console.log("in property state adding part 'shopping-cart"+variant);
                            $translatePartialLoader.addPart('global' + variant);
                            $translatePartialLoader.addPart('shopping-cart' + variant);
                            return $translate.refresh();
                        },
                    ],
                    profileInfo: [
                        'ProfileService',
                        function(ProfileService) {
                            return ProfileService.getProfileInfo();
                        },
                    ],
                    isChina : ['$window', function($window){
                        var isChina = false;
                        //no GTM and GA in China!
                        if($window.IN1 && $window.IN1.countryCodeTwoLetter && $window.IN1.countryCodeTwoLetter=="CN"){
                            console.log("detected chinese user");
                            isChina = true;
                        }
                        return isChina;
                    }],
                    gtmAccounts: [
                        'currentProperty',
                        '$stateParams',
                        'GoogleTagManagerService',
                        function(currentProperty, $stateParams, GoogleTagManagerService) {
                            return GoogleTagManagerService.getCodes({
                                id: currentProperty.hotelId,
                                ref: $stateParams.ref,
                            });
                        },
                    ],
                    gtm: [
                        'profileInfo',
                        'gtmAccounts',
                        'currentProperty',
                        'GoogleTagManagerService',
                        'TagManager',
                        'isChina',
                        '$rootScope',
                        'CookiesConsentStorageService',
                        'IN1_CONSENT',
                        '$window',
                        function(profileInfo, gtmAccounts, currentProperty, GoogleTagManagerService, TagManager, isChina, $rootScope, CookiesConsentStorageService, IN1_CONSENT, $window) {

                            var inProduction = profileInfo.inProduction;
                            if (!inProduction) {
                                console.log("deactivating google GTM in dev profile");
                                //return;
                            }

                            //no GTM and GA in China!
                            if(isChina){
                                console.log("no GTM in China");
                                return;
                            }

                            //COOKIE POLICY:
                            var isGDPR = ($window && $window.IN1 && $window.IN1.isGDPR) ? $window.IN1.isGDPR : false;

                            function getDefaultStorage(){
                                var defaultConsent = CookiesConsentStorageService.get();

                                //1. HANDLE GOOGLE ADSENSE / GOOGLE ADWORDS VIA GTM
                                var allowGTMAdStorage = isGDPR ? false : true;//by default it's false for people in the GDPR territories
                                //check if it is explicitly allowed
                                var adConsentAllowed = defaultConsent[IN1_CONSENT.ADVERTISING]==IN1_CONSENT.GRANTED || (typeof defaultConsent[IN1_CONSENT.ADVERTISING]  === "undefined" && defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.GRANTED) || false;
                                if(adConsentAllowed){
                                    allowGTMAdStorage = true;
                                }
                                //check if it is explicitly denied
                                var adConsentDenied = defaultConsent[IN1_CONSENT.ADVERTISING]==IN1_CONSENT.DENIED || (typeof defaultConsent[IN1_CONSENT.ADVERTISING]  === "undefined" && defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.DENIED) || true;
                                if(adConsentDenied){
                                    allowGTMAdStorage = false;
                                }

                                //2. HANDLE GOOGLE ANALYTICS VIA GTM
                                var allowGTMAnalyticsStorage = isGDPR ? false : true;//we don't know if the account has anonymizeIp ON and allowAdFeatures OFF, so we must set to false for people in the GDPR territories
                                //check if it is explicitly allowed
                                /*var analyticsConsentAllowed = defaultConsent[IN1_CONSENT.ANALYTICS]==IN1_CONSENT.GRANTED || (typeof defaultConsent[IN1_CONSENT.ANALYTICS]  === "undefined" && defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.GRANTED);
                                if(analyticsConsentAllowed){
                                    allowGTMAnalyticsStorage = true;
                                }
                                //check if it is explicitly denied
                                var analyticsConsentDenied = defaultConsent[IN1_CONSENT.ANALYTICS]==IN1_CONSENT.DENIED || (typeof defaultConsent[IN1_CONSENT.ANALYTICS]  === "undefined" && defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.DENIED);
                                if(analyticsConsentDenied){
                                    allowGTMAnalyticsStorage = false;
                                }
                                */
                                 //check if it is explicitly allowed
                                var analyticsConsentAllowed = defaultConsent[IN1_CONSENT.PERFORMANCE]==IN1_CONSENT.GRANTED || (typeof defaultConsent[IN1_CONSENT.PERFORMANCE]  === "undefined" && defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.GRANTED);
                                if(analyticsConsentAllowed){
                                    allowGTMAnalyticsStorage = true;
                                }
                                //check if it is explicitly denied
                                var analyticsConsentDenied = defaultConsent[IN1_CONSENT.PERFORMANCE]==IN1_CONSENT.DENIED || (typeof defaultConsent[IN1_CONSENT.PERFORMANCE]  === "undefined" && defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.DENIED);
                                if(analyticsConsentDenied){
                                    allowGTMAnalyticsStorage = false;
                                }

                                var processedConsent = CookiesConsentStorageService.processDefaultConsent(defaultConsent);

                                return {
                                    consent : defaultConsent,
                                    processedConsent: processedConsent,
                                    adConsentDenied : adConsentDenied,
                                    allDenied : defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.DENIED,
                                    allowGTMAnalyticsStorage : true,
                                    allowGTMAdStorage: true
                                }
                            }

                            var defaultGTMStorage = getDefaultStorage();

                            //3. CONFIGURE GTM based on initial consent
                            //Products that support Consent Mode include:
                            // Google Ads (including Google Ads Conversion Tracking and Remarketing)
                            // Google Analytics
                            // Floodlight
                            // Conversion Linker
                            var ad_storage = defaultGTMStorage.allowGTMAdStorage;
                            var analytics_storage = defaultGTMStorage.allowGTMAnalyticsStorage;

                            //set GTM variables
                            TagManager.updateConsent(ad_storage, analytics_storage);

                            //default datalayer variables
                            TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ANALYTICS,isGDPR && !defaultGTMStorage.processedConsent[IN1_CONSENT.ANALYTICS] ? IN1_CONSENT.DENIED : IN1_CONSENT.GRANTED);
                            TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ADVERTISING,isGDPR && !defaultGTMStorage.processedConsent[IN1_CONSENT.ADVERTISING] ? IN1_CONSENT.DENIED : IN1_CONSENT.GRANTED);
                            TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_PERFORMANCE,isGDPR && !defaultGTMStorage.processedConsent[IN1_CONSENT.PERFORMANCE] ? IN1_CONSENT.DENIED : IN1_CONSENT.GRANTED);
                            TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ENHANCEMENT,isGDPR && !defaultGTMStorage.processedConsent[IN1_CONSENT.ENHANCEMENT] ? IN1_CONSENT.DENIED : IN1_CONSENT.GRANTED);
                            TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_FUNCTIONAL,isGDPR && !defaultGTMStorage.processedConsent[IN1_CONSENT.FUNCTIONAL] ? IN1_CONSENT.DENIED : IN1_CONSENT.GRANTED);
                            TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_TRACKING,isGDPR && !defaultGTMStorage.processedConsent[IN1_CONSENT.TRACKING] ? IN1_CONSENT.DENIED : IN1_CONSENT.GRANTED);

                            TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ALL,isGDPR && (typeof defaultGTMStorage.consent[IN1_CONSENT.ALL] !== 'undefined' && !defaultGTMStorage.processedConsent[IN1_CONSENT.ALL]) ? IN1_CONSENT.DENIED : IN1_CONSENT.GRANTED);

                            //4. make sure to manage consent properly on update
                            $rootScope.$on(IN1_CONSENT.EVENT_GRANTED_ALL, function(){
                                TagManager.updateConsent(true, true, true);

                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ALL,IN1_CONSENT.GRANTED);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_STRICTLY_NECESSARY,IN1_CONSENT.GRANTED);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ANALYTICS,IN1_CONSENT.GRANTED);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ADVERTISING,IN1_CONSENT.GRANTED);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_TRACKING,IN1_CONSENT.GRANTED);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_PERFORMANCE,IN1_CONSENT.GRANTED);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ENHANCEMENT,IN1_CONSENT.GRANTED);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_FUNCTIONAL,IN1_CONSENT.GRANTED);
                                registerGTMScripts();
                            });
                            $rootScope.$on(IN1_CONSENT.EVENT_GRANTED_ADVERTISING, function(){
                                TagManager.updateConsent(true, undefined, true);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ADVERTISING,IN1_CONSENT.GRANTED);
                                registerGTMScripts();
                            });
                            $rootScope.$on(IN1_CONSENT.EVENT_GRANTED_PERFORMANCE, function(){
                                TagManager.updateConsent(undefined, true, true);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_PERFORMANCE,IN1_CONSENT.GRANTED);
                                registerGTMScripts(true);
                            });
                            $rootScope.$on(IN1_CONSENT.EVENT_GRANTED_ANALYTICS, function(){
                                TagManager.updateConsent(undefined, true, true);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ANALYTICS,IN1_CONSENT.GRANTED);
                                registerGTMScripts(true);
                            });
                            $rootScope.$on(IN1_CONSENT.EVENT_GRANTED_TRACKING, function(){
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_TRACKING,IN1_CONSENT.GRANTED);
                                registerGTMScripts(true);
                            });
                            $rootScope.$on(IN1_CONSENT.EVENT_GRANTED_ENHANCEMENT, function(){
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ENHANCEMENT,IN1_CONSENT.GRANTED);
                                registerGTMScripts(true);
                            });
                            $rootScope.$on(IN1_CONSENT.EVENT_GRANTED_FUNCTIONAL, function(){
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_FUNCTIONAL,IN1_CONSENT.GRANTED);
                                registerGTMScripts(true);
                            });
                            $rootScope.$on(IN1_CONSENT.EVENT_GRANTED_STRICTLY_NECESSARY, function(){
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_STRICTLY_NECESSARY,IN1_CONSENT.GRANTED);
                                registerGTMScripts(true);
                            });

                            $rootScope.$on(IN1_CONSENT.EVENT_DENIED_ALL, function(){
                                TagManager.updateConsent(false, false, true);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ALL,IN1_CONSENT.DENIED);

                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ANALYTICS,IN1_CONSENT.DENIED);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ADVERTISING,IN1_CONSENT.DENIED);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_TRACKING,IN1_CONSENT.DENIED);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_PERFORMANCE,IN1_CONSENT.DENIED);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ENHANCEMENT,IN1_CONSENT.DENIED);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_FUNCTIONAL,IN1_CONSENT.DENIED);
                            });

                            $rootScope.$on(IN1_CONSENT.EVENT_DENIED_ANALYTICS, function(){
                                TagManager.updateConsent(undefined, false, true);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ANALYTICS,IN1_CONSENT.DENIED);
                            });
                            $rootScope.$on(IN1_CONSENT.EVENT_DENIED_ADVERTISING, function(){
                                TagManager.updateConsent(false, undefined, true);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ADVERTISING,IN1_CONSENT.DENIED);
                            });
                            $rootScope.$on(IN1_CONSENT.EVENT_DENIED_PERFORMANCE, function(){
                                TagManager.updateConsent(false, undefined, true);
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_PERFORMANCE,IN1_CONSENT.DENIED);
                            });
                            $rootScope.$on(IN1_CONSENT.EVENT_DENIED_TRACKING, function(){
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_TRACKING,IN1_CONSENT.DENIED);
                            });
                            $rootScope.$on(IN1_CONSENT.EVENT_DENIED_ENHANCEMENT, function(){
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_ENHANCEMENT,IN1_CONSENT.DENIED);
                            });
                            $rootScope.$on(IN1_CONSENT.EVENT_DENIED_FUNCTIONAL, function(){
                                TagManager.pushVariable(IN1_CONSENT.GTM_EVENT_DENIED_FUNCTIONAL,IN1_CONSENT.DENIED);
                            });

                            //5. check if we can register the scripts
                            if(!isGDPR || defaultGTMStorage.processedConsent[IN1_CONSENT.ALL] || defaultGTMStorage.processedConsent[IN1_CONSENT.ADVERTISING]){
                                registerGTMScripts();
                            } else {
                                console.info('GTM will register scripts on consent');
                            }


                            function registerGTMScripts(safeOnly){

                                console.info('GTM registerGTMScripts with safeOnly: '+safeOnly);

                                //add generic IN1 solutions tag manager, it's safe to add it as we control it
                                /*
                                if (inProduction && !GoogleTagManagerService.isInitializedTag('GTM-TKLJPR')) {
                                    TagManager.registerScriptTags('GTM-TKLJPR', 'dataLayer');
                                    GoogleTagManagerService.setInitializedTag('GTM-TKLJPR',true);
                                    console.info('Registering Safe In1 Own GTM-TKLJPR');
                                } else if(GoogleTagManagerService.isInitializedTag('GTM-TKLJPR')) {
                                    console.info('GoogleTagManagerService GTM-TKLJPR already initialised');
                                }*/

                                //add DEV IN1 solutions tag manager, it's safe to add it as we control it
                                if (!inProduction && !GoogleTagManagerService.isInitializedTag('GTM-WLJRCF9')) {
                                    //TagManager.registerScriptTags('GTM-WLJRCF9', 'dataLayer');
                                    //GoogleTagManagerService.setInitializedTag('GTM-WLJRCF9',true);
                                    //console.info('Registering Safe DEV In1 Own GTM-WLJRCF9');
                                } else if(GoogleTagManagerService.isInitializedTag('GTM-WLJRCF9')) {
                                    console.info('GoogleTagManagerService GTM-WLJRCF9 already initialised');
                                }

                                function initializeTags(){
                                    //TODO: add here only GTM containers that we control, add rest only if advertising consent
                                    if (gtmAccounts) {
                                        angular.forEach(gtmAccounts, function(gtmAccount, key) {
                                            if(safeOnly && !gtmAccount.safe){
                                                //skip tag if it's unsafe
                                                console.info('GoogleTagManagerService skipping unsafe tag '+gtmAccount.containerTag);
                                                return;
                                            }
                                            //always use same name: 'dataLayer'
                                            if (!GoogleTagManagerService.isInitializedTag(gtmAccount.containerTag)) {
                                                TagManager.registerScriptTags(gtmAccount.containerTag, 'dataLayer');
                                                GoogleTagManagerService.setInitializedTag(gtmAccount.containerTag,true);
                                                console.info('Registering '+gtmAccount.containerTag);
                                            } else {
                                                console.info('GoogleTagManagerService '+gtmAccount.containerTag+' already initialised');
                                            }
                                        });
                                    }
                                }

                                if (inProduction) {
                                    initializeTags();
                                }
                            }

                        },
                    ],
                    analyticsAccounts: [
                        'profileInfo',
                        'currentProperty',
                        '$stateParams',
                        'GoogleAnalyticsCodesService',
                        function(profileInfo, currentProperty, $stateParams, GoogleAnalyticsCodesService) {
                            //var inProduction = profileInfo.inProduction;
                            //if(!inProduction){
                            //	return;
                            //}
                            return GoogleAnalyticsCodesService.getCodes({
                                id: currentProperty.hotelId,
                                ref: $stateParams.ref,
                            });
                        },
                    ],
                    analytics: [
                        'profileInfo',
                        'analyticsAccounts',
                        'currentProperty',
                        'Analytics',
                        'GoogleAnalyticsCodesService',
                        '$window',
                        'isChina',
                        '$rootScope',
                        'CookiesConsentStorageService',
                        'shoppingCart',
                        '$timeout',
                        'IN1_CONSENT',
                        function(
                            profileInfo,
                            analyticsAccounts,
                            currentProperty,
                            Analytics,
                            GoogleAnalyticsCodesService,
                            $window,
                            isChina,
                            $rootScope,
                            CookiesConsentStorageService,
                            shoppingCart,
                            $timeout,
                            IN1_CONSENT
                        ) {

                            var inProduction = profileInfo.inProduction;
                            if (!inProduction) {
                                console.log("deactivating google in dev profile");
                                //return;
                            }

                            console.log("doing google analytics scripts");
                            //if($window && $window.navigator && $window.navigator.userAgent && ~navigator.userAgent.indexOf("Speed Insights")){
                            //	return;
                            //}
                            //console.log("isProduction: "+inProduction);

                            try {
                                Analytics.configuration.currency = currentProperty.hotelCurrency;
                            } catch (e){
                                console.error(e);
                            }

                            //ga('set', 'currencyCode', 'EUR');//does not work
                            //Analytics.set('currencyCode', currentProperty.hotelCurrency);//does not work

                            //COOKIE POLICY:
                            var isGDPR = ($window && $window.IN1 && $window.IN1.isGDPR) ? $window.IN1.isGDPR : false;

                            var defaultConsent = getDefaultConsent();

                            function getDefaultConsent() {
                                var defaultConsent = CookiesConsentStorageService.get();

                                var allowAds = isGDPR ? false : true;//by default it's false for people in the GDPR territories
                                //check if it is explicitly allowed
                                var adConsentAllowed = defaultConsent[IN1_CONSENT.ADVERTISING]==IN1_CONSENT.GRANTED || (typeof defaultConsent[IN1_CONSENT.ADVERTISING]  === "undefined" && defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.GRANTED);
                                if(adConsentAllowed){
                                    allowAds = true;
                                }
                                //check if it is explicitly denied
                                var adConsentDenied = defaultConsent[IN1_CONSENT.ADVERTISING]==IN1_CONSENT.DENIED || (typeof defaultConsent[IN1_CONSENT.ADVERTISING]  === "undefined" && defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.DENIED);
                                if(adConsentDenied){
                                    allowAds = false;
                                }

                                var allowAnalytics = isGDPR ? false : true;//we don't know if the account has anonymizeIp ON and allowAdFeatures OFF, so we must set to false for people in the GDPR territories
                                //check if it is explicitly allowed
                                /*var analyticsConsentAllowed = defaultConsent[IN1_CONSENT.ANALYTICS]==IN1_CONSENT.GRANTED || (typeof defaultConsent[IN1_CONSENT.ANALYTICS]  === "undefined" && defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.GRANTED);
                                if(analyticsConsentAllowed){
                                    allowAnalytics = true;
                                }
                                //check if it is explicitly denied
                                var analyticsConsentDenied = defaultConsent[IN1_CONSENT.ANALYTICS]==IN1_CONSENT.DENIED || (typeof defaultConsent[IN1_CONSENT.ANALYTICS]  === "undefined" && defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.DENIED);
                                if(analyticsConsentDenied){
                                    allowAnalytics = false;
                                }*/
                                var analyticsConsentAllowed = defaultConsent[IN1_CONSENT.PERFORMANCE]==IN1_CONSENT.GRANTED || (typeof defaultConsent[IN1_CONSENT.PERFORMANCE]  === "undefined" && defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.GRANTED);
                                if(analyticsConsentAllowed){
                                    allowAnalytics = true;
                                }
                                //check if it is explicitly denied
                                var analyticsConsentDenied = defaultConsent[IN1_CONSENT.PERFORMANCE]==IN1_CONSENT.DENIED || (typeof defaultConsent[IN1_CONSENT.PERFORMANCE]  === "undefined" && defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.DENIED);
                                if(analyticsConsentDenied){
                                    allowAnalytics = false;
                                }

                                return {
                                    consent : defaultConsent,
                                    adsConsentDenied :!allowAds,
                                    analyticsConsentDenied : !allowAnalytics,
                                    analyticsConsentAllowed : analyticsConsentAllowed,
                                    allDenied : defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.DENIED,
                                    analyticsDenied : defaultConsent[IN1_CONSENT.PERFORMANCE]==IN1_CONSENT.DENIED,
                                    allGranted : defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.GRANTED,
                                    analyticsAllowed : defaultConsent[IN1_CONSENT.PERFORMANCE]==IN1_CONSENT.GRANTED,
                                }
                            }

                            function addTrackers(noStorage){

                                console.log("Registering Google Analytics with storage: "+!noStorage)

                                if (inProduction) {
                                    if (analyticsAccounts && analyticsAccounts.length > 0) {
                                        for (var i = 0; i < analyticsAccounts.length; i++) {
                                            var otherAccount = analyticsAccounts[i];

                                            var tracker_fields = {
                                                cookieName:  'tracker_' + i,
                                                cookieExpires: 20000,
                                                cookieFlags: 'secure'
                                                // See: [Analytics Field Reference](https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference) for a list of all fields.
                                            };

                                            if(noStorage){
                                                tracker_fields['storage'] = 'none';
                                                //should this be sha256 encoded?
                                                tracker_fields['clientId'] = shoppingCart.shoppingCartKey;
                                            }

                                            var tracker = {
                                                tracker: otherAccount.ua,
                                                name: 'tracker_' + i,
                                                fields: tracker_fields,
                                                crossDomainLinker: true,
                                                displayFeatures: true,
                                                enhancedLinkAttribution: true,
                                                trackEvent: true,
                                                trackEcommerce: true,
                                                select: function(args) {
                                                    return true;
                                                },
                                                set: {
                                                    'currencyCode': currentProperty.hotelCurrency,
                                                    'forceSSL': true,
                                                    //COOKIE POLICY:
                                                    // (https://www.simoahava.com/analytics/allow-block-advertising-features-google-analytics/)
                                                    'allowAdFeatures' : noStorage || defaultConsent.analyticsConsentDenied || defaultConsent.allDenied || defaultConsent.adsConsentDenied ? false : true,
                                                    'anonymizeIp' : noStorage || defaultConsent.allDenied || defaultConsent.analyticsConsentDenied  ? true : false,
                                                },

                                            };
                                            Analytics.configuration.accounts.push(tracker);
                                        }
                                    }
                                }
                            }




                            //console.log("will register trackers");
                            // Manually create either classic analytics (ga.js) or universal analytics (analytics.js) script tags
                            function registerScriptTags(noStorage){
                                if (GoogleAnalyticsCodesService.isInitialized()) {
                                    console.log("GoogleAnalyticsCodesService already initialized");
                                    return false;
                                }

                                // Manually setup the tracker object(s)
                                addTrackers(noStorage);
                                Analytics.registerScriptTags();
                                Analytics.registerTrackers();

                                //mark this as done' so we won't init GA next time
                                GoogleAnalyticsCodesService.setInitialized(true);
                                GoogleAnalyticsCodesService.setInitializedWithoutStorage(noStorage);

                                return true;
                            }

                            //self hosted GA in China!
                            if(isChina){
                                //var scriptSource = '/ga/in1analytics-v1.4.js';
                                var scriptSource = 'https://in1-obe-resources.imgix.net/ga/in1analytics-v1.4.js';
                                console.log("using GA hosted on our server");
                                (function (i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function (){
                                    (i[r].q=i[r].q||[]).push(arguments);},i[r].l=1*new Date();a=s.createElement(o),
                                    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m);
                                })(window,document,'script',scriptSource,'ga');

                                // Manually setup the tracker object(s)
                                registerScriptTags();
                            } else {
                                if (!isGDPR) {
                                    registerScriptTags(true);
                                } else if(defaultConsent.allGranted || defaultConsent.analyticsAllowed) {
                                    //register with cookies
                                    registerScriptTags();
                                }
                            }

                            $rootScope.$on(IN1_CONSENT.EVENT_GRANTED_ALL, function(){
                                registerScriptTags();
                                window['ga-disable-UA-25206573-4'] = false;
                                Analytics.set('anonymizeIp', false, 'tracker_in1');
                                Analytics.set('allowAdFeatures', true, 'tracker_in1');
                                if (analyticsAccounts && analyticsAccounts.length > 0) {
                                    for (var i = 0; i < analyticsAccounts.length; i++) {
                                        var otherAccount = analyticsAccounts[i];
                                        window['ga-disable-'+otherAccount.ua] = false;
                                        Analytics.set('anonymizeIp', false, 'tracker_' + i);
                                        Analytics.set('allowAdFeatures', true, 'tracker_' + i);
                                    }
                                }
                            });

                            $rootScope.$on(IN1_CONSENT.EVENT_GRANTED_PERFORMANCE, function(){
                                registerScriptTags();
                                window['ga-disable-UA-25206573-4'] = false;
                                Analytics.set('anonymizeIp', false, 'tracker_in1');
                                if (analyticsAccounts && analyticsAccounts.length > 0) {
                                    for (var i = 0; i < analyticsAccounts.length; i++) {
                                        var otherAccount = analyticsAccounts[i];
                                        window['ga-disable-'+otherAccount.ua] = false;
                                        Analytics.set('anonymizeIp', false, 'tracker_' + i);
                                    }
                                }
                            });

                            $rootScope.$on(IN1_CONSENT.EVENT_GRANTED_ADVERTISING, function(){
                                registerScriptTags();
                                window['ga-disable-UA-25206573-4'] = false;
                                Analytics.set('anonymizeIp', false, 'tracker_in1');
                                Analytics.set('allowAdFeatures', true, 'tracker_in1');
                                if (analyticsAccounts && analyticsAccounts.length > 0) {
                                    for (var i = 0; i < analyticsAccounts.length; i++) {
                                        var otherAccount = analyticsAccounts[i];
                                        window['ga-disable-'+otherAccount.ua] = false;
                                        Analytics.set('anonymizeIp', false, 'tracker_' + i);
                                        Analytics.set('allowAdFeatures', true, 'tracker_' + i);
                                    }
                                }
                            });

                            $rootScope.$on(IN1_CONSENT.EVENT_DENIED_ALL, function(){
                                window['ga-disable-UA-25206573-4'] = true;
                                if (analyticsAccounts && analyticsAccounts.length > 0) {
                                    for (var i = 0; i < analyticsAccounts.length; i++) {
                                        var otherAccount = analyticsAccounts[i];
                                        window['ga-disable-'+otherAccount.ua] = true;
                                    }
                                }
                            });

                            $rootScope.$on(IN1_CONSENT.EVENT_DENIED_PERFORMANCE, function(){
                                window['ga-disable-UA-25206573-4'] = true;
                                if (analyticsAccounts && analyticsAccounts.length > 0) {
                                    for (var i = 0; i < analyticsAccounts.length; i++) {
                                        var otherAccount = analyticsAccounts[i];
                                        window['ga-disable-'+otherAccount.ua] = true;
                                    }
                                }
                            });

                            $rootScope.$on(IN1_CONSENT.EVENT_DENIED_ADVERTISING, function(){
                                Analytics.set('anonymizeIp', true, 'tracker_in1');
                                Analytics.set('allowAdFeatures', false, 'tracker_in1');
                                if (analyticsAccounts && analyticsAccounts.length > 0) {
                                    for (var i = 0; i < analyticsAccounts.length; i++) {
                                        Analytics.set('anonymizeIp', true, 'tracker_' + i);
                                        Analytics.set('allowAdFeatures', false, 'tracker_' + i);
                                    }
                                }
                            });
                        },
                    ],
                },
            })
            .state('list', {
                parent: 'property',
                url: '/list?cat&promotionCode&minPrice&maxPrice&page&pRef',
                params: {
                    cat: 'all',
                },
                data: {
                    authorities: [],
                },
                reloadOnSearch: false, //THIS WILL PREVENT RELOADING WHEN CAT(?cat=category) in URL CHANGES!
                views: {
                    'content@': {
                        templateUrl: 'app/site/property/vouchers/property-vouchers.html',
                        controller: 'PropertyVouchersController',
                        controllerAs: 'vm',
                    },
                    'header@': {
                        templateUrl: 'app/layouts/header/header.html',
                        controller: 'BrandedHeaderController',
                        controllerAs: 'vm',
                    },
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.html',
                        controller: 'BrandedFooterController',
                        controllerAs: 'vm',
                    }
                },
                onEnter: [
                    'propertyVouchers',
                    'propertyCashVouchers',
                    'propertyGiftCards',
                    '$state',
                    '$stateParams',
                    '$timeout',
                    '$document',
                    'AlertService',
                    '$window',
                    '$interval',
                    function(
                        propertyVouchers,
                        propertyCashVouchers,
                        propertyGiftCards,
                        $state,
                        $stateParams,
                        $timeout,
                        $document,
                        AlertService,
                        $window,
                        $interval
                    ) {
                        console.info('entering property.list', $stateParams);
                        //if (propertyVouchers.voucherPoolsCount == 0 && propertyCashVouchers && propertyCashVouchers.cashVouchersWrapper && propertyCashVouchers.cashVouchersWrapper.length > 0 && propertyGiftCards.length == 0) {
                        //	$timeout(function(){
                        //		$state.transitionTo("property.list.cash-detail-fullpage", $stateParams, {
                        //    	  reload: false, inherit: true, notify: true
                        //	    });
                        //	});
                        //};
                        var lastActivity = Date.now();
                        var TIMEOUT = 1000*60*30;//30 minutes
                        var lastIdle = undefined;
                        var refreshInterval;
                        var repeat = function() {
                            var refresh = false;
                            if ($document.get(0).visibilityState === 'hidden') {
                                //if user is idle, do not refresh
                                if(!lastIdle){
                                    lastIdle = Date.now();
                                }
                                return;
                            }
                            //case 1: we enter from 30 min or more idle
                            if ($document.get(0).visibilityState !== 'hidden' && lastIdle && Date.now()-lastIdle>TIMEOUT) {
                               refresh = true;
                            }
                            //case 2: if timeout pass
                            if (Date.now()-lastActivity>TIMEOUT) {
                                refresh = true;
                            }

                            if(refresh && $state.includes('property.list')){
                                if(refreshInterval){
                                    $interval.cancel(refreshInterval);
                                }
                                $window.location.reload();
                            }
                            if ($document.get(0).visibilityState !== 'hidden') {
                                //reset last idle
                                lastIdle = undefined;
                            }

                        };

                        refreshInterval = $interval(repeat, 1000*10);//run every 10 seconds even if idle

                        var resetLastActivity = function (){
                            lastActivity = Date.now();
                        }

                        $document.mousemove(resetLastActivity);
                        $document.keypress(resetLastActivity);
                    },
                ],
                resolve: {
                    voucherConfig: [
                        'VobeConfig',
                        'currentProperty',
                        function(VobeConfig, currentProperty) {
                            //gather property ids
                            var propertyIds = [];
                            propertyIds.push(currentProperty.hotelId);
                            return VobeConfig.config.get({ propertyIds: propertyIds }).$promise;
                        },
                    ],
                    shoppingCart: [
                        '$state',
                        '$stateParams',
                        'shoppingCart',
                        'currentProperty',
                        'PromotionCodeAdd',
                        '$q',
                        function($state, $stateParams, shoppingCart, currentProperty, PromotionCodeAdd, $q) {
                            if ($stateParams.promotionCode) {
                                var shoppingCartWithPromoPromise = $q.defer();

                                var promotionCodeVM = {
                                    propertyId: currentProperty.hotelId,
                                    code: $stateParams.promotionCode,
                                };

                                PromotionCodeAdd.add(
                                    promotionCodeVM,
                                    function(response) {
                                        shoppingCartWithPromoPromise.resolve(response);
                                    },
                                    function(err) {
                                        //if promotion code that we want to apply is invalid
                                        if (err.data && err.data.shoppingCartItems) {
                                            //check if we have already items in the cart
                                            //because if we have we cannot remove previously applied discount
                                            shoppingCartWithPromoPromise.resolve(err.data);
                                        } else {
                                            //if we don't have any items in the basket
                                            //proceed with
                                            shoppingCartWithPromoPromise.resolve(shoppingCart);
                                        }
                                    }
                                );

                                return shoppingCartWithPromoPromise.promise;
                            } else {
                                return shoppingCart;
                            }
                        },
                    ],
                    propertyGiftCards: [
                        //'$stateParams',
                        //'GiftCards',
                        //'currentProperty',
                        //'currentPropertyGroup',
                        //'currentLanguage',
                        //'voucherConfig',
                        function(
                            $stateParams,
                            GiftCards,
                            currentProperty,
                            currentPropertyGroup,
                            currentLanguage,
                            voucherConfig
                        ) {
                            return [];
                            /*var propertyConfig = voucherConfig['' + currentProperty.hotelId];
                            if (
                                propertyConfig &&
                                propertyConfig.configMap &&
                                propertyConfig.configMap.hideCashVouchers &&
                                propertyConfig.configMap.hideCashVouchers === 'true'
                            ) {
                                return [];
                            }
                            if (
                                propertyConfig &&
                                propertyConfig.configMap &&
                                (!propertyConfig.configMap.postalOption ||
                                    (propertyConfig.configMap.postalOption &&
                                        propertyConfig.configMap.postalOption != 'true')) &&
                                (!propertyConfig.configMap.forceGiftCards ||
                                    (propertyConfig.configMap.forceGiftCards &&
                                        propertyConfig.configMap.forceGiftCards != 'true'))
                            ) {
                                return [];
                            }
                            if (typeof currentPropertyGroup !== 'undefined') {
                                //at the moment for groups don't return them, as this colodes with pagination
                                //it's small so we can enable
                                return [];
                            }
                            return GiftCards.get({ id: currentProperty.hotelId, languageKey: currentLanguage }).$promise;
                            */
                        },
                    ],
                    //don't remove shoppingCart from here as parameters otherwise it will be called before shoppingCart resolves
                    groupVouchers: [
                        '$stateParams',
                        'voucherConfig',
                        'propertyGiftCards',
                        'GroupVouchers',
                        'currentProperty',
                        'currentPropertyGroup',
                        'currentLanguage',
                        'shoppingCart',
                        'VouchersProcessService',
                        function(
                            $stateParams,
                            voucherConfig,
                            propertyGiftCards,
                            GroupVouchers,
                            currentProperty,
                            currentPropertyGroup,
                            currentLanguage,
                            shoppingCart,
                            VouchersProcessService
                        ) {
                            if (typeof currentPropertyGroup === 'undefined') {
                                return undefined;
                            }
                            return GroupVouchers.get(
                                {
                                    id: currentPropertyGroup.id,
                                    code: currentPropertyGroup.code,
                                    channel: $stateParams.channel,
                                    passkey: $stateParams.passkey,
                                    languageKey: (currentLanguage || 'en' ).split('_')[0].split('-')[0],
                                    promoCode: undefined,
                                    selectedCategoryCodes: $stateParams.cat || [],
                                    minPrice: $stateParams.minPrice || 0,
                                    maxPrice: $stateParams.maxPrice || 0,
                                    intervalBars: 50,
                                    sort: 'price',
                                    sortOrder: 'asc',
                                    page: 1,
                                    pageSize: 24,
                                },
                                function(groupVouchers) {
                                    VouchersProcessService.processGroupVouchers(
                                        groupVouchers,
                                        currentProperty,
                                        shoppingCart,
                                        voucherConfig,
                                        propertyGiftCards
                                    );
                                }
                            ).$promise.then(function(result) {
                                return result.toJSON();
                            });
                        },
                    ],
                    //don't remove shoppingCart from here as parameters otherwise it will be called before shoppingCart resolves
                    propertyVouchers: [
                        '$transition$',
                        'PropertyVouchers',
                        'currentProperty',
                        'currentPropertyGroup',
                        'currentLanguage',
                        'shoppingCart',
                        'VouchersProcessService',
                        function(
                            $transition$,
                            PropertyVouchers,
                            currentProperty,
                            currentPropertyGroup,
                            currentLanguage,
                            shoppingCart,
                            VouchersProcessService
                        ) {
                            if (typeof currentPropertyGroup === 'undefined') {
                                return PropertyVouchers.get(
                                    {
                                        id: currentProperty.hotelId,
                                        channel: $transition$.params().channel,
                                        passkey: $transition$.params().passkey,
                                        languageKey: (currentLanguage || 'en' ).split('_')[0].split('-')[0],
                                        contextType: $transition$.params().contextType,
                                    },
                                    function(propertyVouchers) {
                                        //1. if there are discounts, filter them out here, it's not nice to do it out in the controller or html via filters... trust me.
                                        if (!shoppingCart.shoppingCartDiscounts.empty) {
                                            var voucherPoolsGenerated = [];
                                            angular.forEach(propertyVouchers.wrapper.voucherPools, function(voucherPool, key) {
                                                var voucherFirstKey = Object.keys(voucherPool.vouchers)[0];
                                                var voucherId = voucherPool.vouchers[voucherFirstKey].id;
                                                var voucherHotelId = voucherPool.vouchers[voucherFirstKey].hotelId;
                                                var isVoucherApplicable = false;
                                                //loop all promos
                                                angular.forEach(shoppingCart.shoppingCartDiscounts.discounts,function(d,dIndex){
                                                    if(!d.hideInapplicable){
                                                        isVoucherApplicable = true;//if discount is not hiding voucher, then it's applicable
                                                    }
                                                    if (d.propertyId && d.propertyId!=null && d.propertyId>0 && d.propertyId!=voucherHotelId){
                                                        //voucher is applicable if belongs to different property
                                                        isVoucherApplicable = true;
                                                    }
                                                    else if (d.filteredItemIds.includes(voucherId)) {
                                                        //voucher is applicable if is assigned to this discount
                                                        isVoucherApplicable = true;
                                                    }
                                                });
                                                if(isVoucherApplicable){
                                                    voucherPoolsGenerated.push(voucherPool);
                                                }
                                            });
                                            propertyVouchers.wrapper.voucherPools = voucherPoolsGenerated;
                                            propertyVouchers.voucherPoolsCount = voucherPoolsGenerated.length;
                                            //TODO: voucherClass
                                        }

                                        if (propertyVouchers.wrapper.voucherPools) {
                                            var voucherPoolsAvailable = [];
                                            angular.forEach(propertyVouchers.wrapper.voucherPools, function(voucherPool, key) {
                                                var countAvailable = 0;
                                                angular.forEach(voucherPool.vouchers, function(v, vkey) {
                                                    //1. generate minValue/maxValue
                                                    VouchersProcessService.setPoolMinMaxValues(voucherPool, v);

                                                    //2. if some vouchers are sold out, don't show them
                                                    var sold = v.vouchersSold;
                                                    var available = v.voucherCount >= 999 ? 99999 : v.voucherCount;
                                                    if (sold < available) {
                                                        countAvailable++;
                                                    }
                                                });
                                                if (countAvailable > 0) {
                                                    voucherPoolsAvailable.push(voucherPool);
                                                }
                                            });
                                            propertyVouchers.wrapper.voucherPools = voucherPoolsAvailable;
                                            propertyVouchers.voucherPoolsCount = voucherPoolsAvailable.length;
                                            //TODO: voucherClass
                                        }
                                    }
                                ).$promise.then(function(result) {
                                    return result.toJSON();
                                });
                            } else {
                                return undefined;
                            }
                        },
                    ],
                    //don't remove shoppingCart from here as parameters otherwise it will be called before shoppingCart resolves
                    propertyCashVouchers: [
                        '$transition$',
                        'PropertyCashVouchers',
                        'currentProperty',
                        'currentPropertyGroup',
                        'propertyGiftCards',
                        'currentLanguage',
                        'voucherConfig',
                        '$filter',
                        'shoppingCart',
                        'VouchersProcessService',
                        function(
                            $transition$,
                            PropertyCashVouchers,
                            currentProperty,
                            currentPropertyGroup,
                            propertyGiftCards,
                            currentLanguage,
                            voucherConfig,
                            $filter,
                            shoppingCart,
                            VouchersProcessService
                        ) {
                            if (typeof currentPropertyGroup === 'undefined') {
                                var propertyConfig = voucherConfig['' + currentProperty.hotelId];
                                console.log('propertyCashVouchers resolve start', propertyConfig);
                                if (
                                    propertyConfig &&
                                    propertyConfig.configMap &&
                                    propertyConfig.configMap.hideCashVouchers &&
                                    propertyConfig.configMap.hideCashVouchers === 'true'
                                ) {
                                    //GENERATE MIN/MAX VALUES
                                    var propertyCashVouchers = {};
                                    propertyCashVouchers.minValue = 0;
                                    propertyCashVouchers.maxValue = 0;
                                    propertyCashVouchers.minValueAfterDiscount = 0;
                                    propertyCashVouchers.maxValueAfterDiscount = 0;
                                    propertyCashVouchers.currency = currentProperty.hotelCurrency;
                                    return propertyCashVouchers;
                                }
                                return PropertyCashVouchers.get(
                                    {
                                        id: currentProperty.hotelId,
                                        languageKey: (currentLanguage || 'en' ).split('_')[0].split('-')[0],
                                        passkey: $transition$.params().passkey,
                                        contextType: $transition$.params().contextType,
                                    },
                                    function(propertyCashVouchers) {
                                        console.log('propertyCashVouchers promise', propertyCashVouchers);
                                        var cashVouchersPresent =
                                            propertyCashVouchers &&
                                            propertyCashVouchers.wrapper &&
                                            propertyCashVouchers.wrapper.voucherPools &&
                                            propertyCashVouchers.wrapper.voucherPools.length > 0;
                                        if (cashVouchersPresent) {
                                            //double check in case vouchers are empty object
                                            var countVouchers = 0;
                                            angular.forEach(propertyCashVouchers.wrapper.voucherPools, function(
                                                voucherPool,
                                                pkey
                                            ) {
                                                angular.forEach(voucherPool.vouchers, function(voucher, vkey) {
                                                    countVouchers++;
                                                });
                                            });
                                            if (countVouchers === 0) {
                                                propertyCashVouchers.vouchersClassCounter = {};
                                                propertyCashVouchers.voucherPoolsCount = 0;
                                                propertyCashVouchers.wrapper.voucherPools = [];
                                                return propertyCashVouchers;
                                            }

                                            if (
                                                !shoppingCart.shoppingCartDiscounts.empty) {
                                                var voucherPoolsGenerated = [];
                                                angular.forEach(propertyCashVouchers.wrapper.voucherPools, function(
                                                    voucherPool,
                                                    pkey
                                                ) {
                                                    var voucherFirstKey = Object.keys(voucherPool.vouchers)[0];
                                                    var voucherId = voucherPool.vouchers[voucherFirstKey].id;
                                                    var voucherHotelId = voucherPool.vouchers[voucherFirstKey].hotelId;
                                                    var isVoucherApplicable = false;
                                                    angular.forEach(shoppingCart.shoppingCartDiscounts.discounts,function(d,dIndex){
                                                        if(!d.hideInapplicable){
                                                            isVoucherApplicable = true;//if discount is not hiding voucher, then it's applicable
                                                        }
                                                        if (d.propertyId && d.propertyId!=null && d.propertyId>0 && d.propertyId!=voucherHotelId){
                                                            //voucher is applicable if belongs to different property
                                                            isVoucherApplicable = true;
                                                        }
                                                        else if (d.filteredItemIds.includes(voucherId)) {
                                                            //voucher is applicable if is assigned to this discount
                                                            isVoucherApplicable = true;
                                                        }
                                                    });
                                                    if(isVoucherApplicable){
                                                        voucherPoolsGenerated.push(voucherPool);
                                                    }
                                                });
                                                propertyCashVouchers.wrapper.voucherPools = voucherPoolsGenerated;
                                            }
                                            var generatedCashPoolsWithGiftCard = [];
                                            var generatedCashPoolsFeatured = [];
                                            var featuredVouchers = []; //these are amounts
                                            var propertyConfig = voucherConfig[currentProperty.hotelId] || {};
                                            if (
                                                propertyConfig &&
                                                propertyConfig.configMap &&
                                                propertyConfig.configMap.featuredCashVouchers
                                            ) {
                                                var value = propertyConfig.configMap.featuredCashVouchers.replace(
                                                    / /g,
                                                    ''
                                                );
                                                featuredVouchers = value.split(',');
                                            }
                                            //iterate each pool
                                            angular.forEach(propertyCashVouchers.wrapper.voucherPools, function(
                                                voucherPool,
                                                pkey
                                            ) {
                                                //GENERATE MIN/MAX VALUES
                                                voucherPool.minValue = 0;
                                                voucherPool.maxValue = 0;
                                                voucherPool.minValueAfterDiscount = 0;
                                                voucherPool.maxValueAfterDiscount = 0;
                                                voucherPool.currency = currentProperty.hotelCurrency;
                                                //todo: names here?
                                                voucherPool.cashVoucherName = 'Monetary';
                                                angular.forEach(voucherPool.vouchers, function(voucher, vkey) {
                                                    //fix currency
                                                    voucherPool.currency = voucher.currency;
                                                    //fix name
                                                    //voucher.currency + ' ' + $filter('number')(voucher.totalRate.minvoucher, 2);
                                                    //fix sequence
                                                    voucherPool.sequence = Number.MIN_SAFE_INTEGER + 1; //voucher.totalRate.priceMin;

                                                    //generate minValue/maxValue
                                                    VouchersProcessService.setPoolMinMaxValues(voucherPool, voucher);

                                                    //generate pool with featured cash voucher
                                                    if (~featuredVouchers.indexOf('' + voucher.totalRate.priceMin)) {
                                                        var generatedFeaturedPool = {};
                                                        generatedFeaturedPool.minValue = voucher.totalRate.priceMin;
                                                        generatedFeaturedPool.maxValue =
                                                            voucher.totalRate.priceMax == 0
                                                                ? voucher.totalRate.priceMin
                                                                : voucher.totalRate.priceMax;
                                                        generatedFeaturedPool.minValueAfterDiscount =
                                                            voucher.totalRateAfterDiscount.priceMin;
                                                        generatedFeaturedPool.maxValueAfterDiscount =
                                                            voucher.totalRateAfterDiscount.priceMax == 0
                                                                ? voucher.totalRateAfterDiscount.priceMin
                                                                : voucher.totalRateAfterDiscount.priceMax;
                                                        generatedFeaturedPool.currency = voucher.currency;
                                                        generatedFeaturedPool.vouchers = [];
                                                        generatedFeaturedPool.vouchers.push(voucher);
                                                        generatedFeaturedPool.sequence = Number.MIN_SAFE_INTEGER; //voucher.totalRate.priceMin;
                                                        generatedFeaturedPool.cashVoucherName =
                                                            voucherPool.cashVoucherName;
                                                        generatedFeaturedPool.type = voucherPool.type;
                                                        generatedFeaturedPool.featured = true;
                                                        generatedCashPoolsFeatured.push(generatedFeaturedPool);
                                                    }
                                                });
                                                if (propertyGiftCards) {
                                                    angular.forEach(propertyGiftCards, function(giftCard, gkey) {
                                                        var generatedGiftCardPool = {};
                                                        generatedGiftCardPool.minValue = voucherPool.minValue;
                                                        generatedGiftCardPool.maxValue = voucherPool.maxValue;
                                                        generatedGiftCardPool.minValueAfterDiscount =
                                                            voucherPool.minValueAfterDiscount;
                                                        generatedGiftCardPool.maxValueAfterDiscount =
                                                            voucherPool.maxValueAfterDiscount;
                                                        generatedGiftCardPool.currency = voucherPool.currency;
                                                        generatedGiftCardPool.vouchers = voucherPool.vouchers;
                                                        generatedGiftCardPool.sequence = voucherPool.sequence + 2;
                                                        generatedGiftCardPool.cashVoucherName =
                                                            voucherPool.cashVoucherName;
                                                        generatedGiftCardPool.giftCard = giftCard;
                                                        generatedGiftCardPool.type = voucherPool.type;
                                                        generatedCashPoolsWithGiftCard.push(generatedGiftCardPool);
                                                    });
                                                }
                                            });
                                            //add generated gift cards
                                            if (generatedCashPoolsWithGiftCard.length > 0) {
                                                propertyCashVouchers.wrapper.voucherPools = generatedCashPoolsWithGiftCard.concat(
                                                    propertyCashVouchers.wrapper.voucherPools
                                                );
                                            }
                                            if (generatedCashPoolsFeatured.length > 0) {
                                                propertyCashVouchers.wrapper.voucherPools = generatedCashPoolsFeatured.concat(
                                                    propertyCashVouchers.wrapper.voucherPools
                                                );
                                            }
                                        }
                                        console.log('new', propertyCashVouchers);
                                    }
                                ).$promise.then(function(result) {
                                    console.log('cash result', result.toJSON());
                                    return result.toJSON();
                                });
                            } else {
                                return undefined;
                            }
                        },
                    ],
                    allVouchers: [
                        'currentProperty',
                        'currentPropertyGroup',
                        'propertyCashVouchers',
                        'propertyVouchers',
                        'groupVouchers',
                        function(
                            currentProperty,
                            currentPropertyGroup,
                            propertyCashVouchers,
                            propertyVouchers,
                            groupVouchers
                        ) {
                            if (typeof currentPropertyGroup === 'undefined') {
                                var packageVouchers = propertyVouchers || {};
                                var cashVouchersPresent =
                                    propertyCashVouchers &&
                                    propertyCashVouchers.wrapper &&
                                    propertyCashVouchers.wrapper.voucherPools &&
                                    propertyCashVouchers.wrapper.voucherPools.length > 0;
                                //for property only-> generate pool in package vouchers (from cash)
                                if (cashVouchersPresent) {
                                    packageVouchers.wrapper.empty = false;
                                    packageVouchers.voucherPoolsCount = packageVouchers.voucherPoolsCount || 0;
                                    packageVouchers.voucherPoolsCount++;
                                    //add cash voucher pool at the beginning of array
                                    angular.forEach(propertyCashVouchers.wrapper.voucherPools, function(
                                        cashVoucherPool,
                                        pkey
                                    ) {
                                        packageVouchers.wrapper.voucherPools.unshift(cashVoucherPool);
                                    });
                                }
                                return packageVouchers;
                            } else {
                                return groupVouchers;
                            }
                        },
                    ],
                    propertyCategories: [
                        '$stateParams',
                        'Categories',
                        'currentProperty',
                        'currentLanguage',
                        function($stateParams, Categories, currentProperty, currentLanguage) {
                            return Categories.get({
                                id: currentProperty.hotelId,
                                languageKey: (currentLanguage || 'en' ).split('_')[0].split('-')[0],
                            }).$promise;
                        },
                    ],
                    groupCategories: [
                        '$stateParams',
                        'GroupCategories',
                        'currentPropertyGroup',
                        'currentLanguage',
                        function($stateParams, GroupCategories, currentPropertyGroup, currentLanguage) {
                            if (typeof currentPropertyGroup === 'undefined') {
                                return undefined;
                            }
                            return GroupCategories.get({
                                code: currentPropertyGroup.code,
                                languageKey: (currentLanguage || 'en' ).split('_')[0].split('-')[0],
                            }).$promise;
                        },
                    ],
                    previousState: [
                        '$state',
                        function($state) {
                            var currentStateData = {
                                name: $state.current.name || 'property.list',
                                params: $state.params,
                                url: $state.href($state.current.name, $state.params),
                            };
                            return currentStateData;
                        },
                    ],
                    shopMoreState: function($state, $transition$, DetermineShopMoreState) {
                        'ngInject';
                        var shopMoreStateData = {
                            name: 'list',
                            params: {
                                cat: $transition$.params().cat,
                                contextType: $transition$.params().contextType,
                                propertyId: $transition$.params().propertyId,
                                propertyType: $transition$.params().propertyType,
                            },
                            url: $state.href('list', $transition$.params()),
                        };
                        DetermineShopMoreState.setShopMoreState(shopMoreStateData);
                        return shopMoreStateData;
                    },

                    mainTranslatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        'currentProperty',
                        '$stateParams',
                        function($translate, $translatePartialLoader, currentProperty, $stateParams) {
                            var variant = '';
                            if ($stateParams.contextType) {
                                variant = '_' + $stateParams.contextType;
                            }
                            variant += '_' + currentProperty.hotelId;

                            $translatePartialLoader.addPart('vouchers' + variant);
                            $translatePartialLoader.addPart('giftcards' + variant);
                            return $translate.refresh();
                        },
                    ],
                },
            })
            .state('package-detail', {
                parent: 'list',
                url: '/item/{voucherId}',
                params: {
                    voucherPool: undefined,
                    doNotZoomIn: undefined
                },
                data: {
                    authorities: [],
                },
                reloadOnSearch: true, //WHEN POOL VOUCHERID CHANGES, RELOAD
                resolve: {
                    preShoppingCart: [
                        'ShoppingCart',
                        '$stateParams',
                        'currentProperty',
                        'currentLanguage',
                        function(ShoppingCart, $stateParams, currentProperty, currentLanguage) {
                            console.log('ModalService preShoppingCart', $stateParams);
                            //build shopping cart locale
                            var variant = '';
                            if ($stateParams.contextType) {
                                variant = '_' + $stateParams.contextType;
                            }
                            variant += (variant.length == 0 ? '_' : '') + currentProperty.hotelId;

                            console.log('variant', variant);
                            return ShoppingCart.api.get({
                                ref: $stateParams.ref,
                                src: $stateParams.src,
                                lang: currentLanguage + variant,
                                contextType: $stateParams.contextType,
                                propertyType: $stateParams.propertyType,
                                propertyCode: $stateParams.propertyId,
                            }).$promise;
                        },
                    ],
                    shoppingCart: [
                        '$q',
                        '$stateParams',
                        'preShoppingCart',
                        'ShoppingCart',
                        'ShoppingCartRemove',
                        'currentProperty',
                        'currentPropertyGroup',
                        'currentLanguage',
                        function(
                            $q,
                            $stateParams,
                            preShoppingCart,
                            ShoppingCart,
                            ShoppingCartRemove,
                            currentProperty,
                            currentPropertyGroup,
                            currentLanguage
                        ) {
                            var variant = '';
                            if ($stateParams.contextType) {
                                variant = '_' + $stateParams.contextType;
                            }
                            variant += (variant.length === 0 ? '_' : '') + currentProperty.hotelId;

                            function removeItem(itemUUID, successcallback, errorcallback) {
                                var cb = successcallback || angular.noop;
                                var ecb = errorcallback || angular.noop;
                                return ShoppingCartRemove.remove(
                                    { itemUUID: itemUUID },
                                    function(response) {
                                        return cb(response);
                                    },
                                    function(err) {
                                        return ecb(err);
                                    }.bind(this)
                                ).$promise;
                            }
                            //remove unwanted items in shopping cart
                            var removedPromises = [];
                            angular.forEach(preShoppingCart.shoppingCartItems.items, function(value, key) {
                                if (
                                    ($stateParams.propertyType == 'property' &&
                                        currentProperty.hotelId !== value.owningProperty.propertyId &&
                                        !isHotelIdInMasters(currentProperty, value.owningProperty.propertyId)) ||
                                    ($stateParams.propertyType == 'group' &&
                                        (!currentPropertyGroup ||
                                            !isHotelIdInGroup(currentPropertyGroup, value.owningProperty.propertyId)))
                                ) {
                                    var removePromise = removeItem(value.uuid);
                                    removedPromises.push(removePromise);
                                }
                            });
                            if (removedPromises.length > 0) {
                                var singleRemovePromise = $q.all(removedPromises);
                                var shoppingCartPromise = singleRemovePromise.then(
                                    function() {
                                        return ShoppingCart.api.get({
                                            ref: $stateParams.ref,
                                            src: $stateParams.src,
                                            lang: currentLanguage + variant,
                                            contextType: $stateParams.contextType,
                                            propertyType: $stateParams.propertyType,
                                            propertyCode: $stateParams.propertyId,
                                        }).$promise;
                                    },
                                    function(reason) {
                                        return $q.reject(reason);
                                    }
                                );
                                return shoppingCartPromise;
                            } else {
                                return preShoppingCart;
                            }
                        },
                    ],
                },
                onEnter:
                    function(
                        $transition$,
                        $state,
                        $uibModal,
                        $stateParams,
                        currentLanguage,
                        currentProperty,
                        currentPropertyGroup,
                        voucherConfig,
                        allVouchers,
                        propertyCategories,
                        groupCategories,
                        shoppingCart,
                        ModalService
                    ) {
                        'ngInject';
                        console.log('onEnter', propertyCategories)
                        var voucherId = $transition$.params().voucherId;
                        var voucherPool = $transition$.params().voucherPool;
                        var params = $transition$.params();
                        var modal = ModalService.open({
                            templateUrl: 'app/site/property/vouchers/voucher-package-detail-dialog.html',
                            controller: 'PropertyVoucherPackageDetailDialogController',
                            controllerAs: 'vm',
                            backdrop: true,
                            animation: false,
                            windowClass: $transition$.params().doNotZoomIn ? '' : 'zoomInModal modal-animated',
                            size: 'lg',
                            resolve: {
                                voucherId: function() {
                                    return voucherId;
                                },
                                currentLanguage: function(){return currentLanguage;},
                                propertyCategories: function() {
                                    return propertyCategories;
                                },
                                groupCategories: function() { return groupCategories; },
                                currentProperty: currentProperty,
                                currentPropertyGroup: currentPropertyGroup,
                                allVouchers: allVouchers,
                                voucherConfig: voucherConfig,
                                shoppingCart: shoppingCart,
                                voucherPool: [
                                    function() {
                                        if (voucherPool) {
                                            return voucherPool;
                                        }
                                        //get the first pool that contains this voucher id
                                        var firstPool;
                                        var fallbackPool;
                                        var selectedPool;
                                        if (allVouchers && allVouchers.wrapper && allVouchers.wrapper.voucherPools) {
                                            angular.forEach(allVouchers.wrapper.voucherPools, function(
                                                voucherPool,
                                                pkey
                                            ) {
                                                var poolHasVoucher = false;
                                                angular.forEach(voucherPool.vouchers, function(voucher, vkey) {
                                                    //voucherId might be string or undefined
                                                    if (!voucherId || voucher.id == voucherId) {
                                                        poolHasVoucher = true;
                                                    }
                                                });
                                                //this is the top most fallback
                                                if (!firstPool) {
                                                    firstPool = voucherPool;
                                                }
                                                //next fallback is a combined pool with this cashVoucherId
                                                if (!fallbackPool && poolHasVoucher) {
                                                    fallbackPool = voucherPool;
                                                }
                                                //then we can choose selected pool
                                                if (!voucherId || poolHasVoucher) {
                                                    selectedPool = voucherPool;
                                                }
                                            });
                                        }
                                        return selectedPool || fallbackPool || firstPool;
                                    },
                                ],
                                contextType: function() { return $stateParams.contextType; }
                            },
                        });
                        modal.result.then(
                            function (reason) {
                                console.log('closed modal success ', reason)
                                //this is called when modal is closed
                                if (reason === 'shoppingCart') {
                                    $state.transitionTo('shopping-cart', params, { inherit: true, notify: true, reload: true });
                                } else if (reason === 'addToCart') {
                                    $state.transitionTo('list', params, { inherit: true, notify: true, reload: false });
                                }else {
                                    $state.transitionTo('^', {}, {reload: false, notify: true});
                                }

                            },
                            function (reason) {
                                console.log('closed modal error ', reason)
                                //this is called when modal is dismissed, i.e: vm.clear() is called with reason 'cancel'
                                if (reason === "voucherIdChanged") {
                                    return;//do not go to parent state if we are already changing the state do to other reason like pool change
                                } else if (reason === "doNotGoToParent") {
                                    return;//do not go to parent state
                                } else if (reason === 'shoppingCart') {
                                    $state.go('shopping-cart', params, { inherit: true, notify: true, reload: true });
                                } else {
                                    $state.go('^', {}, {reload: false, notify: true});
                                }


                            }
                        );
                        $state.currentModal = modal;
                    }
                ,
            })
            .state('cash-detail', {
                parent: 'list',
                url: '/cashitem?giftCardId&cashVoucherId&cashPropertyId&focusedAmount',
                params: {
                    //params hidden from URL
                    voucherPool: undefined,
                },
                data: {
                    authorities: [],
                },
                reloadOnSearch: false, //THIS WILL PREVENT RELOADING WHEN CAT in URL CHANGES!
                resolve: {
                    preShoppingCart: [
                        'ShoppingCart',
                        '$stateParams',
                        'currentProperty',
                        'currentLanguage',
                        function(ShoppingCart, $stateParams, currentProperty, currentLanguage) {
                            //build shopping cart locale
                            var variant = '';
                            if ($stateParams.contextType) {
                                variant = '_' + $stateParams.contextType;
                            }
                            variant += (variant.length == 0 ? '_' : '') + currentProperty.hotelId;

                            return ShoppingCart.api.get({
                                ref: $stateParams.ref,
                                src: $stateParams.src,
                                lang: currentLanguage + variant,
                                contextType: $stateParams.contextType,
                                propertyType: $stateParams.propertyType,
                                propertyCode: $stateParams.propertyId,
                            }).$promise;
                        },
                    ],
                    shoppingCart: [
                        '$q',
                        '$stateParams',
                        'preShoppingCart',
                        'ShoppingCart',
                        'ShoppingCartRemove',
                        'currentProperty',
                        'currentPropertyGroup',
                        'currentLanguage',
                        function(
                            $q,
                            $stateParams,
                            preShoppingCart,
                            ShoppingCart,
                            ShoppingCartRemove,
                            currentProperty,
                            currentPropertyGroup,
                            currentLanguage
                        ) {
                            var variant = '';
                            if ($stateParams.contextType) {
                                variant = '_' + $stateParams.contextType;
                            }
                            variant += (variant.length === 0 ? '_' : '') + currentProperty.hotelId;

                            function removeItem(itemUUID, successcallback, errorcallback) {
                                var cb = successcallback || angular.noop;
                                var ecb = errorcallback || angular.noop;
                                return ShoppingCartRemove.remove(
                                    { itemUUID: itemUUID },
                                    function(response) {
                                        return cb(response);
                                    },
                                    function(err) {
                                        return ecb(err);
                                    }.bind(this)
                                ).$promise;
                            }
                            //remove unwanted items in shopping cart
                            var removedPromises = [];
                            angular.forEach(preShoppingCart.shoppingCartItems.items, function(value, key) {
                                if (
                                    ($stateParams.propertyType == 'property' &&
                                        currentProperty.hotelId !== value.owningProperty.propertyId &&
                                        !isHotelIdInMasters(currentProperty, value.owningProperty.propertyId)) ||
                                    ($stateParams.propertyType == 'group' &&
                                        (!currentPropertyGroup ||
                                            !isHotelIdInGroup(currentPropertyGroup, value.owningProperty.propertyId)))
                                ) {
                                    var removePromise = removeItem(value.uuid);
                                    removedPromises.push(removePromise);
                                }
                            });
                            if (removedPromises.length > 0) {
                                var singleRemovePromise = $q.all(removedPromises);
                                var shoppingCartPromise = singleRemovePromise.then(
                                    function() {
                                        return ShoppingCart.api.get({
                                            ref: $stateParams.ref,
                                            src: $stateParams.src,
                                            lang: currentLanguage + variant,
                                            contextType: $stateParams.contextType,
                                            propertyType: $stateParams.propertyType,
                                            propertyCode: $stateParams.propertyId,
                                        }).$promise;
                                    },
                                    function(reason) {
                                        return $q.reject(reason);
                                    }
                                );
                                return shoppingCartPromise;
                            } else {
                                return preShoppingCart;
                            }
                        },
                    ],
                },
                onEnter:
                    function(
                        $transition$,
                        $stateParams,
                        $state,
                        $uibModal,
                        currentLanguage,
                        currentProperty,
                        currentPropertyGroup,
                        voucherConfig,
                        allVouchers,
                        propertyGiftCards,
                        shoppingCart,
                        ModalService
                    ) {
                        'ngInject';
                        console.log('opening modal...')
                        var modal = ModalService.open({
                            templateUrl: 'app/site/property/vouchers/voucher-cash-detail-dialog.html',
                            controller: 'PropertyVoucherCashDetailDialogController',
                            controllerAs: 'vm',
                            backdrop: true,
                            animation: false,
                            windowClass: 'zoomInModal modal-animated',
                            size: 'lg',
                            resolve: {
                                currentLanguage: function(){return currentLanguage;},
                                currentProperty: currentProperty,
                                currentPropertyGroup: currentPropertyGroup,
                                allVouchers: allVouchers,
                                voucherConfig: voucherConfig,
                                //propertyGiftCards : propertyGiftCards,
                                shoppingCart: shoppingCart,
                                voucherPool: [
                                    function() {
                                        if ($stateParams.voucherPool) {
                                            return $stateParams.voucherPool;
                                        }
                                        //we are looking for particular pool that holds this cash voucher
                                        var cashVoucherId;
                                        if ($stateParams.cashVoucherId && $stateParams.cashVoucherId > 0) {
                                            cashVoucherId = $stateParams.cashVoucherId;
                                        }
                                        //are we looking for a pool with specific amount only (featured voucher?)
                                        var featured = false;
                                        if ($stateParams.focusedAmount && $stateParams.focusedAmount > 0) {
                                            featured = true;
                                        }
                                        //are we looking for a pool with specific gift card?
                                        var giftCardId;
                                        if ($stateParams.giftCardId && $stateParams.giftCardId > 0) {
                                            giftCardId = $stateParams.giftCardId;
                                        }
                                        //get the first pool that contains this voucher id
                                        var firstPool;
                                        var fallbackPool;
                                        var selectedPool;
                                        if (allVouchers && allVouchers.wrapper && allVouchers.wrapper.voucherPools) {
                                            angular.forEach(allVouchers.wrapper.voucherPools, function(
                                                voucherPool,
                                                pkey
                                            ) {
                                                if (!voucherPool.type.includes('cash')) {
                                                    return;
                                                }
                                                var poolIsFeatured = voucherPool.featured;
                                                var poolHasGiftCard =
                                                    voucherPool.giftCard && voucherPool.giftCard.id == giftCardId;
                                                var poolHasCashVoucher = false;
                                                angular.forEach(voucherPool.vouchers, function(voucher, vkey) {
                                                    if (!cashVoucherId || voucher.id == cashVoucherId) {
                                                        poolHasCashVoucher = true;
                                                    }
                                                });
                                                //this is the top most fallback
                                                if (!firstPool) {
                                                    firstPool = voucherPool;
                                                }
                                                //next fallback is a combined pool with this cashVoucherId
                                                if (!fallbackPool && poolHasCashVoucher) {
                                                    fallbackPool = voucherPool;
                                                }
                                                //then we can choose selected pool
                                                if (
                                                    (!featured || (featured && poolIsFeatured)) &&
                                                    (!giftCardId || poolHasGiftCard) &&
                                                    (!cashVoucherId || poolHasCashVoucher)
                                                ) {
                                                    selectedPool = voucherPool;
                                                }
                                            });
                                        }
                                        return cashVoucherId ? selectedPool : (selectedPool || fallbackPool || firstPool);
                                    }],
                            },
                        });

                        $state.currentModal = modal;

                        modal.result.then(
                            function() {
                                //this is called when modal is closed
                                $state.go('^', {}, { reload: false, notify: false });
                            },
                            function() {
                                //this is called when modal is dismissed, i.e: vm.clear() is called with reason 'cancel'
                                //every time item is added to the card this modal is dismissed
                                $state.go('^', {}, { reload: false, notify: false });
                            }
                        );
                    },

            })
            .state('cash-detail-fullpage', {
                parent: 'property.list',
                url: '/cashitem/full?giftCardId&cashVoucherId&focusedAmount',
                data: {
                    authorities: [],
                    hideClear: true,
                },
                reloadOnSearch: false, //THIS WILL PREVENT RELOADING WHEN CAT in URL CHANGES!
                views: {
                    'content@': {
                        templateUrl: 'app/site/property/vouchers/voucher-cash-detail-dialog.html',
                        controller: 'PropertyVoucherCashDetailDialogController',
                        controllerAs: 'vm',
                    },
                    'header@': {
                        templateUrl: 'app/layouts/header/header.html',
                        controller: 'BrandedHeaderController',
                        controllerAs: 'vm',
                    },
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.html',
                        controller: 'BrandedFooterController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    voucherConfig: [
                        'VobeConfig',
                        'currentProperty',
                        function(VobeConfig, currentProperty) {
                            //gather property ids
                            var propertyIds = [];
                            propertyIds.push(currentProperty.hotelId);
                            return VobeConfig.config.get({ propertyIds: propertyIds }).$promise;
                        },
                    ],
                    $uibModalInstance: [function() {}],
                    voucherPool: [
                        function() {
                            if ($stateParams.voucherPool) {
                                return $stateParams.voucherPool;
                            }
                            //we are looking for particular pool that holds this cash voucher
                            var cashVoucherId;
                            if ($stateParams.cashVoucherId && $stateParams.cashVoucherId > 0) {
                                cashVoucherId = $stateParams.cashVoucherId;
                            }
                            //are we looking for a pool with specific amount only (featured voucher?)
                            var featured = false;
                            if ($stateParams.focusedAmount && $stateParams.focusedAmount > 0) {
                                featured = true;
                            }
                            //are we looking for a pool with specific gift card?
                            var giftCardId;
                            if ($stateParams.giftCardId && $stateParams.giftCardId > 0) {
                                giftCardId = $stateParams.giftCardId;
                            }
                            //get the first pool that contains this voucher id
                            var firstPool;
                            var fallbackPool;
                            var selectedPool;
                            if (propertyCashVouchers) {
                                angular.forEach(propertyCashVouchers.wrapper.voucherPools, function(voucherPool, pkey) {
                                    var poolIsFeatured = voucherPool.featured;
                                    var poolHasGiftCard = voucherPool.giftCard && voucherPool.giftCard.id == giftCardId;
                                    var poolHasCashVoucher = false;
                                    angular.forEach(voucherPool.vouchers, function(voucher, vkey) {
                                        if (!cashVoucherId || voucher.id == cashVoucherId) {
                                            poolHasCashVoucher = true;
                                        }
                                    });
                                    //this is the top most fallback
                                    if (!firstPool) {
                                        firstPool = voucherPool;
                                    }
                                    //next fallback is a combined pool with this cashVoucherId
                                    if (!fallbackPool && poolHasCashVoucher) {
                                        fallbackPool = voucherPool;
                                    }
                                    //then we can choose selected pool
                                    if (
                                        (!featured || (featured && poolIsFeatured)) &&
                                        (!giftCardId || poolHasGiftCard) &&
                                        (!cashVoucherId || poolHasCashVoucher)
                                    ) {
                                        selectedPool = voucherPool;
                                    }
                                });
                            }
                            return selectedPool || fallbackPool || firstPool;
                        },
                    ],
                    shoppingCart: [
                        'shoppingCart',
                        function(shoppingCart) {
                            return shoppingCart;
                        },
                    ],
                },
            })
            .state('cookie-policy', {
                parent: 'property',
                url : "/cookie-policy",
                data: {
                    pageTitle: 'legal.cookies.policy.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/components/cookies-consent/cookies-policy-modal.html',
                        controller: 'CookiesPolicyController',
                        controllerAs: 'vm',
                    },
                    'header@': {
                        templateUrl: 'app/layouts/header/header.html',
                        controller: 'BrandedHeaderController',
                        controllerAs: 'vm',
                    },
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.html',
                        controller: 'BrandedFooterController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //console.log("in app state addPart global");
                        $translatePartialLoader.addPart('legal');
                        return $translate.refresh();
                    }]
                }
            })
            .state('cookie-preferences', {
            parent: 'property',
            url : "/cookie-preferences",
            data: {
                pageTitle: 'legal.cookies.policy.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/components/cookies-consent/cookies-policy-modal.html',
                    controller: 'CookiesPolicyController',
                    controllerAs: 'vm',
                },
                'header@': {
                    templateUrl: 'app/layouts/header/header.html',
                    controller: 'BrandedHeaderController',
                    controllerAs: 'vm',
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.html',
                    controller: 'BrandedFooterController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    //console.log("in app state addPart global");
                    $translatePartialLoader.addPart('legal');
                    return $translate.refresh();
                }]
            },

        });
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PropertyVouchers', PropertyVouchers);

    PropertyVouchers.$inject = ['$resource'];

    function PropertyVouchers ($resource) {
        var service = $resource('api/property/:id/vouchers', {}, {
            'query': {method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

/* eslint-disable no-console */
(function() {
    'use strict';

    angular.module('vobeApp').controller('PropertyVouchersController', PropertyVouchersController);

    function PropertyVouchersController(
        $scope,
        $rootScope,
        $state,
        previousState,
        $location,
        currentLanguage,
        currentProperty,
        currentPropertyGroup,
        propertyVouchers,
        propertyCashVouchers,
        propertyGiftCards,
        Property,
        PropertyVouchers,
        VouchersProcessService,
        allVouchers,
        User,
        $animate,
        $timeout,
        $document,
        $window,
        VouchersViewSettings,
        shoppingCart,
        shoppingCartConfigs,
        propertyCategories,
        groupCategories,
        PromotionCodeService,
        $sce,
        $log,
        $q,
        GroupVouchers,
        CurrencyExchange,
        $localStorage,
        $uiRouterGlobals,
        $filter,
        translationHandler,
        $cookies
    ) {
        'ngInject';
        var vm = this;

        //for the moment $log prints in production profile, so overwriting with console
        $log = console;
        console.log('property vouchers controller');

        vm.filter = $filter;//important
        var categoryParameterName = 'cat';
        var minPriceParameterName = 'minPrice';
        var maxPriceParameterName = 'maxPrice';
        var pageParameterName = 'page';
        var viewSettings = {
            viewLayoutTileActive: 'three',
            voucherPoolOrderBy: {
                name: 'sequence',
                reverse: false,
            },
        };

        var cashVouchersPresent = false;
        var propertyConfig = {};

        vm.$onInit = function () {
            vm.websiteType = (typeof currentPropertyGroup !== 'undefined') ? 'group' : 'property';
            vm.voucherClassCounter = [];//only one reference to array
            vm.channel = $uiRouterGlobals.params.channel;
            vm.currentProperty = currentProperty;
            vm.currentPropertyGroup = currentPropertyGroup;
            var isGroup = (typeof vm.currentPropertyGroup !== 'undefined');
            vm.isGroup = isGroup;
            vm.shoppingCartConfigs = shoppingCartConfigs;
            vm.promotionCode = {
                code: $uiRouterGlobals.params.promotionCode
            };

            vm.applyPromotionCode = applyPromotionCode;
            vm.removePromotionCode = removePromotionCode;
            vm.processingPromotionCode = false;

            vm.viewClass = 'property-detail';
            vm.openCashModal = openCashModal;
            vm.openPackageModal = openPackageModal;

            vm.viewLayoutTileDesign = 'default';
            vm.descriptionLines = $uiRouterGlobals.params.descriptionLines || 1;

            propertyConfig = shoppingCartConfigs['' + currentProperty.hotelId];
            if (
                propertyConfig &&
                propertyConfig.configMap &&
                propertyConfig.configMap.defaultItemsPerRow &&
                propertyConfig.configMap.defaultItemsPerRow == '3'
            ) {
                viewSettings.viewLayoutTileActive = 'three';
            }
            if (
                propertyConfig &&
                propertyConfig.configMap &&
                propertyConfig.configMap.defaultItemsPerRow &&
                propertyConfig.configMap.defaultItemsPerRow == '4'
            ) {
                viewSettings.viewLayoutTileActive = 'four';
            }
            if (
                propertyConfig &&
                propertyConfig.configMap &&
                propertyConfig.configMap.defaultItemsPerRow &&
                propertyConfig.configMap.defaultItemsPerRow == '6'
            ) {
                viewSettings.viewLayoutTileActive = 'six';
            }
            if (
                propertyConfig &&
                propertyConfig.configMap &&
                propertyConfig.configMap.defaultSortOption &&
                propertyConfig.configMap.defaultSortOption == '1'
            ) {
                viewSettings.voucherPoolOrderBy.name = 'minValueAfterDiscount';
            }
            if (
                propertyConfig &&
                propertyConfig.configMap &&
                propertyConfig.configMap.viewLayoutTileDesign &&
                ['text', 'default'].includes(propertyConfig.configMap.viewLayoutTileDesign)
            ) {
                vm.viewLayoutTileDesign = propertyConfig.configMap.viewLayoutTileDesign;
            }
            if (propertyConfig && propertyConfig.configMap && propertyConfig.configMap.descriptionLines) {
                vm.descriptionLines = propertyConfig.configMap.descriptionLines;
            }

            vm.defaultShowCategoriesBoxTreshold = 2;//two or more
            vm.showCategoriesBoxTreshold = vm.defaultShowCategoriesBoxTreshold;
            if (
                propertyConfig &&
                propertyConfig.configMap &&
                propertyConfig.configMap.showCategoriesBoxTreshold &&
                propertyConfig.configMap.showCategoriesBoxTreshold != ''
            ) {
                try {
                    var parsedShowCategoriesBoxTreshold = parseInt(propertyConfig.configMap.showCategoriesBoxTreshold);
                    if(parsedShowCategoriesBoxTreshold>0){
                        vm.showCategoriesBoxTreshold = parsedShowCategoriesBoxTreshold;
                    }
                } catch (e) {}
            }
            vm.showCategoriesBoxType = 1;
            if (
                propertyConfig &&
                propertyConfig.configMap &&
                propertyConfig.configMap.showCategoriesBoxType &&
                propertyConfig.configMap.showCategoriesBoxType != 1
            ) {
                try {
                    vm.showCategoriesBoxType = parseInt(propertyConfig.configMap.showCategoriesBoxType);
                } catch (e) {}
            }
            vm.showSortControls = true;
            if (
                propertyConfig &&
                propertyConfig.configMap &&
                propertyConfig.configMap.hideSortOption &&
                propertyConfig.configMap.hideSortOption == 'true'
            ) {
                try {
                    vm.showSortControls = false;
                } catch (e) {}
            }
            vm.showColumnControls = true;
            if (
                propertyConfig &&
                propertyConfig.configMap &&
                propertyConfig.configMap.hideItemsPerRow &&
                propertyConfig.configMap.hideItemsPerRow == 'true'
            ) {
                try {
                    vm.showColumnControls = false;
                } catch (e) {}
            }
            vm.showPromoControls = true;
            if (
                propertyConfig &&
                propertyConfig.configMap &&
                propertyConfig.configMap.hasActivePromotionCodes &&
                propertyConfig.configMap.hasActivePromotionCodes == 'false'
            ) {
                try {
                    vm.showPromoControls = false;
                } catch (e) {}
            }
            vm.mobileExpandedCategories = false;
            if (
                propertyConfig &&
                propertyConfig.configMap &&
                propertyConfig.configMap.mobileExpandedCategories &&
                propertyConfig.configMap.mobileExpandedCategories == 'true'
            ) {
                try {
                    vm.mobileExpandedCategories = true;
                } catch (e) {}
            }

            /*promo disabled for group*/
            if(isGroup){
                //vm.showPromoControls = false;
            }

            var savedSettings = VouchersViewSettings.getSettings();
            vm.settings = angular.extend(viewSettings, savedSettings);

            vm.voucherPoolOrderBy = vm.settings.voucherPoolOrderBy;

            vm.viewLayoutTiles = {
                three: {
                    breakpoint: {
                        xs: { cards: 1 },
                        sm: { cards: 1 },
                        md: { cards: 2 },
                        lg: { cards: 3 },
                    },
                    activeBreakpoint: {},
                },
                four: {
                    breakpoint: {
                        xs: { cards: 1 },
                        sm: { cards: 2 },
                        md: { cards: 3 },
                        lg: { cards: 4 },
                    },
                    activeBreakpoint: {},
                },
                six: {
                    breakpoint: {
                        xs: { cards: 1 },
                        sm: { cards: 3 },
                        md: { cards: 4 },
                        lg: { cards: 6 },
                    },
                    activeBreakpoint: {},
                },
            };


            setActiveBreakpoints(getViewSize());

            //reference shortcuts
            vm.viewLayoutTileActive = vm.settings.viewLayoutTileActive;
            //reference to active layout
            vm.viewLayout = vm.viewLayoutTiles[vm.viewLayoutTileActive];

            vm.property = currentProperty;
            vm.previousState = previousState.name;

            vm.activateSlick = activateSlick;
            vm.activateSlickFeatured = activateSlickFeatured;

            /**
             * CATEGORIES
             */

            vm.propertyCategories = propertyCategories;
            vm.groupCategories = groupCategories;
            vm.voucherClassActive = $uiRouterGlobals.params.cat || ($uiRouterGlobals.current.data ? $uiRouterGlobals.current.data.voucherClassActive : 'all');
            vm.multipleCategoryFilter = [];
            vm.voucherFirstCategoryActive = {classId: 'all'};
            vm.activateVoucherClass = activateVoucherClass;
            vm.sortVoucherClass = sortVoucherClass;
            vm.filterByVoucherClass = filterByVoucherClass;
            vm.filterGiftCardByVoucherClass = filterGiftCardByVoucherClass;
            vm.showCategoriesBox = true;//always true

            /**
             * PRICING
             */
            var minPriceParsed = 0;
            try {
                minPriceParsed = parseInt($uiRouterGlobals.params[minPriceParameterName] ? $uiRouterGlobals.params[minPriceParameterName] : minPriceParsed);
            } catch (e) {
                $log.error("Error parsing min price");
            }
            var maxPriceParsed = 0;
            try {
                maxPriceParsed = parseInt($uiRouterGlobals.params[maxPriceParameterName] ? $uiRouterGlobals.params[maxPriceParameterName] : maxPriceParsed);
            } catch (e) {
                $log.error("Error parsing min price");
            }
            vm.priceFilter = {
                minPrice: minPriceParsed,
                maxPrice: maxPriceParsed
            };
            activatePriceRange(minPriceParsed,maxPriceParsed);

            /**
             * FEATURED VOUCHERS
             */

            vm.featuredVouchers = []; //these are amounts
            if (propertyConfig && propertyConfig.configMap && propertyConfig.configMap.featuredCashVouchers) {
                var value = propertyConfig.configMap.featuredCashVouchers.replace(/ /g, '');
                vm.featuredVouchers = value.split(',');
            }


            //vm.allVouchers = allVouchers;
            //vm.propertyVouchers = propertyVouchers;
            //vm.propertyCashVouchers = propertyCashVouchers;

            vm.propertyGiftCards = propertyGiftCards;

            vm.displayCashVoucher = false;
            vm.disableVoucherClass = true; //Always true since Nov 2017. Reason: always disable voucher class
            vm.shoppingCart = shoppingCart;

            /**
             * VARIABLES THAT WILL CHANGE ON VOUCHERS RELOAD
             */
            vm.initialVoucherClassCounter = [];
            vm.showCategoriesBoxUseful = true;
            vm.priceIntervalsCounter = {};

            //multiple category filter values ... initally empty.. which means all.
            vm.multipleCategoryFilter = vm.multipleCategoryFilter || [];
            vm.cardsCounter = 0;

            processVouchers(allVouchers);
            activateVoucherClassAsync();
            activatePriceRange(vm.priceFilter.minPrice,vm.priceFilter.maxPrice);

            /**
             * SLICK CAROUSEL CONFIG - FOR CATEGORIES
             */

            if(vm.allVouchers.wrapper) {
                angular.forEach(vm.allVouchers.wrapper.voucherPools, function (pool, pkey) {
                    if (pool.type === 'cash' || pool.type === 'cash-wildcard') {
                        cashVouchersPresent = true;
                    }
                });
            }
            if(!cashVouchersPresent && isGroup && vm.allVouchers.eligibleVouchers){
                angular.forEach(vm.allVouchers.eligibleVouchers, function(poolIdsArray, hotelId){
                    angular.forEach(poolIdsArray, function(voucherIdsArray, poolId){
                        if(poolId<0){
                            cashVouchersPresent = true;
                        }
                    });
                });
            }
            var sliderArows = true; //false;
            var slidesPerRow = 3;
            var slideCategories = vm.voucherClassCounter.length + 1 /*all*/ + (cashVouchersPresent ? 0 : 1);
            var slickRows = 1; //parseInt(slideCategories / slidesPerRow);
            if ($(window).width() < 568) {
                slickRows = 1;
                slidesPerRow = 1;
            } else if ($(window).width() < 768) {
                slickRows = 2;
                slidesPerRow = 2;
            } else if ($(window).width() < 1025) {
                slickRows = 3;
                slidesPerRow = 3;
            }
            if (slidesPerRow * slickRows < slideCategories) {
                sliderArows = true;
            }

            vm.slickConfig = {
                enabled: false,
                autoplay: false,
                draggable: true,
                centerMode: false,
                dots: false,
                arrows: sliderArows,
                swipe: true,
                //slidesToShow: slidesPerRow,
                //slidesPerRow: slidesPerRow,
                rows: slickRows,
                infinite: false,
                method: {},
                prevArrow: '<span class="glyphicon glyphicon-chevron-left slick-prev" aria-hidden="true"></span>',
                nextArrow: '<span class="glyphicon glyphicon-chevron-right slick-next" aria-hidden="true"></span>',
                event: {
                    beforeChange: function(event, slick, currentSlide, nextSlide) {},
                    afterChange: function(event, slick, currentSlide, nextSlide) {},
                },
            };

            if (slickRows === 1) {
                vm.slickConfig.slidesToShow = slidesPerRow;
            } else {
                vm.slickConfig.slidesPerRow = slidesPerRow;
            }
            /** END SLICK CAROUSEL CONFIG FOR CATEGORIES */

            /**
             * SLICK CAROUSEL CONFIG - FOR FEATURED VOUCHERS
             */
            var isRTL = translationHandler.isRTL((currentLanguage || 'en' ).split('_')[0].split('-')[0]);
            var feat_v_slidesToShow = 1;
            var feat_v_slidesPerRow = 1;
            var feat_v_slickRows = 1; //parseInt(slideCategories / slidesPerRow);
            vm.feat_v_slickConfig = {
                rtl: isRTL,
                enabled: false,
                autoplay: false,
                draggable: true,
                centerMode: false,
                dots: true,
                arrows: true,
                swipe: true,
                slidesToShow: feat_v_slidesToShow,
                slidesPerRow: feat_v_slidesPerRow,
                rows: feat_v_slickRows,
                infinite: false,
                method: {},
                prevArrow: '<div class="slick-prev"><button class="w3-button w3-text-grey w3-card-2 w3-circle w3-padding" style="line-height: 2;" role="button">\n' +
                '<span class="glyphicon glyphicon-chevron-'+(isRTL ? 'right' : 'left')+'" aria-hidden="true"></span>\n' +
                '</button></div>',
                nextArrow: '<div class="slick-next"><button class="w3-button w3-text-grey w3-card-2 w3-circle w3-padding" style="line-height: 2;" role="button">\n' +
                '<span class="glyphicon glyphicon-chevron-'+(isRTL ? 'left' : 'right')+'" aria-hidden="true"></span>\n' +
                '</button></div>',
                event: {
                    beforeChange: function(event, slick, currentSlide, nextSlide) {},
                    afterChange: function(event, slick, currentSlide, nextSlide) {},
                },
            };
            /** END SLICK CAROUSEL CONFIG FOR FEATURED VOUCHERS */

            vm.filterCashVouchersByFeatured = filterCashVouchersByFeatured;
            vm.handlePageChange = handlePageChange;
            vm.getImageFileName = getImageFileName;

            vm.appliedPromotionCode;
            if (
                shoppingCart &&
                shoppingCart.shoppingCartDiscounts &&
                shoppingCart.shoppingCartDiscounts.promotionCodeIds &&
                shoppingCart.shoppingCartDiscounts.promotionCodeIds.length > 0
            ) {

                angular.forEach(shoppingCart.shoppingCartDiscounts.discounts, function(d, i) {
                    console.log('checking dicount...', d)
                    //if is already set, skip looping
                    if(vm.appliedPromotionCode){
                        vm.promotionCode.code = vm.appliedPromotionCode.code;
                        return;
                    }
                    if (!isGroup && !d.automatic && shoppingCart.shoppingCartDiscounts.promotionCodeIds.includes(d.id) && d.propertyId == currentProperty.hotelId) {
                        vm.appliedPromotionCode = d;
                        vm.promotionCode.code = d.code;
                    }

                    if (isGroup && !d.automatic && shoppingCart.shoppingCartDiscounts.promotionCodeIds.includes(d.id)) {
                        angular.forEach(currentPropertyGroup.hotels,function(h,hIndex){
                            if( d.propertyId == h.hotelId){
                                vm.appliedPromotionCode = d;
                                vm.promotionCode.code = d.code;
                            }
                        });
                    }
                    //TODO: please test
                    else if (!d.automatic && shoppingCart.shoppingCartDiscounts.promotionCodeIds.includes(d.id)  && d.propertyId == null && isGroup){
                        //for a group only 'masteradmin' level promo can be applied to pricing
                        //therefore only under 'd.propertyId == null' condition it's allowed to be displayed as applied
                        vm.appliedPromotionCode = d;
                        vm.promotionCode.code = d.code;
                    }
                });
            }

            //set paymentRefToken cookie if present in the stateparams
            if ($uiRouterGlobals.params.pRef) {
                const expiryDate = new Date(Date.now() + 1 * (60 * 60 * 1000) );
                $cookies.put('paymentRefToken', $uiRouterGlobals.params.pRef, { expires: expiryDate });``
            }

            //allows for category sequences
            vm.useCategorySequence = false;
            var propertyId = vm.currentProperty.hotelId;
            if (vm.shoppingCartConfigs[propertyId] && vm.shoppingCartConfigs[propertyId].configMap && vm.shoppingCartConfigs[propertyId].configMap.useCategorySequence && vm.shoppingCartConfigs[propertyId].configMap.useCategorySequence == 'true') {
                vm.useCategorySequence = true;
            }

            vm.onCurrencyUpdated = onCurrencyUpdated;
            vm.min = Math.min;
        }

        var itemRemovedFromCartEvent = $rootScope.$on('itemRemovedFromCart', function(event, args) {
            console.log('property-vouchers controller itemRemoveFromCart', args.shoppingCart);
            vm.shoppingCart = args.shoppingCart;
        });

        $scope.$watch('vm.settings.viewLayoutTileActive', function() {
            console.log('watch vm.settings.viewLayoutTileActive');
            angular.forEach(vm.viewLayoutTiles, function(value, key) {
                if (key === vm.settings.viewLayoutTileActive) {
                    vm.viewLayout = value;
                }
            });
            VouchersViewSettings.setSettings(vm.settings);
        });

        $scope.$watch('vm.settings.voucherPoolOrderBy', function() {
            console.log('watch vm.settings.voucherPoolOrderBy');
            VouchersViewSettings.setSettings(vm.settings);
        });

        $window.addEventListener(
            'orientationchange',
            function() {
                console.log('event listender, orientationchange');
                var newViewSize = getViewSize();
                //console.log("new view size: "+newViewSize);
                setActiveBreakpoints(newViewSize);
                $scope.$apply();
            },
            false
        );

        /**
         * LISTENERS
         */

        $scope.$on('vouchersFinishedRendering', function(vouchersFinishedRenderingEvent) {
            console.log('finished rendering');
            //var vouchersRow = angular.element(document.getElementById('vouchers-row'));
            //$document.scrollToElementAnimated(vouchersRow);
        });

        var setActiveBreakpoints = function(viewSize) {
            vm.viewLayoutTiles.three.activeBreakpoint = vm.viewLayoutTiles.three.breakpoint[viewSize];
            vm.viewLayoutTiles.four.activeBreakpoint = vm.viewLayoutTiles.four.breakpoint[viewSize];
            vm.viewLayoutTiles.six.activeBreakpoint = vm.viewLayoutTiles.six.breakpoint[viewSize];
        };

        function filterCashVouchersByFeatured(value, index, array) {
            return ~vm.featuredVouchers.indexOf('' + value.totalRate.priceMin);
        }

        /**
         * PRICE FILTER FUNCTIONS
         */
        vm.handlePriceFilter = function(event) {
            $log.info('handlePriceFilter', event.minPrice, event.maxPrice);

            var promise = $q.defer();

            if(typeof vm.currentPropertyGroup !== 'undefined'){
                GroupVouchers.get(
                    {
                        id: vm.currentPropertyGroup.id,
                        code : vm.currentPropertyGroup.code,
                        channel: $uiRouterGlobals.params.channel,
                        passkey: $uiRouterGlobals.params.passkey,
                        languageKey: (currentLanguage || 'en' ).split('_')[0].split('-')[0],
                        promoCode: undefined ,
                        selectedCategoryCodes:vm.multipleCategoryFilter,
                        minPrice: event.minPrice,
                        maxPrice: event.maxPrice,
                        intervalBars: 50,
                        sort: "price",
                        sortOrder: "asc",
                        page: 1,//vm.currentPage+1,//always reset page
                        pageSize: 24
                    },
                    function(groupVouchers) {
                        VouchersProcessService.processGroupVouchers(groupVouchers,vm.currentProperty,vm.shoppingCart,vm.shoppingCartConfigs,vm.propertyGiftCards);
                        processVouchers(groupVouchers);
                        activateVoucherClassAsync();
                        activatePriceRange(event.minPrice,event.maxPrice);
                        promise.resolve();
                    }
                );
            }
            else {
                activateVoucherClassAsync();
                activatePriceRange(event.minPrice,event.maxPrice);
                promise.resolve();
            }
            return promise;

        };

        vm.filterCashOnly = function(voucherPool, index, array) {

            return (voucherPool.type === 'cash')
        };

        vm.filterPrice = function(value, index, array) {
            //$log.info('filterPrice', value);
            if (vm.priceFilter.minPrice === 0 && vm.priceFilter.maxPrice === 0) {
                return true;
            }

            var priceMatched = false;

            angular.forEach(value.vouchers, function(v, key) {
                if (
                    vm.priceFilter.minPrice <= v.totalRate.priceMin &&
                    vm.priceFilter.maxPrice >= v.totalRate.priceMin
                ) {
                    priceMatched = true;
                }
            });
            return priceMatched;
        };

        function activatePriceRange(minPrice,maxPrice) {

            if(!vm.showCategoriesBox || vm.showCategoriesBoxType != 2){
                return;
            }

            vm.priceFilter.minPrice = minPrice;
            vm.priceFilter.maxPrice = maxPrice;

            if ($stateParams[minPriceParameterName] !== minPrice || $stateParams[maxPriceParameterName] !== maxPrice) {
                //$stateParams[categoryParameterName] = voucherClass;
                //$state.params[categoryParameterName] = voucherClass;
                //$state.transitionTo($state.current.name,$stateParams,{location: false,reload:false,inherit:false,notify:false});
                //$state.go($state.current.name,$stateParams,{notify:false,reload:false});//this will not change url param
                //PLEASE DON'T USE ANY ABOVE AS THIS WILL ALWAYS RELOAD PAGE
                //THERE IS reloadOnSearch: false ON THIS VIEW SO THE BELOW WILL NOT TRIGGER RELOAD
                var searchObject = {};
                angular.copy($location.search(),searchObject);
                searchObject[minPriceParameterName] = minPrice;
                searchObject[maxPriceParameterName] = maxPrice;
                $location.search(searchObject); //this will reload whole page
            }

            console.info('pricingRangeActive',  { minPrice: minPrice, maxPrice: maxPrice });
            $scope.$broadcast('pricingRangeActive',  { minPrice: minPrice, maxPrice: maxPrice });

            return vm.priceFilter;

        }


        /**
         * CATEGORY FILTER FUNCTIONS
         */

        //filter based on `showCategoriesBoxType` value
        vm.filterCategory = function(value, index, array) {
            return vm.filterByMultipleCategories(value, index, array);
        };


        //multiple category filter onUpdate handler ...
        vm.handleCategoriesFilter = function(event) {
            var promise = $q.defer();
            vm.voucherClassActive = event.selectedCategories.join(',');//will be used in processVouchers();
            //if this is a group we reload vouchers
            //do this if page is more than 1
            if(typeof vm.currentPropertyGroup !== 'undefined'){
                GroupVouchers.get(
                    {
                        id: vm.currentPropertyGroup.id,
                        code : vm.currentPropertyGroup.code,
                        channel: $uiRouterGlobals.params.channel,
                        passkey: $uiRouterGlobals.params.passkey,
                        languageKey: (currentLanguage || 'en' ).split('_')[0].split('-')[0],
                        promoCode: undefined ,
                        selectedCategoryCodes:event.selectedCategories,
                        minPrice: vm.priceFilter.minPrice,
                        maxPrice: vm.priceFilter.maxPrice,
                        intervalBars: 50,
                        sort: "price",
                        sortOrder: "asc",
                        page: 1,//vm.currentPage+1,//always reset page
                        pageSize: 24
                    },
                    function(groupVouchers) {
                        VouchersProcessService.processGroupVouchers(groupVouchers,vm.currentProperty,vm.shoppingCart,vm.shoppingCartConfigs,vm.propertyGiftCards);
                        processVouchers(groupVouchers);
                        vm.multipleCategoryFilter = event.selectedCategories;
                        activateVoucherClassAsync();
                        activatePriceRange(vm.priceFilter.minPrice,vm.priceFilter.maxPrice);
                        promise.resolve();
                    }
                );
            } else {
                vm.multipleCategoryFilter = event.selectedCategories;
                activateVoucherClassAsync();
                activatePriceRange(vm.priceFilter.minPrice,vm.priceFilter.maxPrice);
                promise.resolve();
            }
            return promise;
        };

        function activateVoucherClassAsync(){
            console.log('activateVoucherClassAsync');
            determineVoucherPoolOrderBy();
            $timeout(function() {
                if (!vm.voucherClassActive) {
                    vm.activateVoucherClass('all');
                } else {
                    vm.activateVoucherClass(vm.voucherClassActive);
                }
                vm.activateSlick();
            }, 250);
        }

        function determineVoucherPoolOrderBy() {
            console.log('determineVoucherPoolOrderBy')
            var mainOrderBy = 'sequence';
            if (vm.settings && vm.settings.voucherPoolOrderBy && vm.settings.voucherPoolOrderBy.name) {
                var mainOrderBy = vm.settings.voucherPoolOrderBy.name.split("_")[0];
            }
            var voucherCategoryShortCodes = vm.voucherClassActive ? vm.voucherClassActive.split(",") : [];
            if (mainOrderBy == 'sequence' && vm.useCategorySequence && voucherCategoryShortCodes.length == 1 && voucherCategoryShortCodes[0] != 'all') {
                vm.voucherPoolOrderBy = 'sequence_' + voucherCategoryShortCodes[0];
                console.log('vm.voucherPoolOrderBy: ', vm.voucherPoolOrderBy);
            } else {
                vm.voucherPoolOrderBy = mainOrderBy;
            }

            vm.settings.voucherPoolOrderBy = vm.settings.voucherPoolOrderBy != vm.voucherPoolOrderBy ? vm.voucherPoolOrderBy : vm.settings.voucherPoolOrderBy;
            console.log('vm.voucherPoolOrderBy: ', vm.settings);
        }
        function activateVoucherClass(requiredVoucherClass) {

            var isGroup = (typeof vm.currentPropertyGroup !== 'undefined');
            var voucherCategoryShortCodes = vm.voucherClassActive ? vm.voucherClassActive.split(",") : [];

            //1. fallback check
            var count = 0;
            angular.forEach(voucherCategoryShortCodes,function(code,ci){
                var vCounterObj = getVoucherClassCounterByName(code);
                if (vCounterObj && vCounterObj.counter && vCounterObj.counter > 0) {
                    count += vCounterObj.counter;
                }
                if(ci==0){
                    vm.voucherFirstCategoryActive = vCounterObj;
                }
            });

            //fallback: check if we have vouchers for this category
            if(count==0){
                voucherCategoryShortCodes = ['all'];
            }

            //2. set values again after fallback check
            var voucherClass = voucherCategoryShortCodes.join(',');
            vm.voucherClassActive = voucherClass;
            vm.multipleCategoryFilter = voucherCategoryShortCodes;

            if ($uiRouterGlobals.params.cat !== voucherClass) {
                var searchObject = {};
                angular.copy($location.search(),searchObject);
                searchObject[categoryParameterName] = voucherClass;
                $location.search(searchObject); //this will reload whole page
            }

            $scope.$broadcast('voucherClassActive', { voucherClassActive: vm.voucherClassActive });

            //todo: is this still required?
            var cashVouchersPresent = false;
            if(vm.allVouchers.wrapper) {
                angular.forEach(vm.allVouchers.wrapper.voucherPools, function (pool, pkey) {
                    if (pool.type === 'cash' || pool.type === 'cash-wildcard') {
                        cashVouchersPresent = true;
                    }
                });
            }
            if(!cashVouchersPresent && isGroup && vm.allVouchers.eligibleVouchers){
                angular.forEach(vm.allVouchers.eligibleVouchers, function(poolIdsArray, hotelId){
                    angular.forEach(poolIdsArray, function(voucherIdsArray, poolId){
                        if(poolId<0){
                            cashVouchersPresent = true;
                        }
                    });
                });
            }
            if ((voucherClass === 'all' || voucherClass === 'cash') && (cashVouchersPresent)) {
                vm.displayCashVoucher = true;
            } else {
                vm.displayCashVoucher = false;
            }

            //send dataLayer impressions for view_item_list
            sendDataLayerImpressions(vm.voucherClassActive);
        }

        function handlePageChange(){
            var promise = $q.defer();
            vm.paginationLoading = true;
            if(typeof vm.currentPropertyGroup !== 'undefined'){
                GroupVouchers.get(
                    {
                        id: vm.currentPropertyGroup.id,
                        code : vm.currentPropertyGroup.code,
                        channel: $uiRouterGlobals.params.channel,
                        passkey: $uiRouterGlobals.params.passkey,
                        languageKey: (currentLanguage || 'en' ).split('_')[0].split('-')[0],
                        promoCode: undefined ,
                        selectedCategoryCodes:vm.multipleCategoryFilter,
                        minPrice: vm.priceFilter.minPrice,
                        maxPrice: vm.priceFilter.maxPrice,
                        intervalBars: 50,
                        sort: "price",
                        sortOrder: "asc",
                        page: vm.currentPage,
                        pageSize: 24
                    },
                    function(groupVouchers) {
                        VouchersProcessService.processGroupVouchers(groupVouchers,vm.currentProperty,vm.shoppingCart,vm.shoppingCartConfigs,vm.propertyGiftCards);
                        processVouchers(groupVouchers);
                        activateVoucherClassAsync();
                        activatePriceRange(vm.priceFilter.minPrice,vm.priceFilter.maxPrice);
                        promise.resolve();
                    }
                );
            }
            var timeoutPromise = $timeout(1000*10);//10 seconds timeout
            timeoutPromise.then(function(){
                //try to resolve the promise after 10sec just in case
                promise.resolve();
            });
            promise.promise.then(function(){
                vm.paginationLoading = false;//stop overlay
            });
        }

        function sortVoucherClass(voucherClass) {
            switch (voucherClass.classId) {
                case 'all':
                    return -9999;
                case 'cash':
                    return -9998;
                default:
                    return voucherClass.sequence; //-1*voucherClass.counter;
            }
        }

        /**
         *
         * @param value this is a pool
         * @param index
         * @param array
         * @returns {boolean}
         */
        function filterByVoucherClass(value, index, array) {
            //$log.info('filterByVoucherClass', value, index, array);
            //value in here is a pool
            if (!vm.voucherClassActive || vm.voucherClassActive === 'all') {
                return true;
            }
            var voucherClassMatched = false;
            //first look at the voucher class
            if (vm.disableVoucherClass) {
                $log.info('filterByVoucherClass', vm.voucherClassActive, value.category);
                angular.forEach(value.vouchers, function(v, key) {
                    if (v.categories && v.categories[vm.voucherClassActive]) {
                        voucherClassMatched = true;
                    }
                });
                //Todo: what os this?
                if (value.category && value.category.category.voucherClassOverride === vm.voucherClassActive) {
                    voucherClassMatched = true;
                }
            } else {
                angular.forEach(value.vouchers, function(v, key) {
                    if (v.voucherClass === vm.voucherClassActive) {
                        voucherClassMatched = true;
                    }
                });
            }
            //check if voucher is assigned to this category

            return voucherClassMatched;
        }
        //actual multiple category filter.
        vm.filterByMultipleCategories = function(value, index, array) {
            if (vm.multipleCategoryFilter.length === 0) {
                //$log.info('filterByMultipleCategories NOTHING');
                return true;
            }
            if (vm.multipleCategoryFilter.includes("all")) {
                //$log.info('filterByMultipleCategories all');
                return true;
            }

            var voucherCategoryMatched = false;

            if (vm.disableVoucherClass) {
                //package vouchers only
                angular.forEach(value.vouchers, function(v, key) {
                    //$log.info(v);
                    angular.forEach(v.categories, function(c, ci) {
                        if (vm.multipleCategoryFilter.includes(c.classId)) {
                            voucherCategoryMatched = true;
                        }
                    });
                });
            } else {
                angular.forEach(value.vouchers, function(v, key) {
                    if (v.voucherClass === vm.voucherClassActive) {
                        voucherCategoryMatched = true;
                    }
                });
            }

            return voucherCategoryMatched;
        };

        function filterGiftCardByVoucherClass(value, index, array) {
            if (!vm.voucherClassActive || vm.voucherClassActive === 'all' || vm.voucherClassActive === 'cash') {
                return true;
            }
            var voucherClassMatched = false;
            return voucherClassMatched;
        }


        vm.filterVouchersByFeatured = function(value, index, array) {
            var voucherCategoryMatched = false;

            //package vouchers only
            angular.forEach(value.vouchers, function(v, key) {
                //$log.info(v);
                angular.forEach(v.categories, function(c, ci) {
                    if (c.classId=='featured') {
                        voucherCategoryMatched = true;
                    }
                });
            });

            return voucherCategoryMatched;
        };

        vm.filterNoOp = filterNoOp;
        function filterNoOp(value, index, array) {
            return true;
        }

        function getEligibleVouchers(cValue) {
            var vouchers = [];
            angular.forEach(vm.allVouchers.wrapper.voucherPools, function(pool, poolkey) {
                angular.forEach(pool.vouchers, function(v, vkey) {
                    if (cValue.voucherIds) {
                        angular.forEach(cValue.voucherIds, function(vId, vIdKey) {
                            if (v.id == vId) {
                                vouchers.push(v);
                            }
                        });
                    }
                });
            });
            return vouchers;
        }

        function getEligibleVouchersByClassName(name) {
            var vouchers = [];
            angular.forEach(vm.allVouchers.wrapper.voucherPools, function(pool, poolkey) {
                angular.forEach(pool.vouchers, function(v, vkey) {
                    if ('' + v.voucherClass == '' + name) {
                        vouchers.push(v);
                    }
                });
            });
            return vouchers;
        }

        function getCategoryByFriendlyName(name) {
            var category;
            angular.forEach(vm.propertyCategories, function(cValue, cKey) {
                if (cValue.friendlyName == name) {
                    category = cValue;
                }
            });
            return category;
        }

        function getCategoryByVoucherClassName(name) {
            var category;
            angular.forEach(vm.propertyCategories, function(cValue, cKey) {
                if (cValue.voucherClassOverride == name) {
                    category = cValue;
                }
            });
            return category;
        }

        function getPreparedCategoryByVoucherClassName(name) {
            var category;
            angular.forEach(vm.propertyCategories, function(cValue, cKey) {
                if (cValue.voucherClassOverride == name) {
                    category = prepareCategoryAsObject(cValue, name);
                }
            });
            return category;
        }

        function prepareCategoryAsObject(cValue, classId) {
            return {
                classId: classId,
                counter: cValue.voucherIds ? cValue.voucherIds.length : 0,
                isCategory: true,
                category: cValue,
                sequence: cValue.sequence,
            };
        }

        function getVoucherClassCounterByName(name) {
            var voucherClassCounter;
            angular.forEach(vm.voucherClassCounter, function(vClass, key) {
                if (name == vClass.classId) {
                    voucherClassCounter = vClass;
                }
            });
            return voucherClassCounter;
        }
        vm.getVoucherClassCounterByName = getVoucherClassCounterByName;

        function getByCashCategoryVoucherIds(vouchersResponse){
            var voucherIds = [];
            //if this is special 'cash' category, firstly lets add all VISIBLE voucher IDs to this category:
            if (vouchersResponse && vouchersResponse.wrapper && vouchersResponse.wrapper.voucherPools){
                angular.forEach(allVouchers.wrapper.voucherPools,function(pool,poolId){
                    if(pool.type=='cash' || pool.type=='cash-wildcard'){
                        angular.forEach(pool.vouchers, function(voucher, vindex){
                            if(!voucherIds.includes(voucher.id)){
                                voucherIds.push(voucher.id);
                            }

                        });

                    }
                });
            }

            //secondly add all cash vouchers to this category from other pages (this is for group)
            if(vouchersResponse.eligibleVouchers){
                angular.forEach(vouchersResponse.eligibleVouchers, function(poolIdsArray, hotelId){
                    angular.forEach(poolIdsArray, function(voucherIdsArray, poolId){
                        if(poolId<0){
                            angular.forEach(voucherIdsArray, function(vid, vindex){
                                if(!voucherIds.includes(vid)){
                                    voucherIds.push(vid);
                                }
                            });
                        }
                    });
                });
            }
            return voucherIds;
        }

        function getByCategoryVoucherIds(vouchersResponse, categoryWrapper, isGroup){
            var voucherIds = [];

            var isCashCategory = categoryWrapper.classId == 'cash';
            if(isCashCategory) {
                //init vouchers with cash vouchers first
                voucherIds = getByCashCategoryVoucherIds(vouchersResponse);
            }


            if(!isGroup){
                if(categoryWrapper.category) {
                    //this checks voucherIds[] in category object and fetches in full vouchers from the feed
                    var eligibleVouchers = getEligibleVouchers(categoryWrapper.category);
                    if(eligibleVouchers){
                        angular.forEach(eligibleVouchers,function (v,i) {
                            voucherIds.push(v.id);
                        });
                    }
                }
            }
            else if (isGroup) {
                if(allVouchers && allVouchers.eligibleVouchers && allVouchers.eligibleVouchers!=null){
                    angular.forEach(allVouchers.eligibleVouchers,function(eligibleVoucherByHotelIdMap,hotelId){
                        angular.forEach(eligibleVoucherByHotelIdMap,function(eligibleVoucherByHotelIdAndPoolIdList,poolId){
                            if(categoryWrapper.category && categoryWrapper.category.voucherIds){
                                angular.forEach(categoryWrapper.category.voucherIds,function(vid,i){
                                    angular.forEach(eligibleVoucherByHotelIdAndPoolIdList,function(evid,vindex){
                                        if(vid==evid){
                                            voucherIds.push(evid);
                                        }
                                    });
                                });
                            }
                        });
                    });
                }
            }
            return voucherIds;
        }

        function calculateCategoryCounter(categoryWrapper,allVouchers,isGroup){
            var voucherIds = getByCategoryVoucherIds(allVouchers,categoryWrapper,isGroup);
            return voucherIds ? voucherIds.length : 0;
        }


        function updateCategorySequenceOnPools() {
            angular.forEach(vm.allVouchers.wrapper.voucherPools, function(pool, poolkey) {
                angular.forEach(pool.vouchers, function(v, vkey) {
                    angular.forEach(v, function(vPropertyValue, vPropertyKey) {
                        if(vPropertyKey.indexOf("sequence_")===0){
                            //check if pool has this sequence
                            var poolExistingCategorySequenceValue = pool[vPropertyKey];
                            if(!poolExistingCategorySequenceValue || poolExistingCategorySequenceValue>vPropertyValue){
                                pool[vPropertyKey] = vPropertyValue;
                            }
                        }
                    });
                });
            });
        }


        /**
         * OTHER FUNCTIONS
         */

        function activateSlick() {
            if (vm.slickConfig.rows == 1) {
                $('slick').removeClass('voucher-class-slick-double');
                $('slick').addClass('voucher-class-slick');
            }
            vm.slickConfig.enabled = true;
        }

        function activateSlickFeatured() {
            $('slick').removeClass('voucher-class-slick-double');
            $('slick').addClass('voucher-class-slick');
            vm.feat_v_slickConfig.enabled = true;
        }

        function getViewSize() {
            var viewportWidth = $(window).width();
            if (viewportWidth < 767) {
                return 'sm';
            }
            if (viewportWidth < 992) {
                return 'sm';
            } else if (viewportWidth < 1199) {
                return 'md';
            }
            return 'lg';
        }

        /**
         * IMAGES
         */
        function getImageFileName(imageUrl) {
            if (!imageUrl) {
                return '';
            }

            var parts = imageUrl.split('/');
            return parts[parts.length - 1];
        }

        //location Boolean or "replace" (default true), If true will update the url in the location bar, if false will not. If string "replace", will update url and also replace last history record.
        //inherit Boolean (default true), If true will inherit url parameters from current url.
        //relative stateObject (default $state.$current), When transitioning with relative path (e.g '^'), defines which state to be relative from.
        //notify Boolean (default true), If true will broadcast $stateChangeStart and $stateChangeSuccess events.
        //reload v0.2.5 Boolean (default false), If true will force transition even if the state or params have not changed, aka a reload of the same state. It differs from reloadOnSearch because you'd use this when you want to force a reload when everything is the same, including search params.

        function openCashModal(params) {
            var stateName = 'cash-detail';
            //var p = angular.extend(params || {}, $stateParams);
            var options = {
                location: true,
                inherit: true,
                relative : $state.$current,
                reload: false
            };
            sendDataLayerProductClick(params.voucherPool);
            console.log('opening cash modal: ', params)
            $state.go(stateName, params, options);
        }

        function openPackageModal(params) {
            console.log('=> openPackageModal', params)
            var stateName = 'package-detail';
            var options = {
                location: true,
                inherit: true,
                relative : $state.$current,
                reload: false
            };
            //sendDataLayerProductClick(params.voucherPool, params.voucherId);
            console.log('opening state: ', params.voucherId)
            $state.go(stateName, params, options);
        }


        function reloadView(promotionCode) {
            $state.transitionTo($state.current.name, {promotionCode: promotionCode}, { reload: true, inherit: true });
        }

        function applyPromotionCode(event) {
            vm.processingPromotionCode = true;

            if (event) {
                event.preventDefault();
            }
            //we need to fetch all voucher endpoints again with promo price
            //so just refresh the whole page
            reloadView(vm.promotionCode.code);
        }

        function removePromotionCode(event) {
            vm.processingPromotionCode = true;

            if (event) {
                event.preventDefault();
            }

            var callback = function(httpResponse, shoppingCart, ngModel) {
                vm.processingPromotionCode = false;
                reloadView('');
            };

            //first remove the promo code from the shopping cart in session
            //then we need to fetch all voucher endpoints again without promo price
            //so just refresh the whole page in callback
            PromotionCodeService.removePromocode(
                shoppingCart,
                vm.promotionCode.code,
                vm.appliedPromotionCode.id,
                callback,
                callback
            );
        }

        //clean up events...
        $scope.$on('$destroy', function() {
            itemRemovedFromCartEvent();
        });

        function processVouchers(vouchersResponse){

            vm.allVouchers = vouchersResponse;
            vm.currentPage = vouchersResponse.page+1 || $uiRouterGlobals.params.pageParameterName || 1;

            //RESET
            //vm.voucherClassCounter.length = 0;//clear entries but don't reference new array
            vm.voucherClassCounter = [];
            vm.uncategorizedVouchers = 0;
            vm.priceIntervalsCounter = {};
            vm.cardsCounter = 0;

            /**
             * CATEGORIES PART
             * 1. populate vouchers with categories and regenerate voucherClassCounter
             */

            //if we have vouchers
            if (vouchersResponse) {

                var isGroup = (typeof currentPropertyGroup !== 'undefined');

                var cashVouchersPresent = false;
                if (vouchersResponse && vouchersResponse.wrapper && vouchersResponse.wrapper.voucherPools) {
                    angular.forEach(vouchersResponse.wrapper.voucherPools, function (pool, pkey) {
                        if (pool.type == 'cash' || pool.type == 'cash-wildcard') {
                            cashVouchersPresent = true;
                        }
                    });
                }
                if(!cashVouchersPresent && isGroup && vouchersResponse.eligibleVouchers){
                    angular.forEach(vouchersResponse.eligibleVouchers, function(poolIdsArray, hotelId){
                        angular.forEach(poolIdsArray, function(voucherIdsArray, poolId){
                            if(poolId<0){
                                cashVouchersPresent = true;
                            }
                        });
                    });
                }


                //get config values for category hide "all"
                var hideCategoryAll = false;
                if (propertyConfig && propertyConfig.configMap && propertyConfig.configMap.hideCategoryAll) {
                    hideCategoryAll = (propertyConfig.configMap.hideCategoryAll === 'true');
                }
                var hideCategoryFeatured = true;

                //1. create voucher categories
                var categoryAll = getPreparedCategoryByVoucherClassName('all');
                if (categoryAll && !hideCategoryAll) {
                    vm.voucherClassCounter.push(categoryAll);
                } else if (!hideCategoryAll) {
                    var totalVouchers = vouchersResponse.nrOfElements ? vouchersResponse.nrOfElements : vouchersResponse.voucherPoolsCount;
                    vm.voucherClassCounter.push({classId: 'all', counter: totalVouchers});
                }

                var categoryCash;
                //2. populate 'voucherClassCounter' from legacy voucher class or new categories
                //Removed in Nov 2017. Reason: always disable voucher class
                //if(propertyConfig && propertyConfig.configMap && propertyConfig.configMap.disableVoucherClass && propertyConfig.configMap.disableVoucherClass=='true' ){
                //	vm.disableVoucherClass = true;
                //}
                if (!vm.disableVoucherClass) {
                    //LEGACY: removed
                }

                //prepare category wrapper for property categories
                angular.forEach(vm.propertyCategories, function (cValue, cKey) {

                    var isCashCategory = cValue.friendlyName == 'cash';
                    cValue.voucherIds = cValue.voucherIds || [];

                    var categoryWrapper = prepareCategoryAsObject(cValue, cValue.friendlyName);

                    //if this is special 'cash' category, firstly lets add all cash-wildcard vouchers IDs to this category
                    //IMPORTANT: for group it will also add cash-wildcard vouchers from other pages
                    if (isCashCategory && vouchersResponse) {
                        var voucherIds = getByCashCategoryVoucherIds(vouchersResponse);
                        if (voucherIds) {
                            angular.forEach(voucherIds, function (vid, i) {
                                if (!cValue.voucherIds.includes(vid)) {
                                    cValue.voucherIds.push(vid);
                                }
                            });
                        }
                    }

                    //get default category if present
                    var defaultCategoryId = 0;
                    if (propertyConfig && propertyConfig.configMap && propertyConfig.configMap.defaultVoucherCategoryId) {
                        defaultCategoryId = parseInt(propertyConfig.configMap.defaultVoucherCategoryId);
                    }

                    //other categories will have vouchers populated
                    if (cValue.voucherIds && cValue.voucherIds.length > 0) {

                        if (cValue.friendlyName == 'cash') {
                            categoryCash = categoryWrapper;
                        }
                        //double check the category counter (from actual returned vouchers by the endpoint)
                        //IMPORTANT: for group it will also count in vouchers from other pages
                        //NOTE: it will include cash-wildcard & package  if it's 'cash' category
                        var counter = calculateCategoryCounter(categoryWrapper, vouchersResponse, isGroup);
                        categoryWrapper.counter = counter;
                        if (counter > 0) {

                            //make the category active if set in config
                            if (defaultCategoryId > 0 && categoryWrapper.category.id === defaultCategoryId) {
                                vm.voucherClassActive = categoryWrapper.classId;
                            }
                            //push this category to a list of VOBE categories
                            if(cValue.friendlyName == 'featured') {
                                if(!hideCategoryFeatured) {
                                    vm.voucherClassCounter.push(categoryWrapper);
                                }
                            } else {
                                vm.voucherClassCounter.push(categoryWrapper);
                            }

                            //assign this category to VISIBLE vouchers
                            var eligibleVouchers = getEligibleVouchers(cValue);
                            if (eligibleVouchers && eligibleVouchers.length > 0) {
                                //set this category to ALL VISIBLE eligible vouchers
                                angular.forEach(eligibleVouchers, function (v, k) {
                                    v.categories = v.categories || {};
                                    v.categories[cValue.friendlyName] = categoryWrapper;
                                    //allow sorting by a category sequence
                                    v['sequence_'+cValue.friendlyName] = cValue.voucherIds.indexOf(v.id);
                                });
                            }
                        }
                    }
                });


                //UPDATE POOLS WITH SEQUENCE WITHIN CATEGORY
                updateCategorySequenceOnPools();

                //CALCULATE UNCATEGORIZED VOUCHERS
                var totalVouchers = vouchersResponse.nrOfElements ? vouchersResponse.nrOfElements : vouchersResponse.voucherPoolsCount;
                var categorizedVouchers = 0;
                angular.forEach(vm.voucherClassCounter, function (vcc, k) {
                    if(vcc.classId != 'all' && vcc.counter){
                        categorizedVouchers += vcc.counter;
                    }
                });
                vm.uncategorizedVouchers = totalVouchers - categorizedVouchers;


                /***USEFULLNESS OF CONTROLS ***/
                //Jun 2021: requested to hide controls when they are not of much help

                //U-1. COLUMN CONTROLS & U-2. SORTING CONTROLS
                if (vouchersResponse.voucherPoolsCount < 4 && viewSettings.viewLayoutTileActive == 'three') {
                    vm.showColumnControls = false;
                    vm.showSortControls = false;
                }
                if (vouchersResponse.voucherPoolsCount < 6 && viewSettings.viewLayoutTileActive == 'four') {
                    vm.showColumnControls = true;
                    vm.showSortControls = false;
                }

                //U-3. CATEGORIES BAR
                vm.showCategoriesBoxUseful = (
                    (vm.voucherClassCounter.length - (vm.hideCategoryAll ? 0 : 1) >= vm.showCategoriesBoxTreshold) //we have at least 2 (or other limit) categories
                    ||
                    (vm.uncategorizedVouchers > 0 && vm.voucherClassCounter.length - (vm.hideCategoryAll ? 0 : 1) >= 1) //we have uncategorized vouchers and at least 1 category
                );


                /**
                 * TRUSTED DESCRIPTION
                 */
                //if we have vouchers
                if (vouchersResponse && vouchersResponse.voucherPoolsCount > 0) {
                    //loop over vouchers to set some data
                    angular.forEach(vouchersResponse.wrapper.voucherPools, function (pool, poolkey) {
                        angular.forEach(pool.vouchers, function (v, vkey) {

                            if (pool.type == 'cash' || pool.type == 'cash-wildcard') {
                                //todo remove that in future
                                if(!pool.cashVoucherDescriptionTrustedHtml) {
                                    pool.cashVoucherDescriptionTrustedHtml = $sce.trustAsHtml(v.voucherDescription);
                                }
                            }
                            v.voucherDescriptionTrustedHtml = $sce.trustAsHtml(v.voucherDescription);
                            v.voucherDescription2TrustedHtml = !v.voucherDescription2 || v.voucherDescription2==null ? $sce.trustAsHtml('<span></span>') : $sce.trustAsHtml(v.voucherDescription2);
                        });
                    });
                }

                /**
                 * POOL TOTAL RATE, PRICE INTERVALS
                 */
                //if we have vouchers
                if (vouchersResponse && vouchersResponse.wrapper && vouchersResponse.wrapper.voucherPools) {

                    var tempIntervals = [];

                    //loop over vouchers to create intervals
                    //TODO: change to loop of pool min/max and step
                    angular.forEach(vouchersResponse.wrapper.voucherPools, function (pool, poolkey) {
                        //1. SET TOTAL RATE FOR SORTING, can be deleted now
                        pool.totalRate = pool.minValue;
                        //2. DO INTERVALS
                        angular.forEach(pool.vouchers, function (v, vkey) {
                            //$log.info('voucher loop', vkey, v);
                            //add the totalPrice to priceInterval counter...
                            //add the totalPrice to priceInterval counter...showCateg
                            //interval 10=28, means there is 28 vouchers in price range 10-19
                            //interval 1540=7 means there are 7 vouchers in price range 1540-1549
                            var currentIntervalPrice = Math.floor(v.totalRate.priceMin / 10) * 10;
                            tempIntervals.push(currentIntervalPrice);
                        });
                    });

                    if (!isGroup || (isGroup && !vouchersResponse.priceIntervalsCounter)) {

                        tempIntervals.forEach(function (x) {
                            vm.priceIntervalsCounter[x] = (vm.priceIntervalsCounter[x] || 0) + 1;
                        });
                    }
                    else {
                        vm.priceIntervalsCounter = vouchersResponse.priceIntervalsCounter;
                    }
                    $log.info('vm.priceIntervalsCounter', vm.priceIntervalsCounter);
                }

                if (
                    vouchersResponse &&
                    vouchersResponse.wrapper &&
                    vouchersResponse.wrapper.voucherPools &&
                    vouchersResponse.wrapper.voucherPools.length
                ) {
                    vm.cardsCounter = vouchersResponse.wrapper.voucherPools.length;
                }

                /**
                 * FEATURED
                 */
                //if we have vouchers
                vm.featuredVoucherPools = ($filter('filter')(vm.allVouchers.wrapper.voucherPools,vm.filterVouchersByFeatured));
                $timeout(function() {
                    vm.activateSlickFeatured();
                }, 500);

            }
        }

        var sendDataLayerProductClick = function (voucherPool, voucherId) {
            var dataLayer = $window.dataLayer = $window.dataLayer || [];
            console.log('item', voucherPool);
            var voucherObject = voucherPool.vouchers[Object.keys(voucherPool.vouchers)[0]];
            if(voucherId){
                voucherObject = voucherPool.vouchers[voucherId];
            }
            dataLayer.push({
                event: 'eec:productClick',
                ecommerce: {
                    click: {
                        products: [{
                            name: voucherObject.voucherName,                      // Name or ID is required.
                            id: voucherObject.id.toString(),
                            price: voucherObject.totalRateAfterDiscount.priceMin,
                            category: voucherObject.voucherType,
                            position: (voucherObject.sequence  < 0 ? 1 : voucherObject.sequence + 1)
                        }]
                    }
                }
            });
        };

        var sendDataLayerImpressions = function(category) {
            console.log('impressions: ', category);
            var dataLayer = $window.dataLayer = $window.dataLayer || [];

            //impressions array
            var impressionsGa4 = [];
            var matchedCategory = null;

            if(vm.allVouchers.wrapper) {
                for (var vp in vm.allVouchers.wrapper.voucherPools) {
                    if (vm.allVouchers.wrapper.voucherPools.hasOwnProperty(vp)) {
                        var voucherPool = vm.allVouchers.wrapper.voucherPools[vp];
                        var voucherObject = voucherPool.vouchers[Object.keys(voucherPool.vouchers)[0]];

                        // Check if any category in voucherObject matches the passed category
                         var matchesCategory = Object.values(voucherObject.categories || {}).some(function(voucherCategory) {

                            if (category === 'all') {
                                matchedCategory = {
                                    id: 1,
                                    name: 'All'
                                }
                                return true;
                            }
                            if (voucherCategory.category && voucherCategory.category.friendlyName === category) {
                                matchedCategory = voucherCategory.category;
                                return true;
                            }
                            return false;
                        });

                        if (matchesCategory) {

                            impressionsGa4.push({
                                item_id: voucherObject.id.toString(),
                                item_name: voucherObject.voucherName,
                                index: (voucherPool.sequence < 0 ? 1 : voucherPool.sequence + 1),
                                price: voucherObject.totalRateAfterDiscount.priceMin,
                                quantity: 1,
                                item_category: 'Gift Voucher',
                                affiliation: currentProperty.hotelName,
                            });
                        }

                    }
                }
            }

            if (impressionsGa4.length > 0) {
                //ga4
                dataLayer.push({
                    event: "view_item_list",
                    ecommerce: {
                        item_list_id: matchedCategory.id,
                        item_list_name: matchedCategory.name,
                        affiliation: "In1Solutions Gift Voucher App",
                        items: impressionsGa4
                    }
                });
                console.log('last dataLayer', dataLayer[dataLayer.length - 1]);
            }

        };


        function onCurrencyUpdated(currency){
            //console.log('onCurrencyUpdated',currency);
            if(!$localStorage.currencySettings){
                $localStorage.currencySettings = {};
            }
            var settings =  $localStorage.currencySettings;
            settings['displayCurrency_'+currentProperty.hotelId] = currency ? currency.code : undefined;
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('GiftCards', GiftCards);

    GiftCards.$inject = ['$resource'];

    function GiftCards ($resource) {
        var service = $resource('api/property/:id/giftcards', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PropertyCreditCards', PropertyCreditCards);

    PropertyCreditCards.$inject = ['$resource'];

    function PropertyCreditCards($resource) {
        var service = $resource('api/property/:id/creditcards', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if (!data || (typeof data === 'string' && data.length == 0)) {
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }

    angular
        .module('vobeApp')
        .factory('PropertyPaymentOptions', PropertyPaymentOptions);

    function PropertyPaymentOptions($resource) {
        'ngInject';
        var service = $resource('api/property/:id/paymentoptions', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if (!data || (typeof data === 'string' && data.length == 0)) {
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('Categories', Categories);

    Categories.$inject = ['$resource'];

    function Categories ($resource) {
        var service = $resource('api/property/:id/categories', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular.module('vobeApp').factory('PropertyCashVouchers', PropertyCashVouchers);

    PropertyCashVouchers.$inject = ['$resource'];

    function PropertyCashVouchers($resource, $http) {
        var service = $resource(
            'api/property/:id/cashvouchers',
            {},
            {
                query: { method: 'GET', isArray: false },
                get: {
                    method: 'GET',
                    transformResponse: function(data) {
                        if(!data || (typeof data === 'string' && data.length==0)){
                            return data;
                        }
                        data = angular.fromJson(data);
                        return data;
                    }
                }
            }
        );

        return service;
    }
})();

(function() {
    'use strict';

    angular.module('vobeApp').factory('ModalService', ModalService);

    ModalService.$inject = ['$uibModal'];

    function ModalService($uibModal) {
        var service = {};
        var currentModal;
        var clearModal = function() {
            currentModal = undefined;
        };

        service.getCurrentModal = function() {
            return currentModal;
        };

        service.open = function(options) {
            currentModal = $uibModal.open(options);
            currentModal.result['finally'](clearModal);
            return currentModal;
        };

        return service;
    }
})();

(function() {
    'use strict';

    angular.module('vobeApp').controller('LanguageDropdownController', LanguageDropdownController);

    LanguageDropdownController.$inject = [
        '$scope',
        '$rootScope',
        '$state',
        '$stateParams',
        'currentProperty',
        'shoppingCartConfigs',
        '$translate',
        'JhiLanguageService',
        'tmhDynamicLocale',
        '$q'
    ];

    function LanguageDropdownController(
        $scope,
        $rootScope,
        $state,
        $stateParams,
        currentProperty,
        shoppingCartConfigs,
        $translate,
        JhiLanguageService,
        tmhDynamicLocale,
        $q
    ) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = ['en'];

        var propertyId = currentProperty.hotelId;
        if (shoppingCartConfigs[propertyId] && shoppingCartConfigs[propertyId].configMap && shoppingCartConfigs[propertyId].configMap.languages) {
            var languagesString = shoppingCartConfigs[propertyId].configMap.languages;
            vm.languages = languagesString.replace(/\s/g, '').split(',');
            if(propertyId == 15311){
                vm.languages.push('ar');
            }
        }
        //JhiLanguageService.getAll().then(function (languages) {
        //    vm.languages = languages;
        //});

        function changeLanguage(languageKey) {
            var languageChangePromises = [];
            languageChangePromises.push($translate.use(languageKey));
            try {
                languageChangePromises.push(tmhDynamicLocale.set(languageKey));
            } catch (e) {
                // TODO: handle exception
            }
            var promise = $q.all(languageChangePromises);
            promise.then(function() {
                var params = $stateParams;
                //params.lang= null;
                $state.transitionTo($state.current, params, { reload: true, inherit: false, notify: true });
                //$state.reload();
            });
        }
    }
})();

(function() {
    'use strict';

    angular.module('vobeApp').config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        function isHotelIdInGroup(currentPropertyGroup, hotelId){
            if(typeof currentPropertyGroup==='undefined'){
                return false;
            }
            var found = false;
            angular.forEach(currentPropertyGroup.hotels, function(hotel, hotelIndex) {
                if (hotel.hotelId == hotelId) {
                    found = true;
                }
            });
            return found;
        }

        function isHotelIdInMasters(currentProperty, hotelId){
            if(!currentProperty.masterProperties || currentProperty.masterProperties==null){
                return false;
            }
            var found = false;
            angular.forEach(currentProperty.masterProperties, function(hotel, hotelIndex) {
                if (hotel.hotelId == hotelId) {
                    found = true;
                }
            });
            return found;
        }

        var sendDataLayerProductImpression = function(voucherPool) {
            console.log('sendDataLayerProductImpression', voucherPool);
            var dataLayer = window.dataLayer = window.dataLayer || [];
        };

        $stateProvider
            .state('bulk-add', {
                parent: 'list',
                url: '/bulk-add?voucherId&comment&dedication',
                params: {
                    //params hidden from URL
                    appliedPromotionCode: undefined,
                    voucherPool: undefined,
                    focusedAmount: 0
                },
                data: {
                    authorities: [],
                    hideClear: true
                },
                //reloadOnSearch: false, //THIS WILL PREVENT RELOADING WHEN CAT in URL CHANGES!
                views: {
                    'content@': {
                        templateUrl: 'app/site/property/vouchers/bulk-add.html',
                        controller: 'PropertyVouchersBulkAddController',
                        controllerAs: 'vm'
                    },
                    'header@': {
                        templateUrl: 'app/layouts/header/header.html',
                        controller: 'BrandedHeaderController',
                        controllerAs: 'vm'
                    },
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.html',
                        controller: 'BrandedFooterController',
                        controllerAs: 'vm'
                    },
                    'cookies@': {
                        templateUrl: 'app/components/cookies-consent/cookies-banner.html',
                        controller: 'CookiesBannerController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    currentProperty: [
                        'currentProperty',
                        function(currentProperty) {
                            return currentProperty;
                        }
                    ],
                    currentPropertyGroup : [
                        'currentPropertyGroup',
                        function(currentPropertyGroup) {
                            return currentPropertyGroup;
                        }
                    ],
                    currentLanguage : [
                        'currentLanguage',
                        function(currentLanguage) {
                            return currentLanguage;
                        }
                    ],
                    allVouchers: [
                        'allVouchers',
                        function(allVouchers) {
                            return allVouchers;
                        }
                    ],
                    shoppingCart: [
                        'shoppingCart',
                        function(shoppingCart) {
                            return shoppingCart;
                        }
                    ],
                    shoppingCartConfigs: [
                        'shoppingCartConfigs',
                        function(shoppingCartConfigs) {
                            return shoppingCartConfigs;
                        }
                    ],
                    emailConfig: ['VobeConfig', 'shoppingCart', function(vobeConfig, shoppingCart) {
                        var propertyIds = [];
                        angular.forEach(shoppingCart.shoppingCartItems.items, function(value, key) {
                            if(jQuery.inArray(value.owningProperty.propertyId, this) < 0 ){
                                this.push(value.owningProperty.propertyId);
                            }

                        }, propertyIds);
                        return vobeConfig.emailConfig.get({propertyIds : propertyIds}).$promise;
                    }],
                    voucherPool: [
                        '$transition$',
                        'allVouchers',
                        '$q',
                        function($transition$, allVouchers, $q) {
                            if($transition$.params().voucherPool){
                                return $transition$.params().voucherPool;
                            }
                            //we are looking for particular pool that holds this cash voucher
                            var voucherId;
                            if($transition$.params().voucherId && $transition$.params().voucherId>0){
                                voucherId = $transition$.params().voucherId;
                            }
                            //get the first pool that contains this voucher id
                            var firstPool;
                            var fallbackPool;
                            var selectedPool;
                            if (allVouchers && allVouchers.wrapper && allVouchers.wrapper.voucherPools) {
                                angular.forEach(allVouchers.wrapper.voucherPools, function(voucherPool, pkey) {
                                    var poolHasVoucher = false;
                                    angular.forEach(voucherPool.vouchers, function(voucher, vkey) {
                                        if (!voucherId || (voucher.id == voucherId)) {
                                            poolHasVoucher = true;
                                        }
                                    });
                                    //this is the top most fallback
                                    if(!firstPool){
                                        firstPool = voucherPool;
                                    }
                                    //next fallback is a combined pool with this cashVoucherId
                                    if(!fallbackPool
                                        && poolHasVoucher
                                    ){
                                        fallbackPool = voucherPool;
                                    }
                                    //then we can choose selected pool
                                    if (
                                        (!voucherId || poolHasVoucher)
                                    ){
                                        selectedPool = voucherPool;
                                    }

                                });
                            }
                            var returnPool = selectedPool || fallbackPool || firstPool;
                            var deferred = $q.defer();
                            if(returnPool){
                                deferred.resolve(returnPool);
                            } else {
                                deferred.reject(returnPool);
                            }
                            return deferred.promise;
                        }
                    ],
                    shopMoreState: function($state, $transition$, DetermineShopMoreState) {
                            'ngInject';
                            var shopMoreStateData = DetermineShopMoreState.getShopMoreState();
                            if($transition$.params().contextType=='refunds') {
                                //if we refund bulk voucher, come back to this bulk page
                                var params = {
                                    cat: $transition$.params().cat,
                                    contextType: $transition$.params().contextType,
                                    propertyId: $transition$.params().propertyId,
                                    propertyType: $transition$.params().propertyType
                                };
                                params.bulk = true;
                                shopMoreStateData = {
                                    name: 'bulk-add',
                                    params: params,
                                    url: $state.href('bulk-add', params),
                                };
                                DetermineShopMoreState.setShopMoreState(shopMoreStateData);
                            }
                            return shopMoreStateData;
                        },
                }
            })
            .state('bulk-add.preview', {
                url: '/preview?uuid&emailCategoryId',
                params: {
                    templateItem : undefined
                },
                data: {
                    authorities: [],
                    autoscroll : true
                },
                onEnter: function($transition$, $state, $uibModal, currentProperty, currentPropertyGroup, shoppingCart, currentLanguage, shoppingCartConfigs) {
                    var params = $transition$.params();
                    var modal = $uibModal.open({
                        templateUrl: 'app/site/shoppingcart/shopping-cart-preview.html',
                        controller: 'ShoppingCartPreviewController',
                        controllerAs: 'vm',
                        backdrop: 'true',
                        animation: false,
                        windowClass : '',
                        size: 'lg',
                        resolve : {
                            currentProperty: function(){
                                return currentProperty;
                            },
                            currentPropertyGroup: function(){
                                return currentPropertyGroup;
                            },
                            shoppingCart: function(){
                                return shoppingCart;
                            },
                            currentLanguage: function(){
                                return currentLanguage;
                            },
                            shoppingCartConfigs: function(){
                                return shoppingCartConfigs;
                            },
                            templateItem: function(){
                                return $transition$.params().templateItem;
                            },
                            params: function () {
                                return {
                                    uuid: params.uuid,
                                    src: params.src,
                                    ref: params.ref,
                                    emailCategoryId: params.emailCategoryId,
                                    channel: params.channel
                                };
                            }
                        }
                    });

                    modal.result.then(function() {
                        var stillInShoppingCartPreview = $state.is('bulk-add.preview');
                        if(stillInShoppingCartPreview){
                            $state.go('^', {}, { reload: false,location: 'replace' });
                        }
                    }, function() {
                        var stillInShoppingCartPreview = $state.is('bulk-add.preview');
                        if(stillInShoppingCartPreview){
                            $state.go('^', {}, { reload: false,location: 'replace' });
                        }
                    });

                    $state.currentModal = modal;

                },
                onExit: ['$state',function($state){
                    $state.currentModal.close();
                }]
            })
            .state('terms-bulk-add', {
            parent: 'bulk-add',
            url: '/terms?uuid',
            params: {
                templateItem: undefined
            },
            data: {
                authorities: [],
                autoscroll : true
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'shoppingCart','currentLanguage', function($stateParams, $state, $uibModal, shoppingCart, currentLanguage) {
                var modal = $uibModal.open({
                    templateUrl: 'app/site/shoppingcart/shopping-cart-terms-dialog.html',
                    controller: 'ShoppingCartTermsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'false',
                    animation: false,
                    windowClass : '',
                    size: 'lg',
                    resolve : {
                        shoppingCart: shoppingCart,
                        terms : ['TermsService',function(TermsService){

                            var cartItem = $stateParams.templateItem;


                            var language = currentLanguage;
                            var delivery = cartItem.recipient.deliveryMethodType;
                            var cb = angular.noop;

                            return TermsService.get(
                                {propertyId : cartItem.owningProperty.propertyId,
                                    voucherId : cartItem.itemId,
                                    lang : (language || 'en' ).split('_')[0].split('-')[0],
                                    termsType : delivery
                                },
                                function (response) {
                                    return cb(response);
                                },
                                function (err) {
                                    return cb(err);
                                }.bind(this)).$promise;
                        }]
                    }
                });

                modal.result.then(function() {
                    var stillIn = $state.is('bulk-add.terms');
                    if(stillIn){
                        $state.go('^', {}, { reload: false });
                    }
                }, function() {
                    var stillIn = $state.is('bulk-add.terms');
                    if(stillIn){
                        $state.go('^', {}, { reload: false });
                    }
                });

                $state.currentModal = modal;

            }],
            onExit: ['$state',function($state){
                $state.currentModal.close();
            }]
        });
    }
})();

/* eslint-disable no-console */
(function() {
    'use strict';

    angular.module('vobeApp').controller('PropertyVouchersBulkAddController', PropertyVouchersBulkAddController);

    function PropertyVouchersBulkAddController(
        $window,
        $document,
        $scope,
        $rootScope,
        $state,
        $transition$,
        previousState,
        $location,
        DetermineItemLanguage,
        DetermineShopMoreState,
        $sce,
        voucherPool,
        shoppingCart,
        shoppingCartConfigs,
        currentProperty,
        currentPropertyGroup,
        currentLanguage,
        ShoppingCartAddBulkRecipientsAndItem,
        ShoppingCartItemDetailsService,
        $q,
        $injector,
        $localStorage,
        PromotionCodeService,
        $filter,
        $locale,
        $translate
    ) {
        'ngInject';
        console.log('property vouchers bulk add controller');
        //NOTE: 'hot-table' directive is using lazy loaded modules, see html file
        //https://oclazyload.readme.io/docs/oclazyload-directive
        var vm = this;

        var locale = $window.navigator.language || $window.navigator.userLanguage;
        var decimalSeparator = Intl && Intl.NumberFormat ? Intl.NumberFormat(locale).format('1.1').charAt(1) : '.';

        vm.voucherPool = voucherPool;
        console.log('bulkAdd voucherPool: ', voucherPool)
        vm.shoppingCartConfigs = shoppingCartConfigs;


        vm.currentProperty = currentProperty;
        vm.currentPropertyGroup = currentPropertyGroup;
        vm.currentLanguage = currentLanguage;

        console.log('sshoppingCartConfigs', vm.shoppingCartConfigs[vm.currentProperty.hotelId].configMap);

        vm.property = currentProperty;//this variable is needed for shopping summary included in the page
        vm.shoppingCart = shoppingCart;//this variable is needed for shopping summary included in the page
        vm.forceHidePromoBox = true;//we don't need promo box here

        vm.appliedPromotionCode = $transition$.params().appliedPromotionCode;
        vm.currentVoucher = ShoppingCartItemDetailsService.getDefaultVoucher($transition$.params().focusedAmount, $transition$.params().voucherId, vm.voucherPool); //this will populate vm.currentVoucher

        vm.voucherProperty = (typeof vm.currentPropertyGroup === 'undefined') ? ShoppingCartItemDetailsService.getVoucherPropertyForIndividualSite(vm.currentVoucher,vm.currentProperty) : ShoppingCartItemDetailsService.getVoucherPropertyForGroupSite(vm.currentVoucher, vm.currentPropertyGroup);

        vm.bulkShoppingCartConfigs = angular.extend({}, vm.shoppingCartConfigs);
        vm.bulkShoppingCartConfigs[vm.currentProperty.hotelId].configMap.disableRecipientMessage = 'true';
        vm.bulkShoppingCartConfigs[vm.currentProperty.hotelId].configMap.disableRecipientDetails = 'true';
        vm.bulkShoppingCartConfigs[vm.currentProperty.hotelId].configMap.disableDeliverToCustomer = 'true';
        vm.bulkShoppingCartConfigs[vm.currentProperty.hotelId].configMap.postalOption = 'false';

        //override maxBulkRows if defined in voucher property config
        console.log('------------vm.currentProperty.hotelId', vm.bulkShoppingCartConfigs[vm.currentProperty.hotelId].configMap)
        vm.maxBulkRows = vm.bulkShoppingCartConfigs[vm.currentProperty.hotelId].configMap.maxBulkRows || (vm.isRefundsContext ? 30 : 30);
        vm.allowBulkPostal = vm.bulkShoppingCartConfigs[vm.currentProperty.hotelId].configMap.allowBulkPostal || false;

        //check itemMeta.emailOption, itemMeta.postalOption, itemMeta.collectOption for 'true' or 'false'
        // if in that order they are true, set them as default delivery method type via "email", "post" or "collect"
        if (vm.currentVoucher.meta) {
            if (vm.currentVoucher.meta.emailOption === 'true' && vm.currentVoucher.meta.postalOption === 'false' && vm.currentVoucher.meta.collectOption === 'false') {
                vm.currentVoucher.meta.defaultDeliveryMethodType = 'email';
            } else if (vm.currentVoucher.meta.emailOption === 'false' && vm.currentVoucher.meta.postalOption === 'true' && vm.currentVoucher.meta.collectOption === 'false') {
                vm.currentVoucher.meta.defaultDeliveryMethodType = 'post';
            } else if (vm.currentVoucher.meta.emailOption === 'false' && vm.currentVoucher.meta.postalOption === 'false' && vm.currentVoucher.meta.collectOption === 'true') {
                vm.currentVoucher.meta.defaultDeliveryMethodType = 'collect';
            }
        }

        vm.templateBulkItem = {

            //uuid is needed for the form
            uuid: 'bulk',
            //item specification
            itemId: vm.currentVoucher.id,
            itemName: vm.currentVoucher.voucherName,
            itemDescription: vm.currentVoucher.voucherDescription,
            collectionDescription: vm.currentVoucher.collectDescription,
            //this is the value of the voucher, it will be used to recalculate the 'itemTotalPrice', do not remove it
            //if you want to remove it, then 'itemTotalPrice' must be changed to contain the value without discounts
            itemTotalPriceBeforeDiscount: (vm.currentVoucher.selectedAmount > 0 ? vm.currentVoucher.selectedAmount : vm.currentVoucher.totalRate.priceMin),
            itemTotalPrice: ShoppingCartItemDetailsService.calculateSelectedAmountAfterDiscount((vm.currentVoucher.selectedAmount > 0 ? vm.currentVoucher.selectedAmount : vm.currentVoucher.totalRate.priceMin),vm.appliedPromotionCode, 1), //it will be recalculated serverside
            itemCurrency: vm.currentVoucher.currency,
            itemImageFileName: ShoppingCartItemDetailsService.getImageFileName(vm.voucherPool),
            itemType: vm.voucherPool.type,
            itemGiftCardId: vm.voucherPool.giftCardId,
            itemEmailCategoryId: !vm.currentVoucher.meta ? 1 : vm.currentVoucher.meta.selectedEmailCategoryId,
            itemFixedDeliveryType: !vm.currentVoucher.meta ? null : vm.currentVoucher.meta.fixedDeliveryType,
            itemMeta: !vm.currentVoucher.meta ? null : vm.currentVoucher.meta,
            owningProperty : {
                propertyId : vm.voucherProperty.hotelId,
                propertyCode : vm.voucherProperty.hotelCode
            },
            itemQuantity : undefined,
            recipient : {
                deliveryMethodType: vm.currentVoucher.meta.defaultDeliveryMethodType,
                deliveryPersonType: 'recipient',
                showValue: vm.voucherPool.type=='cash' || vm.voucherPool.type=='cash-wildcard' ? 'true' : ShoppingCartItemDetailsService.defaultShowValue($transition$.params().contextType=='refunds'?'refunds':vm.voucherPool.type,vm.voucherProperty)
            },
            meta: vm.currentVoucher.meta,
            additionalFields : {
                'bulk' : true
            }
        };
        vm.templateBulkItem.itemLanguage = DetermineItemLanguage.getLanguage(vm.templateBulkItem);

        //build additional fields
        if(vm.currentVoucher.meta && vm.currentVoucher.meta.redemptionEndDate && vm.currentVoucher.meta.redemptionEndDate!=null ){
            vm.templateBulkItem.additionalFields['not_valid_after_date'] = new Date(vm.currentVoucher.meta.redemptionEndDate).getTime()/1000;
        }

        vm.totalPrice = vm.templateBulkItem.itemTotalPrice;
        vm.totalValue = vm.templateBulkItem.itemTotalPriceBeforeDiscount;
        /**
         * Create values to use in the dropdown
         */
        vm.valueRange = [];
        if(vm.voucherPool.type.includes('package') || vm.voucherPool.type.includes('cash-wildcard')){
            if (vm.currentVoucher.totalRate.increment > 0) {
                //if it's a package and has increments create array of numbers to display as value
                vm.valueRange = range(vm.voucherPool.minValue, vm.voucherPool.maxValue, vm.currentVoucher.totalRate.increment);
            }
            else {
                vm.valueRange.push(parseNumber(vm.currentVoucher.totalRate.priceMin));
            }
        } else {
            angular.forEach(vm.voucherPool.vouchers,function (voucher,vkey) {
                vm.valueRange.push(parseNumber(voucher.totalRate.priceMin));
            });
        }

        vm.valueRange.sort(function(v1, v2) {
            return v1 - v2;
        });

        vm.browseMore = browseMore;
        vm.goToPayment = goToPayment;

        //if this is refunds, and dedication not forced, don't use it
        vm.useDedication = $transition$.params().contextType=='refunds' && ($transition$.params().dedication!='true') ? false : true;
        //if this is refunds, and comment not forcefully disabled, use it
        vm.useComment = $transition$.params().contextType=='refunds' && ($transition$.params().comment!='false') ? true : false;

        function addBulkRecipientsAndItem (callback, errorCallback) {
            var cb = callback || angular.noop;
            var ecb = errorCallback || angular.noop;

            var bulkVM = {
                item : {
                    propertyId: vm.voucherProperty.hotelId,
                    propertyCode: vm.voucherProperty.hotelCode,
                    propertyName: vm.voucherProperty.hotelName,
                    propertyCountry: vm.voucherProperty.hotelCountry,
                    itemId: vm.templateBulkItem.itemId,
                    itemName: vm.templateBulkItem.itemName,
                    itemDescription: vm.templateBulkItem.itemDescription,
                    itemTotalPrice: vm.templateBulkItem.itemTotalPriceBeforeDiscount,
                    itemCurrency: vm.templateBulkItem.itemCurrency,
                    itemType: vm.templateBulkItem.itemType,
                    itemEmailCategoryId: vm.templateBulkItem.itemEmailCategoryId,
                    itemFixedDeliveryType: vm.templateBulkItem.itemFixedDeliveryType,
                    itemImageFileName: vm.templateBulkItem.itemImageFileName,
                    itemLanguage: vm.templateBulkItem.itemLanguage,
                    passkey: $transition$.params().passkey || '',
                    channelId: $transition$.params().channel || 0
                },
                recipients: []
            };

            angular.forEach(vm.hot.items, function(bulkRecipientModel, key) {

                var bulkRecipient = bulkRecipientModel.internalData;
                var recipient = angular.extend({},vm.templateBulkItem.recipient);//default recipient
                recipient.deliveryMethodType = bulkRecipient.deliveryMethod_type_name;
                recipient.showValue = bulkRecipient.showValue;

                //override the recipient if the delivery method is 'email' due to post using the values template vm.templateBulkItem.recipient
                if (recipient.deliveryMethodType === 'email') {
                    recipient.firstName = bulkRecipient.recipient_name_first;
                    recipient.lastName = bulkRecipient.recipient_name_last;
                }
                recipient.email = bulkRecipient.recipient_email;
                if (recipient.country && recipient.country.countryName) {
                    recipient.country = recipient.country.countryName;
                }
                recipient.message = bulkRecipient.message;
                recipient.comment = bulkRecipient.comment;
                recipient.emailCategoryId = vm.templateBulkItem.itemEmailCategoryId;

                var value = bulkRecipient.value;
                if (typeof value === 'string') {
                    value = parseNumber(bulkRecipient.value);
                }
                recipient.itemTotalPrice = value;
                console.log('recipient', recipient);
                bulkVM.recipients.push(recipient);

            });

            //params needed to create shopping cart from scratch
            //build shopping cart locale
            var variant = '';
            if ($transition$.params().contextType) {
                variant = '_' + $transition$.params().contextType;
            }
            variant += (variant.length === 0 ? '_' : '') + currentProperty.hotelId;

            var src = undefined;
            if (typeof currentPropertyGroup !== 'undefined') {
                src = currentPropertyGroup.code;
            }
            if ($transition$.params().src) {
                src = $transition$.params().src;
            }
            bulkVM.ref = $transition$.params().ref;
            bulkVM.src = src;
            bulkVM.lang = currentLanguage + variant;
            bulkVM.contextType = $transition$.params().contextType;
            bulkVM.propertyType = $transition$.params().propertyType;
            bulkVM.propertyCode = $transition$.params().propertyId;
            bulkVM.customerRef = $transition$.params().customerRef;

            return ShoppingCartAddBulkRecipientsAndItem.add(bulkVM,
                function (response) {
                    try {
                        vm.trackCheckout(bulkVM.item,bulkVM.recipients.size);
                    } catch (e) {

                    }
                    return cb(response);
                },
                function (err) {
                    return ecb(err);
                }.bind(this)).$promise;
        }


        /**
         * we are using handsontable version 0.38.1 CE, which corresponds to Pro version 1.18.1 (Released on 20th of March, 2018)
         * Documentation: https://handsontable.com/docs/1.18.1/Options.html
        **/
        vm.hot = {};

        vm.hot.items = [];

        vm.hot.loadData = function(flatData){
            console.log('loading data',flatData);
            vm.hot.items = [];
            if(flatData && flatData.length>0){

                angular.forEach(flatData,function(item,key){
                    if(item.itemId ==vm.templateBulkItem.itemId){
                        var modelledItem = vm.hot.model(item);
                        vm.hot.items.push(modelledItem);
                    }
                });
            }

            //add default item if nothing loaded from storage
            if(vm.hot.items.length==0){
                for(var i = 0; i<1;i++){
                    var item = angular.extend({},vm.hot.flatItemDataModel);
                    var modelledItem = vm.hot.model(item);
                    vm.hot.items.push(modelledItem);
                }
            }

            vm.templateBulkItem.itemQuantity = Math.max(1,vm.hot.items.length);
        }
        vm.hot.flatItemDataModel = {
            "recipient_name_first" : "",
            "recipient_name_last" : "",
            "recipient_email" : "",
            "message" : "",
            "comment" : "",
            "price": vm.templateBulkItem.itemTotalPrice,
            "value": vm.templateBulkItem.itemTotalPriceBeforeDiscount,
                "deliveryMethod_type_name": vm.templateBulkItem.recipient.deliveryMethodType,
            "showValue": vm.templateBulkItem.recipient.showValue,
            "itemId" : vm.templateBulkItem.itemId
        };

        vm.hot.model = function(opts) {
            var
                _pub = {},
                _priv = angular.extend({},vm.hot.flatItemDataModel);

            for (var i in opts) {
                if (opts.hasOwnProperty(i)) {
                    _priv[i] = opts[i];
                }
            }

            _pub.attr = function (attr, val) {
                if (typeof val === 'undefined') {
                    //window.console && console.log("\t\tGET the", attr, "value of", _pub);
                    return _priv[attr];
                }
                //window.console && console.log("SET the", attr, "value of", _pub);
                _priv[attr] = val;

                return _pub;
            };

            _pub.internalData = _priv;

            return _pub;
        }

        vm.hot.modelProperty = function(attr){
            return function (row, value) {
                if(typeof row==='undefined'){
                    return undefined;
                }
                if(row==null || row.attr ==null){
                    return undefined;
                }
                //console.log("GET the", attr, "value of row data", row);
                return row.attr(attr, value);
            }
        }

        var storageFlatData = $localStorage.bulkFlatData || {};
        var flatDataInstance = storageFlatData[vm.shoppingCart.shoppingCartKey] || [];
        vm.hot.loadData(flatDataInstance);

        vm.hot.beforePaste = function(data,coords){
            //console.log('beforePaste',data);
            if(vm.hot.settings.maxRows){
                if(data.length>vm.hot.settings.maxRows){
                    data.length = vm.hot.settings.maxRows;
                }
            }
            if(data.length){
                for (var i = 0; i < data.length; i++) {
                    for (var j = 0; j < data[i].length; j++) {
                        data[i][j] = data[i][j].trim();
                    }
                }
            }
            vm.templateBulkItem.itemQuantity = Math.max(1,vm.hot.items.length,coords[0].startRow+data.length);
        }

        vm.hot.afterPaste = function(){
            //after pasing values from excel we must format all prices to numbers
            updatePriceAndSave();
        }

        vm.hot.beforeCreateRow = function(createRowAtIndex,amountOfRows,source){
            /*if(source=="ContextMenu.rowBelow"){
                //createRowAtIndex
                createRowsInItems(createRowAtIndex, amountOfRows, false);
            }
            if(source=="ContextMenu.rowAbove"){
                createRowsInItems(createRowAtIndex, amountOfRows, true);
            }
            */;
        }

        vm.hot.afterChange = function(changes, source){
            //save only if changes is not null
            if (changes === null) {
                return;
            }
            updatePriceAndSave();

            // var hotInstanceRegisterer = $injector.get('hotRegisterer');
            // var hotInstance = vm.hot.instance || angular.element("#"+vm.shoppingCart.shoppingCartKey).handsontable('getInstance') || hotInstanceRegisterer.getInstance(vm.shoppingCart.shoppingCartKey);
        }

        vm.hot.afterRemoveRow = function(index, amount, physicalRows, source){
            vm.templateBulkItem.itemQuantity = Math.max(1,vm.hot.items.length);
        }



        vm.hot.afterInit = function(){
            vm.hot.instance = this;
            //vm.hot.instance.addHook('beforePaste', vm.hot.beforePaste);//this work but is now moved to settings object
            //vm.hot.instance.addHook('afterPaste', vm.hot.afterPaste);//this work but is now moved to settings object
        }

        //https://emailregex.com/
        vm.hot.emailValidator = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            ///(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

        vm.hot.messageValidator = function(value, callback) {
            //if null add empty
            if (value == null) {
                value = '';
            }

            //if allowEmpty and empty return true
            if (this.allowEmpty && value === '') {
                callback(true);
            }

            if (value.length > vm.shoppingCartConfigs[vm.currentProperty.hotelId].configMap.dedicationMessageLengthPost) {
                console.log('messageValidator', value.length, vm.shoppingCartConfigs[vm.currentProperty.hotelId].configMap.dedicationMessageLengthPost);
                callback(false);
            } else {
                callback(true);
            }
        }

        vm.hot.requiredValidator = function(value, callback) {
            if (value == null) {
                value = '';
            }
            if (this.allowEmpty && vm.templateBulkItem.recipient.deliveryMethodType === "post" && value === '') {
                callback(true);
            }
            // Check if the delivery method is 'email'
            else if (vm.templateBulkItem.recipient.deliveryMethodType === 'email') {
                // Apply the regex validation for email
                var isValidEmail = /^(?!\s*$).+/.test(value);
                callback(isValidEmail);
            }
            // If the delivery method is 'post'
            else if (vm.templateBulkItem.recipient.deliveryMethodType === 'post') {
                // Check for non-empty string
                var isValidPost = value !== '';
                callback(isValidPost);
            }
            else {
                // Default case if deliveryMethodType is neither 'email' nor 'post'
                callback(true);
            }
        };

        vm.hot.colHeadersFn = function() {
            var totals = getItemTotals();
            vm.totalValue = totals.totalValue;//just in case
            vm.totalPrice = totals.totalPrice;

            //var cacheSeparator = $locale.NUMBER_FORMATS.DECIMAL_SEP;
            //$locale.NUMBER_FORMATS.DECIMAL_SEP = decimalSeparator;

            var colHeaders = [];
            colHeaders.push('Value<br/><small>'+$translate.instant("shopping-cart.items.total")+': '+$filter('number')(totals.totalValue,2)+'</small>');
            if (vm.templateBulkItem.recipient.deliveryMethodType === 'email') {
                colHeaders.push($translate.instant("vouchers.form.label.recipient.firstname"));
                colHeaders.push($translate.instant("vouchers.form.label.recipient.lastname"));
                colHeaders.push($translate.instant("vouchers.form.label.recipient.email")+'<br/><small>('+$translate.instant("vouchers.form.label.recipient.bulk.deliverhere")+')</small>');
            }

            if ($transition$.params().contextType !== 'refunds') {
                colHeaders.splice(0, 0, '<span class="w3-text-gray">'+$translate.instant("vouchers.form.label.price")+'<br/><small>'+$translate.instant("shopping-cart.items.total")+': '+totalPrice+'</small></span>');
            }

            //$locale.NUMBER_FORMATS.DECIMAL_SEP = cacheSeparator;

            if(vm.useComment){
                colHeaders.push($translate.instant("vouchers.form.label.comment"));
            }
            else {
                colHeaders.push($translate.instant("vouchers.form.label.dedication"));
            };


            var hotInstanceRegisterer = undefined;
            try { hotInstanceRegisterer = $injector.get('hotRegisterer'); } catch (e){}
            var hotInstance = hotInstanceRegisterer ? hotInstanceRegisterer.getInstance(vm.shoppingCart.shoppingCartKey) : undefined;
            if(hotInstance){
                hotInstance.updateSettings({
                    colHeaders : colHeaders
                });
            }
            return colHeaders;
        }

        vm.hot.inRangeValidator = function(value, callback) {

            if (testNumber(value)) {
                var valueAsNumber = parseNumber(value);
                if (vm.currentVoucher.currency === 'ZAR' && !Number.isInteger(valueAsNumber)) {
                    callback(false);
                } else if (vm.voucherPool.enableTypedAmounts && valueAsNumber >= vm.voucherPool.minValue && valueAsNumber <= vm.voucherPool.maxValue) {
                    callback(true);
                } else if (vm.valueRange.includes(valueAsNumber)) {
                    callback(true);
                } else {
                    callback(false);
                }
            } else {
                callback(false);
            }
        };

        function getItemTotals() {
            var totalPrice = 0;
            var totalValue = 0;
            angular.forEach(vm.hot.items, function (item, index) {

                var price = item.internalData.price;
                if (typeof price === 'string') {
                    price = parseNumber(item.internalData.price);
                }
                var value = item.internalData.value;
                if (typeof value === 'string') {
                    value = parseNumber(item.internalData.value);
                }
                totalPrice += price;
                totalValue += value;
            });
            return {totalPrice, totalValue};
        }

        vm.getColumns = function() {
            var totals = getItemTotals();
            var columns = [];
            if ($transition$.params().contextType !== 'refunds') {
                columns.push({
                    data: vm.hot.modelProperty('price'),
                    title: '<span class="w3-text-gray">' + $translate.instant("vouchers.form.label.price") + '<br/><small>' + $translate.instant("shopping-cart.items.total") + ': ' + totals.totalPrice + '</small></span>',
                    type: 'numeric',
                    width: 80,
                    numericFormat: {
                        pattern: '0,0.00'
                    },
                    validator: 'numeric',
                    readOnly: true //PRICE is caluclated based on VALUE (it's promo code aware)
                });
            }
            columns.push({
                data: vm.hot.modelProperty('value'),
                width: 100,
                title: 'Value<br/><small>'+$translate.instant("shopping-cart.items.total")+': '+$filter('number')(totals.totalValue,2)+'</small>',
                source: vm.valueRange,
                type: vm.voucherPool.enableTypedAmounts ? 'numeric' : 'dropdown',
                // the numeric pattern decimal separator is working in 'dropdown' (showing , on selected langs) but not 'numeric' (always showing .)
                numericFormat: {
                    pattern: vm.currentVoucher.currency === 'ZAR' ? '0,000' :  '0,0.00'
                },
                selectOptions: [225, 450],
                validator: vm.hot.inRangeValidator
            });

            if (vm.templateBulkItem.recipient.deliveryMethodType === 'email') {
                columns.push({
                    data: vm.hot.modelProperty('recipient_name_first'),
                    title: $translate.instant("vouchers.form.label.recipient.firstname"),
                    type: 'text',
                    width: 250,
                    validator: vm.hot.requiredValidator,
                    allowInvalid: true,
                    allowEmpty: true
                });

                columns.push({
                    data: vm.hot.modelProperty('recipient_name_last'),
                    title: $translate.instant("vouchers.form.label.recipient.lastname"),
                    type: 'text',
                    width: 250,
                    validator: vm.hot.requiredValidator,
                    allowEmpty: true,
                    allowInvalid: true
                });

                columns.push({
                    data: vm.hot.modelProperty('recipient_email'),
                    title: $translate.instant("vouchers.form.label.recipient.email")+'<br/><small>('+$translate.instant("vouchers.form.label.recipient.bulk.deliverhere")+')</small>',
                    type: 'text',
                    width: 250,
                    validator: vm.hot.emailValidator,
                    allowEmpty: true,
                    allowInvalid: true
                });
            }

            var characterLimitText = '';
            if (vm.templateBulkItem.recipient.deliveryMethodType === 'post' && vm.shoppingCartConfigs[vm.currentProperty.hotelId].configMap.dedicationMessageLengthPost) {
                characterLimitText = ' ('+vm.shoppingCartConfigs[vm.currentProperty.hotelId].configMap.dedicationMessageLengthPost+' characters)';
            }
            columns.push({
                data: vm.useComment ? vm.hot.modelProperty('comment') : vm.hot.modelProperty('message'),
                type: 'text',
                width: undefined,
                validator: vm.hot.messageValidator,
                allowEmpty: true,
                title: $translate.instant("vouchers.form.label.dedication") + characterLimitText
            });

            return columns;

        }

        vm.hot.settings = {
            id: vm.shoppingCart.shoppingCartKey,
            contextMenu: ['row_above', 'row_below', 'remove_row', 'undo', 'redo'],
            persistentState: true,
            copyPaste: true,
            //dataSchema: vm.hot.model,//this is not working
            /* dataSchema is defined in html angular component 'dataschema' attribute and points to "vm.hot.model" */
            beforeCreateRow: vm.hot.beforeCreateRow,
            beforePaste: vm.hot.beforePaste, //important this will create required empty rows before paste
            afterPaste: vm.hot.afterPaste,
            afterChange: vm.hot.afterChange,
            afterRemoveRow: vm.hot.afterRemoveRow,
            afterInit: vm.hot.afterInit, //not working not sure why
            stretchH: 'last',
            minSpareRows: 0,
            fillHandle: {
                direction: 'vertical',
                autoInsertRow: false //prevent fill handle from creating extra row at the bottom https://handsontable.com/docs/7.1.0/demo-auto-fill.html
            },
            rowHeaders: true,
            maxRows: vm.maxBulkRows,
            minRows: 1,//Pat don't want to be able to see 0 rows
            undo: true,
            trimWhitespace: true,
            //data : vm.hot.items,//this is not working,
            /* data is defined in html angular component 'datarows' attribute and points to "vm.hot.items"
            data: [
                model({id: 1, name: 'Ted Right', address: ''}),
                model({id: 2, name: 'Frank Honest', address: ''}),
                model({id: 3, name: 'Joan Well', address: ''}),
                model({id: 4, name: 'Gail Polite', address: ''}),
                model({id: 5, name: 'Michael Fair', address: ''})
            ],
            */
            // colHeaders: vm.hot.colHeadersFn(),
            // colWidths: [
            //     //80, //Delivery
            //     //80, //Show Value
            //     80, //Price
            //     100, //Value
            //     250,//First Name
            //     250,//Last Name
            //     250,//Comment or Message
            //     undefined],
            columns: vm.getColumns(),
        };


        //don't display the extra 'price' column for refunds.. maybe change this to those with discounts only.
        // if ($transition$.params().contextType === 'refunds') {
        //     vm.hot.settings.columns.shift(1);
        //     vm.hot.settings.colWidths.shift(1);
        // }

        //watch changes in global values

        $scope.$watch('vm.templateBulkItem.itemQuantity', function(val1,val2) {
            console.info("quantity changed from to",val2,val1);
            bulkRecipientsUpdateQuantity(val1);
        });

        $scope.$watch('vm.templateBulkItem.recipient.showValue', function(val1,val2) {
            console.info("showValue changed from to",val2,val1);
            bulkRecipientsUpdateShowValue(val1);
        });

        $scope.$watch('vm.templateBulkItem.recipient.deliveryMethodType', function(val1,val2) {
            console.info("deliveryMethodType changed from to", val2, val1);
            //change each bulkInternal item deliveryMethod_type_name to match the new value
            angular.forEach(vm.hot.items,function(item,key){
                item.internalData.deliveryMethod_type_name = val1;
            });
            if (val1 !== val2) {
                console.log('reload...')

                var hotInstanceRegisterer = undefined;
                try {
                    hotInstanceRegisterer = $injector.get('hotRegisterer');
                } catch (e) {
                }
                var hotInstance = hotInstanceRegisterer ? hotInstanceRegisterer.getInstance(vm.shoppingCart.shoppingCartKey) : undefined;
                if (hotInstance) {
                    hotInstance.updateSettings({columns: vm.getColumns()});
                }
            }
        });

        $scope.$watch('vm.shoppingCart.shoppingCartDiscounts', function(val1,val2) {
            console.info("shoppingCartDiscounts changed from to",val2,val1);
            var applicablePromo = PromotionCodeService.findApplicablePromo(vm.shoppingCart, vm.currentProperty, typeof vm.currentPropertyGroup !== 'undefined', vm.currentVoucher)
            console.log("new promo",applicablePromo );
            vm.appliedPromotionCode = applicablePromo;
            //1. change bulk item total price
            vm.templateBulkItem.itemTotalPrice = ShoppingCartItemDetailsService.calculateSelectedAmountAfterDiscount(vm.currentVoucher.totalRate.priceMin, vm.appliedPromotionCode, vm.templateBulkItem.itemQuantity);//it will be recalculated serverside
            //2. update all items & save
            updatePriceAndSave();

        });


        function updatePriceAndSave(saveOnly){
            console.log('updatePriceAndSave', saveOnly)
            var flatData = {};
            flatData[vm.shoppingCart.shoppingCartKey] = [];

            angular.forEach(vm.hot.items,function(item,index) {
                var newPrice = item.internalData.value;
                if (typeof newPrice === 'string') {
                    var newPrice = parseNumber(item.internalData.value);
                }
                if (!saveOnly){
                    //of change was done in voucher value
                    var discountAllowed = true;
                    if(vm.appliedPromotionCode && vm.appliedPromotionCode.maxUsage>0 && vm.appliedPromotionCode.used+index>=vm.appliedPromotionCode.maxUsage){
                        discountAllowed = false;
                    }
                    if(discountAllowed){
                        item.internalData.price = ShoppingCartItemDetailsService.calculateSelectedAmountAfterDiscount(newPrice, vm.appliedPromotionCode, vm.templateBulkItem.itemQuantity);
                    } else {
                        item.internalData.price = newPrice;
                    }
                    item.internalData.deliveryMethod_type_name = vm.templateBulkItem.recipient.deliveryMethodType;
                }
                flatData[vm.shoppingCart.shoppingCartKey].push(item.internalData);
            });
            //vm.hot.settings.colHeaders = vm.hot.colHeadersFn();
            //vm.hot.settings.columns = vm.getColumns();
            $localStorage.bulkFlatData = flatData;

            var hotInstanceRegisterer = undefined;
            try {
                hotInstanceRegisterer = $injector.get('hotRegisterer');
            } catch (e) {
            }
            var hotInstance = hotInstanceRegisterer ? hotInstanceRegisterer.getInstance(vm.shoppingCart.shoppingCartKey) : undefined;
            if (hotInstance) {
                hotInstance.updateSettings({columns: vm.getColumns()});
                hotInstance.validateCells();
            }
        }

        function createRowsInItems(createRowAtIndex, amountOfRows, isAbove){
            //createRowAtIndex - this index might not exist yet
            for(var n=0;n<amountOfRows;n++){
                var item = angular.extend({},vm.hot.flatItemDataModel);
                var newModelledItem = vm.hot.model(item);
                newModelledItem.internalData.deliveryMethod_type_name = vm.templateBulkItem.recipient.deliveryMethodType;
                vm.hot.items.splice(createRowAtIndex,0,newModelledItem);
            }
        }

        function bulkRecipientsUpdateQuantity(newQuantity){
            var size = vm.hot.items.length;

            //add items
            if(newQuantity>size){
                var numberOfNewItems = newQuantity - size;
                console.log("adding "+numberOfNewItems+" new items");
                createRowsInItems(vm.hot.items.length, numberOfNewItems, false);

            }
            else if(newQuantity<size){
                //remove items
                vm.hot.items.splice(newQuantity,size);
            }
            updatePriceAndSave();
        }

        function bulkRecipientsUpdateShowValue(newShowValue){
            angular.forEach(vm.hot.items,function(item,key){
                item.internalData.showValue = newShowValue;
            });
            updatePriceAndSave(true);
        }

        vm.trackCheckout = function(item, quantity){

            Analytics.addProduct(
                item.itemId,//productId
                item.itemName,//name
                item.itemType,//category
                item.owningProperty.propertyCode,//brand
                '',//variant
                parseNumber(item.itemTotalPrice),//price
                quantity,//quantity
                '',//coupon
                ''//position
            );
            Analytics.trackCheckout(1, 'Details');
        }


        function goToPayment(event){
            console.log('goToPayment')
            event.preventDefault();
            vm.bulkAddFailed = false;

            var validateForm = $q.defer();
            if(vm.checkoutForm.$invalid){
                console.log('not valid...', vm.checkoutForm)
                validateForm.reject('false');
            }
            else {
                console.log('valid...')
                validateForm.resolve('true');
            }

            var validateHandsontable = $q.defer();
            this.hot.instance.validateCells(function(valid) {
                console.log('validateCells',valid);
                if (valid) {
                    validateHandsontable.resolve('true');
                }
                else {
                    validateHandsontable.reject('false');
                }
            });

            var validatationPromise = $q.all([validateForm.promise, validateHandsontable.promise])
                .then(function (succ) {
                    vm.checkoutFormInvalid = false;
                    addBulkRecipientsAndItem(goToPaymentState, refreshAndRevalidate);
                }, function (err) {
                    console.log('add bulk error', err)
                    vm.checkoutFormInvalid = true;
                });
        }

        /**
         * This is the successful callback after adding item and recipients
         */
        function goToPaymentState(){
            console.log('goToPaymentState')
            $state.transitionTo("payment", $transition$.params(), {
                reload: 'site', inherit: true, notify: true
            });
        }

        /**
         * This is the error callback after adding item and recipients
         */
        function refreshAndRevalidate(err){
            console.log('refreshAndRevalidate')
            $transition$.params().revalidate = true;
            //$state.transitionTo($state.current, $stateParams, {
            //    reload: 'site', inherit: false, notify: true
            //});
            vm.bulkAddFailed = true;
        };


        function browseMore(event) {
            event.preventDefault();
            var shopMoreState = DetermineShopMoreState.getShopMoreState();
            console.log('shopMoreState', shopMoreState)
            $state.go(shopMoreState.name, shopMoreState.params);
        }

        function range(min, max, step) {
            //console.log(min);
            //console.log(max);
            //console.log(step);

            step = step || 1;
            if (step == 0) {
                step = 1;
            }
            if (max == 0) {
                max = min;
            }

            var input = [];
            for (var i = min; i <= max; i += step) {
                input.push(parseNumber(i));
            }

            return input;
        }

        function normalizeNumber(input){
            if(isNaN(input)===false){
                return input.toString();
            }
            var value = input.toString();
            var cleanPattern = new RegExp('[^-+0-9$'+decimalSeparator+']', 'g');
            var cleaned = value.replace(cleanPattern, '');
            var normalized = cleaned.replace(decimalSeparator, '.');
            return normalized;
        }


        function parseNumber(input) {
            return parseFloat(normalizeNumber(input));
        }

        function testNumber(input) {
            return normalizeNumber(input).match(/^[0-9.]*$/);
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PropertySearch', PropertySearch);

    PropertySearch.$inject = ['$resource'];

    function PropertySearch ($resource) {
        var service = $resource('api/property/search/:search', {}, {
            'query': {method: 'GET', isArray: true, ignoreLoadingBar: true},
            'get': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('Property', Property);

    Property.$inject = ['$resource'];

    function Property ($resource) {
        var service = $resource('api/property/:id', {}, {
            'query': {method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('voucher-properties-list', {
        	//abstract: true,
            parent: 'site',
            url: '/properties',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/site/property/catalogue/voucher-properties.html',
                    controller: 'VoucherPropertiesController',
                    controllerAs: 'vm'
                }
            },      
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },            
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],            	
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('property');
                    return $translate.refresh();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'property',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    var propertiesCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('vobeApp')
        .component('propertiesCount', propertiesCount);
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('VoucherProperties', VoucherProperties);

    VoucherProperties.$inject = ['$resource'];

    function VoucherProperties ($resource) {
        var service = $resource('api/property', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('VoucherPropertiesController', VoucherPropertiesController);

    VoucherPropertiesController.$inject = ['Principal', 'User', 'VoucherProperties', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function VoucherPropertiesController(Principal, User, VoucherProperties, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.currentAccount = null;
        vm.loadAll = loadAll;
        vm.properties = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });


        function loadAll () {
        	VoucherProperties.get({
                page: pagingParams.page - 1,
                //sort: sort(),
                size: vm.itemsPerPage                
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security

            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.properties = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }


        /*function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }*/

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                //sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('propertyErrorHandlerInterceptor', propertyErrorHandlerInterceptor);

    propertyErrorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function propertyErrorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (response && !(response instanceof Error) && (response.headers('X-vobeApp-error-property') || response.headers('x-vobeapp-error-property')) ) {
                $rootScope.$emit('vobeApp.propertyError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    var propertyAlertError = {
        template: '<div id="snackbar" ng-show="vm.alerts.length>0">' +
                        '<div uib-alert ng-repeat="alert in vm.alerts" ng-class="\'alert alert-\'+alert.type" close="alert.close(vm.alerts)"><span>{{ alert.msg }}</span></div>' +
                  '</div>',
        controller: propertyAlertErrorController,
        controllerAs: 'vm',
        bindToController: true
    };

    angular
        .module('vobeApp')
        .component('propertyAlertError', propertyAlertError);

    function propertyAlertErrorController ($scope, $element, AlertService, $rootScope, $translate) {
        'ngInject';
        var vm = this;

        vm.alerts = [];
        vm.addErrorAlert = addErrorAlert;
        vm.addSuccessAlert = addSuccessAlert;
        vm.addWarningAlert = addWarningAlert;

        $element.data('propertyAlertErrorScope', $scope);

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        function addWarningAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'warning',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        function addSuccessAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'success',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }


        var cleanPropertyErrorListener = $rootScope.$on('vobeApp.propertyError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            if(httpResponse){
                var errorHeader = httpResponse.headers('X-vobeApp-error') || httpResponse.headers('x-vobeapp-error');
                switch (errorHeader) {
                    case 'error.maxreached':
                        addErrorAlert('Max reached','global.messages.error.maxreached');
                        break;
                    default:
                        if (httpResponse.data && httpResponse.data.message) {
                            addErrorAlert(httpResponse.data.message);
                        } else {
                            addErrorAlert(angular.toJson(httpResponse));
                        }
                }
            }

        });


        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanPropertyErrorListener) && cleanPropertyErrorListener !== null){
                cleanPropertyErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function () {

    'use strict';
    angular.module('vobeApp')
        .component('cfTurnstile', {
            bindings: {
                siteKey: '@',
                onChallengeCompleted: '&'
            },
            controller: CfTurnstile,
            template: '<div id="turnstile-container"></div>',
        });

    function CfTurnstile($window, $document, PaymentProcessTransaction) {
        'ngInject';
        var vm = this;

        vm.$onInit = function () {

            function loadAndRenderTurnstile() {
                var containerId = 'turnstile-container';
                if (!$window.onloadTurnstileCallback) {
                    $window.onloadTurnstileCallback = function () {
                        $window.turnstile.render('#' + containerId, {
                            sitekey: vm.siteKey,
                            callback: function (token) {
                                var validationSuccess = false; // Placeholder for validation logic
                                //call the rest endpoint `/api/payment/turnstile` with request payload "cf-turnstile-response"
                                PaymentProcessTransaction.turnstile.verify({ 'cf-turnstile-response': token }, function (response) {
                                    console.log('success response', response);
                                    if (response.success) {
                                        validationSuccess = true;
                                        vm.onChallengeCompleted({isValid: validationSuccess});
                                    } else {
                                        validationSuccess = false;
                                        vm.onChallengeCompleted({isValid: validationSuccess});
                                        $window.turnstile.reset(); //reset when validation fails
                                    }
                                }, function (error) {
                                    validationSuccess = false;
                                    vm.onChallengeCompleted({isValid: validationSuccess});
                                    $window.turnstile.reset(); //reset when validation errors
                                });
                            },
                        });
                    };
                }
            }

            if (!$window.turnstileLoaded) {
                var script = $document[0].createElement('script');
                script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback";
                script.defer = true;
                $document[0].body.appendChild(script);
                $window.turnstileLoaded = true;
            } else {
                // If script is already loaded, immediately initialize the widget
                $window.onloadTurnstileCallback();
            }

            loadAndRenderTurnstile();
        }
    }


})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PaymentTransactionsDialogItemController', PaymentTransactionsDialogItemController);


    function PaymentTransactionsDialogItemController($window, $scope, $rootScope, $state, $stateParams, $anchorScroll, $timeout, $interval, PaymentProcessTransaction, SnapScanRefreshTransaction, $httpParamSerializer, $sce, PaymentRedirectSingleton, Analytics, TagManager, GoogleAdwordsService, StripeElements, $element) {
        'ngInject';
        var transactionVM = this;
        var transactionStatusCheckMillis = 3000;


        //console.log("PaymentRedirectSingleton busy ? "+PaymentRedirectSingleton.isBusy());

        transactionVM.$onInit = function () {
            console.log('$onInit PaymentTransactionsDialogItemController', transactionVM.transaction)

            $anchorScroll();

            transactionVM.date = new Date();
            transactionVM.availablePaymentOptions = $scope.vm.availablePaymentOptions;
            transactionVM.shoppingCart = $scope.vm.shoppingCart;
            transactionVM.transaction = $scope.transaction;
            transactionVM.propertyConfig = $scope.vm.propertyConfig;
            transactionVM.shoppingCartItems = [];
            transactionVM.method = 'POST';
            transactionVM.checkoutFormLoaded = false;
            transactionVM.finterpringHiddenIframe = false;
            transactionVM.backToPayment = backToPayment;
            transactionVM.fingerprintIframeSource = "";

            transactionVM.showSpinner = false;

            transactionVM.error;

            transactionVM.channel = $stateParams.channel;

            transactionVM.snapScan = {
                enabled: false,
                qrCode: ''
            }

            //retry logic
            transactionVM.current3dsRetryAttempt = 0
            transactionVM.MAX_3DS_RETRIES = 3;
            transactionVM.authMessage = "Processing ... Please allow up to 30 seconds.";
            transactionVM.displayTryAgain = false;


            angular.forEach(transactionVM.shoppingCart.shoppingCartItems.items, function (item, index) {
                if (transactionVM.transaction.shoppingCartItemUUIDs.indexOf(item.uuid) > -1) {
                    transactionVM.shoppingCartItems.push(item);
                }
            });


            if (transactionVM.transaction.paymentTransactionStatusType === 'WAIT_REDIRECT_REPLY') {
                transactionVM.showSpinner = true;
                console.log('processPayment ... WAIT_REDIRECT_REPLY')
                processPayment();//it will do nothing, just keep calling endpoint and executing processTransactionCallback
            }

            if (transactionVM.transaction.paymentTransactionStatusType === 'INITIAL') {
                transactionVM.showSpinner = true;
                console.log('processPayment ... INITIAL')
                processPayment(); //process transaction straight away in the background
            }

            if (transactionVM.transaction.paymentTransactionStatusType === 'REDIRECT') {
                transactionVM.showSpinner = true;
                //process transaction straight away in the background
                processRedirect(transactionVM.transaction.paymentTransactionStatusAdditionalFields['REDIRECT']);
            }

            if (transactionVM.transaction.paymentTransactionStatusType === 'DISPLAY_IFRAME') {
                console.log('handle DISPLAY_IFRAME...')
                transactionVM.redirectObjectUrl = transactionVM.transaction.paymentTransactionStatusAdditionalFields['REDIRECT'].redirectURL;
            }

            if (transactionVM.transaction.paymentTransactionStatusType === 'DISPLAY_HTML') {
                console.log('DISPLAY_HTML', transactionVM.transaction.paymentAccountTypeId)
                transactionVM.showSpinner = true;
                //do nothing for now...
                if (transactionVM.transaction.paymentAccountTypeId === 23) {
                    initZapper(transactionVM.transaction.paymentTransactionStatusAdditionalFields.REDIRECT.redirectParams);
                } else if (transactionVM.transaction.paymentAccountTypeId === 24) {
                    initSnapScan(transactionVM.transaction.paymentTransactionStatusAdditionalFields.REDIRECT.redirectParams);
                }

            }

            if (transactionVM.transaction.paymentTransactionStatusType === 'THREEDS2FINGERPRINT' || transactionVM.transaction.paymentTransactionStatusType === 'THREEDS2CHALLENGE') {
                console.log('$onInit THREEDS2FINGERPRINT/THREEDS2CHALLENGE...', transactionVM.propertyConfig.paymentType, transactionVM.transaction.paymentTransactionStatusType)
                //adyen
                if (transactionVM.propertyConfig.paymentType === '25') {
                    var transactionParams = {
                        type: transactionVM.transaction.paymentTransactionStatusAdditionalFields[transactionVM.transaction.paymentTransactionStatusType].redirectParams.type,
                        paymentData: transactionVM.transaction.paymentTransactionStatusAdditionalFields[transactionVM.transaction.paymentTransactionStatusType].redirectParams.paymentData,
                        paymentMethodType: transactionVM.transaction.paymentTransactionStatusAdditionalFields[transactionVM.transaction.paymentTransactionStatusType].redirectParams.paymentMethodType,
                        token: transactionVM.transaction.paymentTransactionStatusAdditionalFields[transactionVM.transaction.paymentTransactionStatusType].redirectParams.token
                    }
                    var clientKey = '';
                    var environment = 'test';
                    //get clientKey and environment from availablePaymentOptions
                    for (const po of transactionVM.availablePaymentOptions) {
                        if (po.id === transactionVM.transaction.paymentAccountTypeId) {
                            clientKey = po.clientKey;
                            environment = po.environment;
                        }
                    }
                    handleAdyenCheckout(transactionParams, transactionVM.transaction.paymentTransactionStatusType === 'THREEDS2FINGERPRINT' ? 1 : 0, clientKey, environment);
                } else if (transactionVM.propertyConfig.paymentType === '11') {
                    //authipay SCA
                    //transactionVM.fingerprintIframeSource = transactionVM.transaction.redirectParams[]
                    console.log('-=-=-=-=-')
                    console.log('authipay $onInit THREEDS2FINGERPRINT...', transactionVM.transaction);
                    handleAuthipaySecure3DMethodForm(transactionVM.transaction.paymentTransactionStatusAdditionalFields[transactionVM.transaction.paymentTransactionStatusType])
                    console.log('-=-=-=-=-')
                } else if (transactionVM.propertyConfig.paymentType === '26') {
                    console.log('Global Pay / Elavon '+transactionVM.transaction.paymentTransactionStatusType);
                    transactionVM.finterpringHiddenIframe = true;
                    if (transactionVM.transaction.paymentTransactionStatusType === 'THREEDS2CHALLENGE') {
                        console.log('Global Pay / Elavon THREEDS2CHALLENGE...');
                        handleChallengeRequest(transactionVM.transaction.paymentTransactionStatusAdditionalFields[transactionVM.transaction.paymentTransactionStatusType]);
                    } else {
                        console.log('Global Pay / Elavon THREEDS2FINGERPRINT...');
                        handleFinegrprintHiddenIframe(transactionVM.transaction.paymentTransactionStatusAdditionalFields[transactionVM.transaction.paymentTransactionStatusType]);
                    }

                } else if (transactionVM.propertyConfig.paymentType === '38') {
                    console.log('Network Payments finterprint/challenge proceed ... ');
                    if (transactionVM.transaction.paymentTransactionStatusType === 'THREEDS2CHALLENGE') {
                        handleChallengeRequest(transactionVM.transaction.paymentTransactionStatusAdditionalFields[transactionVM.transaction.paymentTransactionStatusType]);
                    } else {
                        verifyChallenge(transactionVM.transaction.uuid, {}, processTransactionCallback, processTransactionErrorCallback);
                    }
                } else if (transactionVM.propertyConfig.paymentType === '39') {
                    console.log('Opayo finterprint/challenge proceed ... ');
                    if (transactionVM.transaction.paymentTransactionStatusType === 'THREEDS2CHALLENGE') {
                        handleChallengeRequest(transactionVM.transaction.paymentTransactionStatusAdditionalFields[transactionVM.transaction.paymentTransactionStatusType]);
                    }
                }
            }
        }
        function handleFinegrprintHiddenIframe(transactionStatusFields) {

            console.log('handleFinegrprintHiddenIframe', transactionStatusFields)

            if (transactionStatusFields.redirectParams.methodUrl) {

                var postParams = {
                    methodUrl: transactionStatusFields.redirectParams.methodUrl,
                    methodData: transactionStatusFields.redirectParams.encodedMethodData,
                    enrolled: true,
                };

                transactionVM.showSpinner = true;

                //this initiates the device fingerprint
                GlobalPayments.ThreeDSecure.handle3dsVersionCheck(postParams, {
                    timeout: 10 * 1000,
                    target: '#embedded-iframe-target',
                }).then(function(response) {
                        console.log('handleFinegrprintHiddenIframe success', response);
                        transactionVM.current3dsRetryAttempt = 0;
                        checkPaymentStatus(transactionVM.transaction.uuid, transactionStatusFields.paymentStatus);

                        transactionVM.paymentStatusInterval = $interval(function() {
                            checkPaymentStatus(transactionVM.transaction.uuid, transactionStatusFields.paymentStatus);
                        }, transactionStatusCheckMillis, 5);

                        transactionVM.paymentStatusInterval.then(function() {
                            console.log('stopped payment check and going with paymentReply... ')
                            if (typeof posthog !== 'undefined') {
                                posthog.capture('handle3dsVersionCheck_noreply', {
                                    transactionId: transactionVM.transaction.uuid
                                });
                            }
                            console.log('going with paymentReply... ')
                            processTransaction(transactionVM.transaction.uuid, processTransactionCallback, processTransactionErrorCallback, true);
                        });

                    }).catch(function(error) {
                    console.error('error with notification', error);
                    if (transactionVM.current3dsRetryAttempt < transactionVM.MAX_3DS_RETRIES) {
                        transactionVM.current3dsRetryAttempt++;

                        if (typeof posthog !== 'undefined') {
                            posthog.capture('handle3dsVersionCheck_retry', {
                                attempts: transactionVM.current3dsRetryAttempt,
                            });
                        }

                        console.log(`Will retry 3DS authentication. Attempt ${transactionVM.current3dsRetryAttempt} of ${transactionVM.MAX_3DS_RETRIES}.`);
                        transactionVM.authMessage = `Connection timeout: Retry ${transactionVM.current3dsRetryAttempt} of ${transactionVM.MAX_3DS_RETRIES}.`;
                        checkPaymentStatus(transactionVM.transaction.uuid);
                        setTimeout(function() {
                            handleFinegrprintHiddenIframe(transactionStatusFields);
                        }, 1000); // e.g., 2-second delay
                    } else {
                        // transactionVM.isAuthenticating3ds = false;
                        console.error('Max 3DS retries reached. Authentication failed.');
                        transactionVM.authMessage = 'Payment authentication failed after multiple attempts.';
                        transactionVM.displayTryAgain = true;
                        transactionVM.showSpinner = false;
                        transactionVM.current3dsRetryAttempt = 0; // Reset for any future, separate transaction flow

                        // At this point, definitely check the server for the transaction's final status
                        checkPaymentStatus(transactionVM.transaction.uuid);
                    }
                });

            } else {
                //no methodUrl provided via, proceed with `3DS Method Completion Indicator as Unavailable.`
                console.log('no methodUrl provided via, proceed with ...3DS Method Completion Indicator as Unavailable....')
                var payload = {
                    threeDsMethod: 'unavailable'
                }
                verifyChallenge(transactionVM.transaction.uuid, payload, processTransactionCallback, processTransactionErrorCallback);
            }
        }

        function handleChallengeRequest(response) {
            console.log('handleChallengeRequest...', response)
            transactionVM.redirectObjectUrl = $sce.trustAsResourceUrl(response.redirectURL);
            transactionVM.method = 'POST';
            transactionVM.redirectObject = {
                redirectParams: {
                    creq: response.redirectParams.creq
                }
            };

            $timeout(function () {
                console.log('$broadcasting SUBMIT_PAYMENT_FORM', transactionVM);
                $scope.$broadcast('SUBMIT_PAYMENT_FORM', {uuid: transactionVM.transaction.uuid});
            }, 2000);
        }

        function backToPayment() {
            console.log('backToPayment')
            $state.transitionTo("payment", $stateParams, {
                reload: 'site', inherit: true, notify: true
            });
        }

        function handleAuthipaySecure3DMethodForm(response) {
            if (response.paymentStatus === 'THREEDS2CHALLENGE') {
                console.log('THREEDS2CHALLENGE...')
                transactionVM.redirectObjectUrl = $sce.trustAsResourceUrl(response.redirectURL);
                transactionVM.method = 'POST';
                transactionVM.redirectObject = {
                    redirectParams: {
                        creq: response.redirectParams.creq
                    }
                };

                $timeout(function () {
                    console.log('$broadcasting SUBMIT_PAYMENT_FORM', transactionVM);
                    $scope.$broadcast('SUBMIT_PAYMENT_FORM', {uuid: transactionVM.transaction.uuid});
                }, 2000);

            } else {
                transactionVM.fingerprintIframeSource = $sce.trustAsHtml(response.redirectParams.secure3DMethodForm);
                //add constant status refresh...
                transactionVM.paymentStatusInterval = $interval(function () {
                    console.log('checking payment status... current status: ', response.paymentStatus)
                    checkPaymentStatus(transactionVM.transaction.uuid, response.paymentStatus);
                }, 3000);
            }
        }

        function handleAdyenCheckout(params, type, clientKey, environment) {

            console.log('handleAdyenCheckout...', params, type, clientKey, environment)

            function handleFingerprintChallengeResponse(state, component) {
                var payload = {
                    'threeds2.fingerprint': state.data.details['threeds2.fingerprint'],
                    'paymentData': state.data.paymentData
                }
                verifyChallenge(transactionVM.transaction.uuid, payload, processTransactionCallback, processTransactionErrorCallback);
            }

            function handleChallengeResponse(state, component) {
                console.log('data', state.data);
            }

            var configuration = {
                clientKey: clientKey,
                locale: 'en-US',
                environment: environment,
                onAdditionalDetails: type === 1 ? handleFingerprintChallengeResponse : handleChallengeResponse
            };

            var threeDSConfiguration = {
                size: '02'
            }

            var checkout = new AdyenCheckout(configuration);
            console.log('----', params)
            transactionVM.checkoutFormAction = checkout.createFromAction(params);
            transactionVM.mountAdyen = function () {
                console.log('mount adyen')
                transactionVM.checkoutFormAction.mount(type === 1 ? '#fingerprint-challenge' : '#threeds-challenge');
            }
            transactionVM.checkoutFormLoaded = true;

        }

        function processPayment(paymentReply) {
            console.log('processPayment...', paymentReply);
            processTransaction(transactionVM.transaction.uuid, processTransactionCallback, processTransactionErrorCallback, paymentReply);
        }


        function refreshSite() {
            console.log('refreshSite...')
            $state.transitionTo($state.current, $stateParams, {
                reload: 'site', inherit: false, notify: true
            });
        }

        function processTransactionCallback(response) {
            console.log('processTransactionCallback...', response.paymentStatus)
            //console.log(response);
            //we got successful response, we expect it to hold new transaction status
            if (response && response.paymentStatus) {
                transactionVM.transaction.paymentTransactionStatusType = response.paymentStatus;
            }
            if (response && response.persistenceStatus) {
                transactionVM.transaction.persistenceTransactionStatusType = response.persistenceStatus;
            }

            //the success response is expected to be of 2 types: 1. redirect or 2. success
            if (response && response.paymentStatus === 'REDIRECT') {
                processRedirect(response)
            } else if (response && (response.paymentStatus === 'THREEDS2FINGERPRINT' || response.paymentStatus === 'THREEDS2CHALLENGE')) {
                var transactionParams = response.redirectParams;
                console.log('THREEDS2FINGERPRINT/THREEDS2CHALLENGE...', transactionVM.propertyConfig.paymentType)
                if (transactionVM.propertyConfig.paymentType === '25') {
                    var transactionParams = response.redirectParams;
                    var clientKey = '';
                    var environment = 'test';
                    //get clientKey and environment from availablePaymentOptions
                    for (const po of transactionVM.availablePaymentOptions) {
                        if (po.id === transactionVM.transaction.paymentAccountTypeId) {
                            clientKey = po.clientKey;
                            environment = po.environment;
                        }
                    }
                    handleAdyenCheckout(transactionParams, response.paymentStatus === 'THREEDS2FINGERPRINT' ? 1 : 0, clientKey, environment);
                } else if (transactionVM.propertyConfig.paymentType === '11') {
                    console.log('transactionParams', response.redirectParams)
                    handleAuthipaySecure3DMethodForm(response);
                } else if (transactionVM.propertyConfig.paymentType === '26') {
                    console.log('Global Payments API', transactionVM.transaction)
                    transactionVM.finterpringHiddenIframe = true;
                    if (transactionVM.transaction.paymentTransactionStatusType === 'THREEDS2CHALLENGE') {
                        console.log('Global Payments API handleChallengeRequest')
                        handleChallengeRequest(response);
                    } else {
                        console.log('Global Payments API handleFinegrprintHiddenIframe')
                        handleFinegrprintHiddenIframe(response);
                    }

                } else if (transactionVM.propertyConfig.paymentType === '38') {
                    console.log('-- NI Direct 38 --', response)
                    if (transactionVM.transaction.paymentTransactionStatusType === 'THREEDS2CHALLENGE') {
                        console.log('NI Direct handleChallengeRequest')
                        handleChallengeRequest(response);
                    } else {
                        console.log('NI Direct handleFinegrprintHiddenIframe')
                        verifyChallenge(transactionVM.transaction.uuid, {}, processTransactionCallback, processTransactionErrorCallback);
                    }
                } else if (transactionVM.propertyConfig.paymentType === '39') {
                    if (transactionVM.transaction.paymentTransactionStatusType === 'THREEDS2CHALLENGE') {
                        console.log('Opayo handleChallengeRequest')
                        handleChallengeRequest(response);
                    }
                }
            } else if (response && response.paymentStatus === 'WAIT_REDIRECT_REPLY') {
                transactionVM.showSpinner = true;
            } else if (response && response.paymentStatus === 'DISPLAY_HTML') {
                transactionVM.showSpinner = true;
                console.log('DISPLAY_HTML', response)
                if (response.paymentAccountType === 23) {
                    initZapper(response.redirectParams)
                } else if (response.paymentAccountType === 24) {
                    console.log('snapscan...', response);
                    initSnapScan(response.redirectParams);
                }
            } else if (response && response.paymentStatus === 'DISPLAY_IFRAME') {
                console.log('handle DISPLAY_IFRAME...', response)
                transactionVM.redirectObjectUrl = response.redirectURL;
                transactionVM.showSpinner = false;
            } else if (response && response.paymentStatus === 'COMPLETED') {
                //check paymentStatus for COMPLETED and SAVED
                checkPaymentStatus(transactionVM.transaction.uuid, response.paymentStatus);
            } else if (response && response.paymentStatus === 'ERROR') {
                console.error('payment error', transactionVM.transaction.errorPaymentStatusDetails);
                if (typeof posthog !== 'undefined') {
                    posthog.capture('payment_error', {
                        error: transactionVM.transaction.errorPaymentStatusDetails.message
                    })
                }
            } else {
                transactionVM.showSpinner = false;
            }
        }

        function processTransactionErrorCallback(error) {
            console.log('processTransactionErrorCallback...')
            transactionVM.showSpinner = false;
            //we got transaction error, try to display required error information instead of status based on response headers TODO
            //console.log('transaction error');
            //console.log(error);
            if (error && error.data && error.data.paymentStatus) {
                //this is expected error somewhere is the flow
                transactionVM.transaction.paymentTransactionStatusType = error.data.paymentStatus;

            }
            if (error && error.data && error.data.persistenceStatus) {
                //this is expected error somewhere is the flow
                transactionVM.transaction.persistenceTransactionStatusType = error.data.persistenceStatus;

            }
            if (error && error.data && error.data.lastInternalResponseStatusDescription) {
                transactionVM.transaction.errorPaymentStatusDetails = transactionVM.transaction.errorPaymentStatusDetails || {};
                transactionVM.transaction.errorPaymentStatusDetails.message = error.data.lastInternalResponseStatusDescription;

            }


            if (error.status && error.status >= 500) {
                transactionVM.transaction.paymentTransactionStatusType = 'ERROR';
                transactionVM.transaction.persistenceTransactionStatusType = 'ERROR';
                //this is app internal error
                transactionVM.error = {
                    status: error.status,
                    message: error.data.message
                };
            } else {
                //unexpected error
                transactionVM.transaction.paymentTransactionStatusType = 'ERROR';
                transactionVM.transaction.persistenceTransactionStatusType = 'ERROR';
            }

            if (typeof posthog !== 'undefined') {
                posthog.capture('payment_error', {
                    error: transactionVM.transaction.errorPaymentStatusDetails.message,
                    transactionId: transactionVM.transaction.uuid
                })
            }

        };

        function verifyChallenge(uuid, payload, callback, errCallback) {
            console.log('verifyChallenge...')
            var cb = callback || angular.noop;
            var cbe = errCallback || angular.noop;

            //call the endpoint to process transaction by uuid
            return PaymentProcessTransaction.service.process({uuid: uuid}, payload,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cbe(err);
                }.bind(this)).$promise;
        }

        function processTransaction(uuid, callback, errCallback, paymentReply) {
            console.log('processTransaction', uuid)
            var cb = callback || angular.noop;
            var cbe = errCallback || angular.noop;

            //call the endpoint to process transaction by uuid
            return PaymentProcessTransaction.service.process({uuid: uuid, paymentReply: paymentReply},
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cbe(err);
                }.bind(this)).$promise;
        };

        function handleStripeConfirmPayment(clientSecret, returnUrl) {
            const stripe = Stripe(transactionVM.propertyConfig.stripePublicKey, {apiVersion: '2022-11-15'});

            return stripe.confirmPayment({
                clientSecret,
                confirmParams: {
                    return_url: returnUrl,
                },
            })
                .then(result => {
                    const error = result.error;
                    if (error) {
                        processPayment(true);
                    }
                });
        }

        function processRedirect(redirectObject) {

            console.log('processRedirect', transactionVM.transaction.paymentAccountTypeId);

            if (redirectObject.paymentStatus === 'REDIRECT') {

                transactionVM.redirectObject = redirectObject;
                transactionVM.redirectObjectUrl = $sce.trustAsResourceUrl(transactionVM.redirectObject.redirectURL);

                console.log('transactionVM.redirectObject.redirectURL', transactionVM.redirectObject.redirectURL)
                console.log('StripeElements.isActive()', StripeElements.isActive());

                if (StripeElements.isActive()) {
                    console.log('stripe applied...')
                    transactionVM.method = 'GET'; // change to get because ... Stripe...
                    // then parse the url to get client source secret...
                    handleStripeConfirmPayment(redirectObject.redirectParams.PaReq, redirectObject.redirectParams.TermUrl);
                    console.log('end processRedirect', redirectObject)

                    return;
                } else if (transactionVM.transaction.paymentAccountTypeId === 30 || transactionVM.transaction.paymentAccountTypeId === 31 || transactionVM.transaction.paymentAccountTypeId === 34 || transactionVM.transaction.paymentAccountTypeId === 35) {
                    //networkpayments/ngenius/spotii/binance requires GET.
                    transactionVM.method = 'GET';
                    var queryParams = getAllUrlParams(transactionVM.redirectObject.redirectURL);
                    transactionVM.redirectObject.redirectParams = queryParams;
                } else if (transactionVM.transaction.paymentAccountTypeId === 33) {
                    transactionVM.method = 'GET';
                } else {
                    transactionVM.method = 'POST';
                }

                console.log('$broadcasting SUBMIT_PAYMENT_FORM');
                $timeout(function () {
                    //console.log('$broadcasting SUBMIT_PAYMENT_FORM', transactionVM);
                    $scope.$broadcast('SUBMIT_PAYMENT_FORM', {uuid: transactionVM.transaction.uuid});
                }, 2000);
                //console.log('transactionVM: ', transactionVM);

            }

        };

        function getAllUrlParams(url) {
            console.log('getAllUrlParams', url)

            // get query string from url (optional) or window
            var queryString = url.split('?')[1];

            // we'll store the parameters here
            var obj = {};

            // if query string exists
            if (queryString) {

                // stuff after # is not part of query string, so get rid of it
                queryString = queryString.split('#')[0];

                // split our query string into its component parts
                var arr = queryString.split('&');

                for (var i = 0; i < arr.length; i++) {
                    // separate the keys and the values
                    var a = arr[i].split('=');

                    // in case params look like: list[]=thing1&list[]=thing2
                    var paramNum = undefined;
                    var paramName = a[0].replace(/\[\d*\]/, function (v) {
                        paramNum = v.slice(1, -1);
                        return '';
                    });

                    // set parameter value (use 'true' if empty)
                    var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];

                    // if parameter name already exists
                    if (obj[paramName]) {
                        // convert value to array (if still string)
                        if (typeof obj[paramName] === 'string') {
                            obj[paramName] = [obj[paramName]];
                        }
                        // if no array index number specified...
                        if (typeof paramNum === 'undefined') {
                            // put the value on the end of the array
                            obj[paramName].push(paramValue);
                        }
                        // if array index number specified...
                        else {
                            // put the value at that index number
                            obj[paramName][paramNum] = paramValue;
                        }
                    }
                    // if param name doesn't exist yet, set it
                    else {
                        obj[paramName] = paramValue;
                    }
                }
            }

            return obj;
        }

        function initSnapScan(params) {
            console.log('snapscan.. init.', params)
            transactionVM.snapScan.qrCode = 'https://pos.snapscan.io/qr/' + params.merchantId + '.svg?id=' + params.reference + '&amount=' + (params.amount * 100) + '&snap_code_size=175&strict=true'
            transactionVM.snapScan.url = 'https://pos.snapscan.io/qr/' + params.merchantId + '?id=' + params.reference + '&amount=' + params.amount
            transactionVM.snapScan.enabled = true;
            transactionVM.transactionId = params.reference;
            transactionVM.showSpinner = false;

            transactionVM.snapScanInterval = $interval(function () {
                checkSnapScan();
            }, transactionStatusCheckMillis);
        }

        transactionVM.checkSnapScanButton = function () {
            console.log('checkSnapScanButton');
            transactionVM.snapScanIntervalButtonLoading = true;
            checkSnapScan()
            $timeout(function () {
                transactionVM.snapScanIntervalButtonLoading = false;
            }, 2000);
        }

        function checkPaymentStatus(uuid, paymentStatus) {
            console.log('checking payment status... current status: ', paymentStatus);
            PaymentProcessTransaction.status.get({uuid: uuid},
                function (response) {
                    console.log('... and response', response.paymentStatus);
                    if (response.paymentStatus === 'COMPLETED' && response.persistenceStatus === 'SAVED') {
                        $interval.cancel(transactionVM.paymentStatusInterval);
                        transactionVM.transaction.paymentTransactionStatusType = response.paymentStatus;
                        transactionVM.transaction.persistenceTransactionStatusType = response.persistenceStatus;
                    } else if (response.paymentStatus !== paymentStatus && response.paymentStatus !== 'COMPLETED' && response.paymentStatus !== 'ERROR') {
                         //stop interval first and then process
                         $interval.cancel(transactionVM.paymentStatusInterval);
                         processTransactionCallback(response);
                    } else if (response.paymentStatus === 'ERROR') {
                        //stop interval first and then process
                        $interval.cancel(transactionVM.paymentStatusInterval);
                        var callbackObject = {
                            data: response
                        }
                        processTransactionErrorCallback(callbackObject);
                    }
                },
                function (error) {
                    console.error('error occured, stopping paymentStatusInterval', error)
                    $interval.cancel(transactionVM.paymentStatusInterval);
                    $window.location.reload(); //lets reload the page
                })
        }

        function checkSnapScan() {
            console.log('checking snapscan transaction status...')
            SnapScanRefreshTransaction.refresh({transactionId: transactionVM.transactionId},
                function (response) {
                    console.log('response', response)
                    if (response.completed) {
                        //stop interval first and then process
                        $interval.cancel(transactionVM.snapScanInterval);
                        processPayment(true);
                    }
                },
                function (error) {
                    console.log('error occured, stopping interval', error)
                    $interval.cancel(transactionVM.snapScanInterval);
                    $window.location.reload(); //lets reload the page
                })
        }

        transactionVM.$onDestroy = function () {
            console.log('$onDestroy...')
            //before we leave, make sure this is stopped
            if (transactionVM.snapScanInterval) {
                $interval.cancel(transactionVM.snapScanInterval);
            }
            //cancel paymentStatusInterval if there is one.
            if (transactionVM.paymentStatusInterval) {
                $interval.cancel(transactionVM.paymentStatusInterval);
            }
        }

        function initZapper(params) {
            console.log('init zapper!', params);
            if (zapper) {
                console.log('zapper loaded!')
                $timeout(function () {
                    transactionVM.paymentWidget = new zapper.payments.PaymentWidget(
                        '.qr-payment-container',
                        {
                            merchantId: params.merchantId,
                            siteId: params.siteId,
                            amount: params.amount,
                            reference: params.reference
                        }
                    );
                    transactionVM.paymentWidget.on('payment', function (event) {
                        console.log('payment event', event.status);
                        if (event.status === 2) {
                            processPayment(true);
                        }
                    });
                    transactionVM.showSpinner = false;
                }, 1000);
            } else {
                console.log('zapper not loaded!')
            }
        }

        $window.onmessage = function (event) {
            if (typeof (event.data) !== 'undefined' && event.data.completed === true) {
                console.log('processPayment call onmessage...')
                processPayment();
            }
        };
    };


})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('PaymentTransactionsDialogController', PaymentTransactionsDialogController);

    function PaymentTransactionsDialogController($scope, $rootScope, $state, $stateParams, $anchorScroll, shoppingCart, PaymentFinishProcess, DetermineShopMoreState,Analytics, TagManager, GoogleAdwordsService, ENV, currentProperty, currentPropertyGroup, currentLanguage, propertyConfig, availablePaymentOptions) {
        'ngInject';
	    var vm = this;

	    $anchorScroll();

	    vm.transactionsCompleted = false;

	    vm.shoppingCart = shoppingCart;
	    vm.propertyConfig = propertyConfig;
	    vm.browseMore = browseMore;
	    vm.isApplicable = isApplicable;
        vm.availablePaymentOptions = availablePaymentOptions;

	    vm.transactions = shoppingCart.shoppingCartPaymentTransactions;


	    $scope.$watch('vm.transactions', finishTransactions, true);

	    function finishTransactions () {
	        console.log('finishTransactions...', vm.transactions.length)
            if (0 == vm.transactions.length) {
                //error no transactions
                console.error("no transactions", vm.transactions.length)
                return;
            }
	    	var completedCount = 0;
            var applicableCount = 0;
	    	//console.info("transactions: ",vm.transactions);
            angular.forEach(vm.transactions, function (t, key) {
                //transaction has items in the shopping bag
                if (isApplicable(t)) {
                    applicableCount++;
                    if (t.paymentTransactionStatusType == 'COMPLETED' && t.persistenceTransactionStatusType == 'SAVED') {
                        completedCount++;
                    }
                }
            });
            if (completedCount == applicableCount) {
                finishProcessAndGoToConfirmationState();
            }
            console.debug("completedCount == applicableCount", completedCount, applicableCount);
	    };

        function isApplicable(t){
            var applicable = false;
            angular.forEach(vm.shoppingCart.shoppingCartItems.items, function (item, index) {
                if (t.shoppingCartItemUUIDs.indexOf(item.uuid) > -1) {
                    applicable = true;
                }
            });
            return applicable;
        }


	    function finishProcessAndGoToConfirmationState() {
	        console.log('finishProcessAndGoToConfirmationState')
            finishProcess(goToConfirmationState);
	    };

        function goToConfirmationState(object) {
            console.log('=> goToConfirmationState', object)

            try {
                angular.forEach(vm.transactions, function (transaction) {
                    trackTransaction(transaction, object.confirmationUuid);
                });
            } catch (e) {
                console.error(e);
            }

            if (object.confirmationUuid) {
                $state.transitionTo('confirmation', {uuid: object.confirmationUuid}, {
                    reload: 'site', inherit: true, notify: true
                });
            }
        };

        function finishProcess (callback) {
            console.log('finishProcess...')
            var cb = callback || angular.noop;

            //build shopping cart locale
            var variant = '';
            if ($stateParams.contextType) {
                variant = '_' + $stateParams.contextType;
            }
            variant += (variant.length === 0 ? '_' : '') + currentProperty.hotelId;

            var src = undefined;
            if (typeof currentPropertyGroup !== 'undefined') {
                src = currentPropertyGroup.code;
            }
            if ($stateParams.src) {
                src = $stateParams.src;
            }

            var params = {
                ref: $stateParams.ref,
                src: src,
                lang: currentLanguage + variant,
                contextType: $stateParams.contextType,
                propertyType: $stateParams.propertyType,
                propertyCode: $stateParams.propertyId,
                customerRef: $stateParams.customerRef,
                reset : $stateParams.reset

            };

            return PaymentFinishProcess.finish(params,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        };




	    function browseMore(event){
	    	event.preventDefault();
	    	var shopMoreState = DetermineShopMoreState.getShopMoreState();
	    	$state.go(shopMoreState.name, shopMoreState.params);
	    };

        function trackTransaction(transaction, confirmationUuid) {
            console.log('trackTransactions...')
            console.log('transaction', transaction)
            angular.forEach(vm.shoppingCart.shoppingCartItems.items, function (item, index) {
                if (transaction.shoppingCartItemUUIDs.indexOf(item.uuid) > -1) {
                    Analytics.addProduct(
                        item.itemId,//productId
                        item.itemName,//name
                        item.itemType,//category
                        item.owningProperty.propertyCode,//brand
                        (item.itemType === 'cash-wildcard' ? item.selectedCurrency + ' ' + item.itemTotalPrice : ''),//variant
                        item.itemTotalPrice,//price
                        '1',//quantity
                        '',//coupon
                        index//position
                    );
                }
            });

            //analytics... UA-XXXXXX
            Analytics.trackTransaction(
                confirmationUuid,//confirmationUUID
                'In1Solutions',//affiliation
                transaction.transactionAmount,//revenue
                '',//tax
                transaction.transactionShippingAmount,//shipping
                '',//coupon
                '',//list
                '',//step
                ''//option
            );

            //GTM datalayer push
            TagManager.trackPurchase(transaction, vm.shoppingCart, confirmationUuid);

            if (GoogleAdwordsService.isInitialized()) {
                GoogleAdwordsService.googleTrackConversion(transaction.transactionAmount, transaction.transactionCurrency, confirmationUuid);
            }

            if (ENV !== 'dev' && typeof posthog !== 'undefined') {

                posthog.capture('purchase', {
                    transactionId: confirmationUuid,
                    transactionRevenue: transaction.transactionAmount,
                    transactionCurrencyCode: transaction.transactionCurrency,
                    customerEmail: vm.shoppingCart.customer.email
                });

                posthog.identify(vm.shoppingCart.customer.uuid, {
                    email: vm.shoppingCart.customer.email
                });
            }

        }

	}
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('PaymentTermsDialogController', PaymentTermsDialogController);

    PaymentTermsDialogController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', '$uibModalInstance', 'terms' ];

	function PaymentTermsDialogController($scope, $rootScope, $state, $stateParams, $uibModalInstance, terms) {
	    var vm = this;

	    vm.terms = terms;

        vm.hideClear = false;
	    if($state.includes('property.terms')){
	        vm.hideClear = true;
        }

	    //console.log(terms);

	    vm.clear = clear;

	    function clear () {
            $uibModalInstance.dismiss('cancel');
        }

	}
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PaymentRedirectSingleton', PaymentRedirectSingleton);

    PaymentRedirectSingleton.$inject = [];

    function PaymentRedirectSingleton () {
    	
    	var redirectInProgress = 0;
    	    	    	
        var service = {
        		isBusy : function(){
        			return redirectInProgress > 0;
        		},
        		start : function(){
        			redirectInProgress += 1;
        		},
        		stop : function(){
        			if(redirectInProgress > 0){
        				redirectInProgress -= 1;
        			};
        		},
        		startIfNotBusy : function(){
        			if(redirectInProgress > 0){
        				return false;
        			}
        			redirectInProgress += 1;
        			return true;
        		}
        		
        }

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PaymentProcessTransaction', PaymentProcessTransaction);

    PaymentProcessTransaction.$inject = ['$resource'];

    function PaymentProcessTransaction($resource) {
        var service = $resource('api/payment/:uuid', {uuid: '@uuid'}, {
            'process': {
                method: 'POST',
                params: {paymentReply: '@paymentReply'}
            }
        });

        var status = $resource('api/payment/status/:uuid', {uuid: '@uuid'}, {
            'get': {
                method: 'GET'
            }
        });

        return {
            service: service,
            status: status
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('SnapScanRefreshTransaction', SnapScanRefreshTransaction);


    function SnapScanRefreshTransaction($resource) {
        'ngInject';
        var service = $resource('api/payment/snapscan/:transactionId', {transactionId: '@transactionId'}, {
            'refresh': {
                method: 'POST'
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PaymentFinishProcess', PaymentFinishProcess);

    PaymentFinishProcess.$inject = ['$resource'];

    function PaymentFinishProcess ($resource) {
        var service = $resource('api/shoppingcart/finish', {}, {
            'finish': {
                method: 'GET',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PaymentAddCustomer', PaymentAddCustomer);

    PaymentAddCustomer.$inject = ['$resource'];

    function PaymentAddCustomer ($resource) {
        var service = $resource('api/payment/start', {}, {
            'add': {
                method: 'POST'
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('payment', {
            parent: 'property',
            url: '/payment',
            data: {
                authorities: [],
                autoscroll : true,
                pageTitle : 'payment.page.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/site/payment/payment.html',
                    controller: 'PaymentController',
                    controllerAs: 'vm'
                },
                'header@': {
                    templateUrl: 'app/layouts/header/header.html',
                    controller: 'BrandedHeaderController',
                    controllerAs: 'vm'
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.html',
                    controller: 'BrandedFooterController',
                    controllerAs: 'vm'
                },
                'cookies@': {
                    templateUrl: 'app/components/cookies-consent/cookies-banner.html',
                    controller: 'CookiesBannerController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                mainTranslatePartialLoader: function ($stateParams,$translate,$translatePartialLoader,currentProperty) {
                    'ngInject';
                	var variant = "";
                	if($stateParams.contextType){
                		variant = "_"+$stateParams.contextType;
                	}
                	variant += "_"+currentProperty.hotelId;

                	$translatePartialLoader.addPart('payment'+variant);
                    return $translate.refresh();
                },
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'payment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }],
                brandingTemplateUUID : ['brandingTemplateUUID',function(brandingTemplateUUID){
                	return brandingTemplateUUID;
                }],
                shoppingCart : ['shoppingCart','$q',function(shoppingCart,$q){
                	var d = $q.defer();
                	var allRecipientsExists = true;
                    var itemsInBasket = shoppingCart.shoppingCartItems.items.length>0;
            	    angular.forEach(shoppingCart.shoppingCartItems.items ,function(item, index){
                		if(item.recipient.uuid==null){
                			allRecipientsExists = false;
                		}
                	});
                    if (itemsInBasket && allRecipientsExists) {
                      d.resolve(shoppingCart);
                    } else if (!allRecipientsExists) {
                      //here the rejection
                      //it is handled in app/blocks/handlers/state.handler.js
                      d.reject('Payment: Recipient missing');
                    } else if (!itemsInBasket) {
                        //here the rejection
                        //it is handled in app/blocks/handlers/state.handler.js
                        d.reject('Payment: Basket empty');
                    }
                    return d.promise;
                }],
                availableCreditCards : function(PropertyCreditCards, currentProperty, shoppingCart) {
                    'ngInject';
                    console.log('shoppingCart contents', shoppingCart)
                    return PropertyCreditCards.get({id: currentProperty.hotelId}).$promise;
                },
                availablePaymentOptions: function (PropertyPaymentOptions, currentProperty, shoppingCart, currentLanguage, currentPropertyGroup, $cookies) {
                    'ngInject';
                    console.log('currentPropertyGroup', currentPropertyGroup);
                    var propertyId = currentProperty.hotelId;
                    if (currentPropertyGroup && !currentPropertyGroup.useMasterPayment) {
                        propertyId = shoppingCart.shoppingCartItems.items[0].owningProperty.propertyId;
                    }
                    var paymentRefToken = '';
                    $cookies.get('paymentRefToken') ? paymentRefToken = $cookies.get('paymentRefToken') : paymentRefToken = '';
                    return PropertyPaymentOptions.get({
                        id: propertyId,
                        lang: currentLanguage,
                        currency: currentProperty.hotelCurrency,
                        paymentRefToken: paymentRefToken
                    }).$promise;
                },
                propertyConfig: function (shoppingCartConfigs, currentProperty, currentPropertyGroup, shoppingCart) {
                    'ngInject';
                    var currentPropertyId = currentProperty.hotelId;
                    console.log('propertyConfig currentPropertyId', currentPropertyId, (currentPropertyGroup && !currentPropertyGroup.useMasterPayment))
                    if (currentPropertyGroup && !currentPropertyGroup.useMasterPayment) {
                        currentPropertyId = shoppingCart.shoppingCartItems.items[0].owningProperty.propertyId;
                    }
                    console.log('propertyConfig currentPropertyId', currentPropertyId)
                    var propertyConfig = (shoppingCartConfigs && shoppingCartConfigs[currentPropertyId]) ? shoppingCartConfigs[currentPropertyId].configMap : {};
                    console.log('propertyConfig', propertyConfig)
                    return propertyConfig;
                },
                stripe: function (propertyConfig, StripeElements, $q) {
                    'ngInject';
                    if (propertyConfig.stripe === 'true') {

                        var deferred = $q.defer();
                        var script = document.createElement('script');
                        script.type = 'text/javascript';
                        document.getElementsByTagName('head')[0].appendChild(script);
                        script.src = 'https://js.stripe.com/v3/';
                        script.onload = function () {
                            console.log('success')
                            deferred.resolve(StripeElements.initStripe(propertyConfig.stripePublicKey));
                        }
                        document.body.appendChild(script)
                        console.info('stripe enabled: ', propertyConfig.stripe, propertyConfig.stripePublicKey)
                        return deferred.promise;
                    } else {
                        return false;
                    }
                }
            }
        })
        .state('transactions', {
            parent: 'payment',
            url: '/result',
            data: {
                authorities: [],
                autoscroll : true,
                pageTitle : 'payment.page.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/site/payment/payment-transactions-dialog.html',
                    controller: 'PaymentTransactionsDialogController',
                    controllerAs: 'vm'
                },
                'hero@': {
                //	templateUrl: 'app/site/shoppingcart/hero-shopping.html',
                //    controller: 'HeroController',
                //    controllerAs: 'vm'
                }
            },
            resolve : {
                loadDependencies:['$ocLazyLoad', function($ocLazyLoad) {
                    return $ocLazyLoad.load('zapper');
                }],
                adwordsAccount: ['currentProperty', 'GoogleAdwordsService', function(currentProperty, GoogleAdwordsService) {
                    return GoogleAdwordsService.getCode({ hotelCode: currentProperty.hotelCode.toLowerCase()});
                }],
                adwords: ['GoogleAdwordsService', 'adwordsAccount', '$rootScope','CookiesConsentStorageService', 'IN1_CONSENT','$window', function(GoogleAdwordsService, adwordsAccount, $rootScope, CookiesConsentStorageService, IN1_CONSENT,$window) {

                    //COOKIE POLICY:
                    var isGDPR = ($window && $window.IN1 && $window.IN1.isGDPR) ? $window.IN1.isGDPR : false;

                    var defaultConsent = getDefaultConsent();

                    function getDefaultConsent() {
                        var defaultConsent = CookiesConsentStorageService.get();

                        var allowAnalytics = isGDPR ? false : true;//we don't know if the account has anonymizeIp ON and allowAdFeatures OFF, so we must set to false for people in the GDPR territories
                        var analyticsConsentAllowed = defaultConsent[IN1_CONSENT.PERFORMANCE]==IN1_CONSENT.GRANTED || (typeof defaultConsent[IN1_CONSENT.PERFORMANCE]  === "undefined" && defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.GRANTED);
                        if(analyticsConsentAllowed){
                            allowAnalytics = true;
                        }
                        //check if it is explicitly denied
                        var analyticsConsentDenied = defaultConsent[IN1_CONSENT.PERFORMANCE]==IN1_CONSENT.DENIED || (typeof defaultConsent[IN1_CONSENT.PERFORMANCE]  === "undefined" && defaultConsent[IN1_CONSENT.ALL]==IN1_CONSENT.DENIED);
                        if(analyticsConsentDenied){
                            allowAnalytics = false;
                        }

                        return {
                            consent : defaultConsent,
                            allowAnalytics : allowAnalytics
                        }
                    }


                    if (adwordsAccount.conversionId && !GoogleAdwordsService.isInitialized()) {

                        if(defaultConsent.allowAnalytics){

                            GoogleAdwordsService.setAccount(adwordsAccount);
                            GoogleAdwordsService.registerScript();
                            GoogleAdwordsService.setInitialized(true);
                        }
                    }
                    return '';
                }],
                stripeEnabled: ['$q', 'stripe', function ($q, stripe) {
                    var d = $q.defer();
                    console.log('testing stripeEnabled', stripe)
                    if (stripe) {
                        d.resolve(true);
                    } else {
                        d.resolve(false);
                    }
                    return d.promise;
                }],
                propertyConfig: function (shoppingCartConfigs, currentProperty) {
                    'ngInject';
                    console.log('payment/result propertyConfig...', currentProperty.hotelId)
                    console.log('shoppingCartConfigs', shoppingCartConfigs)
                    var currentPropertyId = currentProperty.hotelId;
                    var propertyConfig = (shoppingCartConfigs && shoppingCartConfigs[currentPropertyId]) ? shoppingCartConfigs[currentPropertyId].configMap : {};
                    return propertyConfig;
                },
            }
        })
        .state('fatal', {
            parent: 'transactions',
            url: '/payment/fatal',
            data: {
                authorities: [],
                autoscroll : true,
                pageTitle : 'payment.page.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/site/fatal/fatal.html',
                    controller: 'FatalController',
                    controllerAs: 'vm'
                },
                'header@': {
                    //templateUrl: 'app/layouts/header/header.html',
                    //controller: 'BrandedHeaderController',
                    //controllerAs: 'vm'
                },
                'footer@': {
                    //templateUrl: 'app/layouts/footer/footer.html',
                    //controller: 'BrandedFooterController',
                    //controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('payment');
                    return $translate.refresh();
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'payment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('terms-payment', {
            parent: 'payment',
            url: '/terms',
            data: {
                authorities: [],
                autoscroll : true
            },
            onEnter: ['$stateParams', '$state', '$uibModal', 'shoppingCart','$q','currentLanguage','currentPropertyGroup', function($stateParams, $state, $uibModal, shoppingCart,$q,currentLanguage,currentPropertyGroup) {
                var modal = $uibModal.open({
                    templateUrl: 'app/site/payment/payment-terms-dialog.html',
                    controller: 'PaymentTermsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'false',
                    animation: false,
                    windowClass : '',
                    size: 'lg',
                    resolve : {
                        shoppingCart: shoppingCart,
                        terms : ['TermsService',function(TermsService){

                        	var language = currentLanguage;
                        	var cb = function(termsText, shoppingCartItem){
                        	    return {terms : "<h5>"+shoppingCartItem.itemName+"</h5>"+termsText.terms}
                            };
                            var errCb = angular.noop;

                        	var termsPromises = [];
                        	angular.forEach(shoppingCart.shoppingCartItems.items, function(value, key) {

                        		var delivery = value.recipient.deliveryMethodType;
                        		var propertyId = value.owningProperty.propertyId;
                                var voucherId = value.itemId;

                        		var termsPromise = TermsService.get({
                                        propertyId : propertyId,
                                        voucherId : voucherId,
                                        lang : (language || 'en').split('-')[0].split('_')[0],
                                        termsType : delivery,
                                        groupCode: typeof currentPropertyGroup !== 'undefined' ?  currentPropertyGroup.code : undefined
                                }).$promise.then(
                                        function (response) {
                                            return cb(response, value);
                                        },
                                        function (err) {
                                            return errCb(err);
                                        }.bind(this)
                                );

                        		termsPromises.push(termsPromise);
                            });

                        	var terms = $q.all(termsPromises);
                        	return terms;

                        }]
                    }
                });

                modal.result.then(function() {
                    var stillIn = $state.is('terms-payment');
                    if(stillIn){
                        $state.go('^', {}, { reload: false });
                    }
                }, function() {
                    var stillIn = $state.is('terms-payment');
                    if(stillIn){
                        $state.go('^', {}, { reload: false });
                    }
                });

                $state.currentModal = modal;

            }],
            onExit: ['$state',function($state){
                $state.currentModal.close();
            }]
        })
        .state('terms-property', {
                parent: 'property',
                url: '/terms?termsType&termsVoucherId&termsPropertyId&termsId',
                data: {
                    authorities: [],
                    autoscroll : true
                },
                params: {
                    termsType: 'email',
                    lang : "en"
                },
                views: {
                    'content@': {
                        templateUrl: 'app/site/payment/payment-terms-dialog.html',
                        controller: 'PaymentTermsDialogController',
                        controllerAs: 'vm'
                    },
                    'header@': {
                        templateUrl: 'app/layouts/header/header.html',
                        controller: 'BrandedHeaderController',
                        controllerAs: 'vm'
                    },
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.html',
                        controller: 'BrandedFooterController',
                        controllerAs: 'vm'
                    },
                    'cookies@': {
                        templateUrl: 'app/components/cookies-consent/cookies-banner.html',
                        controller: 'CookiesBannerController',
                        controllerAs: 'vm',
                    }
                },
                resolve : {
                    $uibModalInstance : [function(){
                        return {};
                    }],
                    terms : ['TermsService','$stateParams','currentPropertyGroup','$q',function(TermsService,$stateParams,currentPropertyGroup,$q){

                        var cb = function(termsText){
                            return {
                                terms : termsText.terms
                            }
                        };
                        var errCb = angular.noop;

                        var termsPromises = [];
                        var lang = $stateParams.lang;
                        var termsType = $stateParams.termsType;
                        var termsPropertyId = $stateParams.termsPropertyId;
                        var termsVoucherId = $stateParams.termsVoucherId;

                        var termsId = $stateParams.termsId;//specific hardcoded terms id

                        var termsPromise = TermsService.get({
                                termsId: termsId,
                                propertyId : termsPropertyId,
                                voucherId : termsVoucherId,
                                lang : lang,
                                termsType : termsType,
                                groupCode: typeof currentPropertyGroup !== 'undefined' ?  currentPropertyGroup.code : undefined
                            }).$promise.then(
                            function (response) {
                                return cb(response);
                            },
                            function (err) {
                                return errCb(err);
                            }.bind(this));

                        termsPromises.push(termsPromise);

                        var terms = $q.all(termsPromises);
                        return terms;

                    }]
                }
            })
        ;
    }
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('PaymentController', PaymentController);

    function PaymentController($scope, $rootScope, $state, $q, $transition$, previousState, $anchorScroll, CountriesService, CountriesWithoutPostcodeService, shoppingCart, PaymentAddCustomer, DetermineShopMoreState, $translate, Analytics, shoppingCartConfigs, currentProperty, currentPropertyGroup, StripeElements, stripe, availableCreditCards, availablePaymentOptions, $document, $uibModal, $window, CurrencyExchange, $uiRouterGlobals, propertyConfig, $timeout) {
        'ngInject';
	    var vm = this;
	    console.log('payment controller 1');

	    vm.$onInit = function() {

            $anchorScroll();

            vm.shoppingCart = shoppingCart;
            vm.isProcessing = false;
            vm.availablePaymentOptions = availablePaymentOptions;
            for (const availablePaymentOption of availablePaymentOptions) {
                if (availablePaymentOption.defaultPayment === true) {
                    vm.selectedPaymentOption = availablePaymentOption;
                    vm.selectedPaymentOptionId = availablePaymentOption.id;
                }
            }


            //currency
            vm.currentCurrency = {
                code : undefined
            }
            var currentCurrency = CurrencyExchange.currencies.current;//current currency might be NULL if this is group engine
            if (currentCurrency) {
                vm.currentCurrency.code = currentCurrency.code;
            }

            $rootScope.$on('CurrencyExchangeProvider.changeCurrency', function(event, args) {
                vm.currentCurrency.code = args.code;
            });

            var currenciesInCart = [];
            angular.forEach(shoppingCart.shoppingCartItems.items, function (cartItem, index) {
                if(!currenciesInCart.includes(cartItem.itemCurrency)) {
                    currenciesInCart.push(cartItem.itemCurrency);
                }
            });
            vm.itemCurrencies = currenciesInCart.join(',');
            vm.isSameCurrency = vm.currentCurrency && vm.currentCurrency.code ? currenciesInCart.includes(vm.currentCurrency.code) : false;

            trackCheckout();

            vm.browseMore = browseMore;


            vm.paymentFormInvalid = false;
            vm.startPayment = startPayment;
            vm.channel= $uiRouterGlobals.params.channel || '';

            vm.forceHidePromoBox = true;

            vm.selectCountry = [];
            vm.noPostcodeCountries = [];
            vm.isPostCodeRequired = true;
            vm.americanStates = states;

            loadCountries(loadCountriesCallback);
            loadCountriesWithoutPostcode(loadCountriesWithoutPostcodeCallback);


            var baseCard = {
                cardType: '',
                cardExpiryMonth: {value: 1},
                cardExpiryYear: {value: 2030},
                cardNumber: '',
                cvv: '',
                cardHolderName: '',
            };

            var baseCustomer = {
                title: '',
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                town: '',
                country: '',
                county: '',
                postcode: '',
                address: '',
                newsletter: undefined,
                card: baseCard
            };

            vm.newsletter = {
                optin : false,
                optout : false
            };

            console.log("Customer from session: ",vm.shoppingCart.customer.newsletter);

            if(!vm.shoppingCart.customer || !vm.shoppingCart.customer.uuid || vm.shoppingCart.customer.uuid.length==0){
                angular.extend(vm.shoppingCart.customer , baseCustomer);
            }

            vm.customer = vm.shoppingCart.customer;
            if (!vm.shoppingCart.customer.card) {
                vm.shoppingCart.customer.card = baseCard;
            }

            vm.shoppingCartConfigs = shoppingCartConfigs;
            vm.currentProperty = currentProperty;
            vm.currentPropertyGroup = currentPropertyGroup;
            vm.property = currentProperty;
            var currentPropertyId = currentProperty.hotelId;
            vm.propertyConfig = propertyConfig;

            if (
                vm.shoppingCartConfigs &&
                vm.shoppingCartConfigs[currentPropertyId] &&
                vm.shoppingCartConfigs[currentPropertyId].configMap &&
                vm.shoppingCartConfigs[currentPropertyId].configMap.newsletterOptMode
            ) {
                if (vm.shoppingCartConfigs[currentPropertyId].configMap.newsletterOptMode == 1) {
                    vm.newsletter.optin = true;
                    vm.newsletter.optout = false;
                } else if (vm.shoppingCartConfigs[currentPropertyId].configMap.newsletterOptMode == 2) {
                    vm.newsletter.optin = false;
                    vm.newsletter.optout = true;
                }
            }

            //set vm.customer.newsletter property
            if (vm.newsletter.optin) {
                vm.newsletter.optout = false;
                //'newsletter' property on customer indicates opt-in flag, change it to be used in the checkbox as opt-in flag (same thing in this case)
                vm.customer.newsletter = vm.customer.newsletter == undefined ? false : vm.customer.newsletter; //f customer has no 'newsletter' property checkbox cannot be pre-ticked
            } else if (vm.newsletter.optout) {
                vm.newsletter.optin = false;
                //'newsletter' property on customer indicates opt-in flag, change it to be used in the checkbox as opt-out flag (reverse in this case)
                vm.customer.newsletter = vm.customer.newsletter == undefined ? false : !vm.customer.newsletter; //if customer has no 'newsletter' property checkbox cannot be pre-ticked
            } else {
                vm.newsletter.optin = false;
                vm.newsletter.optout = false;
                vm.customer.newsletter = false;
            }

            vm.stripeEnabled = false;
            vm.stripeError = {};
            vm.cardErrors = '';
            vm.stripeToken = '';
            vm.stripeRedirect = 'not_supported'; // default value for stripe sources
            vm.enableCardName = true; //this is used to hide card name field for stripe

            vm.paypal = vm.propertyConfig.paypal === 'true';

            vm.isRefundsContext = 'refunds' === $uiRouterGlobals.params.contextType;

            vm.displayCardPayment = true;
            vm.displayTerms = true;
            vm.displayCardExpiry = true;
            vm.displayCardCvv = true;

            vm.displayIdentityInput = false;
            if (vm.currentProperty.hotelCountryCode === 'CO' || vm.currentProperty.hotelCountryCode === 'BR') {
                vm.displayIdentityInput = true;
            }

            //by default use short form, unless:
            //1. we have postal vouchers
            //2. we have longFrm in config
            vm.longForm = false;
            angular.forEach(shoppingCart.shoppingCartItems.items, function (cartItem, index) {
                if (
                    cartItem.recipient.deliveryMethodType == 'post' &&
                    cartItem.recipient.deliveryPersonType == 'customer'
                ) {
                    vm.longForm = true;
                }
            });

            if (
                vm.shoppingCartConfigs &&
                vm.shoppingCartConfigs[currentPropertyId] &&
                vm.shoppingCartConfigs[currentPropertyId].configMap &&
                vm.shoppingCartConfigs[currentPropertyId].configMap.paymentType === '26' || vm.shoppingCartConfigs[currentPropertyId].configMap.paymentType === '33'
            ) {
                vm.longForm = true;
            }

            if (
                vm.shoppingCartConfigs &&
                vm.shoppingCartConfigs[currentPropertyId] &&
                vm.shoppingCartConfigs[currentPropertyId].configMap &&
                vm.shoppingCartConfigs[currentPropertyId].configMap.longForm
            ) {
                if (vm.shoppingCartConfigs[currentPropertyId].configMap.longForm == 'true') {
                    vm.longForm = true;
                }
            }

            vm.collapsePurchaserDetails = false;

            if (vm.isRefundsContext) {
                vm.longForm = false; //always short form
                vm.forceHidePromoBox = true;
                vm.isSameCurrency = true;
                vm.displayCardExpiry = false;
                vm.displayCardCvv = false;

                // insert dummy values
                vm.customer.card.cvv = "123";
                vm.customer.card.cardExpiryMonth = { value: 1 };
                vm.customer.card.cardExpiryYear = { value: 2028 };

                vm.displayTerms = false;
                vm.customer.termsAgreed = true;
                if ($transition$.params().customerRef && $transition$.params().customerRef == vm.customer.customerRef) {
                    vm.customer.emailConfirm = vm.customer.email;
                    //collapse customer only if it's valid
                    var customerValid =
                        vm.customer.firstName &&
                        vm.customer.firstName.length > 0 &&
                        vm.customer.lastName &&
                        vm.customer.lastName.length > 0 &&
                        vm.customer.email &&
                        vm.customer.email.length > 0 &&
                        vm.customer.emailConfirm &&
                        vm.customer.emailConfirm.length > 0 &&
                        vm.customer.phone &&
                        vm.customer.phone.length > 0 &&
                        vm.customer.country &&
                        vm.customer.country.length > 0 &&
                        (vm.longForm || (vm.customer.address && vm.customer.address.length > 0)) &&
                        (vm.longForm || (vm.customer.town && vm.customer.town.length > 0)) &&
                        (vm.longForm || (vm.customer.county && vm.customer.county.length > 0)) &&
                        (vm.longForm ||
                            !vm.isPostCodeRequired ||
                            (vm.customer.postcode && vm.customer.postcode.length > 0));

                    vm.collapsePurchaserDetails = customerValid;
                } else {
                    //if it's refunds context, we also do not need to enter the customer details, as it all will be the hotel itself
                    vm.collapsePurchaserDetails = true;
                    vm.customer.firstName = currentProperty.hotelName;
                    vm.customer.email = currentProperty.hotelEmail;
                    vm.customer.emailConfirm = currentProperty.hotelEmail;
                    vm.customer.phone = currentProperty.hotelPhone;
                    vm.customer.country = currentProperty.hotelCountry;
                }
            }

            if (vm.propertyConfig.paypal === 'true') {
                //temp values for expiry date.
                vm.customer.card.cardExpiryMonth = { value: 1 };
                vm.customer.card.cardExpiryYear = { value: 2028 };
                vm.displayCardPayment = false;
            }

            //red dot payment, don't display payment card options
            if (vm.propertyConfig.paymentType === '15') {
                vm.displayCardPayment = false;
                //temp values for expiry date.
                vm.customer.card.cardExpiryMonth = { value: 1 };
                vm.customer.card.cardExpiryYear = { value: 2028 };
            }

            var pgNoCardDetails = ['17', '19', '20', '25', '28', '30', '40'];
            if (pgNoCardDetails.includes(vm.propertyConfig.paymentType) && !vm.isRefundsContext && vm.availablePaymentOptions.length === 1) {
                if (vm.propertyConfig.paymentType != 25) {
                    vm.displayCardPayment = false;
                }
                //temp values for expiry date.
                vm.customer.card.cardNumber = "4242424242424242";
                vm.customer.card.cvv = "123";
                vm.customer.card.cardType = "VISA";
                vm.customer.card.cardExpiryMonth = { value: 1 };
                vm.customer.card.cardExpiryYear = { value: 2028 };
            }

            //adyen
            vm.adyenPaymentMethods = {
                paymentMethods: [
                    {
                        brands: ['visa', 'mc', 'amex'],
                        details: [
                            {
                                key: 'encryptedCardNumber',
                                type: 'cardToken',
                            },
                            {
                                key: 'encryptedSecurityCode',
                                type: 'cardToken',
                            },
                            {
                                key: 'encryptedExpiryMonth',
                                type: 'cardToken',
                            },
                            {
                                key: 'encryptedExpiryYear',
                                type: 'cardToken',
                            },
                            {
                                key: 'holderName',
                                optional: true,
                                type: 'text',
                            },
                        ],
                        name: 'Credit Card',
                        type: 'scheme',
                    },
                ],
            };

            //gather browser info
            var now = new Date();
            vm.customer.browserInfo = {
                colorDepth: screen && screen.colorDepth,
                javaEnabled: navigator && navigator.javaEnabled(),
                javascriptEnabled: true,
                language: navigator && navigator.language,
                screenHeight: screen && screen.height,
                screenWidth: screen && screen.width,
                time: now,
                timeZoneOffset: now.getTimezoneOffset() / 60,
                userAgent: navigator && navigator.userAgent,
            };

            //adyen exceptions..
            function handleOnChange(state, component) {
                state.isValid; // True or false. Specifies if all the information that the shopper provided is valid.
                state.data; // Provides the data that you need to pass in the `/payments` call.
                component; // Provides the active component instance that called this event.
            }

            vm.adyenConfiguration = {};
            if (vm.propertyConfig.paymentType == 25 && vm.selectedPaymentOption.clientKey) {

                var configuration = {
                    clientKey: vm.selectedPaymentOption.clientKey,
                    locale: navigator.language,
                    environment: vm.selectedPaymentOption.environment === 'test' ? 'test' : 'live',
                    showPayButton: false,
                    paymentMethodsResponse: vm.selectedPaymentOption.optionalPaymentMethods,
                    onChange: handleOnChange,
                    onValid: function (state) {
                        vm.customer.browserInfo = state.data.browserInfo;
                        vm.customer.encryptedCardNumber = state.data.paymentMethod.encryptedCardNumber;
                        vm.customer.encryptedExpiryMonth = state.data.paymentMethod.encryptedExpiryMonth;
                        vm.customer.encryptedExpiryYear = state.data.paymentMethod.encryptedExpiryYear;
                        vm.customer.encryptedSecurityCode = state.data.paymentMethod.encryptedSecurityCode;
                        vm.customer.encryptedCard = true;
                    },
                    onError: function(error) {
                        console.log(error);
                    },
                    allowPaymentMethods: ['scheme'],
                    paymentMethodsConfiguration: {
                        card: { // Example optional configuration for Cards
                            hasHolderName: true,
                            holderNameRequired: true,
                            enableStoreDetails: false,
                            hideCVC: false, // Change this to true to hide the CVC field for stored cards
                            onSubmit: function(){}, // onSubmit configuration for card payments. Overrides the global configuration.
                            challengeWindowSize: '04',
                        }
                    }
                };

                vm.adyenConfiguration = configuration;

            }


            //eventually decide on the size of purchaser details and payment layout parts
            vm.purchaserDetailsSize = 'full';
            vm.paymentDetailsSize = 'full';
            if (!vm.longForm) {
                //if it's long form both parts are half size smaller
                vm.purchaserDetailsSize = 'half';
                vm.paymentDetailsSize = 'half';
            }
            if (vm.collapsePurchaserDetails) {
                //if we don't display purchaser details, then payment part must take the full size
                vm.purchaserDetailsSize = 'full';
                vm.paymentDetailsSize = 'full';
            }
            if (!vm.displayCardPayment && vm.propertyConfig.paymentType != 25) {
                //if we don't display payment part, then purchaser details must take the full size
                vm.purchaserDetailsSize = 'full';
                vm.paymentDetailsSize = 'full';
            }

            //#####stripe logic start#######//
            var total = Object.values(vm.shoppingCart.shoppingCartItems.totalPerProperty).reduce((a, b) => a + b, 0);

            if (stripe && total > 0) {
                initStripeElements();//paymentElement.mount('#payment-element');
            }

            if (vm.propertyConfig.paymentType == 39) {
                initOpayoConfig();
            }

            vm.openBuyerDetailsModal = openBuyerDetailsModal;

            $scope.$watch('vm.customer.country', function (newValue, oldValue) {
                isPostCodeRequired(vm.selectedPaymentOption.clientKey);
            });

            sendDataLayerCheckoutStep();
        }

        function initOpayoConfig(clientKey) {
            var deferred = $q.defer();
            var script = document.createElement('script');
            script.type = 'text/javascript';
            document.getElementsByTagName('head')[0].appendChild(script);
            script.src = 'https://pi-live.sagepay.com/api/v1/js/sagepay.js';
            script.onload = function () {
                //deferred.resolve(StripeElements.initStripe(propertyConfig.stripePublicKey));
            }
            document.body.appendChild(script)
            //console.info('stripe enabled: ', propertyConfig.stripe, propertyConfig.stripePublicKey)
            return deferred.promise;
        }

        function createOpayoToken(clientKey) {
             // to prevent form submission
            console.log(vm.customer.card)
            var month = vm.customer.card.cardExpiryMonth.display;
            var year = vm.customer.card.cardExpiryYear.display.toString().slice(-2); // Extract last two digits of year
            var expiryDateInMMYY = month + year;

            sagepayOwnForm({merchantSessionKey: clientKey }).tokeniseCardDetails({
                cardDetails: {
                    cardholderName: vm.customer.card.cardHolderName,
                    cardNumber: vm.customer.card.cardNumber,
                    expiryDate: expiryDateInMMYY,
                    securityCode: vm.customer.card.cvv
                },
                onTokenised: function (result) {
                    if (result.success) {
                        vm.customer.encryptedCardNumber = result.cardIdentifier;
                        addCustomer(goToPaymentTransactionsState);
                    } else {
                        console.error(JSON.stringify(result));
                        $timeout(function () {
                            vm.isProcessing = false;
                        }, 100);
                    }
                }
            });
        }

        function initStripeElements() {
            vm.stripeEnabled = true; //disables native form

            var total = Object.values(vm.shoppingCart.shoppingCartItems.totalPerProperty).reduce((a, b) => a + b, 0);

            const options = {
                mode: 'payment',
                paymentMethodTypes: ['card'],
                paymentMethodCreation: 'manual',
                amount: Math.round(total*100),
                currency: currentProperty.hotelCurrency.toLowerCase(),
                // Fully customizable with appearance API.
                appearance:{
                    variables: {
                        fontFamily: 'Open Sans, Helvetica Neue, Helvetica, Arial, system-ui, sans-serif'
                    }
                },
                fonts: [{
                    cssSrc: 'https://fonts.googleapis.com/css?family=Open+Sans'
                }]
            };

            // Set up Stripe.js and Elements to use in checkout form
            vm.elements = stripe.elements(options);

            // Create and mount the Payment Element
            vm.paymentElement = vm.elements.create('payment');
        }



        function handleCardChange(e) {
            vm.cardErrors = e.error ? e.error.message : '';
        }

        function createPaymentMethod(paymentElement) {
            const elements = vm.elements;
            vm.stripeError = {};

            return elements.submit()
                .then(({ error: submitError }) => {
                    if (submitError) {
                        return Promise.reject(submitError);
                    }

                    stripe.createPaymentMethod({
                        elements,
                        params: {
                            billing_details: {
                                name: !vm.enableCardName ? vm.card.cardHolderName : vm.customer.firstName + ' ' + vm.customer.lastName,
                                email: vm.customer.email,
                                phone: vm.customer.phone
                            }
                        }
                    }).then(({ error, paymentMethod }) => {
                        if (error) {
                            console.log('error', error);
                            return Promise.reject(error);
                        }

                        vm.stripeToken = paymentMethod.id;
                        addCustomer(goToPaymentTransactionsState);
                    })
                    .catch((error) => {
                        // Handle any errors that were caught in the promise chain
                        $timeout(function () {
                            vm.stripeError = error;
                        }, 100);
                    });
                })
                .catch((error) => {
                    // Handle any errors that were caught in the promise chain
                    $timeout(function () {
                        vm.stripeError = error;
                    }, 100);
                })
                .finally(() => {
                    $timeout(function () {
                        vm.isProcessing = false;
                    }, 100);
                });
        }

        function createSource() {
            console.log('createSource')
            stripe.createSource(vm.cardNumberElement, {
                owner: {
                    name: vm.customer.card.cardHolderName,
                }
            }).then(function (result) {
                if (result.error) {
                    // Inform the user if there was an error
                    console.log('error', result.error);
                } else {
                    console.log('result', result)
                    vm.stripeToken = result.source.id
                    vm.stripeRedirect = result.source.card.three_d_secure;
                    addCustomer(goToPaymentTransactionsState);
                }
            })
        }

        function createToken() {
            console.log('createToken');
            stripe.createToken(vm.cardNumberElement).then(function (result) {
                if (result.error) {
                    // Inform the user if there was an error
                    console.log('error', result.error);
                    return false;
                } else {
                    // Send the token to your server
                    vm.stripeToken = result.token.id;
                    addCustomer(goToPaymentTransactionsState);
                }
            });
        }

        //#####stripe logic end#######//

        /*
        this should be handled by transition error handler

        if (shoppingCart.shoppingCartPaymentTransactions.length > 0) {
            var allTransactionsCompleted = true;
            angular.forEach(shoppingCart.shoppingCartPaymentTransactions, function (t, index) {
                if (t.paymentTransactionStatusType != "COMPLETED") {
                    allTransactionsCompleted = false;
                }
            });

            console.log(allTransactionsCompleted);

            if (allTransactionsCompleted) {

            }
            else {
                //goToPaymentTransactionsState();
                //return;
            }
        }
        */

        function loadCountries(callback) {
            var cb = callback || angular.noop;

            CountriesService.get(function (response) {
                return cb(response);
            });
        }

        function loadCountriesWithoutPostcode(callback) {
            var cb = callback || angular.noop;

            CountriesWithoutPostcodeService.get(function (response) {
                return cb(response);
            });
        }

        function loadCountriesCallback(data) {
            //get countries from shopping basket and make them a priority
            var alreadyUsedCountryNames = [];

            var customerCountryAlreadyExists = false;
            if (typeof vm.customer.country === 'string' && vm.customer.country.length > 0) {
                alreadyUsedCountryNames.push(vm.customer.country);
                customerCountryAlreadyExists = true;
            }

            angular.forEach(shoppingCart.shoppingCartItems.items, function (item, index) {
                if (item.recipient.country && item.recipient.country.length > 0) {
                    if (customerCountryAlreadyExists) {
                        alreadyUsedCountryNames.push(item.recipient.country);
                    } else {
                        alreadyUsedCountryNames.unshift(item.recipient.country);
                    }
                }
                if (item.owningProperty.propertyCountry && item.owningProperty.propertyCountry.length > 0) {
                    alreadyUsedCountryNames.push(item.owningProperty.propertyCountry);
                }
            });

            //add priorities to countries
            angular.forEach(data.countries.country, function (c, index) {
                //add country priority
                var aIndex = alreadyUsedCountryNames.indexOf(c.countryName);
                var isPriority = aIndex > -1;
                var priorityIndex = aIndex - alreadyUsedCountryNames.length;
                if (isPriority) {
                    if (
                        typeof vm.customer.country === 'string' ||
                        priorityIndex < vm.customer.country.priorityCountryIndex
                    ) {
                        vm.customer.country = c;
                    }
                    var copy = angular.copy(c, {});
                    copy.priorityGroupIndex = 1; //like any other
                    copy.priorityCountryIndex = 1; //like any other
                    data.countries.country.push(copy);
                }
                c.priorityCountryIndex = isPriority ? priorityIndex : 1;
                c.priorityGroupIndex = isPriority ? priorityIndex : 1;
            });

            vm.selectCountry = data.countries.country;
        }

        function loadCountriesWithoutPostcodeCallback(data) {
            vm.noPostcodeCountries = data.countries.country;
            isPostCodeRequired();
        }

	    function isPostCodeRequired(){

	    	var isPostCodeRequired = true;
	    	if(typeof vm.customer.country === 'string' && vm.customer.country.length===0){
	    		isPostCodeRequired = false;
	    	}
	    	else if(typeof vm.customer.country === 'string' && vm.customer.country.length>0){
		    	angular.forEach(vm.noPostcodeCountries ,function(c, index){
		    		if(c[0]===vm.customer.country){
		    			isPostCodeRequired = false;
		    		}
		    	});
	    	}
	    	else {
		    	angular.forEach(vm.noPostcodeCountries ,function(c, index){
		    		if(c[0]===vm.customer.country.countryName){
		    			isPostCodeRequired = false;
		    		}
		    	});
	    	}

            vm.isPostCodeRequired = isPostCodeRequired;
        }

        $scope.$watch('vm.customer.country', function (newValue, oldValue) {
            isPostCodeRequired();
        });

        function startPayment(event) {
            vm.isProcessing = true;
            console.log('startPayment..!', vm.isProcessing)
            event.preventDefault();

            if (vm.paymentForm.$invalid) {
                console.log('vm.paymentForm.$invalid', vm.paymentForm.$invalid)
                var error = vm.paymentForm.$error;
                console.log(error)
                angular.forEach(error.required, function(field){
                    if(field.$invalid){
                        console.log(field.$name)
                    }
                });
                vm.paymentFormInvalid = true;
                vm.isProcessing = false;
                return;
            } else {
                vm.paymentFormInvalid = false;

                if (vm.stripeEnabled) {
                    createPaymentMethod(vm.paymentElement);
                } else if (vm.propertyConfig.paymentType === "39") {
                    createOpayoToken(vm.selectedPaymentOption.clientKey);
                } else {
                    addCustomer(goToPaymentTransactionsState);
                }
            }
        }

        function sendAddPaymentInfoDataLayer() {
            console.log('sendAddPaymentInfoDataLayer..!', vm.shoppingCart);
            var products = [];
            var overallRevenue = 0;
            angular.forEach(vm.shoppingCart.shoppingCartItems.items, function (cartItem, index) {
                products.push({
                    item_id: cartItem.itemId.toString(),
                    item_name: cartItem.itemName,
                    index: index+1,
                    price: cartItem.itemTotalPrice,
                    quantity: 1
                });
                overallRevenue = overallRevenue + cartItem.itemTotalPrice;
            });
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "add_payment_info",
                ecommerce: {
                    currency: vm.currentProperty.hotelCurrency,
                    value: overallRevenue,
                    payment_type: vm.selectedPaymentOption.displayName,
                    items: products
                }
            });
        }

        function goToPaymentTransactionsState(shoppingCartVM) {
            console.log('goToPaymentTransactionsState...');
            if (shoppingCartVM && shoppingCartVM.customer) {
                vm.shoppingCart.customer = shoppingCartVM.customer;
            }
            //send GA4 dataLayer info
            sendAddPaymentInfoDataLayer();

            $state.transitionTo('transactions', {}, {
                reload: 'site',
                inherit: true,
                notify: true
            });
        }

        const getEncryptedSecurityCode = (ignoreCard) => {
            if (vm.selectedPaymentOption.id === 39) {
                //todo: Opayo needs to use clientKey inside the payment lib
                //send cliantKey for Opayo
                return vm.selectedPaymentOption.clientKey;
            } else {
                return ignoreCard ? vm.customer.encryptedSecurityCode : '';
            }
        };

        function addCustomer(callback) {
            var cb = callback || angular.noop;

            var ignoreCard = false;
            if (vm.selectedPaymentOption.type === 'token') {
                ignoreCard = true;
            }

            var customer = {
                title: vm.customer.title,
                firstName: vm.customer.firstName,
                lastName: vm.customer.lastName,
                email: vm.customer.email,
                phone: vm.customer.phone,
                identityNumber: vm.displayIdentityInput ? vm.customer.idType + ':' + vm.customer.idNumber : '',
                town: vm.customer.town,
                country: typeof vm.customer.country === 'string' ? vm.customer.country : vm.customer.country.countryName,
                countryCode: typeof vm.customer.country === 'string' ? vm.customer.country : vm.customer.country.countryCode,
                county: vm.customer.county,
                postcode: vm.customer.postcode,
                address: vm.customer.address,
                cardType: vm.customer.card.cardType,
                cardExpiryMonth: ignoreCard ? 1 : vm.customer.card.cardExpiryMonth.value,
                cardExpiryYear: ignoreCard ? 2033 : vm.customer.card.cardExpiryYear.value,
                cardNumber: ignoreCard ? '4242424242424242' : vm.customer.card.cardNumber,
                cvv: ignoreCard ? '999' : vm.customer.card.cvv,
                cardHolderName: vm.customer.card.cardHolderName,
                //below the opt-in or opt-out checkbox meaning is changed to customer 'newsletter' property with only opt-in meaning
                newsletter: (vm.customer.newsletter && vm.newsletter.optin) || (!vm.customer.newsletter && vm.newsletter.optout),
                stripeToken: vm.stripeToken,
                stripeRedirect: vm.stripeRedirect,
                customerRef: vm.customer.customerRef,
                vobeContext: $uiRouterGlobals.params.contextType,
                paymentAccountTypeId: vm.selectedPaymentOptionId,
                browserInfo: vm.customer.browserInfo,
                encryptedCardNumber: vm.customer.encryptedCardNumber,
                encryptedExpiryMonth: vm.customer.encryptedExpiryMonth,
                encryptedExpiryYear: vm.customer.encryptedExpiryYear,
                encryptedSecurityCode: getEncryptedSecurityCode(ignoreCard),
                fulfillmentOptions: vm.customer.fulfillmentOptions,
                fulfillmentIdApplyOnce: vm.customer.fulfillmentIdApplyOnce,
            };

            return PaymentAddCustomer.add(
                customer,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    console.error(err)
                    return cb(err);
                }.bind(this)
            ).$promise;
        }

        function browseMore(event) {
            event.preventDefault();
            var shopMoreState = DetermineShopMoreState.getShopMoreState();
            $state.go(shopMoreState.name, shopMoreState.params);
        }

        function openBuyerDetailsModal(size, parentSelector) {
            var defaultModalOptions = {
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/site/payment/modals/buyer-info.html',
                controller: 'PaymentInfoModalInstanceCtrl',
                controllerAs: '$ctrl',
                size: 'lg',
                appendTo: 'body',
                //resolve: {
                //customExplain: function () {
                //        return itemVM.customExplain;
                //    }
                //}
            };

            var parentElem = parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;
            var modalOptions = angular.extend({}, defaultModalOptions);
            modalOptions.templateUrl = 'app/site/payment/modals/buyer-info.html';
            modalOptions.appendTo = parentElem || modalOptions.appendTo;
            modalOptions.size = size || modalOptions.size;
            var modalInstance = $uibModal.open(modalOptions);
            //modalInstance.result.then(function (something) {
            //}, function () {
            //  console.info('Modal dismissed at: ' + new Date());
            //});
        }


        function trackCheckout() {
            angular.forEach(shoppingCart.shoppingCartItems.items, function (item, index) {
                Analytics.addProduct(
                    item.itemId, //productId
                    item.itemName, //name
                    item.itemType, //category
                    item.owningProperty.propertyCode, //brand
                    '', //variant
                    item.itemTotalPrice, //price
                    '1', //quantity
                    '', //coupon
                    '' //position
                );
            });
            Analytics.trackCheckout(2, 'Credit Card');
        }

        var sendDataLayerCheckoutStep = function () {
            var dataLayer = ($window.dataLayer = $window.dataLayer || []);

            var productsInCartGa4 = [];
            var overallRevenue = 0;
            angular.forEach(shoppingCart.shoppingCartItems.items, function (cartItem, index) {
                productsInCartGa4.push({
                    name: cartItem.itemName,
                    id: cartItem.itemId.toString(),
                    price: cartItem.itemTotalPrice,
                    brand: cartItem.owningProperty.propertyName,
                    category: cartItem.itemType,
                    quantity: 1,
                    affiliation: cartItem.owningProperty.propertyName,
                    item_list_id: cartItem.itemCategoryId ? cartItem.itemCategoryId : 1,
                    item_list_name: cartItem.itemCategoryName ? cartItem.itemCategoryName : 'All',
                });
                overallRevenue += cartItem.itemTotalPrice;
            });

            //ga4
            dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
            dataLayer.push({
                event: "begin_checkout",
                ecommerce: {
                    currency: vm.currentProperty.hotelCurrency,
                    value: overallRevenue,
                    items: productsInCartGa4
                }
            });
        };

        //function to update totals and totalsPerPropertyInCurrentCurrency from the shopping-cart-summary component
        vm.updateTotals = function (value) {
            vm.totals = value.totals;
            vm.totalsPerPropertyInCurrentCurrency = value.totalsPerPropertyInCurrentCurrency;
            vm.amountToCharge = 0;
            angular.forEach(vm.totalsPerPropertyInCurrentCurrency, function (value, key) {
                vm.amountToCharge += value.itemTotalPrice + value.totalShipping + value.serviceFee;
            });
        }

        vm.updateCard = function (value) {
            vm.customer.card = value;
        }

        vm.changedPaymentOption = function(selectedPaymentOption) {
            console.log('changedPaymentOption',selectedPaymentOption )
            vm.selectedPaymentOption = selectedPaymentOption;
            angular.forEach(vm.availablePaymentOptions, function(value, key) {
                if (value.id === selectedPaymentOption.id && !value.displayCreditCard) {
                    //override baseCard values to dummy values.
                    vm.customer.card.cardNumber = "4242424242424242";
                    vm.customer.card.cvv = "123";
                    vm.customer.card.cardType = "VISA";
                    vm.customer.card.cardExpiryMonth = { value: 1 };
                    vm.customer.card.cardExpiryYear = { value: 2028 };
                } else {
                    vm.customer.card.cardNumber = ""; //default to empty.RedisVobeCacheConfiguration
                }

                //disable stripe elements if not selected

                vm.stripeEnabled = (selectedPaymentOption.id === 9)
                if (vm.stripeEnabled) {
                    initStripeElements();
                }
            })
        }

	}


	//credit card form component - NEW!
	angular.module('vobeApp')
        .component('creditCardForm', {
            templateUrl: 'app/site/payment/payment-credit-card.html',
            controller: 'CreditCardFormController',
            bindings: {
                paymentDetailsSize: '<',
                availableCreditCards: '<',
                formReference: '<',
                onUpdate: '&',
                card: '<',
                displayCardExpiry: '<',
                displayCardCvv: '<',
                paymentFormInvalid: '<',
                propertyConfig: '<',
            }
        });

    angular.module('vobeApp')
        .controller('CreditCardFormController', CreditCardFormController)

	function CreditCardFormController($scope, $translate) {
        'ngInject';

        var vm = this;
        vm.$onInit = function () {
            console.log('CreditCardFormController $onInit')
            var mmDisplay = 'MM';
            var yyDisplay = 'YY';

            $translate('payment.form.label.card.mm', {}, undefined, 'MM').then(function (translation) {
                mmDisplay = translation;
            });
            $translate('payment.form.label.card.yy', {}, undefined, 'YY').then(function (translation) {
                yyDisplay = translation;
            });

            vm.selectCardMonth = [
                {display: mmDisplay, value: '', disabled: true},
                {display: '01', value: 1},
                {display: '02', value: 2},
                {display: '03', value: 3},
                {display: '04', value: 4},
                {display: '05', value: 5},
                {display: '06', value: 6},
                {display: '07', value: 7},
                {display: '08', value: 8},
                {display: '09', value: 9},
                {display: '10', value: 10},
                {display: '11', value: 11},
                {display: '12', value: 12}
            ];
            vm.selectCardYear = [
                {display: yyDisplay, value: '', disabled: true}
            ];
            var currentYear = new Date().getFullYear();
            for (var y = currentYear; y < currentYear + 15; y++) {
                vm.selectCardYear.push({display: y, value: y});
            }

            vm.popoverUrl = {
                securityCode: 'app/site/payment/popovers/security-code-popover.html'
            };


            vm.card.cardExpiryMonth = vm.selectCardMonth[0];
            vm.card.cardExpiryYear = vm.selectCardYear[0];


            //update function to push back updated values to PaymentController
            vm.update = function (value) {
                console.log('running onUpdate..', value)
                var card = angular.extend({}, vm.card);
                  vm.onUpdate({value: card});
            };

        }
    }

    const states = [
        {
            "name": "Alabama",
            "abbreviation": "AL"
        },
        {
            "name": "Alaska",
            "abbreviation": "AK"
        },
        {
            "name": "American Samoa",
            "abbreviation": "AS"
        },
        {
            "name": "Arizona",
            "abbreviation": "AZ"
        },
        {
            "name": "Arkansas",
            "abbreviation": "AR"
        },
        {
            "name": "California",
            "abbreviation": "CA"
        },
        {
            "name": "Colorado",
            "abbreviation": "CO"
        },
        {
            "name": "Connecticut",
            "abbreviation": "CT"
        },
        {
            "name": "Delaware",
            "abbreviation": "DE"
        },
        {
            "name": "District Of Columbia",
            "abbreviation": "DC"
        },
        {
            "name": "Federated States Of Micronesia",
            "abbreviation": "FM"
        },
        {
            "name": "Florida",
            "abbreviation": "FL"
        },
        {
            "name": "Georgia",
            "abbreviation": "GA"
        },
        {
            "name": "Guam",
            "abbreviation": "GU"
        },
        {
            "name": "Hawaii",
            "abbreviation": "HI"
        },
        {
            "name": "Idaho",
            "abbreviation": "ID"
        },
        {
            "name": "Illinois",
            "abbreviation": "IL"
        },
        {
            "name": "Indiana",
            "abbreviation": "IN"
        },
        {
            "name": "Iowa",
            "abbreviation": "IA"
        },
        {
            "name": "Kansas",
            "abbreviation": "KS"
        },
        {
            "name": "Kentucky",
            "abbreviation": "KY"
        },
        {
            "name": "Louisiana",
            "abbreviation": "LA"
        },
        {
            "name": "Maine",
            "abbreviation": "ME"
        },
        {
            "name": "Marshall Islands",
            "abbreviation": "MH"
        },
        {
            "name": "Maryland",
            "abbreviation": "MD"
        },
        {
            "name": "Massachusetts",
            "abbreviation": "MA"
        },
        {
            "name": "Michigan",
            "abbreviation": "MI"
        },
        {
            "name": "Minnesota",
            "abbreviation": "MN"
        },
        {
            "name": "Mississippi",
            "abbreviation": "MS"
        },
        {
            "name": "Missouri",
            "abbreviation": "MO"
        },
        {
            "name": "Montana",
            "abbreviation": "MT"
        },
        {
            "name": "Nebraska",
            "abbreviation": "NE"
        },
        {
            "name": "Nevada",
            "abbreviation": "NV"
        },
        {
            "name": "New Hampshire",
            "abbreviation": "NH"
        },
        {
            "name": "New Jersey",
            "abbreviation": "NJ"
        },
        {
            "name": "New Mexico",
            "abbreviation": "NM"
        },
        {
            "name": "New York",
            "abbreviation": "NY"
        },
        {
            "name": "North Carolina",
            "abbreviation": "NC"
        },
        {
            "name": "North Dakota",
            "abbreviation": "ND"
        },
        {
            "name": "Northern Mariana Islands",
            "abbreviation": "MP"
        },
        {
            "name": "Ohio",
            "abbreviation": "OH"
        },
        {
            "name": "Oklahoma",
            "abbreviation": "OK"
        },
        {
            "name": "Oregon",
            "abbreviation": "OR"
        },
        {
            "name": "Palau",
            "abbreviation": "PW"
        },
        {
            "name": "Pennsylvania",
            "abbreviation": "PA"
        },
        {
            "name": "Puerto Rico",
            "abbreviation": "PR"
        },
        {
            "name": "Rhode Island",
            "abbreviation": "RI"
        },
        {
            "name": "South Carolina",
            "abbreviation": "SC"
        },
        {
            "name": "South Dakota",
            "abbreviation": "SD"
        },
        {
            "name": "Tennessee",
            "abbreviation": "TN"
        },
        {
            "name": "Texas",
            "abbreviation": "TX"
        },
        {
            "name": "Utah",
            "abbreviation": "UT"
        },
        {
            "name": "Vermont",
            "abbreviation": "VT"
        },
        {
            "name": "Virgin Islands",
            "abbreviation": "VI"
        },
        {
            "name": "Virginia",
            "abbreviation": "VA"
        },
        {
            "name": "Washington",
            "abbreviation": "WA"
        },
        {
            "name": "West Virginia",
            "abbreviation": "WV"
        },
        {
            "name": "Wisconsin",
            "abbreviation": "WI"
        },
        {
            "name": "Wyoming",
            "abbreviation": "WY"
        }
    ];

})();

(function() {
	'use strict';

	angular.module('vobeApp').controller('PaymentInfoModalInstanceCtrl', PaymentInfoModalInstanceCtrl);

    PaymentInfoModalInstanceCtrl.$inject = [ '$uibModalInstance' ];

	function PaymentInfoModalInstanceCtrl($uibModalInstance) {

		var $ctrl = this;


		$ctrl.ok = function() {
			$uibModalInstance.close();
		};

		$ctrl.cancel = function() {
			$uibModalInstance.dismiss('cancel');
		};
	}
})();

(function() {
	'use strict';

	angular.module('vobeApp').directive('sameValue', sameValue);

	function sameValue() {
		var directive = {
			restrict : 'A',
			require : '?ngModel',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs, ngModel) {
			if (!ngModel) {
				return;
			}
			
			var compareActive = false;
			var compare = undefined;
			
			scope.$watch(attrs.sameValue, function(value) {
				compare = value;
				ngModel.$validate();
			});
			
			scope.$watch(attrs.sameValueRequired, function(value) {
				compareActive = value;
				ngModel.$validate();
			});
			
			var validator = function () {
				
				if(compareActive==false){
					return true;
				}
				else if(ngModel.$viewValue==compare){
					return true;
				}
				else {
					return false;
				}				
				
			};			
			
			ngModel.$validators.sameValue = validator;	
		}
	};

})();
(function() {
	'use strict';

	angular.module('vobeApp').directive('cardExpiryInFuture2',
			cardExpiryInFuture2);

	function cardExpiryInFuture2() {
		var directive = {
			restrict : 'A',
			require : '?ngModel',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs, ngModel) {
			if (!ngModel) {
				return;
			}

			var yearValue = undefined;
			var monthNgModel = ngModel;

			var validator = function () {

				if(!yearValue || !yearValue.value || yearValue.value.length==0){
					return false;
				}

				var d = new Date();
				var dMilis = d.getTime();
				try {
					var intYear = parseInt(yearValue.value);
					var intMonth = parseInt(monthNgModel.$viewValue.value);
					d.setFullYear(intYear, intMonth - 1);
					var dMilis2 = d.getTime();
					return (dMilis <= dMilis2);
				} catch (err) {
					//console.log(err);
				}
				// it is invalid
				return false;
			};

			ngModel.$validators.cardExpiryInFuture2 = validator;

			scope.$watch("$ctrl.card.cardExpiryYear", function (newValue, oldValue) {
				yearValue = newValue;
				monthNgModel.$validate();

			});





		}
	}
	;

})();

(function() {
	'use strict';

	angular.module('vobeApp').directive('cardExpiryInFuture',
			cardExpiryInFuture);

	function cardExpiryInFuture() {
		var directive = {
			restrict : 'A',
			require : '?ngModel',
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs, ngModel) {
			if (!ngModel) {
				return;
			}
			
			var yearValue = undefined;
			var monthNgModel = ngModel;
			
			var validator = function () {
				
				if(!yearValue || !yearValue.value || yearValue.value.length==0){
					return false;
				}

				var d = new Date();
				var dMilis = d.getTime();
				try {
					var intYear = parseInt(yearValue.value);
					var intMonth = parseInt(monthNgModel.$viewValue.value);
					d.setFullYear(intYear, intMonth - 1);
					var dMilis2 = d.getTime();
					return (dMilis <= dMilis2);
				} catch (err) {
					//console.log(err);
				}
				// it is invalid
				return false;
			};			
			
			ngModel.$validators.cardExpiryInFuture = validator;
				
			scope.$watch("vm.customer.cardExpiryYear", function (newValue, oldValue) {
				yearValue = newValue;
				monthNgModel.$validate();
			    
			});	
				
				



		}
	}
	;

})();
(function() {
	'use strict';

	angular.module('vobeApp').directive('autoSumbitRedirectForm',
			autoSumbitRedirectForm);

	autoSumbitRedirectForm.$inject = ['$timeout', 'PaymentRedirectSingleton'];

	function autoSumbitRedirectForm($timeout, PaymentRedirectSingleton) {
		var directive = {
			restrict : 'A',
			scope: {
				uuid : '=autoSumbitRedirectForm'
			},
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs) {
			//check if form is in the visible DOM
			//https://stackoverflow.com/questions/5629684/how-to-check-if-element-exists-in-the-visible-dom/16820058#16820058
			//otherwise counter gets incremented but if form is not in visible DOM the submission gets cancelled without errors
			var submissionAllowed = document.body.contains(element[0]);
			var startSubmission = function(event, data){
				if(submissionAllowed && data.uuid==scope.uuid && PaymentRedirectSingleton.startIfNotBusy()==true){
					element[0].submit();
					//console.log("started");
				}
			}
			var stopSubmission = function(event, data){
				submissionAllowed=false;
				PaymentRedirectSingleton.stop();
				//console.log("stoped");
			}
			scope.$on('$destroy',stopSubmission);
			scope.$on('SUBMIT_PAYMENT_FORM',startSubmission);

		}
	}
	;

})();

(function() {
	'use strict';

	angular.module('vobeApp').directive('adyenCheckout',
        adyenCheckout);

    adyenCheckout.$inject = ['$timeout'];

	function adyenCheckout($timeout) {
		var directive = {
			restrict : 'A',
			scope: {
                configuration : '=configuration'
			},
			link : linkFunc
		};

		return directive;

		function linkFunc(scope, element, attrs) {
			//check if form is in the visible DOM
			//https://stackoverflow.com/questions/5629684/how-to-check-if-element-exists-in-the-visible-dom/16820058#16820058
			//otherwise counter gets incremented but if form is not in visible DOM the submission gets cancelled without errors
			var elementInTheDom = document.body.contains(element[0]);

            if(elementInTheDom){
                // eslint-disable-next-line no-undef
                var checkout = new AdyenCheckout(scope.configuration);
                checkout.create('dropin', {openFirstPaymentMethod: true}).mount(element[0]);
            }

		}
	}
	;

})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('GroupVouchers', GroupVouchers);

    GroupVouchers.$inject = ['$resource'];

    function GroupVouchers ($resource) {
        var service = $resource('api/group/:code/vouchers', {}, {
            'query': {method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('GroupCategories', GroupCategories);

    GroupCategories.$inject = ['$resource'];

    function GroupCategories ($resource) {
        var service = $resource('api/group/:code/categories', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PropertyGroup', PropertyGroup);

    PropertyGroup.$inject = ['$resource'];

    function PropertyGroup ($resource) {
        var service = $resource('api/group/:code', {}, {
            'query': {method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('TheGuestbookFatalController', TheGuestbookFatalController);

    TheGuestbookFatalController.$inject = ['$scope', '$rootScope', '$state', '$stateParams'];
	
	function TheGuestbookFatalController($scope, $rootScope, $state, $stateParams) {
	    var vm = this;
	    //console.log("here");
	}
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('FatalController', FatalController);

    FatalController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', 'DetermineShopMoreState'];
	
	function FatalController($scope, $rootScope, $state, $stateParams,  DetermineShopMoreState) {
	    var vm = this;
	    vm.browseMore = browseMore;

	    
	    function browseMore(event){
	    	event.preventDefault();
	    	var shopMoreState = DetermineShopMoreState.getShopMoreState();
	    	$state.go(shopMoreState.name, shopMoreState.params);
	    };
	    
	}
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('confirmation', {
            parent: 'property',
            url: '/confirmation/:uuid?walletDebug',
            data: {
                authorities: [],
                autoscroll : true,
                pageTitle : 'confirmation.page.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/site/confirmation/confirmation.html',
                    controller: 'ConfirmationController',
                    controllerAs: 'vm'
                },
                'header@': {
                    templateUrl: 'app/layouts/header/header.html',
                    controller: 'BrandedHeaderController',
                    controllerAs: 'vm'
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.html',
                    controller: 'BrandedFooterController',
                    controllerAs: 'vm'
                },
                'cookies@': {
                    templateUrl: 'app/components/cookies-consent/cookies-banner.html',
                    controller: 'CookiesBannerController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$stateParams', '$translate', '$translatePartialLoader','currentProperty', function ($stateParams, $translate,$translatePartialLoader,currentProperty) {
                	var variant = "";
                	if($stateParams.contextType){
                		variant = "_"+$stateParams.contextType;
                	}
                	variant += "_"+currentProperty.hotelId;

                	$translatePartialLoader.addPart('confirmation'+variant);
                    $translatePartialLoader.addPart('vouchers'+variant);
                    return $translate.refresh();
                }],
                voucherConfig: function (VobeConfig, currentProperty) {
                    'ngInject';
                    //gather property ids
                    var propertyIds = [];
                    propertyIds.push(currentProperty.hotelId);
                    return VobeConfig.config.get({propertyIds: propertyIds}).$promise;
                },
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'confirmation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }],
                confirmation: function($stateParams, Confirmation) {
                    'ngInject';
                    return Confirmation.get({ uuid: $stateParams.uuid, ref: '' }).$promise;
                },
                brandingTemplateUUID: function(brandingTemplateUUID) {
                    'ngInject';
                    return brandingTemplateUUID;
                },
            }
        })

        ;
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('Confirmation', Confirmation);

    Confirmation.$inject = ['$resource'];

    function Confirmation ($resource) {
        var service = $resource('api/confirmation/:uuid', {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('ConfirmationController', ConfirmationController);

    function ConfirmationController($window, $scope, $rootScope, $state, $stateParams, $anchorScroll, confirmation, DetermineShopMoreState, currentProperty, CurrencyExchange, voucherConfig) {
        'ngInject';
		var vm = this;

		vm.confirmation = confirmation;
		vm.property = currentProperty;
	    vm.browseMore = browseMore;
	    vm.channel = $stateParams.channel;
        vm.voucherConfig = voucherConfig;

        //currency
        vm.currentCurrency = {
            code : undefined
        }
        var currentCurrency = CurrencyExchange.currencies.current;//current currency might be NULL if this is group engine
        if (currentCurrency) {
            vm.currentCurrency.code = currentCurrency.code;
        }

        $rootScope.$on('CurrencyExchangeProvider.changeCurrency', function(event, args) {
            vm.currentCurrency.code = args.code;
        });

	    function browseMore(event){
	    	event.preventDefault();
	    	var shopMoreState = DetermineShopMoreState.getShopMoreState();
	    	var params = shopMoreState.params;
	    	$state.go(shopMoreState.name, params);
	    }

	}

})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('VouchersViewSettings', VouchersViewSettings);

    VouchersViewSettings.$inject = ['$state', '$stateParams', '$localStorage'];

    function VouchersViewSettings ($state,$stateParams, $localStorage) {
        var service = {
        	setSettings : setSettings,
        	getSettings : getSettings,
            setCurrencySettings : setCurrencySettings,
            getCurrencySettings : getCurrencySettings
        }

        function setSettings(settings){
        	$localStorage.vouchersViewSettings = settings;
        }

        function getSettings(){
        	return $localStorage.vouchersViewSettings;
        }

        function setCurrencySettings(settings){
            $localStorage.currencySettings = settings;
        }

        function getCurrencySettings(){
            return $localStorage.currencySettings;
        }

        return service;

    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('VobeConfig', VobeConfig);

    VobeConfig.$inject = ['$resource'];

    function VobeConfig($resource) {

        return {
            config: $resource('api/config?propertyIds=:propertyIds', {}, {
                'query': {method: 'GET', isArray: false},
                'get': {
                    method: 'GET',
                    ignoreLoadingBar: true,
                    transformResponse: function (data) {
                        if(!data || (typeof data === 'string' && data.length==0)){
                            return data;
                        }
                        data = angular.fromJson(data);
                        return data;
                    }
                }
            }),
            emailConfig: $resource('api/config/email?propertyIds=:propertyIds', {}, {
                'query': {method: 'GET', isArray: false},
                'get': {
                    method: 'GET',
                    ignoreLoadingBar: true,
                    transformResponse: function (data) {
                        if(!data || (typeof data === 'string' && data.length==0)){
                            return data;
                        }
                        data = angular.fromJson(data);
                        return data;
                    }
                }
            })
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('GoogleTagManager', GoogleTagManager);

    GoogleTagManager.$inject = ['$resource'];

    function GoogleTagManager ($resource) {
        var service = $resource('api/property/:id/gtm', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if (data === '') {
                        return [];
                    } else {
                        data = angular.fromJson(data);
                        return data;
                    }
                }
            }
        });

        return service;
    }


    angular
        .module('vobeApp')
        .factory('GoogleTagManagerService', GoogleTagManagerService);

    GoogleTagManagerService.$inject = ['$q','GoogleTagManager', '$window', '$rootScope'];

    function GoogleTagManagerService($q,GoogleTagManager, $window, $rootScope) {

        var dataPromise;

        var initialized = false;

        var initializedTag = {};

        var service = {
            getCodes : getCodes,
            isInitialized : isInitialized,
            setInitialized : setInitialized,
            isInitializedTag : isInitializedTag,
            setInitializedTag : setInitializedTag
        };


        return service;

        function getCodes(options) {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = GoogleTagManager.get(options).$promise;
            }
            return dataPromise;
        }

        function isInitialized() {
            return initialized;
        }
        function setInitialized(boolean) {
            initialized = boolean;
        }
        function isInitializedTag(tagName) {
            return initializedTag[tagName];
        }
        function setInitializedTag(tagName, boolean) {
            initializedTag[tagName] = boolean;
        }
    }

})();

(function(){
    'use strict';

    angular.module('vobeApp')
        .provider('TagManager', function () {
            var pageEvent = '$routeChangeSuccess',
                ignoreFirstPageLoad = false,
                created = {},
                readFromRoute = false,
                delayScriptTag = false,
                trackUrlParams = false,
                removeRegExp,
                trackCount = 0,
                ad_storage = true,
                analytics_storage = true;

            this.setPageEvent = function (name) {
                pageEvent = name;
                return this;
            };

            this.trackUrlParams = function (val) {
                trackUrlParams = !!val;
                return this;
            };

            this.ignoreFirstPageLoad = function (val) {
                ignoreFirstPageLoad = !!val;
                return this;
            };

            this.delayScriptTag = function (val) {
                delayScriptTag = !!val;
                return this;
            };

            this.setAdStorage = function(val){
                ad_storage = val;
            };

            this.setAnalyticsStorage = function(val){
                analytics_storage = val;
            };

            this.setRemoveRegExp = function (regex) {
                if (regex instanceof RegExp) {
                    removeRegExp = regex;
                }
                return this;
            };

            this.$get = ['$document', // To read page title
                '$location', //
                '$log',      //
                '$rootScope',//
                '$window',   //
                '$injector', // To access ngRoute module without declaring a fixed dependency
                '$state',
                function ($document, $location, $log, $rootScope, $window, $injector, $state) {
                    var that = this;

                    /**
                     * Side-effect Free Helper Methods
                     **/

                    var isPropertyDefined = function (key, config) {
                        return angular.isObject(config) && angular.isDefined(config[key]);
                    };

                    var isPropertySetTo = function (key, config, value) {
                        return isPropertyDefined(key, config) && config[key] === value;
                    };

                    var generateCommandName = function (commandName, config) {
                        if (angular.isString(config)) {
                            return config + '.' + commandName;
                        }
                        return isPropertyDefined('name', config) ? (config.name + '.' + commandName) : commandName;
                    };

                    // Try to read route configuration and log warning if not possible
                    var $route = {};
                    if (readFromRoute) {
                        if (!$injector.has('$route')) {
                            $log.warn('$route service is not available. Make sure you have included ng-route in your application dependencies.');
                        } else {
                            $route = $injector.get('$route');
                        }
                    }

                    // Get url for current page
                    var getUrl = function () {
                        // Using ngRoute provided tracking urls
                        if (readFromRoute && $route.current && ('pageTrack' in $route.current)) {
                            return $route.current.pageTrack;
                        }

                        // Otherwise go the old way
                        var url = trackUrlParams ? $location.url() : $location.path();
                        return removeRegExp ? url.replace(removeRegExp, '') : url;
                    };

                    /**
                     * Private Methods
                     */

                    var _getProtocol = function (httpPostfix, httpsPostfix) {
                        var protocol = '',
                            isSslEnabled = document.location.protocol === 'https:',
                            isChromeExtension = document.location.protocol === 'chrome-extension:';
                        httpPostfix = angular.isString(httpPostfix) ? httpPostfix : '';
                        httpsPostfix = angular.isString(httpsPostfix) ? httpsPostfix : '';
                        if (httpPostfix !== '') {
                            protocol = 'http:' + httpPostfix;
                        }
                        if (isChromeExtension || (isSslEnabled && httpsPostfix !== '')) {
                            protocol = 'https:' + httpsPostfix;
                        }
                        return protocol;
                    };

                    this._registerScriptTags = function (gtmCode, dataLayerName) {
                        console.log('registerScriptTags', gtmCode, dataLayerName);
                        var document = $document[0],
                            protocol = _getProtocol(),
                            scriptSource;

                        if (created[gtmCode] && created[gtmCode].created === true) {
                            console.warn('Script tags already created');
                            return;
                        }

                        (function (w, d, s, l, i) {
                            w[l] = w[l] || [];
                            w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
                            var f = d.getElementsByTagName(s)[0],
                                j = d.createElement(s),
                                dl = l != 'dataLayer' ? '&l=' + l : '';
                            j.async = true;
                            j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
                            f.parentNode.insertBefore(j, f);
                        })($window, document, 'script', dataLayerName, gtmCode);

                        created[gtmCode] = { created: true};
                        return true;
                    };

                    /**
                     * Track page
                     https://developers.google.com/analytics/devguides/collection/gajs/
                     https://developers.google.com/analytics/devguides/collection/analyticsjs/pages
                     * @param url
                     * @param title
                     * @param custom
                     * @private
                     */
                    this._trackPage = function (url, title, custom) {
                        var dataLayer = $window.dataLayer = $window.dataLayer || [];
                        if (!ignoreFirstPageLoad || trackCount > 0) {
                            url = url ? url : getUrl();
                            title = title ? title : $document[0].title;
                            dataLayer.push({
                                event: 'ngRouteChange',
                                attributes: {
                                    route: url,
                                    title: title
                                }
                            });
                        }
                        trackCount++;
                    };

                    /**
                     * Send page view
                     * @param trackerName
                     * @private
                     */
                    this._pageView = function (trackerName) {
                        //console.log('pageview');
                    };

                    this._gtag = function (){
                        var dataLayer = $window.dataLayer = $window.dataLayer || [];
                        dataLayer.push(arguments);
                    };

                    this._pushVariable = function (variableName, variableValue){
                        var variable = {};
                        variable[variableName] = variableValue;
                        //this._gtag(variable);
                        var dataLayer = $window.dataLayer = $window.dataLayer || [];
                        dataLayer.push(variable);
                    };

                    this._updateConsent = function (ad_storage, analytics_storage, isUpdate) {

                        var allowAdStorage = typeof ad_storage === "undefined" ? this.ad_storage : ad_storage;
                        var allowAnalyticsStorage = typeof analytics_storage === "undefined" ? this.analytics_storage : analytics_storage;
                        this.ad_storage = allowAdStorage;
                        this.analytics_storage = allowAnalyticsStorage;

                    };

                    this._pushSimpleEvent = function(eventName){

                        var dataLayer = $window.dataLayer = $window.dataLayer || [];

                        dataLayer.push({
                            event: eventName
                        });
                    }

                    //activates purchase tracking
                    this._trackPurchase = function (transaction, shoppingCart, confirmationUuid) {
                        console.log('trackPurchase', transaction, shoppingCart, confirmationUuid)

                        var dataLayer = $window.dataLayer = $window.dataLayer || [];

                        var products = [];
                        var productsGa4 = [];
                        var customer = shoppingCart.customer;
                        var overallRevenue = 0;
                        var rateId = [];
                        angular.forEach(shoppingCart.shoppingCartItems.items, function (item, index) {
                            if (transaction.shoppingCartItemUUIDs.indexOf(item.uuid) > -1) {
                                var product = {
                                    name: item.itemName,
                                    id: item.itemId.toString(),
                                    price: item.itemTotalPrice,
                                    brand: item.owningProperty.propertyName,
                                    category: item.itemType,
                                    quantity: 1,
                                    currency: item.owningProperty.propertyCurrency
                                };

                                productsGa4.push({
                                    item_id: item.itemId.toString(),
                                    item_name: item.itemName,
                                    item_brand: item.owningProperty.propertyName,
                                    index: index+1,
                                    price: item.itemTotalPrice,
                                    quantity: 1,
                                    affiliation: item.owningProperty.propertyName,
                                    item_list_id: item.itemCategoryId ? item.itemCategoryId : 1,
                                    item_list_name: item.itemCategoryName ? item.itemCategoryName : 'All',
                                });

                                overallRevenue += item.itemTotalPrice;
                                rateId.push(item.itemId);
                                products.push(product);
                            }
                        });

                        dataLayer.push({
                            ecommerce: {
                                currencyCode: transaction.transactionCurrency,
                                purchase: {
                                    actionField: {
                                        id: confirmationUuid,
                                        revenue: transaction.transactionAmount,
                                        shipping: transaction.transactionShippingAmount
                                    },
                                    products: products,
                                    customer: customer
                                }
                            },
                            event: 'ngTrackPurchase'
                        });


                        //same datalayer push but with `eec:purchase` event name...
                        dataLayer.push({
                            ecommerce: {
                                currencyCode: transaction.transactionCurrency,
                                purchase: {
                                    actionField: {
                                        id: confirmationUuid,
                                        revenue: transaction.transactionAmount,
                                        shipping: transaction.transactionShippingAmount
                                    },
                                    products: products,
                                    customer: customer
                                }
                            },
                            event: 'eec:purchase'
                        });

                        //ga4
                        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
                        dataLayer.push({
                            event: "purchase",
                            ecommerce: {
                                transaction_id: confirmationUuid,
                                tax: 0,
                                value: transaction.transactionAmount,
                                currency: transaction.transactionCurrency,
                                items: productsGa4,
                            }
                        });
                    };



                    // creates the Google Analytics tracker
                    if (!delayScriptTag) {
                        this._registerScriptTags();
                    }

                    // activates page tracking
                    $rootScope.$on(pageEvent, function () {
                        that._trackPage();
                    });

                    return {
                        configuration: {
                            ignoreFirstPageLoad: ignoreFirstPageLoad,
                            pageEvent: pageEvent,
                            delayScriptTag: delayScriptTag,
                            trackUrlParams: trackUrlParams,
                            removeRegExp: removeRegExp
                        },
                        registerScriptTags: function (gtmCode, dataLayerName) {
                            return that._registerScriptTags(gtmCode, dataLayerName);
                        },
                        trackPage: function (url, title, custom) {
                            that._trackPage.apply(that, arguments);
                        },
                        pageView: function () {
                            that._pageView.apply(that, arguments);
                        },
                        set: function (name, value, trackerName) {
                            that._set.apply(that, arguments);
                        },
                        trackPurchase: function(transaction, shoppingCart, confirmationUuid) {
                            that._trackPurchase.apply(that, arguments);
                        },
                        updateConsent: function(ad_storage, analytics_storage, isUpdate) {
                            that._updateConsent.apply(that, arguments);
                        },
                        pushSimpleEvent: function(eventName) {
                            that._pushSimpleEvent.apply(that, arguments);
                        },
                        pushVariable: function(variableName, variableValue){
                            that._pushVariable.apply(that, arguments);
                        },
                        gtag : function(){
                            that._gtag.apply(that, arguments);
                        }

                    };
                }];
        })

})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('GoogleAnalyticsCodes', GoogleAnalyticsCodes);

    GoogleAnalyticsCodes.$inject = ['$resource'];

    function GoogleAnalyticsCodes ($resource) {
        var service = $resource('api/property/:id/ga', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }


    angular
        .module('vobeApp')
        .factory('GoogleAnalyticsCodesService', GoogleAnalyticsCodesService);

    GoogleAnalyticsCodesService.$inject = ['$q','GoogleAnalyticsCodes'];

    function GoogleAnalyticsCodesService($q,GoogleAnalyticsCodes) {

        var dataPromise;

        var initialized = false;
        var initializedWithoutStorage = true;

        var service = {
            getCodes : getCodes,
            isInitialized : isInitialized,
            setInitialized : setInitialized,
            isInitializedWithoutStorage : isInitializedWithoutStorage,
            setInitializedWithoutStorage : setInitializedWithoutStorage
        };

        return service;

        function getCodes(options) {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = GoogleAnalyticsCodes.get(options).$promise;
            }
            return dataPromise;
        }

        function isInitialized() {
            return initialized;
        }
        function setInitialized(boolean) {
        	initialized = boolean;
        }
        function isInitializedWithoutStorage() {
            return initialized;
        }
        function setInitializedWithoutStorage(boolean) {
            initialized = boolean;
        }
    }



})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('GoogleAdwords', GoogleAdwords);

    GoogleAdwords.$inject = ['$resource'];

    function GoogleAdwords ($resource) {
        var service = $resource('api/property/:hotelCode/adwords', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: false,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)) {
                        return {};
                    } else {
                        data = angular.fromJson(data);
                        return data;
                    }
                }
            }
        });

        return service;
    }

    angular
        .module('vobeApp')
        .factory('GoogleAdwordsService', GoogleAdwordsService);

    GoogleAdwordsService.$inject = ['$q','GoogleAdwords', '$window', '$rootScope'];

    function GoogleAdwordsService($q,GoogleAdwords, $window, $rootScope) {

        var dataPromise;

        var initialized = false,
            account = {
                google_conversion_id: '',
                google_conversion_language: '',
                google_conversion_format: '',
                google_conversion_color: '',
                google_conversion_label: '',
                google_conversion_value: 0,
                google_remarketing_only: false,
                google_conversion_currency: 'EUR'
            };

        var service = {
            getCode : getCode,
            isInitialized : isInitialized,
            setInitialized : setInitialized,
            registerScript: registerScript,
            googleTrackConversion: googleTrackConversion,
            setAccount: setAccount
        };


        return service;

        function getCode(options) {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = GoogleAdwords.get(options).$promise;
            }
            return dataPromise;
        }

        function isInitialized() {
            return initialized;
        }
        function setInitialized(boolean) {
            initialized = boolean;
        }

        function setAccount(adwordsAccount) {
            account.google_conversion_color = adwordsAccount.conversionColour;
            account.google_conversion_format = adwordsAccount.conversionFormat;
            account.google_conversion_id = adwordsAccount.conversionId;
            account.google_conversion_label = adwordsAccount.conversionLabel;
            account.google_conversion_language = adwordsAccount.conversionLanguage;
        }

        function registerScript() {
            (function (w, d, s) {
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s);
                j.src = '//www.googleadservices.com/pagead/conversion_async.js';
                f.parentNode.insertBefore(j, f);
            })($window, document, 'script');
        }

        function googleTrackConversion(value, currency, orderId) {
            if (this.isInitialized()) {
                account.google_conversion_value = value;
                account.google_conversion_currency = currency
                account.google_conversion_order_id = orderId;
                $window.google_trackConversion(account);
            }
        };
    }

})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('DetermineShopMoreState', DetermineShopMoreState);

    function DetermineShopMoreState ($localStorage) {
        'ngInject';
        var service = {
        	setShopMoreState : setShopMoreState,
        	getShopMoreState : getShopMoreState
        }

        function setShopMoreState(state){
            $localStorage.shopMoreState = state;
        }

        function getShopMoreState(){
        	//var lang = $translate.storage().get('NG_TRANSLATE_LANG_KEY');
        	//console.log(lang);
        	var state = $localStorage.shopMoreState;
        	if(state && state.params){
        		//state.params.lang = null;
        	}
        	return state;

        }

        return service;

    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('DetermineItemLanguage', DetermineItemLanguage);

    DetermineItemLanguage.$inject = ['$state', '$stateParams', '$translate'];

    function DetermineItemLanguage ($state,$stateParams, $translate) {
        var service = {
        	getLanguage : getLanguage
        }
        
        function getLanguage(item){

        	var language = $translate.use();
    		var variant = "";
    		if($stateParams.contextType){
    			variant = "_"+$stateParams.contextType;
    		}
    		if(item && item.owningProperty && item.owningProperty.propertyId){
    			variant += (variant.length==0 ? "_" : "") + item.owningProperty.propertyId;
    		}
    		if(item && item.propertyId){
    			variant += (variant.length==0 ? "_" : "") + item.propertyId;
    		}

        	return language+variant;
        }

        return service;
        
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('CountriesWithoutPostcodeService', CountriesWithoutPostcodeService);

    CountriesWithoutPostcodeService.$inject = ['$resource'];

    function CountriesWithoutPostcodeService ($resource) {
        var service = $resource('/content/json/countries-without-postcode.json', {}, {
            'query': {method: 'GET', isArray: false,ignoreLoadingBar: true},
            'get': {
                method: 'GET',
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;

    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('CountriesService', CountriesService);

    CountriesService.$inject = ['$resource'];

    function CountriesService ($resource) {
        var service = $resource('/i18n/en/countries.json', {}, {
            'query': {method: 'GET', isArray: false, ignoreLoadingBar: true},
            'get': {
                method: 'GET',
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;

    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('CldrDataService', CldrDataService);

    CldrDataService.$inject = ['$resource'];

    function CldrDataService ($resource) {
        var service = $resource('/i18n/cldr-data/main/:language/:name.json', {language:'@language',name:'@name'}, {
            'getMain': {
                method: 'GET',
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'getSupplemental': {
                url:'/i18n/cldr-data/supplemental/:name.json',
                method: 'GET',
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;

    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('VouchersProcessService', VouchersProcessService);

    VouchersProcessService.$inject = ['$q', '$http', 'PromotionCodeService', 'ShoppingCartItemDetailsService'];

    function VouchersProcessService($q, $http, PromotionCodeService, ShoppingCartItemDetailsService) {

        var dataPromise;

        var service = {
            processGroupVouchers : processGroupVouchers,
            setPoolMinMaxValues : setPoolMinMaxValues,
            extractPageHolder: extractPageHolder
        };

        return service;

        function processGroupVouchers(groupVouchers,currentProperty,shoppingCart,voucherConfig,propertyGiftCards) {
            //1. if there are discounts, filter them out here, it's not nice to do it out in the controller or html via filters... trust me.
            if (!shoppingCart.shoppingCartDiscounts.empty) {
                var voucherPoolsGenerated = [];
                angular.forEach(groupVouchers.wrapper.voucherPools, function(voucherPool, key) {
                    var voucherFirstKey = Object.keys(voucherPool.vouchers)[0];
                    var voucherId = voucherPool.vouchers[voucherFirstKey].id;
                    var voucherHotelId = voucherPool.vouchers[voucherFirstKey].hotelId;
                    var isVoucherApplicable = false;
                    //loop all promos
                    angular.forEach(shoppingCart.shoppingCartDiscounts.discounts,function(d,dIndex){
                        if(!d.hideInapplicable){
                            isVoucherApplicable = true;//if discount is not hiding voucher, then it's applicable
                        }
                        if (d.propertyId && d.propertyId!=null && d.propertyId>0 && d.propertyId!=voucherHotelId){
                            //voucher is applicable if belongs to different property
                            isVoucherApplicable = true;
                        }
                        else if (d.filteredItemIds.includes(voucherId)) {
                            //voucher is applicable if is assigned to this discount
                            isVoucherApplicable = true;
                        }
                    });
                    if(isVoucherApplicable){
                        voucherPoolsGenerated.push(voucherPool);
                    }
                });
                groupVouchers.wrapper.voucherPools = voucherPoolsGenerated;
                groupVouchers.voucherPoolsCount = voucherPoolsGenerated.length;
                //TODO: voucherClass ?
            }

            var generatedCashPoolsWithGiftCard = [];
            var generatedCashPoolsFeatured = [];
            var featuredVouchers = []; //these are amounts
            var propertyConfig = voucherConfig[currentProperty.hotelId] || {};

            if (propertyConfig && propertyConfig.configMap && propertyConfig.configMap.featuredCashVouchers) {
                var value = propertyConfig.configMap.featuredCashVouchers.replace(/ /g, '');
                featuredVouchers = value.split(',');
            }
            //iterate each pool
            angular.forEach(groupVouchers.wrapper.voucherPools, function(voucherPool, pkey) {

                //GENERATE MIN/MAX VALUES
                voucherPool.minValue = 0;
                voucherPool.maxValue = 0;
                voucherPool.minValueAfterDiscount = 0;
                voucherPool.maxValueAfterDiscount = 0;
                voucherPool.currency = currentProperty.hotelCurrency;

                if(voucherPool.type=='cash'){
                    var count = 0;
                    var firstVoucher;
                    angular.forEach(voucherPool.vouchers, function(voucher, vkey) {
                        count++;
                        firstVoucher = firstVoucher || voucher;
                    });
                    if(count==1){
                        var generatedCashVouchers = {};
                        //generate cash vouchers, this can be removed if cash will be using package card and dialog components
                        var min = firstVoucher.totalRate.priceMin;
                        var max = (firstVoucher.totalRate.priceMax == 0 ? firstVoucher.totalRate.priceMin : firstVoucher.totalRate.priceMax);
                        var increment = firstVoucher.totalRate.increment ? firstVoucher.totalRate.increment : 25;

                        var base = 0;
                        for(var nextAmount = 0; nextAmount<=min; nextAmount = nextAmount+increment){
                            base = nextAmount;
                        }
                        var generatedCashVouchersIndex = 0;
                        for(var amount = min, iteration=0; amount <= max; amount=(iteration==0 ? base : amount )+increment, iteration++){
                            var generatedVoucher = angular.copy(firstVoucher);
                            //change price
                            generatedVoucher.voucherPrice = amount;
                            var appliedPromotionCode = PromotionCodeService.findApplicablePromo(shoppingCart, currentProperty, true, generatedVoucher);
                            var amountDiscount = ShoppingCartItemDetailsService.calculateSelectedAmountAfterDiscount(amount,appliedPromotionCode);

                            //change total rate
                            generatedVoucher.totalRate.priceMin=amount;
                            generatedVoucher.totalRate.priceMax=amount;
                            generatedVoucher.totalRateAfterDiscount.priceMin=amountDiscount;
                            generatedVoucher.totalRateAfterDiscount.priceMax=amountDiscount;
                            generatedVoucher.totalRate.increment=firstVoucher.totalRate.increment ? firstVoucher.totalRate.increment : 0;
                            //change total rate after discount
                            generatedVoucher.totalRateChannel.priceMin=amount;
                            generatedVoucher.totalRateChannel.priceMax=amount;
                            generatedVoucher.totalRateChannelAfterDiscount.priceMin=amountDiscount;
                            generatedVoucher.totalRateChannelAfterDiscount.priceMax=amountDiscount;
                            generatedVoucher.totalRateChannel.increment=firstVoucher.totalRate.increment ? firstVoucher.totalRate.increment : 0;//TODO fix after adding inct to channel rates in DB
                            //because map key must be unique, with cash-wildcard it's just index (as voucher id is the same)
                            generatedCashVouchers[generatedCashVouchersIndex]=generatedVoucher;
                            generatedCashVouchersIndex++;
                            if(generatedCashVouchersIndex>=500){
                                break;
                            }
                        }
                        voucherPool.vouchers = generatedCashVouchers;
                    }
                }


                //todo: names here?
                //voucherPool.cashVoucherName = "Monetary";
                angular.forEach(voucherPool.vouchers, function(voucher, vkey) {

                    setPoolMinMaxValues(voucherPool, voucher);
                    //fix currency
                    voucherPool.currency = voucher.currency;
                    //fix name
                    //voucher.currency + ' ' + $filter('number')(voucher.totalRate.minvoucher, 2);

                    //generate pool with featured cash voucher
                    if(~featuredVouchers.indexOf('' + voucher.totalRate.priceMin)){
                        var generatedFeaturedPool={};
                        generatedFeaturedPool.minValue = voucher.totalRate.priceMin;
                        generatedFeaturedPool.maxValue = (voucher.totalRate.priceMax == 0 ? voucher.totalRate.priceMin : voucher.totalRate.priceMax);
                        generatedFeaturedPool.minValueAfterDiscount = voucher.totalRateAfterDiscount.priceMin;
                        generatedFeaturedPool.maxValueAfterDiscount = (voucher.totalRateAfterDiscount.priceMax == 0 ? voucher.totalRateAfterDiscount.priceMin : voucher.totalRateAfterDiscount.priceMax);
                        generatedFeaturedPool.currency = voucher.currency;
                        generatedFeaturedPool.vouchers = [];
                        generatedFeaturedPool.vouchers.push(voucher);
                        generatedFeaturedPool.sequence = voucher.totalRate.priceMin;
                        generatedFeaturedPool.cashVoucherName = voucherPool.cashVoucherName;
                        generatedFeaturedPool.type = voucherPool.type;
                        generatedFeaturedPool.featured = true;
                        generatedCashPoolsFeatured.push(generatedFeaturedPool);
                    }
                });

                //fix sequence
                angular.forEach(voucherPool.vouchers, function(voucher, vkey) {
                    if (voucher.sequence !== 999) {
                        voucherPool.sequence = voucher.sequence;
                    } else {
                        voucherPool.sequence = voucherPool.minValue;
                    }
                });
                //voucherPool.sequence = voucherPool.minValue;
                if(propertyGiftCards){
                    angular.forEach(propertyGiftCards, function(giftCard, gkey) {
                        if(voucherPool.type=='cash' || voucherPool.type=='cash-wildcard'){
                            var generatedGiftCardPool={};
                            generatedGiftCardPool.minValue = voucherPool.minValue;
                            generatedGiftCardPool.maxValue = voucherPool.maxValue;
                            generatedGiftCardPool.minValueAfterDiscount = voucherPool.minValueAfterDiscount;
                            generatedGiftCardPool.maxValueAfterDiscount = voucherPool.maxValueAfterDiscount;
                            generatedGiftCardPool.currency = voucherPool.currency;
                            generatedGiftCardPool.vouchers = voucherPool.vouchers;
                            generatedGiftCardPool.sequence = voucherPool.minValue;
                            generatedGiftCardPool.cashVoucherName = voucherPool.cashVoucherName;
                            generatedGiftCardPool.type = voucherPool.type;
                            generatedGiftCardPool.giftCard = giftCard;
                            generatedCashPoolsWithGiftCard.push(generatedGiftCardPool);
                        }
                    });
                }
            });

            //add generated gift cards
            if(generatedCashPoolsWithGiftCard.length>0){
                //add at the begining
                groupVouchers.wrapper.voucherPools = generatedCashPoolsWithGiftCard.concat(groupVouchers.wrapper.voucherPools);
            }
            if(generatedCashPoolsFeatured.length>0){
                //add at the begining
                groupVouchers.wrapper.voucherPools = generatedCashPoolsFeatured.concat(groupVouchers.wrapper.voucherPools);
            }

            groupVouchers.voucherPoolsCount = (groupVouchers && groupVouchers.wrapper && groupVouchers.wrapper.voucherPools) ? groupVouchers.wrapper.voucherPools.length : 0;

        }

        function extractPageHolder(groupVouchers){

            return {
                nrOfElements: groupVouchers.nrOfElements || groupVouchers.voucherPoolsCount,
                firstElementOnPage: groupVouchers.firstElementOnPage || 0,
                lastElementOnPage: groupVouchers.lastElementOnPage || 0,
                firstLinkedPage: groupVouchers.firstLinkedPage || 0,
                lastLinkedPage: groupVouchers.lastLinkedPage || 0,
                maxLinkedPages: groupVouchers.maxLinkedPages || 0,
                page: groupVouchers.page || 0,
                pageCount: groupVouchers.pageCount || 0,
                pageSize: groupVouchers.pageSize || 0
            }
        }


        function setPoolMinMaxValues(voucherPool, voucher){
            voucherPool.minValue = voucherPool.minValue || 0;
            voucherPool.maxValue = voucherPool.maxValue || 0;
            voucherPool.minValueAfterDiscount = voucherPool.minValueAfterDiscount || 0;
            voucherPool.maxValueAfterDiscount = voucherPool.maxValueAfterDiscount || 0;
            //get min and max
            if (voucherPool.minValue == 0 || voucherPool.minValue > voucher.totalRate.priceMin) {
                voucherPool.minValue = voucher.totalRate.priceMin;
            }
            if (voucherPool.maxValue == 0 || voucherPool.maxValue <(voucher.totalRate.priceMax == 0 ? voucher.totalRate.priceMin : voucher.totalRate.priceMax)) {
                voucherPool.maxValue = (voucher.totalRate.priceMax == 0 ? voucher.totalRate.priceMin : voucher.totalRate.priceMax);
            }
            //get min and max after discount
            if (
                voucherPool.minValueAfterDiscount == 0 ||
                voucherPool.minValueAfterDiscount > voucher.totalRateAfterDiscount.priceMin
            ) {
                voucherPool.minValueAfterDiscount = voucher.totalRateAfterDiscount.priceMin;
            }
            if (
                voucherPool.maxValueAfterDiscount == 0 ||
                voucherPool.maxValueAfterDiscount < (voucher.totalRateAfterDiscount.priceMax == 0 ? voucher.totalRateAfterDiscount.priceMin : voucher.totalRateAfterDiscount.priceMax)
            ) {
                voucherPool.maxValueAfterDiscount = (voucher.totalRateAfterDiscount.priceMax == 0 ? voucher.totalRateAfterDiscount.priceMin : voucher.totalRateAfterDiscount.priceMax);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="dev-ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'JhiTrackerService'];

    function Principal ($q, Account, JhiTrackerService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                JhiTrackerService.connect();
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .directive('hasNotAuthority', hasNotAuthority);

    hasNotAuthority.$inject = ['Principal'];

    function hasNotAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                            	setHidden();
                            } else {
                            	setVisible();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' , 'JhiTrackerService'];

    function AuthServerProvider ($http, $localStorage , JhiTrackerService) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).then(function (response) {
                return response;
            });
        }

        function logout () {
            JhiTrackerService.disconnect();


            // logout from the server
            $http.post('api/logout').then(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'JhiTrackerService'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, JhiTrackerService) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState && $rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    JhiTrackerService.sendActivity();
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .directive('verticalButtons', verticalButtons);
    
    verticalButtons.$inject = ['$window', '$rootScope'];

    function verticalButtons($window, $rootScope) {
        var directive = {
            restrict: 'C',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
        	
        	var back2top_offset = 220;
		    var back2top_duration = 500;
		    
		    $window.jQuery(window).scroll(function() {
		        if ($window.jQuery(this).scrollTop() > back2top_offset) {
		        	$window.jQuery(element).fadeIn(back2top_duration);
		        } else {
		        	$window.jQuery(element).fadeOut(back2top_duration);
		        }
		    });
		    
		    $window.jQuery(element).click(function(event) {
		        //event.preventDefault();
		        $window.jQuery('html, body').animate({scrollTop: 0}, back2top_duration);
		        //return false;
		    });
		    
		    
		    $window.jQuery(element).find('.open-shopping-cart-dropdown').click(function(event) {
		        //event.preventDefault();
		        $rootScope.$broadcast('openShoppingCartDropdown'); 
		        //return false;
		    }); 
		    
		    
        	        	
        }
    }
})();
(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$rootScope','$state', '$location', 'Auth', 'Principal', 'ProfileService', 'LoginService'];

    function NavbarController ($rootScope,$state,$location, Auth, Principal, ProfileService, LoginService) {
        var vm = this;        
        
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        vm.stateParams = $location.search();

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }
        
        vm.openShoppingCartNavbar = openShoppingCartNavbar;
        function openShoppingCartNavbar() {
        	$rootScope.$emit('openShoppingCartDropdown');
        }        
        
        

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('HeroController', HeroController);

    HeroController.$inject = ['$state','$rootScope'];

    function HeroController ($state, $rootScope) {
        var vm = this;
        vm.property;
        
        $rootScope.$on('propertySelected', function(event, args) {
        	vm.property = args.property;
        }); 
        
    }
    
    
    
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('BrandedHeaderController', BrandedHeaderController);

    BrandedHeaderController.$inject = ['$state', '$stateParams', '$rootScope','brandingTemplateUUID', 'currentLanguage', 'currentProperty', '$location'];

    function BrandedHeaderController ($state, $stateParams, $rootScope, brandingTemplateUUID, currentLanguage, currentProperty, $location) {
        var vm = this;
        vm.property = currentProperty;

        $rootScope.$on('propertySelected', function(event, args) {
        	vm.property = args.property;
        });

        vm.brandingUUID = brandingTemplateUUID.uuid;
        vm.currentLanguage = (currentLanguage || 'en' ).split('_')[0].split('-')[0];
        vm.channel = $stateParams.channel || '';
        vm.url = $location.url();

        if(!vm.brandingUUID){
        	vm.headerUrl = 'app/site/property/hero-property.html';
        }
        else{
        	vm.headerUrl = '/assets/property/header?uuid='+vm.brandingUUID+'&includeStyle=true&userLang='+vm.currentLanguage+'&channel='+vm.channel+'&propertyId='+vm.property.hotelId;
        }
    }



})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('LegalFooterController', LegalFooterController);

    LegalFooterController.$inject = ['$state','$rootScope', 'ModalService', '$transitions', '$window'];

    function LegalFooterController ($state, $rootScope, ModalService, $transitions, $window) {
        var vm = this;
        vm.today = new Date();

        vm.isGDPR = ($window && $window.IN1 && $window.IN1.isGDPR) ? $window.IN1.isGDPR : false;

        var modal;

        vm.openCookiePreferencesTab = function(){

            modal = ModalService.open({
                templateUrl: 'app/components/cookies-consent/cookies-preferences-modal.html',
                controller: 'CookiesBannerController',
                controllerAs: 'vm',
                backdrop: true,
                animation: false,
                size: 'lg',
                resolve: {

                },
            });

            $state.cookiePreferencesModal = modal;

        }

    }



})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('BrandedFooterController', BrandedFooterController);

    BrandedFooterController.$inject = ['$state','$stateParams','$rootScope','brandingTemplateUUID','currentLanguage'];

    function BrandedFooterController ($state, $stateParams, $rootScope, brandingTemplateUUID, currentLanguage) {
        var vm = this;
        vm.property;

        $rootScope.$on('propertySelected', function(event, args) {
        	vm.property = args.property;
        });

        vm.brandingUUID = brandingTemplateUUID.uuid;
        vm.currentLanguage = (currentLanguage || 'en' ).split('_')[0].split('-')[0];
        vm.channel = $stateParams.channel || '';

        if(!vm.brandingUUID){
        	vm.footerUrl = '';
        }
        else{
        	vm.footerUrl = '/assets/property/footer?uuid='+vm.brandingUUID+'&userLang='+vm.currentLanguage+'&channel='+vm.channel;
        }
    }



})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('VoucherSaleConfirmationDialogController', VoucherSaleConfirmationDialogController);

    VoucherSaleConfirmationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VoucherSaleConfirmation', 'VobeUser', 'VoucherSale'];

    function VoucherSaleConfirmationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VoucherSaleConfirmation, VobeUser, VoucherSale) {
        var vm = this;

        vm.voucherSaleConfirmation = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.vobeusers = VobeUser.query();
        vm.vouchersales = VoucherSale.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.voucherSaleConfirmation.id !== null) {
                VoucherSaleConfirmation.update(vm.voucherSaleConfirmation, onSaveSuccess, onSaveError);
            } else {
                VoucherSaleConfirmation.save(vm.voucherSaleConfirmation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('vobeApp:voucherSaleConfirmationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdAt = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('VoucherSaleConfirmationDetailController', VoucherSaleConfirmationDetailController);

    VoucherSaleConfirmationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'VoucherSaleConfirmation', 'VobeUser', 'VoucherSale'];

    function VoucherSaleConfirmationDetailController($scope, $rootScope, $stateParams, previousState, entity, VoucherSaleConfirmation, VobeUser, VoucherSale) {
        var vm = this;

        vm.voucherSaleConfirmation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('vobeApp:voucherSaleConfirmationUpdate', function(event, result) {
            vm.voucherSaleConfirmation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('VoucherSaleConfirmationDeleteController',VoucherSaleConfirmationDeleteController);

    VoucherSaleConfirmationDeleteController.$inject = ['$uibModalInstance', 'entity', 'VoucherSaleConfirmation'];

    function VoucherSaleConfirmationDeleteController($uibModalInstance, entity, VoucherSaleConfirmation) {
        var vm = this;

        vm.voucherSaleConfirmation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VoucherSaleConfirmation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('voucher-sale-confirmation', {
            parent: 'entity',
            url: '/voucher-sale-confirmation?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'vobeApp.voucherSaleConfirmation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/voucher-sale-confirmation/voucher-sale-confirmations.html',
                    controller: 'VoucherSaleConfirmationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('voucherSaleConfirmation');
                    return $translate.refresh();
                }]
            }
        })
        .state('voucher-sale-confirmation-detail', {
            parent: 'entity',
            url: '/voucher-sale-confirmation/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'vobeApp.voucherSaleConfirmation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/voucher-sale-confirmation/voucher-sale-confirmation-detail.html',
                    controller: 'VoucherSaleConfirmationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('voucherSaleConfirmation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VoucherSaleConfirmation', function($stateParams, VoucherSaleConfirmation) {
                    return VoucherSaleConfirmation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'voucher-sale-confirmation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('voucher-sale-confirmation-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voucher-sale-confirmation/voucher-sale-confirmation-dialog.html',
                    controller: 'VoucherSaleConfirmationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VoucherSaleConfirmation', function(VoucherSaleConfirmation) {
                            return VoucherSaleConfirmation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('voucher-sale-confirmation.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voucher-sale-confirmation/voucher-sale-confirmation-dialog.html',
                    controller: 'VoucherSaleConfirmationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                createdAt: null,
                                confirmationUuid: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('voucher-sale-confirmation', null, { reload: 'voucher-sale-confirmation' });
                }, function() {
                    $state.go('voucher-sale-confirmation');
                });
            }]
        })
        .state('voucher-sale-confirmation.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voucher-sale-confirmation/voucher-sale-confirmation-dialog.html',
                    controller: 'VoucherSaleConfirmationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VoucherSaleConfirmation', function(VoucherSaleConfirmation) {
                            return VoucherSaleConfirmation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('voucher-sale-confirmation', null, { reload: 'voucher-sale-confirmation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('voucher-sale-confirmation.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voucher-sale-confirmation/voucher-sale-confirmation-delete-dialog.html',
                    controller: 'VoucherSaleConfirmationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VoucherSaleConfirmation', function(VoucherSaleConfirmation) {
                            return VoucherSaleConfirmation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('voucher-sale-confirmation', null, { reload: 'voucher-sale-confirmation' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('VoucherSaleConfirmation', VoucherSaleConfirmation);

    VoucherSaleConfirmation.$inject = ['$resource', 'DateUtils'];

    function VoucherSaleConfirmation ($resource, DateUtils) {
        var resourceUrl =  'api/voucher-sale-confirmations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdAt = DateUtils.convertDateTimeFromServer(data.createdAt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('VoucherSaleConfirmationSearch', VoucherSaleConfirmationSearch);

    VoucherSaleConfirmationSearch.$inject = ['$resource'];

    function VoucherSaleConfirmationSearch($resource) {
        var resourceUrl =  'api/_search/voucher-sale-confirmations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('VoucherSaleConfirmationController', VoucherSaleConfirmationController);

    VoucherSaleConfirmationController.$inject = ['$scope', '$state', 'VoucherSaleConfirmation', 'VoucherSaleConfirmationSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function VoucherSaleConfirmationController ($scope, $state, VoucherSaleConfirmation, VoucherSaleConfirmationSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                VoucherSaleConfirmationSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                VoucherSaleConfirmation.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.voucherSaleConfirmations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSiteTranslationPropertyPart', PublicSiteTranslationPropertyPart);

    PublicSiteTranslationPropertyPart.$inject = ['$resource'];

    function PublicSiteTranslationPropertyPart ($resource) {
        var resourceUrl =  'api/public-site-translations-properties/part';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { 
            	method:'POST',
                isArray: true,
                transformResponse: function (data) {
	                if (data) {
	                	data = angular.fromJson(data);
	                }
	                return data;
                }	
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteTranslationPropertyPartController', PublicSiteTranslationPropertyPartController);

    PublicSiteTranslationPropertyPartController.$inject = ['$scope', '$state', '$stateParams', 'PublicSiteTranslation','PublicSiteTranslationPart','PublicSiteTranslationPropertyPart','PublicSitePartKeys', 'PublicSiteTranslationSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'siteLanguages','translations','sitePart','hotelTranslations','currentProperty'];

    function PublicSiteTranslationPropertyPartController ($scope, $state, $stateParams, PublicSiteTranslation, PublicSiteTranslationPart, PublicSiteTranslationPropertyPart, PublicSitePartKeys, PublicSiteTranslationSearch, ParseLinks, AlertService, pagingParams, paginationConstants, siteLanguages, translations, sitePart, hotelTranslations, currentProperty) {
        var vm = this;        
        
        vm.sitePart = sitePart;
        vm.partName = sitePart.publicSitePartName;
        vm.siteLanguages = siteLanguages;
        vm.currentProperty = currentProperty;
        vm.translations = translations;
        vm.hotelTranslations = hotelTranslations;
        vm.getMessage = getMessage;
        vm.getHotelMessage = getHotelMessage;
        vm.calculateIndex = calculateIndex;
        vm.saveForm = saveForm;
        vm.formTranslations = [];
        
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
        	PublicSitePartKeys.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                partName: sitePart.publicSitePartName
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.publicSitePartKeys = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                siteName: sitePart.publicSiteName,
                partName: sitePart.publicSitePartName,
                publicSitePartRelationshipId : sitePart.id,//needed for state resolve
                propertyId : currentProperty.hotelId//needed for state resolve
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
        
        
        function calculateIndex(outerIndex,innerIndex){
        	return (outerIndex*vm.siteLanguages.length)+innerIndex;
        }
        
        
        function getMessage(publicSitePartKeyId,publicSiteLanguageId){
        	var translation;
        	angular.forEach(vm.translations,function(value,k){
        		
        		if(value.publicSiteLanguageId==publicSiteLanguageId 
        				&& value.publicSitePartKeyId==publicSitePartKeyId){
        			translation = value;
        		}
        		
        	});
        	
        	return translation;
        }
        
        function getHotelMessage(publicSitePartKeyId,publicSiteLanguageId){
        	var translation;
        	angular.forEach(vm.hotelTranslations,function(value,k){
        		
        		if(value.publicSiteLanguageId==publicSiteLanguageId 
        				&& value.publicSitePartKeyId==publicSitePartKeyId){
        			translation = value;
        		}
        		
        	});
        	
        	return translation;
        }        
        
        
        function saveForm(event){
        	event.preventDefault();
        	//console.log(vm.formTranslations);
        	saveAll();
        }
        
        
        function saveAll () {
        	PublicSiteTranslationPropertyPart.update({
        		translations : vm.formTranslations
        		}, onSuccess, onError);
            function onSuccess(data, headers) {
            	$state.transitionTo($state.current, $stateParams, {reload:true, inherit:true})
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }        
    }
})();

(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSiteTranslationPart', PublicSiteTranslationPart);

    PublicSiteTranslationPart.$inject = ['$resource'];

    function PublicSiteTranslationPart ($resource) {
        var resourceUrl =  'api/public-site-translations/part';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { 
            	method:'POST',
                isArray: true,
                transformResponse: function (data) {
	                if (data) {
	                	data = angular.fromJson(data);
	                }
	                return data;
                }	
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('translation', {
            parent: 'entity',
            url: '/translation?page&sort&search&publicSitePartRelationshipId&propertyId',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TRANSLATOR'],
                pageTitle: 'vobeApp.publicSitePartKey.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/translations/public-site-translation.html',
                    controller: 'PublicSiteTranslationPartController',
                    controllerAs: 'vm'
                },
                'header@': {}
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
            	sitePart : function($transition$, PublicSitePartRelationship){
            	    'ngInject';
            		return PublicSitePartRelationship.get({id :$transition$.params().publicSitePartRelationshipId}).$promise;
            	},
            	siteLanguages : ['PublicSiteLanguages', function(PublicSiteLanguages){
            		return PublicSiteLanguages.get().$promise;
            	}],
            	translations : function(PublicSiteTranslationPart,sitePart){
            	    'ngInject';
            		return PublicSiteTranslationPart.get({partName : sitePart.publicSitePartName, siteName : sitePart.publicSiteName}).$promise;
            	},
                pagingParams: function ($transition$, PaginationUtil) {
            	    'ngInject';
                    return {
                        page: PaginationUtil.parsePage($transition$.params().page),
                        sort: $transition$.params().sort,
                        predicate: PaginationUtil.parsePredicate($transition$.params().sort),
                        ascending: PaginationUtil.parseAscending($transition$.params().sort),
                        publicSitePartRelationshipId: $transition$.params().publicSitePartRelationshipId
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePartKey');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('translation-browse-property', {
            parent: 'entity',
            url: '/translation/browseProperty?publicSitePartRelationshipId&propertyId',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TRANSLATOR'],
                pageTitle: 'vobeApp.publicSitePartKey.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/translations/public-site-browse-property.html',
                    controller: 'PublicSiteBrowsePropertyController',
                    controllerAs: 'vm'
                },
                'header@': {}
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePartKey');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('translation-browse-part', {
            parent: 'entity',
            url: '/translation/browsePart?page&sort&search&publicSitePartRelationshipId&propertyId',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TRANSLATOR'],
                pageTitle: 'vobeApp.publicSitePartRelationship.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-part-relationship/public-site-part-relationships.html',
                    controller: 'PublicSitePartRelationshipController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: function ($transition$, PaginationUtil) {
                    'ngInject';
                    return {
                        page: PaginationUtil.parsePage($transition$.params().page),
                        sort: $transition$.params().sort,
                        predicate: PaginationUtil.parsePredicate($transition$.params().sort),
                        ascending: PaginationUtil.parseAscending($transition$.params().sort),
                        search: $transition$.params().search
                    };
                },
                translatePartialLoader: function ($translate, $translatePartialLoader) {
                    'ngInject';
                    $translatePartialLoader.addPart('publicSitePartRelationship');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }
            }
        })
        .state('translation.property', {
            url: '/property',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TRANSLATOR'],
                pageTitle: 'vobeApp.publicSitePartKey.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/translations/public-site-translation-property.html',
                    controller: 'PublicSiteTranslationPropertyPartController',
                    controllerAs: 'vm'
                },
                'header@': {}
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
            	sitePart : function($transition$,PublicSitePartRelationship){
            	    'ngInject';
            		return PublicSitePartRelationship.get({id :$transition$.params().publicSitePartRelationshipId}).$promise;
            	},
            	siteLanguages : ['PublicSiteLanguages', function(PublicSiteLanguages){
            		return PublicSiteLanguages.get().$promise;
            	}],
                currentProperty: function($transition$, Property) {
            	    'ngInject';
                    return Property.get({id : $transition$.params().propertyId}).$promise;
                },
            	translations : function(PublicSiteTranslationPart,sitePart){
            	    'ngInject';
            		return PublicSiteTranslationPart.get({partName : sitePart.publicSitePartName, siteName : sitePart.publicSiteName}).$promise;
            	},
            	hotelTranslations : function(PublicSiteTranslationPropertyPart,sitePart,currentProperty){
            	    'ngInject';
            		return PublicSiteTranslationPropertyPart.get({hotelId : currentProperty.hotelId ,partName : sitePart.publicSitePartName, siteName : sitePart.publicSiteName}).$promise;
            	},
                pagingParams: function ($transition$, PaginationUtil) {
            	    'ngInject';
                    return {
                        page: PaginationUtil.parsePage($transition$.params().page),
                        sort: $transition$.params().sort,
                        predicate: PaginationUtil.parsePredicate($transition$.params().sort),
                        ascending: PaginationUtil.parseAscending($transition$.params().sort),
                        publicSitePartRelationshipId: $transition$.params().publicSitePartRelationshipId
                    };
                },
                translatePartialLoader: function ($translate, $translatePartialLoader, sitePart) {
            	    'ngInject';
                    $translatePartialLoader.addPart('publicSitePartKey');
                    $translatePartialLoader.addPart(sitePart.publicSitePartName);
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }
            }
        });
    };

})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteTranslationPartController', PublicSiteTranslationPartController);

    function PublicSiteTranslationPartController ($scope, $state, $transition$, PublicSiteTranslation, PublicSiteTranslationPart, PublicSitePartKeys, PublicSiteTranslationSearch, ParseLinks, AlertService, pagingParams, paginationConstants, siteLanguages, translations, sitePart) {
        'ngInject';
        console.log('PublicSiteTranslationPartController...')
        var vm = this;

        vm.sitePart = sitePart;
        vm.partName = sitePart.publicSitePartName;
        vm.siteLanguages = siteLanguages;
        vm.translations = translations;
        vm.getMessage = getMessage;
        vm.calculateIndex = calculateIndex;
        vm.saveForm = saveForm;
        vm.formTranslations = [];


        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
        	PublicSitePartKeys.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                partName: sitePart.publicSitePartName
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.publicSitePartKeys = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                siteName: sitePart.publicSiteName,
                partName: sitePart.publicSitePartName,
                publicSitePartRelationshipId : sitePart.id//needed for state resolve
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


        function calculateIndex(outerIndex,innerIndex){
        	return (outerIndex*vm.siteLanguages.length)+innerIndex;
        }


        function getMessage(publicSitePartKeyId,publicSiteLanguageId){
        	var translation;
        	angular.forEach(vm.translations,function(value,k){

        		if(value.publicSiteLanguageId==publicSiteLanguageId
        				&& value.publicSitePartKeyId==publicSitePartKeyId){
        			translation = value;
        		}

        	});

        	return translation;
        }


        function saveForm(event){
        	event.preventDefault();
        	//console.log(vm.formTranslations);
        	saveAll();
        }


        function saveAll () {
        	PublicSiteTranslationPart.update({
        		translations : vm.formTranslations
        		}, onSuccess, onError);
            function onSuccess(data, headers) {
            	$state.transitionTo($state.current, $transition$.params(), {reload:true, inherit:true})
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSitePartKeys', PublicSitePartKeys);

    PublicSitePartKeys.$inject = ['$resource'];

    function PublicSitePartKeys ($resource) {
        var resourceUrl =  'api/public-site-part-keys?partName=:partName';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSiteLanguages', PublicSiteLanguages);

    PublicSiteLanguages.$inject = ['$resource'];

    function PublicSiteLanguages ($resource) {
        var resourceUrl =  'api/public-site-language-relationships?siteName=vobe';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteBrowsePropertyController', PublicSiteBrowsePropertyController);

    PublicSiteBrowsePropertyController.$inject = ['$scope', '$state', '$stateParams', 'PropertySearch'];

    function PublicSiteBrowsePropertyController ($scope, $state, $stateParams, PropertySearch) {
        var vm = this;


        vm.selectedProperty = {};

        vm.properties = [];

        vm.refreshProperties = function(propertyName) {
          if(!propertyName || propertyName.length==0){
        	  return;
          }
          var params = {search: propertyName};
          vm.properties = PropertySearch.get(params,function() {
        	  angular.forEach(vm.properties,function(p,key){
        		  p.formatted_name = '(' +p.hotelCode+ ') '+p.hotelName
        	  });
          });
        };

        vm.onSelect = function(){
        	$state.transitionTo('translation.property', {
                publicSitePartRelationshipId : $stateParams.publicSitePartRelationshipId,//needed for state resolve
                propertyId : vm.selectedProperty.hotelId//needed for state resolve
            });

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteTranslationPropertyDialogController', PublicSiteTranslationPropertyDialogController);

    PublicSiteTranslationPropertyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PublicSiteTranslationProperty', 'PublicSitePartRelationship', 'PublicSitePartKey', 'PublicSiteLanguage'];

    function PublicSiteTranslationPropertyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PublicSiteTranslationProperty, PublicSitePartRelationship, PublicSitePartKey, PublicSiteLanguage) {
        var vm = this;

        vm.publicSiteTranslationProperty = entity;
        vm.clear = clear;
        vm.save = save;
        vm.publicsitepartrelationships = PublicSitePartRelationship.query();
        vm.publicsitepartkeys = PublicSitePartKey.query();
        vm.publicsitelanguages = PublicSiteLanguage.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publicSiteTranslationProperty.id !== null) {
                PublicSiteTranslationProperty.update(vm.publicSiteTranslationProperty, onSaveSuccess, onSaveError);
            } else {
                PublicSiteTranslationProperty.save(vm.publicSiteTranslationProperty, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('vobeApp:publicSiteTranslationPropertyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteTranslationPropertyDetailController', PublicSiteTranslationPropertyDetailController);

    PublicSiteTranslationPropertyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PublicSiteTranslationProperty', 'PublicSitePartRelationship', 'PublicSitePartKey', 'PublicSiteLanguage'];

    function PublicSiteTranslationPropertyDetailController($scope, $rootScope, $stateParams, previousState, entity, PublicSiteTranslationProperty, PublicSitePartRelationship, PublicSitePartKey, PublicSiteLanguage) {
        var vm = this;

        vm.publicSiteTranslationProperty = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('vobeApp:publicSiteTranslationPropertyUpdate', function(event, result) {
            vm.publicSiteTranslationProperty = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteTranslationPropertyDeleteController',PublicSiteTranslationPropertyDeleteController);

    PublicSiteTranslationPropertyDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicSiteTranslationProperty'];

    function PublicSiteTranslationPropertyDeleteController($uibModalInstance, entity, PublicSiteTranslationProperty) {
        var vm = this;

        vm.publicSiteTranslationProperty = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicSiteTranslationProperty.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site-translation-property', {
            parent: 'entity',
            url: '/public-site-translation-property?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteTranslationProperty.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-translation-property/public-site-translation-properties.html',
                    controller: 'PublicSiteTranslationPropertyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteTranslationProperty');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-translation-property-detail', {
            parent: 'entity',
            url: '/public-site-translation-property/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteTranslationProperty.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-translation-property/public-site-translation-property-detail.html',
                    controller: 'PublicSiteTranslationPropertyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteTranslationProperty');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSiteTranslationProperty', function($stateParams, PublicSiteTranslationProperty) {
                    return PublicSiteTranslationProperty.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site-translation-property',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-translation-property-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation-property/public-site-translation-property-dialog.html',
                    controller: 'PublicSiteTranslationPropertyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteTranslationProperty', function(PublicSiteTranslationProperty) {
                            return PublicSiteTranslationProperty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-translation-property.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation-property/public-site-translation-property-dialog.html',
                    controller: 'PublicSiteTranslationPropertyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                hotelId: null,
                                message: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site-translation-property', null, { reload: 'public-site-translation-property' });
                }, function() {
                    $state.go('public-site-translation-property');
                });
            }]
        })
        .state('public-site-translation-property.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation-property/public-site-translation-property-dialog.html',
                    controller: 'PublicSiteTranslationPropertyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteTranslationProperty', function(PublicSiteTranslationProperty) {
                            return PublicSiteTranslationProperty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-translation-property', null, { reload: 'public-site-translation-property' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-translation-property.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation-property/public-site-translation-property-delete-dialog.html',
                    controller: 'PublicSiteTranslationPropertyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSiteTranslationProperty', function(PublicSiteTranslationProperty) {
                            return PublicSiteTranslationProperty.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-translation-property', null, { reload: 'public-site-translation-property' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSiteTranslationProperty', PublicSiteTranslationProperty);

    PublicSiteTranslationProperty.$inject = ['$resource'];

    function PublicSiteTranslationProperty ($resource) {
        var resourceUrl =  'api/public-site-translation-properties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PublicSiteTranslationPropertySearch', PublicSiteTranslationPropertySearch);

    PublicSiteTranslationPropertySearch.$inject = ['$resource'];

    function PublicSiteTranslationPropertySearch($resource) {
        var resourceUrl =  'api/_search/public-site-translation-properties/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteTranslationPropertyController', PublicSiteTranslationPropertyController);

    PublicSiteTranslationPropertyController.$inject = ['$scope', '$state', 'PublicSiteTranslationProperty', 'PublicSiteTranslationPropertySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PublicSiteTranslationPropertyController ($scope, $state, PublicSiteTranslationProperty, PublicSiteTranslationPropertySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PublicSiteTranslationPropertySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PublicSiteTranslationProperty.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.publicSiteTranslationProperties = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteTranslationDialogController', PublicSiteTranslationDialogController);

    PublicSiteTranslationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PublicSiteTranslation', 'PublicSitePartRelationship', 'PublicSitePartKey', 'PublicSiteLanguage'];

    function PublicSiteTranslationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PublicSiteTranslation, PublicSitePartRelationship, PublicSitePartKey, PublicSiteLanguage) {
        var vm = this;

        vm.publicSiteTranslation = entity;
        vm.clear = clear;
        vm.save = save;
        vm.publicsitepartrelationships = PublicSitePartRelationship.query();
        vm.publicsitepartkeys = PublicSitePartKey.query();
        vm.publicsitelanguages = PublicSiteLanguage.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publicSiteTranslation.id !== null) {
                PublicSiteTranslation.update(vm.publicSiteTranslation, onSaveSuccess, onSaveError);
            } else {
                PublicSiteTranslation.save(vm.publicSiteTranslation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('vobeApp:publicSiteTranslationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteTranslationDetailController', PublicSiteTranslationDetailController);

    PublicSiteTranslationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PublicSiteTranslation', 'PublicSitePartRelationship', 'PublicSitePartKey', 'PublicSiteLanguage'];

    function PublicSiteTranslationDetailController($scope, $rootScope, $stateParams, previousState, entity, PublicSiteTranslation, PublicSitePartRelationship, PublicSitePartKey, PublicSiteLanguage) {
        var vm = this;

        vm.publicSiteTranslation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('vobeApp:publicSiteTranslationUpdate', function(event, result) {
            vm.publicSiteTranslation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteTranslationDeleteController',PublicSiteTranslationDeleteController);

    PublicSiteTranslationDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicSiteTranslation'];

    function PublicSiteTranslationDeleteController($uibModalInstance, entity, PublicSiteTranslation) {
        var vm = this;

        vm.publicSiteTranslation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicSiteTranslation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site-translation', {
            parent: 'entity',
            url: '/public-site-translation?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteTranslation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-translation/public-site-translations.html',
                    controller: 'PublicSiteTranslationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteTranslation');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-translation-detail', {
            parent: 'entity',
            url: '/public-site-translation/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteTranslation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-translation/public-site-translation-detail.html',
                    controller: 'PublicSiteTranslationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteTranslation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSiteTranslation', function($stateParams, PublicSiteTranslation) {
                    return PublicSiteTranslation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site-translation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-translation-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation/public-site-translation-dialog.html',
                    controller: 'PublicSiteTranslationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteTranslation', function(PublicSiteTranslation) {
                            return PublicSiteTranslation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-translation.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation/public-site-translation-dialog.html',
                    controller: 'PublicSiteTranslationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                message: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site-translation', null, { reload: 'public-site-translation' });
                }, function() {
                    $state.go('public-site-translation');
                });
            }]
        })
        .state('public-site-translation.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation/public-site-translation-dialog.html',
                    controller: 'PublicSiteTranslationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteTranslation', function(PublicSiteTranslation) {
                            return PublicSiteTranslation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-translation', null, { reload: 'public-site-translation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-translation.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-translation/public-site-translation-delete-dialog.html',
                    controller: 'PublicSiteTranslationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSiteTranslation', function(PublicSiteTranslation) {
                            return PublicSiteTranslation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-translation', null, { reload: 'public-site-translation' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSiteTranslation', PublicSiteTranslation);

    PublicSiteTranslation.$inject = ['$resource'];

    function PublicSiteTranslation ($resource) {
        var resourceUrl =  'api/public-site-translations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PublicSiteTranslationSearch', PublicSiteTranslationSearch);

    PublicSiteTranslationSearch.$inject = ['$resource'];

    function PublicSiteTranslationSearch($resource) {
        var resourceUrl =  'api/_search/public-site-translations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteTranslationController', PublicSiteTranslationController);

    PublicSiteTranslationController.$inject = ['$scope', '$state', 'PublicSiteTranslation', 'PublicSiteTranslationSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PublicSiteTranslationController ($scope, $state, PublicSiteTranslation, PublicSiteTranslationSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {

        console.log('...PublicSiteTranslationController...')
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PublicSiteTranslationSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PublicSiteTranslation.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.publicSiteTranslations = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartRelationshipDialogController', PublicSitePartRelationshipDialogController);

    PublicSitePartRelationshipDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PublicSitePartRelationship', 'PublicSitePart', 'PublicSite'];

    function PublicSitePartRelationshipDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PublicSitePartRelationship, PublicSitePart, PublicSite) {
        var vm = this;

        vm.publicSitePartRelationship = entity;
        vm.clear = clear;
        vm.save = save;
        vm.publicsiteparts = PublicSitePart.query();
        vm.publicsites = PublicSite.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publicSitePartRelationship.id !== null) {
                PublicSitePartRelationship.update(vm.publicSitePartRelationship, onSaveSuccess, onSaveError);
            } else {
                PublicSitePartRelationship.save(vm.publicSitePartRelationship, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('vobeApp:publicSitePartRelationshipUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartRelationshipDetailController', PublicSitePartRelationshipDetailController);

    PublicSitePartRelationshipDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PublicSitePartRelationship', 'PublicSitePart', 'PublicSite'];

    function PublicSitePartRelationshipDetailController($scope, $rootScope, $stateParams, previousState, entity, PublicSitePartRelationship, PublicSitePart, PublicSite) {
        var vm = this;

        vm.publicSitePartRelationship = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('vobeApp:publicSitePartRelationshipUpdate', function(event, result) {
            vm.publicSitePartRelationship = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartRelationshipDeleteController',PublicSitePartRelationshipDeleteController);

    PublicSitePartRelationshipDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicSitePartRelationship'];

    function PublicSitePartRelationshipDeleteController($uibModalInstance, entity, PublicSitePartRelationship) {
        var vm = this;

        vm.publicSitePartRelationship = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicSitePartRelationship.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site-part-relationship', {
            parent: 'entity',
            url: '/public-site-part-relationship?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSitePartRelationship.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-part-relationship/public-site-part-relationships.html',
                    controller: 'PublicSitePartRelationshipController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePartRelationship');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-part-relationship-detail', {
            parent: 'entity',
            url: '/public-site-part-relationship/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSitePartRelationship.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-part-relationship/public-site-part-relationship-detail.html',
                    controller: 'PublicSitePartRelationshipDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePartRelationship');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSitePartRelationship', function($stateParams, PublicSitePartRelationship) {
                    return PublicSitePartRelationship.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site-part-relationship',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-part-relationship-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-relationship/public-site-part-relationship-dialog.html',
                    controller: 'PublicSitePartRelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSitePartRelationship', function(PublicSitePartRelationship) {
                            return PublicSitePartRelationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-part-relationship.new', {
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-relationship/public-site-part-relationship-dialog.html',
                    controller: 'PublicSitePartRelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site-part-relationship', null, { reload: 'public-site-part-relationship' });
                }, function() {
                    $state.go('public-site-part-relationship');
                });
            }]
        })
        .state('public-site-part-relationship.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-relationship/public-site-part-relationship-dialog.html',
                    controller: 'PublicSitePartRelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSitePartRelationship', function(PublicSitePartRelationship) {
                            return PublicSitePartRelationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-part-relationship', null, { reload: 'public-site-part-relationship' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-part-relationship.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-relationship/public-site-part-relationship-delete-dialog.html',
                    controller: 'PublicSitePartRelationshipDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSitePartRelationship', function(PublicSitePartRelationship) {
                            return PublicSitePartRelationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-part-relationship', null, { reload: 'public-site-part-relationship' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSitePartRelationship', PublicSitePartRelationship);

    PublicSitePartRelationship.$inject = ['$resource'];

    function PublicSitePartRelationship ($resource) {
        var resourceUrl =  'api/public-site-part-relationships/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PublicSitePartRelationshipSearch', PublicSitePartRelationshipSearch);

    PublicSitePartRelationshipSearch.$inject = ['$resource'];

    function PublicSitePartRelationshipSearch($resource) {
        var resourceUrl =  'api/_search/public-site-part-relationships/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartRelationshipController', PublicSitePartRelationshipController);

    PublicSitePartRelationshipController.$inject = ['$scope', '$state', 'PublicSitePartRelationship', 'PublicSitePartRelationshipSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PublicSitePartRelationshipController ($scope, $state, PublicSitePartRelationship, PublicSitePartRelationshipSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PublicSitePartRelationshipSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PublicSitePartRelationship.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.publicSitePartRelationships = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartKeyDialogController', PublicSitePartKeyDialogController);

    PublicSitePartKeyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PublicSitePartKey', 'PublicSitePart'];

    function PublicSitePartKeyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PublicSitePartKey, PublicSitePart) {
        var vm = this;

        vm.publicSitePartKey = entity;
        vm.clear = clear;
        vm.save = save;
        vm.publicsiteparts = PublicSitePart.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publicSitePartKey.id !== null) {
                PublicSitePartKey.update(vm.publicSitePartKey, onSaveSuccess, onSaveError);
            } else {
                PublicSitePartKey.save(vm.publicSitePartKey, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('vobeApp:publicSitePartKeyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartKeyDetailController', PublicSitePartKeyDetailController);

    PublicSitePartKeyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PublicSitePartKey', 'PublicSitePart'];

    function PublicSitePartKeyDetailController($scope, $rootScope, $stateParams, previousState, entity, PublicSitePartKey, PublicSitePart) {
        var vm = this;

        vm.publicSitePartKey = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('vobeApp:publicSitePartKeyUpdate', function(event, result) {
            vm.publicSitePartKey = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartKeyDeleteController',PublicSitePartKeyDeleteController);

    PublicSitePartKeyDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicSitePartKey'];

    function PublicSitePartKeyDeleteController($uibModalInstance, entity, PublicSitePartKey) {
        var vm = this;

        vm.publicSitePartKey = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicSitePartKey.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site-part-key', {
            parent: 'entity',
            url: '/public-site-part-key?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSitePartKey.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-part-key/public-site-part-keys.html',
                    controller: 'PublicSitePartKeyController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePartKey');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-part-key-detail', {
            parent: 'entity',
            url: '/public-site-part-key/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSitePartKey.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-part-key/public-site-part-key-detail.html',
                    controller: 'PublicSitePartKeyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePartKey');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSitePartKey', function($stateParams, PublicSitePartKey) {
                    return PublicSitePartKey.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site-part-key',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-part-key-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-key/public-site-part-key-dialog.html',
                    controller: 'PublicSitePartKeyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSitePartKey', function(PublicSitePartKey) {
                            return PublicSitePartKey.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-part-key.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-key/public-site-part-key-dialog.html',
                    controller: 'PublicSitePartKeyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                translationKey: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site-part-key', null, { reload: 'public-site-part-key' });
                }, function() {
                    $state.go('public-site-part-key');
                });
            }]
        })
        .state('public-site-part-key.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-key/public-site-part-key-dialog.html',
                    controller: 'PublicSitePartKeyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSitePartKey', function(PublicSitePartKey) {
                            return PublicSitePartKey.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-part-key', null, { reload: 'public-site-part-key' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-part-key.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part-key/public-site-part-key-delete-dialog.html',
                    controller: 'PublicSitePartKeyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSitePartKey', function(PublicSitePartKey) {
                            return PublicSitePartKey.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-part-key', null, { reload: 'public-site-part-key' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSitePartKey', PublicSitePartKey);

    PublicSitePartKey.$inject = ['$resource'];

    function PublicSitePartKey ($resource) {
        var resourceUrl =  'api/public-site-part-keys/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PublicSitePartKeySearch', PublicSitePartKeySearch);

    PublicSitePartKeySearch.$inject = ['$resource'];

    function PublicSitePartKeySearch($resource) {
        var resourceUrl =  'api/_search/public-site-part-keys/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartKeyController', PublicSitePartKeyController);

    PublicSitePartKeyController.$inject = ['$scope', '$state', 'PublicSitePartKey', 'PublicSitePartKeySearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PublicSitePartKeyController ($scope, $state, PublicSitePartKey, PublicSitePartKeySearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PublicSitePartKeySearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PublicSitePartKey.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.publicSitePartKeys = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartDialogController', PublicSitePartDialogController);

    PublicSitePartDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PublicSitePart', 'PublicSitePartKey'];

    function PublicSitePartDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PublicSitePart, PublicSitePartKey) {
        var vm = this;

        vm.publicSitePart = entity;
        vm.clear = clear;
        vm.save = save;
        vm.publicsitepartkeys = PublicSitePartKey.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publicSitePart.id !== null) {
                PublicSitePart.update(vm.publicSitePart, onSaveSuccess, onSaveError);
            } else {
                PublicSitePart.save(vm.publicSitePart, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('vobeApp:publicSitePartUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartDetailController', PublicSitePartDetailController);

    PublicSitePartDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PublicSitePart', 'PublicSitePartKey'];

    function PublicSitePartDetailController($scope, $rootScope, $stateParams, previousState, entity, PublicSitePart, PublicSitePartKey) {
        var vm = this;

        vm.publicSitePart = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('vobeApp:publicSitePartUpdate', function(event, result) {
            vm.publicSitePart = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartDeleteController',PublicSitePartDeleteController);

    PublicSitePartDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicSitePart'];

    function PublicSitePartDeleteController($uibModalInstance, entity, PublicSitePart) {
        var vm = this;

        vm.publicSitePart = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicSitePart.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site-part', {
            parent: 'entity',
            url: '/public-site-part?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSitePart.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-part/public-site-parts.html',
                    controller: 'PublicSitePartController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePart');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-part-detail', {
            parent: 'entity',
            url: '/public-site-part/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSitePart.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-part/public-site-part-detail.html',
                    controller: 'PublicSitePartDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSitePart');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSitePart', function($stateParams, PublicSitePart) {
                    return PublicSitePart.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site-part',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-part-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part/public-site-part-dialog.html',
                    controller: 'PublicSitePartDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSitePart', function(PublicSitePart) {
                            return PublicSitePart.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-part.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part/public-site-part-dialog.html',
                    controller: 'PublicSitePartDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site-part', null, { reload: 'public-site-part' });
                }, function() {
                    $state.go('public-site-part');
                });
            }]
        })
        .state('public-site-part.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part/public-site-part-dialog.html',
                    controller: 'PublicSitePartDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSitePart', function(PublicSitePart) {
                            return PublicSitePart.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-part', null, { reload: 'public-site-part' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-part.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-part/public-site-part-delete-dialog.html',
                    controller: 'PublicSitePartDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSitePart', function(PublicSitePart) {
                            return PublicSitePart.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-part', null, { reload: 'public-site-part' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSitePart', PublicSitePart);

    PublicSitePart.$inject = ['$resource'];

    function PublicSitePart ($resource) {
        var resourceUrl =  'api/public-site-parts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PublicSitePartSearch', PublicSitePartSearch);

    PublicSitePartSearch.$inject = ['$resource'];

    function PublicSitePartSearch($resource) {
        var resourceUrl =  'api/_search/public-site-parts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSitePartController', PublicSitePartController);

    PublicSitePartController.$inject = ['$scope', '$state', 'PublicSitePart', 'PublicSitePartSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PublicSitePartController ($scope, $state, PublicSitePart, PublicSitePartSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PublicSitePartSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PublicSitePart.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.publicSiteParts = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteLanguageRelationshipDialogController', PublicSiteLanguageRelationshipDialogController);

    PublicSiteLanguageRelationshipDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PublicSiteLanguageRelationship', 'PublicSite','PublicSiteLanguage'];

    function PublicSiteLanguageRelationshipDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PublicSiteLanguageRelationship, PublicSite, PublicSiteLanguage) {
        var vm = this;

        vm.publicSiteLanguageRelationship = entity;
        vm.clear = clear;
        vm.save = save;
        vm.publicsites = PublicSite.query();
        vm.publicsitelanguages = PublicSiteLanguage.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publicSiteLanguageRelationship.id !== null) {
                PublicSiteLanguageRelationship.update(vm.publicSiteLanguageRelationship, onSaveSuccess, onSaveError);
            } else {
                PublicSiteLanguageRelationship.save(vm.publicSiteLanguageRelationship, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('vobeApp:publicSiteLanguageRelationshipUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteLanguageRelationshipDetailController', PublicSiteLanguageRelationshipDetailController);

    PublicSiteLanguageRelationshipDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PublicSiteLanguageRelationship', 'PublicSite'];

    function PublicSiteLanguageRelationshipDetailController($scope, $rootScope, $stateParams, previousState, entity, PublicSiteLanguageRelationship, PublicSite) {
        var vm = this;

        vm.publicSiteLanguageRelationship = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('vobeApp:publicSiteLanguageRelationshipUpdate', function(event, result) {
            vm.publicSiteLanguageRelationship = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteLanguageRelationshipDeleteController',PublicSiteLanguageRelationshipDeleteController);

    PublicSiteLanguageRelationshipDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicSiteLanguageRelationship'];

    function PublicSiteLanguageRelationshipDeleteController($uibModalInstance, entity, PublicSiteLanguageRelationship) {
        var vm = this;

        vm.publicSiteLanguageRelationship = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicSiteLanguageRelationship.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site-language-relationship', {
            parent: 'entity',
            url: '/public-site-language-relationship?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteLanguageRelationship.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-language-relationship/public-site-language-relationships.html',
                    controller: 'PublicSiteLanguageRelationshipController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteLanguageRelationship');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-language-relationship-detail', {
            parent: 'entity',
            url: '/public-site-language-relationship/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteLanguageRelationship.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-language-relationship/public-site-language-relationship-detail.html',
                    controller: 'PublicSiteLanguageRelationshipDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteLanguageRelationship');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSiteLanguageRelationship', function($stateParams, PublicSiteLanguageRelationship) {
                    return PublicSiteLanguageRelationship.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site-language-relationship',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-language-relationship-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language-relationship/public-site-language-relationship-dialog.html',
                    controller: 'PublicSiteLanguageRelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteLanguageRelationship', function(PublicSiteLanguageRelationship) {
                            return PublicSiteLanguageRelationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-language-relationship.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language-relationship/public-site-language-relationship-dialog.html',
                    controller: 'PublicSiteLanguageRelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                active: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site-language-relationship', null, { reload: 'public-site-language-relationship' });
                }, function() {
                    $state.go('public-site-language-relationship');
                });
            }]
        })
        .state('public-site-language-relationship.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language-relationship/public-site-language-relationship-dialog.html',
                    controller: 'PublicSiteLanguageRelationshipDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteLanguageRelationship', function(PublicSiteLanguageRelationship) {
                            return PublicSiteLanguageRelationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-language-relationship', null, { reload: 'public-site-language-relationship' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-language-relationship.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language-relationship/public-site-language-relationship-delete-dialog.html',
                    controller: 'PublicSiteLanguageRelationshipDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSiteLanguageRelationship', function(PublicSiteLanguageRelationship) {
                            return PublicSiteLanguageRelationship.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-language-relationship', null, { reload: 'public-site-language-relationship' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSiteLanguageRelationship', PublicSiteLanguageRelationship);

    PublicSiteLanguageRelationship.$inject = ['$resource'];

    function PublicSiteLanguageRelationship ($resource) {
        var resourceUrl =  'api/public-site-language-relationships/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PublicSiteLanguageRelationshipSearch', PublicSiteLanguageRelationshipSearch);

    PublicSiteLanguageRelationshipSearch.$inject = ['$resource'];

    function PublicSiteLanguageRelationshipSearch($resource) {
        var resourceUrl =  'api/_search/public-site-language-relationships/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteLanguageRelationshipController', PublicSiteLanguageRelationshipController);

    PublicSiteLanguageRelationshipController.$inject = ['$scope', '$state', 'PublicSiteLanguageRelationship', 'PublicSiteLanguageRelationshipSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PublicSiteLanguageRelationshipController ($scope, $state, PublicSiteLanguageRelationship, PublicSiteLanguageRelationshipSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PublicSiteLanguageRelationshipSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PublicSiteLanguageRelationship.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.publicSiteLanguageRelationships = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteLanguageDialogController', PublicSiteLanguageDialogController);

    PublicSiteLanguageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PublicSiteLanguage'];

    function PublicSiteLanguageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PublicSiteLanguage) {
        var vm = this;

        vm.publicSiteLanguage = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publicSiteLanguage.id !== null) {
                PublicSiteLanguage.update(vm.publicSiteLanguage, onSaveSuccess, onSaveError);
            } else {
                PublicSiteLanguage.save(vm.publicSiteLanguage, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('vobeApp:publicSiteLanguageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteLanguageDetailController', PublicSiteLanguageDetailController);

    PublicSiteLanguageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PublicSiteLanguage'];

    function PublicSiteLanguageDetailController($scope, $rootScope, $stateParams, previousState, entity, PublicSiteLanguage) {
        var vm = this;

        vm.publicSiteLanguage = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('vobeApp:publicSiteLanguageUpdate', function(event, result) {
            vm.publicSiteLanguage = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteLanguageDeleteController',PublicSiteLanguageDeleteController);

    PublicSiteLanguageDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicSiteLanguage'];

    function PublicSiteLanguageDeleteController($uibModalInstance, entity, PublicSiteLanguage) {
        var vm = this;

        vm.publicSiteLanguage = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicSiteLanguage.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site-language', {
            parent: 'entity',
            url: '/public-site-language?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteLanguage.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-language/public-site-languages.html',
                    controller: 'PublicSiteLanguageController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteLanguage');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-language-detail', {
            parent: 'entity',
            url: '/public-site-language/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSiteLanguage.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site-language/public-site-language-detail.html',
                    controller: 'PublicSiteLanguageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSiteLanguage');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSiteLanguage', function($stateParams, PublicSiteLanguage) {
                    return PublicSiteLanguage.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site-language',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-language-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language/public-site-language-dialog.html',
                    controller: 'PublicSiteLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteLanguage', function(PublicSiteLanguage) {
                            return PublicSiteLanguage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-language.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language/public-site-language-dialog.html',
                    controller: 'PublicSiteLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site-language', null, { reload: 'public-site-language' });
                }, function() {
                    $state.go('public-site-language');
                });
            }]
        })
        .state('public-site-language.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language/public-site-language-dialog.html',
                    controller: 'PublicSiteLanguageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSiteLanguage', function(PublicSiteLanguage) {
                            return PublicSiteLanguage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-language', null, { reload: 'public-site-language' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site-language.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site-language/public-site-language-delete-dialog.html',
                    controller: 'PublicSiteLanguageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSiteLanguage', function(PublicSiteLanguage) {
                            return PublicSiteLanguage.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site-language', null, { reload: 'public-site-language' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSiteLanguage', PublicSiteLanguage);

    PublicSiteLanguage.$inject = ['$resource'];

    function PublicSiteLanguage ($resource) {
        var resourceUrl =  'api/public-site-languages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PublicSiteLanguageSearch', PublicSiteLanguageSearch);

    PublicSiteLanguageSearch.$inject = ['$resource'];

    function PublicSiteLanguageSearch($resource) {
        var resourceUrl =  'api/_search/public-site-languages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteLanguageController', PublicSiteLanguageController);

    PublicSiteLanguageController.$inject = ['$scope', '$state', 'PublicSiteLanguage', 'PublicSiteLanguageSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PublicSiteLanguageController ($scope, $state, PublicSiteLanguage, PublicSiteLanguageSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PublicSiteLanguageSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PublicSiteLanguage.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.publicSiteLanguages = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteDialogController', PublicSiteDialogController);

    PublicSiteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PublicSite'];

    function PublicSiteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PublicSite) {
        var vm = this;

        vm.publicSite = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publicSite.id !== null) {
                PublicSite.update(vm.publicSite, onSaveSuccess, onSaveError);
            } else {
                PublicSite.save(vm.publicSite, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('vobeApp:publicSiteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteDetailController', PublicSiteDetailController);

    PublicSiteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PublicSite'];

    function PublicSiteDetailController($scope, $rootScope, $stateParams, previousState, entity, PublicSite) {
        var vm = this;

        vm.publicSite = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('vobeApp:publicSiteUpdate', function(event, result) {
            vm.publicSite = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteDeleteController',PublicSiteDeleteController);

    PublicSiteDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicSite'];

    function PublicSiteDeleteController($uibModalInstance, entity, PublicSite) {
        var vm = this;

        vm.publicSite = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicSite.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-site', {
            parent: 'entity',
            url: '/public-site?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSite.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site/public-sites.html',
                    controller: 'PublicSiteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSite');
                    //$translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-site-detail', {
            parent: 'entity',
            url: '/public-site/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'vobeApp.publicSite.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-site/public-site-detail.html',
                    controller: 'PublicSiteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicSite');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicSite', function($stateParams, PublicSite) {
                    return PublicSite.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-site',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-site-detail.edit', {
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site/public-site-dialog.html',
                    controller: 'PublicSiteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSite', function(PublicSite) {
                            return PublicSite.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('pnew', {
            parent: 'public-site',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site/public-site-dialog.html',
                    controller: 'PublicSiteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-site', null, { reload: 'public-site' });
                }, function() {
                    $state.go('public-site');
                });
            }]
        })
        .state('public-site.edit', {
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site/public-site-dialog.html',
                    controller: 'PublicSiteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicSite', function(PublicSite) {
                            return PublicSite.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site', null, { reload: 'public-site' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-site.delete', {
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-site/public-site-delete-dialog.html',
                    controller: 'PublicSiteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicSite', function(PublicSite) {
                            return PublicSite.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-site', null, { reload: 'public-site' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('vobeApp')
        .factory('PublicSite', PublicSite);

    PublicSite.$inject = ['$resource'];

    function PublicSite ($resource) {
        var resourceUrl =  'api/public-sites/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PublicSiteSearch', PublicSiteSearch);

    PublicSiteSearch.$inject = ['$resource'];

    function PublicSiteSearch($resource) {
        var resourceUrl =  'api/_search/public-sites/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PublicSiteController', PublicSiteController);

    PublicSiteController.$inject = ['$scope', '$state', 'PublicSite', 'PublicSiteSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function PublicSiteController ($scope, $state, PublicSite, PublicSiteSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PublicSiteSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PublicSite.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.publicSites = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app',
            views: {
                'header@': {}
            }
        });
    }
})();

(function() {
    'use strict';

    angular.module('currencyExchangeModule', []).provider('CurrencyExchange', CurrencyExchangeProvider);

    function isInt(value){
        return !isNaN(value) && parseInt(value) === value;
    };

    function Currency(code, symbol, rate, precision, decimal, thousands, post) {
        this.code = code;
        this.symbol = symbol;
        this.precision = isInt(precision) ? precision : 2;
        this.decimal = decimal || '.';
        this.thousands = thousands || ',';
        this.post = post || false;
        this.rate = rate || 1;
        this.isInt = isInt;
    }

    function CurrencyExchangeProvider(
        XE_CURRENCIES
    ) {
        'ngInject';

        var isReady = { currencies: false };
        var currencyCodes = {all: []};
        var currencies = {all: {}, current: null, base: null};
        var currencyWaiting = '';


        var addBaseCurrency = function(code){
            currencies.base = currencies.all[code];
            currencies.current = currencies.all[code];
            isReady.currencies = true;
        }

        var changeCurrentCurrency = function(code){
            currencies.current = currencies.all[code];
        }

        var resetCurrentCurrency = function(){
            currencies.current = null;
        }

        var addAllCurrencies = function(currencyArr){
            angular.forEach(currencyArr,function(currency,i){
                var precision = XE_CURRENCIES[currency.code] ? XE_CURRENCIES[currency.code][0] : 2;
                var symbol = XE_CURRENCIES[currency.code] ? XE_CURRENCIES[currency.code][1] : currency.symbol;
                addCurrency(currency.code, symbol, currency.eurExchange, precision)
            });
            console.log('CurrencyExchangeProvider addAllCurrencies', currencies.all)
        }

        var setActiveCurrencies = function(activeCurrencies){
            currencyCodes.all = activeCurrencies;
        }

        var addCurrency = function(code, symbol, rate, precision, decimal, thousands, post){
            currencies.all[code] = new Currency(code, symbol, rate, precision, decimal, thousands, post);
        }


        var publicService = function(CurrenciesService,$rootScope) {
            'ngInject';

            return {
                initCurrencies: function() {
                    console.log('CurrencyExchangeProvider initCurrencies');
                    var currenciesPromise = CurrenciesService.get().$promise;
                    var currenciesPromiseChain1 = currenciesPromise.then(function(data) {
                        addAllCurrencies(data);
                    })
                    return currenciesPromiseChain1;
                },
                changeCurrency: function(code) {
                    changeCurrentCurrency(code);
                    $rootScope.$broadcast('CurrencyExchangeProvider.changeCurrency', currencies.current);
                    console.log('CurrencyExchangeProvider change current currency: ', currencies.current);
                },
                addBaseCurrency: function(code) {
                    addBaseCurrency(code);
                    console.log('CurrencyExchangeProvider base currency: ', currencies.base);
                },
                setActiveCurrencies: function(activeCurrencies) {
                    setActiveCurrencies(activeCurrencies);
                    console.log('CurrencyExchangeProvider active currencies', currencyCodes.all)
                },
                resetCurrency : function(){
                    resetCurrentCurrency();
                },
                currencyCodes: currencyCodes,
                currencies: currencies
            };
        }


        return {
            $get : publicService
        }



    }
})();

(function() {
    'use strict';

    angular.module('currencyExchangeModule').factory('CurrencyExchangeUtils', currencyExchangeUtils);

    function currencyExchangeUtils(
        $locale
    ) {
        'ngInject';
        return {
            /*XE_CURRENCIES_FORMAT object type is = { format: string, fractional?: boolean, };*/
            format: function (amount /*must be number*/,currency /*one of XE_CURRENCIES_FORMAT*/, rounding) {
                rounding = rounding || Math.round;
                var multiplier = Math.pow(10, currency.fractional === false ? 0 : 2);//TODO should it be 2 ???
                var price = Math.round(amount * multiplier) / multiplier;
                var readablePrice = price.toLocaleString().replace(/(\.[\d]{1})$/, '$10');
                return currency.format.replace('#', readablePrice);

            }
        }



    }
})();

(function () {
    'use strict';
    angular
        .module('currencyExchangeModule')
        .constant('XE_CURRENCIES', {
            'AED': [2, 'dh', '\u062f.\u0625.', 'DH'],
            'AUD': [2, '$', 'AU$'],
            'BDT': [2, '\u09F3', 'Tk'],
            'BRL': [2, 'R$', 'R$'],
            'CAD': [2, '$', 'C$'],
            'CHF': [2, 'CHF', 'CHF'],
            'CLP': [0, '$', 'CL$'],
            'CNY': [2, '¥', 'RMB¥'],
            'COP': [0, '$', 'COL$'],
            'CRC': [0, '\u20a1', 'CR\u20a1'],
            'CZK': [2, 'Kč', 'Kč'],
            'DKK': [2, 'kr', 'kr'],
            'DOP': [2, '$', 'RD$'],
            'EGP': [2, '£', 'LE'],
            'EUR': [2, '€', '€'],
            'GBP': [2, '£', 'GB£'],
            'HKD': [2, '$', 'HK$'],
            'ILS': [2, '\u20AA', 'IL\u20AA'],
            'INR': [2, '\u20B9', 'Rs'],
            'ISK': [0, 'kr', 'kr'],
            'JMD': [2, '$', 'JA$'],
            'JPY': [0, '¥', 'JP¥'],
            'KRW': [0, '\u20A9', 'KR?'],
            'LKR': [2, 'Rs', 'SLRs'],
            'MNT': [0, '\u20AE', 'MN?'],
            'MXN': [2, '$', 'Mex$'],
            'MYR': [2, 'RM', 'RM'],
            'NOK': [2, 'kr', 'NOkr'],
            'PAB': [2, 'B/.', 'B/.'],
            'PEN': [2, 'S/.', 'S/.'],
            'PHP': [2, '\u20B1', 'Php'],
            'PKR': [0, 'Rs', 'PKRs.'],
            'RUB': [0, '₽', '₽'],
            'SAR': [2, 'Rial', 'Rial'],
            'SEK': [2, 'kr', 'kr'],
            'SGD': [2, '$', 'S$'],
            'THB': [2, '\u0e3f', 'THB'],
            'TRY': [2, 'TL', 'YTL'],
            'TWD': [2, 'NT$', 'NT$'],
            'USD': [2, '$', 'US$'],
            'VND': [0, '\u20AB', 'VN\u20AB'],
            'YER': [0, 'Rial', 'Rial'],
            'ZAR': [2, 'R', 'ZAR'],
            'AFN': [16, 'Af.', 'AFN'],
            'ALL': [0, 'Lek', 'Lek'],
            'AMD': [0, 'Dram', 'dram'],
            'AOA': [2, 'Kz', 'Kz'],
            'ARS': [2, '$', 'AR$'],
            'AWG': [2, 'Afl.', 'Afl.'],
            'AZN': [2, 'man.', 'man.'],
            'BAM': [18, 'KM', 'KM'],
            'BBD': [2, '$', 'Bds$'],
            'BGN': [2, 'lev', 'lev'],
            'BHD': [3, 'din', 'din'],
            'BIF': [0, 'FBu', 'FBu'],
            'BMD': [2, '$', 'BD$'],
            'BND': [2, '$', 'B$'],
            'BOB': [2, 'Bs', 'Bs'],
            'BSD': [2, '$', 'BS$'],
            'BTN': [2, 'Nu.', 'Nu.'],
            'BWP': [2, 'P', 'pula'],
            'BYR': [0, 'BYR', 'BYR'],
            'BZD': [2, '$', 'BZ$'],
            'CDF': [2, 'FrCD', 'CDF'],
            'CUC': [1, '$', 'CUC$'],
            'CUP': [2, '$', 'CU$'],
            'CVE': [2, 'CVE', 'Esc'],
            'DJF': [0, 'Fdj', 'Fdj'],
            'DZD': [2, 'din', 'din'],
            'ERN': [2, 'Nfk', 'Nfk'],
            'ETB': [2, 'Birr', 'Birr'],
            'FJD': [2, '$', 'FJ$'],
            'FKP': [2, '£', 'FK£'],
            'GEL': [2, 'GEL', 'GEL'],
            'GHS': [2, 'GHS', 'GHS'],
            'GIP': [2, '£', 'GI£'],
            'GMD': [2, 'GMD', 'GMD'],
            'GNF': [0, 'FG', 'FG'],
            'GTQ': [2, 'Q', 'GTQ'],
            'GYD': [0, '$', 'GY$'],
            'HNL': [2, 'L', 'HNL'],
            'HRK': [2, 'kn', 'kn'],
            'HTG': [2, 'HTG', 'HTG'],
            'HUF': [0, 'Ft', 'Ft'],
            'IDR': [0, 'Rp', 'Rp'],
            'IQD': [0, 'din', 'IQD'],
            'IRR': [0, 'Rial', 'IRR'],
            'JOD': [3, 'din', 'JOD'],
            'KES': [2, 'Ksh', 'Ksh'],
            'KGS': [2, 'KGS', 'KGS'],
            'KHR': [2, 'Riel', 'KHR'],
            'KMF': [0, 'CF', 'KMF'],
            'KPW': [0, '\u20A9KP', 'KPW'],
            'KWD': [3, 'din', 'KWD'],
            'KYD': [2, '$', 'KY$'],
            'KZT': [2, '\u20B8', 'KZT'],
            'LAK': [0, '\u20AD', '\u20AD'],
            'LBP': [0, 'L£', 'LBP'],
            'LRD': [2, '$', 'L$'],
            'LSL': [2, 'LSL', 'LSL'],
            'LTL': [2, 'Lt', 'Lt'],
            'LVL': [2, 'Ls', 'Ls'],
            'LYD': [3, 'din', 'LD'],
            'MAD': [2, 'dh', 'MAD'],
            'MDL': [2, 'MDL', 'MDL'],
            'MGA': [0, 'Ar', 'MGA'],
            'MKD': [2, 'din', 'MKD'],
            'MMK': [0, 'K', 'MMK'],
            'MOP': [2, 'MOP', 'MOP$'],
            'MRO': [0, 'MRO', 'MRO'],
            'MUR': [0, 'MURs', 'MURs'],
            'MWK': [2, 'MWK', 'MWK'],
            'MZN': [2, 'MTn', 'MTn'],
            'NAD': [2, '$', 'N$'],
            'NGN': [2, '\u20A6', 'NG\u20A6'],
            'NIO': [2, 'C$', 'C$'],
            'NPR': [2, 'Rs', 'NPRs'],
            'NZD': [2, '$', 'NZ$'],
            'OMR': [3, 'Rial', 'OMR'],
            'PGK': [2, 'PGK', 'PGK'],
            'PLN': [2, 'z\u0142', 'z\u0142'],
            'PYG': [0, 'Gs', 'PYG'],
            'QAR': [2, 'Rial', 'QR'],
            'RON': [2, 'RON', 'RON'],
            'RSD': [0, 'din', 'RSD'],
            'RWF': [0, 'RF', 'RF'],
            'SBD': [2, '$', 'SI$'],
            'SCR': [2, 'SCR', 'SCR'],
            'SDG': [2, 'SDG', 'SDG'],
            'SHP': [2, '£', 'SH£'],
            'SLL': [0, 'SLL', 'SLL'],
            'SOS': [0, 'SOS', 'SOS'],
            'SRD': [2, '$', 'SR$'],
            'STD': [0, 'Db', 'Db'],
            'SYP': [16, '£', 'SY£'],
            'SZL': [2, 'SZL', 'SZL'],
            'TJS': [2, 'Som', 'TJS'],
            'TND': [3, 'din', 'DT'],
            'TOP': [2, 'T$', 'T$'],
            'TTD': [2, '$', 'TT$'],
            'TZS': [0, 'TSh', 'TSh'],
            'UAH': [2, '\u20B4', 'UAH'],
            'UGX': [0, 'UGX', 'UGX'],
            'UYU': [1, '$', '$U'],
            'UZS': [0, 'so\u02bcm', 'UZS'],
            'VEF': [2, 'Bs', 'Bs'],
            'VUV': [0, 'VUV', 'VUV'],
            'WST': [2, 'WST', 'WST'],
            'XAF': [0, 'FCFA', 'FCFA'],
            'XCD': [2, '$', 'EC$'],
            'XOF': [0, 'CFA', 'CFA'],
            'XPF': [0, 'FCFP', 'FCFP'],
            'ZMK': [0, 'ZMK', 'ZMK']
        });


})();

(function () {
    'use strict';
    angular
        .module('currencyExchangeModule')
        .constant('XE_CURRENCIES_FORMAT', {
                "AUD": {
                    "format": "A$#"
                },
                "BGN": {
                    "format": "# leva"
                },
                "BRL": {
                    "format": "R$#"
                },
                "CAD": {
                    "format": "C$#"
                },
                "CHF": {
                    "format": "CHF #"
                },
                "CNY": {
                    "format": "元#"
                },
                "CZK": {
                    "format": "# Kč",
                    "fractional": false
                },
                "DKK": {
                    "format": "# kr."
                },
                "EUR": {
                    "format": "€#"
                },
                "GBP": {
                    "format": "£#"
                },
                "HKD": {
                    "format": "HK$#"
                },
                "HRK": {
                    "format": "# kn"
                },
                "HUF": {
                    "format": "# Ft",
                    "fractional": false
                },
                "IDR": {
                    "format": "Rp #",
                    "fractional": false
                },
                "ILS": {
                    "format": "₪#"
                },
                "INR": {
                    "format": "₹#"
                },
                "ISK": {
                    "format": "#kr",
                    "fractional": false
                },
                "JPY": {
                    "format": "¥ #",
                    "fractional": false
                },
                "KRW": {
                    "format": "₩#",
                    "fractional": false
                },
                "MXN": {
                    "format": "$#"
                },
                "MYR": {
                    "format": "RM#"
                },
                "NOK": {
                    "format": "# kr",
                    "fractional": false
                },
                "NZD": {
                    "format": "$#"
                },
                "PHP": {
                    "format": "₱#"
                },
                "PLN": {
                    "format": "#zł"
                },
                "RON": {
                    "format": "# lei"
                },
                "RUB": {
                    "format": "#₽"
                },
                "SEK": {
                    "format": "# kr",
                    "fractional": false
                },
                "SGD": {
                    "format": "S$#"
                },
                "THB": {
                    "format": "฿#"
                },
                "TRY": {
                    "format": "₺#"
                },
                "USD": {
                    "format": "$#"
                },
                "ZAR": {
                    "format": "R #"
                }
            }
        );


})();

(function() {
    'use strict';

    angular.module('currencyExchangeModule')
        .filter('forex', function(CurrencyExchange, CurrencyExchangeUtils) {
            'ngInject';
            return function(rate, override) {
                var outputCurrent;
                //console.log('forex...', input)

                if (CurrencyExchange.currencies.base.code === CurrencyExchange.currencies.current.code) {
                    return rate;
                } else if (CurrencyExchange.currencies.base.code === 'EUR') {
                    console.log('base currency: EUR');
                    outputCurrent = rate * CurrencyExchange.currencies.current.rate;
                } else if (CurrencyExchange.currencies.current.code === 'EUR') {
                    console.log('current currency: EUR');
                    outputCurrent = rate * (1 / CurrencyExchange.currencies.base.rate);
                } else {
                    console.log('current currency: else...');
                    outputCurrent = rate * (CurrencyExchange.currencies.current.rate * (1 / CurrencyExchange.currencies.base.rate));
                }
                console.log('converted from '+CurrencyExchange.currencies.base.code+' to '+CurrencyExchange.currencies.current.code+': '+outputCurrent);

                return outputCurrent;
            };
        })
        .filter('forexsingle', function(CurrencyExchange) {
            'ngInject';
            return function(rate, override) {
                var outputCurrent;

                if (CurrencyExchange.currencies.base.code === CurrencyExchange.currencies.current.code) {
                    return rate;
                } else if (CurrencyExchange.currencies.base.code === 'EUR') {
                    outputCurrent = rate * CurrencyExchange.currencies.current.rate;
                } else if (CurrencyExchange.currencies.current.code === 'EUR') {
                    outputCurrent = rate * (1 / CurrencyExchange.currencies.base.rate);
                } else {
                    outputCurrent = rate * (CurrencyExchange.currencies.current.rate * (1 / CurrencyExchange.currencies.base.rate));
                }
                return outputCurrent;
            };
        })
        .filter('exchangenumber', function (CurrencyExchange, XE_CURRENCIES, $filter) {
            'ngInject';
            return function (input, fromCode, toCode, toString) {
                var outputCurrent;

                var fromCurrencyCode = fromCode || CurrencyExchange.currencies.base.code;
                var fromCurrency = CurrencyExchange.currencies.all[fromCurrencyCode];

                //for groups we might not have current currency so treat FROM as CURRENT
                var currentCurrency = CurrencyExchange.currencies.current || fromCurrency;

                var toCurrencyCode = toCode || currentCurrency.code;
                var toCurrency = CurrencyExchange.currencies.all[toCurrencyCode];

                if (fromCurrency.code === toCurrency.code) {
                    outputCurrent = input;
                } else if (fromCurrency.code === 'EUR') {
                    outputCurrent = input * toCurrency.rate;
                } else if (toCurrency.code === 'EUR') {
                    outputCurrent = input * (1 / fromCurrency.rate);
                } else {
                    outputCurrent = input * (toCurrency.rate * (1 / fromCurrency.rate));
                }

                //return outputCurrent;
                var toCurrencyDetails = XE_CURRENCIES[toCurrencyCode];

                if(!toCurrencyDetails){
                    return outputCurrent;
                }

                var fractionLength = toCurrencyDetails[0];//first element is fraction length
                var multiplier = Math.pow(10, fractionLength);
                var price = Math.round(outputCurrent * multiplier) / multiplier;

                if(toString){
                    return $filter('number')(price, fractionLength);
                }

                return price;
            }
        })
        .filter('c', function($locale){
            'ngInject';
            var formats = $locale.NUMBER_FORMATS;

            return function(amount, currencySymbol, fractionSize) {
                if (angular.isUndefined(currencySymbol)) {
                    currencySymbol = formats.CURRENCY_SYM;
                }

                if (angular.isUndefined(fractionSize)) {
                    fractionSize = formats.PATTERNS[1].maxFrac;
                }

                // If the currency symbol is empty, trim whitespace around the symbol
                var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;

                // if null or undefined pass it through
                return amount === null ? amount : CurrencyExchangeUtils.format(amount, XE_CURRENCIES_FORMAT[currencySymbolRe], fractionSize);
            };
        });


})();

(function() {
    'use strict';

    function randomIntFromInterval(min, max) {
        // min and max included
        return Math.floor(Math.random() * (max - min + 1) + min);
    }

    function PriceFilterController($log, $scope, $timeout) {
        'ngInject';
        var ctrl = this;

        //for the moment $log prints in production profile, so overwriting with console
        var $log = console;

        ctrl.$onInit = function() {
            $log.info('$onInit PriceFilterController');
            ctrl.priceRange = ctrl.priceRange || {};
            $log.info('priceRange', ctrl.priceRange);
            ctrl.loadingData = false;
            var priceRangeKeysArray = Object.keys(ctrl.priceRange).map(function(v) {
                return parseInt(v);
            });
            ctrl.minPrice = Math.min.apply(null, priceRangeKeysArray);
            ctrl.maxPrice = Math.max.apply(null, priceRangeKeysArray);

            ctrl.priceOverlay = false;

            $log.info('min/maxPrice', ctrl.minPrice, ctrl.maxPrice);
            /*
            * this is the ideal approach, but it will only work if step is currency exchanged and amounts to 20 euro in value
            ctrl.stepPrice = 20;
            var numberOfBins = Math.ceil((ctrl.maxPrice - ctrl.minPrice) / ctrl.stepPrice);
            */
            var numberOfBins = 40;
            //when using ceil: (2.1 becomes 3, 2.9 becomes 3)
            ctrl.stepPrice = Math.ceil((ctrl.maxPrice - ctrl.minPrice) / numberOfBins);
            $log.info('result stepPrice 1', ctrl.stepPrice);
            //minimum step we want is 10 and then ceil to the nearest 10 (2 becomes 10, 19 becomes 20)
            //ctrl.stepPrice = Math.ceil(ctrl.stepPrice / 10) * 10;
            //$log.info('result stepPrice 2', ctrl.stepPrice);

            ctrl.graphItems = ctrl.generateGraphItems(ctrl.priceRange,ctrl.minPrice,ctrl.maxPrice,ctrl.stepPrice);

            //price range slider
            ctrl.slider = {
                minValue: ctrl.min || 0,
                maxValue: ctrl.max || ctrl.graphItems[ctrl.graphItems.length - 1].max,
                options: {
                    floor: 0,
                    ceil: ctrl.graphItems[ctrl.graphItems.length - 1].max,
                    step: ctrl.stepPrice,
                    hidePointerLabels: true,
                    hideLimitLabels: true,
                },
            };
        };

        ctrl.generateGraphItems = function(priceIntervals,minPrice,maxPrice,stepPrice){

            var graphItems = [];

            for (var i = 0; i <= maxPrice && stepPrice>0; i += stepPrice) {
                var graphItem = {
                    min: i,
                    max: i + stepPrice /*- 1*/,
                    height: 0,
                    count: 0,
                };

                graphItems.push(graphItem);
            }

            var maxGraphCount = 0;

            graphItems.forEach(function(v, i) {
                //$log.info('------------');
                Object.keys(priceIntervals).filter(function(prKey) {
                    var keyInt = parseInt(prKey);
                    //$log.info('keyInt', keyInt, v.min, v.max);
                    if (keyInt >= v.min && keyInt <= v.max) {
                        v.count += priceIntervals[keyInt];
                        if (v.count > maxGraphCount) {
                            maxGraphCount = v.count;
                        }
                    }
                });
            });

            graphItems.map(function(v, i) {
                v.height = Math.round((64 / maxGraphCount) * v.count);
            });

            $log.info('graphItems', graphItems, maxGraphCount);

            return graphItems;

        }


        ctrl.checkRange = function(min, max) {
            if (
                (min < ctrl.slider.minValue && max < ctrl.slider.minValue) ||
                (max > ctrl.slider.maxValue && max > ctrl.slider.maxValue)
            ) {
                return true;
            } else {
                return false;
            }
        };

        ctrl.togglePriceButton = function(open) {
            //$log.info('price toggled', open, ctrl.priceOverlay);
            $log.info('price toggled', open);
            $timeout(function() {
                $scope.$broadcast('rzSliderForceRender');
            });
        };

        ctrl.save = function() {
            $log.info('save...?!', ctrl.slider.maxValue, ctrl.stepPrice);
            ctrl.loadingData = true;
            var promise = ctrl.onUpdatePromise({
                minPrice: ctrl.slider.minValue,
                maxPrice:
                    ctrl.slider.maxValue === ctrl.graphItems[ctrl.graphItems.length - 1].max + 1
                        ? 0
                        : ctrl.slider.maxValue,
            });
            var timeoutPromise = $timeout(1000*10);//10 seconds timeout
            timeoutPromise.then(function(){
                //try to resolve the promise after 10sec just in case
                promise.resolve();
            });
            promise.promise.then(function(){
                ctrl.loadingData = false;//stop loader
                ctrl.priceOverlay = false; //close overlay
            });

        };

        ctrl.clear = function() {
            $log.info(
                'ctrl.graphItems[ctrl.graphItems.length - 1].max',
                ctrl.graphItems[ctrl.graphItems.length - 1].max
            );
            ctrl.slider.minValue = 0;
            ctrl.slider.maxValue = ctrl.graphItems[ctrl.graphItems.length - 1].max + 1;
        };

    }

    angular.module('vobeApp').component('priceFilter', {
        templateUrl: 'app/components/vouchers/priceFilter/priceFilter.html',
        controller: PriceFilterController,
        bindings: {
            min: '<',
            max: '<',
            currencyString: '<',
            priceRange: '<',
            onUpdatePromise: '&',
        },
    });
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .directive('vouchersNavbarFixed', vouchersNavbarFixed);

    vouchersNavbarFixed.$inject = ['$window', '$rootScope'];

    function vouchersNavbarFixed($window, $rootScope) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {

        	var back2top_offset = 220;
		    var back2top_duration = 500;

		    $window.jQuery(window).scroll(function() {

		        if($window.innerWidth>767){
		            //we only do it for small viewports
		            return;
                }

                var top_of_screen = $(window).scrollTop();
                var top_of_nav = $window.jQuery(element).offset().top;
		        if (top_of_screen>top_of_nav && !$window.jQuery(element).hasClass('vouchers-navbar-is-fixed')) {
                    //if this element has negative offset (we scroll past visible view on mobiles)
                    $window.jQuery(element).addClass('vouchers-navbar-is-fixed');
                    $window.jQuery(element).find('.vouchers-navbar.allow-fixed').addClass('vouchers-navbar-fixed');
		        } else if(top_of_screen<=top_of_nav) {
                    $window.jQuery(element).removeClass('vouchers-navbar-is-fixed');
                    $window.jQuery(element).find('.vouchers-navbar.allow-fixed').removeClass('vouchers-navbar-fixed');
		        }
		    });



        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PropertyVouchersNavbarController', PropertyVouchersNavbarController);

    function PropertyVouchersNavbarController ($rootScope,$scope,$state,$location, Auth, Principal, ProfileService, LoginService, $translate, CurrencyExchange) {
        'ngInject';
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isWorldNavbarCollapsed = true;
        vm.isSortNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.currentLanguageCode = $translate.use();
        vm.currentCurrency = CurrencyExchange.currencies.current;//current currency might be NULL if this is group engine


        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.toggleWorldNavbar = toggleWorldNavbar;
        vm.collapseWorldNavbar = collapseWorldNavbar;
        vm.toggleSortNavbar = toggleSortNavbar;
        vm.collapseSortNavbar = collapseSortNavbar;


        vm.languages;
        vm.onAvailableLanguages = function(languages){
            vm.languages=languages;
        }
        vm.availableCurrencies;
        vm.onAvailableCurrencies = function(availableCurrencies){
            vm.availableCurrencies=availableCurrencies;
        }

        vm.onCurrencyChanged = function(currency){
            if(vm.onCurrencyUpdated/*from component*/){
                vm.onCurrencyUpdated(currency);
            }
            vm.currentCurrency = CurrencyExchange.currencies.current;
        }

        vm.$state = $state;
        vm.stateParams = $location.search();

        //vm.shoppingCartConfigs = shoppingCartConfigs;
        //vm.currentProperty = currentProperty;


        function toggleWorldNavbar() {
            vm.isWorldNavbarCollapsed = !vm.isWorldNavbarCollapsed;
        }
        function collapseWorldNavbar() {
            vm.isWorldNavbarCollapsed = true;
        }

        function toggleSortNavbar() {
            vm.isSortNavbarCollapsed = !vm.isSortNavbarCollapsed;
        }
        function collapseSortNavbar() {
            vm.isSortNavbarCollapsed = true;
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }
        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }


        vm.openShoppingCartNavbar = openShoppingCartNavbar;
        function openShoppingCartNavbar() {
        	$rootScope.$emit('openShoppingCartDropdown');
        }


        vm.$onInit = function(){

            vm.useCategorySequence = false;
            var propertyId = vm.currentProperty.hotelId;
            if (vm.shoppingCartConfigs[propertyId] && vm.shoppingCartConfigs[propertyId].configMap && vm.shoppingCartConfigs[propertyId].configMap.useCategorySequence && vm.shoppingCartConfigs[propertyId].configMap.useCategorySequence=='true') {
                vm.useCategorySequence = true;
            }
            //vm.useCategorySequence = true;//for testing purposes

            vm.determineVoucherPoolOrderBy = function(){
                var mainOrderBy = 'sequence';
                if(vm.settings && vm.settings.voucherPoolOrderBy && vm.settings.voucherPoolOrderBy.name){
                    var mainOrderBy = vm.settings.voucherPoolOrderBy.name.split("_")[0];
                }
                var voucherCategoryShortCodes = vm.voucherClassActive ? vm.voucherClassActive.split(",") : [];
                if(mainOrderBy == 'sequence' && vm.useCategorySequence && voucherCategoryShortCodes.length==1 && voucherCategoryShortCodes[0]!='all'){
                    vm.voucherPoolOrderBy = 'sequence_'+voucherCategoryShortCodes[0];
                } else {
                    vm.voucherPoolOrderBy = mainOrderBy;
                }
                //UPDATE PARENT
                vm.settings.voucherPoolOrderBy = vm.settings.voucherPoolOrderBy != vm.voucherPoolOrderBy ? vm.voucherPoolOrderBy : vm.settings.voucherPoolOrderBy;
            }
            //INITIAL SORT
            vm.determineVoucherPoolOrderBy();

            //$scope.$watch('vm.settings.voucherPoolOrderBy.name', function () {
            //    console.log('vm.settings.voucherPoolOrderBy.name: ',vm.settings.voucherPoolOrderBy.name);
            //});

        }


    }
})();

(function() {
    'use strict';

    angular.module('vobeApp').component('voucherNavbar', {
        templateUrl: 'app/components/vouchers/navbar/vouchers-navbar.html',
        controller: 'PropertyVouchersNavbarController',
        controllerAs: 'vm',
        bindings: {
            shoppingCart: '<',
            shoppingCartConfigs: '<',
            currentProperty: '<',
            currentPropertyGroup: '<',
            onCurrencyUpdated: '<',
            //needed for sorting & columns layout:
            isGroup: '<',
            showCategoriesBoxType: '<',
            showSortControls: '<',
            settings: '<',
            showColumnControls: '<',
            viewLayoutTiles : '<',
            //needed for promotion box:
            showPromoControls: '<',
            processingPromotionCode: '<',
            appliedPromotionCode: '<',
            promotionCode: '<',
            applyPromotionCode: '<',
            removePromotionCode: '<',
            voucherClassActive: '<'
        }
    });
})();

(function() {
    'use strict';


    angular
        .module('vobeApp')
        .controller('VoucherTilesSlickController', VoucherTilesSlickController);


    function VoucherTilesSlickController($log) {
        'ngInject';
        var vm = this;

        vm.$onInit = function() {
            vm.slickTiles = true;
            vm.tilesSettings = angular.copy(vm.tilesSettings);  //make copy, don't redraw slick on parent object updates
            vm.tilesSettings.voucherPoolOrderBy = 'sequence_featured';
            vm.viewLayout = angular.copy(vm.viewLayout);        //make copy, don't redraw on parent object updates
            vm.viewLayout.activeBreakpoint.cards = 1;
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .component('voucherTilesSlick', {
            templateUrl: 'app/components/vouchers/layouts/voucher-tiles-slick.html',
            controller: 'VoucherTilesSlickController',
            controllerAs: 'vm',
            bindings: {
                slickSettings: '<',//like vm.settings
                allVouchers: '<',
                onlyFeatured: '<',
                viewLayoutTileDesign : '<',//default or text
                viewLayout : '<',
                tilesSettings: '<',//like vm.settings
                appliedPromotionCode: '<',
                channel: '<',
                voucherPoolObject: '<',
                currentProperty: '<',
                currentPropertyGroup: '<',
                shoppingCart: '<',
                websiteType: '<',//group or property
                descriptionLines: '<',
                openPackageModal: '<',//function
                openCashModal: '<',//function
                groupCategories: '<',
                propertyCategories: '<',
                filterPrice: '<',//function
                filterCategory: '<',//function
                filterGiftCardByVoucherClass: '<',
                filterCashOnly: '<',
                filterVouchersByFeatured: '<'
            }
        });
})();

(function() {
    'use strict';


    angular
        .module('vobeApp')
        .controller('VoucherTilesController', VoucherTilesController);


    function VoucherTilesController($log) {
        'ngInject';
        var vm = this;

        vm.$onInit = function() {
            $log.info('$onInit VoucherTilesController');
            //vm.tiles = vm.viewLayout.activeBreakpoint.cards;
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .component('voucherTiles', {
            templateUrl: 'app/components/vouchers/layouts/voucher-tiles.html',
            controller: 'VoucherTilesController',
            controllerAs: 'vm',
            bindings: {
                allVouchers: '<',
                onlyFeatured: '<',
                viewLayoutTileDesign : '<',//default or text
                viewLayout : '<',
                tilesSettings: '<',//like vm.settings
                appliedPromotionCode: '<',
                channel: '<',
                voucherPoolObject: '<',
                currentProperty: '<',
                currentPropertyGroup: '<',
                shoppingCart: '<',
                websiteType: '<',//group or property
                descriptionLines: '<',
                openPackageModal: '<',//function
                openCashModal: '<',//function
                groupCategories: '<',
                propertyCategories: '<',
                filterPrice: '<',//function
                filterCategory: '<',//function
                filterGiftCardByVoucherClass: '<',
                filterCashOnly: '<',
                filterVouchersByFeatured: '<'
            }
        });
})();

(function() {
    'use strict';

    function CategoryFilterController($log, $timeout) {
        'ngInject';
        var ctrl = this;

        //for the moment $log prints in production profile, so overwriting with console
        var $log = console;

        ctrl.$onInit = function() {
            $log.info('$onInit FilterBarController');
            //used for voucherIds count
            ctrl.loadingData = false;
            ctrl.categoriesOpen = false;
            ctrl.voucherFilterArray = [];
            ctrl.categoriesSelected = ctrl.categoriesSelected || {};
            ctrl.syncViewData();
            ctrl.categoryChanged();
        };

        ctrl.syncViewData = function(){
            ctrl.selectedCategoriesApplied = (ctrl.voucherClassActive ? ctrl.voucherClassActive.split(',') : [])
                .filter(function(value, index, arr){
                return value!='all';
            });
            angular.forEach(ctrl.selectedCategoriesApplied,function (friendlyName, i) {
                ctrl.categoriesSelected[friendlyName] = true;
            });
        }

        ctrl.countSelected = function(){
            if(typeof ctrl.categoriesSelected === 'undefined' || ctrl.categoriesSelected==null){
                return 0;
            }
            var counter = 0;
            for (var selectedFriendlyNameKey in ctrl.categoriesSelected) {
                var selectedValue = ctrl.categoriesSelected[selectedFriendlyNameKey];

                if (selectedValue) {
                    counter++;
                }
            }
            return counter;
        }

        ctrl.toggled = function(open) {
            $log.info('toggled', open);
            ctrl.syncViewData();
            //when closing, run through the selected and applied categories and remove the checkboxes as needed.
            if (!open) {
                for (var selectedFriendlyNameKey in ctrl.categoriesSelected) {
                    var selectedValue = ctrl.categoriesSelected[selectedFriendlyNameKey];

                    if (!ctrl.selectedCategoriesApplied.includes(selectedFriendlyNameKey)) {
                        ctrl.categoriesSelected[selectedFriendlyNameKey] = false;
                    }
                }
            }
        };

        ctrl.categoryChanged = function() {
            $log.info('categoryChanged', ctrl.categoriesSelected);
            var newFilterArray = [];

            angular.forEach(ctrl.voucherClassCounter, function(vc, index) {
                //has category object
                if (vc.category) {
                    //$log.info('category selected', vc);
                    //iterate over keys selected or unselected..
                    for (var selectedFriendlyNameKey in ctrl.categoriesSelected) {
                        var selectedValue = ctrl.categoriesSelected[selectedFriendlyNameKey];

                        //check if selected then add to new array
                        if (selectedFriendlyNameKey === vc.category.friendlyName && selectedValue) {
                            angular.forEach(vc.category.voucherIds, function(vid) {
                                if(!newFilterArray.includes(vid)){
                                    newFilterArray.push(vid);
                                }
                            });
                        }
                    }
                }
            });

            $log.info('newFilterArray', newFilterArray);
            //commenting out as ES6 syntax breaks production build with no error (gulp has --no-notifications oprion ON)
            //ctrl.voucherFilterArray = [...new Set(newFilterArray)]; //todo: does this work everywhere
            ctrl.voucherFilterArray = newFilterArray;
        };

        ctrl.clear = function() {
            //clears all category filters
            ctrl.voucherFilterArray = [];
            ctrl.categoriesSelected = {};
            ctrl.selectedCategoriesApplied =[];
            //notifyChange(ctrl.selectedCategoriesApplied);
        };

        ctrl.filterVouchers = function() {
            var selectedCategories = [];
            for (var key in ctrl.categoriesSelected) {
                if (ctrl.categoriesSelected[key]) {
                    selectedCategories.push(key);
                }
            }
            $log.info('filterVouchers', selectedCategories);
            ctrl.selectedCategoriesApplied = selectedCategories;
            notifyChange(selectedCategories);

        };

        /**
         * PRIVATE FUNCTIONS
         */
        function notifyChange(selectedCategories){
            //notify others about new categories and close after
            ctrl.loadingData = true;
            var promise = ctrl.onUpdatePromise({ selectedCategories: selectedCategories });
            var timeoutPromise = $timeout(1000*10);//10 seconds timeout
            timeoutPromise.then(function(){
                //try to resolve the promise after 10sec just in case
                promise.resolve();
            });
            promise.promise.then(function(){
                ctrl.loadingData = false;//stop spinner
                ctrl.categoriesOpen = false; //close dropdown
            });
        }
    }



    angular.module('vobeApp').component('categoryFilter', {
        templateUrl: 'app/components/vouchers/categoryFilter/categoryFilter.html',
        controller: CategoryFilterController,
        bindings: {
            voucherClassCounter: '<',
            voucherClassActive: '<',
            sortVoucherClass: '<',
            onUpdatePromise: '&',
        },
    });
})();

(function() {
    'use strict';

    angular.module('vobeApp').directive('ellipsisTextInner',
        ellipsisTextInner);

    ellipsisTextInner.$inject = ['$sce'];

    function ellipsisTextInner($sce) {
        var directive = {
            restrict : 'A',
            //scope: {
                //options : '=ellipsisTextInner'
            //},
            //transclude : true,
            //template: '<div class="w3-text-grey description-text-inner" style="overflow: hidden;"><div ng-transclude></div></div>',
            //Require another directive and inject its controller as the fourth argument to the linking function.
            //The require property can be a string, an array or an object:
            //require: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
            require: '^ellipsisText',
            link : postLinkFunc
        };

        return directive;

        function postLinkFunc($scope, $element, $attrs, ellipsisText) {

            $element.ready(function(){

                var height = $element.height();
                var fontSizePx = $element.css('font-size');
                var fontSize = parseInt(fontSizePx.replace('px',''));

                //console.log("ellipsisTextInner",height,fontSize);

                //reporting height to parent:
                ellipsisText.innerHeight(height,fontSize);
            });


        }
    };
})();

(function() {
    'use strict';

    angular.module('vobeApp').directive('ellipsisText',
        ellipsisText);

    ellipsisText.$inject = ['$sce'];

    function ellipsisText($sce) {
        var directive = {
            restrict : 'A',
            scope: {
                options : '=ellipsisText'
            },
            controller : 'EllipsisTextController'
        };

        return directive;

    };

})();

/* eslint-disable no-console */
(function() {
    'use strict';

    angular.module('vobeApp').controller('EllipsisTextController', EllipsisTextController);

    EllipsisTextController.$inject = [
        '$scope',
        '$element',
        '$window'
    ];

    function EllipsisTextController(
        $scope,
        $element,
        $window
    ) {

        //console.log("ellipsisText",$element.height());

        //reporting height to parent:
        this.innerHeight = function(innerHeight, innerFontSize){

            if(innerHeight==0){
                //console.error("Inner height is 0");
                return;
            }

            handleEllipsis(innerHeight, innerFontSize, $element, $scope.options || {})
        };


        function handleEllipsis(innerHeight, innerFontSize, $element, options) {

            var requiredLines = options.descriptionLines || 3;
            var lineHeight = options.lineHeight || 1.36;//average and will work with most of the fonts, must be same as in CSS
            var ellipsisHeight = 50;//as in CSS

            var descriptionConteinerHeight = Math.floor(innerFontSize * lineHeight) * requiredLines;

            //set height of the container based on required lines
            //console.log("heightOfContainer",descriptionConteinerHeight);
            //console.log("heightOfText",innerHeight);

            var textLargerThanContainerAndRequireEllipsis = (descriptionConteinerHeight + ellipsisHeight) < innerHeight;

            var ellipsisEl = $element.find('.ellipsis');
            if (ellipsisEl.length == 0) {
                return;
            }

            if (textLargerThanContainerAndRequireEllipsis) {
                ellipsisEl.show();
                $element.find('.ellipsis-more').show();
                $element.height(descriptionConteinerHeight + ellipsisHeight);
            }
            else {
                ellipsisEl.hide();
                $element.find('.ellipsis-more').hide();
            }

            if(options.revealHeightIfNoHeight && $element.height()==0){
                $element.height('auto');
            }

            if(options.revealHeight){
                $element.height('auto');
            }

            if (options.scrollToId) {
                var childOffset = $window.jQuery('#' + options.scrollToId).offset();
                if(childOffset){
                    var parentOffset = $window.jQuery('#' + options.scrollToId).parent().offset();
                    if(parentOffset){
                        var childTopOffset = childOffset.top;
                        var parentTopOffset = parentOffset.top;
                        if(childTopOffset>parentTopOffset+60) {
                            $element.animate({scrollTop: childTopOffset}, 1000);
                        }
                    }
                }
            }
        }


    }
})();

(function() {
    'use strict';

    angular.module('vobeApp').component('cardPackageSingleText', {
        templateUrl: 'app/components/vouchers/card/text/card-package-single-text.html',
        controller: 'CardPackageSingleController',
        controllerAs: '$ctrl',
        bindings: {
            viewLayoutTileDesign : '<',//default or text
            tiles: '<', //3 or 4 or 6
            descriptionLines : '<',
            settings: '<',//like vm.settings
            appliedPromotionCode: '<',
            channel: '<',
            //voucherObject: '<',
            voucherPoolObject: '<',
            currentProperty: '<',
            currentPropertyGroup: '<',
            shoppingCart: '<',
            openPackageModal: '<',//function
            websiteType: '<',//group or property
            groupCategories: '<',
            propertyCategories: '<',
            onlyFeatured: '<',
        }
    });
})();

(function() {
    'use strict';

    angular.module('vobeApp').component('cardCashCombinedText', {
        templateUrl: 'app/components/vouchers/card/text/card-cash-combined-text.html',
        controller: 'CardCashCombinedController',
        controllerAs: '$ctrl',
        bindings: {
            viewLayoutTileDesign : '<',//default or text
            tiles: '<', //3 or 4 or 6
            descriptionLines : '<',
            settings: '<',//like vm.settings
            appliedPromotionCode: '<',
            channel: '<',
            //voucherObject: '<',
            voucherPoolObject: '<',
            currentProperty: '<',
            currentPropertyGroup: '<',
            shoppingCart: '<',
            openCashModal: '<',//function
            websiteType: '<',//group or property
            onlyFeatured: '<',
        }
    });
})();

(function() {
    'use strict';

    angular.module('vobeApp').component('cardPackageSingleDefault', {
        templateUrl: 'app/components/vouchers/card/default/card-package-single-default.html',
        controller: 'CardPackageSingleController',
        controllerAs: '$ctrl',
        bindings: {
            viewLayoutTileDesign : '<',//default or text
            tiles: '<', //3 or 4 or 6
            settings: '<',//current view settings
            appliedPromotionCode: '<',
            channel: '<',
            //voucherObject: '<',
            voucherPoolObject: '<',
            currentProperty: '<',
            currentPropertyGroup: '<',
            shoppingCart: '<',
            openPackageModal: '<',//function
            websiteType: '<',//group or property
            groupCategories: '<',
            propertyCategories: '<',
            onlyFeatured: '<',
        }
    });
})();

(function() {
    'use strict';

    angular.module('vobeApp').component('cardCashCombinedDefault', {
        templateUrl: 'app/components/vouchers/card/default/card-cash-combined-default.html',
        controller: 'CardCashCombinedController',
        controllerAs: '$ctrl',
        bindings: {
            viewLayoutTileDesign : '<',//default or text
            tiles: '<', //3 or 4 or 6
            settings: '<',//like vm.settings
            appliedPromotionCode: '<',
            channel: '<',
            //voucherObject: '<',
            voucherPoolObject: '<',
            currentProperty: '<',
            currentPropertyGroup: '<',
            shoppingCart: '<',
            openCashModal: '<',//function
            websiteType: '<',//group or property
            onlyFeatured: '<',
        }
    });
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('CardPackageSingleController', CardPackageSingleController);

    function CardPackageSingleController($scope, $rootScope, $stateParams, ShoppingCart, PromotionCodeService, CurrencyExchange /*,previousState, entity, Property, PropertyVouchers, User, $animate, $timeout, $document*/) {
        'ngInject';
        var vm = this;

        vm.$onInit = function(){

            //this is from bindings:
            /*
            vm.voucherObject;
            vm.currentProperty;
            vm.currentPropertyGroup;
            vm.websiteType;
            vm.onOpenModal;
            vm.groupCategories;
            vm.propertyCategories;
            */
            vm.voucherPoolObject = vm.voucherPoolObject || {};
            vm.singleMode = (vm.voucherPoolObject && vm.voucherPoolObject.vouchers && getVoucherPoolLength()==1);
            vm.homogeneous = isVoucherPoolHomogeneous();
            vm.openPackageModal = vm.openPackageModal || angular.noop;
            vm.viewLayoutTileDesign =  vm.viewLayoutTileDesign  || 'default';
            vm.descriptionLines = vm.descriptionLines || 3;

            //vm.currentVoucher = vm.voucherObject;
            vm.voucherPoolObjectVouchersArray = [];
            angular.forEach(vm.voucherPoolObject.vouchers,function(voucher,vkey){
                if(!voucher.variationName){
                    voucher.variationName = voucher.voucherName;
                }
                vm.voucherPoolObjectVouchersArray.push(voucher);
            });
            vm.firstVoucher = firstVoucher();
            vm.voucherObject = vm.firstVoucher;//for the moment only first
            vm.voucherObjectFirstCategory = vm.getFirstApplicableCategory(vm.voucherObject,'');
            vm.poolCategory = getPoolCategory(vm.voucherObject);




            vm.currentProperty = vm.currentProperty || {};
            vm.currentPropertyGroup = vm.currentPropertyGroup;
            var isGroup = typeof vm.currentPropertyGroup !== 'undefined';
            vm.isGroup = isGroup;
            vm.voucherProperty = getVoucherProperty();

            vm.giftCard = vm.voucherPoolObject.giftCard || undefined;
            vm.getImageFileName = getImageFileName;
            vm.revealedDescription = false;


            //recheck applied promotion code in case we have 2 or more promotion codes
            vm.appliedPromotionCode = PromotionCodeService.findApplicablePromo(vm.shoppingCart, vm.currentProperty, isGroup, vm.firstVoucher);;

            $scope.$on('itemAddedToCart', function(event, args) {
                vm.shoppingCart = args.shoppingCart;
            });
            $scope.$on('itemRemovedFromCart', function(event, args) {
                vm.shoppingCart = args.shoppingCart;
            });

            $scope.$on('voucherClassActive', function(event, args) {
                var categoryShortCodes = args.voucherClassActive ? args.voucherClassActive.split(',') : undefined;
                vm.voucherObjectFirstCategory = vm.getFirstApplicableCategory(vm.voucherObject,categoryShortCodes && categoryShortCodes.length>0 ? categoryShortCodes[0] : undefined);
            });

            //currency
            vm.baseCurrency = {
                code : vm.voucherObject.currency
            };

            vm.currentCurrency = {
                code : vm.baseCurrency.code
            }
            var currentCurrency = CurrencyExchange.currencies.current;//current currency might be NULL if this is group engine
            if(currentCurrency && currentCurrency!=null){
                vm.currentCurrency.code = currentCurrency.code;
            }

            $rootScope.$on('CurrencyExchangeProvider.changeCurrency', function(event, args) {
                vm.currentCurrency.code = args.code;
            });

        };

        function firstVoucher(){
            var firstVoucher;
            angular.forEach(vm.voucherPoolObject.vouchers,function(voucher,vkey){
                firstVoucher = firstVoucher || voucher;
                if (voucher.sequence < firstVoucher.sequence) {
                    firstVoucher = voucher;
                }
            });
            return firstVoucher;
        }

        function getVoucherProperty(){
            if(!vm.firstVoucher){
                return undefined;
            }
            if(!vm.currentPropertyGroup || !vm.currentPropertyGroup.hotels){
                return undefined;
            }
            var property = undefined;
            angular.forEach(vm.currentPropertyGroup.hotels,function(hotel,hkey){
                if(hotel.hotelId==vm.firstVoucher.hotelId){
                    property = hotel;
                }
            });
            return property;
        }

        function getVoucherPoolLength(){

            var count = 0;
            angular.forEach( vm.voucherPoolObject.vouchers,function(voucher,vkey){
                count++;
            });
            return count;
        }

        function isVoucherPoolHomogeneous(){

            var voucherIds = [];
            angular.forEach( vm.voucherPoolObject.vouchers,function(voucher,vkey){
                if(!voucherIds.includes(voucher.id)){
                    voucherIds.push(voucher.id);
                }
            });
            return voucherIds.length<=1;
        }

        function getPoolCategory(voucher){
            var categories = vm.websiteType=='group' ? vm.groupCategories : vm.propertyCategories;

            var poolCategory;

            angular.forEach(categories,function(c,cKey){
                if(c.id==vm.voucherPoolObject.poolId){
                    poolCategory = c;
                }
            });
            return poolCategory;
        }

        //when we change the variation
        vm.onVoucherObjectChanged = onVoucherObjectChanged;
        function onVoucherObjectChanged(voucherObject){
            //recheck applied promotion code in case we have 2 or more promotion codes
            vm.appliedPromotionCode = PromotionCodeService.findApplicablePromo(vm.shoppingCart, vm.currentProperty, vm.isGroup, vm.voucherObject);


        }

        function getImageFileName(){
            if (vm.firstVoucher && vm.firstVoucher.images && vm.firstVoucher.images!=null && vm.firstVoucher.images[7]) {
                return useImgix(vm.firstVoucher.images[7]);
            } else {
                return "//in1-image-library.imgix.net/no-image.jpg";
            }
        }

        vm.getFirstApplicableCategory = function(voucher,voucherClassActive){
            var category;
            angular.forEach(voucher.categories,function(c,cKey){
                if(!category){
                    category = c;
                }
                if(''+voucherClassActive==''+c.classId){
                    category = c;
                }
            });
            return category;
        }

        vm.toggleDescription = function($event){
            $event.preventDefault();
            $event.stopPropagation();
            vm.revealedDescription = !vm.revealedDescription;
            return false;
        }


        function useImgix(imgUrl){
            var old_host = 'dddo4e1h8fdy4.cloudfront.net';
            var new_host = 'in1-image-library.imgix.net';
            return imgUrl.replace(old_host, new_host);
        }

        vm.isPoolAvailableToBuy = function(){
            var voucherPool = vm.voucherPoolObject;
            var shoppingCart = vm.shoppingCart;
            var countAvailable = 0;
            angular.forEach(voucherPool.vouchers, function(v, vkey) {
                var sold = v.vouchersSold;
                if(shoppingCart && shoppingCart.shoppingCartItems && shoppingCart.shoppingCartItems.items){
                    angular.forEach(shoppingCart.shoppingCartItems.items, function(value, key) {
                        if(value.itemId == v.id){
                            sold++;
                        }
                    });
                }

                var available = v.voucherCount >=999 ? 99999 : v.voucherCount;
                if(sold<available){
                    countAvailable++;
                }
            });
            return countAvailable>0;
        }

        vm.openModal = function(){
            vm.openPackageModal({voucherPool:vm.voucherPoolObject, voucherId: vm.voucherObject.id});
        }

        vm.stopPropagation = function($event){
            $event.stopPropagation();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('CardCashCombinedController', CardCashCombinedController);

    function CardCashCombinedController(
        $scope,
        $rootScope,
        $stateParams,
        ShoppingCart,
        PromotionCodeService,
        CurrencyExchange
        /*,previousState, entity, Property, PropertyVouchers, User, $animate, $timeout, $document*/) {
        'ngInject';
        var vm = this;

        vm.$onInit = function(){

            //vm.voucherObject = vm.voucherObject || {};
            vm.voucherPoolObject = vm.voucherPoolObject || {};
            if(vm.voucherPoolObject.minValue<vm.voucherPoolObject.maxValue){
                vm.singleMode = false;
            }
            else if(vm.voucherPoolObject.type=='cash'){
                vm.singleMode = false;
            }
            else if(vm.voucherPoolObject.featured) {
                vm.singleMode = true;
            } else {
                vm.singleMode = (vm.voucherPoolObject && vm.voucherPoolObject.vouchers && getVoucherPoolLength() == 1);
            }



            vm.openCashModal = vm.openCashModal || angular.noop;
            vm.viewLayoutTileDesign =  vm.viewLayoutTileDesign  || 'default';
            vm.descriptionLines = vm.descriptionLines || 3;

            //vm.currentVoucher = vm.voucherObject;
            vm.currentVoucherPool = vm.voucherPoolObject;
            vm.firstVoucher = firstVoucher();
            vm.voucherObjectFirstCategory = getFirstApplicableCategory(vm.firstVoucher,'');


            vm.currentProperty = vm.currentProperty || {};
            vm.currentPropertyGroup = vm.currentPropertyGroup;
            var isGroup = typeof vm.currentPropertyGroup !== 'undefined';
            vm.isGroup = isGroup;
            vm.voucherProperty = getVoucherProperty();

            vm.giftCard = vm.voucherPoolObject.giftCard || undefined;
            vm.getGiftCardImageFileName = getGiftCardImageFileName;
            vm.getCategoryImageFileName = getCategoryImageFileName;
            vm.getImageFileName = getImageFileName;
            vm.revealedDescription = false;
            vm.toggleDescription = toggleDescription;

            //recheck applied promotion code in case we have 2 or more promotion codes
            vm.appliedPromotionCode = PromotionCodeService.findApplicablePromo(vm.shoppingCart, vm.currentProperty, isGroup, vm.firstVoucher);

            //currency
            vm.baseCurrency = {
                code : vm.firstVoucher.currency
            };

            vm.currentCurrency = {
                code : vm.baseCurrency.code
            }
            var currentCurrency = CurrencyExchange.currencies.current;//current currency might be NULL if this is group engine
            if(currentCurrency && currentCurrency!=null){
                vm.currentCurrency.code = currentCurrency.code;
            }

            $rootScope.$on('CurrencyExchangeProvider.changeCurrency', function(event, args) {
                vm.currentCurrency.code = args.code;
            });

        }

        function firstVoucher(){
            var firstVoucher;
            angular.forEach(vm.currentVoucherPool.vouchers,function(voucher,vkey){
                firstVoucher = firstVoucher || voucher;
            });
            return firstVoucher;
        }

        function getVoucherProperty(){
            if(!vm.firstVoucher){
                return undefined;
            }
            if(!vm.currentPropertyGroup || !vm.currentPropertyGroup.hotels){
                return undefined;
            }
            var property = undefined;
            angular.forEach(vm.currentPropertyGroup.hotels,function(hotel,hkey){
                if(hotel.hotelId==vm.firstVoucher.hotelId){
                    property = hotel;
                }
            });
            return property;
        }

        function getVoucherPoolLength(){

            var count = 0;
            angular.forEach( vm.voucherPoolObject.vouchers,function(voucher,vkey){
                count++;
            });
            return count;
        }


        //when we change the variation
        vm.onVoucherObjectChanged = onVoucherObjectChanged;
        function onVoucherObjectChanged(voucherObject){
            //recheck applied promotion code in case we have 2 or more promotion codes
            vm.appliedPromotionCode = PromotionCodeService.findApplicablePromo(vm.shoppingCart, vm.currentProperty, vm.isGroup, vm.voucherObject);

        }

        function getCategoryImageFileName(category){
            if(category.category.imageUrl){
                return useImgix(category.category.imageUrl);
            }
            return "//in1-image-library.imgix.net/no-image.jpg";
        }

        function getGiftCardImageFileName(){
            return getImageFileName();
        }

        function getImageFileName(){
            var giftCard = vm.giftCard;
            if(giftCard && giftCard.imageUrl && giftCard.imageUrl!=null && giftCard.imageUrl.trim().length>0){
                return useImgix( giftCard.imageUrl);
            }
            if (vm.firstVoucher && vm.firstVoucher.images && vm.firstVoucher.images!=null && vm.firstVoucher.images[7]) {
                return useImgix(vm.firstVoucher.images[7]);
            } else {
                return "//in1-image-library.imgix.net/no-image.jpg";
            }
        }

        function getFirstApplicableCategory(voucher,voucherClassActive){
            var category;
            angular.forEach(voucher.categories,function(c,cKey){
                if(!category){
                    category = c;
                }
                if(''+voucherClassActive==''+c.classId){
                    category = c;
                }
            });
            return category;
        }

        function toggleDescription($event){
            $event.preventDefault();
            $event.stopPropagation();
            vm.revealedDescription = !vm.revealedDescription;
            return false;
        }

        function useImgix(imgUrl){
            var old_host = 'dddo4e1h8fdy4.cloudfront.net';
            var new_host = 'in1-image-library.imgix.net';
            return imgUrl.replace(old_host, new_host);
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('vobeApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('vobeApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
            }
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('vobeApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular.module('vobeApp').component('sortNavbarDropdown', {
        templateUrl: 'app/components/shopping-cart/sort-dropdown/sort-nav-dropdown.html',
        controller: 'SortNavbarDropdownController',//same controller as dropdown button
        controllerAs: 'vm',
        bindings: {
            isGroup: '<',
            showCategoriesBoxType: '<',
            showSortControls: '<',
            settings: '<'
        }
    });
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('SortNavbarDropdownController', SortNavbarDropdownController);

	function SortNavbarDropdownController($scope, $rootScope, $state, $stateParams, $uibModal, $document) {
	    'ngInject';
	    var vm = this;
        vm.shoppingCart = vm.shoppingCart || {};
        vm.shoppingCartConfigs = vm.shoppingCartConfigs || {};
        vm.property = vm.property || {};


	}
})();

(function() {
    'use strict';

    angular.module('vobeApp').component('shoppingCartNavbarButton', {
        templateUrl: 'app/components/shopping-cart/shopping-cart-dropdown/shopping-cart-navbar.html',
        controller: 'ShoppingCartDropdownButtonController',//same controller as dropdown button
        controllerAs: 'vm',
        bindings: {
            shoppingCart: '<',
            shoppingCartConfigs: '<',
            property: '<',
            propertyGroup: '<'
        }
    });
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('ShoppingCartDropdownModalController', ShoppingCartDropdownModalController);

	function ShoppingCartDropdownModalController($scope, $rootScope, $state, $stateParams, ShoppingCartRemove, $translate, CurrencyExchange, $document) {
	    'ngInject';
	    var vm = this;

        vm.shoppingCart = vm.shoppingCart || $scope.$resolve.shoppingCart || {};
        vm.property = vm.property || $scope.$resolve.property;
        vm.shoppingCartConfigs = vm.shoppingCartConfigs || $scope.$resolve.shoppingCartConfigs;
        vm.propertyGroup = vm.propertyGroup || $scope.$resolve.propertyGroup;
        vm.clear = vm.clear || $scope.$resolve.clear || angular.noop;
        vm.removeItemFromCartAndRefresh = removeItemFromCartAndRefresh;
        vm.getAnyItemByPropertyId = getAnyItemByPropertyId;
        vm.goToShoppingCart = goToShoppingCart;
        vm.maxHeighStyle = maxHeighStyle();
        vm.appendToEl = angular.element($document).find('.vobe-cards-container');

        vm.shoppingCartOpen = false;
        vm.perishableAlerts = [];


        //currency
        vm.currentCurrency = {
            code : undefined
        }
        var currentCurrency = CurrencyExchange.currencies.current;//current currency might be NULL if this is group engine
        if(currentCurrency && currentCurrency!=null){
            vm.currentCurrency.code = currentCurrency.code;
        }

        $rootScope.$on('CurrencyExchangeProvider.changeCurrency', function(event, args) {
            vm.currentCurrency.code = args.code;
        });

        vm.$onInit = function() {



        };



        function maxHeighStyle(){
            var viewportHeight = $(window).height();
            return {'max-height':(viewportHeight - 50)+'px'};
        }

        function getAnyItemByPropertyId(propertyId){
            var anyItem;
            angular.forEach(vm.shoppingCart.shoppingCartItems.items,function(item,index){
                if(item.owningProperty.propertyId==propertyId){
                    anyItem = item;
                }
            });
            return anyItem;
        }


        function removeItemFromCartAndRefresh(event, itemUUID){
            event.preventDefault();
            removeItem(itemUUID, backToCurrent);

        }

        function backToCurrent(shoppingCart){
            $rootScope.$broadcast('itemRemovedFromCart', {shoppingCart : shoppingCart, openShoppingCartDropdown : true});
            if(!$state.includes('property.list')){
                $state.go($state.current,{}, { reload: true }).then(function() {
                    vm.shoppingCartOpen = true;
                });
            }

        }

        function goToShoppingCart(event){
            event.preventDefault();
            //we need to reload
            $state.go('shopping-cart',{}, { reload: true });

        }


        function removeItem(itemUUID, callback){

            var cb = callback || angular.noop;

            return ShoppingCartRemove.remove({itemUUID : itemUUID},
                function (shoppingCart) {
                    return cb(shoppingCart);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;

        }

        $scope.$on('itemAddedToCart',function(event, args){
            vm.shoppingCart = args.shoppingCart;
        });

        $scope.$on('itemRemovedFromCart',function(event, args){
            vm.shoppingCart = args.shoppingCart;
        });


	}
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('ShoppingCartDropdownButtonController', ShoppingCartDropdownButtonController);

	function ShoppingCartDropdownButtonController($scope, $rootScope, $state, $stateParams, $uibModal, $document) {
	    'ngInject';
	    var vm = this;
        vm.shoppingCart = vm.shoppingCart || {};
        vm.shoppingCartConfigs = vm.shoppingCartConfigs || {};
        vm.property = vm.property || {};

        function openShoppingCartDropdownModal(size, parentSelector) {

            var defaultModalOptions = {
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/components/shopping-cart/shopping-cart-dropdown/shopping-cart-dropdown-modal.html',
                controller: 'ShoppingCartDropdownModalController',
                controllerAs: 'vm',
                size: 'lg',
                appendTo: 'body',
                resolve: {
                    shoppingCart: function () {
                        return vm.shoppingCart;
                    },
                    property: function () {
                        return vm.property;
                    },
                    shoppingCartConfigs: function () {
                        return vm.shoppingCartConfigs;
                    },
                    propertyGroup: function () {
                        return vm.propertyGroup;
                    },
                    clear: function() {
                        return clear;
                    }
                }
            }

            var parentElem = parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;
            var modalOptions = angular.extend({},defaultModalOptions);
            modalOptions.templateUrl = 'app/components/shopping-cart/shopping-cart-dropdown/shopping-cart-dropdown-modal.html';
            modalOptions.appendTo = parentElem || modalOptions.appendTo;
            modalOptions.size = size || modalOptions.size;
            vm.modalInstance = $uibModal.open(modalOptions);

            function clear() {
                vm.modalInstance.dismiss('cancel');
            }

            //modalInstance.result.then(function (something) {
            //}, function () {
            //  console.info('Modal dismissed at: ' + new Date());
            //});
        };
        vm.openShoppingCartDropdownModal = openShoppingCartDropdownModal;

        $scope.$on('itemAddedToCart',function(event, args){
            vm.shoppingCart = args.shoppingCart;
            //vm.perishableAlerts.push({
            //	msg : $translate.instant('shopping-cart.alert.added.success'),
            //	type : "success"
            //});
            if($('#snackbar').length>0) {
                angular.element($("#snackbar")).parent().data('propertyAlertErrorScope').vm.addSuccessAlert('Added', 'shopping-cart.alert.added.success');
            }
        });

        $scope.$on('itemAddedToCartError',function(event, args) {
            if($('#snackbar').length>0) {
                var message = 'Error';
                if (args.data && args.data.message) {
                    message = args.data.message;
                }
                angular.element($("#snackbar")).parent().data('propertyAlertErrorScope').vm.addWarningAlert(message);
            }
        });


        $scope.$on('itemRemovedFromCart',function(event, args){
            vm.shoppingCart = args.shoppingCart;
            //vm.perishableAlerts.push({
            //	msg : $translate.instant('shopping-cart.alert.removed.success'),
            //	type : "success"
            //});
            if($('#snackbar').length>0) {
                angular.element($("#snackbar")).parent().data('propertyAlertErrorScope').vm.addSuccessAlert('Removed', 'shopping-cart.alert.removed.success');
            }
        });

	}
})();

(function() {
    'use strict';

    angular.module('vobeApp').component('shoppingCartDropdownButton', {
        templateUrl: 'app/components/shopping-cart/shopping-cart-dropdown/shopping-cart-dropdown.html',
        controller: 'ShoppingCartDropdownButtonController',
        controllerAs: 'vm',
        bindings: {
            shoppingCart: '<',
            shoppingCartConfigs: '<',
            property: '<',
            propertyGroup: '<',
            websiteType: '<',//group or property
        }
    });
})();

(function() {
    'use strict';

    angular.module('vobeApp').component('languageNavDropdown', {
        templateUrl: 'app/components/shopping-cart/language-dropdown/language-nav-dropdown.html',
        controller: 'LanguageDropdownButtonController',//same controller like for the button
        controllerAs: 'vm',
        bindings: {
            shoppingCartConfigs: '<',
            currentProperty: '<',
            collapseWorldNavbar:'<',
            onAvailableLanguages: '<'
        }
    });
})();

(function() {
    'use strict';

    angular.module('vobeApp').component('languageDropdownButton', {
        templateUrl: 'app/components/shopping-cart/language-dropdown/language-dropdown.html',
        controller: 'LanguageDropdownButtonController',
        controllerAs: 'vm',
        bindings: {
            shoppingCartConfigs: '<',
            currentProperty: '<',
            websiteType: '<',//group or property
        }
    });
})();

(function() {
    'use strict';

    angular.module('vobeApp').controller('LanguageDropdownButtonController', LanguageDropdownButtonController);

    LanguageDropdownButtonController.$inject = [
        '$scope',
        '$rootScope',
        '$state',
        '$stateParams',
        '$translate',
        'JhiLanguageService',
        'tmhDynamicLocale',
        '$q'
    ];

    function LanguageDropdownButtonController(
        $scope,
        $rootScope,
        $state,
        $stateParams,
        $translate,
        JhiLanguageService,
        tmhDynamicLocale,
        $q
    ) {
        var vm = this;

        vm.$onInit = function(){
            vm.currentProperty = vm.currentProperty || {};
            vm.shoppingCartConfigs = vm.shoppingCartConfigs || {};

            vm.changeLanguage = changeLanguage;
            vm.languages = ['en'];

            vm.currentLanguageCode = $translate.use();

            var propertyId = vm.currentProperty.hotelId;
            if (vm.shoppingCartConfigs[propertyId] && vm.shoppingCartConfigs[propertyId].configMap && vm.shoppingCartConfigs[propertyId].configMap.languages) {
                var languagesString = vm.shoppingCartConfigs[propertyId].configMap.languages;
                vm.languages = languagesString.replace(/\s/g, '').split(',');
            }
            //JhiLanguageService.getAll().then(function (languages) {
            //    vm.languages = languages;
            //});

            if(vm.onAvailableLanguages){
                vm.onAvailableLanguages(vm.languages);
            }
        };



        function changeLanguage(languageKey) {
            vm.currentLanguageCode =languageKey;
            var languageChangePromises = [];
            languageChangePromises.push( $translate.use(languageKey));
            try {
                languageChangePromises.push(tmhDynamicLocale.set(languageKey));
            } catch (e) {
                // TODO: handle exception
            }
            var promise = $q.all(languageChangePromises);
            promise.then(function() {
                var params = angular.copy($stateParams);
                params.language = vm.currentLanguageCode;
                //params.lang= null;
                $state.transitionTo($state.current, params, { reload: true, inherit: false, notify: true });
                //$state.reload();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
    .module('vobeApp')
    .controller('CartItemVoucherController', CartItemVoucherController);

	function CartItemVoucherController(
	    $scope,
        $rootScope,
        $state,
        $stateParams,
        ShoppingCartRemove,
        CountriesService,
        CountriesWithoutPostcodeService,
        ExplainDeliveryPersonService,
        $translate,
        $uibModal,
        $document,
        $window,
        $sce,
        $q,
        $filter,
        CurrencyExchange,
        CldrDataService
        ) {
	    'ngInject';
	    var itemVM = this;

        var defaultModalOptions = {
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'app/site/shoppingcart/explain/explain-delivery-modal.html',
            controller: 'ExplainModalInstanceCtrl',
            controllerAs: '$ctrl',
            size: 'lg',
            appendTo: 'body',
            resolve: {
                customExplain: function () {
                    return itemVM.customExplain;
                },
                config: function () {
                    return itemVM.configMap;
                }
            }
        }

	    this.$onInit = function () {
            itemVM.property = itemVM.property || {}; //not item property, but master property
            itemVM.shoppingCart = itemVM.shoppingCart || {};
            //itemVM.shoppingCartConfigs = itemVM.shoppingCartConfigs || {};
            itemVM.emailConfig = itemVM.emailConfig || {};
            itemVM.cartItem = itemVM.cartItem || {};
            itemVM.translateContextType = itemVM.cartItem.itemType && itemVM.cartItem.itemType.includes("product") ? "items" : "vouchers";
            itemVM.cartItemIndex = itemVM.cartItemIndex || 0;
            itemVM.cartItemFirst = typeof itemVM.cartItemFirst === 'undefined' ? true : itemVM.cartItemFirst;
            itemVM.isRefundsContext = $stateParams.contextType=='refunds';
            itemVM.isGroup = typeof itemVM.propertyGroup !== 'undefined';

            itemVM.explicitlyTrustedItemDescription = $sce.trustAsHtml(itemVM.cartItem.itemDescription);

            if(itemVM.cartItem.collectionDescription) {
                itemVM.explicitlyTrustedItCollectionDescription = $sce.trustAsHtml(itemVM.cartItem.collectionDescription);
            }

            itemVM.getFullName = getFullName;
            itemVM.copyRecipientFromPrevious = copyRecipientFromPrevious;
            itemVM.copyDedicationFromPrevious = copyDedicationFromPrevious;

            itemVM.removeItemFromCartAndRefresh = removeItemFromCartAndRefresh;
            itemVM.previewVoucher = previewVoucher;



            itemVM.configMap = {
                cashDefault : "1",
                customerIsRecipient : "false",
                disableDeliverToCustomer : "false",
                disableRecipientMessage : "false",
                disableAmountVisibilityOption : (itemVM.cartItem.itemType=='cash' || itemVM.cartItem.itemType=='cash-wildcard' ? 'true' : 'false'),
                displayShowValue: (itemVM.cartItem.itemType=='cash' || itemVM.cartItem.itemType=='cash-wildcard' ? 'DISABLE_SHOW_VALUE' : 'ENABLE'),
                emailOption : "true",
                postalOption : "false",
                collectOption : "false",
                limitQuantity : 999,
                confirmEmail: "false",
                maxBulkRows: 30,
                disableScheduledDelivery: defaultScheduledDeliveryDisabled(itemVM.cartItem),
                dedicationMessageLength: 2000,
                dedicationMessageLengthPost: 2000,
                displayInformalDedication: false,
                disableRecipientDetails: false,
                allowBulkPostal: false,
            };

            itemVM.emailConfigMap = {
                emailPreview: "true"
            };

            itemVM.emailCategories = [];

            var currentPropertyId = itemVM.cartItem.owningProperty.propertyId;
            //TODO: group shopping cart and email config
            //extend default config with property config
            if(itemVM.shoppingCartConfigs && itemVM.shoppingCartConfigs[currentPropertyId]){
                angular.extend(itemVM.configMap,itemVM.shoppingCartConfigs[currentPropertyId].configMap);
            }

            //extend the emailConfig
            if (itemVM.emailConfig && itemVM.emailConfig[currentPropertyId]) {
                angular.extend(itemVM.emailConfigMap, itemVM.emailConfig[currentPropertyId].configMap);
                //console.info('emailCategories', itemVM.emailConfig[currentPropertyId].emailCategories)
                itemVM.emailCategories = itemVM.emailConfig[currentPropertyId].emailCategories;
            }

            if(itemVM.configMap.customerIsRecipient==='true'){
                itemVM.configMap.disableDeliverToRecipient = "true";
                itemVM.configMap.disableScheduledDelivery = "true";
            }

            //fix the string value to boolean
            itemVM.configMap.displayInformalDedication = itemVM.configMap.displayInformalDedication === 'true';

            //fix the displayShowValue for cash/cash-wildcard -- in case the override is ENABLE or DISABLE_HIDE_VALUE
            //cash and cash-wildcard should always be DISABLE_SHOW_VALUE
            if (itemVM.cartItem.itemType == 'cash' || itemVM.cartItem.itemType == 'cash-wildcard') {
                itemVM.configMap.displayShowValue = 'DISABLE_SHOW_VALUE';
            }


            //gift cards can only be sent by post // legacy, not used anymore
            if(itemVM.cartItem.itemGiftCardId && itemVM.cartItem.itemGiftCardId>0){
                itemVM.configMap.emailOption = "false";
                itemVM.configMap.postalOption = "true";
            }

            //read voucher settings
            //please note 'itemFixedDeliveryType' is now legac and has been replaced by email-, post- or collectOption
            if (!itemVM.cartItem.itemMeta || (!itemVM.cartItem.emailOption && !itemVM.cartItem.itemMeta.postalOption && !itemVM.cartItem.itemMeta.collectOption)) {
                //use 'itemFixedDeliveryType'
                if(itemVM.cartItem.itemFixedDeliveryType && "post"==itemVM.cartItem.itemFixedDeliveryType){
                    itemVM.configMap.emailOption = "false";
                    itemVM.configMap.postalOption = "true";
                }
                else if(itemVM.cartItem.itemFixedDeliveryType && "email"==itemVM.cartItem.itemFixedDeliveryType){
                    itemVM.configMap.emailOption = "true";
                    itemVM.configMap.postalOption = "false";
                }
            } else {
                if(itemVM.cartItem.itemMeta && itemVM.cartItem.itemMeta.emailOption && "true"==itemVM.cartItem.itemMeta.emailOption){
                    itemVM.configMap.emailOption = "true";
                } else if(itemVM.cartItem.itemMeta && itemVM.cartItem.itemMeta.emailOption && "false"==itemVM.cartItem.itemMeta.emailOption) {
                    itemVM.configMap.emailOption = "false";

                }
                if(itemVM.cartItem.itemMeta && itemVM.cartItem.itemMeta.postalOption && "true"==itemVM.cartItem.itemMeta.postalOption){
                    itemVM.configMap.postalOption = "true";
                } else if(itemVM.cartItem.itemMeta && itemVM.cartItem.itemMeta.postalOption && "false"==itemVM.cartItem.itemMeta.postalOption) {
                    itemVM.configMap.postalOption = "false";
                }
                if(itemVM.cartItem.itemMeta && itemVM.cartItem.itemMeta.collectOption && "true"==itemVM.cartItem.itemMeta.collectOption){
                    itemVM.configMap.collectOption = "true";
                } else if(itemVM.cartItem.itemMeta && itemVM.cartItem.itemMeta.collectOption && "false"==itemVM.cartItem.itemMeta.collectOption) {
                    itemVM.configMap.collectOption = "false";
                }
            }

            if(itemVM.shoppingCartConfigs && itemVM.shoppingCartConfigs[currentPropertyId] && itemVM.shoppingCartConfigs[currentPropertyId].disableScheduledDelivery){
                itemVM.configMap.disableScheduledDelivery = itemVM.shoppingCartConfigs[currentPropertyId].disableScheduledDelivery;
            }

            if(itemVM.cartItem.itemMeta && itemVM.cartItem.itemMeta.disableScheduledDelivery=='true'){
                //disabled for now due to voucher override.
                itemVM.configMap.disableScheduledDelivery = "true";
            }
            if(itemVM.cartItem.itemMeta && itemVM.cartItem.itemMeta.disableScheduledDelivery=='false'  && itemVM.configMap.disableScheduledDelivery!="true"){
                //we can enable, but only if property level is not disabled
                itemVM.configMap.disableScheduledDelivery = "false";
            }
            if(itemVM.cartItem.itemMeta && itemVM.cartItem.itemMeta.disableScheduledDelivery=='force_false'){
                //enable regardless of property level
                itemVM.configMap.disableScheduledDelivery = "false";
            }


            //the guest book has defaults
            if($stateParams.channel==20 || $stateParams.channel=='20'){
                itemVM.configMap.emailOption = "true";
                itemVM.configMap.postalOption = "false";
                itemVM.configMap.collectOption = "false";
                itemVM.configMap.customerIsRecipient = "false";
                itemVM.configMap.disableDeliverToCustomer = "true";
                itemVM.configMap.disableRecipientMessage = "true";
                itemVM.configMap.disableAmountVisibilityOption = "true";
                itemVM.configMap.displayShowValue = 'DISABLE_SHOW_VALUE';
                itemVM.configMap.showTAndC = "true";
                itemVM.configMap.disableScheduledDelivery = "true";
                itemVM.cartItem.termsAgreed = false;
                itemVM.cartItem.recipient.scheduledDelivery = 'now';

            }

            //refunds have defaults
            if($stateParams.contextType=='refunds'){
                itemVM.configMap.emailOption = "true";
                itemVM.configMap.postalOption = "false";
                itemVM.configMap.collectOption = "false";
                itemVM.configMap.disableDeliveryMethod = "true";
                itemVM.configMap.customerIsRecipient = "false";
                itemVM.configMap.disableDeliverToCustomer = "true";
                itemVM.configMap.disableDeliverToRecipient = "true";
                itemVM.configMap.disableRecipientMessage = "true";
                itemVM.configMap.enableComment = "true";
                itemVM.configMap.disableAmountVisibilityOption = "true";
                itemVM.configMap.displayShowValue = 'DISABLE_SHOW_VALUE';
                itemVM.configMap.disableScheduledDelivery = "true";
                itemVM.cartItem.termsAgreed = true;
                itemVM.cartItem.recipient.deliveryMethodType = "email";
                itemVM.cartItem.recipient.deliveryPersonType = "recipient";
            }

            //bulk have defaults
            if(itemVM.isBulk) {
                itemVM.configMap.emailOption = itemVM.configMap.allowBulkPostal === 'true' ? itemVM.configMap.emailOption : "true";
                itemVM.configMap.postalOption = itemVM.configMap.allowBulkPostal && itemVM.configMap.postalOption === 'true' ? "true" : "false"
                itemVM.configMap.collectOption = (itemVM.configMap.allowBulkClickCollect === 'true' && itemVM.cartItem.itemMeta.collectOption === 'true') ? "true" : "false";
                itemVM.configMap.disableDeliveryMethod = "false";
                itemVM.configMap.customerIsRecipient = "false";
                itemVM.configMap.disableDeliverToCustomer = "true";
                itemVM.configMap.disableDeliverToRecipient = "false";
                itemVM.configMap.disableRecipientDetails = false;
                itemVM.configMap.disableRecipientMessage = "true";//will be handled by spreadsheet
                itemVM.configMap.enableComment = "false";//will be handled by spreadsheet
                itemVM.configMap.disableAmountVisibilityOption = itemVM.configMap.disableAmountVisibilityOption || "false";
                itemVM.configMap.displayShowValue = itemVM.configMap.displayShowValue || 'ENABLE';
                itemVM.configMap.disableScheduledDelivery = "true";
                itemVM.cartItem.termsAgreed = itemVM.cartItem.termsAgreed || true;
                itemVM.cartItem.recipient.deliveryMethodType = itemVM.cartItem.recipient.deliveryMethodType || "email";
                itemVM.cartItem.recipient.deliveryPersonType = itemVM.cartItem.recipient.deliveryPersonType || "recipient";

                if (itemVM.shoppingCartConfigs && itemVM.shoppingCartConfigs[currentPropertyId] && itemVM.shoppingCartConfigs[currentPropertyId].maxBulkRows){
                    itemVM.configMap.maxBulkRows = itemVM.shoppingCartConfigs[currentPropertyId].maxBulkRows;
                }

                if (itemVM.isGroup && itemVM.shoppingCartConfigs[itemVM.property.hotelId] && itemVM.shoppingCartConfigs[itemVM.property.hotelId].configMap && itemVM.shoppingCartConfigs[itemVM.property.hotelId].configMap.maxBulkRows) {
                    itemVM.configMap.maxBulkRows = parseInt(itemVM.shoppingCartConfigs[itemVM.property.hotelId].configMap.maxBulkRows);
                }

            }

            //end of configuration

            var deliveryOptionsCount = 0;
            if(itemVM.configMap.emailOption == "true") {
                deliveryOptionsCount++;
            }
            if(itemVM.configMap.postalOption == "true") {
                deliveryOptionsCount++;
            }
            if(itemVM.configMap.collectOption == "true") {
                deliveryOptionsCount++;
            }
            itemVM.deliveryOptionsCount = deliveryOptionsCount>0 ? deliveryOptionsCount : 2;

            if(itemVM.deliveryOptionsCount==1 && itemVM.configMap.collectOption == "true"){
                activateCollectionOption();
            }

            var baseRecipient = {
                firstName : itemVM.cartItem.recipient.firstName || '',
                lastName : itemVM.cartItem.recipient.lastName || '',
                country : '',
                dedicationFrom: itemVM.cartItem.recipient.dedicationTo || '',
                dedicationTo: itemVM.cartItem.recipient.dedicationFrom || '',
                message: itemVM.cartItem.recipient.message || '',
                comment: itemVM.cartItem.recipient.comment || undefined,
                deliveryMethodType : itemVM.cartItem.recipient.deliveryMethodType || defaultDeliveryMethodTypeFromConfig(itemVM.shoppingCartConfigs[currentPropertyId].configMap.defaultDeliveryMethodType, itemVM.cartItem),
                deliveryPersonType : itemVM.cartItem.recipient.deliveryPersonType || defaultDeliveryPersonType(itemVM.cartItem),
                scheduledDelivery: 'now',
                showValue : itemVM.cartItem.recipient.showValue || (itemVM.cartItem.itemType=='cash' || itemVM.cartItem.itemType=='cash-wildcard' ? 'true' : defaultShowValue(itemVM.cartItem)),
                emailCategoryId: availableEmailCaregory(itemVM.cartItem.recipient.emailCategoryId)
            };


            if(!itemVM.cartItem.recipient || !itemVM.cartItem.recipient.uuid || itemVM.cartItem.recipient.uuid.length==0){
                angular.extend(itemVM.cartItem.recipient , baseRecipient);
            }

            if(!itemVM.cartItem.recipient.scheduledDelivery){
                itemVM.cartItem.recipient.scheduledDelivery = baseRecipient.scheduledDelivery;
            }


            itemVM.hideCustomizationBox = (
                itemVM.configMap.customerIsRecipient==='true'
                && (itemVM.configMap.disableRecipientMessage==='true'
                    || itemVM.configMap.disableRecipientMessage==='trueWithDefault'
                    || (itemVM.configMap.disableRecipientMessage == 'trueForPost' && itemVM.cartItem.recipient.deliveryMethodType=='post' )
                    || (itemVM.configMap.disableRecipientMessage == 'trueForEmail' && itemVM.cartItem.recipient.deliveryMethodType=='email' )
                )
                && itemVM.configMap.disableAmountVisibilityOption==='true'
                && (itemVM.cartItem.recipient.deliveryMethodType=='post' || itemVM.emailCategories.length==0)
            );

            itemVM.selectCountry = [];
            itemVM.noPostcodeCountries = [];
            itemVM.isPostCodeRequired = true;

            loadCountries(loadCountriesCallback);
            loadCountriesWithoutPostcode(loadCountriesWithoutPostcodeCallback);

            itemVM.customExplain = {
                post: {
                    customer : false,
                    recipient : false
                },
                email : {
                    customer : false,
                    recipient : false
                }
            };

            updateExplainDescriptions('customer','email');
            updateExplainDescriptions('customer','post');
            updateExplainDescriptions('recipient','email');
            updateExplainDescriptions('recipient','post');


            var defaultModalOptions = {
                animation: true,
                ariaLabelledBy: 'modal-title',
                ariaDescribedBy: 'modal-body',
                templateUrl: 'app/site/shoppingcart/explain/explain-delivery-modal.html',
                controller: 'ExplainModalInstanceCtrl',
                controllerAs: '$ctrl',
                size: 'lg',
                appendTo: 'body',
                resolve: {
                    customExplain: function () {
                        return itemVM.customExplain;
                    },
                    config: function () {
                        return itemVM.configMap;
                    }
                }
            }

            //currency
            itemVM.baseCurrency = {
                code : itemVM.cartItem.itemCurrency
            };

            itemVM.currentCurrency = {
                code : itemVM.baseCurrency.code
            }
            var currentCurrency = CurrencyExchange.currencies.current;//current currency might be NULL if this is group engine
            if(currentCurrency && currentCurrency!=null){
                itemVM.currentCurrency.code = currentCurrency.code;
            }

            itemVM.isCollapsedDescr = shouldCollapsedDescr();

            //SCHEDULED DELIVERY


            itemVM.zones = [];
            var scheduledZone = {continentKey:'',value:itemVM.property.hotelTimeZone || '',display:itemVM.property.hotelCountry,territoryName:itemVM.property.hotelCountry};
            itemVM.zones.push(scheduledZone);

            //get timezones in user's locale (using Common Locale Data Repository)
            loadCldrData(itemVM.currentLanguage);

            var scheduledTime = new Date();
            scheduledTime.setMinutes(0);
            scheduledTime.setSeconds(0);
            scheduledTime.setMilliseconds(0);
            var scheduledDate = new Date();
            scheduledDate.setMinutes(0);
            scheduledDate.setSeconds(0);
            scheduledDate.setMilliseconds(0);

            if(itemVM.cartItem.recipient.scheduledDeliveryTime){
                var scheduledDateString = itemVM.cartItem.recipient.scheduledDeliveryTime;
                try {
                    scheduledTime = new Date(scheduledDateString);
                    itemVM.cartItem.recipient.scheduledDelivery = 'later';
                } catch(e){
                    scheduledTime = new Date();
                    scheduledTime.setMinutes(0);
                    scheduledTime.setSeconds(0);
                    scheduledTime.setMilliseconds(0);
                }
                try {
                    scheduledDate = new Date(scheduledDateString);
                } catch(e){
                    scheduledDate = new Date();
                    scheduledDate.setMinutes(0);
                    scheduledDate.setSeconds(0);
                    scheduledDate.setMilliseconds(0);
                }
            }

            if(itemVM.cartItem.recipient.scheduledDeliveryTimeZone){

            }

            var scheduledDeliveryMaxDays = 90;
            if(itemVM.shoppingCartConfigs && itemVM.shoppingCartConfigs[currentPropertyId] && itemVM.shoppingCartConfigs[currentPropertyId].configMap && itemVM.shoppingCartConfigs[currentPropertyId].configMap.scheduledDeliveryMaxDays){
                try {
                    scheduledDeliveryMaxDays = parseInt(itemVM.shoppingCartConfigs[currentPropertyId].configMap.scheduledDeliveryMaxDays);
                } catch(e){
                }
                if (isNaN(scheduledDeliveryMaxDays)) { scheduledDeliveryMaxDays = 90; }
            }
            var scheduledDeliveryMaxDate = new Date();
            scheduledDeliveryMaxDate.setDate(scheduledDeliveryMaxDate.getDate()+scheduledDeliveryMaxDays);

            itemVM.scheduledDeliveryData = {
                scheduledTime : scheduledTime,
                scheduledDate : scheduledDate,
                scheduledZone : scheduledZone,
                scheduledDatePickerOptions : {
                    minDate : new Date(),
                    maxDate : scheduledDeliveryMaxDate,
                    showWeeks: false,
                    language: 'en-gb',
                    maxMode: 'month'
                }
            };

            itemVM.cartItem.recipient.scheduledDate = $filter('date')(itemVM.scheduledDeliveryData.scheduledDate, 'yyyy-MM-dd'/*, timezone*/)//using timezone of the browser;
            itemVM.cartItem.recipient.scheduledTime = $filter('date')(itemVM.scheduledDeliveryData.scheduledTime, 'HH:mm'/*, timezone*/)//using timezone of the browser;
            itemVM.cartItem.recipient.scheduledZone = itemVM.scheduledDeliveryData.scheduledZone.value;


            //SCHEDULED WATCHERS
            $scope.$watch('itemVM.scheduledDeliveryData.scheduledZone', function(newValue, oldValue) {
                itemVM.cartItem.recipient.scheduledZone = newValue.value;
            });

            $scope.$watch('itemVM.scheduledDeliveryData.scheduledDate', function(newValue, oldValue) {
                var dateString = $filter('date')(newValue, 'yyyy-MM-dd'/*, timezone*/)//using timezone of the browser
                itemVM.cartItem.recipient.scheduledDate = dateString;
            });

            $scope.$watch('itemVM.scheduledDeliveryData.scheduledTime', function(newValue, oldValue) {
                var timeString = $filter('date')(newValue, 'HH:mm'/*, timezone*/)//using timezone of the browser
                itemVM.cartItem.recipient.scheduledTime = timeString;
            });


            //OTHER WATCHERS
            $rootScope.$on('CurrencyExchangeProvider.changeCurrency', function(event, args) {
                itemVM.currentCurrency.code = args.code;
            });

            $scope.$watch('itemVM.cartItem.recipient.deliveryMethodType', function(newValue, oldValue) {
                //1. if you interact with delivery method type, you must approve t&c again:
                itemVM.cartItem.termsAgreed = false;

                //2. FIRST DEACTIVATE AND RETURN TO CACHED CONFIG AND RECIPIENT
                //if old value is collection:
                if(oldValue=='collect' && newValue!='collect'){
                    deactivateCollectionOption();
                }
                //if old value is post:
                if(oldValue=='post' && newValue!='post'){
                    deactivatePostOption();
                }

                //3. THEN ACTIVATE REQUIRED OPTION
                //if new value is collection:
                if(newValue=='collect'){
                    activateCollectionOption();
                }
                //if new value is post:
                if(newValue=='post'){
                    activatePostOption();
                }

                // remove the recipient message if the post option doesn't allow recipient message via config.
                if (newValue == 'post' && itemVM.configMap.disableRecipientMessage == 'trueForPost') {
                    itemVM.cartItem.recipient.message = '';
                }

                // remove the recipient message if the email option doesn't allow recipient message via config.
                if (newValue == 'email' && itemVM.configMap.disableRecipientMessage == 'trueForEmail') {
                    itemVM.cartItem.recipient.message = '';
                }

                // check the dedication message length rules
                changeDedicationMessageLength(newValue);

                //modify display of post recipient message if isBulk
                if (itemVM.isBulk) {
                    //check if newValue is either `post` or `collect` then set itemVM.configMap.disableRecipientDetails to false, else true
                    itemVM.configMap.disableRecipientDetails = (newValue == 'post' || newValue == 'collect') ? false : true;
                }

            });

            /*$scope.$watch('itemVM.cartItem.recipient.deliveryPersonType', function(newValue, oldValue) {
                //2. FIRST DEACTIVATE AND RETURN TO CACHED CONFIG
                //if old value is customer:
                if(oldValue=='customer' && newValue!='customer'){
                    activateScheduledDelivery();
                }
                //3. THEN ACTIVATE REQUIRED OPTION
                //if new value is customer:
                if(newValue=='customer'){
                    deactivateScheduledDelivery();
                }
            });*/

            $scope.$watch("itemVM.cartItem.recipient.country", function (newValue, oldValue) {
                isPostCodeRequired();
            });

        }

        function changeDedicationMessageLength(deliveryMethodType) {
            if (deliveryMethodType == 'post' && itemVM.configMap.dedicationMessageLengthPost) {
                itemVM.configMap.dedicationMessageLength = parseInt(itemVM.configMap.dedicationMessageLengthPost);
            } else if (deliveryMethodType == 'email' && itemVM.configMap.dedicationMessageLengthEmail) {
                itemVM.configMap.dedicationMessageLength = parseInt(itemVM.configMap.dedicationMessageLengthEmail);
            } else {
                itemVM.configMap.dedicationMessageLength = 2000;
            }
        }


        function loadCldrData(currentLanguage){

            var dataPromises = [];

            var territoryKeyToNameMap = {};
            var zonesMap = {};
            var zoneKeyToTerritoryKeyMap = {};

            var zonesPromise = CldrDataService
                .getMain({language:currentLanguage,name:'timeZoneNames'})
                .$promise
                .then(function(data) {
                    angular.forEach(data.main[currentLanguage.replace('_','-')].dates.timeZoneNames.zone,function(zoneCityObject,continentKey){
                        angular.forEach(zoneCityObject,function(cityObject,cityKey){
                            zonesMap[continentKey+'_'+cityKey] = {
                                continentKey:continentKey,
                                territoryName:continentKey,
                                cityKey: cityKey,
                                exemplarCity: cityObject.exemplarCity,
                                value:continentKey+'/'+cityKey,
                                display:continentKey+'/'+cityObject.exemplarCity ? cityObject.exemplarCity : cityKey
                            };
                        });
                    });
                },function(reason){
                    //try loading data without country
                    loadCldrData((currentLanguage || 'en').split('_')[0].split('-')[0]);
                });

            var windowsZonesPromise = CldrDataService
                .getSupplemental({name:'windowsZones'})
                .$promise
                .then(function(data) {
                    angular.forEach(data.supplemental.windowsZones.mapTimezones,function(mapTimezoneObject,mI){
                        var zones = mapTimezoneObject.mapZone._type.split(" ");
                        angular.forEach(zones,function(zoneName,zI){
                            var zoneKey = zoneName.replace("/","_");//replace only first '/'
                            zoneKey = zoneKey.split('/')[0];//remove everything after the second '/'
                            zoneKeyToTerritoryKeyMap[zoneKey]=mapTimezoneObject.mapZone._territory;
                        });
                    });
                },function(reason){

                });

            var territoryPromise = CldrDataService
                .getMain({language:currentLanguage,name:'territories'})
                .$promise
                .then(function(data) {
                    angular.forEach(data.main[currentLanguage.replace('_','-')].localeDisplayNames.territories,function(territory,territoryKey){
                        territoryKeyToNameMap[territoryKey]=territory;
                    });
                },function(reason){

                });

            dataPromises.push(zonesPromise);
            dataPromises.push(windowsZonesPromise);
            dataPromises.push(territoryPromise);

            $q.all(dataPromises).then(cldrDataCbSuccess({territoryKeyToNameMap:territoryKeyToNameMap,zoneKeyToTerritoryKeyMap:zoneKeyToTerritoryKeyMap,zonesMap:zonesMap}));

        }

        function cldrDataCbSuccess(dataHash){
            return function(){
                var territoryKeyToNameMap = dataHash.territoryKeyToNameMap;
                var zonesMap = dataHash.zonesMap;
                var zoneKeyToTerritoryKeyMap = dataHash.zoneKeyToTerritoryKeyMap;
                //prepare zones
                angular.forEach(zonesMap,function(zoneObject,zoneKey){
                    //localize continentName
                    var territoryKey = zoneKeyToTerritoryKeyMap[zoneKey];
                    if(!territoryKey){
                        return;
                    }
                    var localizedTerritoryName = territoryKeyToNameMap[territoryKey];
                    if(!localizedTerritoryName){
                        return;
                    }
                    zoneObject.territory = localizedTerritoryName;
                    zoneObject.display = localizedTerritoryName+'/'+(zoneObject.exemplarCity ? zoneObject.exemplarCity : zoneObject.cityKey);

                    itemVM.zones.push(zoneObject);
                });
            }
        }

	    function availableEmailCaregory(id){
	    	var matched = false;
	    	if(itemVM.emailCategories && id){
	    		angular.forEach(itemVM.emailCategories,function(c,i){
	    			if(c.id==id){
	    				matched= true;
	    			}
	    		});
	    	}

	    	return matched ? id : 1;
	    }

        function defaultDeliveryMethodTypeFromConfig(defaultValue, item) {

            if (item.itemGiftCardId && item.itemGiftCardId > 0) {
                return 'post';
            }

            if (defaultValue === 'none' && $stateParams.contextType != "refunds" && !itemVM.isBulk) {
                return undefined;
            } else if (typeof defaultValue !== 'undefined') {
                return defaultValue;
            }

            if (itemVM.configMap.emailOption == 'true') {
                return 'email';
            } else if (itemVM.configMap.postalOption == 'true') {
                return 'post';
            } else if (itemVM.configMap.collectOption == 'true') {
                return 'collect';
            }

            return 'email';

        }

	    function defaultDeliveryMethodType (item){
	    	if(item.itemGiftCardId && item.itemGiftCardId>0){
	    		return 'post';
	    	}
		    if(item.owningProperty.propertyId==297 /*IIL*/ && $stateParams.contextType!="refunds" && !itemVM.isBulk){
		    	return undefined;
		    }
		    if(['MDVHIE','CLYVIE','MDHVUK','CLYVUK','CWHVIE','CHSVIE','CHGVIE','MHSVIE'].indexOf(item.owningProperty.propertyCode.toUpperCase())!=-1){
		    	return undefined;
		    }
		    if(itemVM.configMap.emailOption=='true'){
		    	return 'email';
		    }
		    else if(itemVM.configMap.postalOption=='true'){
		    	return 'post';
		    }
            else if(itemVM.configMap.collectOption=='true'){
                return 'collect';
            }

		    return 'email';
	    }

	    function defaultDeliveryPersonType (item){
	    	if(['MDVHIE','CLYVIE','MDHVUK','CLYVUK','CWHVIE','CHSVIE','CHGVIE','MHSVIE'].indexOf(item.owningProperty.propertyCode.toUpperCase())!=-1){
		    	return undefined;
		    }
		    if($stateParams.contextType=="refunds" || itemVM.isBulk){
                return 'recipient';
            }
		    return 'customer';
	    }

	    function defaultShowValue(item){
            console.log('defaultShowValue', item);

            if(item.itemType.toLowerCase().includes("refund")){
                return true;
            }

            if(['MDVHIE','CLYVIE','MDHVUK','CLYVUK','CWHVIE','CHSVIE','CHGVIE','MHSVIE'].indexOf(item.owningProperty.propertyCode.toUpperCase())!=-1){
		    	return undefined;
		    }

            if(['BSHVUK'].indexOf(item.owningProperty.propertyCode.toUpperCase())!=-1){
                return 'true';
            }

            if (itemVM.configMap.displayShowValue === 'DISABLE_SHOW_VALUE') {
                return 'true';
            }

            if (itemVM.configMap.displayShowValue === 'DISABLE_HIDE_VALUE') {
                return 'false'
            }

            if(itemVM.configMap.displayShowValue === 'ENABLE' && item.itemType.toLowerCase().includes('package')){
                return 'false';
            }

		    return 'true';
	    }

        function defaultScheduledDeliveryDisabled(item){
            if(['TSTDEMO'/*,'PVHVAE'*/].indexOf(item.owningProperty.propertyCode.toUpperCase())!=-1){
                return 'false';
            }
            return 'true';
        }


	    function activateCollectionOption(){

            console.log("Collection option activated");

            //preserve config
            itemVM.cachedConfigMap = itemVM.cachedConfigMap || angular.copy(itemVM.configMap);
            itemVM.cachedConfigMap.deliveryPersonType = itemVM.cartItem.recipient.deliveryPersonType;

            itemVM.configMap.customerIsRecipient = "true";
            itemVM.configMap.disableDeliverToCustomer = "true";
            itemVM.configMap.disableDeliverToRecipient = "true";
            itemVM.configMap.disableRecipientMessage = itemVM.isBulk ? "true" : "false";
            itemVM.configMap.disableAmountVisibilityOption = "true";
            itemVM.configMap.deliveryPersonType = "customer";

            itemVM.configMap.showCollectionInfo = "true";

            //remove scheduled delivery option, as set it to now
            itemVM.configMap.disableScheduledDelivery = "true";
            itemVM.cachedConfigMap.scheduledDelivery = itemVM.cartItem.recipient.scheduledDelivery;
            itemVM.cartItem.recipient.scheduledDelivery = "now";

        }

        function deactivateCollectionOption(){

            console.log("Collection option deactivated");

            //recreate config from preserved one
            itemVM.configMap.customerIsRecipient = itemVM.cachedConfigMap ? itemVM.cachedConfigMap.customerIsRecipient : itemVM.configMap.customerIsRecipient;
            itemVM.configMap.disableDeliverToCustomer = itemVM.cachedConfigMap ? itemVM.cachedConfigMap.disableDeliverToCustomer : itemVM.configMap.disableDeliverToCustomer;
            itemVM.configMap.disableDeliverToRecipient = itemVM.cachedConfigMap ? itemVM.cachedConfigMap.disableDeliverToRecipient : itemVM.configMap.disableDeliverToRecipient;
            itemVM.configMap.disableRecipientMessage = itemVM.cachedConfigMap ? itemVM.cachedConfigMap.disableRecipientMessage : itemVM.configMap.disableRecipientMessage;
            itemVM.configMap.disableAmountVisibilityOption = itemVM.cachedConfigMap ? itemVM.cachedConfigMap.disableAmountVisibilityOption : itemVM.configMap.disableAmountVisibilityOption;
            itemVM.cartItem.recipient.deliveryPersonType = itemVM.cachedConfigMap ? itemVM.cachedConfigMap.deliveryPersonType : itemVM.cartItem.recipient.deliveryPersonType;
            itemVM.configMap.showCollectionInfo = "false";

            //set scheduled delivery option to what it was previously
            itemVM.cartItem.recipient.scheduledDelivery = itemVM.cachedConfigMap ? itemVM.cachedConfigMap.scheduledDelivery : itemVM.cartItem.recipient.scheduledDelivery;
            itemVM.configMap.disableScheduledDelivery = itemVM.cachedConfigMap ? itemVM.cachedConfigMap.disableScheduledDelivery : itemVM.configMap.disableScheduledDelivery;

        }

        function activatePostOption(){

            console.log("Post option activated");

            //preserve config
            itemVM.cachedConfigMap = itemVM.cachedConfigMap || angular.copy(itemVM.configMap);

            deactivateScheduledDelivery();

        }

        function deactivatePostOption(){

            console.log("Post option deactivated");

            activateScheduledDelivery();

        }

        function deactivateScheduledDelivery(){
            //preserve config
            itemVM.cachedConfigMap = itemVM.cachedConfigMap || angular.copy(itemVM.configMap);

            //remove scheduled delivery option, as set it to now
            itemVM.configMap.disableScheduledDelivery = "true";
            itemVM.cachedConfigMap.scheduledDelivery = itemVM.cartItem.recipient.scheduledDelivery;
            itemVM.cartItem.recipient.scheduledDelivery = "now";

        }
        function activateScheduledDelivery(){
            //set scheduled delivery option to what it was previously
            itemVM.cartItem.recipient.scheduledDelivery = itemVM.cachedConfigMap ? itemVM.cachedConfigMap.scheduledDelivery : itemVM.cartItem.recipient.scheduledDelivery;
            itemVM.configMap.disableScheduledDelivery = itemVM.cachedConfigMap ? itemVM.cachedConfigMap.disableScheduledDelivery : itemVM.configMap.disableScheduledDelivery;
        }

	    function getFullName(firstName,lastName){
	    	var arr = [];
	    	if(firstName){
	    		arr.push(firstName);
	    	}
	    	if(lastName){
	    		arr.push(lastName);
	    	}

	    	return arr.join(' ');
	    }

	    function copyRecipientFromPrevious(event, currentIndex){
	    	event.preventDefault();
	    	var previousItem = itemVM.shoppingCart.shoppingCartItems.items[currentIndex-1];

	    	itemVM.cartItem.recipient.email = previousItem.recipient.email;
	    	itemVM.cartItem.recipient.address = previousItem.recipient.address;
	    	itemVM.cartItem.recipient.town = previousItem.recipient.town;
	    	itemVM.cartItem.recipient.county = previousItem.recipient.county;
	    	itemVM.cartItem.recipient.postcode = previousItem.recipient.postcode;
	    	itemVM.cartItem.recipient.country = previousItem.recipient.country;
	    	itemVM.cartItem.recipient.phone = previousItem.recipient.phone;
	    }

	    function copyDedicationFromPrevious(event, currentIndex){
	    	event.preventDefault();
	    	var previousItem = itemVM.shoppingCart.shoppingCartItems.items[currentIndex-1];

	    	itemVM.cartItem.recipient.message = previousItem.recipient.message;
	    	itemVM.cartItem.recipient.firstName = previousItem.recipient.firstName;
	    	itemVM.cartItem.recipient.lastName = previousItem.recipient.lastName;
	    	itemVM.cartItem.recipient.hideValue = previousItem.recipient.hideValue;
			itemVM.cartItem.recipient.emailCategoryId = previousItem.recipient.emailCategoryId;

	    }

	    function loadCountries(callback){

	    	var cb = callback || angular.noop;

	    	CountriesService.get(function (response) {
                return cb(response);
            });

	    }

	    function loadCountriesWithoutPostcode(callback){

	    	var cb = callback || angular.noop;

	    	CountriesWithoutPostcodeService.get(function (response) {
                return cb(response);
            });

	    }

	    function loadCountriesCallback(data){

	    	//get countries from shopping basket and make them a priority
	    	var alreadyUsedCountryNames = [];

	    	if(typeof itemVM.cartItem.recipient.country === 'string' && itemVM.cartItem.recipient.country.length>0){
	    		alreadyUsedCountryNames.push(itemVM.cartItem.recipient.country);
	    	}

	    	if(itemVM.shoppingCart.shoppingCartItems){
                angular.forEach(itemVM.shoppingCart.shoppingCartItems.items ,function(item, index){
                    if(item.recipient.country){
                        alreadyUsedCountryNames.unshift(item.recipient.country);
                    }
                    if(item.owningProperty.propertyCountry){
                        alreadyUsedCountryNames.push(item.owningProperty.propertyCountry);
                    }
                });
            }



	    	//add priorities to countries
	    	angular.forEach(data.countries.country ,function(c, index){
	    		//add country priority
	    		var aIndex = alreadyUsedCountryNames.indexOf(c.countryName);
	    		var isPriority = aIndex>-1;
	    		var priorityIndex = aIndex-alreadyUsedCountryNames.length;
	    		if(isPriority){
	    			if(itemVM.cartItem.recipient.country && (typeof itemVM.cartItem.recipient.country==='string' || priorityIndex<itemVM.cartItem.recipient.country.priorityCountryIndex)){
	    				itemVM.cartItem.recipient.country = c;
	    	    	}
	    			var copy = angular.copy(c, {});
	    			copy.priorityGroupIndex = 1;//like any other
	    			copy.priorityCountryIndex = 1;//like any other
	    			data.countries.country.push(copy);
	    		}
	    		c.priorityCountryIndex = isPriority ? priorityIndex : 1;
	    		c.priorityGroupIndex = isPriority ? priorityIndex : 1;

	    	});

	    	itemVM.selectCountry = data.countries.country;

	    }

	    function loadCountriesWithoutPostcodeCallback(data){

	    	itemVM.noPostcodeCountries = data.countries.country;
	    	isPostCodeRequired();
	    }

	    function isPostCodeRequired(){

	    	var isPostCodeRequired = true;
	    	if(itemVM.cartItem.recipient === undefined || itemVM.cartItem.recipient === null){
	    		isPostCodeRequired = true;
	    	}
	    	else if(itemVM.cartItem.recipient.country === undefined || itemVM.cartItem.recipient.country === null){
	    		isPostCodeRequired = true;
	    	}
	    	else if(typeof itemVM.cartItem.recipient.country === 'string' && itemVM.cartItem.recipient.country.length==0){
	    		isPostCodeRequired = false;
	    	}
	    	else if(typeof itemVM.cartItem.recipient.country === 'string' && itemVM.cartItem.recipient.country.length>0){
		    	angular.forEach(itemVM.noPostcodeCountries ,function(c, index){
		    		if(c[0]==itemVM.cartItem.recipient.country){
		    			isPostCodeRequired = false;
		    		}
		    	});
	    	}
	    	else {
		    	angular.forEach(itemVM.noPostcodeCountries ,function(c, index){
		    		if(c[0]==itemVM.cartItem.recipient.country.countryName){
		    			isPostCodeRequired = false;
		    		}
		    	});
	    	}

	    	itemVM.isPostCodeRequired = isPostCodeRequired;

	    }


	    function removeItemFromCartAndRefresh(event){
	    	event.preventDefault();
	    	removeItem(refreshSite);

	    }

	    function refreshSite(){
		    $state.transitionTo($state.current, $stateParams, {
		    	  reload: 'site', inherit: true, notify: true
		    });
	    }

	    function removeItem(callback){

            var cb = callback || angular.noop;

            return ShoppingCartRemove.remove({itemUUID : itemVM.cartItem.uuid},
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;

	    }

	    function previewVoucher() {
	        if(itemVM.isBulk){
                $state.go('bulk-add.preview', {
                    'uuid': itemVM.cartItem.uuid,
                    'emailCategoryId' : itemVM.cartItem.recipient.emailCategoryId || 1,
                    'templateItem': itemVM.cartItem
                });
            } else {
                $state.go('shopping-cart.preview', {
                    'uuid': itemVM.cartItem.uuid,
                    'emailCategoryId' : itemVM.cartItem.recipient.emailCategoryId || 1
                });
            }

        }

        function updateExplainDescriptions(person,type){
	    	ExplainDeliveryPersonService.get({
		    	id : itemVM.cartItem.owningProperty.propertyId,
		    	deliveryPerson : person,
		    	deliveryMethod : type,
		    	languageKey : ($translate.use() || 'en' ).split('_')[0].split('-')[0]
		    }).$promise.then(function(response){
		    	//console.log("RESPONSE",response);
		    	if(response.text){
    				itemVM.customExplain[type][person] = response.text;
    			}
	    	});
	    }

	    itemVM.openExplainDeliveryModal = function (size, parentSelector) {
	        var parentElem = parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;
	        var modalOptions = angular.extend({}, defaultModalOptions);
	        modalOptions.templateUrl = 'app/site/shoppingcart/explain/explain-delivery-modal.html';
	        modalOptions.appendTo = parentElem || modalOptions.appendTo;
	        modalOptions.size = size || modalOptions.size;
	        var modalInstance = $uibModal.open(modalOptions);
	        //modalInstance.result.then(function (something) {
	        //}, function () {
	        //  console.info('Modal dismissed at: ' + new Date());
	        //});
	    };

        itemVM.openExplainRecipientModal = function (size, parentSelector) {
            var parentElem = parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;
            var modalOptions = angular.extend({},defaultModalOptions);
            modalOptions.templateUrl = 'app/site/shoppingcart/explain/explain-recipient-modal.html';
            modalOptions.appendTo = parentElem || modalOptions.appendTo;
            modalOptions.size = size || modalOptions.size;
            var modalInstance = $uibModal.open(modalOptions);
        };

	    itemVM.openExplainDedicationModal = function (size, parentSelector) {
	        var parentElem = parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;
	        var modalOptions = angular.extend({},defaultModalOptions);
	        modalOptions.templateUrl = 'app/site/shoppingcart/explain/explain-dedication-modal.html';
	        modalOptions.appendTo = parentElem || modalOptions.appendTo;
	        modalOptions.size = size || modalOptions.size;
	        var modalInstance = $uibModal.open(modalOptions);
	    };

	    itemVM.openExplainValueModal = function (size, parentSelector) {
	    	var parentElem = parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;
	        var modalOptions = angular.extend({},defaultModalOptions);
	        modalOptions.templateUrl = 'app/site/shoppingcart/explain/explain-value-modal.html';
	        modalOptions.appendTo = parentElem || modalOptions.appendTo;
	        modalOptions.size = size || modalOptions.size;
	        var modalInstance = $uibModal.open(modalOptions);
	    };

	    itemVM.openExplainCopyModal = function (size, parentSelector) {
	    	var parentElem = parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;
	        var modalOptions = angular.extend({},defaultModalOptions);
	        modalOptions.templateUrl = 'app/site/shoppingcart/explain/explain-copy-modal.html';
	        modalOptions.appendTo = parentElem || modalOptions.appendTo;
	        modalOptions.size = size || modalOptions.size;
	        var modalInstance = $uibModal.open(modalOptions);
	    };


        itemVM.openExplainScheduledLaterModal = function (size, parentSelector) {
            var parentElem = parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;
            var modalOptions = angular.extend({},defaultModalOptions);
            modalOptions.templateUrl = 'app/site/shoppingcart/explain/explain-schedule-later-modal.html';
            modalOptions.appendTo = parentElem || modalOptions.appendTo;
            modalOptions.size = size || modalOptions.size;
            var modalInstance = $uibModal.open(modalOptions);
        };

        function shouldCollapsedDescr() {
            var viewportWidth = $window.jQuery($window).width();
            if (viewportWidth < 767) {
                return true;
            }
            return false;
        }

	}
})();

(function() {
    'use strict';

    angular.module('vobeApp').component('cartItemVoucher', {
        templateUrl: 'app/components/shopping-cart/item-details/shopping-cart-item-voucher.html',
        controller: 'CartItemVoucherController',
        controllerAs: 'itemVM',
        bindings: {
            shoppingCart: '<',
            shoppingCartConfigs: '<',
            emailConfig: '<',
            cartItem: '<',
            cartItemIndex: '<',
            cartItemFirst: '<',
            isBulk: '<',
            checkoutForm: '<',
            checkoutFormInvalid: '<',
            channel: '<',
            property: '<',
            currentLanguage: '<',
            propertyGroup: '<',
        }
    });
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('ShoppingCartItemDetailsService', ShoppingCartItemDetailsService);

    function ShoppingCartItemDetailsService($q, $http, $sce, $state) {
        'ngInject';

        var service = {
            getDefaultVoucher : getDefaultVoucher,
            getVoucherPropertyForIndividualSite: getVoucherPropertyForIndividualSite,
            getVoucherPropertyForGroupSite: getVoucherPropertyForGroupSite,

            calculateSelectedAmountAfterDiscount : calculateSelectedAmountAfterDiscount,
            defaultShowValue:defaultShowValue,
            getImageFileName: getImageFileName,
            useImgix: useImgix,
        };

        return service;

        function getDefaultVoucher(focusedAmount, voucherId, voucherPool) {
            voucherId = parseInt(voucherId);
            console.log('===getDefaultVoucher..')
            console.log('focusedAmount', focusedAmount)
            console.log('voucherId', voucherId)
            console.log('voucherPool', voucherPool)
            var useFirst = !focusedAmount || focusedAmount==0;
            var defaultVoucher;

            if (voucherPool) {
                angular.forEach(voucherPool.vouchers, function (value, key) {
                    console.log('value', value)
                    console.log('sanity check, ', value.id === voucherId, value.totalRate.increment > 0)
                    if (useFirst && value.id === voucherId) {
                        defaultVoucher = value;
                    } else if (value.id === voucherId && focusedAmount === value.totalRate.priceMin) {
                        console.log('price min check...');
                        defaultVoucher = value;
                    } else if (value.id === voucherId && value.totalRate.increment > 0) {
                        //this could be incremented value
                        console.log('incremented value check...');
                        var generatedRange = [];
                        for (var i = value.totalRate.priceMin; i <= value.totalRate.priceMax; i += value.totalRate.increment) {
                            generatedRange.push(i);
                        }
                        if (generatedRange.includes(focusedAmount)) {
                            defaultVoucher = value;
                        }
                    }
                });

                //if we still don't have voucher it could be typed amount
                if (!defaultVoucher && voucherPool.enableTypedAmounts) {
                    //TODO: validate typed min max range ?
                    angular.forEach(voucherPool.vouchers, function (value, key) {
                        if (value.id === voucherId && !defaultVoucher) {
                            defaultVoucher = value;
                        }
                    });
                }
            }



            if(defaultVoucher){
                defaultVoucher.voucherDescriptionTrustedHtml = $sce.trustAsHtml(defaultVoucher.voucherDescription);
                defaultVoucher.selectedAmount = focusedAmount;
                return defaultVoucher;
            } else {
                $state.transitionTo('property.list');
            }
        }

        function calculateSelectedAmountAfterDiscount(beforeDiscountAmount, appliedPromotionCode, itemQuantity) {

            console.log('calculateSelectedAmountAfterDiscount..', beforeDiscountAmount, appliedPromotionCode);
            if (typeof itemQuantity === 'undefined') {
                itemQuantity = 1;
            }
            console.log('itemQuantity', itemQuantity)



            var newSelectedAmountAfterDiscount = beforeDiscountAmount;

            if (!appliedPromotionCode) {
                newSelectedAmountAfterDiscount = beforeDiscountAmount;
            } else if (itemQuantity < appliedPromotionCode.minQuantity) {
                return newSelectedAmountAfterDiscount;
            } else {
                if (appliedPromotionCode.amountPercentage) {
                    newSelectedAmountAfterDiscount = beforeDiscountAmount - beforeDiscountAmount * (appliedPromotionCode.discountAmount / 100.0);
                } else {
                    newSelectedAmountAfterDiscount = beforeDiscountAmount - appliedPromotionCode.discountAmount;
                }
            }
            return newSelectedAmountAfterDiscount;
        }

        function defaultShowValue(itemType, voucherProperty, item) {
            if(itemType.toLowerCase().includes("refund")){
                return true;
            }
            if (['MDVHIE', 'CLYVIE', 'MDHVUK', 'CLYVUK', 'CWHVIE', 'CHSVIE', 'CHGVIE', 'MHSVIE'].indexOf(voucherProperty.hotelCode.toUpperCase()) != -1) {
                return undefined;
            }
            if (voucherProperty && ['BSHVUK'].indexOf(voucherProperty.hotelCode.toUpperCase()) != -1) {
                return 'true';
            }
            if(item && ['BSHVUK'].indexOf(item.owningProperty.propertyCode.toUpperCase())!=-1){
                return 'true';
            }
            if (itemType == 'package') {
                return 'false';
            }
        }


        function getImageFileName(voucherPool){

            var giftCard = voucherPool.giftCard;
            if(giftCard && giftCard.imageUrl && giftCard.imageUrl.trim().length>0){
                return useImgix( giftCard.imageUrl);
            }

            var firstVoucher = undefined;
            angular.forEach(voucherPool.vouchers,function(voucher,vkey){
                firstVoucher = firstVoucher || voucher;
            });
            if (firstVoucher && firstVoucher.images && firstVoucher!=null && firstVoucher.images[7]) {
                return useImgix(firstVoucher.images[7]);
            } else {
                return "//in1-image-library.imgix.net/no-image.jpg";
            }
        }

        function useImgix(imgUrl){
            var old_host = 'dddo4e1h8fdy4.cloudfront.net';
            var new_host = 'in1-image-library.imgix.net';
            return imgUrl.replace(old_host, new_host);
        }

        function getVoucherPropertyForIndividualSite(voucher,property){
            var propertyForIndividualSite = property;
            if(voucher && voucher.hotelId != property.hotelId){
                //try among master hotels
                if(property.masterProperties && property.masterProperties!=null){
                    angular.forEach(property.masterProperties,function(hotel,hkey){
                        if(hotel.hotelId==voucher.hotelId){
                            propertyForIndividualSite = hotel;
                        }
                    });
                }
            }

            return propertyForIndividualSite;
        }

        function getVoucherPropertyForGroupSite(voucher, propertyGroup){
            if(!voucher){
                return undefined;
            }
            if(!propertyGroup || !propertyGroup.hotels){
                return undefined;
            }
            var propertyForGroupSite = undefined;
            angular.forEach(propertyGroup.hotels,function(hotel,hkey){
                if(hotel.hotelId==voucher.hotelId){
                    propertyForGroupSite = hotel;
                }
            })
            return propertyForGroupSite;
        }


    }
})();

(function() {
    'use strict';

    angular.module('vobeApp')
        .component('currencyNavDropdown', {
            templateUrl: 'app/components/shopping-cart/currencyDropdown/currency-nav-dropdown.html',
            controller: 'CurrencyDropdownController',//same controller as currency button
            controllerAs: 'vm',
            bindings: {
                onUpdate: '<',
                collapseWorldNavbar:'<',
                onAvailableCurrencies: '<'
            }
        });
})();

(function() {
    'use strict';

    angular.module('vobeApp').controller('CurrencyDropdownController', CurrencyDropdownController);

    function CurrencyDropdownController(
        $scope,
        $rootScope,
        $state,
        $stateParams,
        $translate,
        $q,
        CurrencyExchange,
        $localStorage

    ) {
        'ngInject';
        var vm = this;
        var currencyApi = CurrencyExchange;

        vm.currencies = currencyApi.currencies.all;//it's map with code as key-value as currencyCode-currencyObject
        vm.availableCurrencies = currencyApi.currencyCodes.all;

        //vm.baseCurrency = currencyApi.currencies.base;//base currency might be undefined if this is group engine
        vm.currentCurrency = currencyApi.currencies.current;//current currency might be NULL if this is group engine

        vm.changeCurrency = changeCurrency;

        if(vm.onAvailableCurrencies){
            vm.onAvailableCurrencies(vm.availableCurrencies);
        }

        function changeCurrency(currency) {

            if(currency) {
                currencyApi.changeCurrency(currency.code);
            } else {
                currencyApi.resetCurrency();
            }

            vm.currentCurrency = currencyApi.currencies.current;

            if(vm.onUpdate){
                vm.onUpdate(currency);
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('vobeApp')
        .component('currencyDropdownButton', {
            templateUrl: 'app/components/shopping-cart/currencyDropdown/currency-dropdown-button.html',
            controller: 'CurrencyDropdownController',
            controllerAs: 'currencyVm',
            bindings: {
                onUpdate: '<'
            }
        });
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('CurrenciesService', CurrenciesService);

    CurrenciesService.$inject = ['$resource'];

    function CurrenciesService ($resource) {
        var service = $resource('api/currency/list', {}, {
            'get': {
                method: 'GET',
                isArray: true,
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });
        return service;
    }
})();

angular.module("payment", ["payment.tpls", "payment.service","payment.restrictNumeric","payment.cardCvc","payment.cardExpiry","payment.cardNumber"]);
angular.module("payment.tpls", ["template/cardCvc/cardCvc.html","template/cardExpiry/cardExpiry.html","template/cardNumber/cardNumber.html"]);
/*global angular: false */
angular.module('payment.service', [])
    .factory('payment', ['$document', function ($document) {
        'use strict';

        var defaultFormat = /(\d{1,4})/g,
            cards = [
                {
                    type: 'maestro',
                    pattern: /^(5(018|0[23]|[68])|6(39|7))/,
                    format: defaultFormat,
                    length: [12, 13, 14, 15, 16, 17, 18, 19],
                    cvcLength: [3],
                    luhn: true
                }, {
                    type: 'dinersclub',
                    pattern: /^(36|38|30[0-5])/,
                    format: defaultFormat,
                    length: [14],
                    cvcLength: [3],
                    luhn: true
                }, {
                    type: 'laser',
                    pattern: /^(6706|6771|6709)/,
                    format: defaultFormat,
                    length: [16, 17, 18, 19],
                    cvcLength: [3],
                    luhn: true
                }, {
                    type: 'jcb',
                    pattern: /^35/,
                    format: defaultFormat,
                    length: [16],
                    cvcLength: [3],
                    luhn: true
                }, {
                    type: 'unionpay',
                    pattern: /^62/,
                    format: defaultFormat,
                    length: [16, 17, 18, 19],
                    cvcLength: [3],
                    luhn: false
                }, {
                    type: 'discover',
                    pattern: /^(6011|65|64[4-9]|622)/,
                    format: defaultFormat,
                    length: [16],
                    cvcLength: [3],
                    luhn: true
                }, {
                    type: 'mastercard',
                    pattern: /^(5[1-5]|2[2-7])/,
                    format: defaultFormat,
                    length: [16],
                    cvcLength: [3],
                    luhn: true
                }, {
                    type: 'amex',
                    pattern: /^3[47]/,
                    format: /(\d{1,4})(\d{1,6})?(\d{1,5})?/,
                    length: [15],
                    cvcLength: [3, 4],
                    luhn: true
                }, {
                    type: 'visa',
                    pattern: /^4/,
                    format: defaultFormat,
                    length: [13, 14, 15, 16],
                    cvcLength: [3],
                    luhn: true
                }, {
                    type: 'visaelectron',
                    pattern: /^4(026|17500|405|508|844|91[37])/,
                    format: defaultFormat,
                    length: [16],
                    cvcLength: [3],
                    luhn: true
                }, {
                    type: 'forbrugsforeningen',
                    pattern: /^600/,
                    format: defaultFormat,
                    length: [16],
                    cvcLength: [3],
                    luhn: true
                }, {
                    type: 'dankort',
                    pattern: /^5019/,
                    format: defaultFormat,
                    length: [16],
                    cvcLength: [3],
                    luhn: true
                },
                {
                    type: 'in1van',
                    pattern: /^737849/,
                    format: defaultFormat,
                    length: [16],
                    cvcLength: [3],
                    luhn: true
                }
            ],
            trim = function (str) {
                return str.toString().replace(/^\s+|\s+$/g, '');
            },
            hasTextSelected = function (elm) {
                var ref;
                if ((elm.prop('selectionStart') != null) && elm.prop('selectionStart') !== elm.prop('selectionEnd')) { return true; }
                return $document !== undefined && $document !== null ? (ref = $document.selection) != null ? typeof ref.createRange === "function" ? ref.createRange().text : undefined : undefined : undefined;
            },
            cardFromNumber = function (num) {
                var card, i, len;
                if (!num) { return null; }
                num = num.toString().replace(/\D/g, '');
                for (i = 0, len = cards.length; i < len; i++) {
                    card = cards[i];
                    if (card.pattern.test(num)) { return card; }
                }

                return null;
            },
            luhnCheck = function (num) {
                var digit, digits = num.toString().split('').reverse(), sum = 0, i, odd = true;
                for (i = 0; i < digits.length; i++) {
                    digit = digits[i];
                    digit = parseInt(digit, 10);
                    if ((odd = !odd)) { digit *= 2; }
                    if (digit > 9) { digit -= 9; }
                    sum += digit;
                }

                return sum % 10 === 0;
            },
            validateCardNumber = function (num) {
                if (!num) { return false; }

                var card;
                num = num.toString().replace(/\s+|-/g, '');
                if (!/^\d+$/.test(num)) { return false; }
                card = cardFromNumber(num);

                return card ? (card.length.indexOf(num.length) >= 0) && (card.luhn === false || luhnCheck(num)) : false;
            },
            formatCardNumber = function (num) {
                var card = cardFromNumber(num), groups, upperLength, ref, result;
                if (!card) { return num; }
                upperLength = card.length[card.length.length - 1];
                num = num.replace(/\D/g, '');
                num = num.slice(0, +upperLength + 1 || 9e9);
                if (card.format.global) {
                    result = (ref = num.match(card.format)) !== null ? ref.join(' ') : undefined;
                } else {
                    groups = card.format.exec(num);
                    if (groups !== null) { groups.shift(); }
                    result = groups !== null ? groups.join(' ') : undefined;
                }

                return result;
            },
            validateCardExpiry = function (month, year) {
                var currentTime, expiry, prefix;
                if (typeof month === 'object' && month.hasOwnProperty('month')) {
                    year = month.year;
                    month = month.month;
                }

                if (!(month && year)) { return false; }

                month = trim(month);
                year = trim(year);
                if (!/^\d+$/.test(month)) { return false; }
                if (!/^\d+$/.test(year)) { return false; }
                if (!(parseInt(month, 10) <= 12)) { return false; } // jshint ignore:line
                if (year.length === 2) {
                    prefix = (new Date()).getFullYear();
                    prefix = prefix.toString().slice(0, 2);
                    year = prefix + year;
                }

                expiry = new Date(year, month);
                currentTime = new Date();
                expiry.setMonth(expiry.getMonth() - 1);
                expiry.setMonth(expiry.getMonth() + 1, 1);

                return expiry > currentTime;
            },
            cardFromType = function (type) {
                var i;
                for (i = 0; i < cards.length; i++) {
                    if (cards[i].type === type) { return cards[i]; }
                }

                return undefined;
            },
            validateCardCVC = function (cvc, type) {
                var card;
                cvc = trim(cvc);
                if (!/^\d+$/.test(cvc)) { return false; }
                if (type) {
                    card = cardFromType(type);
                    return card ? card.cvcLength.indexOf(cvc.length) >= 0 : false;
                }

                return cvc.length >= 3 && cvc.length <= 4;
            };

        return {
            hasTextSelected: hasTextSelected,
            cardFromNumber: cardFromNumber,
            validateCardNumber: validateCardNumber,
            validateCardExpiry: validateCardExpiry,
            validateCardCvc: validateCardCVC,
            formatCardNumber: formatCardNumber
        };
    }]);
angular.module('payment.restrictNumeric', [])
    .directive('restrictNumeric', function () {
        'use strict';
        var restrictNumeric = function (allowDecimals) {
            return function (e) {
                if (e.metaKey || e.ctrlKey || e.which === 0 || e.which < 33) { return; }
                var input = String.fromCharCode(e.which);
                // Allow decimal point if "allow-decimals" is true
                if (allowDecimals && input === '.') { return; }
                // Allow only digits and, if "allow-decimals" is true, a single decimal point followed by up to two digits
                var pattern = allowDecimals ? /^[\d]*\.?[\d]{0,2}$/ : /^[\d\s]*$/;
                if (!pattern.test(e.target.value + input)) { e.preventDefault(); }
            };
        };

        return {
            restrict: 'A',
            scope: {
                allowDecimals: '<'
            },
            link: function postLink(scope, element) {
                element.bind('keypress', restrictNumeric(scope.allowDecimals));
            }
        };
    });
/*global angular: false */
angular.module('payment.cardCvc', ['payment.service', 'payment.restrictNumeric'])
    .directive('cardCvcInput', function () {
        'use strict';
        return {
            restrict: 'E',
            templateUrl: 'template/cardCvc/cardCvc.html',
            replace: true
        };
    })

    .directive('cardCvcFormatter', function () {
        'use strict';
        var restrictCvc = function (e) {
            var elm = angular.element(e.currentTarget), digit, val;
            digit = String.fromCharCode(e.which);
            if (!/^\d+$/.test(digit)) { return; }

            val = elm.val() + digit;
            if (val.length > 4) { e.preventDefault(); }
        };

        return {
            link: function postLink(scope, element) {
                element.bind('keypress', restrictCvc);
            }
        };
    })

    .directive('cardCvcValidator', ['payment', function (payment) {
        'use strict';
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {
                function validate(value) {
                    var valid = value ? payment.validateCardCvc(value) : false;
                    ngModelCtrl.$setValidity('cardCvc', valid);
                    return valid;
                }

                ngModelCtrl.$parsers.unshift(function (value) {
                    return validate(value) ? value : undefined;
                });

                ngModelCtrl.$formatters.unshift(function (value) {
                    validate(value);
                });
            }
        };
    }]);
/*global angular: false */
angular.module('payment.cardExpiry', ['payment.service', 'payment.restrictNumeric'])
    .directive('cardExpiryInput', ['payment', function (payment) {
        'use strict';
        return {
            restrict: 'E',
            templateUrl: 'template/cardExpiry/cardExpiry.html',
            replace: true
        };
    }])

    .directive('cardExpiryFormatter', ['payment', function (payment) {
        'use strict';
        var formatExpiry = function (e) {
                var elm, digit, val;

                digit = String.fromCharCode(e.which);
                if (!/^\d+$/.test(digit)) { return; }
                elm = angular.element(e.currentTarget);
                val = elm.val() + digit;
                if (/^\d$/.test(val) && (val !== '0' && val !== '1')) {
                    e.preventDefault();
                    elm.val('0' + val + ' / ');
                } else if (/^\d\d$/.test(val)) {
                    e.preventDefault();
                    elm.val(val + ' / ');
                }
            },
            formatForwardExpiry = function (e) {
                var elm, digit, val;

                digit = String.fromCharCode(e.which);
                if (!/^\d+$/.test(digit)) { return; }
                elm = angular.element(e.currentTarget);
                val = elm.val();
                if (/^\d\d$/.test(val)) { elm.val(val + ' / '); }
            },
            formatForwardSlash = function (e) {
                var elm, slash, val;

                slash = String.fromCharCode(e.which);
                if (slash !== '/') { return; }
                elm = angular.element(e.currentTarget);
                val = elm.val();
                if (/^\d$/.test(val) && val !== '0') { elm.val(val + " / "); }
            },
            formatBackExpiry = function (e) {
                var elm, value;

                if (e.meta) { return; }
                elm = angular.element(e.currentTarget);
                value = elm.val();
                if (e.which !== 8) { return; }
                if ((elm.prop('selectionStart') != null) && elm.prop('selectionStart') !== value.length) { return; }
                if (/\d(\s|\/)+$/.test(value)) {
                    e.preventDefault();
                    elm.val(value.replace(/\d(\s|\/)*$/, ''));
                } else if (/\s\/\s?\d?$/.test(value)) {
                    e.preventDefault();
                    elm.val(value.replace(/\s\/\s?\d?$/, ''));
                }
            },
            restrictExpiry = function (e) {
                var elm = angular.element(e.currentTarget), digit, value;

                digit = String.fromCharCode(e.which);
                if (!/^\d+$/.test(digit)) { return; }
                if (payment.hasTextSelected(elm)) { return; }
                value = elm.val() + digit;
                value = value.replace(/\D/g, '');
                if (value.length > 6) { e.preventDefault(); }
            };

        return {
            link: function postLink(scope, element) {
                element.bind('keypress', restrictExpiry);
                element.bind('keypress', formatExpiry);
                element.bind('keypress', formatForwardSlash);
                element.bind('keypress', formatForwardExpiry);
                element.bind('keydown', formatBackExpiry);
            }
        };
    }])

    .directive('cardExpiryValidator', ['payment', function (payment) {
        'use strict';
        var cardExpiryVal = function (value) {
            var month, prefix, year, ref;

            value = value.replace(/\s/g, '');
            ref = value.split('/', 2);
            month = ref[0];
            year = ref[1];

            if ((year ? year.length : undefined) === 2 && /^\d+$/.test(year)) {
                prefix = (new Date()).getFullYear();
                prefix = prefix.toString().slice(0, 2);
                year = prefix + year;
            }

            month = parseInt(month, 10);
            year = parseInt(year, 10);

            return {month: month, year: year};
        };

        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {
                ngModelCtrl.$parsers.unshift(function (value) {
                    var expiry = cardExpiryVal(value), valid = payment.validateCardExpiry(expiry.month, expiry.year);
                    ngModelCtrl.$setValidity('cardExpiry', valid);
                    return valid ? expiry : undefined;
                });

                ngModelCtrl.$formatters.unshift(function (value) {
                    var valid = (value && value.hasOwnProperty('month') && value.hasOwnProperty('year')) ?
                            payment.validateCardExpiry(value.month, value.year) : false;
                    ngModelCtrl.$setValidity('cardExpiry', valid);
                    return valid ? value.month + ' / ' + value.year : undefined;
                });
            }
        };
    }]);
angular.module('payment.cardNumber', ['payment.service', 'payment.restrictNumeric'])
    .directive('cardNumberInput', function () {
        'use strict';
        return {
            restrict: 'E',
            templateUrl: 'template/cardNumber/cardNumber.html',
            replace: true
        };
    })

    .directive('cardNumberFormatter', ['$timeout', '$parse', 'payment', function ($timeout, $parse, payment) {
        'use strict';
        var restrictCardNumber = function (e) {
                var card, digit = String.fromCharCode(e.which), value, elm = angular.element(e.currentTarget);

                if (!/^\d+$/.test(digit)) { return; }
                if (payment.hasTextSelected(elm)) { return; }

                value = (elm.val() + digit).replace(/\D/g, '');
                card = payment.cardFromNumber(value);

                if (card && value.length > card.length[card.length.length - 1]) {
                    e.preventDefault();
                } else if (value.length > 16) {
                    e.preventDefault();
                }
            },
            formatCardNumber = function (e) {
                var elm, card, digit, length, re, upperLength = 16, value;

                digit = String.fromCharCode(e.which);
                if (!/^\d+$/.test(digit)) { return; }

                elm = angular.element(e.currentTarget);
                value = elm.val();
                card = payment.cardFromNumber(value + digit);
                length = (value.replace(/\D/g, '') + digit).length;

                if (card) { upperLength = card.length[card.length.length - 1]; }
                if (length >= upperLength) { return; }
                if ((elm.prop('selectionStart') !== null) && elm.prop('selectionStart') !== value.length) { return; }
                if (card && card.type === 'amex') {
                    re = /^(\d{4}|\d{4}\s\d{6})$/;
                } else {
                    re = /(?:^|\s)(\d{4})$/;
                }

                if (re.test(value)) {
                    e.preventDefault();
                    elm.val(value + ' ' + digit);
                } else if (re.test(value + digit)) {
                    e.preventDefault();
                    elm.val(value + digit + ' ');
                }
            },
            reFormatCardNumber = function (e) {
                var elm = angular.element(e.currentTarget);
                $timeout(function () {
                    var value = elm.val();
                    value = payment.formatCardNumber(value);
                    elm.val(value);
                });
            };

        return {
            require: 'ngModel',
            link: function postLink(scope, element, attrs, ngModelCtrl) {
                var cardType = $parse(attrs.cardType);

                element.bind('keypress', restrictCardNumber);
                element.bind('keypress', formatCardNumber);
                element.bind('paste', reFormatCardNumber);

                function applyCardType(value) {
                    if (attrs.cardType) {
                        var card = payment.cardFromNumber(value);
                        cardType.assign(scope, (card && cardType !== card.type) ? card.type : null);
                    }
                }

                ngModelCtrl.$formatters.unshift(function (value) {
                    applyCardType(value);
                    return payment.formatCardNumber(value);
                });

                ngModelCtrl.$parsers.unshift(function (value) {
                    applyCardType(value);
                    return value;
                });
            }
        };
    }])

    .directive('cardNumberValidator', ['payment', function (payment) {
        'use strict';
        return {
            require: 'ngModel',
            link: function (scope, elm, attrs, ngModelCtrl) {
                function validate(value) {
                    if (!value) { return false; }
                    var valid = payment.validateCardNumber(value);
                    ngModelCtrl.$setValidity('cardNumber', valid);
                    return valid;
                }

                ngModelCtrl.$parsers.push(function (value) {
                    return validate(value) ? value.replace(/ /g, '') : undefined;
                });

                ngModelCtrl.$formatters.unshift(function (value) {
                    validate(value);
                    return value;
                });
            }
        };
    }]);
angular.module("template/cardCvc/cardCvc.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/cardCvc/cardCvc.html",
    "<input type=\"text\" x-autocompletetype=\"cc-csc\" restrict-numeric card-cvc-validator card-cvc-formatter ng-maxlength=\"4\" ng-pattern=\"/\\d*/\" />");
}]);

angular.module("template/cardExpiry/cardExpiry.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/cardExpiry/cardExpiry.html",
    "<input type=\"text\" class=\"cc-exp\" x-autocompletetype=\"cc-exp\" maxlength=\"9\" restrict-numeric card-expiry-validator card-expiry-formatter />");
}]);

angular.module("template/cardNumber/cardNumber.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("template/cardNumber/cardNumber.html",
    "<input type=\"text\" x-autocompletetype=\"cc-number\" restrict-numeric card-number-validator card-number-formatter />");
}]);

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES','translationStorageProvider'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES, translationStorageProvider) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            //var language = $translate.storage().get('LANG_JhiLanguageService');
            var language = translationStorageProvider.get($translate.storageKey());
            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular.module('vobeApp').filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                ca: 'Català',
                cs: 'Český',
                da: 'Dansk',
                de: 'Deutsch',
                el: 'Ελληνικά',
                en: 'English',
                'en-gb': 'English (UK)',
                'en_GB': 'English (UK)',
                es: 'Español',
                fr: 'Français',
                gl: 'Galego',
                hu: 'Magyar',
                hi: 'हिंदी',
                it: 'Italiano',
                ja: '日本語',
                ko: '한국어',
                mr: 'मराठी',
                nl: 'Nederlands',
                pl: 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt': 'Português',
                'pt-pt': 'Português',
                'pt_BR': 'Português (Brasil)',
                'pt_PT': 'Português',
                ro: 'Română',
                ru: 'Русский',
                sk: 'Slovenský',
                sv: 'Svenska',
                he: 'עברי',
                iw: 'עברי',
                ta: 'தமிழ்',
                tr: 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文',
                zh: '中文（简体）', /*this is zh-cn just IMC don't use country*/
                ar: 'عربى',
                hr: 'Hrvatski'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            try {
            	tmhDynamicLocale.set(languageKey);
			} catch (e) {
				// TODO: handle exception
			}
            
        }
    }
})();

(function() {
    'use strict';


    //var langs = {};


    angular
        .module('vobeApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'en_GB',
            'en_IE',
            //'en-gb',//these will not work as mappings will never resolve to this
            //'en-ie',//these will not work as mappings will never resolve to this
            'ru',
            'es',
            'fr',
            'nl',
            'it',
            'pl',
            'zh',
            'he',
            'iw',
            'ar',
            'ja',
            'ko',
            'de',
            'pt',
            'hr',
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ])
        .constant('LANGUAGES_MAPPINGS', {
            'en': 'en',
            //this will never work as $translate will use for-each (=keys are enumerated) to loop and order is not guaranteed (as oppose to Object.keys(obj) which is guaranteed) https://exploringjs.com/es6/ch_oop-besides-classes.html#_traversal-order-of-properties
            //en_GB': 'en-gb',
            //en_IE': 'en-ie',
            'ru': 'ru',
            'es': 'es',
            'fr': 'fr',
            'nl': 'nl',
            'it': 'it',
            'pl': 'pl',
            'zh': 'zh',
            'he': 'he',
            'iw': 'iw',
            'ar': 'ar',
            'ja': 'ja',
            'ko': 'ko',
            'de': 'de',
            'pt': 'pt',
            'hr': 'hr',

            'en_*': 'en',
            'ru_*': 'ru',
            'es_*': 'es',
            'fr_*': 'fr',
            'nl_*': 'nl',
            'it_*': 'it',
            'pl_*': 'pl',
            'zh_*': 'zh',
            'he_*': 'he',
            'iw_*': 'iw',
            'ar_*': 'ar',
            'ja_*': 'ja',
            'ko_*': 'ko',
            'de_*': 'de',
            'pt_*': 'pt',
            'hr_*': 'hr',
            '*': 'en'
        });
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';


    angular
        .module('vobeApp')
        .filter('trustHtml', trustHtml);

    trustHtml.$inject = ['$sce'];

    function trustHtml($sce) {
        return function (text) {
            return $sce.trustAsHtml(text);
        };
    }
})();

(function() {
    'use strict';


    angular
        .module('vobeApp')
        .filter('numberInteger', numberInteger);

    numberInteger.$inject = ['$filter'];

    function numberInteger ($filter) {
    	return function (number) {
    		if(isNaN(number)){
    			return number;
    		}
    		//console.log('numberInteger from: ',number);
    		var price = parseInt(number);
    		return $filter("currency")(price, "", 0).trim();
    	};
    }
})();

(function () {
    'use strict';


    angular
        .module('vobeApp')
        .filter('numberFraction', numberFraction);


    function numberFraction(XE_CURRENCIES) {
        'ngInject';
        return function (number, fractionSize, toCode) {

            if (isNaN(number)) {
                return '';
            }
            var toCurrencyDetails;
            if (toCode) {
                toCurrencyDetails = XE_CURRENCIES[toCode];
            }
            var fractionLength = isNaN(fractionSize) ? 2 : fractionSize;
            if (toCurrencyDetails) {
                fractionLength = toCurrencyDetails[0];
            }
            //console.log('numberFraction',number,fractionLength,toCode);
            //if currency has no fraction, don't do it
            if (fractionLength < 1) {
                return '';
            }
            var fraction = Math.ceil(((number < 1.0) ? number : (number % Math.floor(number)).toFixed(4)) * Math.pow(10, fractionLength));
            if (fraction > 0) {
                var paddedFraction = pad(fraction,fractionLength);
                var fractionRegex = /(\d{2})/.exec(paddedFraction);
                return '.'+fractionRegex[0];
            } else {
                return '.00';
            }
        };
    }

    function pad(num, size) {
        num = num.toString();
        while (num.length < size) num = "0" + num;
        return num;
    }

})();

(function() {
    'use strict';


    angular
        .module('vobeApp')
        .filter('currencySign', currencySign);

    currencySign.$inject = ['$filter'];

    function currencySign ($filter) {
    	return function (currency) {
    		if(currency=='USD'){
    			return '$';
    		}
    		else if(currency=='EUR'){
    			return '€';
    		}
    		else if(currency=='GBP'){
    			return '£';
    		}
    		return currency;
    	};
    }
})();

(function() {
    'use strict';

    angular.module('vobeApp').controller('CookiesPolicyController', CookiesPolicyController);

    function CookiesPolicyController(
        $anchorScroll

    ) {
        'ngInject';
        var vm = this;

        $anchorScroll();


    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .constant('IN1_CONSENT',{
            //generic strings
            COOKIE_NAME: "in1_vobe_consent",
            GRANTED: "granted",
            DENIED: "denied",
            MODIFIED: "modified",
            //consent category names
            ALL : 'in1_consent_granted_all',
            ANALYTICS : 'in1_consent_analytics',//ie. GA
            ADVERTISING : 'in1_consent_advertising',//ie. profiling and re-marketing by google ads
            PERFORMANCE : 'in1_consent_performance',//ie. posthog
            ENHANCEMENT : 'in1_consent_enhancement',//ie. posthog
            FUNCTIONAL : 'in1_consent_functional',//ie. language preferences
            TRACKING : 'in1_consent_tracking',//ie. conversion tracking
            STRICTLY_NECESSARY : 'in1_consent_strictly_necessary',

            //internal vobe events
            EVENT_GRANTED_ALL : 'in1_consent_granted_all',
            EVENT_GRANTED_ANALYTICS : 'in1_consent_granted_analytics',//ie. GA
            EVENT_GRANTED_ADVERTISING : 'in1_consent_granted_advertising',
            EVENT_GRANTED_PERFORMANCE : 'in1_consent_granted_performance',//ie. posthog
            EVENT_GRANTED_ENHANCEMENT : 'in1_consent_granted_enhancement',//ie. triptease?
            EVENT_GRANTED_FUNCTIONAL : 'in1_consent_granted_functional',//ie. language preferences
            EVENT_GRANTED_TRACKING : 'in1_consent_granted_tracking',//ie. profiling and re-marketing by google ads
            EVENT_GRANTED_STRICTLY_NECESSARY : 'in1_consent_granted_strictly_necessary',
            EVENT_DENIED_ALL : 'in1_consent_denied_all',
            EVENT_DENIED_ANALYTICS : 'in1_consent_denied_analytics',//ie. GA
            EVENT_DENIED_ADVERTISING : 'in1_consent_denied_advertising',
            EVENT_DENIED_PERFORMANCE : 'in1_consent_denied_performance',//ie. posthog
            EVENT_DENIED_ENHANCEMENT : 'in1_consent_denied_enhancement',//ie. triptease?
            EVENT_DENIED_FUNCTIONAL : 'in1_consent_denied_functional',//ie. language preferences
            EVENT_DENIED_TRACKING : 'in1_consent_denied_taracking',//ie. profiling and re-marketing by google ads
            EVENT_DENIED_STRICTLY_NECESSARY : 'in1_consent_denied_strictly_necessary',

            //Events sent to GTM
            GTM_EVENT_GRANTED_ALL : 'in1_consent_granted_all',
            GTM_EVENT_GRANTED_ANALYTICS : 'in1_consent_granted_analytics',//ie. GA
            GTM_EVENT_GRANTED_ADVERTISING : 'in1_consent_granted_advertising',
            GTM_EVENT_GRANTED_PERFORMANCE : 'in1_consent_granted_performance',//ie. posthog
            GTM_EVENT_GRANTED_ENHANCEMENT : 'in1_consent_granted_enhancement',//ie. triptease?
            GTM_EVENT_GRANTED_FUNCTIONAL : 'in1_consent_granted_functional',//ie. language preferences
            GTM_EVENT_GRANTED_TRACKING : 'in1_consent_granted_tracking',//ie. profiling and re-marketing by google ads
            GTM_EVENT_GRANTED_STRICTLY_NECESSARY : 'in1_consent_granted_strictly_necessary',
            GTM_EVENT_DENIED_ALL : 'in1_consent_denied_all',
            GTM_EVENT_DENIED_ANALYTICS : 'in1_consent_denied_analytics',//ie. GA
            GTM_EVENT_DENIED_ADVERTISING : 'in1_consent_denied_advertising',
            GTM_EVENT_DENIED_PERFORMANCE : 'in1_consent_denied_performance',//ie. posthog
            GTM_EVENT_DENIED_ENHANCEMENT : 'in1_consent_denied_enhancement',//ie. triptease?
            GTM_EVENT_DENIED_FUNCTIONAL : 'in1_consent_denied_functional',//ie. language preferences
            GTM_EVENT_DENIED_TRACKING : 'in1_consent_denied_tracking',//ie. profiling and re-marketing by google ads
            GTM_EVENT_DENIED_STRICTLY_NECESSARY : 'in1_consent_denied_strictly_necessary',
        });

    angular
        .module('vobeApp')
        .factory('CookiesConsentStorageService', CookiesConsentStorageService);

    //CookiesConsentStorageService.$inject = ['$cookies', '$log', '$window', 'IN1_CONSENT', '$rootScope'];

    function CookiesConsentStorageService($cookies, $log, $window, IN1_CONSENT, $rootScope, Analytics) {
        'ngInject';
        return {
            get: get,

            consentGrantedAll: consentGrantedAll,
            consentGrantedAnalytics: consentGrantedAnalytics,
            consentGrantedAdvertising: consentGrantedAdvertising,
            consentGrantedPerformance: consentGrantedPerformance,
            consentGrantedEnhancement: consentGrantedEnhancement,
            consentGrantedFunctional: consentGrantedFunctional,
            consentGrantedTracking: consentGrantedTracking,
            consentGrantedStrictlyNecessary: consentGrantedStrictlyNecessary,

            consentDeniedAll: consentDeniedAll,
            consentDeniedAnalytics: consentDeniedAnalytics,
            consentDeniedAdvertising: consentDeniedAdvertising,
            consentDeniedPerformance: consentDeniedPerformance,
            consentDeniedEnhancement: consentDeniedEnhancement,
            consentDeniedFunctional: consentDeniedFunctional,
            consentDeniedTracking: consentDeniedTracking,
            //consentDeniedStrictlyNecessary: consentDeniedStrictlyNecessary,

            processDefaultConsent: processDefaultConsent
        };


        function init() {
            //we need to record consent, so initial values are not determined
            var consent = {};
            consent[IN1_CONSENT.ALL] = undefined;
            consent[IN1_CONSENT.ANALYTICS] = undefined;
            consent[IN1_CONSENT.ADVERTISING] = undefined;
            consent[IN1_CONSENT.PERFORMANCE] = undefined;
            consent[IN1_CONSENT.FUNCTIONAL] = undefined;
            consent[IN1_CONSENT.ENHANCEMENT] = undefined;
            consent[IN1_CONSENT.TRACKING] = undefined;
            consent[IN1_CONSENT.STRICTLY_NECESSARY] = undefined;
            return consent;
        }

        function get() {
            var consent;
            try {
                consent = $cookies.getObject(IN1_CONSENT.COOKIE_NAME);
            } catch (e){
                $log.error("Cannot get cookie "+IN1_CONSENT.COOKIE_NAME);
            }
            $log.info("getting cookie "+IN1_CONSENT.COOKIE_NAME+", value: ",consent);
            if (!consent) {
                consent = init();
                put(consent, true);
            }
            return consent;
        }

        function put(value, initial) {
            value[IN1_CONSENT.MODIFIED] = initial ? false : true;
            $log.info("putting cookie "+IN1_CONSENT.COOKIE_NAME+": ",value);
            try {
                $cookies.putObject(IN1_CONSENT.COOKIE_NAME, value);
            } catch (e){
                $log.error("Cannot put cookie "+IN1_CONSENT.COOKIE_NAME);
            }

        }

        /*HANDLE GRANT EVENTS*/
        function consentGrantedAll() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = IN1_CONSENT.GRANTED;
            consent[IN1_CONSENT.ANALYTICS] = IN1_CONSENT.GRANTED;
            consent[IN1_CONSENT.ADVERTISING] = IN1_CONSENT.GRANTED;
            consent[IN1_CONSENT.PERFORMANCE] = IN1_CONSENT.GRANTED;
            consent[IN1_CONSENT.FUNCTIONAL] = IN1_CONSENT.GRANTED;
            consent[IN1_CONSENT.ENHANCEMENT] = IN1_CONSENT.GRANTED;
            consent[IN1_CONSENT.TRACKING] = IN1_CONSENT.GRANTED;
            consent[IN1_CONSENT.STRICTLY_NECESSARY] = IN1_CONSENT.GRANTED;

            put(consent);//save

            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_ALL);// $broadcast() sends an even downwards from parent to child controllers
            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_ADVERTISING);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_ANALYTICS);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_PERFORMANCE);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_FUNCTIONAL);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_ENHANCEMENT);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_TRACKING);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_STRICTLY_NECESSARY);

            Analytics.trackEvent('consent', IN1_CONSENT.ALL, IN1_CONSENT.GRANTED);

        };

        function consentGrantedAnalytics() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = undefined;
            consent[IN1_CONSENT.ANALYTICS] = IN1_CONSENT.GRANTED;
            put(consent);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_ANALYTICS);

            Analytics.trackEvent('consent', IN1_CONSENT.ANALYTICS, IN1_CONSENT.GRANTED);
        };

        function consentGrantedAdvertising() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = undefined;
            consent[IN1_CONSENT.ADVERTISING] = IN1_CONSENT.GRANTED;
            put(consent);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_ADVERTISING);

            Analytics.trackEvent('consent', IN1_CONSENT.ADVERTISING, IN1_CONSENT.GRANTED);
        };

        function consentGrantedPerformance() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = undefined;
            consent[IN1_CONSENT.PERFORMANCE] = IN1_CONSENT.GRANTED;
            put(consent);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_PERFORMANCE);

            Analytics.trackEvent('consent', IN1_CONSENT.PERFORMANCE, IN1_CONSENT.GRANTED);
        };

        function consentGrantedEnhancement() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = undefined;
            consent[IN1_CONSENT.ENHANCEMENT] = IN1_CONSENT.GRANTED;
            put(consent);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_ENHANCEMENT);

            Analytics.trackEvent('consent', IN1_CONSENT.ENHANCEMENT, IN1_CONSENT.GRANTED);
        };

        function consentGrantedFunctional() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = undefined;
            consent[IN1_CONSENT.FUNCTIONAL] = IN1_CONSENT.GRANTED;
            put(consent);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_FUNCTIONAL);

            Analytics.trackEvent('consent', IN1_CONSENT.FUNCTIONAL, IN1_CONSENT.GRANTED);
        };

        function consentGrantedTracking() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = undefined;
            consent[IN1_CONSENT.TRACKING] = IN1_CONSENT.GRANTED;
            put(consent);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_TRACKING);

            Analytics.trackEvent('consent', IN1_CONSENT.TRACKING, IN1_CONSENT.GRANTED);
        };

        function consentGrantedStrictlyNecessary() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = undefined;
            consent[IN1_CONSENT.STRICTLY_NECESSARY] = IN1_CONSENT.GRANTED;
            put(consent);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_GRANTED_STRICTLY_NECESSARY);

            Analytics.trackEvent('consent', IN1_CONSENT.STRICTLY_NECESSARY, IN1_CONSENT.GRANTED);
        };

        /*HANDLE DENIED EVENTS*/
        function consentDeniedAll() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = IN1_CONSENT.DENIED;
            consent[IN1_CONSENT.ANALYTICS] = IN1_CONSENT.DENIED;
            consent[IN1_CONSENT.ADVERTISING] = IN1_CONSENT.DENIED;
            consent[IN1_CONSENT.PERFORMANCE] = IN1_CONSENT.DENIED;
            consent[IN1_CONSENT.FUNCTIONAL] = IN1_CONSENT.DENIED;
            consent[IN1_CONSENT.ENHANCEMENT] = IN1_CONSENT.DENIED;
            consent[IN1_CONSENT.TRACKING] = IN1_CONSENT.DENIED;
            consent[IN1_CONSENT.STRICTLY_NECESSARY] = IN1_CONSENT.DENIED;
            put(consent);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_ALL);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_ADVERTISING);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_ANALYTICS);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_PERFORMANCE);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_FUNCTIONAL);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_ENHANCEMENT);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_TRACKING);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_STRICTLY_NECESSARY);

            Analytics.trackEvent('consent', IN1_CONSENT.ALL, IN1_CONSENT.DENIED);
        };

        function consentDeniedAnalytics() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = undefined;
            consent[IN1_CONSENT.ANALYTICS] = IN1_CONSENT.DENIED;
            put(consent);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_ANALYTICS);

            Analytics.trackEvent('consent', IN1_CONSENT.ANALYTICS, IN1_CONSENT.DENIED);
        };

        function consentDeniedAdvertising() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = undefined;
            consent[IN1_CONSENT.ADVERTISING] = IN1_CONSENT.DENIED;
            put(consent);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_ADVERTISING);

            Analytics.trackEvent('consent', IN1_CONSENT.ADVERTISING, IN1_CONSENT.DENIED);
        };

        function consentDeniedPerformance() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = undefined;
            consent[IN1_CONSENT.PERFORMANCE] = IN1_CONSENT.DENIED;
            put(consent);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_PERFORMANCE);

            Analytics.trackEvent('consent', IN1_CONSENT.PERFORMANCE, IN1_CONSENT.DENIED);
        };

        function consentDeniedFunctional() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = undefined;
            consent[IN1_CONSENT.FUNCTIONAL] = IN1_CONSENT.DENIED;
            put(consent);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_FUNCTIONAL);

            Analytics.trackEvent('consent', IN1_CONSENT.FUNCTIONAL, IN1_CONSENT.DENIED);
        };

        function consentDeniedEnhancement() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = undefined;
            consent[IN1_CONSENT.ENHANCEMENT] = IN1_CONSENT.DENIED;
            put(consent);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_ENHANCEMENT);

            Analytics.trackEvent('consent', IN1_CONSENT.ENHANCEMENT, IN1_CONSENT.DENIED);
        };

        function consentDeniedTracking() {
            var consent = get();
            consent[IN1_CONSENT.ALL] = undefined;
            consent[IN1_CONSENT.TRACKING] = IN1_CONSENT.DENIED;
            put(consent);
            $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_TRACKING);

            Analytics.trackEvent('consent', IN1_CONSENT.TRACKING, IN1_CONSENT.DENIED);
        };

        //function consentDeniedStrictlyNecessary() {
        //    $rootScope.$broadcast(IN1_CONSENT.EVENT_DENIED_STRICTLY_NECESSARY);
        //};

        function processDefaultConsent(defaultConsent){
            var consent = {};
            consent[IN1_CONSENT.ALL] = defaultConsent[IN1_CONSENT.ALL] == IN1_CONSENT.GRANTED;
            consent[IN1_CONSENT.ANALYTICS] = defaultConsent[IN1_CONSENT.ANALYTICS] == IN1_CONSENT.GRANTED;
            consent[IN1_CONSENT.ADVERTISING] = defaultConsent[IN1_CONSENT.ADVERTISING] == IN1_CONSENT.GRANTED;
            consent[IN1_CONSENT.PERFORMANCE] = defaultConsent[IN1_CONSENT.PERFORMANCE] == IN1_CONSENT.GRANTED;
            consent[IN1_CONSENT.FUNCTIONAL] = defaultConsent[IN1_CONSENT.FUNCTIONAL] == IN1_CONSENT.GRANTED;
            consent[IN1_CONSENT.ENHANCEMENT] = defaultConsent[IN1_CONSENT.ENHANCEMENT] == IN1_CONSENT.GRANTED;
            consent[IN1_CONSENT.TRACKING] = defaultConsent[IN1_CONSENT.TRACKING] == IN1_CONSENT.GRANTED;
            consent[IN1_CONSENT.STRICTLY_NECESSARY] = defaultConsent[IN1_CONSENT.STRICTLY_NECESSARY] == IN1_CONSENT.GRANTED;
            if(typeof defaultConsent[IN1_CONSENT.STRICTLY_NECESSARY] === 'undefined'){
                //always allow
                consent[IN1_CONSENT.STRICTLY_NECESSARY] = true;
            }
            consent[IN1_CONSENT.MODIFIED] = typeof defaultConsent[IN1_CONSENT.MODIFIED] !== 'undefined' && defaultConsent[IN1_CONSENT.MODIFIED] == true;
            return consent;
        }


    }
})();

(function() {
    'use strict';

    angular.module('vobeApp').controller('CookiesBannerController', CookiesBannerController);

    function CookiesBannerController(
        $scope,
        $state,
        $translate,
        $q,
        $window,
        CookiesConsentStorageService,
        IN1_CONSENT,
        ModalService,
        $transitions,
        $cookies

    ) {
        'ngInject';
        var vm = this;

        vm.isGDPR = ($window && $window.IN1 && $window.IN1.isGDPR) ? $window.IN1.isGDPR : false;

        var storedConsent = CookiesConsentStorageService.get();

        vm.consent = CookiesConsentStorageService.processDefaultConsent(storedConsent);


        vm.IN1_CONSENT = IN1_CONSENT;

        //TODO: should we delete all the cookies here?

        vm.onConsentDirty = function(){
            vm.consentDirty = true;
            console.log("Current consent ", vm.consent);
        };

        vm.consentDirty = false;

        vm.saveConsent = function(refresh){
            console.log("Save consent ", vm.consent);

            //analytics
            if(vm.consent[IN1_CONSENT.ANALYTICS] == true){
                CookiesConsentStorageService.consentGrantedAnalytics();
            }
            else {
                CookiesConsentStorageService.consentDeniedAnalytics();
            }

            //advertising
            if(vm.consent[IN1_CONSENT.ADVERTISING] == true){
                CookiesConsentStorageService.consentGrantedAdvertising();
            }
            else {
                CookiesConsentStorageService.consentDeniedAdvertising();
            }

            //TRACKING
            if(vm.consent[IN1_CONSENT.TRACKING] == true){
                CookiesConsentStorageService.consentGrantedTracking();
            }
            else {
                CookiesConsentStorageService.consentDeniedTracking();
            }

            //enhancement
            if(vm.consent[IN1_CONSENT.ENHANCEMENT] == true){
                CookiesConsentStorageService.consentGrantedEnhancement();
            }
            else {
                CookiesConsentStorageService.consentDeniedEnhancement();
            }

            //PERFORMANCE
            if(vm.consent[IN1_CONSENT.PERFORMANCE] == true){
                CookiesConsentStorageService.consentGrantedPerformance();
            }
            else {
                CookiesConsentStorageService.consentDeniedPerformance();
            }

            //FUNCTIONAL
            if(vm.consent[IN1_CONSENT.FUNCTIONAL] == true){
                CookiesConsentStorageService.consentGrantedFunctional();
            }
            else {
                CookiesConsentStorageService.consentDeniedFunctional();
            }

            angular.extend(vm.consent, CookiesConsentStorageService.processDefaultConsent(CookiesConsentStorageService.get()));
            console.log("Current consent ", vm.consent);

            if(refresh) {
                clear();
                $state.reload('property');
            }

        }

        vm.allowAll = function(refresh){
            console.log("Allow All consent ", vm.consent);
            CookiesConsentStorageService.consentGrantedAll();
            angular.extend(vm.consent, CookiesConsentStorageService.processDefaultConsent(CookiesConsentStorageService.get()));
            if(refresh) {
                clear();
                $state.reload('property');
            }
        }

        vm.denyAll = function(refresh){
            console.log("Deny All consent ", vm.consent);
            CookiesConsentStorageService.consentDeniedAll();
            angular.extend(vm.consent, CookiesConsentStorageService.processDefaultConsent(CookiesConsentStorageService.get()));

            //TODO: remove cookies that were denied
            var cookies = $cookies.getAll();
            angular.forEach(cookies, function (v, k) {
                if(k!='SESSION' && k!='CSRF-TOKEN' && k!='NG_TRANSLATE_LANG_KEY' && k!='in1_vobe_consent'){
                    console.log('removing cookie with key: '+k);
                    $cookies.remove(k, {expires : new Date(), path: '/'});
                }

            });

            if(refresh) {
                clear();
                $state.reload('property');
            }


        }

        vm.clear = clear;

        function clear () {
            if($state.cookiePreferencesModal){
                $state.cookiePreferencesModal.dismiss('cancel');
            }
        }





        //init cookie consent, send default events and handle changes

    }
})();

(function() {
    'use strict';


})();

(function() {
    'use strict';

    angular.module('vobeApp')
        .component('cookiesBanner', {
            templateUrl: 'app/components/cookies-consent/cookies-banner.html',
            controller: 'CookiesBannerController',
            controllerAs: 'vm',
            bindings: {
                onUpdate: '<'
            }
        });
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('ConfirmationItemController', ConfirmationItemController);

    function ConfirmationItemController($scope, $sce, $uiRouterGlobals) {
        'ngInject';
        var vm = this;

        vm.$onInit = function() {
            vm.voucherItem.voucher.voucherDescriptionTrustedHtml = $sce.trustAsHtml(vm.voucherItem.voucher.voucherDescription);
            vm.walletDebug = $uiRouterGlobals.params.walletDebug || false;
            if (vm.walletDebug) {
                vm.voucherItem.displayAppleWalletButton = true;
                vm.voucherItem.displayGoogleWalletButton = true;
            }
            vm.deliveryEmail = vm.voucherItem.voucherPurchaser.email;
            vm.customerEmail = vm.voucherItem.voucherPurchaser.customerEmail;

            vm.signetProperties  = ["HSAVUK", "ERNVUK"];
            vm.isSignetProperty = vm.signetProperties.includes(vm.voucherItem.hotel.hotelCode.toUpperCase());

            vm.hideSavvyProperties = vm.signetProperties;
            vm.hideSavvy = vm.hideSavvyProperties.includes(vm.voucherItem.hotel.hotelCode.toUpperCase()) && vm.deliveryEmail != vm.customerEmail;
        }


    }

})();

(function() {
    'use strict';

    angular.module('vobeApp').component('confirmationItem', {
        templateUrl: 'app/components/confirmation/confirmation-item.html',
        controller: 'ConfirmationItemController',
        controllerAs: '$ctrl',
        bindings: {
            voucherItem : '<',
            voucherConfig : '<',
            confirmationUuid : '<',
            index: '<',
        }
    });
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .factory('HeaderFooterService', HeaderFooterService);

    HeaderFooterService.$inject = ['$resource'];

    function HeaderFooterService ($resource) {
        var service = $resource('api/headerfooter', {}, {
            'get': {
                method: 'GET',
                ignoreLoadingBar: true,
                transformResponse: function (data) {
                    if(!data || (typeof data === 'string' && data.length==0)){
                        return data;
                    }
                    data = angular.fromJson(data);
                    return data;
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('vobeApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key && key !== null ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('vobeApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            if(httpResponse){
                switch (httpResponse.status) {
                    // connection refused, server not reachable
                    case 0:
                        addErrorAlert('Server not reachable','error.server.not.reachable');
                        break;

                    case 400:
                        var errorHeader = httpResponse.headers('X-vobeApp-error') || httpResponse.headers('x-vobeapp-error');
                        var entityKey = httpResponse.headers('X-vobeApp-params') || httpResponse.headers('x-vobeapp-params');
                        if (errorHeader) {
                            var entityName = $translate.instant('global.menu.entities.' + entityKey);
                            addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                        } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                            for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                                var fieldError = httpResponse.data.fieldErrors[i];
                                // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                                var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                                var fieldName = $translate.instant('vobeApp.' + fieldError.objectName + '.' + convertedField);
                                addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                            }
                        } else if (httpResponse.data && httpResponse.data.message) {
                            addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                        } else {
                            addErrorAlert(httpResponse.data);
                        }
                        break;

                    case 404:
                        addErrorAlert('Not found','error.url.not.found');
                        break;

                    default:
                        if (httpResponse.data && httpResponse.data.message) {
                            addErrorAlert(httpResponse.data.message);
                        } else {
                            addErrorAlert(angular.toJson(httpResponse));
                        }
                }
            }

        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$filter', '$translate'];

        function getService ($timeout, $sce ,$filter, $translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                //alertOptions.msg = $filter('translate')(alertOptions.msg, alertOptions.params);//this is not interpolating {{params}}
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<div uib-alert ng-cloak="" ng-class="\'alert alert-\'+alert.type" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></div>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('vobeApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-vobeApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-vobeApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!response || response instanceof Error || !(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('vobeApp.httpError', response);
                //if(response.data.path && response.data.path.indexOf('/api/shoppingcart/add') && response.data.path.endsWith('add')==-1){
                //    $rootScope.$broadcast('itemAddedToCartError', {});
                //}
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);


    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$document'];

    function authExpiredInterceptor($rootScope, $q, $injector, $document) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response && response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            } else if (response && response.status === 403 && response.config.method !== 'GET' && getCSRF() === '') {
                // If the CSRF token expired, then try to get a new CSRF token and retry the old request
                var $http = $injector.get('$http');
                return $http.get('/').finally(function() { return afterCSRFRenewed(response); });
            }
            return $q.reject(response);
        }

        function getCSRF() {
            var doc = $document[0];
            if (doc) {
                var name = 'CSRF-TOKEN=';
                var ca = doc.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) === ' ') {c = c.substring(1);}

                    if (c.indexOf(name) !== -1) {
                        return c.substring(name.length, c.length);
                    }
                }
            }
            return '';
        }

        function afterCSRFRenewed(oldResponse) {
            if (getCSRF() !== '') {
                // retry the old request after the new CSRF-TOKEN is obtained
                var $http = $injector.get('$http');
                return $http(oldResponse.config);
            } else {
                // unlikely get here but reject with the old response any way and avoid infinite loop
                return $q.reject(oldResponse);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('translationPartialLoaderErrorHandler', translationPartialLoaderErrorHandler);

    translationPartialLoaderErrorHandler.$inject = ['$q', '$log'];

    function translationPartialLoaderErrorHandler($q, $log) {
        return function (part, lang, response) {
            $log.error('The "' + part + '/' + lang + '" part was not loaded.');
            return $q.when({});
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate', '$uiRouterGlobals'];

    function translationHandler($rootScope, $window, $state, $translate, $uiRouterGlobals) {
        return {
            initialize: initialize,
            updateTitle: updateTitle,
            isRTL: isRTL
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
                updatePageDirection();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $uiRouterGlobals.current.data && $uiRouterGlobals.current.data.pageTitle) {
                titleKey = $uiRouterGlobals.current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }

        function updatePageDirection() {
            var currentLang = $translate.proposedLanguage() || $translate.use();
            angular.element('html').attr('lang', currentLang);
            angular.element('html').attr('dir', isRTL(currentLang) ? 'rtl' : 'ltr');
        }

        function isRTL(langKey) {
            if (langKey === 'ar' ||
                langKey === 'fa' ||
                langKey === 'iw' ||
                langKey === 'he') {
                return true;
            }
            return false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('stateHandler', stateHandler);



    function stateHandler($rootScope, $state, $transitions, $sessionStorage, $translate, JhiLanguageService, translationHandler, faviconHandler, $window,
        Auth, Principal, VERSION) {
        'ngInject';
        return {
            initialize: initialize
        };

        function initialize() {
            console.log('stateHandler initialize')
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $transitions.onStart({}, function(transition) {
                console.log('onStart: ', transition.to().name, transition.to())
                $rootScope.toState = transition.to();
                $rootScope.toStateParams = transition.to().params;
                $rootScope.fromState = transition.from();

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (transition.to().external) {
                    //event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language

                //JhiLanguageService.getCurrent().then(function (language) {
                //    $translate.use(language);
                //});

            });

            var stateChangeSuccess = $transitions.onSuccess({}, function(transition) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (transition.to().data.pageTitle) {
                    titleKey = transition.to().data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
                faviconHandler.updateFavicon();
            });

            $rootScope.$on('$destroy', function () {
                console.log('======== $destroy!')
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });

            //$rootScope.$on('$stateChangeError', function (event, toState, toParams, fromState, fromParams, error) {
            $transitions.onError({}, function (transition) {
                console.warn('$stateChangeError!!', transition._error.message)
                var toParams = transition.params();
                if (transition._error.detail === "Payment: Recipient missing") {
                    toParams.revalidate = true;
                    $state.transitionTo('shopping-cart', toParams, {
                        reload: 'site', inherit: true, notify: true
                    });
                } else if (transition._error.detail === 'Payment: Basket empty') {
                    //due to introduction of a special case for HILTON Refunds, we cannot go back to LIST if we started in bulk
                    if (toParams.contextType === "refunds" && toParams.bulk && toParams.bulk.length > 0) {
                        $state.transitionTo('bulk-add', toParams, {
                            reload: 'site', inherit: true, notify: true
                        });
                    } else {
                        $state.transitionTo('list', toParams, {
                            reload: 'site', inherit: true, notify: true
                        });
                    }

                }
                var toState = transition.to();
                if(toState && toState.name=='bulk-add'){
                    //if there are no vouchers pools and we tried to open /bulk-add
                    $state.transitionTo('list', toParams, {
                        reload: 'site', inherit: true, notify: true
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('faviconHandler', faviconHandler);

    faviconHandler.$inject = ['$rootScope', '$window', '$state'];

    function faviconHandler($rootScope, $window, $state) {

        var _doc = $window.document;

        return {
            initialize: initialize,
            updateFavicon: updateFavicon
        };

        function initialize() {

        }

        function updateFavicon() {
            var _orig = getIcons();
            if ($state.params.propertyId && ($state.params.propertyId === 'tgbvus' || $state.params.channel === '20')) {
                var _orig = getIcons();
                _orig.forEach(function(icon) {
                    icon.setAttribute('href', '/favicon-guestbook.ico' );
                });
            } /*else {
                _orig.forEach(function(icon) {
                    icon.setAttribute('href', '/favicon.png' );
                });
            }*/
        }

        function getIcons() {
            var elms = [];
            //get link element
            var getLinks = function () {
                var icons = [];
                var links = _doc.getElementsByTagName('head')[0].getElementsByTagName('link');
                for (var i = 0; i < links.length; i++) {
                    if ((/(^|\s)icon(\s|$)/i).test(links[i].getAttribute('rel'))) {
                        icons.push(links[i]);
                    }
                }
                return icons;
            };

            //if link element
            elms = getLinks();
            if (elms.length === 0) {
                elms = [_doc.createElement('link')];
                elms[0].setAttribute('rel', 'icon');
                _doc.getElementsByTagName('head')[0].appendChild(elms[0]);
            }
            elms.forEach(function(item) {
                item.setAttribute('type', 'image/png');
            });
            return elms;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('translationStorageProvider', translationStorageProvider);

    function translationStorageProvider($cookies, $log, LANGUAGES, LANGUAGES_MAPPINGS) {
        'ngInject';

        return {
            get: get,
            put: put
        };

        function get(name) {
            var preferred = $cookies.getObject(name);
            //preferred = getAlias(preferred);
        	//console.log("getting cookie: "+name+", value: "+$cookies.getObject(name));
            if (/*preferred && */LANGUAGES.indexOf(preferred) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                //$cookies.putObject(name, 'en');
            }
            return preferred;
        }

        function put(name, value) {
        	//console.log("putting cookie lang: "+value);
        	//console.trace();
            $cookies.putObject(name, value);
        }

        function getAlias(preferred){
            if(!preferred){
                return preferred;
            }
            if (LANGUAGES_MAPPINGS) {
                var alias;
                for (var langKeyAlias in LANGUAGES_MAPPINGS) {
                    if (LANGUAGES_MAPPINGS.hasOwnProperty(langKeyAlias)) {
                        var hasWildcardKey = false;
                        var hasExactKey = Object.prototype.hasOwnProperty.call(LANGUAGES_MAPPINGS, langKeyAlias) &&
                            langKeyAlias.toLowerCase() === preferred.toLowerCase();

                        if (langKeyAlias.slice(-1) === '*') {
                            hasWildcardKey = langKeyAlias.slice(0, -1) === preferred.slice(0, langKeyAlias.length - 1);
                        }
                        if (hasExactKey || hasWildcardKey) {
                            alias = LANGUAGES_MAPPINGS[langKeyAlias];
                            if (LANGUAGES.indexOf(alias.toLowerCase()) > -1) {
                                return alias;
                            }
                        }
                    }
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular.module('vobeApp').config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider', 'LANGUAGES', 'LANGUAGES_MAPPINGS'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider, LANGUAGES, LANGUAGES_MAPPINGS) {
        // Initialize angular-translate

        //must be the same linke in JAVA config: LocaleConfiguration.java
        var STORAGE_KEY = 'NG_TRANSLATE_LANG_KEY';

        $translateProvider.storageKey(STORAGE_KEY);
        $translateProvider.useStorage('translationStorageProvider');

        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'api/i18n/{lang}/{part}.json',
            loadFailureHandler: 'translationPartialLoaderErrorHandler',
        });

        //var prefferedLanguage = $translateProvider.resolveClientLocale() || 'en';
        //prefferedLanguage =  (prefferedLanguage || '').split('-').join('_');
        //console.log("preferred language: ",prefferedLanguage);

        //https://angular-translate.github.io/docs/#/guide/09_language-negotiation
        $translateProvider.registerAvailableLanguageKeys(LANGUAGES, LANGUAGES_MAPPINGS);

        //NOTE:
        // 1. the preferredLanguage will be set cookie from the server if "&language=ZYX" is present
        // 2. preferred language will come from pre-existing cookie
        // 3. the preferred language will come from the browser
        //$translateProvider.preferredLanguage(prefferedLanguage);//not needed thanks to LANGUAGES_MAPPINGS
        //$translateProvider.fallbackLanguage('en');//not needed thanks to LANGUAGES_MAPPINGS
        $translateProvider.determinePreferredLanguage();

        $translateProvider.useSanitizeValueStrategy('escaped');
        //$translateProvider.useMessageFormatInterpolation();
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');
        // $translateProvider.useMessageFormatInterpolation();

        tmhDynamicLocaleProvider.storageKey(STORAGE_KEY);
        tmhDynamicLocaleProvider.defaultLocale($translateProvider.resolveClientLocale());
        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
    }
})();

(function() {
    'use strict';

    angular.module('vobeApp')
        .provider('StripeElements', stripeElementsProvider)
        .directive('stripeElementDecorator', stripeElementDecorator)
        .directive('stripeElement', stripeElement);

    function stripeElementsProvider() {

        this.$get = function () {

            var that = this;
            this.Stripe = null;

            this._initStripe = function(apiKey) {
                that.Stripe = Stripe(apiKey, {apiVersion: '2022-11-15'});
                return that.Stripe;
            };

            this._isActive = function() {
                console.log('_isActive', that.Stripe)
                if (that.Stripe && that.Stripe._apiKey) {
                    return true;
                } else {
                    return false;
                }
            }

            return {
                initStripe: function (apiKey) {
                    return that._initStripe(apiKey);
                },
                isActive: function () {
                    return that._isActive();
                }
            }
        }
    }


    function stripeElementDecorator () {
        return {
            restrict: 'A',
            link: link
        }

        function link($scope, $element, $attr) {
            var $ctrl = $scope;

            $scope.$on('$destroy', function () {
                $ctrl.instance.destroy()
            })

            $ctrl.instance.mount($element[0])
        }
    }

    function stripeElement() {
        var controller = ['$scope', function ($scope) {

                function init() {
                    $scope.instance = angular.copy($scope.instance);
                }

                init();

                $scope.addItem = function () {
                    $scope.add();

                    //Add new customer to directive scope
                    $scope.items.push({
                        name: 'New Directive Controller Item'
                    });
                };
            }],

            template = '<div stripe-element-decorator></div>';

        return {
            restrict: 'EA', //Default in 1.3+
            scope: {
                instance: '='
            },
            controller: controller,
            template: template
        };
    }

})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(httpConfig);

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        'ngInject';

        //enable CSRF
        $httpProvider.defaults.xsrfCookieName = 'CSRF-TOKEN';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';

        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here



        $httpProvider.interceptors.push('propertyErrorHandlerInterceptor');

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('app', {
                abstract: true,
                url : "?src&ref&passkey&channel&lang",
                views: {
                    'navbar@': {
                        templateUrl: 'app/layouts/navbar/navbar.html',
                        controller: 'NavbarController',
                        controllerAs: 'vm'
                    },
                    'header@': {
                        templateUrl: 'app/layouts/hero/hero.html',
                        controller: 'HeroController',
                        controllerAs: 'vm'
                    },
                    'footer@': {
                        //templateUrl: 'app/layouts/hero/hero.html',
                        //controller: 'HeroController',
                        //controllerAs: 'vm'
                    },
                    'legal@' : {
                        templateUrl: 'app/layouts/footer/legal.html',
                        controller: 'LegalFooterController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    authorize: ['Auth',
                        function (Auth) {
                            return Auth.authorize();
                        }
                    ],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        //console.log("in app state addPart global");
                        $translatePartialLoader.addPart('global');
                        //this state is abstract just add the part, but don't hit servers, don't return anything
                        //return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('vobeApp')
        .constant('VERSION', "2.0.0")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('ENABLE_ROLLBAR', true)
        .constant('ENV', "prod")
        .constant('BUILD_LANGUAGES', [
	"ar",
	"en",
	"en-gb",
	"en-ie",
	"es",
	"de",
	"fr",
	"he",
	"it",
	"iw",
	"ja",
	"ko",
	"nl",
	"pl",
	"ru",
	"zh",
	"zh-cn",
	"pt",
	"hr"
])
;
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN','ROLE_TRANSLATOR'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_ADMIN', 'ROLE_TRANSLATOR','ROLE_PROPERTY','ROLE_USER'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count');
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-tracker', {
            parent: 'admin',
            url: '/tracker',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tracker.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/tracker/tracker.html',
                    controller: 'JhiTrackerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tracker');
                    return $translate.refresh();
                }]
            },
            onEnter: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.subscribe();
            }],
            onExit: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.unsubscribe();
            }]
        });
    }
})();

(function() {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('vobeApp')
        .factory('JhiTrackerService', JhiTrackerService);

    function JhiTrackerService ($transitions, $window, $cookies, $http, $q, $rootScope) {
        'ngInject';
        var stompClient = null;
        var subscriber = null;
        var listener = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            sendActivity: sendActivity,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect () {
            //building absolute path so that websocket doesnt fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + /*loc.pathname +*/ '/websocket/tracker';
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            var stateChangeStart;
            var headers = {};
            headers['X-CSRF-TOKEN'] = $cookies[$http.defaults.xsrfCookieName];
            stompClient.connect(headers, function() {
                connected.resolve('success');
                sendActivity();
                if (!alreadyConnectedOnce) {
                    stateChangeStart = $transitions.onSuccess({}, function (transition) {
                        sendActivity();
                    });
                    alreadyConnectedOnce = true;
                }
            });
            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
            });
        }

        function disconnect () {
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
        }

        function receive () {
            return listener.promise;
        }

        function sendActivity() {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/activity',
                    {},
                    angular.toJson({'page': $rootScope.toState.name}));
            }
        }

        function subscribe () {
            connected.promise.then(function() {
                subscriber = stompClient.subscribe('/topic/tracker', function(data) {
                    listener.notify(angular.fromJson(data.body));
                });
            }, null, null);
        }

        function unsubscribe () {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .controller('JhiTrackerController', JhiTrackerController);

    JhiTrackerController.$inject = ['$cookies', '$http', 'JhiTrackerService'];

    function JhiTrackerController ($cookies, $http, JhiTrackerService) {
        // This controller uses a Websocket connection to receive user activities in real-time.
        var vm = this;

        vm.activities = [];

        JhiTrackerService.receive().then(null, null, function(activity) {
            showActivity(activity);
        });

        function showActivity(activity) {
            var existingActivity = false;
            for (var index = 0; index < vm.activities.length; index++) {
                if(vm.activities[index].sessionId === activity.sessionId) {
                    existingActivity = true;
                    if (activity.page === 'logout') {
                        vm.activities.splice(index, 1);
                    } else {
                        vm.activities[index] = activity;
                    }
                }
            }
            if (!existingActivity && (activity.page !== 'logout')) {
                vm.activities.push(activity);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/appmetrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    index = newKey.lastIndexOf('.');
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(index + 1),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/apphealth',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('vobeApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('vobeApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx = 0;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('vobeApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){'use strict';angular.module('vobeApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2 translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="sessions.table.ipaddress">IP Address</th><th translate="sessions.table.useragent">User agent</th><th translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.formattedTokenDate}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><div uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></div></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 translate="configuration.title">Configuration</h2><span translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span translate="configuration.table.prefix">Prefix</span></th><th translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" translate="health.table.service">Service Name</th><th class="col-md-2 text-center" translate="health.table.status">Status</th><th class="col-md-2 text-center" translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" translate="health.details.name">Name</th><th class="col-md-6 text-left" translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 translate="logs.title">Logs</h2><p translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span translate="metrics.refresh.button">Refresh</span></button></p><h3 translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b translate="metrics.jvm.memory.title">Memory</b><p><span translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" translate="metrics.updating">Updating...</div><h3 translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.jvm.http.table.code">Code</th><th translate="metrics.jvm.http.table.count">Count</th><th class="text-right" translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" translate="metrics.servicesstats.table.count">Count</th><th class="text-right" translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" translate="metrics.servicesstats.table.min">Min</th><th class="text-right" translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 translate="metrics.ehcache.title">Ehcache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="metrics.ehcache.cachename">Cache name</th><th class="text-right" translate="metrics.ehcache.objects">Objects</th><th class="text-right" translate="metrics.ehcache.hits">Hits</th><th class="text-right" translate="metrics.ehcache.misses">Misses</th><th class="text-right" translate="metrics.ehcache.evictioncount">Eviction count</th><th class="text-right" translate="metrics.ehcache.mean">Mean get time (ms)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.mean-get-time\'].value | number:2}}</td></tr></tbody></table></div><h3 translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" translate="metrics.datasource.count">Count</th><th class="text-right" translate="metrics.datasource.mean">Mean</th><th class="text-right" translate="metrics.datasource.min">Min</th><th class="text-right" translate="metrics.datasource.p50">p50</th><th class="text-right" translate="metrics.datasource.p75">p75</th><th class="text-right" translate="metrics.datasource.p95">p95</th><th class="text-right" translate="metrics.datasource.p99">p99</th><th class="text-right" translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/tracker/tracker.html','<div><h2 translate="tracker.title">Real-time user activities</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th translate="tracker.table.userlogin">User</th><th translate="tracker.table.ipaddress">IP Address</th><th translate="tracker.table.page">Current page</th><th translate="tracker.table.time">Time</th><th></th></tr></thead><tbody><tr ng-repeat="activity in vm.activities"><td>{{activity.userLogin}}</td><td>{{activity.ipAddress}}</td><td>{{activity.page}}</td><td>{{activity.time}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" ng-model="vm.user.activated"> <span translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" translate="userManagement.deactivated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><div uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></div></div></div>');
$templateCache.put('app/components/confirmation/confirmation-item.html','<div class="w3-card-2 w3-margin-top w3-margin-bottom w3-white"><div class="row"><div class="col-xs-12"><div class="w3-container w3-center w3-dark-grey" style="padding: 4px 0px;text-transform: uppercase"><div class="col-xs-12"><span translate="confirmation.headings.item">ITEM</span> #{{$ctrl.index + 1}}</div></div></div></div><div class="row w3-margin-bottom"><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="w3-ul"><div class="w3-border-0" style="padding: 0px"><div class="row w3-center"><div class="col-xs-12"><div class="w3-light-grey"><div class="w3-container w3-center"><h3>{{$ctrl.voucherItem.voucher.voucherName}}</h3><span ng-bind-html="$ctrl.voucherItem.voucher.voucherDescriptionTrustedHtml"></span></div></div></div></div></div><div class="w3-border-0" style="padding: 0px"><div class="row w3-center"><div class="col-xs-12"><b style="display: block" class="w3-border-top w3-border-bottom" ng-show="$ctrl.voucherItem.voucherSale.pricePerVoucherAfterDiscount && $ctrl.voucherItem.voucherSale.pricePerVoucherAfterDiscount < $ctrl.voucherItem.voucherSale.pricePerVoucher"><span translate="vouchers.headings.price.retail">Retail Value</span>: {{$ctrl.voucherItem.voucherPurchaser.currency | currencySign}} {{$ctrl.voucherItem.voucherSale.pricePerVoucher | number:2}}</b> <span style="display: block" class="w3-small" ng-show="vm.channel==\'20\'"><span translate="vouchers.headings.price.member">Member Price</span>: {{$ctrl.voucherItem.voucherPurchaser.currency | currencySign}} {{$ctrl.voucherItem.voucherSale.pricePerVoucherAfterDiscount | number:2}} <span translate="vouchers.headings.price.rewards">Rewards</span></span></div><div class="col-xs-12"><span class="w3-xlarge">{{($ctrl.voucherItem.voucherSale.pricePerVoucherAfterDiscount ? $ctrl.voucherItem.voucherSale.pricePerVoucherAfterDiscount : $ctrl.voucherItem.voucherSale.pricePerVoucher) | currency:($ctrl.voucherItem.voucherPurchaser.currency + \' \'):2}}</span></div></div></div><div class="w3-border-0" style="padding: 0px"><div class="w3-light-grey w3-padding" style="text-align: center" ng-if="!$ctrl.voucherItem.additionalFields[\'tutuka_VoucherNumber\']"><span class="w3-text-light-green glyphicon glyphicon-ok-sign"></span> <span translate="confirmation.headings.vouchercode">Voucher Code</span>:<label>{{$ctrl.voucherItem.voucherPurchaser.voucherCode}}</label></div><div class="w3-light-grey w3-padding" style="text-align: center" ng-if="$ctrl.voucherItem.additionalFields[\'tutuka_VoucherNumber\']"><span class="w3-text-light-green glyphicon glyphicon-ok-sign"></span> <span translate="confirmation.headings.vouchercode">Voucher Code</span>:<label ng-bind="$ctrl.voucherItem.additionalFields[\'tutuka_VoucherNumber\']"></label></div><div class="w3-light-grey w3-padding" style="text-align: center" ng-if="$ctrl.voucherItem.additionalFields[\'savvy_PanNumber\']"><span class="w3-text-light-green glyphicon glyphicon-ok-sign"></span> <span translate="confirmation.headings.savvy.cardnum">Card Number</span>:<label ng-bind="$ctrl.voucherItem.additionalFields[\'savvy_PanNumber\']"></label></div><div class="w3-light-grey w3-padding" style="text-align: center" ng-if="$ctrl.voucherItem.additionalFields[\'savvy_CardPin\']"><span class="w3-text-light-green glyphicon glyphicon-ok-sign"></span> <span translate="confirmation.headings.savvy.cardpin">Card Pin</span>:<label ng-bind="$ctrl.voucherItem.additionalFields[\'savvy_CardPin\']"></label></div><div class="row w3-padding" ng-show="$ctrl.isSignetProperty"><div class="col-xs-12"><div class="row"><div class="col-xs-12 w3-padding w3-center"><span>Note: Your bank statement will show a payment to IN1 SOLUTIONS for this purchase</span></div></div></div></div><div class="row w3-padding"><div class="col-xs-12"><div class="row"><div class="col-xs-12 w3-padding w3-center" ng-if="$ctrl.voucherItem.displayDownloadButton"><label ng-show="!$ctrl.hideSavvy && $ctrl.voucherItem.voucherPurchaser.electronic"><a class="in1-button w3-button w3-white w3-border-0 w3-round w3-padding w3-hover-black" target="_blank" ng-href="/api/confirmation/{{$ctrl.confirmationUuid}}/download/{{$ctrl.voucherItem.voucherSale.id}}"><span class="glyphicon glyphicon-floppy-save" aria-hidden="true"></span> <span style="text-decoration: underline"><span translate="confirmation.headings.download.pdf">Download as PDF</span></span></a></label></div></div></div></div></div></div></div><div class="col-lg-6 col-md-6 col-sm-12 col-xs-12"><div class="w3-ul"><div class="w3-border-0" style="padding: 0px"><div class="w3-light-grey w3-padding text-left"><span class="w3-text-light-green glyphicon glyphicon-ok-sign"></span> <span translate="vouchers.form.label.deliverymethod">Delivery Method</span></div><div class="row w3-padding"><div class="col-xs-12 w3-padding" ng-if="$ctrl.voucherItem.voucherPurchaser.electronic"><label><span translate="vouchers.delivery.email.name">E-mail</span>: {{$ctrl.voucherItem.voucherPurchaser.email}}</label></div><div class="col-xs-12 w3-padding" ng-if="!$ctrl.voucherItem.voucherPurchaser.electronic && !$ctrl.voucherItem.voucherPurchaser.collection"><label translate="vouchers.delivery.post.name">Post</label></div><div class="col-xs-12 w3-padding" ng-if="$ctrl.voucherItem.voucherPurchaser.collection"><label translate="vouchers.delivery.collect.name">Collection</label></div></div></div><div class="w3-border-0" style="padding: 0px" ng-if="!$ctrl.voucherItem.voucherPurchaser.collection" ng-show="$ctrl.voucherItem.voucherPurchaser.fname !== \'\'"><div class="w3-light-grey w3-padding text-left"><span class="w3-text-light-green glyphicon glyphicon-ok-sign"></span> <span translate="vouchers.delivery.person.recipient">Recipient</span></div><div class="row w3-padding"><div class="col-xs-6 w3-padding"><label>{{$ctrl.voucherItem.voucherPurchaser.fname}} {{$ctrl.voucherItem.voucherPurchaser.lname}}</label></div></div></div><div class="w3-border-0" style="padding: 0px"><div class="w3-light-grey w3-padding text-left"><span class="w3-text-light-green glyphicon glyphicon-ok-sign"></span> <span translate="vouchers.buttons.confirmation.receipt.name">Customer Receipt</span></div><div class="row w3-padding"><div class="col-xs-12 w3-padding w3-center"><a class="btn btn-defaultx" target="_blank" ng-href="/api/confirmation/{{$ctrl.confirmationUuid}}/viewReceipt/{{$ctrl.voucherItem.voucherSale.id}}"><span class="glyphicon glyphicon-list-alt" aria-hidden="true"></span> <span style="text-decoration: underline"><span translate="vouchers.buttons.confirmation.receipt.view">View Receipt</span></span></a></div></div></div></div></div><div class="col-xs-12 col-md-6 wallet-grid"><div ng-if="$ctrl.voucherItem.displayAppleWalletButton"><div style="display: flex; flex-direction: column; justify-content: space-between; align-items: center"><a target="_self" ng-href="/api/wallet/pass/{{$ctrl.confirmationUuid}}/{{$ctrl.voucherItem.voucherSale.id}}" download><img height="54px" src="/content/images/svg/US-UK_Add_to_Apple_Wallet_RGB_101421.svg" alt="Add to Apple Wallet"> </a><span style="text-align: left; font-size: 12px; color: #5a5a5a; padding: 15px 20px; max-width: 300px">To add this item to Wallet, open this web page on your iOS device, including iPhone, iPad or Mac computer.</span></div></div><div class="w3-center" ng-if="$ctrl.voucherItem.displayGoogleWalletButton"><a target="_blank" ng-href="/api/wallet/google/{{$ctrl.confirmationUuid}}/{{$ctrl.voucherItem.voucherSale.id}}"><img src="/content/images/svg/enGB_add_to_google_wallet_add-wallet-badge.svg" alt="Add to Google Wallet" style="padding: 0 8px; padding-bottom: 8px"></a></div></div></div></div>');
$templateCache.put('app/components/cookies-consent/cookies-banner.html','<div id="cookie_directive_container" class="container" ng-show="vm.isGDPR && !vm.consent[vm.IN1_CONSENT.MODIFIED]"><nav class="navbar navbar-default navbar-fixed-bottom" style="padding: 10px 0px; /*background-color: black !important;*/ font-size:14px"><div class="container"><div class="navbar-inner navbar-content-center" id="cookie_accept"><div class="row"><div class="col-sm-8"><div class="row"><div class="col-sm-12"><span class="text-muted">This website uses cookies to improve user experience. By using our website you are consenting to our use of cookies in accordance with our <a ui-sref="cookies-policy" target="_blank">Cookie Policy</a>.</span></div></div><div class="row" style="padding-bottom: 5px"><div class="col-xs-6 col-sm-4"><input class="w3-check" type="checkbox" checked="checked" ng-model="vm.consent[vm.IN1_CONSENT.STRICTLY_NECESSARY]" disabled="disabled"><label class="w3-text-light-grayx">Strictly Necessary</label></div><!--\n                            <div class="col-xs-6 col-sm-4">\n                                <input class="w3-check" type="checkbox" checked="checked" ng-model="vm.consent[vm.IN1_CONSENT.ANALYTICS]" ng-change="vm.consentDirty=true">\n                                <label class="w3-text-light-grayx">Analytics</label>\n                            </div>\n                            --><div class="col-xs-6 col-sm-3"><input class="w3-check" type="checkbox" ng-model="vm.consent[vm.IN1_CONSENT.PERFORMANCE]" ng-change="vm.consentDirty=true"><label class="w3-text-light-grayx">Performance</label></div><div class="col-xs-6 col-sm-4"><input class="w3-check" type="checkbox" ng-model="vm.consent[vm.IN1_CONSENT.ADVERTISING]" ng-change="vm.consentDirty=true"><label class="w3-text-light-grayx">Advertising</label></div></div></div><div class="col-sm-4"><div class="row"><div class="col-xs-6 col-sm-12" style="padding-bottom: 10px"><button ng-show="!vm.consentDirty" ng-click="vm.allowAll()" type="button" class="btn btn-success btn-lgx btn-block"><span>Accept All</span></button> <button ng-show="vm.consentDirty" ng-click="vm.saveConsent()" type="button" class="btn btn-success btn-lgx btn-block"><span>Save & Close</span></button></div><div class="col-xs-6 col-sm-12"><button type="button" ng-click="vm.denyAll(true)" class="btn btn-default btn-sm btn-block btn-link">Decline All</button></div></div></div></div></div></div></nav></div>');
$templateCache.put('app/components/cookies-consent/cookies-policy-modal.html','<div class="row"><div class="w3-padding"><div class="col-lg-12"><div><h1>Cookie Policy</h1></div><div><div><h2><strong>About this Cookie policy</strong></h2><p>This Cookie policy explains what cookies are and how we use them. You should read this policy so you can understand what type of cookies we use, the information we collect using cookies and how that information is used.<!--For further information on how we use, store and keep your personal data secure, see our <a href="https://www.ikea.com/ie/en/customer-service/privacy-policy/">Privacy policy</a>.--></p><p>This Policy also tells you what your rights are in relation to the personal data you give to us. If you have any questions about this Cookie policy, please contact:</p><p>Address: 61 Rathbeale Road, Swords, Co Dublin, K67 P8W6</p><p>Phone: +353 1 870 6350</p><p>Email: <a href="mailto:sales@in1solutions.com">sales@in1solutions.com</a></p></div></div></div><div class="col-lg-12"><div><div><h2><strong>What are cookies?</strong></h2><p>Cookies are little text files which are stored on the browser or hard drive of your computer or mobile device when you visit a webpage or application. Cookies work to make your experience browsing our site as smooth as possible and they remember your preferences, so you don\u2019t have to insert your details again and again.</p><p>There are different types of cookies. Some cookies come directly from our website and others come from third parties which place cookies on our site.</p><p>Cookies can be stored for varying lengths of time on your browser or device. Session cookies are deleted from your computer or device when you close your browser. Persistent cookies will remain stored on your computer or device until deleted or until they reach their expiry date.</p><p>We have 3 varieties of cookies which operate on our website:</p><p><strong>1. Strictly Necessary cookies</strong></p><p>These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request of services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information.</p><p><strong>2. Performance cookies</strong></p><p>These cookies allow us to count visits and traffic sources, so we can measure and improve the performance of our site. They help us know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies, we will not know when you have visited our site.</p><p><strong>3. Targeting cookies</strong></p><p>These cookies may be set through our site by our advertising partners who may use them to build a profile of your interests and show you relevant adverts on other sites. They do not store directly personal information but are based on uniquely identifying your browser and internet device. If you do not allow these cookies, you will experience less targeted advertising.</p></div></div></div><div class="col-lg-12"><div><div><h2><strong>How do we use cookies?</strong></h2><p>We use cookies to enhance your browsing experience by:</p><ul><li>Recognising what your preferred settings are</li><li>Giving you a browsing experience that is unique to you and to serve you content which we believe improves your experience on our site</li><li>Analysing how you use our site which helps us to troubleshoot any problems and to monitor our own performance</li></ul></div></div></div><div class="col-lg-12"><div><div><h2><strong>Strictly necessary cookies</strong></h2><p>The strictly necessary cookies allow you to navigate our site, add products to your basket, set the language settings, display the correct page for the device you are using, verify your details when you make an order and they allow us to process payment for an order.</p><ul><li>SESSION \u2013 Session handling cookie</li><li>CSRF-TOKEN - A security cookie</li><li>in1_vobe_consent - A cookie to store user cookie consent</li></ul><p></p><p>To opt out of these cookies you will need to change the settings on your browser by selecting your cookie preferences. If you choose to block these cookies our website may not work as it should.</p></div></div></div><div class="col-lg-12"><div><div><h2><strong>Performance cookies</strong></h2><p>These cookies are used to track visits to our site and help us measure traffic sources to improve performance. They are also used to optimise the website based on how many visitors navigate through the site. All information collected is anonymised. If you disable these cookies the site should function correctly, we simply won\u2019t know that you visited the site.</p><p></p><p><strong>Preferences</strong></p><p>These are user preference cookies to remember user selection such as language and currency.</p><ul><li>NG_TRANSLATE_LANG_KEY</li></ul><p></p><p><strong>Google Analytics</strong></p><p>These are performance cookies used to track visits to our website and movement around the site. The data which is collected is anonymous and is used for benchmarking purposes to monitor the performance of our site and to measure user engagement. We share the anonymised Google Analytics data with selected third parties to assist us in understanding the effectiveness of our website and our marketing efforts.</p><ul><li>_gat_gtag_</li><li>_gat, _gat_tracer_*</li><li>_gid, tracker_*_gid</li><li>_ga, tracker_*</li></ul><p></p><p><strong>Posthog</strong></p><p>It helps us to track how users navigate around our website. We use this information to test new features and make the website easier to use.</p><ul><li>ph_*</li></ul><p><strong>Google AdWords Conversions</strong></p><p>With the help of the conversion tracking cookie, we can analyse the effectiveness of our ads.</p><ul><li>_gcl_aw</li><li>_gcl_dc</li></ul><p></p></div></div></div><div class="col-lg-12"><div><div><h2><strong>Targeting cookies</strong></h2><p>These cookies are set through our advertising partners and are used to help present you with relevant advertising. No personal information is collected they instead rely on the cookies to identify your internet device and browser details. By disabling these cookies, you will not receive less advertising, just that the advertising you receive will be less targeted to your preferences.</p><p></p><p><strong>Facebook</strong></p><p>These are targeting cookies which allow us to place advertising content onto Facebook that is relevant to you based on your browsing patterns on our website. This information is never connected to your profile and it is always anonymous.</p><p>You can read more and change your preferences on Facebook here: <a href="https://www.facebook.com/policies/cookies/" target="_blank" rel="nofollow noopener noreferrer">https://www.facebook.com/policies/cookies/</a></p><p>You can control and opt-out of Facebook adverts and other third-party cookies here: <a href="https://www.youronlinechoices.com/ie/your-ad-choices" target="_blank" rel="nofollow noopener noreferrer">https://www.youronlinechoices.com/ie/your-ad-choices</a></p><ul><li>_fbp</li><li>fr</li></ul><p></p><p><strong>Google DoubleClick / Google Ads</strong></p><p>These are targeting cookies which we use to help us track the effectiveness of our advertising. Google DoubleClick serves our adverts on other sites based on your browsing history from our website and also your engagement with them.</p><p>You can change your preferences about the adverts you see on Google by clicking here: <a href="http://www.google.com/settings/ads" target="_blank" rel="nofollow noopener noreferrer">www.google.com/settings/ads</a></p><p>You can control and opt-out of Google adverts and other third-party cookies here: <a href="https://www.youronlinechoices.com/ie/your-ad-choices" target="_blank" rel="nofollow noopener noreferrer">https://www.youronlinechoices.com/ie/your-ad-choices</a></p><ul><li>_dc_gtm_UA-XXX</li><li>IDE</li><li>NID</li><li>ANID</li></ul><p></p></div></div></div><div class="col-lg-12"><div><div><h2><strong>How do you change cookie preferences or block cookies?</strong></h2><p>For the performance cookies and targeting cookies when starting a new session on our website, you can choose to opt-out of these. It is possible that any advertising you receive will be less targeted as a result, but the site should function correctly.</p><p>If you wish to disable the strictly necessary cookies, then within your browser you can choose whether you want to accept cookies or not. Different browsers make different controls available to you. Generally, your browser will offer you the choice to accept, refuse or delete all cookies, third-party cookies or specific website cookies. Each browser\u2019s website should contain instructions on how you can do this.</p><p>For further information please refer to: <a href="https://www.aboutcookies.org/how-to-delete-cookies/" target="_blank" rel="nofollow noopener noreferrer">https://www.aboutcookies.org/how-to-delete-cookies/</a></p><p>If you block these cookies on our website, you may be unable to access certain areas of our website and certain functions and pages will not work in the usual way.</p></div></div></div><div class="col-lg-12"><div><div><h2><strong>Changes to the Cookie policy</strong></h2><p>We may update this policy from time to time. If we make significant changes, we will let you know, but please do check regularly this policy to ensure you are aware of the most updated version.</p><p>This Cookie policy was last updated on <strong>November 2020</strong></p></div></div></div></div></div>');
$templateCache.put('app/components/cookies-consent/cookies-preferences-modal.html','<div class="row"><span class="w3-border w3-padding w3-circle w3-white w3-border-dark-grey" ng-click="vm.clear()" style="outline: none; float: right; top: -15px;\n\t\tposition: relative;z-index: 1000"><span class="w3-closebtn">&times;</span></span><div class="w3-padding"><div class="col-lg-12"><div><h1>Cookie Preferences</h1></div><div><div><p>When you visit any website, it may store or retrieve information on your browser, mostly in the form of cookies. This information might be about you, your preferences or your device and is mostly used to make the site work as you expect it to. The information does not usually directly identify you, but it can give you a more personalized web experience. Because we respect your right to privacy, you can choose not to allow some types of cookies. Click on the different category headings to find out more and change our default settings. However, blocking some types of cookies may impact your experience of the site and the services we are able to offer.</p><p>More information: <a ui-sref="cookie-policy" target="_blank">Cookie Policy</a></p></div></div></div><div class="col-lg-12"><div><button ng-click="vm.allowAll(true)" type="button" class="btn btn-success btn-lg btn-block"><span>Accept All</span></button></div></div><div class="col-lg-12"><div><hr></div></div><div class="col-lg-12"><div><div><h4><input class="w3-check" type="checkbox" checked="checked" ng-model="vm.consent[vm.IN1_CONSENT.STRICTLY_NECESSARY]" disabled="disabled"><strong><label style="padding: 0px 10px">Strictly necessary cookies</label></strong></h4><p>These cookies are necessary for the website to function and cannot be switched off in our systems. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work. These cookies do not store any personally identifiable information.</p></div></div></div><div class="col-lg-12"><div><div><h4><input class="w3-check" type="checkbox" ng-model="vm.consent[vm.IN1_CONSENT.PERFORMANCE]" ng-change="vm.onConsentDirty()"><strong><label style="padding: 0px 10px">Performance cookies</label></strong></h4><p>These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site. All information these cookies collect is aggregated and therefore anonymous. If you do not allow these cookies we will not know when you have visited our site, and will not be able to monitor its performance.</p></div></div></div><div class="col-lg-12"><div><div><h4><input class="w3-check" type="checkbox" ng-model="vm.consent[vm.IN1_CONSENT.ADVERTISING]" ng-change="vm.onConsentDirty()"><strong><label style="padding: 0px 10px">Targeting cookies</label></strong></h4><p>These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of your interests and show you relevant adverts on other sites. They do not store directly personal information, but are based on uniquely identifying your browser and internet device. If you do not allow these cookies, you will experience less targeted advertising.</p></div></div></div><div class="col-lg-12"><p><button ng-click="vm.saveConsent(true)" type="button" class="btn btn-primary btn-lg btn-block"><span>Save & Close</span></button></p></div></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-6"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.passwordplaceholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" translate="login.form.button">Sign in</button></form><p></p><div class="alert alert-warning"><a class="alert-link" href="" ng-click="vm.requestResetPassword()" translate="login.password.forgot">Did you forget your password?</a></div><div class="alert alert-warning" translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a></div></div><div class="col-md-6" style="visibility: hidden"><br><jh-social ng-provider="google"></jh-social><jh-social ng-provider="facebook"></jh-social><jh-social ng-provider="twitter"></jh-social><!-- jhipster-needle-add-social-button --></div></div></div>');
$templateCache.put('app/entities/public-site/public-site-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.publicSite.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="vobeApp.publicSite.delete.question" translate-values="{id: \'{{vm.publicSite.id}}\'}">Are you sure you want to delete this Public Site?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/public-site/public-site-detail.html','<div><h2><span translate="vobeApp.publicSite.detail.title">Public Site</span> {{vm.publicSite.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="vobeApp.publicSite.name">Name</span></dt><dd><span>{{vm.publicSite.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="public-site-detail.edit({id:vm.publicSite.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/public-site/public-site-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPublicSiteLabel" translate="vobeApp.publicSite.home.createOrEditLabel">Create or edit a Public Site</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.publicSite.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.publicSite.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="vobeApp.publicSite.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.publicSite.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/public-site/public-sites.html','<div><h2 translate="vobeApp.publicSite.home.title">Public Sites</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="public-site.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="vobeApp.publicSite.home.createLabel">Create new Public Site</span></button></div><!--\n            <div class="col-xs-8 no-padding-right">\n                <form name="searchForm" class="form-inline">\n                    <div class="input-group pull-right" >\n                        <input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'vobeApp.publicSite.home.search\' | translate }}">\n                        <span  class="input-group-btn width-min" >\n                            <button class="btn btn-info" ng-click="vm.search(vm.searchQuery)">\n                                <span class="glyphicon glyphicon-search"></span>\n                            </button>\n                        </span>\n                        <span class="input-group-btn width-min" ng-if="vm.currentSearch">\n                            <button class="btn btn-info" ng-click="vm.clear()">\n                                <span class="glyphicon glyphicon-trash"></span>\n                            </button>\n                        </span>\n                    </div>\n                </form>\n            </div>\n             --></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span translate="vobeApp.publicSite.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="publicSite in vm.publicSites track by publicSite.id"><td><a ui-sref="public-site-detail({id:publicSite.id})">{{publicSite.id}}</a></td><td>{{publicSite.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="public-site-detail({id:publicSite.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="public-site.edit({id:publicSite.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="public-site.delete({id:publicSite.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><div uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></div></div>');
$templateCache.put('app/entities/public-site-language/public-site-language-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.publicSiteLanguage.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="vobeApp.publicSiteLanguage.delete.question" translate-values="{id: \'{{vm.publicSiteLanguage.id}}\'}">Are you sure you want to delete this Public Site Language?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/public-site-language/public-site-language-detail.html','<div><h2><span translate="vobeApp.publicSiteLanguage.detail.title">Public Site Language</span> {{vm.publicSiteLanguage.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="vobeApp.publicSiteLanguage.code">Code</span></dt><dd><span>{{vm.publicSiteLanguage.code}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="public-site-language-detail.edit({id:vm.publicSiteLanguage.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/public-site-language/public-site-language-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPublicSiteLanguageLabel" translate="vobeApp.publicSiteLanguage.home.createOrEditLabel">Create or edit a Public Site Language</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.publicSiteLanguage.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.publicSiteLanguage.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="vobeApp.publicSiteLanguage.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.publicSiteLanguage.code" required><div ng-show="editForm.code.$invalid"><p class="help-block" ng-show="editForm.code.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/public-site-language/public-site-languages.html','<div><h2 translate="vobeApp.publicSiteLanguage.home.title">Public Site Languages</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="public-site-language.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="vobeApp.publicSiteLanguage.home.createLabel">Create new Public Site Language</span></button></div><!--\n            <div class="col-xs-8 no-padding-right">\n                <form name="searchForm" class="form-inline">\n                    <div class="input-group pull-right" >\n                        <input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'vobeApp.publicSiteLanguage.home.search\' | translate }}">\n                        <span  class="input-group-btn width-min" >\n                            <button class="btn btn-info" ng-click="vm.search(vm.searchQuery)">\n                                <span class="glyphicon glyphicon-search"></span>\n                            </button>\n                        </span>\n                        <span class="input-group-btn width-min" ng-if="vm.currentSearch">\n                            <button class="btn btn-info" ng-click="vm.clear()">\n                                <span class="glyphicon glyphicon-trash"></span>\n                            </button>\n                        </span>\n                    </div>\n                </form>\n            </div>\n             --></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="code"><span translate="vobeApp.publicSiteLanguage.code">Code</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="publicSiteLanguage in vm.publicSiteLanguages track by publicSiteLanguage.id"><td><a ui-sref="public-site-language-detail({id:publicSiteLanguage.id})">{{publicSiteLanguage.id}}</a></td><td>{{publicSiteLanguage.code}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="public-site-language-detail({id:publicSiteLanguage.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="public-site-language.edit({id:publicSiteLanguage.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="public-site-language.delete({id:publicSiteLanguage.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><div uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></div></div>');
$templateCache.put('app/entities/public-site-language-relationship/public-site-language-relationship-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.publicSiteLanguageRelationship.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="vobeApp.publicSiteLanguageRelationship.delete.question" translate-values="{id: \'{{vm.publicSiteLanguageRelationship.id}}\'}">Are you sure you want to delete this Public Site Language Relationship?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/public-site-language-relationship/public-site-language-relationship-detail.html','<div><h2><span translate="vobeApp.publicSiteLanguageRelationship.detail.title">Public Site Language Relationship</span> {{vm.publicSiteLanguageRelationship.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="vobeApp.publicSiteLanguageRelationship.active">Active</span></dt><dd><span>{{vm.publicSiteLanguageRelationship.active}}</span></dd><dt><span translate="vobeApp.publicSiteLanguageRelationship.publicSite">Public Site</span></dt><dd><a ui-sref="public-site-detail({id:vm.publicSiteLanguageRelationship.publicSiteId})">{{vm.publicSiteLanguageRelationship.publicSiteName}}</a></dd><dt><span translate="vobeApp.publicSiteLanguageRelationship.publicSiteLanguage">Public Site Language</span></dt><dd><a ui-sref="public-site-language-detail({id:vm.publicSiteLanguageRelationship.publicSiteLanguageId})">{{vm.publicSiteLanguageRelationship.publicSiteLanguageCode}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="public-site-language-relationship-detail.edit({id:vm.publicSiteLanguageRelationship.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/public-site-language-relationship/public-site-language-relationship-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPublicSiteLanguageRelationshipLabel" translate="vobeApp.publicSiteLanguageRelationship.home.createOrEditLabel">Create or edit a Public Site Language Relationship</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.publicSiteLanguageRelationship.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.publicSiteLanguageRelationship.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="vobeApp.publicSiteLanguageRelationship.active" for="field_active">Active</label><input type="checkbox" class="form-control" name="active" id="field_active" ng-model="vm.publicSiteLanguageRelationship.active"></div><div class="form-group"><label translate="vobeApp.publicSiteLanguageRelationship.publicSite" for="field_publicSite">Public Site</label><select class="form-control" id="field_publicSite" name="publicSite" ng-model="vm.publicSiteLanguageRelationship.publicSiteId" ng-options="publicSite.id as publicSite.name for publicSite in vm.publicsites" required><option value=""></option></select></div><div ng-show="editForm.publicSite.$invalid"><p class="help-block" ng-show="editForm.publicSite.$error.required" translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label translate="vobeApp.publicSiteLanguageRelationship.publicSiteLanguage" for="field_publicSiteLanguage">Public Site Language</label><select class="form-control" id="field_publicSiteLanguage" name="publicSiteLanguage" ng-model="vm.publicSiteLanguageRelationship.publicSiteLanguageId" ng-options="publicSiteLanguage.id as publicSiteLanguage.code for publicSiteLanguage in vm.publicsitelanguages" required><option value=""></option></select></div><div ng-show="editForm.publicSiteLanguage.$invalid"><p class="help-block" ng-show="editForm.publicSiteLanguage.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/public-site-language-relationship/public-site-language-relationships.html','<div><h2 translate="vobeApp.publicSiteLanguageRelationship.home.title">Public Site Language Relationships</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="public-site-language-relationship.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="vobeApp.publicSiteLanguageRelationship.home.createLabel">Create new Public Site Language Relationship</span></button></div><!--\n            <div class="col-xs-8 no-padding-right">\n                <form name="searchForm" class="form-inline">\n                    <div class="input-group pull-right" >\n                        <input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'vobeApp.publicSiteLanguageRelationship.home.search\' | translate }}">\n                        <span  class="input-group-btn width-min" >\n                            <button class="btn btn-info" ng-click="vm.search(vm.searchQuery)">\n                                <span class="glyphicon glyphicon-search"></span>\n                            </button>\n                        </span>\n                        <span class="input-group-btn width-min" ng-if="vm.currentSearch">\n                            <button class="btn btn-info" ng-click="vm.clear()">\n                                <span class="glyphicon glyphicon-trash"></span>\n                            </button>\n                        </span>\n                    </div>\n                </form>\n            </div>\n             --></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publicSiteName"><span translate="vobeApp.publicSiteLanguageRelationship.publicSite">Public Site</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publicSiteLanguageCode"><span translate="vobeApp.publicSiteLanguageRelationship.publicSiteLanguage">Public Site Language</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="active"><span translate="vobeApp.publicSiteLanguageRelationship.active">Active</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="publicSiteLanguageRelationship in vm.publicSiteLanguageRelationships track by publicSiteLanguageRelationship.id"><td><a ui-sref="public-site-language-relationship-detail({id:publicSiteLanguageRelationship.id})">{{publicSiteLanguageRelationship.id}}</a></td><td><a ui-sref="public-site-detail({id:publicSiteLanguageRelationship.publicSiteId})">{{publicSiteLanguageRelationship.publicSiteName}}</a></td><td><a ui-sref="public-site-detail({id:publicSiteLanguageRelationship.publicSiteLanguageId})">{{publicSiteLanguageRelationship.publicSiteLanguageCode}}</a></td><td>{{publicSiteLanguageRelationship.active}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="public-site-language-relationship-detail({id:publicSiteLanguageRelationship.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="public-site-language-relationship.edit({id:publicSiteLanguageRelationship.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="public-site-language-relationship.delete({id:publicSiteLanguageRelationship.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><ul uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul></div>');
$templateCache.put('app/entities/public-site-part/public-site-part-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.publicSitePart.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="vobeApp.publicSitePart.delete.question" translate-values="{id: \'{{vm.publicSitePart.id}}\'}">Are you sure you want to delete this Public Site Part?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/public-site-part/public-site-part-detail.html','<div><h2><span translate="vobeApp.publicSitePart.detail.title">Public Site Part</span> {{vm.publicSitePart.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="vobeApp.publicSitePart.name">Name</span></dt><dd><span>{{vm.publicSitePart.name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="public-site-part-detail.edit({id:vm.publicSitePart.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/public-site-part/public-site-part-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPublicSitePartLabel" translate="vobeApp.publicSitePart.home.createOrEditLabel">Create or edit a Public Site Part</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.publicSitePart.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.publicSitePart.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="vobeApp.publicSitePart.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.publicSitePart.name" required><div ng-show="editForm.name.$invalid"><p class="help-block" ng-show="editForm.name.$error.required" translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/public-site-part/public-site-parts.html','<div><h2 translate="vobeApp.publicSitePart.home.title">Public Site Parts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="public-site-part.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="vobeApp.publicSitePart.home.createLabel">Create new Public Site Part</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="name"><span translate="vobeApp.publicSitePart.name">Name</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="publicSitePart in vm.publicSiteParts track by publicSitePart.id"><td><a ui-sref="public-site-part-detail({id:publicSitePart.id})">{{publicSitePart.id}}</a></td><td>{{publicSitePart.name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="public-site-part-detail({id:publicSitePart.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="public-site-part.edit({id:publicSitePart.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="public-site-part.delete({id:publicSitePart.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><div uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></div></div>');
$templateCache.put('app/entities/public-site-part-key/public-site-part-key-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.publicSitePartKey.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="vobeApp.publicSitePartKey.delete.question" translate-values="{id: \'{{vm.publicSitePartKey.id}}\'}">Are you sure you want to delete this Public Site Part Key?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/public-site-part-key/public-site-part-key-detail.html','<div><h2><span translate="vobeApp.publicSitePartKey.detail.title">Public Site Part Key</span> {{vm.publicSitePartKey.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="vobeApp.publicSitePartKey.translationKey">Translation Key</span></dt><dd><span>{{vm.publicSitePartKey.translationKey}}</span></dd><dt><span translate="vobeApp.publicSitePartKey.publicSitePart">Public Site Part</span></dt><dd><a ui-sref="public-site-part-detail({id:vm.publicSitePartKey.publicSitePartId})">{{vm.publicSitePartKey.publicSitePartName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="public-site-part-key-detail.edit({id:vm.publicSitePartKey.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/public-site-part-key/public-site-part-key-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPublicSitePartKeyLabel" translate="vobeApp.publicSitePartKey.home.createOrEditLabel">Create or edit a Public Site Part Key</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.publicSitePartKey.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.publicSitePartKey.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="vobeApp.publicSitePartKey.translationKey" for="field_translationKey">Translation Key</label><input type="text" class="form-control" name="translationKey" id="field_translationKey" ng-model="vm.publicSitePartKey.translationKey" required><div ng-show="editForm.translationKey.$invalid"><p class="help-block" ng-show="editForm.translationKey.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label translate="vobeApp.publicSitePartKey.publicSitePart" for="field_publicSitePart">Public Site Part</label><select class="form-control" id="field_publicSitePart" name="publicSitePart" ng-model="vm.publicSitePartKey.publicSitePartId" ng-options="publicSitePart.id as publicSitePart.name for publicSitePart in vm.publicsiteparts"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/public-site-part-key/public-site-part-keys.html','<div><h2 translate="vobeApp.publicSitePartKey.home.title">Public Site Part Keys</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="public-site-part-key.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="vobeApp.publicSitePartKey.home.createLabel">Create new Public Site Part Key</span></button></div><!--\n            <div class="col-xs-8 no-padding-right">\n                <form name="searchForm" class="form-inline">\n                    <div class="input-group pull-right" >\n                        <input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'vobeApp.publicSitePartKey.home.search\' | translate }}">\n                        <span  class="input-group-btn width-min" >\n                            <button class="btn btn-info" ng-click="vm.search(vm.searchQuery)">\n                                <span class="glyphicon glyphicon-search"></span>\n                            </button>\n                        </span>\n                        <span class="input-group-btn width-min" ng-if="vm.currentSearch">\n                            <button class="btn btn-info" ng-click="vm.clear()">\n                                <span class="glyphicon glyphicon-trash"></span>\n                            </button>\n                        </span>\n                    </div>\n                </form>\n            </div>\n             --></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="translationKey"><span translate="vobeApp.publicSitePartKey.translationKey">Translation Key</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publicSitePartName"><span translate="vobeApp.publicSitePartKey.publicSitePart">Public Site Part</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="publicSitePartKey in vm.publicSitePartKeys track by publicSitePartKey.id"><td><a ui-sref="public-site-part-key-detail({id:publicSitePartKey.id})">{{publicSitePartKey.id}}</a></td><td>{{publicSitePartKey.translationKey}}</td><td><a ui-sref="public-site-part-detail({id:publicSitePartKey.publicSitePartId})">{{publicSitePartKey.publicSitePartName}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="public-site-part-key-detail({id:publicSitePartKey.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" has-any-authority="ROLE_ADMIN" ui-sref="public-site-part-key.edit({id:publicSitePartKey.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" has-any-authority="ROLE_ADMIN" ui-sref="public-site-part-key.delete({id:publicSitePartKey.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><div uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></div></div>');
$templateCache.put('app/entities/public-site-part-relationship/public-site-part-relationship-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.publicSitePartRelationship.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="vobeApp.publicSitePartRelationship.delete.question" translate-values="{id: \'{{vm.publicSitePartRelationship.id}}\'}">Are you sure you want to delete this Public Site Part Relationship?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/public-site-part-relationship/public-site-part-relationship-detail.html','<div><h2><span translate="vobeApp.publicSitePartRelationship.detail.title">Public Site Part Relationship</span> {{vm.publicSitePartRelationship.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="vobeApp.publicSitePartRelationship.publicSitePart">Public Site Part</span></dt><dd><a ui-sref="public-site-part-detail({id:vm.publicSitePartRelationship.publicSitePartId})">{{vm.publicSitePartRelationship.publicSitePartName}}</a></dd><dt><span translate="vobeApp.publicSitePartRelationship.publicSite">Public Site</span></dt><dd><a ui-sref="public-site-detail({id:vm.publicSitePartRelationship.publicSiteId})">{{vm.publicSitePartRelationship.publicSiteName}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="public-site-part-relationship-detail.edit({id:vm.publicSitePartRelationship.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/public-site-part-relationship/public-site-part-relationship-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPublicSitePartRelationshipLabel" translate="vobeApp.publicSitePartRelationship.home.createOrEditLabel">Create or edit a Public Site Part Relationship</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.publicSitePartRelationship.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.publicSitePartRelationship.id" readonly="readonly"></div><div class="form-group"><label translate="vobeApp.publicSitePartRelationship.publicSitePart" for="field_publicSitePart">Public Site Part</label><select class="form-control" id="field_publicSitePart" name="publicSitePart" ng-model="vm.publicSitePartRelationship.publicSitePartId" ng-options="publicSitePart.id as publicSitePart.name for publicSitePart in vm.publicsiteparts" required><option value=""></option></select></div><div ng-show="editForm.publicSitePart.$invalid"><p class="help-block" ng-show="editForm.publicSitePart.$error.required" translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label translate="vobeApp.publicSitePartRelationship.publicSite" for="field_publicSite">Public Site</label><select class="form-control" id="field_publicSite" name="publicSite" ng-model="vm.publicSitePartRelationship.publicSiteId" ng-options="publicSite.id as publicSite.name for publicSite in vm.publicsites" required><option value=""></option></select></div><div ng-show="editForm.publicSite.$invalid"><p class="help-block" ng-show="editForm.publicSite.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/public-site-part-relationship/public-site-part-relationships.html','<div><h2 translate="vobeApp.publicSitePartRelationship.home.title">Public Site Part Relationships</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="public-site-part-relationship.new" has-any-authority="ROLE_ADMIN"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="vobeApp.publicSitePartRelationship.home.createLabel">Create new Public Site Part Relationship</span></button></div><!--\n            <div class="col-xs-8 no-padding-right">\n                <form name="searchForm" class="form-inline">\n                    <div class="input-group pull-right" >\n                        <input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'vobeApp.publicSitePartRelationship.home.search\' | translate }}">\n                        <span  class="input-group-btn width-min" >\n                            <button class="btn btn-info" ng-click="vm.search(vm.searchQuery)">\n                                <span class="glyphicon glyphicon-search"></span>\n                            </button>\n                        </span>\n                        <span class="input-group-btn width-min" ng-if="vm.currentSearch">\n                            <button class="btn btn-info" ng-click="vm.clear()">\n                                <span class="glyphicon glyphicon-trash"></span>\n                            </button>\n                        </span>\n                    </div>\n                </form>\n            </div>\n             --></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><!-- <th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th> --><th jh-sort-by="publicSiteName"><span translate="vobeApp.publicSitePartRelationship.publicSite">Public Site</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publicSitePartName"><span translate="vobeApp.publicSitePartRelationship.publicSitePart">Public Site Part</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="publicSitePartRelationship in vm.publicSitePartRelationships track by publicSitePartRelationship.id"><!-- <td><a ui-sref="public-site-part-relationship-detail({id:publicSitePartRelationship.id})">{{publicSitePartRelationship.id}}</a></td> --><td><a ui-sref="public-site-detail({id:publicSitePartRelationship.publicSiteId})">{{publicSitePartRelationship.publicSiteName}}</a></td><td><a ui-sref="public-site-part-detail({id:publicSitePartRelationship.publicSitePartId})">{{publicSitePartRelationship.publicSitePartName}}</a></td><td class="text-right"><div class=""><button type="submit" has-any-authority="ROLE_ADMIN,ROLE_TRANSLATOR" ui-sref="translation({publicSitePartRelationshipId:publicSitePartRelationship.id})" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">Translations (Global)</span></button> <button type="submit" has-any-authority="ROLE_ADMIN,ROLE_TRANSLATOR" ui-sref="translation-browse-property({publicSitePartRelationshipId:publicSitePartRelationship.id})" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm">Translations (Specific Property)</span></button></div><div class="btn-group flex-btn-group-container"><button type="submit" has-any-authority="ROLE_ADMIN" ui-sref="public-site-part-relationship.edit({id:publicSitePartRelationship.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" has-any-authority="ROLE_ADMIN" ui-sref="public-site-part-relationship.delete({id:publicSitePartRelationship.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><ul uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></ul></div>');
$templateCache.put('app/entities/public-site-translation/public-site-translation-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.publicSiteTranslation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="vobeApp.publicSiteTranslation.delete.question" translate-values="{id: \'{{vm.publicSiteTranslation.id}}\'}">Are you sure you want to delete this Public Site Translation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/public-site-translation/public-site-translation-detail.html','<div><h2><span translate="vobeApp.publicSiteTranslation.detail.title">Public Site Translation</span> {{vm.publicSiteTranslation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="vobeApp.publicSiteTranslation.message">Message</span></dt><dd><span>{{vm.publicSiteTranslation.message}}</span></dd><dt><span translate="vobeApp.publicSiteTranslation.publicSitePartRelationship">Public Site Part Relationship</span></dt><dd><a ui-sref="public-site-part-relationship-detail({id:vm.publicSiteTranslation.publicSitePartRelationshipId})">{{vm.publicSiteTranslation.publicSitePartRelationship.publicSiteName}}-{{vm.publicSiteTranslation.publicSitePartRelationship.publicSitePartName}}</a></dd><dt><span translate="vobeApp.publicSiteTranslation.publicSitePartKey">Public Site Part Key</span></dt><dd><a ui-sref="public-site-part-key-detail({id:vm.publicSiteTranslation.publicSitePartKeyId})">{{vm.publicSiteTranslation.publicSitePartKeyTranslationKey}}</a></dd><dt><span translate="vobeApp.publicSiteTranslation.publicSiteLanguage">Public Site Language</span></dt><dd><a ui-sref="public-site-language-detail({id:vm.publicSiteTranslation.publicSiteLanguageId})">{{vm.publicSiteTranslation.publicSiteLanguageCode}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="public-site-translation-detail.edit({id:vm.publicSiteTranslation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/public-site-translation/public-site-translation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPublicSiteTranslationLabel" translate="vobeApp.publicSiteTranslation.home.createOrEditLabel">Create or edit a Public Site Translation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.publicSiteTranslation.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.publicSiteTranslation.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="vobeApp.publicSiteTranslation.message" for="field_message">Message</label><input type="text" class="form-control" name="message" id="field_message" ng-model="vm.publicSiteTranslation.message"></div><div class="form-group"><label translate="vobeApp.publicSiteTranslation.publicSitePartRelationship" for="field_publicSitePartRelationship">Public Site Part Relationship</label><select class="form-control" id="field_publicSitePartRelationship" name="publicSitePartRelationship" ng-model="vm.publicSiteTranslation.publicSitePartRelationshipId" ng-options="publicSitePartRelationship.id as (publicSitePartRelationship.publicSiteName+\'-\'+publicSitePartRelationship.publicSitePartName) for publicSitePartRelationship in vm.publicsitepartrelationships" required><option value=""></option></select></div><div ng-show="editForm.publicSitePartRelationship.$invalid"><p class="help-block" ng-show="editForm.publicSitePartRelationship.$error.required" translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label translate="vobeApp.publicSiteTranslation.publicSitePartKey" for="field_publicSitePartKey">Public Site Part Key</label><select class="form-control" id="field_publicSitePartKey" name="publicSitePartKey" ng-model="vm.publicSiteTranslation.publicSitePartKeyId" ng-options="publicSitePartKey.id as publicSitePartKey.translationKey for publicSitePartKey in vm.publicsitepartkeys" required><option value=""></option></select></div><div ng-show="editForm.publicSitePartKey.$invalid"><p class="help-block" ng-show="editForm.publicSitePartKey.$error.required" translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label translate="vobeApp.publicSiteTranslation.publicSiteLanguage" for="field_publicSiteLanguage">Public Site Language</label><select class="form-control" id="field_publicSiteLanguage" name="publicSiteLanguage" ng-model="vm.publicSiteTranslation.publicSiteLanguageId" ng-options="publicSiteLanguage.id as publicSiteLanguage.code for publicSiteLanguage in vm.publicsitelanguages" required><option value=""></option></select></div><div ng-show="editForm.publicSiteLanguage.$invalid"><p class="help-block" ng-show="editForm.publicSiteLanguage.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/public-site-translation/public-site-translations.html','<div><h2 translate="vobeApp.publicSiteTranslation.home.title">Public Site Translations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="public-site-translation.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="vobeApp.publicSiteTranslation.home.createLabel">Create new Public Site Translation</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="message"><span translate="vobeApp.publicSiteTranslation.message">Message</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publicSitePartRelationshipShortCode"><span translate="vobeApp.publicSiteTranslation.publicSitePartRelationship">Public Site Part Relationship</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publicSitePartKeyTranslationKey"><span translate="vobeApp.publicSiteTranslation.publicSitePartKey">Public Site Part Key</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publicSiteLanguageCode"><span translate="vobeApp.publicSiteTranslation.publicSiteLanguage">Public Site Language</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="publicSiteTranslation in vm.publicSiteTranslations track by publicSiteTranslation.id"><td><a ui-sref="public-site-translation-detail({id:publicSiteTranslation.id})">{{publicSiteTranslation.id}}</a></td><td>{{publicSiteTranslation.message}}</td><td><a ui-sref="public-site-part-relationship-detail({id:publicSiteTranslation.publicSitePartRelationshipId})">{{publicSiteTranslation.publicSiteName}}-{{publicSiteTranslation.publicSitePartName}}</a></td><td><a ui-sref="public-site-part-key-detail({id:publicSiteTranslation.publicSitePartKeyId})">{{publicSiteTranslation.publicSitePartKeyTranslationKey}}</a></td><td><a ui-sref="public-site-language-detail({id:publicSiteTranslation.publicSiteLanguageId})">{{publicSiteTranslation.publicSiteLanguageCode}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="public-site-translation-detail({id:publicSiteTranslation.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="public-site-translation.edit({id:publicSiteTranslation.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="public-site-translation.delete({id:publicSiteTranslation.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><div uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></div></div>');
$templateCache.put('app/entities/public-site-translation-property/public-site-translation-properties.html','<div><h2 translate="vobeApp.publicSiteTranslationProperty.home.title">Public Site Translation Properties</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="public-site-translation-property.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="vobeApp.publicSiteTranslationProperty.home.createLabel">Create new Public Site Translation Property</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="hotelId"><span translate="vobeApp.publicSiteTranslationProperty.hotelId">Hotel Id</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="message"><span translate="vobeApp.publicSiteTranslationProperty.message">Message</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publicSitePartRelationshipId"><span translate="vobeApp.publicSiteTranslationProperty.publicSitePartRelationship">Public Site Part Relationship</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publicSitePartKeyTranslationKey"><span translate="vobeApp.publicSiteTranslationProperty.publicSitePartKey">Public Site Part Key</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="publicSiteLanguageCode"><span translate="vobeApp.publicSiteTranslationProperty.publicSiteLanguage">Public Site Language</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="publicSiteTranslationProperty in vm.publicSiteTranslationProperties track by publicSiteTranslationProperty.id"><td><a ui-sref="public-site-translation-property-detail({id:publicSiteTranslationProperty.id})">{{publicSiteTranslationProperty.id}}</a></td><td>{{publicSiteTranslationProperty.hotelId}}</td><td>{{publicSiteTranslationProperty.message}}</td><td><a ui-sref="public-site-part-relationship-detail({id:publicSiteTranslationProperty.publicSitePartRelationshipId})">{{publicSiteTranslationProperty.publicSitePartRelationshipId}}</a></td><td><a ui-sref="public-site-part-key-detail({id:publicSiteTranslationProperty.publicSitePartKeyId})">{{publicSiteTranslationProperty.publicSitePartKeyTranslationKey}}</a></td><td><a ui-sref="public-site-language-detail({id:publicSiteTranslationProperty.publicSiteLanguageId})">{{publicSiteTranslationProperty.publicSiteLanguageCode}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="public-site-translation-property-detail({id:publicSiteTranslationProperty.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="public-site-translation-property.edit({id:publicSiteTranslationProperty.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="public-site-translation-property.delete({id:publicSiteTranslationProperty.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><div uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></div></div>');
$templateCache.put('app/entities/public-site-translation-property/public-site-translation-property-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.publicSiteTranslationProperty.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="vobeApp.publicSiteTranslationProperty.delete.question" translate-values="{id: \'{{vm.publicSiteTranslationProperty.id}}\'}">Are you sure you want to delete this Public Site Translation Property?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/public-site-translation-property/public-site-translation-property-detail.html','<div><h2><span translate="vobeApp.publicSiteTranslationProperty.detail.title">Public Site Translation Property</span> {{vm.publicSiteTranslationProperty.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="vobeApp.publicSiteTranslationProperty.hotelId">Hotel Id</span></dt><dd><span>{{vm.publicSiteTranslationProperty.hotelId}}</span></dd><dt><span translate="vobeApp.publicSiteTranslationProperty.message">Message</span></dt><dd><span>{{vm.publicSiteTranslationProperty.message}}</span></dd><dt><span translate="vobeApp.publicSiteTranslationProperty.publicSitePartRelationship">Public Site Part Relationship</span></dt><dd><a ui-sref="public-site-part-relationship-detail({id:vm.publicSiteTranslationProperty.publicSitePartRelationshipId})">{{vm.publicSiteTranslationProperty.publicSitePartRelationshipId}}</a></dd><dt><span translate="vobeApp.publicSiteTranslationProperty.publicSitePartKey">Public Site Part Key</span></dt><dd><a ui-sref="public-site-part-key-detail({id:vm.publicSiteTranslationProperty.publicSitePartKeyId})">{{vm.publicSiteTranslationProperty.publicSitePartKeyTranslationKey}}</a></dd><dt><span translate="vobeApp.publicSiteTranslationProperty.publicSiteLanguage">Public Site Language</span></dt><dd><a ui-sref="public-site-language-detail({id:vm.publicSiteTranslationProperty.publicSiteLanguageId})">{{vm.publicSiteTranslationProperty.publicSiteLanguageCode}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="public-site-translation-property-detail.edit({id:vm.publicSiteTranslationProperty.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/public-site-translation-property/public-site-translation-property-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPublicSiteTranslationPropertyLabel" translate="vobeApp.publicSiteTranslationProperty.home.createOrEditLabel">Create or edit a Public Site Translation Property</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.publicSiteTranslationProperty.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.publicSiteTranslationProperty.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="vobeApp.publicSiteTranslationProperty.hotelId" for="field_hotelId">Hotel Id</label><input type="number" class="form-control" name="hotelId" id="field_hotelId" ng-model="vm.publicSiteTranslationProperty.hotelId" required><div ng-show="editForm.hotelId.$invalid"><p class="help-block" ng-show="editForm.hotelId.$error.required" translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.hotelId.$error.number" translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" translate="vobeApp.publicSiteTranslationProperty.message" for="field_message">Message</label><input type="text" class="form-control" name="message" id="field_message" ng-model="vm.publicSiteTranslationProperty.message"></div><div class="form-group"><label translate="vobeApp.publicSiteTranslationProperty.publicSitePartRelationship" for="field_publicSitePartRelationship">Public Site Part Relationship</label><select class="form-control" id="field_publicSitePartRelationship" name="publicSitePartRelationship" ng-model="vm.publicSiteTranslationProperty.publicSitePartRelationshipId" ng-options="publicSitePartRelationship.id as publicSitePartRelationship.id for publicSitePartRelationship in vm.publicsitepartrelationships" required><option value=""></option></select></div><div ng-show="editForm.publicSitePartRelationship.$invalid"><p class="help-block" ng-show="editForm.publicSitePartRelationship.$error.required" translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label translate="vobeApp.publicSiteTranslationProperty.publicSitePartKey" for="field_publicSitePartKey">Public Site Part Key</label><select class="form-control" id="field_publicSitePartKey" name="publicSitePartKey" ng-model="vm.publicSiteTranslationProperty.publicSitePartKeyId" ng-options="publicSitePartKey.id as publicSitePartKey.translationKey for publicSitePartKey in vm.publicsitepartkeys" required><option value=""></option></select></div><div ng-show="editForm.publicSitePartKey.$invalid"><p class="help-block" ng-show="editForm.publicSitePartKey.$error.required" translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label translate="vobeApp.publicSiteTranslationProperty.publicSiteLanguage" for="field_publicSiteLanguage">Public Site Language</label><select class="form-control" id="field_publicSiteLanguage" name="publicSiteLanguage" ng-model="vm.publicSiteTranslationProperty.publicSiteLanguageId" ng-options="publicSiteLanguage.id as publicSiteLanguage.code for publicSiteLanguage in vm.publicsitelanguages" required><option value=""></option></select></div><div ng-show="editForm.publicSiteLanguage.$invalid"><p class="help-block" ng-show="editForm.publicSiteLanguage.$error.required" translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/translations/public-site-browse-property.html','<div><h2>Select Property</h2><br><div class="select-box"><ui-select ng-model="vm.selectedProperty" theme="bootstrap" reset-search-input="false" on-select="vm.onSelect()" style="width: 600px" title="Choose a property" append-to-body="true"><ui-select-match placeholder="Enter a property code or name">{{$select.selected.formatted_name}}</ui-select-match><ui-select-choices repeat="property in vm.properties track by $index" refresh="vm.refreshProperties($select.search)" refresh-delay="0"><div ng-bind-html="property.formatted_name | highlight: $select.search"></div></ui-select-choices></ui-select></div></div>');
$templateCache.put('app/entities/translations/public-site-translation-property.html','<div><h2>Overwriting Part: "{{vm.partName}}" for {{vm.currentProperty.hotelName}}</h2><jhi-alert></jhi-alert><br><form name="vm.translationsForm"><div class="table-responsivex"><table class="jh-table table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th style="width:30%" jh-sort-by="translationKey"><span translate="vobeApp.publicSitePartKey.translationKey">Translation Key</span> <span class="glyphicon glyphicon-sort"></span></th><th>Language & Message</th></tr></thead><tbody><tr ng-repeat="publicSitePartKey in vm.publicSitePartKeys track by publicSitePartKey.id"><td><span style="font-family: monospace">{{publicSitePartKey.translationKey}}</span><br><span translate>{{vm.sitePart.publicSitePartName+\'.\'+publicSitePartKey.translationKey}}</span></td><td><div class="row w3-padding" ng-repeat="lang in vm.siteLanguages | orderBy:\'publicSiteLanguageId\'" ng-init="tIndex=vm.calculateIndex($parent.$index,$index);t = vm.getMessage(publicSitePartKey.id,lang.publicSiteLanguageId);ht = vm.getHotelMessage(publicSitePartKey.id,lang.publicSiteLanguageId);vm.formTranslations[tIndex]={\'languageId\':lang.publicSiteLanguageId,\'partKeyId\':publicSitePartKey.id,\'message\':ht.message,\'globalMessage\':t.message, \'id\': ht.id, \'hotelId\':vm.currentProperty.hotelId, \'sitePartRelationshipId\': vm.sitePart.id}" ng-class="{\'w3-border-bottomx\': !$last}"><div class="col-lg-1">{{lang.publicSiteLanguageCode}}</div><div class="col-lg-11"><input type="hidden" ng-model="vm.formTranslations[tIndex].id" name="translation[{{tIndex}}].id"> <input type="hidden" ng-model="vm.formTranslations[tIndex].languageId" name="translation[{{tIndex}}].languageId"> <input type="hidden" ng-model="vm.formTranslations[tIndex].partKeyId" name="translation[{{tIndex}}].partKeyId"> <input type="hidden" ng-model="vm.formTranslations[tIndex].sitePartRelationshipId" name="translation[{{tIndex}}].sitePartRelationshipId"> <input type="hidden" ng-model="vm.formTranslations[tIndex].hotelId" name="translation[{{tIndex}}].hotelId"> <input class="form-control input-sm" ng-model="vm.formTranslations[tIndex].message" name="translation[{{tIndex}}].message"> <span class="help-block w3-small" style="padding-left: 11px">{{vm.formTranslations[tIndex].globalMessage}}</span></div></div></td></tr></tbody></table></div></form><div class="row w3-padding-16"><div class="col-xs-12 w3-center"><button class="btn btn-success" ng-click="vm.saveForm($event);">Save</button></div></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><div uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></div></div>');
$templateCache.put('app/entities/translations/public-site-translation.html','<div><h2>Translate "{{vm.partName}}" part:</h2><jhi-alert></jhi-alert><br><div class="row w3-padding-xlarge"><div class="col-xs-12 w3-center"><button class="btn btn-success" ng-click="vm.saveForm($event);">Save</button></div></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><div uib-pagination total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></div><form name="vm.translationsForm"><div class="table-responsivex"><table class="jh-table table"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th style="width:30%" jh-sort-by="translationKey"><span translate="vobeApp.publicSitePartKey.translationKey">Translation Key</span> <span class="glyphicon glyphicon-sort"></span></th><th>Language & Message</th></tr></thead><tbody><tr ng-repeat="publicSitePartKey in vm.publicSitePartKeys track by publicSitePartKey.id"><td>{{publicSitePartKey.translationKey}}</td><td><div class="row w3-padding" ng-repeat="lang in vm.siteLanguages | orderBy:\'publicSiteLanguageId\'" ng-init="tIndex=vm.calculateIndex($parent.$index,$index);t = vm.getMessage(publicSitePartKey.id,lang.publicSiteLanguageId);vm.formTranslations[tIndex]={\'languageId\':lang.publicSiteLanguageId,\'partKeyId\':publicSitePartKey.id,\'message\':t.message, \'id\': t.id, \'sitePartRelationshipId\': vm.sitePart.id}" ng-class="{\'w3-border-bottomx\': !$last}"><div class="col-lg-1">{{lang.publicSiteLanguageCode}}</div><div class="col-lg-11"><input type="hidden" ng-model="vm.formTranslations[tIndex].id" name="translation[{{tIndex}}].id"> <input type="hidden" ng-model="vm.formTranslations[tIndex].languageId" name="translation[{{tIndex}}].languageId"> <input type="hidden" ng-model="vm.formTranslations[tIndex].partKeyId" name="translation[{{tIndex}}].partKeyId"> <input type="hidden" ng-model="vm.formTranslations[tIndex].sitePartRelationshipId" name="translation[{{tIndex}}].sitePartRelationshipId"> <input class="form-control input-sm" ng-model="vm.formTranslations[tIndex].message" name="translation[{{tIndex}}].message"></div></div></td></tr></tbody></table></div></form><div class="row w3-padding-xlarge"><div class="col-xs-12 w3-center"><button class="btn btn-success" ng-click="vm.saveForm($event);">Save</button></div></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><div uib-pagination total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></div><i>Note: Please press SAVE before changing the page.</i></div>');
$templateCache.put('app/entities/voucher-sale-confirmation/voucher-sale-confirmation-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.voucherSaleConfirmation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p translate="vobeApp.voucherSaleConfirmation.delete.question" translate-values="{id: \'{{vm.voucherSaleConfirmation.id}}\'}">Are you sure you want to delete this Voucher Sale Confirmation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/voucher-sale-confirmation/voucher-sale-confirmation-detail.html','<div><h2><span translate="vobeApp.voucherSaleConfirmation.detail.title">Voucher Sale Confirmation</span> {{vm.voucherSaleConfirmation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span translate="vobeApp.voucherSaleConfirmation.createdAt">Created At</span></dt><dd><span>{{vm.voucherSaleConfirmation.createdAt | date:\'medium\'}}</span></dd><dt><span translate="vobeApp.voucherSaleConfirmation.confirmationUuid">Confirmation Uuid</span></dt><dd><span>{{vm.voucherSaleConfirmation.confirmationUuid}}</span></dd><dt><span translate="vobeApp.voucherSaleConfirmation.user">User</span></dt><dd><a ui-sref="vobe-user-detail({id:vm.voucherSaleConfirmation.userId})">{{vm.voucherSaleConfirmation.userLogin}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="voucher-sale-confirmation-detail.edit({id:vm.voucherSaleConfirmation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/voucher-sale-confirmation/voucher-sale-confirmation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVoucherSaleConfirmationLabel" translate="vobeApp.voucherSaleConfirmation.home.createOrEditLabel">Create or edit a Voucher Sale Confirmation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.voucherSaleConfirmation.id"><label for="id" translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.voucherSaleConfirmation.id" readonly="readonly"></div><div class="form-group"><label class="control-label" translate="vobeApp.voucherSaleConfirmation.createdAt" for="field_createdAt">Created At</label><div class="input-group"><input id="field_createdAt" type="text" class="form-control" name="createdAt" datetime-picker="{{dateformat}}" ng-model="vm.voucherSaleConfirmation.createdAt" is-open="vm.datePickerOpenStatus.createdAt"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdAt\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" translate="vobeApp.voucherSaleConfirmation.confirmationUuid" for="field_confirmationUuid">Confirmation Uuid</label><input type="text" class="form-control" name="confirmationUuid" id="field_confirmationUuid" ng-model="vm.voucherSaleConfirmation.confirmationUuid"></div><div class="form-group"><label translate="vobeApp.voucherSaleConfirmation.user" for="field_user">User</label><select class="form-control" id="field_user" name="user" ng-model="vm.voucherSaleConfirmation.userId" ng-options="vobeUser.id as vobeUser.login for vobeUser in vm.vobeusers"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/voucher-sale-confirmation/voucher-sale-confirmations.html','<div><h2 translate="vobeApp.voucherSaleConfirmation.home.title">Voucher Sale Confirmations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="voucher-sale-confirmation.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" translate="vobeApp.voucherSaleConfirmation.home.createLabel">Create new Voucher Sale Confirmation</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'vobeApp.voucherSaleConfirmation.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="createdAt"><span translate="vobeApp.voucherSaleConfirmation.createdAt">Created At</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="confirmationUuid"><span translate="vobeApp.voucherSaleConfirmation.confirmationUuid">Confirmation Uuid</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="userLogin"><span translate="vobeApp.voucherSaleConfirmation.user">User</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="voucherSaleConfirmation in vm.voucherSaleConfirmations track by voucherSaleConfirmation.id"><td><a ui-sref="voucher-sale-confirmation-detail({id:voucherSaleConfirmation.id})">{{voucherSaleConfirmation.id}}</a></td><td>{{voucherSaleConfirmation.createdAt | date:\'medium\'}}</td><td>{{voucherSaleConfirmation.confirmationUuid}}</td><td><a ui-sref="vobe-user-detail({id:voucherSaleConfirmation.userId})">{{voucherSaleConfirmation.userLogin}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="voucher-sale-confirmation-detail({id:voucherSaleConfirmation.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" translate="entity.action.view"></span></button> <button type="submit" ui-sref="voucher-sale-confirmation.edit({id:voucherSaleConfirmation.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" translate="entity.action.edit"></span></button> <button type="submit" ui-sref="voucher-sale-confirmation.delete({id:voucherSaleConfirmation.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count></div><div uib-pager total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div class="alert alert-danger" translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/footer/footer.html','<div class="branded-footer" style="margin-top: 50px" ng-include="vm.footerUrl"></div>');
$templateCache.put('app/layouts/footer/legal-property.html','<div style="text-align: end"><small ng-if="vm.isGDPR"><span ng-click="vm.openCookiePreferencesTab()" class="cookie-policy w3-tiny" style="color:#428bca">Cookie Preferences</span>&nbsp;|&nbsp;</small> <small><a ui-sref="cookie-policy" target="_blank" class="cookie-policy w3-tiny">Cookie Policy</a>&nbsp;|&nbsp;</small> <small class="w3-text-gray w3-tiny">Powered by <a class="w3-text-dark-grey" rel="noopener noreferrer" href="http://www.in1solutions.com" target="_blank">In1Solutions</a> \xA9 2002 - <span ng-cloak>{{vm.today | date:\'yyyy\'}}</span></small></div>');
$templateCache.put('app/layouts/footer/legal.html','<div style="text-align: end"><small class="w3-text-gray w3-tiny">Powered by <a class="w3-text-dark-grey" rel="noopener noreferrer" href="http://www.in1solutions.com" target="_blank">In1Solutions</a> \xA9 2002 - <span ng-cloak>{{vm.today | date:\'yyyy\'}}</span></small></div>');
$templateCache.put('app/layouts/header/header.html','<div class="branded-header" ng-include="vm.headerUrl"></div>');
$templateCache.put('app/layouts/hero/hero.html','<div class="jumbotron"><div class="jumbotron-stripe"><div class="w3-container w3-section w3-white-60"><h1>IF THERE IS NO WAY, CREATE ONE</h1><p>\u201CSo little of what could happen does happen.\u201D \u2015 Salvador Dal\xED</p></div></div><!-- \n\t  <div class="container" style="text-align: center;">\n\t  \t  <p><a ui-sref="voucher-properties" class="w3-btn w3-white w3-border w3-round" href="#" role="button">Browse Gift Vouchers</a></p>\t  \t\n\t  </div>\n   --></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<property-alert-error></property-alert-error><nav class="navbar navbar-default navbar-static-topx" role="navigation" style="margin-bottom: 0px;clear: both" ng-if="vm.stateParams.admin"><div class="container-fluid"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="glyphicon glyphicon glyphicon-option-vertical"></span></button> <button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar();vm.openShoppingCartNavbar();"><span class="sr-only">Toggle cart</span> <span class="glyphicon glyphicon-shopping-cart"></span></button></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'confirmation\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="voucher-sale-confirmation" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.voucherSaleConfirmation">Voucher Sale Confirmation</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'public-site\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="public-site-menu"><span><span class="glyphicon glyphicon-folder-open"></span> <span class="hidden-sm">Site Config </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="public-site" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.publicSite">Public Site</span></a></li><li ui-sref-active="active"><a ui-sref="public-site-language" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.publicSiteLanguage">Public Site Language</span></a></li><li ui-sref-active="active"><a ui-sref="public-site-language-relationship" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.publicSiteLanguageRelationship">Public Site Language Relationship</span></a></li><li ui-sref-active="active"><a ui-sref="public-site-part" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.publicSitePart">Public Site Part</span></a></li><li ui-sref-active="active"><a ui-sref="public-site-part-relationship" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.publicSitePartRelationship">Public Site Part Relationship</span></a></li><li ui-sref-active="active"><a ui-sref="public-site-part-key" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span translate="global.menu.entities.publicSitePartKey">Public Site Part Key</span></a></li><!--\n                        <li ui-sref-active="active" >\n                            <a ui-sref="public-site-translation" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                <span translate="global.menu.entities.publicSiteTranslation">Translations</span>\n                            </a>\n                        </li>\n                        <li ui-sref-active="active" >\n                            <a ui-sref="public-site-translation-property" ng-click="vm.collapseNavbar()">\n                                <span class="glyphicon glyphicon-asterisk"></span>&nbsp;\n                                <span translate="global.menu.entities.publicSiteTranslationProperty">Translations -> Property</span>\n                            </a>\n                        </li>\n                        --></ul></li><li ng-class="{active: vm.$state.includes(\'translation\')}" ng-switch-when="true" has-any-authority="ROLE_ADMIN, ROLE_TRANSLATOR, ROLE_PROPERTY" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="public-site-menu"><span><span class="glyphicon glyphicon-globe"></span> <span class="hidden-sm">Manage Translations </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="translation-browse-part" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Select Part</span></a></li><li ui-sref-active="active" ng-show="vm.stateParams.propertyId && vm.stateParams.publicSitePartRelationshipId"><a ui-sref="translation.property" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span>Translations</span></a></li></ul></li><li ng-if="vm.stateParams.admin" ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span translate="global.menu.account.sessions">Sessions</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span translate="global.menu.account.login">Sign in</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a ui-sref="register" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus-sign"></span>&nbsp; <span translate="global.menu.account.register">Register</span></a></li></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-tracker" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span>&nbsp; <span translate="global.menu.admin.tracker">User tracker</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><!--\n                <li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm" has-authority="ROLE_ADMIN">\n                    <a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1">\n                        <span>\n                            <span class="glyphicon glyphicon-flag"></span>\n                            <span class="hidden-sm" translate="global.menu.language">Language</span>\n                            <b class="caret"></b>\n                        </span>\n                    </a>\n                    <ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1">\n                        <li active-menu="{{language}}" ng-repeat="language in languageVm.languages">\n                            <a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a>\n                        </li>\n                    </ul>\n                </li>--></ul><!--\n            <ul class="nav navbar-nav navbar-right" ui-view="languageDropdown">\n            </ul>\n            <ul class="nav navbar-nav navbar-right" ui-view="shoppingCartDropdown">\n            </ul>\n            --></div></div></nav>');
$templateCache.put('app/site/confirmation/breadcrumbs-tgb.html','<div class="row w3-margin-top w3-margin-bottom"><div class="col-xs-12"><div class="w3-container vobe-breadcrumb-container" style="padding-top: 0px; padding-bottom: 0px"><div class="col-xs-6 w3-center gutter-0"><div class="padding-hor-xlarge-sm w3-text-grey"><span class="glyphicon glyphicon-shopping-cart"></span> 1. <span translate="shopping-cart.headings.cart">Cart</span></div></div><div class="col-xs-6 w3-center gutter-0"><div class="padding-hor-xlarge-sm w3-text-grey w3-white w3-card-2"><span class="glyphicon glyphicon-ok" aria-hidden="true"></span> 2. <span translate="shopping-cart.headings.confirmation">Your confirmation</span></div></div></div></div></div>');
$templateCache.put('app/site/confirmation/breadcrumbs.html','<div class="row w3-margin-top w3-margin-bottom"><div class="col-xs-12"><div class="w3-container vobe-breadcrumb-container" style="padding-top: 0px; padding-bottom: 0px"><div class="col-xs-12 col-sm-12 col-md-3 w3-center gutter-0"><div class="w3-padding-16 w3-text-blue"><span class="glyphicon glyphicon glyphicon-th-list"></span> 1. <a ng-click="vm.browseMore($event)" translate="shopping-cart.headings.more">Shop More</a></div></div><div class="col-xs-4 col-sm-4 col-md-3 w3-center gutter-0"><div class="w3-padding-16 w3-text-grey"><span class="glyphicon glyphicon-shopping-cart"></span> 2. <span translate="shopping-cart.headings.cart" class="hidden-xs">Cart</span></div></div><div class="col-xs-4 col-sm-4 col-md-3 w3-center gutter-0"><div class="w3-padding-16 w3-text-grey"><span class="glyphicon glyphicon-credit-card" aria-hidden="true"></span> 3. <span translate="shopping-cart.headings.payment" class="hidden-xs">Payment</span></div></div><div class="col-xs-4 col-sm-4 col-md-3 w3-center gutter-0"><div class="w3-padding-16 w3-text-grey w3-white w3-card-2"><span class="glyphicon glyphicon-ok" aria-hidden="true"></span> 4. <span translate="shopping-cart.headings.confirmation" class="hidden-xs">Your confirmation</span></div></div></div></div></div>');
$templateCache.put('app/site/confirmation/confirmation.html','<div ng-if="vm.property.theGuestBook" ng-include="\'app/site/confirmation/breadcrumbs-tgb.html\'"></div><div ng-if="!vm.property.theGuestBook" ng-include="\'app/site/confirmation/breadcrumbs.html\'"></div><div class="row"><div class="col-xs-12"><div class="vobe-container"><div class="row w3-margin-top"><div class="col-xs-12"><div class="w3-container w3-light-grey w3-padding vobe-bar"><span style="text-transform: uppercase" translate="confirmation.headings.confirmation">Confirmation</span></div></div></div><confirmation-item ng-repeat="voucherItem in vm.confirmation.items | orderBy:\'voucherSale.id\'" voucher-item="voucherItem" index="$index" confirmation-uuid="vm.confirmation.confirmation.confirmationUuid" voucher-config="vm.voucherConfig"></confirmation-item></div></div></div><div class="row w3-padding" ng-if="vm.channel!=20"><div class="w3-card-4"><div class="w3-container w3-padding vobe-bg-container"><div class="col-xs-12 w3-padding-large w3-center"><a ng-if="vm.channel!=20" class="in1-button w3-button w3-border w3-green w3-border-white w3-round" ng-click="vm.browseMore($event)" role="button"><span class="glyphicon glyphicon-th-list" aria-hidden="true" style="top:3px"></span> <span translate="confirmation.buttons.continueshopping">Continue Shopping</span></a></div></div></div></div>');
$templateCache.put('app/site/fatal/breadcrumbs.html','<div class="row w3-margin-top w3-margin-bottom"><div class="col-xs-12"><div class="w3-container w3-whitex vobe-breadcrumb-container" style="padding-top: 0px; padding-bottom: 0px"><div class="col-xs-12 col-sm-12 col-md-12 w3-center gutter-0"><div class="w3-padding-16 w3-text-blue"><span class="glyphicon glyphicon glyphicon-th-list"></span><a ng-click="vm.browseMore($event)" translate="global.headings.more">Shop More</a></div></div></div></div></div>');
$templateCache.put('app/site/fatal/fatal.html','<div ng-include="\'app/site/fatal/breadcrumbs.html\'"></div><div ng-cloak><div class="row"><div class="col-xs-12"><div class="w3-container"><div class="row w3-margin-top"><div class="col-xs-12"><span translate="global.headings.session.expired">Your session has expired. Click \'Shop More\' to start over</span>.</div></div></div></div></div></div>');
$templateCache.put('app/site/fatal/theguestbook-fatal.html','<div ng-cloak><div id="header" class="ng-scope"><div id="headerContainer"><div id="logo"><a href="https://theguestbook.com/"><img src="//in1media.s3.amazonaws.com/obe_resources/TGBVUS/logo.svg" width="278" height="auto" alt="The Guestbook" title="The Guestbook"></a></div></div></div><div class="row"><div class="col-xs-12"><div class="w3-container"><div class="row w3-margin-top"><div class="col-xs-12"><span>Whoops! An unexpected error occurred. If you continue to receive this message, please email <a href="mailto:contact@theguestbook.com" class="w3-text-black"><b>contact@theguestbook.com</b></a> for assistance.</span></div></div></div></div></div></div>');
$templateCache.put('app/site/payment/breadcrumbs-tgb.html','<div class="row w3-margin-top w3-margin-bottom"><div class="col-xs-12"><div class="w3-container vobe-breadcrumb-container" style="padding-top: 0px; padding-bottom: 0px"><div class="col-xs-6 w3-center gutter-0"><div class="padding-hor-xlarge-sm w3-text-grey w3-white w3-card-2"><span class="glyphicon glyphicon-shopping-cart"></span> 1. <span translate="shopping-cart.headings.cart">Cart</span></div></div><div class="col-xs-6 w3-center gutter-0"><div class="padding-hor-xlarge-sm w3-text-grey"><span class="glyphicon glyphicon-ok" aria-hidden="true"></span> 2. <span translate="shopping-cart.headings.confirmation">Your confirmation</span></div></div></div></div></div>');
$templateCache.put('app/site/payment/breadcrumbs.html','<div class="row w3-margin-top w3-margin-bottom"><div class="col-lg-12x"><div class="w3-container w3-whitex vobe-breadcrumb-container" style="padding-top: 0px; padding-bottom: 0px"><div class="col-xs-12 col-sm-12 col-md-3 w3-center gutter-0"><div class="w3-padding-16 w3-text-grey" ng-if="vm.shoppingCart.shoppingCartProperties.bulk"><span class="glyphicon glyphicon glyphicon-th-list"></span> 1. <span translate="shopping-cart.headings.more">Shop More</span></div><div class="w3-padding-16 w3-text-blue" ng-if="!vm.shoppingCart.shoppingCartProperties.bulk"><span class="glyphicon glyphicon glyphicon-th-list"></span> 1. <a ng-click="vm.browseMore($event)" translate="shopping-cart.headings.more">Shop More</a></div></div><div class="col-xs-4 col-sm-4 col-md-3 w3-center gutter-0"><div class="w3-padding-16 w3-text-grey"><span class="glyphicon glyphicon-shopping-cart"></span> 2. <span translate="shopping-cart.headings.cart" class="hidden-xs">Cart</span></div></div><div class="col-xs-4 col-sm-4 col-md-3 w3-center gutter-0"><div class="w3-padding-16 w3-text-grey w3-white w3-card-2"><span class="glyphicon glyphicon-credit-card" aria-hidden="true"></span> 3. <span translate="shopping-cart.headings.payment" class="hidden-xs">Payment</span></div></div><div class="col-xs-4 col-sm-4 col-md-3 w3-center gutter-0"><div class="w3-padding-16 w3-text-grey"><span class="glyphicon glyphicon-ok" aria-hidden="true"></span> 4. <span translate="shopping-cart.headings.confirmation" class="hidden-xs">Your confirmation</span></div></div></div></div></div>');
$templateCache.put('app/site/payment/payment-credit-card.html','<div class="w3-container w3-white w3-padding vobe-bg-payment-2"><div class="w3-padding-0" ng-class="{\'col-xs-12 \' : $ctrl.paymentDetailsSize==\'half\', \'col-xs-12 col-md-6\' : $ctrl.paymentDetailsSize==\'full\'}"><div class="col-xs-12 w3-padding"><label ng-class="($ctrl.paymentFormInvalid && $ctrl.formReference[\'card.cardHolderName\'].$invalid) ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.card.name">Name on Card</label><input ng-class="{\'w3-border-error\': ($ctrl.paymentFormInvalid && $ctrl.formReference[\'card.cardHolderName\'].$invalid)}" class="w3-input w3-sand" type="text" ng-model="$ctrl.card.cardHolderName" name="card.cardHolderName" required></div><div class="col-xs-12 w3-padding"><label ng-class="$ctrl.paymentFormInvalid && $ctrl.formReference[\'card.cardNumber\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.card.number">Card Number</label><input ng-class="{\'w3-border-error\': ($ctrl.paymentFormInvalid && $ctrl.formReference[\'card.cardNumber\'].$invalid)}" class="w3-input w3-sand card-image {{$ctrl.card.cardType}}" type="tel" ng-model="$ctrl.card.cardNumber" ng-if="!$ctrl.stripeEnabled" name="card.cardNumber" x-autocompletetype="cc-number" restrict-numeric="" card-number-validator="" card-number-formatter="" card-type="$ctrl.card.cardType" required></div><div class="col-xs-12 col-sm-6 col-md-4 w3-padding" ng-if="$ctrl.displayCardExpiry"><label ng-class="$ctrl.paymentFormInvalid && $ctrl.formReference[\'card.cardExpiryMonth\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.card.expiry">Expiry Date</label><div><select ng-class="{\'w3-border-error\' : ($ctrl.paymentFormInvalid && $ctrl.formReference[\'card.cardExpiryMonth\'].$invalid)}" class="w3-select w3-sand cardExpiryMonth select-no-caret" card-expiry-in-future2 ng-model="$ctrl.card.cardExpiryMonth" ng-if="!$ctrl.stripeEnabled" name="card.cardExpiryMonth" ng-change="$ctrl.update($ctrl.card.cardExpiryMonth)" ng-required="true" ng-options="o as o.display disable when o.disabled for o in $ctrl.selectCardMonth track by o.value" required></select><select ng-class="{\'w3-border-error\' : ($ctrl.paymentFormInvalid && $ctrl.formReference[\'card.cardExpiryMonth\'].$invalid)}" class="w3-select w3-sand cardExpiryYear select-no-caret" ng-model="$ctrl.card.cardExpiryYear" ng-if="!$ctrl.stripeEnabled" name="card.cardExpiryYear" ng-required="true" ng-options="o as o.display disable when o.disabled for o in $ctrl.selectCardYear" required></select></div></div><div class="col-xs-12 col-sm-6 col-md-4 w3-padding" ng-if="$ctrl.displayCardCvv"><label ng-class="$ctrl.paymentFormInvalid && $ctrl.formReference[\'card.cvv\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.card.cvv">Security Code <span class="glyphicon glyphicon-question-sign" uib-popover-template="$ctrl.popoverUrl.securityCode" popover-trigger="outsideClick"></span></label><input ng-class="{\'w3-border-error\' : ($ctrl.paymentFormInvalid && $ctrl.formReference[\'card.cvv\'].$invalid)}" class="w3-input w3-sand ph-no-capture" type="text" ng-if="!$ctrl.stripeEnabled" ng-model="$ctrl.card.cvv" name="card.cvv" x-autocompletetype="cc-csc" restrict-numeric="" card-cvc-validator="" card-cvc-formatter="" ng-maxlength="4" ng-pattern="/\\d*/" required></div><div class="col-xs-12 col-md-4 w3-padding" style="text-align: center; margin-top: 20px" ng-if="$ctrl.displayCardCvv"><img src="/content/images/ssl-secure-padlock.png" height="40px"></div></div></div>');
$templateCache.put('app/site/payment/payment-terms-dialog.html','<div class="row"><span class="w3-border w3-padding w3-circle w3-white w3-border-dark-grey" ng-click="vm.clear()" ng-show="!vm.hideClear" style="outline: none; float: right; top: -15px; position: relative; z-index: 1000"><span class="w3-closebtn">&times;</span></span><div class="col-xs-12 w3-padding-large voucher-class-contrast" style="padding-top: 0px !important"><div class="w3-container"><p ng-repeat="t in vm.terms" ng-bind-html="t.terms"></p></div></div></div>');
$templateCache.put('app/site/payment/payment-transactions-dialog-item.html','<div class="w3-card-4 w3-row vobe-bg-customization-2" style="margin-bottom: 40px" ng-class="{\'w3-text-green\' : (transactionVM.transaction.paymentTransactionStatusType==\'COMPLETED\' || transactionVM.transaction.persistenceTransactionStatusType==\'SAVED\')}"><div class="w3-col s12 w3-padding" ng-show="transactionVM.transaction.paymentTransactionStatusType==\'ERROR\' || transactionVM.transaction.persistenceTransactionStatusType==\'ERROR\'"><p><span translate="payment.alert.error">Complications arose during the process of this transaction</span><span> ({{transactionVM.date | date:\'yyyy-MM-dd HH:mm Z\'}})</span></p><p class="w3-pale-red w3-padding-16 w3-center w3-round w3-xlarge" ng-show="transactionVM.transaction.errorPaymentStatusDetails && transactionVM.transaction.errorPaymentStatusDetails.message">{{transactionVM.transaction.errorPaymentStatusDetails.message}}</p><dl class="dl-horizontal" ng-if="transactionVM.channel!=20"><dt translate="payment.alert.label.a">Purchase Error</dt><dd><span translate="payment.alert.detail.a1" style="text-transform: uppercase">We could not process your purchase</span>. <span translate="payment.alert.detail.a2" style="text-transform: uppercase">NO PURCHASE MADE</span>.</dd><dt translate="payment.alert.label.b">Common Cause</dt><dd><span translate="payment.alert.detail.b1">1. The issuing bank in many cases limits the transaction you can conduct online to the currency of the bank account supporting the Debit Card.</span><br><span translate="payment.alert.detail.b2">2. This credit card was accepted for a successful booking within the past 3 seconds. A repeat booking attempt can occur if the web browser screen was refreshed. We think it more important to make this check than to accept a booking you did not wish to make. We apologise if we interfered with a genuine booking attempt, please click back and book again and we will not prevent your next attempt</span></dd><dt translate="payment.alert.label.c">Email Us</dt><dd><span translate="payment.alert.detail.c1">If you are still encountering problems, please contact our support team at support@in1solutions.com</span> <span translate="payment.alert.detail.c2">We will email you or we can call you back if you supply a phone number.</span></dd></dl><dl class="dl-horizontal" ng-if="transactionVM.channel!=20"><dt></dt><dd><a class="w3-btn w3-green w3-border w3-border-white w3-round btn-white-hover" ng-click="transactionVM.backToPayment()" translate="payment.alert.label.retry">Try Again</a> <span translate="payment.alert.detail.retry">Click to retry the transaction or to use an alternate payment method</span>.</dd></dl><dl class="dl-horizontal" ng-if="transactionVM.channel==20"><dt translate="payment.alert.label.a">Purchase Error</dt><dd><span>If you think you received this in error, please email us at <a href="mailto=contact@theguestbook.com">contact@theguestbook.com</a> or call us at <a href="tel:+13233024602">+1-323-302-4602</a>.</span></dd></dl></div><div class="w3-col l6 m6 s12 w3-white vobe-bg-customization-1"><div class="row"><div class="col-xs-12"><div class="w3-container w3-center w3-dark-grey" style="padding: 4px 0px; text-transform: uppercase"><div class="col-xs-12"><span translate="payment.headings.transaction">TRANSACTION</span> #{{$index+1}}</div></div></div></div><div class="row"><ul class="w3-ul" style="min-height:160px"><li class="w3-padding-16 col-lg-12" ng-repeat="transactionItem in transactionVM.shoppingCartItems"><div class="col-lg-2"><div class="w3-left w3-circle w3-margin-right voucher-class-bg-img voucher-class-bg-img-cash" style="height:60px; width: 60px" ng-style="{\'background-image\' : transactionItem.itemImageFileName ? \'url(\'+transactionItem.itemImageFileName+\'?h=60)\' : \'\'}"></div></div><div class="col-lg-7"><span class="w3-xlarge">{{transactionItem.itemName}}</span><br><span ng-bind-html="transactionItem.owningProperty.propertyName"></span></div><div class="col-lg-3"><span>{{transactionItem.itemCurrency}} {{transactionItem.itemTotalPrice | number:2}}</span></div></li></ul></div></div><div class="w3-col l6 m6 s12"><div class="row"><div class="col-xs-12"><div class="w3-container w3-center w3-dark-grey" style="padding: 4px 0px; text-transform: uppercase"><span translate="payment.headings.status">STATUS</span></div></div></div><div class="row"><div class="col-xs-12 w3-center" style="display:flex; flex-direction: column; align-items: center"><div style="height: 60px; width: 60px; margin:20px" ng-show="transactionVM.showSpinner" ng-show="transactionVM.transaction.paymentTransactionStatusType!=\'COMPLETED\' && transactionVM.transaction.paymentTransactionStatusType!=\'ERROR\'"><svg fill="rgb(#4caf50) / 0.9)" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25"/><path d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"><animateTransform attributeName="transform" type="rotate" dur="0.75s" values="0 12 12;360 12 12" repeatCount="indefinite"/></path></svg></div><div ng-switch="transactionVM.transaction.paymentTransactionStatusType" style="width: 100%"><div ng-switch-when="INITIAL"><p><span translate="payment.status.initial.description">Payment is being processed. Please allow up to 30 seconds. Do not press refresh in your browser as this may lead to duplication of your purchase.</span></p></div><div ng-switch-when="REDIRECT"><p><span translate="payment.status.redirect.description">You will be redirected to your bank in few seconds</span></p></div><div ng-switch-when="ERROR"><p><span translate="payment.status.error">ERROR</span></p></div><div ng-switch-when="SUCCESS"><p><span translate="payment.status.success">SUCCESS</span></p></div><div ng-switch-when="VOID"><p><span translate="payment.status.void">VOIDED</span></p></div><div ng-switch-when="DISPLAY_HTML"><div class="qr-payment-container"></div><div ng-if="transactionVM.snapScan.enabled" class="snapscan-container"><div class="row"><div class="col-sm-12"><img src="https://pos.snapscan.io/images/qr/titlebar_logo.png" width="200px"></div><div class="col-sm-12"><img ng-src="{{transactionVM.snapScan.qrCode}}"></div><div class="col-sm-12"><span class="qr-action">Scan here to pay</span></div><div class="col-sm-12"><span class="subheader">Don\'t have SnapScan?</span> <span class="subheader semi-bold">Download it for free</span></div><div class="col-sm-12"><div class="app-store-button" style="display: inline-block"><a target="_blank" href="https://play.google.com/store/apps/details?id=com.fireid.snapscan&amp;hl=en_ZA"><img style="height: 25px" src="https://pos.snapscan.io/images/qr/download_android.svg"></a></div><div class="app-store-button" style="display: inline-block"><a target="_blank" href="https://apps.apple.com/il/app/snapscan/id594791461"><img style="height: 25px" src="https://pos.snapscan.io/images/qr/download_ios.svg"></a></div></div><div class="col-sm-12"><button class="in1-button btn btn-lg btn-primary" ng-click="transactionVM.checkSnapScanButton()" ng-disabled="transactionVM.snapScanIntervalButtonLoading" style="margin: 15px">Click Here When Paid</button></div></div></div></div><div ng-switch-when="THREEDS2FINGERPRINT"><div id="fingerprint-challenge" ng-if="transactionVM.checkoutFormLoaded" ng-init="transactionVM.mountAdyen()"></div><div id="fingerprint-challenge-iframe" ng-bind-html="transactionVM.fingerprintIframeSource"></div><p ng-bind="transactionVM.authMessage">Processing...</p><div ng-if="transactionVM.displayTryAgain" style="display: flex; flex-direction: column; align-items: center"><span translate="payment.alert.detail.a2" style="text-transform: uppercase">NO PAYMENT HAS BEEN TAKEN</span> <a class="w3-btn w3-green w3-border w3-border-white w3-round btn-white-hover" ng-click="transactionVM.backToPayment()" translate="payment.alert.label.retry">Try Again </a><span translate="payment.alert.detail.retry">Click to retry the transaction or to use an alternate payment method.</span>.</div></div><div ng-switch-when="THREEDS2CHALLENGE" style="width: 100%"><div id="threeds-challenge" style="height: 600px" ng-if="transactionVM.checkoutFormLoaded" ng-init="transactionVM.mountAdyen()"></div></div><div ng-switch-when="DISPLAY_IFRAME" style="position: relative; width: 100%; min-height: 600px"><iframe style="display: block; border: none; width: 100%; height: 600px" ng-src="{{transactionVM.redirectObjectUrl}}"></iframe></div><div ng-switch-default><p>{{transactionVM.transaction.paymentTransactionStatusType}}</p></div></div><form method="{{transactionVM.method}}" name="{{transactionVM.redirectForm}}" action="{{transactionVM.redirectObjectUrl}}" auto-sumbit-redirect-form="transactionVM.transaction.uuid" ng-show="transactionVM.transaction.paymentTransactionStatusType==\'REDIRECT\' && transactionVM.redirectObjectUrl"><input type="hidden" name="{{rkey}}" value="{{rvalue}}" ng-repeat="(rkey, rvalue) in transactionVM.redirectObject.redirectParams"></form><div class="clearfix"></div></div></div></div></div>');
$templateCache.put('app/site/payment/payment-transactions-dialog.html','<div ng-include="\'app/site/payment/breadcrumbs.html\'"></div><div class="row w3-margin-top w3-margin-bottom" ng-repeat="transaction in vm.transactions" ng-show="vm.isApplicable(transaction)"><div class="col-xs-12" ng-include="\'app/site/payment/payment-transactions-dialog-item.html\'" ng-controller="PaymentTransactionsDialogItemController as transactionVM"></div></div>');
$templateCache.put('app/site/payment/payment.html','<div ng-if="vm.property.theGuestBook" ng-include="\'app/site/payment/breadcrumbs-tgb.html\'"></div><div ng-if="!vm.property.theGuestBook && !vm.isRefundsContext" ng-include="\'app/site/payment/breadcrumbs.html\'"></div><div ng-cloak><div class="row"><div class="col-xs-12x"><div class="w3-container w3-whitex vobe-shopping-cart-container"><div class="row w3-margin-top"><div class="col-xs-12"><div class="w3-container w3-padding vobe-bar"><span style="text-transform: uppercase" translate="shopping-cart.headings.summary">Cart Summary</span></div></div></div><form name="vm.paymentForm"><div class="row"><shopping-cart-summary ng-if="vm.channel!=20" class="col-xs-12" shopping-cart="vm.shoppingCart" shopping-cart-configs="vm.shoppingCartConfigs" property="vm.currentProperty" property-group="vm.currentPropertyGroup" force-hide-promo-box="vm.forceHidePromoBox" payment-form-invalid="vm.paymentFormInvalid" payment-form="vm.paymentForm" customer="vm.customer" on-update-totals="vm.updateTotals(value)"></shopping-cart-summary><shopping-cart-summary-tgb ng-if="vm.channel==20" class="col-xs-12" shopping-cart="vm.shoppingCart" shopping-cart-configs="vm.shoppingCartConfigs" property="vm.currentProperty" property-group="vm.currentPropertyGroup" force-hide-promo-box="vm.forceHidePromoBox"></shopping-cart-summary-tgb></div><div class="row w3-margin-top"><div class="col-xs-12"><div class="w3-container w3-padding vobe-bar"><span style="text-transform: uppercase" translate="payment.headings.paymentform">Payment Form</span></div></div></div><div class="row w3-padding" ng-show="vm.paymentFormInvalid"><div class="w3-container w3-pale-red w3-leftbar w3-border-red w3-margin-bottom w3-margin-top w3-center"><p><span translate="payment.form.alert.invalid">Please fill out all required details marked in red to proceed</span>.</p></div></div><div class="row" ng-class="{\'vobe-purchaser-details-row-flex\' : vm.purchaserDetailsSize==\'half\'}"><div ng-show="!vm.collapsePurchaserDetails" ng-class="{\'col-sm-12\' : vm.purchaserDetailsSize==\'full\', \'col-xs-12 col-md-6\' :vm.purchaserDetailsSize==\'half\', \'vobe-purchaser-details-col-flex\' : vm.purchaserDetailsSize==\'half\'}"><div class="w3-card-2" style="height: 100%; background-color: #ffffff"><div class="w3-container w3-dark-grey w3-padding"><div class="row"><div class="col-sm-6"><span style="text-transform: uppercase" translate="payment.headings.buyerdetails">1. Buyer Details</span></div><div class="col-sm-6 vobe-text-right-md" ng-if="!vm.isRefundsContext"><span class="glyphicon glyphicon-info-sign" style="padding-right:5px; vertical-align: bottom; line-height: 1.5"></span> <span ng-click="vm.openBuyerDetailsModal(\'lg\',\'.modal-parent\')" style="text-decoration:underline" translate="shopping-cart.info.buyer.heading">What Happens Next?</span></div></div></div><div class="w3-container w3-white w3-padding-16" ng-style="{\'min-height\' : vm.purchaserDetailsSize==\'full\'?\'auto\':\'410px\' }"><div class="row"><div ng-class="{\'col-xs-12 col-md-6\' : vm.longForm, \'col-sm-12\' : !vm.longForm}"><div class="row"><div class="col-md-6"><label ng-class="vm.paymentFormInvalid && vm.paymentForm[\'customer.title\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'"><span translate="payment.form.label.customer.title">Title</span></label><select class="w3-select w3-sand" ng-model="vm.customer.title" name="customer.title"><option value=""></option><option ng-show="(\'payment.form.customer.mr\' | translate).trim()!=\'\'" value="{{\'payment.form.customer.mr\' | translate}}">{{\'payment.form.customer.mr\' | translate}}</option><option ng-show="(\'payment.form.customer.mrs\' | translate).trim()!=\'\'" value="{{\'payment.form.customer.mrs\' | translate}}">{{\'payment.form.customer.mrs\' | translate}}</option><option ng-show="(\'payment.form.customer.ms\' | translate).trim()!=\'\'" value="{{\'payment.form.customer.ms\' | translate}}">{{\'payment.form.customer.ms\' | translate}}</option><option ng-show="(\'payment.form.customer.miss\' | translate).trim()!=\'\'" value="{{\'payment.form.customer.miss\' | translate}}">{{\'payment.form.customer.miss\' | translate}}</option></select></div><div class="clearfix visible-xs-block visible-sm-block visible-md-block visible-lg-block"></div><!-- first name --><div class="col-xs-12 col-md-6 w3-padding"><label ng-class="vm.paymentFormInvalid && vm.paymentForm[\'customer.firstName\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.customer.firstname">First Name</label><input ng-class="{\'w3-border-error\': (vm.paymentFormInvalid && vm.paymentForm[\'customer.firstName\'].$invalid)}" class="w3-input w3-sand" type="text" ng-model="vm.customer.firstName" name="customer.firstName" ng-required="true"></div><!-- last name --><div class="col-xs-12 col-md-6 w3-padding"><label ng-class="vm.paymentFormInvalid && vm.paymentForm[\'customer.lastName\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.customer.last">Last Name</label><input ng-class="{\'w3-border-error\': (vm.paymentFormInvalid && vm.paymentForm[\'customer.lastName\'].$invalid)}" class="w3-input w3-sand" type="text" ng-model="vm.customer.lastName" name="customer.lastName" ng-required="!vm.isRefundsContext"></div><!-- email --><div class="col-xs-12 col-md-6 w3-padding"><label ng-class="vm.paymentFormInvalid && (vm.paymentForm[\'customer.email\'].$invalid || (vm.propertyConfig.emailConfirm==\'true\' && vm.paymentForm[\'customer.emailConfirm\'].$invalid) ) ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.customer.email">Email</label><input ng-class="{\'w3-border-error\': (vm.paymentFormInvalid && vm.paymentForm[\'customer.email\'].$invalid)}" class="w3-input w3-sand" type="email" autocomplete="email" ng-model="vm.customer.email" name="customer.email" ng-required="true"></div><!-- confirm email --><div class="col-xs-12 col-md-6 w3-padding" ng-if="vm.propertyConfig.emailConfirm==\'true\'"><label ng-class="vm.paymentFormInvalid && vm.paymentForm[\'customer.emailConfirm\'].$invalid  ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.customer.emailconfirm">Confirm Email</label><input ng-class="{\'w3-border-error\': (vm.paymentFormInvalid && vm.paymentForm[\'customer.emailConfirm\'].$invalid)}" class="w3-input w3-sand" type="email" ng-model="vm.customer.emailConfirm" name="customer.emailConfirm" ng-required="vm.propertyConfig.emailConfirm==\'true\'" same-value-required="vm.propertyConfig.emailConfirm==\'true\'" same-value="vm.customer.email"></div><div class="col-xs-12 w3-padding" ng-show="vm.propertyConfig.emailConfirm==\'true\' && vm.paymentFormInvalid && vm.paymentForm[\'customer.emailConfirm\'].$error.sameValue"><span class="w3-text-red" translate="payment.form.alert.emailconfirm">Email addresses do not match. Please review and correct.</span></div><!-- phone --><div class="col-xs-12 col-md-6 w3-padding"><label ng-class="vm.paymentFormInvalid && vm.paymentForm[\'customer.phone\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.customer.phone">Phone</label><input ng-class="{\'w3-border-error\': (vm.paymentFormInvalid && vm.paymentForm[\'customer.phone\'].$invalid)}" class="w3-input w3-sand" type="tel" autocomplete="tel" ng-model="vm.customer.phone" name="customer.phone" ng-required="true"></div><!-- country --><div class="col-xs-12 col-md-6 w3-padding"><label ng-class="vm.paymentFormInvalid && vm.paymentForm[\'customer.country\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.customer.country">Country</label><select ng-class="{\'w3-border-error\': (vm.paymentFormInvalid && vm.paymentForm[\'customer.country\'].$invalid)}" class="w3-select w3-sand" type="text" autocomplete="country" ng-model="vm.customer.country" name="customer.country" ng-required="true" ng-options="o as o.countryName group by o.continentName for o in vm.selectCountry | orderBy:[\'priorityCountryIndex\',\'priorityGroupIndex\',\'continentName\',\'countryName\']"></select></div></div></div><div class="col-md-6 w3-padding-0" ng-if="vm.longForm || vm.propertyConfig.paymentType == 8"><!-- address --><div class="col-xs-12 w3-padding"><label ng-class="vm.paymentFormInvalid && vm.paymentForm[\'customer.address\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.customer.address">Address</label><input ng-class="{\'w3-border-error\': (vm.paymentFormInvalid && vm.paymentForm[\'customer.address\'].$invalid)}" class="w3-input w3-sand" type="text" autocomplete="street-address" ng-model="vm.customer.address" name="customer.address" ng-maxlength="50" ng-required="true"></div><div class="col-xs-12 w3-padding"><label ng-class="vm.paymentFormInvalid && vm.paymentForm[\'customer.town\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.customer.town">Town / City</label><input ng-class="{\'w3-border-error\': (vm.paymentFormInvalid && vm.paymentForm[\'customer.town\'].$invalid)}" class="w3-input w3-sand" type="text" ng-model="vm.customer.town" name="customer.town" ng-maxlength="50" ng-required="true"></div><div class="col-xs-12 w3-padding"><label ng-class="vm.paymentFormInvalid && vm.paymentForm[\'customer.county\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.customer.county">County / State</label><input ng-if="vm.customer.country.countryCode !== \'US\'" ng-class="{\'w3-border-error\': (vm.paymentFormInvalid && vm.paymentForm[\'customer.county\'].$invalid)}" class="w3-input w3-sand" type="text" ng-model="vm.customer.county" name="customer.county" ng-maxlength="50" ng-required="true"><select ng-if="vm.customer.country.countryCode === \'US\'" ng-class="{\'w3-border-error\': (vm.paymentFormInvalid && vm.paymentForm[\'customer.county\'].$invalid)}" class="w3-select w3-sand" type="text" ng-model="vm.customer.county" name="customer.county" ng-required="true" ng-options="o.abbreviation as o.name for o in vm.americanStates"></select></div><div class="col-xs-12 w3-padding"><label ng-class="vm.paymentFormInvalid && vm.paymentForm[\'customer.postcode\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.customer.postcode">Postcode / Zip</label><input ng-class="{\'w3-border-error\': (vm.paymentFormInvalid && vm.paymentForm[\'customer.postcode\'].$invalid)}" class="w3-input w3-sand" type="text" autocomplete="postal-code" pattern="[a-zA-Z0-9-\\s]+" title="Postcode is required." ng-model="vm.customer.postcode" name="customer.postcode" ng-maxlength="20" ng-required="vm.isPostCodeRequired"></div></div><div class="col-xs-12 w3-padding-0" ng-if="vm.displayIdentityInput"><div class="col-xs-6 col-sm-6 w3-padding"><label ng-class="vm.paymentFormInvalid && vm.paymentForm[\'customer.idType\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.customer.idtype">Select ID Type</label><select ng-class="{\'w3-border-error\': (vm.paymentFormInvalid && vm.paymentForm[\'customer.idType\'].$invalid)}" name="customer.idType" class="w3-select w3-sand" id="idType" ng-model="vm.customer.idType" ng-required="true"><option value="CC" translate="payment.form.label.customer.idcc">CC</option><option value="CE" translate="payment.form.label.customer.idce">CE</option><option value="NIT" translate="payment.form.label.customer.idnit">NIT</option></select></div><div class="col-xs-6 col-sm-6 w3-padding"><label ng-class="vm.paymentFormInvalid && vm.paymentForm[\'customer.idNumber\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" for="idValue" translate="payment.form.label.customer.idvalue">Enter ID Value</label><input type="text" ng-class="{\'w3-border-error\': (vm.paymentFormInvalid && vm.paymentForm[\'customer.idNumber\'].$invalid)}" class="w3-input w3-sand" id="idValue" name="customer.idNumber" ng-model="vm.customer.idNumber" ng-maxlength="40" ng-required="true"></div></div></div></div></div></div><div ng-if="vm.displayCardPayment" ng-class="{\'col-sm-12\' : vm.paymentDetailsSize==\'full\', \'col-xs-12 col-md-6\' : vm.paymentDetailsSize==\'half\', \'vobe-purchaser-details-col-flex\' : vm.purchaserDetailsSize==\'half\'}"><div class="w3-card-2" style="height: 100%; background-color: #ffffff"><div class="w3-container w3-dark-grey w3-padding"><span style="text-transform: uppercase" translate="payment.headings.paymentdetails">2. Payment Details</span></div><div style="display: flex; flex-direction: row"><div ng-repeat="po in vm.availablePaymentOptions | orderBy:\'sequence\'" class="payment-option payment-option__section"><div class="payment-option__radio-wrapper"><label for="radio-{{po.name}}" ng-class="{\'active\' : vm.selectedPaymentOptionId == po.id}"><input type="radio" class="payment-option__radio" name="paymentoptions" id="radio-{{po.name}}" ng-model="vm.selectedPaymentOptionId" ng-value="po.id" ng-checked="vm.selectedPaymentOption.id == po.id" ng-change="vm.changedPaymentOption(po)"><div class="payment-option__title payment-option__creditcards-title payment-label"><div class="payment-option__radio-button-title"><span ng-bind="::po.displayName"></span></div><div class="payment-option__credit-cards"><div class="payment-option__credit-card-icon {{po.name}}"></div></div></div></label></div></div></div><!--                                <pre>{{vm.selectedPaymentOption | json}}</pre>--><div ng-if="vm.selectedPaymentOption.displayCreditCard || vm.selectedPaymentOption.id == 9"><credit-card-form payment-details-size="vm.paymentDetailsSize" ng-if="!vm.stripeEnabled" form-reference="vm.paymentForm" card="vm.customer.card" display-card-expiry="vm.displayCardExpiry" display-card-cvv="vm.displayCardCvv" payment-form-invalid="vm.paymentFormInvalid" on-update="vm.updateCard(value)" property-config="vm.propertyConfig" available-credit-cards="po.creditCards"></credit-card-form><!-- stripe elements payment form --><div ng-if="vm.stripeEnabled" id="payment-element" class="w3-container w3-white w3-padding-16 vobe-bg-payment-2"><stripe-element instance="vm.paymentElement"></stripe-element><!--                                        <stripe-element instance="vm.billingElement"></stripe-element>--><div class="w3-padding-16"><div><input type="checkbox" ng-model="vm.enableCardName" id="enable-card-name"><label for="enable-card-name">Cardholder same as purchaser</label></div><div ng-if="!vm.enableCardName"><label ng-class="vm.paymentFormInvalid && vm.paymentForm[\'card.cardHolderName\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="payment.form.label.card.name">Name on Card</label><input class="w3-input w3-sand" type="text" ng-model="vm.card.cardHolderName" name="card.cardHolderName" ng-required="!vm.enableCardName"></div></div></div></div><div ng-if="!vm.selectedPaymentOption.displayCreditCard && vm.selectedPaymentOption.id == 25"><!-- Adyen --><div class="w3-card-2"><div class="w3-container w3-white w3-padding-16 vobe-bg-payment-2" ng-style="{\'min-height\' : vm.paymentDetailsSize==\'full\'?\'auto\':\'410px\' }"><div id="dropin-container" adyen-checkout configuration="vm.adyenConfiguration"><div ng-if="!vm.selectedPaymentOption.clientKey"><p>Adyen Payment Gateway is not activated! Please try again later.</p></div></div><div class="card-row col-xs-12 w3-center" ng-class="{\'col-md-6\' : vm.paymentDetailsSize==\'full\'}"><div class="row"><div class="card-row" ng-class="{\'col-xs-12 \' : vm.paymentDetailsSize==\'half\', \'col-sm-6 col-sm-offset-3\' : vm.paymentDetailsSize==\'full\'}"><span ng-repeat="creditCard in vm.availableCreditCards" ng-show="creditCard.code!=\'switch\' && creditCard.code!=\'laser\'" class="{{creditCard.code}}"></span></div></div></div></div></div></div><div class="col-xs-12 w3-text-small w3-text-gray" ng-if="!vm.isSameCurrency"><p><br>Payment will occur in {{vm.itemCurrencies}} currency as this is the currency of the merchant.</p></div></div></div></div><div class="row" ng-if="vm.displayTerms"><div class="col-sm-12"><div class="w3-card-2"><div class="w3-container w3-dark-grey w3-padding-16"><span style="text-transform: uppercase" translate="payment.headings.tandc">3. Terms & Conditions</span></div><div class="w3-container w3-white w3-padding-16 vobe-bg-payment-2"><div class="col-md-12 w3-padding-0" style="position: relative"><div class="row"><div class="col-xs-12 w3-padding" style="position: relative"><input class="switch-input" type="checkbox" ng-class="vm.paymentFormInvalid && vm.paymentForm[\'customer.termsAgreed\'].$invalid ? \'red\' : \'\'" name="customer.termsAgreed" id="customer.termsAgreed" ng-model="vm.customer.termsAgreed" value="email" ng-required="!vm.customer.termsAgreed"><label class="switch-label" for="customer.termsAgreed" ng-class="vm.paymentFormInvalid && vm.paymentForm[\'customer.termsAgreed\'].$invalid ? \'w3-text-red\' : \'\'" translate="payment.form.label.terms.agree">I agree to the Terms & Conditions</label><a ui-sref="terms-payment" class="vobe-payment-terms-link vobe-text-right-md w3-text-grey"><span class="glyphicon glyphicon-list-alt" aria-hidden="true"></span> <span translate="payment.form.label.terms.read">Read Terms</span></a></div><div class="col-xs-12 w3-padding" style="position: relative"><input class="switch-input" type="checkbox" id="customer.newsletter" name="customer.newsletter" ng-model="vm.customer.newsletter" value="on"><label for="customer.newsletter" ng-if="vm.newsletter.optin" class="switch-label" translate="payment.form.label.newsletter.optin">Sign up to our updates</label><label for="customer.newsletter" ng-if="vm.newsletter.optout" class="switch-label" translate="payment.form.label.newsletter.optout">Don\'t sign me up to updates</label></div></div></div></div></div></div></div><div class="row w3-padding" ng-show="vm.paymentFormInvalid"><div class="w3-container w3-pale-red w3-leftbar w3-border-red w3-margin-bottom w3-margin-top w3-center"><p translate="payment.form.alert.invalid">Please fill out all required details marked in red to proceed</p></div></div><div class="row w3-padding" ng-show="vm.stripeError.message"><div class="w3-container w3-pale-red w3-leftbar w3-border-red w3-margin-bottom w3-margin-top w3-center"><p ng-bind="vm.stripeError.message"></p></div></div><div class="row"><div class="col-xs-12 w3-center" style="padding-top: 15px; font-weight: bold"><div style="padding: 5px" translate="payment.form.label.card_charged_confirm" translate-interpolation="messageformat" translate-values="{ amount: (vm.itemCurrencies + (vm.amountToCharge | currency:\' \')), QUANTITY: vm.shoppingCart.shoppingCartItems.items.length}"></div><button type="button" class="complete-pay-button" ng-click="vm.startPayment($event)" ng-disabled="vm.isProcessing"><span ng-show="!vm.isProcessing" translate="payment.buttons.paynow">Complete and pay</span> <span ng-show="vm.isProcessing">Processing...</span></button></div></div></form></div></div></div></div><div class="modal-parent"></div>');
$templateCache.put('app/site/property/hero-property.html','<div class="jumbotron"><div class="jumbotron-stripe"><div class="w3-container w3-section w3-white-60"><h1 ng-show="vm.property.hotelName">{{vm.property.hotelName}}</h1><p>SEND INSTANT E-GIFT CARDS TO YOUR FAVOURITE PEOPLE FROM YOUR FAVOURITE HOTEL</p></div></div><!-- \n\t  <div class="container" style="text-align: center;">\n\t  \t  <p><a class="w3-btn w3-white w3-border w3-round" href="#" role="button">Browse</a></p>\t  \t\n\t  </div>\n\t   --></div>');
$templateCache.put('app/site/shoppingcart/breadcrumbs-tgb.html','<div class="row w3-margin-top w3-margin-bottom"><div class="col-lg-12x"><div class="w3-container vobe-breadcrumb-container" style="padding-top: 0px; padding-bottom: 0px"><div class="col-xs-6 w3-center gutter-0"><div class="padding-hor-xlarge-sm w3-text-grey w3-white w3-card-2"><span class="glyphicon glyphicon-shopping-cart"></span> 1. <span translate="shopping-cart.headings.cart">Cart</span></div></div><div class="col-xs-6 w3-center gutter-0"><div class="padding-hor-xlarge-sm w3-text-grey"><span class="glyphicon glyphicon-ok" aria-hidden="true"></span> 2. <span translate="shopping-cart.headings.confirmation">Your confirmation</span></div></div></div></div></div>');
$templateCache.put('app/site/shoppingcart/breadcrumbs.html','<div class="row w3-margin-top w3-margin-bottom"><div class="col-lg-12x"><div class="w3-container vobe-breadcrumb-container" style="padding-top: 0px; padding-bottom: 0px"><div class="col-xs-12 col-sm-12 col-md-3 w3-center gutter-0"><div class="padding-hor-xlarge-sm w3-text-blue"><span class="glyphicon glyphicon glyphicon-th-list"></span> 1. <a ng-click="vm.browseMore($event)" translate="shopping-cart.headings.more">Shop More</a></div></div><div class="col-xs-4 col-sm-4 col-md-3 w3-center gutter-0"><div class="padding-hor-xlarge-sm w3-text-grey w3-white w3-card-2"><span class="glyphicon glyphicon-shopping-cart"></span> 2. <span translate="shopping-cart.headings.cart" class="hidden-xs">Cart</span></div></div><div class="col-xs-4 col-sm-4 col-md-3 w3-center gutter-0"><div class="padding-hor-xlarge-sm w3-text-grey"><span class="glyphicon glyphicon-credit-card" aria-hidden="true"></span> 3. <span translate="shopping-cart.headings.payment" class="hidden-xs">Payment</span></div></div><div class="col-xs-4 col-sm-4 col-md-3 w3-center gutter-0"><div class="padding-hor-xlarge-sm w3-text-grey"><span class="glyphicon glyphicon-ok" aria-hidden="true"></span> 4. <span translate="shopping-cart.headings.confirmation" class="hidden-xs">Your confirmation</span></div></div></div></div></div>');
$templateCache.put('app/site/shoppingcart/hero-shopping.html','<div class="jumbotron" style="background-image: url(/content/images/shopping-checkout.jpg);background-position: center bottom"><div class="jumbotron-stripe"><div class="w3-container w3-section w3-white-60"><h1 translate="shopping-cart.hero.title">Your Shopping Cart</h1></div></div></div>');
$templateCache.put('app/site/shoppingcart/shopping-cart-dropdown.html','<li ng-class="{active: vm.$state.includes(\'property\')}" uib-dropdown class="dropdown pointer" is-open="vm.shoppingCartOpen" on-toggle="vm.shoppingCartToggled(open)" auto-close="outsideClick"><a class="dropdown-toggle" uib-dropdown-toggle id="shopping-menu"><span><span class="glyphicon glyphicon-shopping-cart"></span> <span class="hidden-sm" translate="global.menu.shopping.main">Cart</span> <span>{{vm.shoppingCart.shoppingCartItems.items.length}}</span> <b class="caret"></b></span></a><ul class="dropdown-menu dropdown-menu-shopping-cart w3-light-grey" uib-dropdown-menu ng-if="vm.shoppingCart.shoppingCartItems.items.length==0"><li><div class="w3-padding-large w3-center w3-text-dark-grey"><span translate="shopping-cart.alert.empty">Your card is empty</span>.</div></li></ul><ul class="dropdown-menu dropdown-menu-shopping-cart w3-light-grey" uib-dropdown-menu ng-style="vm.maxHeighStyle" ng-if="vm.shoppingCart.shoppingCartItems.items.length>0" style="padding-left:\n\t\t15px"><li><div style="margin: 5px" uib-alert ng-repeat="alert in vm.perishableAlerts">{{alert.msg}}</div></li><li><table class="w3-table" style="border-collapse: separate; border-spacing: 0px\n\t\t\t\t5px"><tr class="w3-card-4x"><th translate="shopping-cart.items.quantity" style="text-transform:\n\t\t\t\t\t\tuppercase">QTY</th><th translate="shopping-cart.items.item" style="text-transform:\n\t\t\t\t\t\tuppercase">ITEM</th><th translate="shopping-cart.items.price" style="text-transform:\n\t\t\t\t\t\tuppercase">PRICE</th><th></th></tr><tr class="w3-white" ng-repeat="cartItem in\n\t\t\t\t\tvm.shoppingCart.shoppingCartItems.items"><td>1</td><td><span class="w3-small">{{cartItem.itemName}}</span></td><td><span class="w3-small">{{cartItem.itemCurrency}}<br></span><span class="w3-medium">{{cartItem.itemTotalPrice | numberInteger}}{{cartItem.itemTotalPrice | numberFraction}}</span></td><td><div class="w3-dropdown-hover w3-right"><button class="w3-btn w3-light-grey" style="min-width: 50px"><span class="glyphicon glyphicon-option-vertical"></span></button><div class="w3-dropdown-content w3-border" style="min-width: 50px"><a style="padding: 4px" ui-sref="shopping-cart" ui-sref-opts="{reload: true}"><span class="glyphicon glyphicon-pencil"></span></a> <a style="padding: 4px" ng-click="vm.removeItemFromCartAndRefresh($event,cartItem.uuid)"><span class="glyphicon glyphicon-trash"></span></a></div></div></td></tr></table></li><li><p translate="shopping-cart.items.totals" style="text-transform:\n\t\t\t\t\tuppercase">TOTALS</p><p ng-repeat="(totalPropertyId,total) in\n\t\t\t\t\tvm.shoppingCart.shoppingCartItems.totalPerProperty"><strong class="pull-right">{{vm.getAnyItemByPropertyId(totalPropertyId).owningProperty.propertyCurrency}} {{total | number:2}}</strong><span class="w3-small">{{vm.getAnyItemByPropertyId(totalPropertyId).owningProperty.propertyName}}</span></p></li><li><p style="text-align: center"><a ng-click="vm.goToShoppingCart($event)" class="w3-btn w3-green w3-border w3-round in1-button" href="#" role="button"><span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span> <span translate="shopping-cart.buttons.checkout">Checkout</span></a></p></li></ul></li>');
$templateCache.put('app/site/shoppingcart/shopping-cart-edit.html','<div ng-if="vm.property.theGuestBook" ng-include="\'app/site/shoppingcart/breadcrumbs-tgb.html\'"></div><div ng-if="!vm.property.theGuestBook" ng-include="\'app/site/shoppingcart/breadcrumbs.html\'"></div><div class="row"><div class="col-xs-12"><div class="vobe-shopping-cart-container"><div class="row w3-margin-top"><div class="col-xs-12"><div class="w3-container w3-whitex w3-leftbarx w3-border-dark-grey w3-padding vobe-bar"><span style="text-transform: uppercase" translate="shopping-cart.headings.summary">Cart Summary</span></div></div></div><div class="row"><shopping-cart-summary ng-if="vm.channel!=20" class="col-xs-12" shopping-cart="vm.shoppingCart" shopping-cart-configs="vm.shoppingCartConfigs" property="vm.currentProperty" property-group="vm.currentPropertyGroup" force-hide-promo-box="vm.forceHidePromoBox"></shopping-cart-summary><shopping-cart-summary-tgb ng-if="vm.channel==20" class="col-xs-12" shopping-cart="vm.shoppingCart" shopping-cart-configs="vm.shoppingCartConfigs" property="vm.currentProperty" property-group="vm.currentPropertyGroup" force-hide-promo-box="vm.forceHidePromoBox"></shopping-cart-summary-tgb></div></div><div class="row w3-margin-top vobe-bar-cart-details"><div class="col-xs-12"><div class="w3-container w3-whitex w3-leftbarx w3-border-dark-grey w3-padding vobe-bar"><span style="text-transform: uppercase" translate="shopping-cart.headings.details">Cart Details</span></div></div></div><form name="vm.checkoutForm" class="vobe-checkout-form"><div class="w3-container w3-pale-red w3-leftbar w3-border-red w3-margin-bottom w3-center" ng-show="vm.checkoutFormInvalid"><p><span translate="shopping-cart.alert.form.invalid">Please fill out all required details marked in red to proceed to payment</span>.</p></div><cart-item-voucher ng-repeat="cartItem in vm.shoppingCart.shoppingCartItems.items" cart-item="cartItem" cart-item-first="$first" cart-item-index="$index" shopping-cart="vm.shoppingCart" shopping-cart-configs="vm.shoppingCartConfigs" email-config="vm.emailConfig" is-bulk="false" checkout-form="vm.checkoutForm" checkout-form-invalid="vm.checkoutFormInvalid" property="vm.currentProperty" current-language="vm.currentLanguage"></cart-item-voucher><!--<div class="col-lg-12" ng-include="\'app/site/shoppingcart/shopping-cart-item-voucher.html\'"  ng-controller="ShoppingCartItemVoucherController as itemVM"></div>--><div class="w3-container w3-pale-red w3-leftbar w3-border-red w3-margin-bottom w3-center" ng-show="vm.checkoutFormInvalid"><p><span translate="shopping-cart.alert.form.invalid">Please fill out all required details marked in red to proceed to payment</span>.</p></div></form><div class="row w3-padding"><div class="w3-card-4"><div class="w3-container w3-padding vobe-bg-container"><div class="col-xs-12 w3-padding-large w3-center"><a ng-if="vm.channel!=20" class="in1-button w3-button w3-border w3-green w3-border-white w3-round" ng-click="vm.goToPayment($event)" role="button"><span class="glyphicon glyphicon-credit-card" aria-hidden="true" style="top:3px"></span> <span translate="shopping-cart.buttons.topayment">Proceed to payment</span></a> <a ng-if="vm.channel==20" class="in1-button w3-button w3-border w3-green w3-border-white w3-round" ng-click="vm.goToConfirmation($event)" role="button"><span class="glyphicon glyphicon-credit-card" aria-hidden="true" style="top:3px"></span> <span translate="shopping-cart.buttons.topayment">Proceed to payment</span></a></div></div></div></div></div></div>');
$templateCache.put('app/site/shoppingcart/shopping-cart-empty.html','<div ng-if="vm.property.theGuestBook" ng-include="\'app/site/shoppingcart/breadcrumbs-tgb.html\'"></div><div ng-if="!vm.property.theGuestBook" ng-include="\'app/site/shoppingcart/breadcrumbs.html\'"></div><div style="display: flex;\n    justify-content: center;\n    align-items: center; margin: 20px" translate="shopping-cart.alert.empty">Your cart is empty</div>');
$templateCache.put('app/site/shoppingcart/shopping-cart-item-voucher.html','<!--<div class="w3-card-2 w3-row vobe-bg-customization-2 w3-padding-16"--><!--style="margin-bottom: 40px;">--><!--<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 vobe-bg-customization-1">--><!--<div class="row">--><!--<div class="col-lg-12">--><!--<div class="w3-container w3-center w3-bottombar vobe-bg-customization-header hide"--><!--style="padding: 4px 0px;text-transform: uppercase;">--><!--<div class="col-xs-12"><span translate="vouchers.headings.item">ITEM</span> #{{$index+1}}</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="row">--><!--<div class="col-lg-12">--><!--<div class="w3-ul">--><!--&lt;!&ndash;--><!--<li class="w3-border-0 w3-light-grey ">--><!--<div class="row">--><!--<div class="col-xs-12">--><!--<a class="w3-small w3-padding w3-right" ng-click="itemVM.removeItemFromCartAndRefresh($event)"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span> Remove</a>--><!--</div>--><!--</div>--><!--</li>--><!--&ndash;&gt;--><!--<div class="w3-border-0" style="padding: 0px;padding-bottom:8px;">--><!--<div class="row w3-center hide" >--><!--<div class="col-xs-12 col-lg-8"><span></span></div>--><!--<div class="col-xs-6 col-lg-2"><span translate="vouchers.form.label.price">Price</span></div>--><!--<div class="col-xs-6 col-lg-2"><span translate="vouchers.form.label.quantity">Qty</span></div>--><!--</div>--><!--<div class="row  w3-center" style="padding-top:8px;">--><!--<div class="col-xs-12 col-sm-6 col-md-12 tilesgrid-two">--><!--<div ng-if="itemVM.cartItem.itemImageFileName && itemVM.cartItem.itemImageFileName!=\'no-image\'" class="voucher-bg-img" style="background-image:url(\'{{itemVM.cartItem.itemImageFileName}}?fit=crop&amp;h=405&amp;min-w=715&amp;crop=edges&amp;q=70&amp;auto=compress&amp;cs=strip\')" alt="{{itemVM.cartItem.owningProperty.propertyName}}"></div>--><!--</div>--><!--<div class="col-xs-12 col-sm-6 col-md-12">--><!--<div class="row">--><!--<div class="col-xs-12">--><!--<div class="vobe-bg-customization-descr">--><!--<div class="w3-container w3-center">--><!--<h3>{{itemVM.cartItem.itemName}}</h3>--><!--<h6 style="text-transform: uppercase;">{{itemVM.cartItem.owningProperty.propertyName}}</h6>--><!--<span class="w3-small" ng-show="itemVM.cartItem.itemTotalPriceBeforeDiscount>itemVM.cartItem.itemTotalPrice" style="display: block;"><span translate="vouchers.headings.price.retail">Retail Value</span>: {{itemVM.cartItem.itemCurrency | currencySign}} {{itemVM.cartItem.itemTotalPriceBeforeDiscount | number:2}}</span>--><!--<span class="w3-small" ng-show="vm.channel==\'20\'"  style="display: block;">Member Price: {{itemVM.cartItem.itemCurrency | currencySign}} {{itemVM.cartItem.itemTotalPrice | number:2}} <span translate="vouchers.headings.price.rewards">Rewards</span></span>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-xs-6">--><!--<span>{{itemVM.cartItem.itemCurrency }}</span><br /> <span--><!--class="w3-xlarge">{{itemVM.cartItem.itemTotalPrice | number:2}}</span>--><!--</div>--><!--<div class="col-xs-6">--><!--<br />&times <span class="w3-xlarge">1</span>--><!--</div>--><!--<div class="col-xs-12">--><!--<div class="vobe-bg-customization-descr">--><!--<div class="w3-container w3-center">--><!--<p class="w3-smallx" ng-bind-html="itemVM.explicitlyTrustedItemDescription"></p>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="w3-border-0" style="padding: 0px;" >--><!--<div class="row w3-padding" ng-show="itemVM.cartItem.recipient.deliveryMethodType==\'email\' && itemVM.emailConfigMap.emailPreview==\'true\'">--><!--<div class="col-xs-12 w3-right-alignx">--><!--<a style="margin-top: 5px; text-decoration: none;" class="btn-block w3-btn w3-border w3-light-grey w3-border-grey w3-round" ng-click="itemVM.previewVoucher()"><span class="glyphicon glyphicon-picture" aria-hidden="true"></span> <span translate="vouchers.form.label.emailpreview">Preview Voucher</span></a>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 vobe-bg-customization-2">--><!--<div class="row">--><!--<div class="col-lg-12">--><!--<div class="w3-container  w3-center w3-bottombar vobe-bg-customization-header hide"--><!--style="padding: 4px 0px;text-transform: uppercase;" translate="vouchers.headings.customization">CUSTOMIZATION</div>--><!--</div>--><!--</div>--><!--<div class="row" ng-show="itemVM.hideCustomizationBox">--><!--<div class="col-lg-12" style="text-align: center;padding: 20px;">--><!--<span class="glyphicon glyphicon-ok-circle" aria-hidden="true" style="text-align: center;font-size: 60px;color: #f1f1f1;"></span>--><!--</div>--><!--</div>--><!--<div class="row" ng-show="!itemVM.hideCustomizationBox">--><!--&lt;!&ndash;<div class="col-lg-12">&ndash;&gt;--><!--<div class="w3-ul w3-padding-8">--><!--<div class="w3-card-4 vobe-bg-customization-2-wrapper" style="margin-top: 8px;">--><!--<div class="w3-padding vobe-bg-customization-2-h" style="text-align: left;">--><!--<div class="vobe-bg-customization-2-h-inner" ng-class="vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].deliveryMethodType\'].$valid ? \'w3-border-light-green\' : \'w3-border-red\'">--><!--<span--><!--ng-class="vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].deliveryMethodType\'].$valid ? \'w3-text-light-green\' : \'w3-text-red\'"--><!--class="glyphicon glyphicon-ok-sign"></span> <span translate="vouchers.form.label.deliverymethod">Delivery Method </span>--><!--</div>--><!--</div>--><!--<div class="row w3-padding">--><!--<div class="col-xs-12 col-sm-6 col-md-12 col-lg-6 w3-padding" ng-if="itemVM.configMap.emailOption==\'true\'">--><!--<input class="w3-radio" type="radio"--><!--name="item[{{itemVM.cartItem.uuid}}].deliveryMethodType"--><!--ng-model="itemVM.cartItem.recipient.deliveryMethodType"--><!--value="email"--><!--ng-required="!itemVM.cartItem.recipient.deliveryMethodType">--><!--<label translate="vouchers.delivery.email.name">E-mail</label>--><!--<div class="w3-text-grey" ng-show="vm.channel!=20">--><!--<span translate="vouchers.delivery.email.explain.any.text"></span>--><!--</div>--><!--</div>--><!--<div class="col-xs-12 col-sm-6 col-md-12 col-lg-6 w3-padding" ng-if="itemVM.configMap.postalOption==\'true\'">--><!--<input class="w3-radio" type="radio"--><!--name="item[{{itemVM.cartItem.uuid}}].deliveryMethodType"--><!--ng-model="itemVM.cartItem.recipient.deliveryMethodType"--><!--value="post"--><!--ng-required="!itemVM.cartItem.recipient.deliveryMethodType"--><!--&gt;--><!--<label translate="vouchers.delivery.post.name">Post</label>--><!--<div class="w3-text-grey" ng-show="vm.channel!=20">--><!--<span >{{ (itemVM.cartItem.itemGiftCardId ? \'giftcards.delivery.post.explain.any.text\' : \'vouchers.delivery.post.explain.any.text\') | translate }}</span>--><!--</div>--><!--</div>--><!--<div class="col-xs-12 w3-padding" ng-show="vm.checkoutFormInvalid && vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].deliveryMethodType\'].$invalid">--><!--<span class="w3-text-red" translate="vouchers.form.alert.deliverymethod">Please select how would you like to receive your gift voucher</span>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="w3-card-4 vobe-bg-customization-2-wrapper">--><!--<div class="w3-padding vobe-bg-customization-2-h" style="text-align: left;">--><!--<div class="vobe-bg-customization-2-h-inner" ng-class="(vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].deliveryPersonType\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.email\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.address\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.town\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.county\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.postcode\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.country\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.phone\'].$valid--><!--) ? \'w3-border-light-green\' : \'w3-border-red\'" style="position: relative;">--><!--<span--><!--ng-class="(vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].deliveryPersonType\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.email\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.address\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.town\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.county\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.postcode\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.country\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.phone\'].$valid--><!--) ? \'w3-text-light-green\' : \'w3-text-red\'"--><!--class="glyphicon glyphicon-ok-sign"></span> <span translate="vouchers.form.label.deliveryperson">Deliver To </span>--><!--<span ng-click="itemVM.openExplainDeliveryModal(\'lg\',\'.modal-parent\')" class="hide explain-icon glyphicon glyphicon-info-sign"></span>--><!--</div>--><!--</div>--><!--<div class="row w3-padding" ng-class="(itemVM.configMap.disableDeliverToCustomer==\'true\') ? \'hide\' : \'\'">--><!--<div class="col-xs-12 col-sm-6 col-md-12 col-lg-6 w3-padding" ng-show="itemVM.configMap.disableDeliverToCustomer==\'false\'">--><!--<input class="w3-radio" type="radio"--><!--id="item[{{itemVM.cartItem.uuid}}].deliveryPersonType.me"--><!--name="item[{{itemVM.cartItem.uuid}}].deliveryPersonType"--><!--ng-model="itemVM.cartItem.recipient.deliveryPersonType"--><!--value="customer"--><!--ng-change="itemVM.cartItem.recipient.email = \'\'"--><!--ng-required="!itemVM.cartItem.recipient.deliveryPersonType">--><!--<label for="item[{{itemVM.cartItem.uuid}}].deliveryPersonType.me"--><!--translate="vouchers.delivery.person.customer">Me</label>--><!--<div class="w3-text-grey"ng-show="vm.channel!=20">--><!--<span >{{ (itemVM.cartItem.itemGiftCardId ? \'giftcards.delivery.customer.explain.any.text\' : \'vouchers.delivery.customer.explain.any.text\') | translate }}</span>--><!--</div>--><!--&lt;!&ndash;--><!--<div class="w3-text-grey" ng-switch--><!--on="itemVM.cartItem.recipient.deliveryMethodType">--><!--<span ng-switch-when="email">{{ (itemVM.cartItem.itemGiftCardId ? \'giftcards.delivery.email.customer\' : \'vouchers.delivery.email.customer\') | translate }}</span>--><!--<span ng-switch-when="post">{{ (itemVM.cartItem.itemGiftCardId ? \'giftcards.delivery.post.customer\' : \'vouchers.delivery.post.customer\') | translate }}</span>--><!--</div>--><!--&ndash;&gt;--><!--</div>--><!--<div class="col-xs-12 col-sm-6 col-md-12 col-lg-6 w3-padding">--><!--<input class="w3-radio" type="radio"--><!--id="item[{{itemVM.cartItem.uuid}}].deliveryPersonType.recipient"--><!--name="item[{{itemVM.cartItem.uuid}}].deliveryPersonType"--><!--ng-model="itemVM.cartItem.recipient.deliveryPersonType"--><!--value="recipient"--><!--ng-required="!itemVM.cartItem.recipient.deliveryPersonType">--><!--<label for="item[{{itemVM.cartItem.uuid}}].deliveryPersonType.recipient" translate="vouchers.delivery.person.recipient">Recipient</label>--><!--<div class="w3-text-grey">--><!--<span>{{ (itemVM.cartItem.itemGiftCardId ? \'giftcards.delivery.recipient.explain.any.text\' : \'vouchers.delivery.recipient.explain.any.text\') | translate }}</span>--><!--</div>--><!--&lt;!&ndash;<div class="w3-text-grey" ng-switch--><!--on="itemVM.cartItem.recipient.deliveryMethodType">--><!--<span ng-switch-when="email">{{ (itemVM.cartItem.itemGiftCardId ? \'giftcards.delivery.email.recipient\' : \'vouchers.delivery.email.recipient\') | translate }}</span>--><!--<span ng-switch-when="post">{{ (itemVM.cartItem.itemGiftCardId ? \'giftcards.delivery.post.recipient\' : \'vouchers.delivery.post.recipient\') | translate }}</span>--><!--</div>--><!--&ndash;&gt;--><!--</div>--><!--<div class="col-xs-12 w3-padding" ng-show="vm.checkoutFormInvalid && vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].deliveryPersonType\'].$invalid">--><!--<span class="w3-text-red" translate="vouchers.form.alert.deliveryperson">Please select who would you like to receive your gift voucher</span>--><!--</div>--><!--</div>--><!--<div class="row w3-padding" ng-show="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\'">--><!--<div class=" w3-padding" ng-class="(itemVM.configMap.disableDeliverToCustomer==\'true\') ? \'col-md-12\' : \'col-md-6 col-md-offset-6\'">--><!--<label ng-class="vm.checkoutFormInvalid--><!--&& (vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.email\'].$invalid--><!--|| vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.emailConfirm\'].$error.sameValue ) ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.email">Recipient Email</label>--><!--<input class="w3-input w3-pale-yellow" type="email"--><!--ng-model="itemVM.cartItem.recipient.email"--><!--name="item[{{itemVM.cartItem.uuid}}].recipient.email"--><!--ng-required="!itemVM.isBulk && itemVM.cartItem.recipient.deliveryPersonType==\'recipient\'">--><!--</div>--><!--<div class=" w3-padding" ng-class="(itemVM.configMap.disableDeliverToCustomer==\'true\') ? \'col-md-12\' : \'col-md-6 col-md-offset-6\'"--><!--ng-if="itemVM.configMap.emailConfirm==\'true\'">--><!--<label ng-class="vm.checkoutFormInvalid--><!--&& itemVM.cartItem.recipient.deliveryPersonType==\'recipient\'--><!--&& itemVM.cartItem.recipient.deliveryMethodType==\'email\'--><!--&& (vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.emailConfirm\'].$invalid || vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.emailConfirm\'].$error.sameValue) ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.emailconfirm">Confirm Recipient Email</label>--><!--<input class="w3-input w3-pale-yellow" type="email"--><!--ng-model="itemVM.cartItem.recipient.emailConfirm"--><!--name="item[{{itemVM.cartItem.uuid}}].recipient.emailConfirm"--><!--ng-required="!itemVM.isBulk && itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'email\'"--><!--same-value-required="!itemVM.isBulk && itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'email\'" same-value="itemVM.cartItem.recipient.email">--><!--</div>--><!--</div>--><!--<div class="row w3-padding" ng-show="itemVM.cartItem.recipient.deliveryMethodType==\'post\' && itemVM.cartItem.recipient.deliveryPersonType==\'recipient\'">--><!--<div class="col-md-12 w3-padding">--><!--<label ng-class="vm.checkoutFormInvalid && vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.address\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.address">Recipient Address</label>--><!--<input class="w3-input w3-pale-yellow" type="text" ng-maxlength="250"--><!--ng-model="itemVM.cartItem.recipient.address"--><!--name="item[{{itemVM.cartItem.uuid}}].recipient.address"--><!--ng-required="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'post\'" />--><!--</div>--><!--<div class="col-md-6 w3-padding">--><!--<label ng-class="vm.checkoutFormInvalid && vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.town\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.town">Recipient Town/City</label>--><!--<input class="w3-input w3-pale-yellow" type="text" ng-maxlength="50"--><!--ng-model="itemVM.cartItem.recipient.town"--><!--name="item[{{itemVM.cartItem.uuid}}].recipient.town"--><!--ng-required="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'post\'" />--><!--</div>--><!--<div class="col-md-6 w3-padding">--><!--<label ng-class="vm.checkoutFormInvalid && vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.county\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.county">Recipient County / State</label>--><!--<input class="w3-input w3-pale-yellow" type="text" ng-maxlength="50"--><!--ng-model="itemVM.cartItem.recipient.county"--><!--name="item[{{itemVM.cartItem.uuid}}].recipient.county"--><!--ng-required="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'post\'"--><!--&gt;--><!--</div>--><!--<div class="col-md-6 w3-padding">--><!--<label ng-class="vm.checkoutFormInvalid && vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.postcode\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.postcode">Recipient Postcode / Zip</label>--><!--<input class="w3-input w3-pale-yellow" type="text" ng-maxlength="20"--><!--ng-model="itemVM.cartItem.recipient.postcode"--><!--name="item[{{itemVM.cartItem.uuid}}].recipient.postcode"--><!--ng-required="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'post\' && itemVM.isPostCodeRequired"--><!--&gt;--><!--</div>--><!--<div class="col-md-6 w3-padding">--><!--<label ng-class="vm.checkoutFormInvalid && vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.country\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.country">Recipient Country</label>--><!--<select class="w3-select w3-pale-yellow" type="text"--><!--ng-model="itemVM.cartItem.recipient.country"--><!--name="item[{{itemVM.cartItem.uuid}}].recipient.country"--><!--ng-required="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'post\'"--><!--ng-options="o as o.countryName group by o.continentName for o in itemVM.selectCountry | orderBy:[\'priorityCountryIndex\',\'priorityGroupIndex\',\'continentName\',\'countryName\']"--><!--&gt;</select>--><!--</div>--><!--<div class="col-md-offset-6 col-md-6 w3-padding">--><!--<label ng-class="vm.checkoutFormInvalid && vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.phone\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.phone">Recipient Phone</label>--><!--<input class="w3-input w3-pale-yellow" type="text" ng-maxlength="50"--><!--ng-model="itemVM.cartItem.recipient.phone"--><!--name="item[{{itemVM.cartItem.uuid}}].recipient.phone"--><!--ng-required="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'post\'"--><!--&gt;--><!--</div>--><!--</div>--><!--<div class="row w3-padding" ng-show="(vm.checkoutFormInvalid--><!--&& (vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.email\'].$invalid--><!--|| vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.address\'].$invalid--><!--|| vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.town\'].$invalid--><!--|| vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.county\'].$invalid--><!--|| vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.postcode\'].$invalid--><!--|| vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.country\'].$invalid--><!--|| vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.phone\'].$invalid)--><!--)">--><!--<div class="col-xs-12 w3-padding">--><!--<span class="w3-text-red" translate="vouchers.form.alert.recipient">Please fill in required recipient details</span>--><!--</div>--><!--</div>--><!--<div class="row w3-padding" ng-if="itemVM.configMap.emailConfirm==\'true\'" ng-show="(vm.checkoutFormInvalid--><!--&& itemVM.cartItem.recipient.deliveryPersonType==\'recipient\'--><!--&& itemVM.cartItem.recipient.deliveryMethodType==\'email\'--><!--&& (vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.emailConfirm\'].$error.sameValue)--><!--)">--><!--<div class="col-xs-12 w3-padding">--><!--<span class="w3-text-red" translate="vouchers.form.alert.emailconfirm">Recipient email addresses do not match. Please review and correct.</span>--><!--</div>--><!--</div>--><!--<div class="row w3-padding" ng-show="!$first && itemVM.cartItem.recipient.deliveryPersonType==\'recipient\'">--><!--<div class="col-md-offset-6 col-md-6 w3-padding">--><!--<span class="w3-text-grey"><span class="glyphicon glyphicon-duplicate" aria-hidden="true"></span><a ng-click="itemVM.copyRecipientFromPrevious($event,$index)"> <span translate="vouchers.buttons.copy.recipient">Copy from previous item</span></a></span>--><!--<span ng-click="itemVM.openExplainCopyModal(\'lg\',\'.modal-parent\')" class="explain-icon glyphicon glyphicon-info-sign"></span>--><!--</div>--><!--</div>--><!--</div>--><!--<div style="border:none;padding: 0 16px 8px 16px" ng-show="!$first && (itemVM.configMap.customerIsRecipient==\'false\' || itemVM.configMap.disableRecipientMessage==\'false\' || itemVM.configMap.disableAmountVisibilityOption==\'false\')">--><!--<div class="" style="text-align: left;">--><!--<div class="" style="position: relative;">--><!--<span class="w3-text-grey"><span class="glyphicon glyphicon-duplicate" aria-hidden="true"></span><a style="text-decoration: underline;" ng-click="itemVM.copyDedicationFromPrevious($event,$index)"> <span translate="vouchers.buttons.copy.dedication">Copy from previous item</span></a></span>--><!--<span ng-click="itemVM.openExplainCopyModal(\'lg\',\'.modal-parent\')" class="explain-icon glyphicon glyphicon-info-sign"></span>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="w3-card-4 vobe-bg-customization-2-wrapper" ng-show="(itemVM.configMap.disableRecipientMessage==\'false\' || (itemVM.configMap.disableRecipientMessage==\'trueForPost\' && itemVM.cartItem.recipient.deliveryMethodType==\'email\') || (itemVM.configMap.disableRecipientMessage==\'trueForEmail\' && itemVM.cartItem.recipient.deliveryMethodType==\'post\'))">--><!--<div class="w3-padding vobe-bg-customization-2-h" style="text-align: left;">--><!--<div class="vobe-bg-customization-2-h-inner" ng-class="(vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.message\'].$valid--><!--) ? \'w3-border-light-green\' : \'w3-border-red\'" style="position: relative;">--><!--<span--><!--ng-class="(vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.message\'].$valid--><!--) ? \'w3-text-light-green\' : \'w3-text-red\'"--><!--class=" glyphicon glyphicon-ok-sign"></span> <span translate="vouchers.form.label.dedication">Dedication</span>--><!--<span ng-click="itemVM.openExplainDedicationModal(\'lg\',\'.modal-parent\')" class="explain-icon glyphicon glyphicon-info-sign"></span>--><!--</div>--><!--</div>--><!--<div class="row w3-padding">--><!--<div class="col-lg-12 w3-padding">--><!--<label>{{ (itemVM.cartItem.itemGiftCardId ? \'giftcards.form.label.message\' : \'vouchers.form.label.message\') | translate }}</label>--><!--<textarea maxlength="2000" class="w3-input w3-sand" style="resize: none"--><!--ng-model="itemVM.cartItem.recipient.message"--><!--name="item[{{itemVM.cartItem.uuid}}].recipient.message"--><!--&gt;</textarea>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="w3-card-4 vobe-bg-customization-2-wrapper" ng-show="itemVM.configMap.customerIsRecipient==\'false\'">--><!--<div class="w3-padding vobe-bg-customization-2-h" style="text-align: left;">--><!--<div class="vobe-bg-customization-2-h-inner" ng-class="(vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.firstName\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.lastName\'].$valid--><!--) ? \'w3-border-light-green\' : \'w3-border-red\'">--><!--<span--><!--ng-class="(vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.firstName\'].$valid--><!--&& vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.lastName\'].$valid--><!--) ? \'w3-text-light-green\' : \'w3-text-red\'"--><!--class=" glyphicon glyphicon-ok-sign"></span> <span translate="vouchers.form.label.recipient.details">Recipient details</span>--><!--</div>--><!--</div>--><!--<div class="row w3-padding">--><!--<div class="col-lg-6 w3-padding">--><!--<label ng-class="vm.checkoutFormInvalid && vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.firstName\'].$invalid ? \'w3-text-red\' : \'\'" translate="vouchers.form.label.recipient.firstname">--><!--Recipient First Name--><!--</label>--><!--<input class="w3-input w3-sand" type="text"--><!--ng-model="itemVM.cartItem.recipient.firstName"--><!--name="item[{{itemVM.cartItem.uuid}}].recipient.firstName"--><!--ng-required="itemVM.configMap.customerIsRecipient==\'false\'"/>--><!--</div>--><!--<div class="col-lg-6 w3-padding">--><!--<label ng-class="vm.checkoutFormInvalid && vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.lastName\'].$invalid ? \'w3-text-red\' : \'\'"--><!--translate="vouchers.form.label.recipient.lastname">Recipient Last Name</label>--><!--<input class="w3-input w3-sand" type="text"--><!--ng-model="itemVM.cartItem.recipient.lastName"--><!--name="item[{{itemVM.cartItem.uuid}}].recipient.lastName"--><!--ng-required="itemVM.configMap.customerIsRecipient==\'false\'" />--><!--</div>--><!--</div>--><!--</div>--><!--<div class="w3-card-4 vobe-bg-customization-2-wrapper" ng-show="itemVM.configMap.disableAmountVisibilityOption==\'false\'">--><!--<div class="w3-padding vobe-bg-customization-2-h" style="text-align: left;">--><!--<div class="vobe-bg-customization-2-h-inner" ng-class="(vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.showValue\'].$valid) ? \'w3-border-light-green\' : \'w3-border-red\'" style="position: relative;">--><!--<span--><!--ng-class="(vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.showValue\'].$valid) ? \'w3-text-light-green\' : \'w3-text-red\'"--><!--class="glyphicon glyphicon-ok-sign"></span> <span translate="vouchers.form.label.value.voucher">Voucher Value </span>--><!--<span ng-click="itemVM.openExplainValueModal(\'lg\',\'.modal-parent\')" class="explain-icon glyphicon glyphicon-info-sign"></span>--><!--</div>--><!--</div>--><!--<div class="row w3-padding">--><!--<div class="col-xs-12 col-sm-6 w3-padding">--><!--<input class="w3-radio" type="radio"--><!--ng-model="itemVM.cartItem.recipient.showValue"--><!--ng-required="itemVM.configMap.disableAmountVisibilityOption==\'false\'"--><!--name="item[{{itemVM.cartItem.uuid}}].recipient.showValue"--><!--id="item[{{itemVM.cartItem.uuid}}].recipient.hideValue"--><!--value="false">--><!--<label for="item[{{itemVM.cartItem.uuid}}].recipient.hideValue" translate="vouchers.form.label.value.hide">Do Not Show Amount</label>--><!--</div>--><!--<div class="col-xs-12 col-sm-6 w3-padding">--><!--<input class="w3-radio" type="radio"--><!--ng-model="itemVM.cartItem.recipient.showValue"--><!--ng-required="itemVM.configMap.disableAmountVisibilityOption==\'false\'"--><!--name="item[{{itemVM.cartItem.uuid}}].recipient.showValue"--><!--id="item[{{itemVM.cartItem.uuid}}].recipient.showValue"--><!--value="true">--><!--<label for="item[{{itemVM.cartItem.uuid}}].recipient.showValue" translate="vouchers.form.label.value.show">Show Amount</label> <span></span>--><!--</div>--><!--<div class="col-xs-12 w3-padding" ng-show="vm.checkoutFormInvalid && vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.showValue\'].$invalid">--><!--<span class="w3-text-red" translate="vouchers.form.alert.showvalue">Please select if would you like to display voucher monetary value on your gift voucher</span>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="w3-card-4 vobe-bg-customization-2-wrapper" ng-show="itemVM.configMap.showTAndC==\'true\'">--><!--<div class="w3-padding vobe-bg-customization-2-h" style="text-align: left;">--><!--<div class="vobe-bg-customization-2-h-inner" ng-class="vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].termsAgreed\'].$valid ? \'w3-border-light-green\' : \'w3-border-red\'">--><!--<span--><!--ng-class="vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].termsAgreed\'].$valid ? \'w3-text-light-green\' : \'w3-text-red\'"--><!--class="glyphicon glyphicon-ok-sign"></span> <span translate="vouchers.form.label.terms">Terms & Conditions</span>--><!--</div>--><!--</div>--><!--<div class="row w3-padding">--><!--<div class="col-xs-12 w3-padding">--><!--<input class="w3-checkbox" type="checkbox"--><!--name="item[{{itemVM.cartItem.uuid}}].termsAgreed"--><!--ng-model="itemVM.cartItem.termsAgreed"--><!--value="email"--><!--id="item[{{itemVM.cartItem.uuid}}].termsAgreed"--><!--ng-required="itemVM.configMap.showTAndC==\'true\' && !itemVM.cartItem.termsAgreed">--><!--&nbsp;<label for="item[{{itemVM.cartItem.uuid}}].termsAgreed" ng-class="vm.checkoutFormInvalid && vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].termsAgreed\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'"  translate="vouchers.form.label.termsagreed"> I agree to the Terms & Conditions</label>--><!--<span>--><!--</span>--><!--<a ng-show="itemVM.cartItem.recipient.deliveryMethodType" ui-sref="shopping-cart.terms({ uuid: itemVM.cartItem.uuid })" class="w3-margin-right w3-right w3-text-grey">--><!--<span class="glyphicon glyphicon-list-alt" aria-hidden="true"></span>--><!--<span translate="vouchers.form.label.termsread">Read Terms</span>--><!--</a>--><!--</div>--><!--<div class="col-xs-12 w3-padding" ng-show="vm.checkoutFormInvalid && vm.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].termsAgreed\'].$invalid">--><!--<span class="w3-text-red" translate="vouchers.form.alert.tandc">Please agree to Terms & Conditions</span>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--</div>--><!--</div>--><!--<div class="modal-parent" style="font-size:12px;">--><!--</div>-->');
$templateCache.put('app/site/shoppingcart/shopping-cart-preview.html','<div class="text-center" style="margin: 5px 0"><span class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-remove"></span> <span translate="vouchers.form.label.close">Close</span></span></div><div ng-include="vm.templatePreview"></div><div class="text-center" style="margin: 5px 0"><span class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-remove"></span> <span translate="vouchers.form.label.close">Close</span></span></div>');
$templateCache.put('app/site/shoppingcart/shopping-cart-summary-TGB.html','<div class="vobe-cart-summary-table w3-card-4 w3-white" ng-show="(itemVM.shoppingCart.shoppingCartItems && itemVM.shoppingCart.shoppingCartItems.items.length>0)"><div class="row w3-dark-gray text-uppercase font-weight-bold vobe-cart-summary-table-title hidden-xs hidden-sm visible-md visible-lg" style="padding-top:5px;padding-bottom:5px"><div class="col-xs-12 col-md-4" translate="shopping-cart.items.item">Item</div><div class="hidden-xs visible-md visible-lg col-md-1 col-lg-1"><span translate="shopping-cart.items.deliverymethod">Deliver By</span></div><div class="hidden-xs visible-md visible-lg col-md-1 col-lg-1"><span translate="shopping-cart.items.deliveryperson">Deliver To</span></div><div class="hidden-xs visible-md visible-lg col-md-1 vobe-text-right-md">&nbsp;<!--Currency--></div><div class="col-xs-9 col-md-2 vobe-text-right-md" translate="shopping-cart.items.value">Value</div><div class="col-xs-9 col-md-2 vobe-text-right-md" translate="shopping-cart.items.price">Price</div><div class="col-xs-3 col-md-1"></div></div><div class="row w3-text-black" ng-repeat="cartDiscount in itemVM.shoppingCart.shoppingCartDiscounts.discounts" ng-if="(cartDiscount.discountType==\'PROMO\' || cartDiscount.discountType==\'MERIT\') && !cartDiscount.automatic" style="padding-top:5px;padding-bottom:5px"><div class="col-xs-9 col-md-9 w3-text-green"><span><span translate="shopping-cart.headings.promotioncode">Promotion Code</span>: {{cartDiscount.code}}<span ng-if="cartDiscount.maxUsage>0 && cartDiscount.used>=cartDiscount.maxUsage"> (Limited Availability)</span></span></div><div class="col-xs-9 col-md-2 w3-text-green vobe-text-right-md"><span ng-show="cartDiscount.amountPercentage"><span style="unicode-bidi: bidi-override">-</span><span>{{cartDiscount.discountAmount}}</span><span style="unicode-bidi: plaintext">%</span> </span><span ng-show="!cartDiscount.amountPercentage">{{itemVM.currentCurrency && itemVM.currentCurrency.code ? itemVM.currentCurrency.code : itemVM.getAnyItemByPropertyId(cartDiscount.propertyId).owningProperty.propertyCurrency}} -<span>{{(cartDiscount.discountAmount | exchangenumber:itemVM.getAnyItemByPropertyId(cartDiscount.propertyId).owningProperty.propertyCurrency:itemVM.currentCurrency.code) | numberInteger}}</span><span class="w3-tiny">{{(cartDiscountdiscountAmount| exchangenumber:itemVM.getAnyItemByPropertyId(cartDiscount.propertyId).owningProperty.propertyCurrency:itemVM.currentCurrency.code) | numberFraction}}</span></span></div><div class="col-xs-3 col-md-1"><a ng-click="itemVM.removePromotionCode($event,cartDiscount.id)"><span class="glyphicon glyphicon-trash"></span></a></div></div><div class="vobe-cart-summary-scrollablex"><div class="row w3-text-dark-gray" ng-repeat="totalItem in itemVM.totals" style="padding-top:5px;padding-bottom:5px"><div class="col-xs-12 col-md-4 w3-text-black"><b>{{$index+1}}. {{totalItem.itemName}}</b></div><!-- vertical divs only for XS and SM--><div class="col-xs-9 col-sm-9 col-md-1 col-lg-1"><span class="text-small-xs hidden-md hidden-lg"><span style="float: none; display: inline-block;padding:0" class="col-xs-7"><span ng-show="totalItem.deliveryMethodType"><span translate="shopping-cart.items.deliverymethod">Deliver By</span>:</span></span></span><span class="text-small-xs"><span ng-show="totalItem.deliveryMethodType==\'post\'" translate="shopping-cart.items.delivery.post.name">Post</span><span ng-show="totalItem.deliveryMethodType==\'email\'" translate="shopping-cart.items.delivery.email.name">E-mail</span><span ng-show="totalItem.deliveryMethodType==\'collect\'" translate="shopping-cart.items.delivery.collect.name">Collection</span></span></div><div class="col-xs-9 col-sm-9 col-md-1 col-lg-1"><span class="text-small-xs hidden-md hidden-lg"><span style="float: none; display: inline-block;padding:0" class="col-xs-7"><span translate="shopping-cart.items.deliveryperson">Deliver To</span>:</span></span><span class="text-small-xs"><span ng-show="totalItem.deliveryPersonType!=\'recipient\'" translate="shopping-cart.items.delivery.person.customer">Me</span><span ng-show="totalItem.deliveryPersonType==\'recipient\'" translate="shopping-cart.items.delivery.person.recipient">Recipient</span></span></div><div class="hidden-xs visible-md visible-lg col-md-1 vobe-text-right-md">{{itemVM.currentCurrency && itemVM.currentCurrency.code ? itemVM.currentCurrency.code : totalItem.currency}}</div><!-- horizontal divs only for MD and LG--><div class="col-xs-9 col-sm-9 col-md-2 vobe-text-right-md"><span class="text-small-xs"><span class="col-xs-7 hidden-md hidden-lg" style="text-transform: uppercase;float: none; display: inline-block;padding:0"><span translate="shopping-cart.items.value">Value</span>:</span>{{totalItem.itemTotalPriceBeforeDiscount | exchangenumber:totalItem.currency:itemVM.currentCurrency.code:true}}</span></div><div class="col-xs-9 col-sm-9 col-md-2 vobe-text-right-md"><span class="text-small-xs"><span class="col-xs-7 hidden-md hidden-lg" style="text-transform: uppercase;float: none; display: inline-block;padding:0"><span translate="shopping-cart.items.price">Price</span>:</span>{{totalItem.itemTotalPrice | exchangenumber:totalItem.currency:itemVM.currentCurrency.code:true}}</span><span class="text-small-xs" style="white-space:nowrap"> &times; {{totalItem.items.length}}</span></div><div class="col-xs-3 col-md-1"><a ng-click="itemVM.removeItemFromCartAndRefreshByKey($event,totalItem.key)"><span class="glyphicon glyphicon-trash"></span></a></div></div></div><div ng-repeat="(totalPropertyId,totalShippingMapPerItemId) in itemVM.shoppingCart.shoppingCartItems.totalShippingListPerProperty"><div class="row w3-text-black text-uppercase" ng-repeat="(totalItemId,totalShippingObject) in totalShippingMapPerItemId" ng-if="totalShippingObject.total>0" style="padding-top:5px;padding-bottom:5px"><div class="col-xs-5 col-sm-5 col-md-6"><span class="text-small-xs"><span class="font-weight-bold"><span translate="shopping-cart.items.packaging" style="text-transform: uppercase">POSTAGE AND PACKAGING</span><span ng-if="totalItemId>0"> ({{itemVM.getAnyItemByPropertyIdAndItemId(totalPropertyId,totalItemId).itemName}})</span>:</span></span></div><div class="hidden-xs visible-md visible-lg col-md-1 vobe-text-right-md w3-border-top w3-border-dark-gray">{{itemVM.currentCurrency && itemVM.currentCurrency.code ? itemVM.currentCurrency.code : itemVM.getAnyItemByPropertyId(totalPropertyId).owningProperty.propertyCurrency}}</div><div class="col-xs-7 col-sm-7 col-md-4 vobe-text-right-md w3-border-top w3-border-dark-gray"><span class="text-small-xs"><span>{{ totalShippingObject.amountPerItem | exchangenumber:itemVM.getAnyItemByPropertyId(totalPropertyId).owningProperty.propertyCurrency:itemVM.currentCurrency.code:true}} <span style="white-space:nowrap">&times; {{ totalShippingObject.quantity}}</span></span></span></div></div></div><div class="row w3-text-black text-uppercase" ng-repeat="(totalPropertyId,totalObject) in itemVM.totalsPerPropertyInCurrentCurrency" ng-if="totalObject.serviceFee>0" style="padding-top:5px;padding-bottom:5px"><div class="col-xs-5 col-sm-5 col-md-6"><span class="text-small-xs"><span class="font-weight-bold"><span ng-if="itemVM.countPropertyIds()>1">{{totalObject.propertyName}}</span> <span translate="shopping-cart.items.servicefee">Service Fee</span>:</span></span></div><div class="hidden-xs visible-md visible-lg col-md-1 vobe-text-right-md w3-border-top w3-border-dark-gray">{{itemVM.currentCurrency && itemVM.currentCurrency.code ? itemVM.currentCurrency.code : itemVM.getAnyItemByPropertyId(totalPropertyId).owningProperty.propertyCurrency}}</div><div class="col-xs-7 col-sm-7 col-md-4 vobe-text-right-md w3-border-top w3-border-dark-gray"><span class="text-small-xs"><span>{{totalObject.serviceFee | exchangenumber:totalObject.currency:totalObject.currency:true}}</span></span></div></div><div class="row w3-text-black text-uppercase font-weight-bold" ng-repeat="(totalPropertyId,totalObject) in itemVM.totalsPerPropertyInCurrentCurrency" style="padding-top:5px;padding-bottom:5px"><div class="col-xs-5 col-sm-5 col-md-6"><span class="text-small-xs"><span><span ng-if="itemVM.countPropertyIds()>1">{{totalObject.propertyName}}</span> <span translate="shopping-cart.items.total">TOTAL</span></span></span></div><div class="hidden-xs visible-md visible-lg col-md-1 vobe-text-right-md w3-border-top w3-border-dark-gray">{{totalObject.currency}}</div><div class="col-xs-7 col-sm-7 col-md-4 vobe-text-right-md w3-border-top w3-border-dark-gray"><span class="text-small-xs"><span>{{(totalObject.itemTotalPrice+totalObject.totalShipping+totalObject.serviceFee ) | exchangenumber:totalObject.currency:totalObject.currency:true}}</span></span></div></div><div class="row w3-white text-uppercase font-weight-bold" ng-repeat="(totalPropertyId,totalObject) in itemVM.totalsPerPropertyInCurrentCurrency" ng-if="itemVM.shoppingCart.shoppingCartDiscounts.meritDiscountTotalPerProperty[totalPropertyId]" style="padding-top:5px;padding-bottom:5px"><div class="col-xs-5 col-sm-5 col-md-6 w3-text-green"><span ng-if="itemVM.countPropertyIds()>1">{{totalObject.propertyName}}</span> <span translate="shopping-cart.items.totalwithdiscount">TOTAL WITH DISCOUNT</span></div><div class="hidden-xs visible-md visible-lg col-md-1 vobe-text-right-md w3-border-top w3-border-dark-gray w3-text-green"><span>{{totalObject.currency}}</span></div><div class="col-xs-7 col-sm-7 col-md-4 vobe-text-right-md w3-border-top w3-border-dark-gray w3-text-green"><span>{{(totalObject.itemTotalPrice+totalObject.totalShipping+totalObject.serviceFee - itemVM.shoppingCart.shoppingCartDiscounts.meritDiscountTotalPerProperty[totalPropertyId]) | exchangenumber:totalObject.currency:totalObject.currency:true}}</span></div></div></div><form name="itemVM.promotionCodeForm" ng-show="itemVM.showPromoControls"><div class="row" style="padding-top: 15px"><div class="col-xs-12 col-md-3 col-md-offset-9"><input type="text" name="promotionCode" class="w3-input w3-left" ng-model="itemVM.promotionCode" placeholder="{{\'shopping-cart.headings.promotioncode\' | translate}}" style="outline: none"> <button type="button" class="w3-right w3-btn w3-small w3-grey apply-promo-btn-summary in1-button" ng-click="itemVM.addPromotionCode($event)" translate="shopping-cart.buttons.apply">Apply</button></div><div class="col-xs-12"><span class="help-block w3-text-red" ng-show="itemVM.promotionCodeForm.promotionCode.$error[\'error.promocodeinvalid\']" style="text-align: right" translate="vouchers.form.alert.promotioncode.invalid">Promotion code is invalid</span> <span class="help-block w3-text-red" ng-show="itemVM.promotionCodeForm.promotionCode.$error[\'error.promocodeexists\']" style="text-align: right" translate="vouchers.form.alert.promotioncode.alreadyapplied">Promotion code already applied</span></div></div></form>');
$templateCache.put('app/site/shoppingcart/shopping-cart-summary.html','<div class="vobe-cart-summary-table" style="font-size: smaller" ng-show="(itemVM.shoppingCart.shoppingCartItems && itemVM.shoppingCart.shoppingCartItems.items.length>0)"><div class="row vobe-cart-summary-table-flex-row"><div class="col-sm-12 col-lg-6" style="flex:1"><div class="w3-card-4 w3-light-gray" style="padding: 0px 15px;height: 100%"><div ng-repeat="totalItem in itemVM.totals"><div class="row w3-border-gray w3-border-bottom w3-light-gray" style="padding-top: 8px;padding-bottom: 8px"><div class="col-xs-10 col-sm-10 col-md-11"><span><b>{{$index+1}}. {{totalItem.itemName}}</b></span></div><div class="col-xs-2 col-sm-2 col-md-1" style="text-align: end"><a ng-click="itemVM.removeItemFromCartAndRefreshByKey($event,totalItem.key)"><span class="glyphicon glyphicon-trash"></span></a></div></div><div class="row w3-white w3-border-gray w3-border-bottom" style="padding-top: 8px;padding-bottom: 8px"><div class="col-xs-12 col-md-6"><span class="text-small-xs"><span class="col-xs-6" style="text-transform: uppercase;float: none; display: inline-block;padding:0"><span class="font-weight-bold" translate="shopping-cart.items.price">Price</span>:</span>{{itemVM.currentCurrency && itemVM.currentCurrency.code ? itemVM.currentCurrency.code : totalItem.currency}} {{totalItem.itemTotalPrice | exchangenumber:totalItem.currency:itemVM.currentCurrency.code:true}}</span><span class="text-small-xs" style="white-space:nowrap"> &times; {{totalItem.items.length}}</span></div><div class="col-xs-12 col-md-6"><span class="text-small-xs"><span class="col-xs-6" style="text-transform: uppercase;float: none; display: inline-block;padding:0"><span class="font-weight-bold" translate="shopping-cart.items.value">Value</span>:</span>{{itemVM.currentCurrency && itemVM.currentCurrency.code ? itemVM.currentCurrency.code : totalItem.currency}} {{totalItem.itemTotalPriceBeforeDiscount | exchangenumber:totalItem.currency:itemVM.currentCurrency.code:true}}</span></div><div class="col-xs-12 col-md-6"><span class="text-small-xs"><span style="float: none; display: inline-block;padding:0" class="col-xs-6"><span ng-show="totalItem.deliveryMethodType"><span class="font-weight-bold" translate="shopping-cart.items.deliverymethod">Deliver By</span>:</span></span></span><span class="text-small-xs"><span ng-show="totalItem.deliveryMethodType==\'post\'" translate="shopping-cart.items.delivery.post.name">Post</span><span ng-show="totalItem.deliveryMethodType==\'email\'" translate="shopping-cart.items.delivery.email.name">E-mail</span><span ng-show="totalItem.deliveryMethodType==\'collect\'" translate="shopping-cart.items.delivery.collect.name">Collection</span></span></div><div class="col-xs-12 col-md-6"><span class="text-small-xs"><span style="float: none; display: inline-block;padding:0" class="col-xs-6"><span class="font-weight-bold" translate="shopping-cart.items.deliveryperson">Deliver To</span>:</span></span><span class="text-small-xs"><span ng-show="totalItem.deliveryPersonType!=\'recipient\'" translate="shopping-cart.items.delivery.person.customer">Me</span><span ng-show="totalItem.deliveryPersonType==\'recipient\'" translate="shopping-cart.items.delivery.person.recipient">Recipient</span></span></div></div></div></div></div><div class="col-md-12 col-lg-6" style="flex:1"><div class="w3-card-4" style="padding: 15px 15px; height: 100%; display: flex; flex-direction: column; justify-content: space-between; background-color: #FFFFFF; border-radius: 6px"><!-- new P&P here --><div><div ng-repeat="totalItem in itemVM.totals" ng-if="totalItem.fulfillmentOptions && totalItem.fulfillmentOptions.length > 0"><div style="display: flex; justify-content: space-between; border-bottom: 1px dotted lightgrey"><div class="text-small-xs">{{itemVM.applyOnceShipping ? (\'shopping-cart.items.packaging\' | translate) : totalItem.itemName}}</div><div class="text-small-xs"><span>{{itemVM.applyOnceShipping ? 1 : totalItem.items.length}} &times;</span> <span>{{itemVM.currentCurrency && itemVM.currentCurrency.code ? itemVM.currentCurrency.code : totalItem.currency}} {{totalItem.fulfillmentOptionPrices[totalItem.fulfillmentId] | exchangenumber:totalItem.currency:itemVM.currentCurrency.code:true}}</span></div></div><div class="text-small-xs"><div ng-show="itemVM.paymentFormInvalid && itemVM.paymentForm[\'fulfillmentOptions[\'+totalItem.key+\']\'].$invalid"><span class="w3-text-red">Please select fulfillment option</span></div><div ng-repeat="fo in totalItem.fulfillmentOptions" ng-style="{\'margin-top\': $index == 0 ? \'5px\' : \'0px\'}"><input class="w3-radiox" type="radio" style="margin-left:4px; margin-right: 4px; vertical-align: top" name="fulfillmentOptions[{{totalItem.key}}]" id="fo[{{totalItem.key}}]_{{fo.id}}" ng-model="totalItem.fulfillmentId" ng-change="itemVM.updateShipping()" ng-value="fo.id" ng-required="true"><label for="fo[{{totalItem.key}}]_{{fo.id}}"><span>{{totalItem.fulfillmentOptionPrices[fo.id] | exchangenumber:totalItem.currency:itemVM.currentCurrency.code:true | currency: itemVM.currentCurrency.code+\' \' }} - {{itemVM.getFulfillmentNameInLang(fo)}}</span><span class="w3-text-grey w3-mobile" style="font-weight: normal"> {{itemVM.getFulfillmentDescriptionInLang(fo)}}</span></label></div></div></div></div><!-- promo --><div class="row w3-white w3-text-black" ng-repeat="cartDiscount in itemVM.shoppingCart.shoppingCartDiscounts.discounts" ng-if="(cartDiscount.discountType==\'PROMO\' || cartDiscount.discountType==\'MERIT\') && !cartDiscount.automatic" style="padding-top:8px;padding-bottom:8px"><div class="col-xs-6 col-md-7 w3-text-green"><span><span translate="shopping-cart.headings.promotioncode">Promotion Code</span>: {{cartDiscount.code}}<span ng-if="cartDiscount.maxUsage>0 && cartDiscount.used>=cartDiscount.maxUsage"> (Limited Availability)</span></span></div><div class="col-xs-4 col-md-3 w3-text-green"><span ng-show="cartDiscount.amountPercentage"><span style="unicode-bidi: bidi-override">-</span><span>{{cartDiscount.discountAmount}}</span><span style="unicode-bidi: plaintext">%</span> </span><span ng-show="!cartDiscount.amountPercentage">{{itemVM.currentCurrency && itemVM.currentCurrency.code ? itemVM.currentCurrency.code : itemVM.getAnyItemByPropertyId(cartDiscount.propertyId).owningProperty.propertyCurrency}} -<span>{{(cartDiscount.discountAmount | exchangenumber:itemVM.getAnyItemByPropertyId(cartDiscount.propertyId).owningProperty.propertyCurrency:itemVM.currentCurrency.code) | numberInteger}}</span><span class="w3-tiny">{{(cartDiscountdiscountAmount| exchangenumber:itemVM.getAnyItemByPropertyId(cartDiscount.propertyId).owningProperty.propertyCurrency:itemVM.currentCurrency.code) | numberFraction}}</span></span></div><div class="col-xs-2 col-md-2" style="text-align: end"><a ng-click="itemVM.removePromotionCode($event,cartDiscount.id)"><span class="glyphicon glyphicon-trash"></span></a></div></div><!-- SERVICE FEE --><div class="row w3-white w3-text-black text-uppercase" ng-repeat="(totalPropertyId,totalObject) in itemVM.totalsPerPropertyInCurrentCurrency" ng-if="totalObject.serviceFee>0" style="padding-top:8px;padding-bottom:8px"><div class="col-xs-6 col-md-7"><span class="text-small-xs"><span class="font-weight-bold"><span ng-if="itemVM.countPropertyIds()>1">{{totalObject.propertyName}}</span> <span translate="shopping-cart.items.servicefee">Service Fee</span>:</span></span></div><div class="col-xs-5 col-md-4 w3-border-topx w3-border-dark-grayx text-right"><div class="text-small-xs" style="display: flex; justify-content: space-between"><span>{{totalObject.currency}}</span> <span>{{totalObject.serviceFee | exchangenumber:totalObject.currency:totalObject.currency:true}}</span></div></div></div><div><!-- QUANTITY --><div ng-repeat="(totalPropertyId, totalObject) in itemVM.totalsPerPropertyInCurrentCurrency" class="shopping-cart-summary-total shopping-cart-summary-quantity"><div style="text-transform: uppercase"><span ng-if="itemVM.countPropertyIds()>1">{{totalObject.propertyName}} </span><span translate="shopping-cart.items.totalquantity">QTY</span></div><div>{{itemVM.shoppingCart.shoppingCartItems.items.length}}</div></div><!-- TOTAL --><div ng-repeat="(totalPropertyId, totalObject) in itemVM.totalsPerPropertyInCurrentCurrency" class="shopping-cart-summary-total"><div style="text-transform: uppercase"><span ng-if="itemVM.countPropertyIds()>1">{{totalObject.propertyName}} </span><span translate="shopping-cart.items.total">TOTAL</span></div><div>{{totalObject.currency}} {{(totalObject.itemTotalPrice + totalObject.totalShipping + totalObject.serviceFee) | exchangenumber:totalObject.currency:totalObject.currency:true}}</div></div><!-- meriot TOTAL --><div class="row w3-white text-uppercase font-weight-bold" ng-repeat="(totalPropertyId,totalObject) in itemVM.totalsPerPropertyInCurrentCurrency" ng-if="itemVM.shoppingCart.shoppingCartDiscounts.meritDiscountTotalPerProperty[totalPropertyId]" style="padding-top:8px;padding-bottom:8px"><div class="col-xs-6 col-md-7 w3-text-green"><span ng-if="itemVM.countPropertyIds()>1">{{totalObject.propertyName}}</span> <span translate="shopping-cart.items.totalwithdiscount">TOTAL WITH DISCOUNT</span></div><div class="col-xs-5 col-md-4 w3-text-green w3-border-topx w3-border-dark-grayx text-right"><div class="text-small-xs" style="display: flex; justify-content: space-between"><span>{{totalObject.currency}}</span> <span>{{(totalObject.itemTotalPrice + totalObject.totalShipping + totalObject.serviceFee - itemVM.shoppingCart.shoppingCartDiscounts.meritDiscountTotalPerProperty[totalPropertyId]) | exchangenumber:totalObject.currency:totalObject.currency:true}}</span></div></div></div></div></div></div></div></div><form name="itemVM.promotionCodeForm" ng-show="itemVM.showPromoControls"><div class="row" style="padding-top: 15px"><div class="col-xs-12 col-md-3 col-md-offset-9"><div class="input-group"><input type="text" name="promotionCode" class="w3-input w3-left" ng-model="itemVM.promotionCode" placeholder="{{\'shopping-cart.headings.promotioncode\' | translate}}"> <span class="input-group-btn"><button type="button" class="btn w3-button in1-button" ng-click="itemVM.addPromotionCode($event)" translate="shopping-cart.buttons.apply">Apply</button></span></div><!-- /input-group --></div><div class="col-xs-12"><span class="help-block w3-text-red" ng-show="itemVM.promotionCodeForm.promotionCode.$error[\'error.promocodeinvalid\']" style="text-align: right" translate="vouchers.form.alert.promotioncode.invalid">Promotion code is invalid</span> <span class="help-block w3-text-red" ng-show="itemVM.promotionCodeForm.promotionCode.$error[\'error.promocodeexists\']" style="text-align: right" translate="vouchers.form.alert.promotioncode.alreadyapplied">Promotion code already applied</span></div></div></form>');
$templateCache.put('app/site/shoppingcart/shopping-cart-terms-dialog.html','<div class="row"><span class="w3-border w3-padding w3-circle w3-white w3-border-dark-grey" ng-click="vm.clear()" ng-show="!vm.hideClear" style="outline: none; float: right; top: -15px; position: relative; z-index: 1000"><span class="w3-closebtn">&times;</span></span><div class="col-xs-12 w3-padding-large voucher-class-contrast" style="padding-top: 0px !important"><div class="w3-container"><p ng-bind-html="vm.terms.terms"></p></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/components/shopping-cart/currencyDropdown/currency-dropdown-button.html','<div class="btn-group" uib-dropdown ng-if="currencyVm.currencies && currencyVm.availableCurrencies && currencyVm.availableCurrencies.length>1"><button type="button" class="btn btn-xs w3-btn w3-small w3-white w3-text-grey" uib-dropdown-toggle><span><span class="glyphicon glyphicon-flag"></span> <span ng-if="currencyVm.currentCurrency"><span>{{currencyVm.currentCurrency.symbol}}</span> &bullet; <span>{{currencyVm.currentCurrency.code}}</span></span> <span ng-if="!currencyVm.currentCurrency"><span transte="global.menu.currency">Currency</span></span> </span><span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu ng-if="currencyVm.currencies"><li ng-class="{\'active\' : !currencyVm.currentCurrency}"><a ng-click="currencyVm.changeCurrency();vm.collapseNavbar();"><span transte="global.menu.default">Default</span></a></li><li active-menu="{{currency}}" ng-repeat="(currencyCode,currency) in currencyVm.currencies" ng-if="currencyVm.availableCurrencies.includes(currencyCode)"><a ng-click="currencyVm.changeCurrency(currency);vm.collapseNavbar();"><span style="display: inline-block;width: 50px">{{currency.symbol}}</span><span>{{currencyCode}}</span></a></li></ul></div>');
$templateCache.put('app/components/shopping-cart/currencyDropdown/currency-nav-dropdown.html','<ul class="nav navbar-nav navbar-right" ng-if="vm.currencies && vm.availableCurrencies && vm.availableCurrencies.length>1"><li class="dropdown pointer" uib-dropdown><a class="dropdown-toggle" uib-dropdown-toggle><span><span class="glyphicon glyphicon-credit-card"></span> <span ng-if="vm.currentCurrency"><span>{{vm.currentCurrency.symbol}}</span></span> <span ng-if="!vm.currentCurrency"><span transte="global.menu.currency">Currency</span></span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="vm.currencies"><li ng-class="{\'active\' : !vm.currentCurrency}"><a ng-click="vm.changeCurrency();vm.collapseWorldNavbar();"><span transte="global.menu.default">Default</span></a></li><li active-menu="{{currency}}" ng-repeat="(currencyCode,currency) in vm.currencies" ng-if="vm.availableCurrencies.includes(currencyCode)"><a ng-click="vm.changeCurrency(currency);vm.collapseWorldNavbar();"><span style="display: inline-block;width: 50px">{{currency.symbol}}</span><span>{{currencyCode}}</span></a></li></ul></li></ul>');
$templateCache.put('app/components/shopping-cart/item-details/shopping-cart-item-voucher.html','<div class="w3-card-2 w3-row vobe-bg-customization-2 w3-padding-16" style="margin-bottom: 40px"><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 vobe-bg-customization-1"><div class="row"><div class="col-xs-12"><div class="w3-container w3-center w3-bottombar vobe-bg-customization-header hide" style="padding: 4px 0px;text-transform: uppercase"><div class="col-xs-12"><span translate="vouchers.headings.item">ITEM</span> #{{itemVM.cartItemIndex+1}}</div></div></div></div><div class="row"><div class="col-xs-12"><div class="w3-ul"><!--\n\t\t\t\t\t<li class="w3-border-0 w3-light-grey ">\n\t\t\t\t\t\t<div class="row">\n\t\t\t\t\t\t\t<div class="col-xs-12">\n\t\t\t\t\t\t\t\t<a class="w3-small w3-padding w3-right" ng-click="itemVM.removeItemFromCartAndRefresh($event)"><span class="glyphicon glyphicon-trash" aria-hidden="true"></span> Remove</a>\n\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</li>\n\t\t\t\t\t --><div class="w3-border-0" style="padding: 0px;padding-bottom:8px"><div class="row w3-center hide"><div class="col-xs-12 col-lg-8"><span></span></div><div class="col-xs-6 col-lg-2"><span translate="vouchers.form.label.price">Price</span></div><div class="col-xs-6 col-lg-2"><span translate="vouchers.form.label.quantity">Qty</span></div></div><div class="row w3-center" style="padding-top:8px"><div class="col-xs-12 col-sm-6 col-md-12 tilesgrid-two"><div ng-if="!(itemVM.isBulk && itemVM.isRefundsContext) && itemVM.cartItem.itemImageFileName && !itemVM.cartItem.itemImageFileName.includes(\'no-image\')" class="voucher-bg-img" style="background-image:url(\'{{itemVM.cartItem.itemImageFileName}}?fit=crop&amp;h=405&amp;min-w=715&amp;crop=edges&amp;q=70&amp;auto=compress&amp;cs=strip\')" alt="{{itemVM.cartItem.owningProperty.propertyName}}"></div></div><div class="col-xs-12 col-sm-6 col-md-12"><div class="row"><div class="col-xs-12"><div class="vobe-bg-customization-descr"><div class="w3-container w3-center"><h3>{{itemVM.cartItem.itemName}}</h3><h6 style="text-transform: uppercase">{{itemVM.cartItem.owningProperty.propertyName}}</h6></div></div></div><div class="col-xs-12 col-md-6" ng-if="!itemVM.isBulk && (itemVM.cartItem.itemTotalPriceBeforeDiscount>itemVM.cartItem.itemTotalPrice || itemVM.channel==\'20\')"><div style="display: inline-block" class="w3-border-top w3-border-bottom w3-white w3-padding retail-price-item"><span ng-if="itemVM.channel!=\'20\'" translate="vouchers.headings.price.retail">Retail Value</span><span ng-if="itemVM.channel==\'20\'">Member Price</span>: {{itemVM.currentCurrency.code | currencySign}} {{(itemVM.cartItem.itemTotalPriceBeforeDiscount | exchangenumber:itemVM.baseCurrency.code:itemVM.currentCurrency.code:true)}} <span ng-if="itemVM.channel==\'20\'" translate="vouchers.headings.price.rewards">Rewards</span></div></div><div class="col-xs-12" ng-if="!itemVM.isBulk" ng-class="{\'col-md-6\' : (itemVM.cartItem.itemTotalPriceBeforeDiscount>itemVM.cartItem.itemTotalPrice || itemVM.channel==\'20\') }"><div><span>{{itemVM.currentCurrency.code }}</span> <span class="w3-xlarge">{{(itemVM.cartItem.itemTotalPrice | exchangenumber:itemVM.baseCurrency.code:itemVM.currentCurrency.code:true)}}</span><span> &times </span><span class="w3-xlarge">1</span></div></div><div class="col-xs-push-3 col-xs-6" ng-if="itemVM.isBulk">QUANTITY <span><input min="1" max="{{itemVM.configMap.maxBulkRows}}" class="w3-input w3-pale-yellow" type="number" ng-model="itemVM.cartItem.itemQuantity" name="item[bulk].itemQuantity" required="required"><div class="w3-padding" ng-show="itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].itemQuantity\'].$invalid"><span class="w3-text-red">Please select number between 1 and {{itemVM.configMap.maxBulkRows}}</span></div></span></div><div class="col-xs-12"><a class="visible-xs" ng-click="itemVM.isCollapsedDescr = !itemVM.isCollapsedDescr"><span translate="vouchers.form.label.description">Description</span> <span class="caret"></span></a><div class="vobe-bg-customization-descr collapse visible-sm visible-md visible-lg" uib-collapse="itemVM.isCollapsedDescr"><div class="w3-container w3-center"><p class="w3-smallx" ng-bind-html="itemVM.explicitlyTrustedItemDescription"></p></div></div></div></div></div></div></div><div class="w3-border-0" style="padding: 0px"><div class="row w3-padding" ng-show="itemVM.cartItem.recipient.deliveryMethodType==\'email\' && itemVM.emailConfigMap.emailPreview==\'true\'"><div class="col-xs-12 w3-right-alignx"><a style="margin-top: 5px; text-decoration: none;white-space: normal" class="btn-block w3-btn w3-border w3-light-grey w3-border-grey w3-round" ng-click="itemVM.previewVoucher()"><span class="glyphicon glyphicon-picture" aria-hidden="true"></span> <span translate="{{itemVM.translateContextType}}.form.label.emailpreview">Preview Voucher</span></a></div></div></div></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 vobe-bg-customization-2"><div class="row"><div class="col-xs-12"><div class="w3-container w3-center w3-bottombar vobe-bg-customization-header hide" style="padding: 4px 0px;text-transform: uppercase" translate="vouchers.headings.customization">CUSTOMIZATION</div></div></div><div class="row" ng-show="itemVM.hideCustomizationBox"><div class="col-xs-12" style="text-align: center;padding: 20px"><span class="glyphicon glyphicon-ok-circle" aria-hidden="true" style="text-align: center;font-size: 60px;color: #f1f1f1"></span></div></div><div class="row" ng-show="!itemVM.hideCustomizationBox"><!--<div class="col-lg-12">--><div class="w3-ul w3-padding-8"><!-- DELIVERY METHOD --><div class="w3-card-4 vobe-bg-customization-2-wrapper" ng-if="(itemVM.configMap.disableDeliveryMethod != \'true\')" style="margin-top: 8px"><div class="w3-padding vobe-bg-customization-2-h"><div class="vobe-bg-customization-2-h-inner" ng-class="itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].deliveryMethodType\'].$valid ? \'w3-border-light-green\' : \'w3-border-red\'"><span ng-class="itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].deliveryMethodType\'].$valid ? \'w3-text-light-green\' : \'w3-text-red\'" class="glyphicon glyphicon-ok-sign"></span> <span translate="vouchers.form.label.deliverymethod">Delivery Method</span></div></div><div class="row w3-padding"><div class="col-xs-12 col-sm-6 col-md-12 w3-padding" ng-if="itemVM.configMap.emailOption==\'true\'" ng-class="{\'col-lg-6\' : itemVM.deliveryOptionsCount==2,\'col-lg-4\' : itemVM.deliveryOptionsCount==3}"><input class="w3-radio" type="radio" name="item[{{itemVM.cartItem.uuid}}].deliveryMethodType" id="item[{{itemVM.cartItem.uuid}}].deliveryMethodTypeEmail" ng-model="itemVM.cartItem.recipient.deliveryMethodType" value="email" ng-required="!itemVM.cartItem.recipient.deliveryMethodType"><label for="item[{{itemVM.cartItem.uuid}}].deliveryMethodTypeEmail" translate="vouchers.delivery.email.name">E-mail</label><div class="w3-text-grey" ng-show="itemVM.channel!=20"><span translate="{{itemVM.translateContextType}}.delivery.email.explain.any.text"></span></div></div><div class="col-xs-12 col-sm-6 col-md-12 w3-padding" ng-if="itemVM.configMap.postalOption==\'true\'" ng-class="{\'col-lg-6\' : itemVM.deliveryOptionsCount==2,\'col-lg-4\' : itemVM.deliveryOptionsCount==3}"><input class="w3-radio" type="radio" name="item[{{itemVM.cartItem.uuid}}].deliveryMethodType" id="item[{{itemVM.cartItem.uuid}}].deliveryMethodTypePost" ng-model="itemVM.cartItem.recipient.deliveryMethodType" value="post" ng-required="!itemVM.cartItem.recipient.deliveryMethodType"><label for="item[{{itemVM.cartItem.uuid}}].deliveryMethodTypePost" translate="vouchers.delivery.post.name">Post</label><div class="w3-text-grey" ng-show="itemVM.channel!=20"><span>{{ (itemVM.cartItem.itemGiftCardId ? \'giftcards.delivery.post.explain.any.text\' : itemVM.translateContextType+\'.delivery.post.explain.any.text\') | translate }}</span></div></div><div class="col-xs-12 col-sm-6 col-md-12 w3-padding" ng-if="itemVM.configMap.collectOption==\'true\'" ng-class="{\'col-lg-6\' : itemVM.deliveryOptionsCount==2,\'col-lg-4\' : itemVM.deliveryOptionsCount==3}"><input class="w3-radio" type="radio" name="item[{{itemVM.cartItem.uuid}}].deliveryMethodType" id="item[{{itemVM.cartItem.uuid}}].deliveryMethodType" ng-model="itemVM.cartItem.recipient.deliveryMethodType" value="collect" ng-required="!itemVM.cartItem.recipient.deliveryMethodType"><label translate="vouchers.delivery.collect.name" for="item[{{itemVM.cartItem.uuid}}].deliveryMethodType">Click & Collect</label><div class="w3-text-grey" ng-show="itemVM.channel!=20"><span>{{ (\'vouchers.delivery.collect.explain.any.text\') | translate }}</span></div></div><div class="col-xs-12 w3-padding" ng-show="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].deliveryMethodType\'].$invalid"><span class="w3-text-red" translate="{{itemVM.translateContextType}}.form.alert.deliverymethod">Please select how would you like to receive your gift voucher</span></div></div></div><!-- COLLECTION DELIVERY INFO --><div class="w3-card-4 vobe-bg-customization-2-wrapper" ng-show="itemVM.configMap.showCollectionInfo==\'true\'"><div class="w3-padding vobe-bg-customization-2-h"><div class="vobe-bg-customization-2-h-inner w3-border-light-green" style="position: relative"><span class="glyphicon glyphicon-ok-sign w3-text-light-green"></span> <span translate="vouchers.delivery.collect.info">Collection Info</span></div></div><div class="row w3-padding"><div class="col-xs-12 w3-padding"><span ng-if="itemVM.cartItem.collectionDescription" ng-bind-html="itemVM.explicitlyTrustedItCollectionDescription"></span> <span ng-if="!itemVM.cartItem.collectionDescription">{{itemVM.property.hotelFullAddress}}</span></div></div></div><!-- DELIVERY PERSON --><div class="w3-card-4 vobe-bg-customization-2-wrapper" ng-if="(!itemVM.configMap.disableDeliverToCustomer || itemVM.configMap.disableDeliverToCustomer!=\'true\') && (!itemVM.configMap.disableDeliverToRecipient || itemVM.configMap.disableDeliverToRecipient!=\'true\')"><div class="w3-padding vobe-bg-customization-2-h"><div class="vobe-bg-customization-2-h-inner w3-border-light-green" style="position: relative"><span class="glyphicon glyphicon-ok-sign w3-text-light-green"></span> <span translate="{{itemVM.translateContextType}}.form.label.deliveryperson">Deliver To </span><span ng-click="itemVM.openExplainDeliveryModal(\'lg\',\'.modal-parent\')" class="w3-text-gray hide explain-icon glyphicon glyphicon-info-sign"></span></div></div><div class="row w3-padding" ng-class="(itemVM.configMap.disableDeliverToCustomer==\'true\' || itemVM.configMap.disableDeliverToRecipient==\'true\') ? \'hide\' : \'\'"><div class="col-xs-12 col-sm-6 col-md-12 col-lg-6 w3-padding" ng-show="itemVM.configMap.disableDeliverToCustomer==\'false\'"><input class="w3-radio" type="radio" id="item[{{itemVM.cartItem.uuid}}].deliveryPersonType.me" name="item[{{itemVM.cartItem.uuid}}].deliveryPersonType" ng-model="itemVM.cartItem.recipient.deliveryPersonType" value="customer" ng-change="itemVM.cartItem.recipient.email = \'\'" ng-required="!itemVM.cartItem.recipient.deliveryPersonType"><label for="item[{{itemVM.cartItem.uuid}}].deliveryPersonType.me" translate="{{itemVM.translateContextType}}.delivery.person.customer">Me</label><div class="w3-text-grey" ng-show="itemVM.channel!=20"><span ng-bind="(itemVM.cartItem.itemGiftCardId ? \'giftcards.delivery.customer.explain.any.text\' : \'vouchers.delivery.customer.explain.any.text\') | translate "></span></div><!--\n\t\t\t\t\t\t\t\t<div class="w3-text-grey" ng-switch\n\t\t\t\t\t\t\t\t\t on="itemVM.cartItem.recipient.deliveryMethodType">\n\t\t\t\t\t\t\t\t\t<span ng-switch-when="email">{{ (itemVM.cartItem.itemGiftCardId ? \'giftcards.delivery.email.customer\' : \'vouchers.delivery.email.customer\') | translate }}</span>\n\t\t\t\t\t\t\t\t\t<span ng-switch-when="post">{{ (itemVM.cartItem.itemGiftCardId ? \'giftcards.delivery.post.customer\' : \'vouchers.delivery.post.customer\') | translate }}</span>\n\t\t\t\t\t\t\t\t</div>\n                                --></div><div class="col-xs-12 col-sm-6 col-md-12 col-lg-6 w3-padding" ng-show="itemVM.configMap.disableDeliverToRecipient!=\'true\'"><input class="w3-radio" type="radio" id="item[{{itemVM.cartItem.uuid}}].deliveryPersonType.recipient" name="item[{{itemVM.cartItem.uuid}}].deliveryPersonType" ng-model="itemVM.cartItem.recipient.deliveryPersonType" value="recipient" ng-required="!itemVM.cartItem.recipient.deliveryPersonType"><label for="item[{{itemVM.cartItem.uuid}}].deliveryPersonType.recipient" translate="{{itemVM.translateContextType}}.delivery.person.recipient">Recipient</label><div class="w3-text-grey"><span>{{ (itemVM.cartItem.itemGiftCardId ? \'giftcards.delivery.recipient.explain.any.text\' : \'vouchers.delivery.recipient.explain.any.text\') | translate }}</span></div><!--<div class="w3-text-grey" ng-switch\n                                    on="itemVM.cartItem.recipient.deliveryMethodType">\n                                    <span ng-switch-when="email">{{ (itemVM.cartItem.itemGiftCardId ? \'giftcards.delivery.email.recipient\' : \'vouchers.delivery.email.recipient\') | translate }}</span>\n                                    <span ng-switch-when="post">{{ (itemVM.cartItem.itemGiftCardId ? \'giftcards.delivery.post.recipient\' : \'vouchers.delivery.post.recipient\') | translate }}</span>\n                                </div>\n                                --></div><div class="col-xs-12 w3-padding" ng-show="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].deliveryPersonType\'].$invalid"><span class="w3-text-red" translate="{{itemVM.translateContextType}}.form.alert.deliveryperson">Please select who would you like to receive your gift voucher</span></div></div></div><!-- RECIPIENT DETAILS --><div class="w3-card-4 vobe-bg-customization-2-wrapper" ng-show="!itemVM.configMap.disableRecipientDetails && itemVM.configMap.customerIsRecipient == \'false\'"><div class="w3-padding vobe-bg-customization-2-h"><div class="vobe-bg-customization-2-h-inner" ng-class="(itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.firstName\'].$valid\n\t\t\t\t\t\t\t\t\t&& itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.lastName\'].$valid\n\t\t\t\t\t\t\t\t\t) ? \'w3-border-light-green\' : \'w3-border-red\'" style="position: relative"><span ng-class="(itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.firstName\'].$valid\n\t\t\t\t\t\t\t\t\t&& itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.lastName\'].$valid\n\t\t\t\t\t\t\t\t\t) ? \'w3-text-light-green\' : \'w3-text-red\'" class="glyphicon glyphicon-ok-sign"></span> <span translate="vouchers.form.label.recipient.details">Recipient details</span> <span ng-click="itemVM.openExplainRecipientModal(\'lg\',\'.modal-parent\')" class="w3-text-gray explain-icon glyphicon glyphicon-info-sign"></span></div></div><div class="row w3-padding"><div class="col-lg-6 col-sm-6 w3-padding"><label ng-class="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.firstName\'].$invalid ? \'w3-text-red\' : \'\'" translate="vouchers.form.label.recipient.firstname">Recipient First Name</label><input class="w3-input w3-pale-yellow" type="text" ng-model="itemVM.cartItem.recipient.firstName" name="item[{{itemVM.cartItem.uuid}}].recipient.firstName" ng-required="!itemVM.configMap.disableRecipientDetails && itemVM.configMap.customerIsRecipient==\'false\'"></div><div class="col-lg-6 col-sm-6 w3-padding"><label ng-class="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.lastName\'].$invalid ? \'w3-text-red\' : \'\'" translate="vouchers.form.label.recipient.lastname">Recipient Last Name</label><input class="w3-input w3-pale-yellow" type="text" ng-model="itemVM.cartItem.recipient.lastName" name="item[{{itemVM.cartItem.uuid}}].recipient.lastName" ng-required="!itemVM.configMap.disableRecipientDetails && itemVM.configMap.customerIsRecipient==\'false\'"></div><!-- email --><div ng-show="!itemVM.configMap.disableRecipientDetails && itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType != \'post\'"><div class="w3-padding" ng-class="(itemVM.configMap.disableDeliverToCustomer==\'true\') ? \'col-md-12\' : \'col-md-6\'"><label ng-class="itemVM.checkoutFormInvalid\n\t\t\t\t\t\t\t\t&& (itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.email\'].$invalid\n\t\t\t\t\t\t\t\t|| itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.emailConfirm\'].$error.sameValue ) ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.email">Recipient Email</label><input class="w3-input w3-pale-yellow" type="email" ng-model="itemVM.cartItem.recipient.email" name="item[{{itemVM.cartItem.uuid}}].recipient.email" ng-required="!itemVM.configMap.disableRecipientDetails && itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'email\'"></div><div class="w3-padding" ng-class="(itemVM.configMap.disableDeliverToCustomer==\'true\') ? \'col-md-12\' : \'col-md-6\'" ng-if="itemVM.configMap.emailConfirm==\'true\'"><label ng-class="itemVM.checkoutFormInvalid\n\t\t\t\t\t\t\t\t&& itemVM.cartItem.recipient.deliveryPersonType==\'recipient\'\n\t\t\t\t\t\t\t\t&& itemVM.cartItem.recipient.deliveryMethodType==\'email\'\n\t\t\t\t\t\t\t\t&& (itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.emailConfirm\'].$invalid || itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.emailConfirm\'].$error.sameValue) ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.emailconfirm">Confirm Recipient Email</label><input class="w3-input w3-pale-yellow" type="email" ng-model="itemVM.cartItem.recipient.emailConfirm" name="item[{{itemVM.cartItem.uuid}}].recipient.emailConfirm" ng-required="!itemVM.configMap.disableRecipientDetails && itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'email\'" same-value-required="(!itemVM.configMap.disableRecipientDetails || itemVM.configMap.disableRecipientDetails!=\'true\') && itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'email\'" same-value="itemVM.cartItem.recipient.email"></div></div></div><div class="row w3-padding" ng-show="!itemVM.configMap.disableRecipientDetails && itemVM.cartItem.recipient.deliveryMethodType==\'post\' && itemVM.cartItem.recipient.deliveryPersonType==\'recipient\'"><div class="col-md-12 w3-padding"><label ng-class="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.address\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.address">Recipient Address</label><input class="w3-input w3-pale-yellow" type="text" ng-maxlength="250" ng-model="itemVM.cartItem.recipient.address" name="item[{{itemVM.cartItem.uuid}}].recipient.address" ng-required="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'post\'"></div><div class="col-md-6 w3-padding"><label ng-class="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.town\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.town">Recipient Town/City</label><input class="w3-input w3-pale-yellow" type="text" ng-maxlength="50" ng-model="itemVM.cartItem.recipient.town" name="item[{{itemVM.cartItem.uuid}}].recipient.town" ng-required="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'post\'"></div><div class="col-md-6 w3-padding"><label ng-class="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.county\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.county">Recipient County / State</label><input class="w3-input w3-pale-yellow" type="text" ng-maxlength="50" ng-model="itemVM.cartItem.recipient.county" name="item[{{itemVM.cartItem.uuid}}].recipient.county" ng-required="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'post\'"></div><div class="col-md-6 w3-padding"><label ng-class="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.postcode\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.postcode">Recipient Postcode / Zip</label><input class="w3-input w3-pale-yellow" type="text" ng-maxlength="20" ng-model="itemVM.cartItem.recipient.postcode" name="item[{{itemVM.cartItem.uuid}}].recipient.postcode" ng-required="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'post\' && itemVM.isPostCodeRequired"></div><div class="col-md-6 w3-padding"><label ng-class="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.country\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.country">Recipient Country</label><select class="w3-select w3-pale-yellow" type="text" ng-model="itemVM.cartItem.recipient.country" name="item[{{itemVM.cartItem.uuid}}].recipient.country" ng-required="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'post\'" ng-options="o as o.countryName group by o.continentName for o in itemVM.selectCountry | orderBy:[\'priorityCountryIndex\',\'priorityGroupIndex\',\'continentName\',\'countryName\']"></select></div><div class="col-md-offset-6 col-md-6 w3-padding"><label ng-class="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.phone\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.phone">Recipient Phone</label><input class="w3-input w3-pale-yellow" type="text" ng-maxlength="50" ng-model="itemVM.cartItem.recipient.phone" name="item[{{itemVM.cartItem.uuid}}].recipient.phone" ng-required="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.deliveryMethodType==\'post\'"></div></div><div class="row w3-padding" ng-show="(itemVM.checkoutFormInvalid\n\t\t\t\t\t\t\t    && (itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.email\'].$invalid\n\t\t\t\t\t\t\t\t|| itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.address\'].$invalid\n\t\t\t\t\t\t\t\t|| itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.town\'].$invalid\n\t\t\t\t\t\t\t\t|| itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.county\'].$invalid\n\t\t\t\t\t\t\t\t|| itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.postcode\'].$invalid\n\t\t\t\t\t\t\t\t|| itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.country\'].$invalid\n\t\t\t\t\t\t\t\t|| itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.phone\'].$invalid)\n\t\t\t\t\t\t\t\t)"><div class="col-xs-12 w3-padding"><span class="w3-text-red" translate="vouchers.form.alert.recipient">Please fill in required recipient details</span></div></div><div class="row w3-padding" ng-if="itemVM.configMap.emailConfirm==\'true\'" ng-show="(itemVM.checkoutFormInvalid\n\t\t\t\t\t\t        && itemVM.cartItem.recipient.deliveryPersonType==\'recipient\'\n\t\t\t\t\t\t        && itemVM.cartItem.recipient.deliveryMethodType==\'email\'\n\t\t\t\t\t\t\t    && (itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.emailConfirm\'].$error.sameValue)\n\t\t\t\t\t\t\t\t)"><div class="col-xs-12 w3-padding"><span class="w3-text-red" translate="vouchers.form.alert.emailconfirm">Recipient email addresses do not match. Please review and correct.</span></div></div><div class="row w3-padding" ng-show="!itemVM.cartItemFirst && itemVM.cartItem.recipient.deliveryPersonType==\'recipient\'"><div class="col-md-offset-6 col-md-6 w3-padding"><span class="w3-text-grey"><span class="glyphicon glyphicon-import" aria-hidden="true"></span><a ng-click="itemVM.copyRecipientFromPrevious($event,itemVM.cartItemIndex)"> <span translate="vouchers.buttons.copy.recipient">Copy from previous item</span></a></span> <span ng-click="itemVM.openExplainCopyModal(\'lg\',\'.modal-parent\')" class="w3-text-gray explain-icon glyphicon glyphicon-info-sign"></span></div></div></div><!-- DEDICATION --><div class="w3-card-4 vobe-bg-customization-2-wrapper" ng-show="(itemVM.configMap.disableRecipientMessage==\'false\' || (itemVM.configMap.disableRecipientMessage==\'trueForPost\' && itemVM.cartItem.recipient.deliveryMethodType==\'email\') || (itemVM.configMap.disableRecipientMessage==\'trueForEmail\' && itemVM.cartItem.recipient.deliveryMethodType==\'post\'))"><div class="w3-padding vobe-bg-customization-2-h"><div class="vobe-bg-customization-2-h-inner" ng-class="(itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.message\'].$valid\n\t\t\t\t\t\t\t\t\t) ? \'w3-border-light-green\' : \'w3-border-red\'" style="position: relative"><span ng-class="(itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.message\'].$valid\n\t\t\t\t\t\t\t\t\t) ? \'w3-text-light-green\' : \'w3-text-red\'" class="glyphicon glyphicon-ok-sign"></span> <span translate="{{itemVM.translateContextType}}.form.label.dedication">Dedication</span> <span ng-click="itemVM.openExplainDedicationModal(\'lg\',\'.modal-parent\')" class="w3-text-gray explain-icon glyphicon glyphicon-info-sign"></span></div></div><div class="row w3-padding"><div class="col-xs-12" style="padding: 15px; position: relative" ng-show="!itemVM.cartItemFirst && (itemVM.configMap.customerIsRecipient==\'false\' || itemVM.configMap.disableRecipientMessage==\'false\' || itemVM.configMap.disableAmountVisibilityOption==\'false\')"><div class="text-left"><div class=""><span class="w3-text-grey"><span class="glyphicon glyphicon-import" aria-hidden="true"></span><a style="text-decoration: underline" ng-click="itemVM.copyDedicationFromPrevious($event,itemVM.cartItemIndex)"> <span translate="vouchers.buttons.copy.dedication">Copy from previous item</span></a></span> <span ng-click="itemVM.openExplainCopyModal(\'lg\',\'.modal-parent\')" class="w3-text-gray explain-icon glyphicon glyphicon-info-sign"></span></div></div></div><div class="col-xs-12 col-sm-6 w3-padding" ng-if="itemVM.configMap.displayInformalDedication" ng-show="false"><label ng-class="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.dedicationTo\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'">To</label><input class="w3-input w3-pale-yellow" type="text" ng-maxlength="50" ng-model="itemVM.cartItem.recipient.dedicationTo" name="item[{{itemVM.cartItem.uuid}}].recipient.dedicationTo"></div><div class="col-xs-12 col-sm-6 w3-padding" ng-if="itemVM.configMap.displayInformalDedication" ng-show="false"><label ng-class="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.dedicationFrom\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'">From</label><input class="w3-input w3-pale-yellow" type="text" ng-maxlength="50" ng-model="itemVM.cartItem.recipient.dedicationFrom" name="item[{{itemVM.cartItem.uuid}}].recipient.dedicationFrom"></div><div class="col-xs-12 w3-padding"><label ng-class="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.message\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'">Message</label><textarea ng-maxlength="itemVM.configMap.dedicationMessageLength" maxlength="{{itemVM.configMap.dedicationMessageLength}}" class="w3-input w3-pale-yellow" style="resize: none; height: 100px" ng-model="itemVM.cartItem.recipient.message" name="item[{{itemVM.cartItem.uuid}}].recipient.message" id="item[{{itemVM.cartItem.uuid}}].recipient.message"></textarea><span style="display: inline-block; padding-top: 5px" ng-if="itemVM.configMap.dedicationMessageLength != 2000">{{itemVM.configMap.dedicationMessageLength - itemVM.cartItem.recipient.message.length}} characters remaining</span></div></div></div><!-- DELIVERY DATE --><div class="w3-card-4 vobe-bg-customization-2-wrapper" ng-if="itemVM.configMap.disableScheduledDelivery==\'false\'"><div class="w3-padding vobe-bg-customization-2-h"><div class="vobe-bg-customization-2-h-inner" ng-class="(\n                            itemVM.configMap.disableScheduledDelivery==\'false\' &&\n                            (itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.scheduledDate\'].$invalid ||\n                            itemVM.scheduledDeliveryData.scheduledTime.$invalid)\n                            ) ? \'w3-border-red\' : \'w3-border-light-green\'" style="position: relative"><span ng-class="(\n                            itemVM.configMap.disableScheduledDelivery==\'false\' &&\n                            (itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.scheduledDate\'].$invalid ||\n                            itemVM.scheduledDeliveryData.scheduledTime.$invalid)\n                            ) ? \'w3-text-red\' : \'w3-text-light-green\'" class="glyphicon glyphicon-ok-sign"></span> <span translate="{{itemVM.translateContextType}}.form.label.value.scheduledDelivery">Delivery Date</span> <span class="w3-text-light-green" style="font-style: italic" ng-show="itemVM.cartItem.recipient.deliveryPersonType!=\'recipient\'" translate="{{itemVM.translateContextType}}.form.label.value.scheduledDeliveryNow">Now</span> <span ng-click="itemVM.openExplainScheduledLaterModal(\'lg\',\'.modal-parent\')" class="w3-text-gray explain-icon glyphicon glyphicon-info-sign"></span></div></div><div class="row w3-padding" ng-show="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\'"><div class="col-xs-12 col-sm-6 w3-padding"><input class="w3-radio" type="radio" ng-model="itemVM.cartItem.recipient.scheduledDelivery" name="item[{{itemVM.cartItem.uuid}}].recipient.scheduledDelivery" id="item[{{itemVM.cartItem.uuid}}].recipient.scheduledDeliveryNow" ng-required="!itemVM.cartItem.recipient.scheduledDelivery" value="now"><label for="item[{{itemVM.cartItem.uuid}}].recipient.scheduledDeliveryNow" translate="{{itemVM.translateContextType}}.form.label.value.scheduledDeliveryNow">Now</label><div class="w3-text-grey"><span>{{ (itemVM.translateContextType+\'.delivery.schedule.now.explain.email.text\') | translate }}</span></div></div><div class="col-xs-12 col-sm-6 w3-padding"><input class="w3-radio" type="radio" ng-model="itemVM.cartItem.recipient.scheduledDelivery" ng-disabled="itemVM.cartItem.recipient.deliveryPersonType!=\'recipient\'" name="item[{{itemVM.cartItem.uuid}}].recipient.scheduledDelivery" id="item[{{itemVM.cartItem.uuid}}].recipient.scheduledDeliveryLater" ng-required="!itemVM.cartItem.recipient.scheduledDelivery" value="later"><label for="item[{{itemVM.cartItem.uuid}}].recipient.scheduledDeliveryLater" translate="{{itemVM.translateContextType}}.form.label.value.scheduledDeliveryLater">Later</label><span></span><div class="w3-text-grey"><span>{{ (itemVM.translateContextType+\'.delivery.schedule.later.explain.email.text\') | translate }}</span></div></div><div class="col-xs-12 w3-padding" ng-show="(\n                            itemVM.configMap.disableScheduledDelivery==\'false\' &&\n                            (itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.scheduledDelivery\'].$invalid))"><span class="w3-text-red" translate="{{itemVM.translateContextType}}.form.alert.scheduledDelivery">Please select if would you like to deliver voucher now or later.</span></div></div><div class="row w3-padding vobe-schedule-box" ng-show="itemVM.cartItem.recipient.deliveryPersonType==\'recipient\' && itemVM.cartItem.recipient.scheduledDelivery==\'later\'"><div class="w3-padding col-xs-12 col-sm-6"><label ng-class="itemVM.checkoutFormInvalid &&\n\t\t\t\t\t\t\t\t(itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.scheduledDate\'].$invalid ) ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.scheduledDateTime" style="padding-top:5px;padding-bottom: 4px">Date & Time</label><div class="col-xs-12 w3-padding" ng-show="(\n                                    itemVM.configMap.disableScheduledDelivery==\'false\' &&\n                                    (itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.scheduledDate\'].$invalid ||\n                                    itemVM.scheduledDeliveryData.scheduledTime.$invalid))"><span class="w3-text-red" translate="{{itemVM.translateContextType}}.form.alert.scheduledDeliveryDate">Please select valid date and time.</span></div><div class="clearfix"></div><div class="" style="position:relative"><input type="text" class="w3-input w3-pale-yellow" uib-datepicker-popup="dd-MMMM-yyyy" ng-model="itemVM.scheduledDeliveryData.scheduledDate" name="item[{{itemVM.cartItem.uuid}}].recipient.scheduledDate" is-open="itemVM.scheduledDateOpen" datepicker-options="itemVM.scheduledDeliveryData.scheduledDatePickerOptions" ng-required="itemVM.cartItem.recipient.scheduledDelivery==\'later\'" close-text="Close" style=""> <span class="vobe-schedule-icon w3-border"><button type="button" class="w3-input w3-pale-yellow" ng-click="itemVM.scheduledDateOpen=true" style="padding-bottom: 5px"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="w3-padding col-xs-12 col-sm-6"><div uib-timepicker ng-model="itemVM.scheduledDeliveryData.scheduledTime" hour-step="\'1\'" minute-step="\'30\'" show-meridian="null" readonly-input="true" template-url="app/components/shopping-cart/item-details/timepicker.html"></div></div><div class="clearfix"></div><div class="col-lg-12"><label ng-class="itemVM.checkoutFormInvalid\n\t\t\t\t\t\t\t\t&& (itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.scheduledZone\'].$invalid || itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.scheduledZone\'].$invalid ) ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.recipient.scheduledZone" style="padding-top:5px;padding-bottom: 4px">Zone</label><select class="w3-select w3-pale-yellow" type="text" ng-model="itemVM.scheduledDeliveryData.scheduledZone" name="item[{{itemVM.cartItem.uuid}}].recipient.scheduledZone" ng-options="o as o.display group by o.continentKey for o in itemVM.zones | orderBy:[\'continentKey\',\'display\']"></select></div></div></div><!-- SHOW VALUE --><div class="w3-card-4 vobe-bg-customization-2-wrapper" ng-show="itemVM.configMap.displayShowValue === \'ENABLE\'"><div class="w3-padding vobe-bg-customization-2-h"><div class="vobe-bg-customization-2-h-inner" ng-class="(itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.showValue\'].$valid) ? \'w3-border-light-green\' : \'w3-border-red\'" style="position: relative"><span ng-class="(itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.showValue\'].$valid) ? \'w3-text-light-green\' : \'w3-text-red\'" class="glyphicon glyphicon-ok-sign"></span> <span translate="{{itemVM.translateContextType}}.form.label.value.voucher">Voucher Value </span><span ng-click="itemVM.openExplainValueModal(\'lg\',\'.modal-parent\')" class="w3-text-gray explain-icon glyphicon glyphicon-info-sign"></span></div></div><div class="row w3-padding"><div class="col-xs-12 col-sm-6 w3-padding"><input class="w3-radio" type="radio" ng-model="itemVM.cartItem.recipient.showValue" ng-required="itemVM.configMap.displayShowValue===\'ENABLE\'" name="item[{{itemVM.cartItem.uuid}}].recipient.showValue" id="item[{{itemVM.cartItem.uuid}}].recipient.hideValue" value="false"><label for="item[{{itemVM.cartItem.uuid}}].recipient.hideValue" translate="{{itemVM.translateContextType}}.form.label.value.hide">Do Not Show Amount</label></div><div class="col-xs-12 col-sm-6 w3-padding"><input class="w3-radio" type="radio" ng-model="itemVM.cartItem.recipient.showValue" ng-required="itemVM.configMap.displayShowValue===\'ENABLE\'" name="item[{{itemVM.cartItem.uuid}}].recipient.showValue" id="item[{{itemVM.cartItem.uuid}}].recipient.showValue" value="true"><label for="item[{{itemVM.cartItem.uuid}}].recipient.showValue" translate="{{itemVM.translateContextType}}.form.label.value.show">Show Amount</label><span></span></div><div class="col-xs-12 w3-padding" ng-show="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.showValue\'].$invalid"><span class="w3-text-red" translate="{{itemVM.translateContextType}}.form.alert.showvalue">Please select if would you like to display voucher monetary value on your gift voucher</span></div></div></div><!-- COMMENT --><div class="w3-card-4 vobe-bg-customization-2-wrapper" ng-show="(itemVM.configMap.enableComment==\'true\')"><div class="w3-padding vobe-bg-customization-2-h"><div class="vobe-bg-customization-2-h-inner" ng-class="(itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.comment\'].$valid\n\t\t\t\t\t\t\t\t\t) ? \'w3-border-light-green\' : \'w3-border-red\'" style="position: relative"><span ng-class="(itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].recipient.comment\'].$valid\n\t\t\t\t\t\t\t\t\t) ? \'w3-text-light-green\' : \'w3-text-red\'" class="glyphicon glyphicon-ok-sign"></span> <span translate="vouchers.form.label.comment">Comment</span></div></div><div class="row w3-padding"><div class="col-xs-12 w3-padding"><label translate="vouchers.form.label.comment">Comment</label><textarea maxlength="500" class="w3-input w3-pale-yellow" style="resize: none" ng-model="itemVM.cartItem.recipient.comment" name="item[{{itemVM.cartItem.uuid}}].recipient.comment"></textarea></div></div></div><!-- TERMS --><div class="w3-card-4 vobe-bg-customization-2-wrapper" ng-show="itemVM.configMap.showTAndC==\'true\'"><div class="w3-padding vobe-bg-customization-2-h"><div class="vobe-bg-customization-2-h-inner" ng-class="itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].termsAgreed\'].$valid ? \'w3-border-light-green\' : \'w3-border-red\'"><span ng-class="itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].termsAgreed\'].$valid ? \'w3-text-light-green\' : \'w3-text-red\'" class="glyphicon glyphicon-ok-sign"></span> <span translate="vouchers.form.label.terms">Terms & Conditions</span></div></div><div class="row w3-padding"><div class="col-xs-12 w3-padding"><input class="w3-checkbox" type="checkbox" name="item[{{itemVM.cartItem.uuid}}].termsAgreed" ng-model="itemVM.cartItem.termsAgreed" value="email" id="item[{{itemVM.cartItem.uuid}}].termsAgreed" ng-required="itemVM.configMap.showTAndC==\'true\' && !itemVM.cartItem.termsAgreed"> &nbsp;<label for="item[{{itemVM.cartItem.uuid}}].termsAgreed" ng-class="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].termsAgreed\'].$invalid ? \'w3-text-red\' : \'w3-text-dark-grey\'" translate="vouchers.form.label.termsagreed">I agree to the Terms & Conditions</label><span></span> <a ng-if="!itemVM.isBulk" ng-show="itemVM.cartItem.recipient.deliveryMethodType" ui-sref="shopping-cart.terms({ uuid: itemVM.cartItem.uuid })" class="w3-margin-right w3-right w3-text-grey"><span class="glyphicon glyphicon-list-alt" aria-hidden="true"></span> <span translate="vouchers.form.label.termsread">Read Terms</span> </a><a ng-if="itemVM.isBulk" ng-show="itemVM.cartItem.recipient.deliveryMethodType" ui-sref="bulk-add.terms({ templateItem: itemVM.cartItem })" class="w3-margin-right w3-right w3-text-grey"><span class="glyphicon glyphicon-list-alt" aria-hidden="true"></span> <span translate="vouchers.form.label.termsread">Read Terms</span></a></div><div class="col-xs-12 w3-padding" ng-show="itemVM.checkoutFormInvalid && itemVM.checkoutForm[\'item[\'+itemVM.cartItem.uuid+\'].termsAgreed\'].$invalid"><span class="w3-text-red" translate="vouchers.form.alert.tandc">Please agree to Terms & Conditions</span></div></div></div><!-- BULK REFUND INSTRUCTION --><div class="w3-card-4 vobe-bg-customization-2-wrapper" ng-if="itemVM.isBulk && itemVM.isRefundsContext"><div class="w3-padding vobe-bg-customization-2-h"><div class="vobe-bg-customization-2-h-inner w3-border-light-green"><span translate="vouchers.bulk.info.heading">Refund Voucher Help</span></div></div><div class="row"><div class="col-xs-12w3-small"><p ng-bind-html="\'vouchers.bulk.info.text\' | translate:{maxBulkRows:itemVM.configMap.maxBulkRows} | trustHtml" style="max-height: 200px;overflow-x: auto;margin-top:0px !important"></p></div></div></div></div><!--</div>--></div></div></div><div class="modal-parent"></div>');
$templateCache.put('app/components/shopping-cart/item-details/timepicker.html','<table class="uib-timepicker"><tbody><tr class="text-center" ng-show="::showSpinners"><td class="uib-increment hours"><a ng-click="incrementHours()" ng-class="{disabled: noIncrementHours()}" class="btn btn-link" ng-disabled="noIncrementHours()" tabindex="-1"><span class="glyphicon glyphicon-plus"></span></a></td><td>&nbsp;</td><td class="uib-increment minutes"><a ng-click="incrementMinutes()" ng-class="{disabled: noIncrementMinutes()}" class="btn btn-link" ng-disabled="noIncrementMinutes()" tabindex="-1"><span class="glyphicon glyphicon-plus"></span></a></td><td ng-show="showSeconds">&nbsp;</td><td ng-show="showSeconds" class="uib-increment seconds"><a ng-click="incrementSeconds()" ng-class="{disabled: noIncrementSeconds()}" class="btn btn-link" ng-disabled="noIncrementSeconds()" tabindex="-1"><span class="glyphicon glyphicon-plus"></span></a></td><td ng-show="showMeridian"></td></tr><tr><td class="form-group uib-time hours" ng-class="{\'has-error\': invalidHours}"><input type="text" placeholder="HH" ng-model="hours" ng-change="updateHours()" class="w3-input w3-pale-yellow text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementHours()" ng-blur="blur()"></td><td class="uib-separator">:</td><td class="form-group uib-time minutes" ng-class="{\'has-error\': invalidMinutes}"><input type="text" placeholder="MM" ng-model="minutes" ng-change="updateMinutes()" class="w3-input w3-pale-yellow text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementMinutes()" ng-blur="blur()"></td><td ng-show="showSeconds" class="uib-separator">:</td><td class="form-group uib-time seconds" ng-class="{\'has-error\': invalidSeconds}" ng-show="showSeconds"><input type="text" placeholder="SS" ng-model="seconds" ng-change="updateSeconds()" class="w3-input w3-pale-yellow text-center" ng-readonly="readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementSeconds()" ng-blur="blur()"></td><td ng-show="showMeridian" class="uib-time am-pm"><button type="button" ng-class="{disabled: noToggleMeridian()}" class="btn btn-default text-center" ng-click="toggleMeridian()" ng-disabled="noToggleMeridian()" tabindex="{{::tabindex}}">{{meridian}}</button></td></tr><tr class="text-center" ng-show="::showSpinners"><td class="uib-decrement hours"><a ng-click="decrementHours()" ng-class="{disabled: noDecrementHours()}" class="btn btn-link" ng-disabled="noDecrementHours()" tabindex="-1"><span class="glyphicon glyphicon-minus"></span></a></td><td>&nbsp;</td><td class="uib-decrement minutes"><a ng-click="decrementMinutes()" ng-class="{disabled: noDecrementMinutes()}" class="btn btn-link" ng-disabled="noDecrementMinutes()" tabindex="-1"><span class="glyphicon glyphicon-minus"></span></a></td><td ng-show="showSeconds">&nbsp;</td><td ng-show="showSeconds" class="uib-decrement seconds"><a ng-click="decrementSeconds()" ng-class="{disabled: noDecrementSeconds()}" class="btn btn-link" ng-disabled="noDecrementSeconds()" tabindex="-1"><span class="glyphicon glyphicon-minus"></span></a></td><td ng-show="showMeridian"></td></tr></tbody></table>');
$templateCache.put('app/components/shopping-cart/language-dropdown/language-dropdown.html','<div class="btn-group" uib-dropdown ng-if="vm.languages.length > 1"><button type="button" class="btn btn-xs w3-btn w3-small w3-white w3-text-grey" uib-dropdown-toggle><span><span class="glyphicon glyphicon-globe"></span> {{(vm.currentLanguageCode || \'en\').split(\'_\')[0].split(\'-\')[0]}} <span>{{vm.shoppingCart.shoppingCartItems.items.length}}</span> </span><span class="caret"></span></button><ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu><li active-menu="{{language}}" ng-repeat="language in vm.languages"><a ng-click="vm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></div>');
$templateCache.put('app/components/shopping-cart/language-dropdown/language-nav-dropdown.html','<ul class="nav navbar-nav navbar-right" ng-if="vm.languages.length > 1"><li class="dropdown pointer" uib-dropdown><a class="dropdown-toggle" uib-dropdown-toggle><span><span class="glyphicon glyphicon-flag"></span> <span>{{vm.currentLanguageCode | findLanguageFromKey}}</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li active-menu="{{language}}" ng-repeat="language in vm.languages | orderBy:\'toString()\'"><a ng-click="vm.changeLanguage(language);vm.collapseWorldNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul>');
$templateCache.put('app/components/shopping-cart/shopping-cart-dropdown/shopping-cart-dropdown-modal.html','<span class="w3-border w3-padding w3-circle w3-white w3-border-dark-grey closebtn" ng-click="vm.clear()"><span class="w3-closebtn">&times;</span></span><div class="w3-container w3-padding-large"><div class="row w3-margin-top"><div class="col-xs-12"><div class="w3-container w3-whitex w3-leftbarx w3-border-dark-grey w3-padding vobe-bar"><span style="text-transform: uppercase" translate="shopping-cart.headings.summary">Cart Summary</span></div></div></div><div class="row" ng-if="!vm.shoppingCart || vm.shoppingCart.shoppingCartItems.items.length==0"><div><div class="w3-padding-large w3-center w3-text-dark-grey"><span translate="shopping-cart.alert.empty">Your card is empty</span>.</div></div></div><div class="row" ng-if="vm.shoppingCart.shoppingCartItems.items.length>0"><div><div style="margin: 5px" uib-alert ng-repeat="alert in vm.perishableAlerts">{{alert.msg}}</div></div><div class="row"><shopping-cart-summary ng-if="vm.channel!=20" class="col-xs-12" shopping-cart="vm.shoppingCart" shopping-cart-configs="vm.shoppingCartConfigs" property="vm.property" property-group="vm.propertyGroup" force-hide-promo-box="true"></shopping-cart-summary><shopping-cart-summary-tgb ng-if="vm.channel==20" class="col-xs-12" shopping-cart="vm.shoppingCart" shopping-cart-configs="vm.shoppingCartConfigs" property="vm.property" property-group="vm.propertyGroup" force-hide-promo-box="true"></shopping-cart-summary-tgb></div><div><p style="text-align: center"><a ng-click="vm.goToShoppingCart($event)" class="w3-btn in1-button w3-border w3-round" href="#" role="button"><span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span> <span translate="shopping-cart.buttons.checkout">Checkout</span></a></p></div></div></div>');
$templateCache.put('app/components/shopping-cart/shopping-cart-dropdown/shopping-cart-dropdown.html','<div class="btn-group"><button type="button" class="btn btn-xs w3-btn w3-small w3-white w3-text-grey" ng-click="vm.openShoppingCartDropdownModal(\'lg\',\'.modal-shopping-cart-dropdown-parent\')"><span><span class="glyphicon glyphicon-shopping-cart"></span> <span class="hidden-sm" translate="global.menu.shopping.main">Cart</span> <span>({{vm.shoppingCart.shoppingCartItems.items.length}})</span> </span><span class="caret"></span></button></div>');
$templateCache.put('app/components/shopping-cart/shopping-cart-dropdown/shopping-cart-navbar.html','<button type="button" class="in1-button navbar-toggle right-toggle right-toggle-visible btn btn-sm w3-border-0" style="display: inline-block" data-vobe-action="open_cart_modal_button" ng-click="vm.openShoppingCartDropdownModal(\'lg\',\'.modal-shopping-cart-dropdown-parent\')"><span class="sr-only">Toggle cart</span> <span class="glyphicon glyphicon-shopping-cart"></span> <span class="" ng-if="vm.shoppingCart.shoppingCartItems.items.length>0">({{vm.shoppingCart.shoppingCartItems.items.length}})</span></button>');
$templateCache.put('app/components/shopping-cart/sort-dropdown/sort-nav-dropdown.html','<ul class="nav navbar-nav navbar-right" ng-if="!vm.isGroup && vm.showCategoriesBoxType !== 2"><li class="dropdown pointer" uib-dropdown><a class="dropdown-toggle" uib-dropdown-toggle><span><span class="glyphicon glyphicon-flag"></span> <span class="vm.settings.voucherPoolOrderBy.name==\'sequence\'"><span transalate="vouchers.buttons.controls.relevance">Relevance</span></span> <span class="vm.settings.voucherPoolOrderBy.name==\'minValueAfterDiscount\'"><span transalate="vouchers.buttons.controls.price">Price</span></span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li><div class="tiles-control" ng-show="vm.showSortControls"><div class="btn-group sort-controls-panel"><label class="btn btn-xs w3-btn w3-small w3-white w3-text-grey" ng-model="vm.settings.voucherPoolOrderBy.name" uib-btn-radio="\'sequence\'" translate="vouchers.buttons.controls.relevance">Relevance <span class="glyphicon glyphicon-sort-by-attributes-alt" aria-hidden="true"></span></label><label class="btn btn-xs w3-btn w3-small w3-white w3-text-grey" ng-model="vm.settings.voucherPoolOrderBy.name" uib-btn-radio="\'minValueAfterDiscount\'" translate="vouchers.buttons.controls.price">Price <span class="glyphicon glyphicon-sort-by-order" aria-hidden="true"></span></label></div></div></li></ul></li></ul>');
$templateCache.put('app/components/vouchers/categoryFilter/categoryFilter.html','<div class="categoryFilter menuItem" uib-dropdown auto-close="outsideClick" is-open="$ctrl.categoriesOpen" on-toggle="$ctrl.toggled(open)"><button type="button" class="btn btn-xs w3-btn w3-small w3-white w3-text-grey dropdown-toggle" ng-class="{ \'in1-button\' : $ctrl.categoriesOpen || $ctrl.selectedCategoriesApplied.length > 0 }" uib-dropdown-toggle>Categories <span ng-if="$ctrl.selectedCategoriesApplied.length > 0 && $ctrl.voucherClassActive==\'all\'">&middot; <span translate="vouchers.voucherclass.name.all">All</span></span> <span ng-if="$ctrl.selectedCategoriesApplied.length > 0 && $ctrl.voucherClassActive!=\'all\'">&middot; {{ $ctrl.selectedCategoriesApplied.length }}</span> <span class="caret"></span></button><div uib-dropdown-menu><div class="menuItemComponent menuItemComponent--categories"><div class="categoryItems--header"><div class="categoryItems--header__left"><span aria-hidden="true" ng-click="$ctrl.categoriesOpen = false" class="closeButton">&times;</span></div><div class="categoryItems--header__center">Categories</div><div class="categoryItems--header__right"><span ng-click="$ctrl.clear()">Clear All</span></div></div><div class="categoryItems"><div class="categoryItem" ng-repeat="vc in $ctrl.voucherClassCounter | orderBy:$ctrl.sortVoucherClass" ng-if="vc.classId!=\'all\'"><div class="optionItem"><label for="{{ vc.classId }}"><div class="optionItemContainer"><div class="optionItemContainer--cell" style="width: 18px"><div class="inputContainer"><span class="inputContainer--display"><input aria-invalid="false" id="{{ vc.classId }}" name="{{ vc.classId }}" ng-model="$ctrl.categoriesSelected[vc.classId]" ng-change="$ctrl.categoryChanged()" type="checkbox" class="customCheckbox" value=""><label for="{{ vc.classId }}"></label></span></div></div><div class="optionItemContainer--cell"><div class="categoryHeaderContainer"><span ng-if="vc.isCategory" class="categoryHeaderContainer--categoryName" ng-bind="vc.category.name"></span> <span ng-if="!vc.isCategory" class="categoryHeaderContainer--categoryName" translate="vouchers.voucherclass.name.{{vc.classId}}">All</span></div></div></div></label></div></div></div><div class="categoryItems--footer"><div class="hidden-xs" style="text-alignx: right"><button type="button" class="btn btn-link" ng-click="$ctrl.clear()" ng-show="$ctrl.countSelected()>0">Clear</button></div><div class="categoryItems--footer__buttonContainer"><button class="in1-button btn btn-block" role="button" ng-click="$ctrl.filterVouchers()"><span translate="vouchers.filters.showxvouchers" translate-values="{voucherCount:$ctrl.voucherFilterArray.length}"></span> <span ng-show="$ctrl.loadingData" class="glyphicon glyphicon-refresh spinning"></span></button></div></div></div></div></div><div class="menuItem--overlay" ng-show="$ctrl.categoriesOpen"></div>');
$templateCache.put('app/components/vouchers/layouts/voucher-tiles-slick.html','<slick class="vobe-cart-pool-pre-slick" settings="vm.slickSettings" ng-include="\'app/components/vouchers/layouts/voucher-tiles.html\'"></slick>');
$templateCache.put('app/components/vouchers/layouts/voucher-tiles.html','<div ng-class="{\n\t\t\'col-xs-12\' : vm.tilesSlick,\n\t\t\'col-xs-12 col-sm-12 col-md-6 col-lg-4\' : !vm.tilesSlick && vm.tilesSettings.viewLayoutTileActive==\'three\',\n\t\t\'col-xs-12 col-sm-6 col-md-4 col-lg-3\' : !vm.tilesSlick && vm.tilesSettings.viewLayoutTileActive==\'four\',\n\t    \'col-xs-12 col-sm-4 col-md-3 col-lg-2\' : !vm.tilesSlick && vm.tilesSettings.viewLayoutTileActive==\'six\'}" class="vobe-cart-pool-pre ng-cloak" style="display: inline-block; vertical-align: top; float: none" ng-repeat="voucherPool in vm.allVouchers.wrapper.voucherPools | filter : vm.filterCategory | filter: vm.filterPrice | filter:(vm.onlyFeatured ? vm.filterVouchersByFeatured : \'\') | orderBy:vm.tilesSettings.voucherPoolOrderBy:vm.tilesSettings.voucherPoolOrderBy.reverse"><div class="no-outline" style="height: 100%" ng-if="voucherPool.type.includes(\'package\') || voucherPool.type.includes(\'cash-wildcard\')"><!--#############################################\n            #### 1. package (one card per pool) #########\n            #############################################\n        --><div class="vobe-cart-pool no-outline" style="height:100%"><!--<a ng-if="vm.onlyFeatured" class="ui right ribbon label in1-button " tabindex="0">Featured</a>--><card-package-single-default class="no-outline" ng-if="vm.viewLayoutTileDesign==\'default\'" view-layout-tile-design="vm.viewLayoutTileDesign" tiles="vm.viewLayout.activeBreakpoint.cards" settings="vm.tilesSettings" applied-promotion-code="vm.appliedPromotionCode" channel="vm.channel" voucher-pool-object="voucherPool" current-property="vm.currentProperty" current-property-group="vm.currentPropertyGroup" shopping-cart="vm.shoppingCart" open-package-modal="vm.openPackageModal" website-type="vm.websiteType" group-categories="vm.groupCategories" property-categories="vm.propertyCategories" only-featured="vm.onlyFeatured"></card-package-single-default><card-package-single-text class="no-outline" ng-if="vm.viewLayoutTileDesign==\'text\'" view-layout-tile-design="vm.viewLayoutTileDesign" tiles="vm.viewLayout.activeBreakpoint.cards" settings="vm.tilesSettings" applied-promotion-code="vm.appliedPromotionCode" channel="vm.channel" voucher-pool-object="voucherPool" current-property="vm.currentProperty" current-property-group="vm.currentPropertyGroup" shopping-cart="vm.shoppingCart" open-package-modal="vm.openPackageModal" website-type="vm.websiteType" description-lines="vm.descriptionLines" group-categories="vm.groupCategories" property-categories="vm.propertyCategories" only-featured="vm.onlyFeatured"></card-package-single-text></div><!-- end vouchers loop--></div><!--end package type --><div style="height: 100%" class="no-outline" ng-if="vm.filterCashOnly(voucherPool) && !voucherPool.featured && !voucherPool.giftCard"><!--#############################################\n             #### cash combined (one card per pool) ####\n             #############################################\n         --><div class="vobe-cart-pool no-outline" style="height:100%"><!--<a ng-if="vm.onlyFeatured" class="ui right ribbon label in1-button " tabindex="0">Featured</a>--><card-cash-combined-default class="no-outline" ng-if="vm.viewLayoutTileDesign==\'default\'" view-layout-tile-design="vm.viewLayoutTileDesign" tiles="vm.viewLayout.activeBreakpoint.cards" settings="vm.tilesSettings" applied-promotion-code="vm.appliedPromotionCode" channel="vm.channel" voucher-pool-object="voucherPool" current-property="vm.currentProperty" current-property-group="vm.currentPropertyGroup" shopping-cart="vm.shoppingCart" open-cash-modal="vm.openCashModal" website-type="vm.websiteType" only-featured="vm.onlyFeatured"></card-cash-combined-default><card-cash-combined-text class="no-outline" ng-if="vm.viewLayoutTileDesign==\'text\'" view-layout-tile-design="vm.viewLayoutTileDesign" tiles="vm.viewLayout.activeBreakpoint.cards" settings="vm.tilesSettings" applied-promotion-code="vm.appliedPromotionCode" channel="vm.channel" voucher-pool-object="voucherPool" current-property="vm.currentProperty" current-property-group="vm.currentPropertyGroup" shopping-cart="vm.shoppingCart" open-cash-modal="vm.openCashModal" website-type="vm.websiteType" description-lines="vm.descriptionLines" only-featured="vm.onlyFeatured"></card-cash-combined-text></div></div><!--end cash combined type --><div style="height: 100%" class="no-outline" ng-if="vm.filterCashOnly(voucherPool) && voucherPool.featured"><!--#############################################\n             #### cash featured (one card per pool) ####\n             #############################################\n         --><div class="vobe-cart-pool no-outline" style="height:100%"><!--<a ng-if="vm.onlyFeatured" class="ui right ribbon label in1-button " tabindex="0">Featured</a>--><card-cash-combined-default class="no-outline" ng-if="vm.viewLayoutTileDesign==\'default\'" view-layout-tile-design="vm.viewLayoutTileDesign" tiles="vm.viewLayout.activeBreakpoint.cards" settings="vm.tilesSettings" applied-promotion-code="vm.appliedPromotionCode" channel="vm.channel" voucher-pool-object="voucherPool" current-property="vm.currentProperty" current-property-group="vm.currentPropertyGroup" shopping-cart="vm.shoppingCart" open-cash-modal="vm.openCashModal" website-type="vm.websiteType" only-featured="vm.onlyFeatured"></card-cash-combined-default><card-cash-combined-text class="no-outline" ng-if="vm.viewLayoutTileDesign==\'text\'" view-layout-tile-design="vm.viewLayoutTileDesign" tiles="vm.viewLayout.activeBreakpoint.cards" settings="vm.tilesSettings" applied-promotion-code="vm.appliedPromotionCode" channel="vm.channel" voucher-pool-object="voucherPool" current-property="vm.currentProperty" current-property-group="vm.currentPropertyGroup" shopping-cart="vm.shoppingCart" open-cash-modal="vm.openCashModal" website-type="vm.websiteType" description-lines="vm.descriptionLines" only-featured="vm.onlyFeatured"></card-cash-combined-text></div></div><!--end cash featured --><div style="height: 100%" class="no-outline" ng-if="vm.filterCashOnly(voucherPool) && voucherPool.giftCard"><!--#############################################\n             #### cash gift card (one card per pool) ####\n             #############################################\n         --><div class="vobe-cart-pool no-outline" style="height:100%"><!--<a ng-if="vm.onlyFeatured" class="ui right ribbon label in1-button " tabindex="0">Featured</a>--><card-cash-combined-default class="no-outline" ng-if="vm.viewLayoutTileDesign==\'default\'" view-layout-tile-design="vm.viewLayoutTileDesign" tiles="vm.viewLayout.activeBreakpoint.cards" settings="vm.tilesSettings" applied-promotion-code="vm.appliedPromotionCode" channel="vm.channel" voucher-pool-object="voucherPool" current-property="vm.currentProperty" current-property-group="vm.currentPropertyGroup" shopping-cart="vm.shoppingCart" open-cash-modal="vm.openCashModal" website-type="vm.websiteType" only-featured="vm.onlyFeatured"></card-cash-combined-default><card-cash-combined-text class="no-outline" ng-if="vm.viewLayoutTileDesign==\'text\'" view-layout-tile-design="vm.viewLayoutTileDesign" tiles="vm.viewLayout.activeBreakpoint.cards" settings="vm.tilesSettings" applied-promotion-code="vm.appliedPromotionCode" channel="vm.channel" voucher-pool-object="voucherPool" current-property="vm.currentProperty" current-property-group="vm.currentPropertyGroup" shopping-cart="vm.shoppingCart" open-cash-modal="vm.openCashModal" website-type="vm.websiteType" description-lines="vm.descriptionLines" only-featured="vm.onlyFeatured"></card-cash-combined-text></div></div><!--end cash combined pool --></div>');
$templateCache.put('app/components/vouchers/navbar/vouchers-navbar.html','<nav class="navbar navbar-default vouchers-navbar allow-fixed" role="navigation" style="margin-bottom: 0px;clear: both" ng-class="{\'navbar-header-promo-applied\' : vm.appliedPromotionCode}"><div class="container-fluid"><div class="row"><div class="navbar-header" style="width: 100%; /*to make columns work*/"><div class="col-xs-12 col-sm-8 col-md-6 col-lg-6 vouchers-navbar-hide-fixed" ng-if="vm.showPromoControls"><form name="vm.promoControlForm" style="position: relative; /*required as parent of popover*/"><!-- promo input --><div class="input-group input-group-sm promo-controls w3-border-0" style="border-radius: 3px"><input ng-class="{\'input-spin\' : vm.processingPromotionCode}" ng-readonly="vm.appliedPromotionCode" type="text" class="form-control left-side" name="promotionCode" ng-model="vm.promotionCode.code" aria-label="{{\'vouchers.promotioncode.name\' | translate}}" placeholder="{{\'vouchers.promotioncode.name\' | translate}}"> <span class="input-group-addon btn btn-default btn-xs w3-text-grey right-side" ng-show="!vm.appliedPromotionCode" ng-click="vm.applyPromotionCode($event)" aria-label="{{\'vouchers.buttons.controls.apply\' | translate}}" translate="vouchers.buttons.controls.apply">Apply</span> <span class="input-group-addon btn btn-default btn-xs w3-text-grey right-side" id="basic-addon2" ng-show="vm.appliedPromotionCode" aria-label="Remove Promotion Code" ng-click="vm.removePromotionCode($event)"><span class="glyphicon glyphicon-trash"></span></span></div><!-- promo error message --> <span ng-messages="vm.promoControlForm.$error"><span ng-show="vm.promoControlForm.promotionCode.$error[\'error.promocodeinvalid\']\n                                                    || (!vm.promoControlForm.promotionCode.$dirty &&\n                                                    !vm.appliedPromotionCode && vm.promotionCode.code)"><span class="help-block w3-text-red w3-tiny" ng-message="error.promocodeinvalid">Promotion code is invalid.</span> </span><span class="help-block w3-text-red w3-tiny" ng-message="error.promocodeexists" ng-show="vm.promoControlForm.promotionCode.$error[\'error.promocodeexists\']">Promotion code already applied.</span> </span><!-- promo popover (inside form to position relatively to it)--><div class="promo-popover top w3-pale-green w3-center w3-text-gray" style="width:100%" ng-show="vm.appliedPromotionCode"><div class="arrow"></div><div class="popover-content w3-small" style="padding:0"><span translate="vouchers.promotioncode.name">Promotion code</span> <span translate="vouchers.promotioncode.applied">applied</span></div></div></form></div><div class="col-xs-12 col-sm-4 col-md-6 col-lg-6" ng-class="{\'col-sm-offset-4 col-md-offset-6 col-offset-lg-6\' : !vm.showPromoControls}"><shopping-cart-navbar-button shopping-cart-configs="vm.shoppingCartConfigs" shopping-cart="vm.shoppingCart" property="vm.currentProperty" property-group="vm.currentPropertyGroup"></shopping-cart-navbar-button><button type="button" class="navbar-toggle left-toggle btn btn-sm w3-white w3-text-gray w3-border-0 w3-card-2" ng-click="vm.toggleSortNavbar()" ng-show="vm.showSortControls || vm.showColumnControls"><span class="sr-only">Toggle sort menu</span> <span><span class="glyphicon glyphicon-sort-by-attributes"></span> <span ng-show="vm.settings.voucherPoolOrderBy.name.includes(\'sequence\')"><span translate="vouchers.buttons.controls.relevance">Relevance</span></span> <span ng-show="vm.settings.voucherPoolOrderBy.name==\'minValueAfterDiscount\'"><span translate="vouchers.buttons.controls.price">Price</span></span></span></button><!-- world mobile button --> <button type="button" class="navbar-toggle left-toggle btn btn-sm w3-white w3-text-gray w3-border-0 w3-card-2" ng-show="(vm.availableCurrencies && vm.availableCurrencies.length>1) || (vm.languages && vm.languages.length > 1)" ng-click="vm.toggleWorldNavbar()"><span class="sr-only">Toggle language and currency menu</span> <span class="glyphicon glyphicon glyphicon-globe"></span> <span ng-show="vm.languages && vm.languages.length > 1 && vm.currentLanguageCode">{{(vm.currentLanguageCode || \'en\').split(\'-\').split(\'_\')[0]}}</span><span ng-show="(vm.availableCurrencies && vm.availableCurrencies.length>1 && vm.currentLanguageCode) && (vm.languages && vm.languages.length > 1)"> / </span><span ng-show="vm.availableCurrencies && vm.availableCurrencies.length>1 && vm.currentCurrency">{{vm.currentCurrency.symbol}}</span></button></div></div></div><div class="row"><div class="navbar-collapse col-sm-6" uib-collapse="vm.isSortNavbarCollapsed" ng-show="vm.showSortControls || vm.showColumnControls"><!-- SORT CONTROLS ---><div class="" ng-if="vm.showSortControls" style="display: inline-block"><div class="sort-controls"><div class="btn-group sort-controls-panel"><label class="btn btn-sm w3-btn w3-white w3-text-grey" ng-model="vm.settings.voucherPoolOrderBy" uib-btn-radio="\'sequence\'" ng-click="vm.collapseSortNavbar();vm.updateVoucherPoolOrderBy()" translate="vouchers.buttons.controls.relevance">Relevance <span class="glyphicon glyphicon-sort-by-attributes-alt" aria-hidden="true"></span></label><label class="btn btn-sm w3-btn w3-white w3-text-grey" ng-model="vm.settings.voucherPoolOrderBy" uib-btn-radio="\'minValueAfterDiscount\'" ng-click="vm.collapseSortNavbar();vm.updateVoucherPoolOrderBy()" translate="vouchers.buttons.controls.price">Price <span class="glyphicon glyphicon-sort-by-order" aria-hidden="true"></span></label></div></div></div><!-- COLUMN CONTROLS ---><div class="hidden-xs hidden-smx" ng-if="vm.showColumnControls" style="display: inline-block"><div class="tiles-control"><div class="btn-group hidden-xs column-controls-panel"><label class="btn btn-sm w3-btn w3-white w3-text-grey" ng-click="vm.collapseSortNavbar()" ng-model="vm.settings.viewLayoutTileActive" uib-btn-radio="\'three\'"><span class="glyphicon glyphicon-th" aria-hidden="true"></span> {{vm.viewLayoutTiles.three.activeBreakpoint.cards}}</label><label class="btn btn-sm w3-btn w3-white w3-text-grey" ng-click="vm.collapseSortNavbar()" ng-model="vm.settings.viewLayoutTileActive" uib-btn-radio="\'four\'"><span class="glyphicon glyphicon-th" aria-hidden="true"></span> {{vm.viewLayoutTiles.four.activeBreakpoint.cards}}</label><label ng-if="vm.viewLayoutTiles.six.activeBreakpoint.cards<6" class="btn btn-sm w3-btn w3-white w3-text-grey" ng-model="vm.settings.viewLayoutTileActive" uib-btn-radio="\'six\'"><span class="glyphicon glyphicon-th" aria-hidden="true"></span> {{vm.viewLayoutTiles.six.activeBreakpoint.cards}}</label></div></div></div></div><div class="navbar-collapse col-sm-6" uib-collapse="vm.isWorldNavbarCollapsed" ng-show="(vm.availableCurrencies && vm.availableCurrencies.length>1) || (vm.languages && vm.languages.length > 1)"><language-nav-dropdown shopping-cart-configs="vm.shoppingCartConfigs" current-property="vm.currentProperty" collapse-world-navbar="vm.collapseWorldNavbar" on-available-languages="vm.onAvailableLanguages"></language-nav-dropdown><currency-nav-dropdown on-update="vm.onCurrencyChanged" collapse-world-navbar="vm.collapseWorldNavbar" on-available-currencies="vm.onAvailableCurrencies"></currency-nav-dropdown></div></div></div></nav>');
$templateCache.put('app/components/vouchers/priceFilter/priceFilter.html','<div class="menuItem priceFilter" uib-dropdown auto-close="outsideClick" on-toggle="$ctrl.togglePriceButton(open)" is-open="$ctrl.priceOverlay"><button type="button" class="btn btn-xs w3-btn w3-small w3-white w3-text-grey dropdown-toggle" ng-class="{ \'in1-button\' : $ctrl.priceOverlay || ($ctrl.min !== 0 || $ctrl.max != 0) }" uib-dropdown-toggle>Price <span ng-if="($ctrl.min != 0 || $ctrl.max != 0)">&middot; <span ng-bind="$ctrl.min | currency:\'\'+\' \':0"></span> - <span ng-bind="$ctrl.max | currency:\'\'+\' \':0"></span> </span><span class="caret"></span></button><div uib-dropdown-menu><div class="menuItemComponent menuItemComponent--price"><div class="categoryItems--header"><div class="categoryItems--header__left"><span aria-hidden="true" ng-click="$ctrl.priceOverlay = false" class="closeButton">&times;</span></div><div class="categoryItems--header__center">Price</div><div class="categoryItems--header__right"></div></div><div class="categoryItems"><div class="priceGraph"><div class="g-item" ng-class="{\'g-item--inactive\' : $ctrl.checkRange(g.min, g.max)}" ng-repeat="g in $ctrl.graphItems track by $index" ng-style="{ height : g.height+\'px\'}"></div></div><rzslider class="priceFilterSlider" rz-slider-model="$ctrl.slider.minValue" rz-slider-high="$ctrl.slider.maxValue" rz-slider-options="$ctrl.slider.options"></rzslider><div class="row"><div class="col-xs-6"><div class="input-group"><span class="input-group-addon">Min</span> <input ng-model="$ctrl.slider.minValue" ng-model-options="{ debounce: 500 }" id="minPrice" type="text" class="form-control"></div></div><div class="col-xs-6"><div class="input-group"><span class="input-group-addon">Max</span> <input ng-model="$ctrl.slider.maxValue" ng-model-options="{ debounce: 500 }" id="maxPrice" type="text" class="form-control"></div></div></div></div><div class="categoryItems--footer"><div class="hidden-xs"><button type="button" class="btn btn-link" ng-click="$ctrl.clear()">Clear</button></div><div class="categoryItems--footer__buttonContainer"><button class="in1-button btn btn-block" role="button" ng-click="$ctrl.save()"><span>Save</span> <span ng-show="$ctrl.loadingData" class="glyphicon glyphicon-refresh spinning"></span></button></div></div></div></div></div><div class="menuItem--overlay" ng-show="$ctrl.priceOverlay"></div>');
$templateCache.put('app/site/payment/modals/buyer-info.html','<div class="modal-body" id="modal-body"><h5 translate="shopping-cart.info.buyer.title"></h5><span translate="shopping-cart.info.buyer.text" style="white-space: pre-line"></span></div><div class="modal-footer"><button class="btn btn-warning" type="button" ng-click="$ctrl.cancel()" translate="shopping-cart.buttons.close">Close</button></div>');
$templateCache.put('app/site/payment/popovers/security-code-popover.html','<div><p>For Visa, Mastercard, and Discover (left), the 3 digits on the <em>back</em> of your card.</p><p>For American Express (right), the 4 digits on the front of your card.</p><div class="cvc-preview-container two-card"><div class="amex-cvc-preview"></div><div class="visa-mc-dis-cvc-preview"></div></div></div>');
$templateCache.put('app/site/property/catalogue/voucher-properties.html','<div><h2>Vouchers</h2><jhi-alert></jhi-alert><div class="table-responsive"><table class="table table-striped"><thead><tr><th><span>Property Name</span></th></tr></thead><tbody><tr ng-repeat="property in vm.properties track by property.hotelId"><td><a ui-sref="property.list({propertyId:property.hotelCode.toLowerCase(),contextType:\'vouchers\'})">{{property.hotelName}}</a></td></tr></tbody></table></div><div class="text-center"><properties-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></properties-count><div uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></div></div></div>');
$templateCache.put('app/site/property/vouchers/bulk-add.html','<div ng-if="!vm.property.theGuestBook" ng-include="\'app/site/shoppingcart/breadcrumbs.html\'"></div><div class="row w3-margin-top" ng-show="(vm.shoppingCart.shoppingCartItems && vm.shoppingCart.shoppingCartItems.items.length>0)"><div class="col-xs-12"><div class="w3-container w3-whitex w3-leftbarx w3-border-dark-grey w3-padding vobe-bar"><span style="text-transform: uppercase" translate="shopping-cart.headings.summary">Cart Summary</span></div></div></div><div class="row"><shopping-cart-summary ng-if="vm.channel!=20" class="col-xs-12" shopping-cart="vm.shoppingCart" shopping-cart-configs="vm.shoppingCartConfigs" property="vm.currentProperty" property-group="vm.currentPropertyGroup" force-hide-promo-box="vm.forceHidePromoBox"></shopping-cart-summary><shopping-cart-summary-tgb ng-if="vm.channel==20" class="col-xs-12" shopping-cart="vm.shoppingCart" shopping-cart-configs="vm.shoppingCartConfigs" property="vm.currentProperty" property-group="vm.currentPropertyGroup" force-hide-promo-box="vm.forceHidePromoBox"></shopping-cart-summary-tgb></div><div class="row w3-margin-top"><div class="col-xs-12"><div class="w3-container w3-padding vobe-bg-container"><div class="col-xs-12 w3-padding-large w3-center">{{vm.templateBulkItem.itemName}}</div></div></div></div><div class="row"><div class="col-xs-12"><form name="vm.checkoutForm" class="vobe-checkout-form"><div class="w3-container w3-pale-red w3-leftbar w3-border-red w3-margin-bottom w3-center" ng-show="vm.checkoutFormInvalid"><p><span translate="shopping-cart.alert.form.invalid">Please fill out all required details marked in red to proceed to payment</span>.</p></div><div ng-repeat="cIndex in [0]"><cart-item-voucher ng-init="$first=$first" cart-item="vm.templateBulkItem" cart-item-index="cIndex" cart-item-first="true" shopping-cart="vm.shoppingCart" shopping-cart-configs="vm.bulkShoppingCartConfigs" email-config="vm.emailConfig" applied-promotion-code="vm.appliedPromotionCode" is-bulk="true" checkout-form="vm.checkoutForm" checkout-form-invalid="vm.checkoutFormInvalid" property="vm.currentProperty" property-group="vm.currentPropertyGroup" current-language="vm.currentLanguage"></cart-item-voucher><!--<div class="col-lg-12" ng-include="\'app/site/shoppingcart/shopping-cart-item-voucher.html\'"  ng-controller="ShoppingCartItemVoucherController as itemVM"></div>--></div><div class="w3-container w3-pale-red w3-leftbar w3-border-red w3-margin-bottom w3-center" ng-show="vm.checkoutFormInvalid"><p><span translate="shopping-cart.alert.form.invalid">Please fill out all required details marked in red to proceed to payment</span>.</p></div></form></div></div><div class="row"><div class="col-xs-12"><div class="w3-container w3-padding vobe-bg-container"><div class="col-xs-12 w3-padding-large w3-center">Recipients</div></div></div></div><div class="row"><div class="col-xs-12" oc-lazy-load="[\'ngHandsontable\']"><hot-table hot-id="{{vm.shoppingCart.shoppingCartKey}}" settings="vm.hot.settings" dataschema="vm.hot.model" col-headers="true" datarows="vm.hot.items"><hot-column ng-repeat="column in vm.getColumns" title="column.title" data="column.data" type="column.type" title="column.title" validator="column.validator" read-only="column.readOnly"></hot-column></hot-table></div></div><div class="row"><div class="col-xs-12"><div class="w3-margin-bottom w3-small w3-text-gray"><p ng-bind-html="\'vouchers.hot.info\' | translate:{ maxBulkRows: vm.maxBulkRows } | trustHtml "></p><div class="w3-container w3-padding vobe-bg-container"><div class="col-xs-12 w3-padding-large w3-center"><a ng-if="vm.channel!=20" class="in1-button w3-button w3-border w3-green w3-border-white w3-round" ng-click="vm.goToPayment($event)" role="button"><span class="glyphicon glyphicon-credit-card" aria-hidden="true" style="top:3px"></span> <span translate="shopping-cart.buttons.topayment">Proceed to payment</span></a></div></div><div class="w3-container w3-pale-red w3-leftbar w3-border-red w3-margin-bottom w3-center" ng-show="vm.bulkAddFailed"><p><span>There has been an internal error when processing with your request. Please try again.</span>.</p></div></div></div></div>');
$templateCache.put('app/site/property/vouchers/property-vouchers.html','<div class="vouchers-overlay" ng-show="vm.paginationLoading"></div><div ng-cloak><div class="row"><voucher-navbar vouchers-navbar-fixed style="position:relative" shopping-cart-configs="vm.shoppingCartConfigs" shopping-cart="vm.shoppingCart" current-property="vm.currentProperty" current-property-group="vm.currentPropertyGroup" on-currency-updated="vm.onCurrencyUpdated" is-group="vm.isGroup" show-categories-box-type="vm.showCategoriesBoxType" show-sort-controls="vm.showSortControls" settings="vm.settings" show-column-controls="vm.showColumnControls" view-layout-tiles="vm.viewLayoutTiles" show-promo-controls="vm.showPromoControls" processing-promotion-code="vm.processingPromotionCode" applied-promotion-code="vm.appliedPromotionCode" promotion-code="vm.promotionCode" apply-promotion-code="vm.applyPromotionCode" remove-promotion-code="vm.removePromotionCode" voucher-class-active="vm.voucherClassActive"></voucher-navbar></div><div class="row"><div class="col-xs-12x"><div class="w3-container w3-whitex vobe-container"><!-- FEATURED VOUCHERS --><div class="row"><div class="col-lg-12x"><div class=""><voucher-tiles-slick ng-if="vm.featuredVoucherPools.length>0" slick-settings="vm.feat_v_slickConfig" class="vobe-vouchers-featured-container col-xs-12 col-md-offset-0 col-md-12 col-lg-offset-1 col-lg-10 gutter-0" all-vouchers="vm.allVouchers" only-featured="true" view-layout-tile-design="vm.viewLayoutTileDesign" view-layout="vm.viewLayout" tiles-settings="vm.settings" applied-promotion-code="vm.appliedPromotionCode" channel="vm.channel" current-property="vm.currentProperty" current-property-group="vm.currentPropertyGroup" shopping-cart="vm.shoppingCart" website-type="vm.websiteType" description-lines="vm.descriptionLines" open-package-modal="vm.openPackageModal" open-cash-modal="vm.openCashModal" filter-price="vm.filterNoOp" filter-category="vm.filterNoOp" filter-gift-card-by-voucher-class="vm.filterGiftCardByVoucherClass" filter-cash-only="vm.filterCashOnly" filter-vouchers-by-featured="vm.filterVouchersByFeatured" group-categories="vm.groupCategories" property-categories="vm.propertyCategories"></voucher-tiles-slick><div class="clearfix"></div></div></div></div><!-- SLICK categories : showCategoriesBoxType == 0 --><div class="row" ng-if="vm.showCategoriesBox && vm.showCategoriesBoxType==0 && vm.showCategoriesBoxUseful"><div class="col-lg-12x"><div class="w3-conatiner w3-light-greyx voucher-class-contrast vobe-categories-container"><slick settings="vm.slickConfig" class="col-xs-offset-1x col-xs-10x col-xs-12 voucher-class-slick-double"><div class="voucher-class-column" ng-repeat="vc in\n\t\t\t\t\t\t\t\t\tvm.voucherClassCounter | orderBy:vm.sortVoucherClass" ng-click="vm.handleCategoriesFilter({selectedCategories : [vc.classId]})" ng-controller="PropertyVouchersClassController" ng-class="{\'active\' : (vm.voucherClassActive==vc.classId)}"><div class="voucher-class-card w3-card-2 card-margin-10" style="position:relative"><footer class="w3-container w3-padding" style="position:absolute;top:0px;width: 100%;z-index:3;background-color: rgba(64,64,64,0.5);color:white" ng-class="\'voucher-class-\'+vc.classId"><span ng-show="!vc.isCategory" translate="vouchers.voucherclass.name.{{vc.classId}}" class="voucher-class-title">Accommodation</span> <span ng-show="vc.isCategory" class="voucher-class-title">{{vc.category.name}}</span> <span ng-show="vc.counter>0" class="badge voucher-class-badge w3-right">{{vc.counter}}</span></footer><div ng-show="!vc.isCategory" class="w3-container voucher-class-bg-img" ng-class="\'voucher-class-bg-img-\'+vc.classId"></div><div ng-show="vc.isCategory" class="w3-container voucher-class-bg-img" ng-class="{\'voucher-class-bg-img-8\' : !vc.category.imageUrl}" ng-style="{\'background-image\':vc.category.imageUrl ? \'url(//in1-image-library.imgix.net/\'+vc.category.hotelId+\'/\'+vm.getImageFileName(vc.category.imageUrl)+\'?h=150)\' : \'\'}"></div></div></div></slick><div class="clearfix"></div></div></div></div><!-- TAB categories : showCategoriesBoxType == 1 --><div class="w3-padding w3-center vobe-categories-container" ellipsis-text="{\n                        descriptionLines : vm.min(vm.voucherClassCounter.length,4),\n                        scrollToId : \'cat-tab-\'+vm.voucherClassActive,\n                        revealHeightIfNoHeight: true,\n                        revealHeight: vm.mobileExpandedCategories\n\t\t\t\t\t }" ng-if="vm.showCategoriesBox && vm.showCategoriesBoxType == 1 && vm.showCategoriesBoxUseful"><div class="w3-light-gray ellipsis-more w3-text-gray hidden-sm" style=""><span class="glyphicon glyphicon-resize-vertical" style="padding: 0px 5px"></span><span translate="vouchers.headings.categories">Categories</span></div><div class="btn-group btn-group-sm" ellipsis-text-inner><label class="btn btn-default w3-padding-16" id="cat-tab-{{vc.classId}}" style="color: #757575" data-vobe-action="category_selected" ng-model="vm.voucherClassActive" uib-btn-radio="vc.classId" ng-repeat="vc in vm.voucherClassCounter | orderBy:vm.sortVoucherClass" ng-click="vm.handleCategoriesFilter({selectedCategories : [vc.classId]})"><span ng-show="!vc.isCategory"><span translate="vouchers.voucherclass.name.{{vc.classId}}">Accommodation</span> <span ng-show="false && vc.counter>0">({{vc.counter}})</span></span> <span ng-show="vc.isCategory">{{vc.category.name}} <span ng-show="false\n\t\t\t\t\t\t\t\t\t&& vc.counter>0">({{vc.counter}})</span></span></label></div><div class="ellipsis hidden-sm" style="display:none"></div></div><div ng-if="false" class="row w3-margin-top vobe-bar-pre vobe-bar-pre-2" style="margin-top:36px !important;/*to allow for promo code popup*/"><div class="col-lg-12 vobe-bar vobe-upper-controls"><div class="row no-gutter"><!-- 60% promo + tiles + basic sorting--><div class="col-xs-12 col-sm-12 col-md-8 col-lg-6 tiles-control-form promo-control-form col-md-border" ng-class="{\'col-xs-push-0 col-sm-push-0 col-md-push-4 col-lg-push-3\' : (vm.showCategoriesBox && vm.showCategoriesBoxType == 2) }"><div class="row"><!-- PROMO INPUT ---><div class="col-md-5 col-lg-5" ng-show="vm.showPromoControls" ng-class="{\'col-xs-6\':(!vm.isGroup && vm.showCategoriesBoxType !== 2), \'col-xs-12\' :!(!vm.isGroup && vm.showCategoriesBoxType !== 2) }"><form name="vm.promoControlForm" style="position: relative; /*required as parent of popover*/"><!-- promo input --><div class="input-group input-group-xs promo-controls"><input ng-class="{\'input-spin\' : vm.processingPromotionCode}" ng-readonly="vm.appliedPromotionCode" type="text" class="form-control left-side" name="promotionCode" ng-model="vm.promotionCode.code" aria-label="{{\'vouchers.promotioncode.name\' | translate}}" placeholder="{{\'vouchers.promotioncode.name\' | translate}}"> <span class="input-group-addon btn btn-default btn-xs w3-text-grey right-side" ng-show="!vm.appliedPromotionCode" ng-click="vm.applyPromotionCode($event)" aria-label="{{\'vouchers.buttons.controls.apply\' | translate}}" translate="vouchers.buttons.controls.apply">Apply</span> <span class="input-group-addon btn btn-default btn-xs w3-text-grey right-side" id="basic-addon2" ng-show="vm.appliedPromotionCode" aria-label="Remove Promotion Code" ng-click="vm.removePromotionCode($event)"><span class="glyphicon glyphicon-trash"></span></span></div><!-- promo error message --> <span ng-messages="vm.promoControlForm.$error"><span ng-show="vm.promoControlForm.promotionCode.$error[\'error.promocodeinvalid\']\n\t\t\t\t\t\t\t\t\t\t\t\t|| (!vm.promoControlForm.promotionCode.$dirty &&\n\t\t\t\t\t\t\t\t\t\t\t\t!vm.appliedPromotionCode && vm.promotionCode.code)"><span class="help-block w3-text-red w3-tiny" ng-message="error.promocodeinvalid">Promotion code is invalid.</span> </span><span class="help-block w3-text-red w3-tiny" ng-message="error.promocodeexists" ng-show="vm.promoControlForm.promotionCode.$error[\'error.promocodeexists\']">Promotion code already applied.</span> </span><!-- promo popover (inside form to position relatively to it)--><div class="promo-popover top w3-pale-green w3-center w3-text-gray" style="width:100%" ng-show="vm.appliedPromotionCode"><div class="arrow"></div><div class="popover-content w3-small" style="padding:0"><span translate="vouchers.promotioncode.name">Promotion code</span> <span translate="vouchers.promotioncode.applied">applied</span></div></div></form></div><!-- COLUMN CONTROLS ---><div class="col-md-3 col-lg-3 hidden-xs hidden-sm"><div class="tiles-control" ng-show="vm.showColumnControls"><div class="btn-group hidden-xs column-controls-panel"><label class="btn btn-xs w3-btn w3-small w3-white w3-text-grey" ng-model="vm.settings.viewLayoutTileActive" uib-btn-radio="\'three\'"><span class="glyphicon glyphicon-th" aria-hidden="true"></span> {{vm.viewLayoutTiles.three.activeBreakpoint.cards}}</label><label class="btn btn-xs w3-btn w3-small w3-white w3-text-grey" ng-model="vm.settings.viewLayoutTileActive" uib-btn-radio="\'four\'"><span class="glyphicon glyphicon-th" aria-hidden="true"></span> {{vm.viewLayoutTiles.four.activeBreakpoint.cards}}</label><label class="btn btn-xs w3-btn w3-small w3-white w3-text-grey" ng-model="vm.settings.viewLayoutTileActive" uib-btn-radio="\'six\'"><span class="glyphicon glyphicon-th" aria-hidden="true"></span> {{vm.viewLayoutTiles.six.activeBreakpoint.cards}}</label></div></div></div><!-- BASIC SORT--><div class="col-xs-6 col-md-4 col-lg-4" ng-if="!vm.isGroup && vm.showCategoriesBoxType !== 2"><div class="tiles-control" ng-show="vm.showSortControls"><div class="btn-group sort-controls-panel"><label class="btn btn-xs w3-btn w3-small w3-white w3-text-grey" ng-model="vm.settings.voucherPoolOrderBy.name" uib-btn-radio="\'sequence\'" translate="vouchers.buttons.controls.relevance">Relevance <span class="glyphicon glyphicon-sort-by-attributes-alt" aria-hidden="true"></span></label><label class="btn btn-xs w3-btn w3-small w3-white w3-text-grey" ng-model="vm.settings.voucherPoolOrderBy.name" uib-btn-radio="\'minValueAfterDiscount\'" translate="vouchers.buttons.controls.price">Price <span class="glyphicon glyphicon-sort-by-order" aria-hidden="true"></span></label></div></div></div></div></div><!-- 30% categories and pricing as buttons / showCategoriesBox==2 --><div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-md-border" ng-if="(vm.showCategoriesBox && vm.showCategoriesBoxType == 2)" ng-class="{\'col-xs-pull-0 col-sm-pull-0 col-md-pull-8 col-lg-pull-6\' : (vm.showCategoriesBox && vm.showCategoriesBoxType == 2) }"><div class="row"><div class="col-xs-12 filter-controls-panel"><category-filter voucher-class-counter="vm.voucherClassCounter" voucher-class-active="vm.voucherClassActive" sort-voucher-class="vm.sortVoucherClass" on-update-promise="vm.handleCategoriesFilter({selectedCategories: selectedCategories})"></category-filter><price-filter style="padding-left:10px" currency-string="vm.property.hotelCurrency" min="vm.priceFilter.minPrice" max="vm.priceFilter.maxPrice" price-range="vm.priceIntervalsCounter" on-update-promise="vm.handlePriceFilter({minPrice: minPrice, maxPrice: maxPrice})"></price-filter></div></div></div><!-- 30% lang + currency + cart--><div class="col-xs-12 col-md-4" ng-class="{\'col-sm-6 col-lg-3\' : (vm.showCategoriesBox && vm.showCategoriesBoxType == 2),\n                                            \'col-sm-12 col-lg-6\' : !(vm.showCategoriesBox && vm.showCategoriesBoxType == 2)}"><div class="row"><div class="cart-controls-panel col-xs-12" style="position: relative; /*needed so dropdown will style properly*/"><language-dropdown-button class="" shopping-cart-configs="vm.shoppingCartConfigs" current-property="vm.currentProperty"></language-dropdown-button><currency-dropdown-button class="" on-update="vm.onCurrencyUpdated"></currency-dropdown-button><shopping-cart-dropdown-button class="" shopping-cart-configs="vm.shoppingCartConfigs" shopping-cart="vm.shoppingCart" property="vm.currentProperty" property-group="vm.currentPropertyGroup"></shopping-cart-dropdown-button></div></div></div></div></div></div><div class="row w3-margin-bottom"><div class="col-lg-12x"><div class="w3-conatiner w3-whitex voucher-class-contrast vobe-cards-container"><voucher-tiles class="tilesgrid tilesgrid-{{vm.settings.viewLayoutTileActive}}" all-vouchers="vm.allVouchers" view-layout-tile-design="vm.viewLayoutTileDesign" view-layout="vm.viewLayout" tiles-settings="vm.settings" applied-promotion-code="vm.appliedPromotionCode" channel="vm.channel" current-property="vm.currentProperty" current-property-group="vm.currentPropertyGroup" shopping-cart="vm.shoppingCart" website-type="vm.websiteType" description-lines="vm.descriptionLines" open-package-modal="vm.openPackageModal" open-cash-modal="vm.openCashModal" filter-price="vm.filterPrice" filter-category="vm.filterCategory" filter-gift-card-by-voucher-class="vm.filterGiftCardByVoucherClass" filter-cash-only="vm.filterCashOnly" group-categories="vm.groupCategories" property-categories="vm.propertyCategories"></voucher-tiles></div></div></div><div class="row w3-margin-bottom" ng-if="vm.allVouchers.pageCount>0"><div class="col-lg-12x"><div class="w3-conatiner"><div class="text-center"><properties-count page="vm.allVouchers.page+1" total="vm.allVouchers.nrOfElements" items-per-page="vm.allVouchers.pageSize"></properties-count><div uib-pagination class="pagination-sm" total-items="vm.allVouchers.nrOfElements" ng-model="vm.currentPage" ng-change="vm.handlePageChange()"></div></div></div></div></div></div></div></div></div><div class="modal-shopping-cart-dropdown-parent"></div>');
$templateCache.put('app/site/property/vouchers/voucher-cash-detail-dialog.html','<div class="row voucher-class-contrast"><span class="w3-border w3-padding w3-circle w3-white w3-border-dark-grey" ng-click="vm.clear()" ng-show="!vm.hideClear" style="outline: none; float:\n\t\tright; top: -15px; position: relative; z-index: 1000"><span class="w3-closebtn">&times;</span></span><div class="col-sm-12 voucher-class-contrast" style="padding-top: 0px\n\t\t!important"><div class="w3-container" style="margin-left: -15px; margin-right: -15px"><div class="col-sm-12"><h2 class="w3-center w3-bottombar w3-border-dark-grey w3-padding-16" style="margin-top: 0px">{{vm.voucherProperty.hotelName}}</h2></div><div class="col-xs-12 col-xs-push-0 col-sm-6 col-sm-push-6 tilesgrid-three"><div class="voucher-bg-img" ng-style="{\'background-image\': vm.getImageFileName().includes(\'no-image\') ? \'url(\\\'/content/images/voucher-class-cash.jpg\\\')\' :\n\t\t\t\'url(\\\'{{vm.getImageFileName()}}?fit=crop&h=300&min-w=500&crop=edges&q=70&auto=compress&cs=strip\\\')\'}" style="margin-bottom: 10px" alt="Cash Voucher"></div></div><div class="col-xs-12 col-xs-pull-0 col-sm-6 col-sm-pull-6"><form name="vm.voucherForm"><div class="col-xs-12 col-md-6" ng-if="vm.dropdownVouchers && vm.dropdownVouchers.length>0"><label translate="vouchers.form.label.cashamount">Choose your amount</label><select class="w3-select" name="option" ng-model="vm.selectedDefaultVoucher" ng-options="voucher as (vm.valueForDropdown(voucher)) for voucher in vm.dropdownVouchers | orderBy:\'totalRate.priceMin\'" ng-change="vm.valueForDropdownChanged()"></select></div><div class="col-xs-12 col-md-1" ng-if="vm.voucherPool.enableTypedAmounts &&\n\t\t\t\t\t\tvm.dropdownVouchers && vm.dropdownVouchers.length>0"><span style="padding: 10px 0px;display: inline-block" translate="vouchers.form.label.or">or</span></div><div class="col-xs-12 col-md-5" ng-show="vm.voucherPool.enableTypedAmounts"><label translate="vouchers.form.label.typeamount">Type Your Amount</label><div class="w3-row"><div class="w3-col" style="width:50px;padding: 10px 0px">{{vm.currentCurrency.code}}</div><div class="w3-rest"><input restrict-numeric type="number" step="1" class="w3-input" name="selectedTypedAmount" ng-model-options="{ debounce: 500 }" min="{{(vm.voucherPool.minValue | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) || 10}}" max="{{(vm.voucherPool.maxValue | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) || 1000}}" ng-model="vm.selectedTypedAmount" ng-change="vm.valueForInputChanged()"></div></div><div style="min-height:40px"><small class="w3-text-red ng-hide" ng-show="vm.voucherForm.selectedTypedAmount.$error.integer"><span translate="vouchers.form.alert.typeamount.invalid">The value is not valid</span>.</small> <small class="w3-text-red ng-hide" ng-show="vm.voucherForm.selectedTypedAmount.$error.min ||\n\t\t\t\t\t\t\t\tvm.voucherForm.selectedTypedAmount.$error.max"><span translate="vouchers.form.alert.typeamount.range1">The amount must be in range from</span> {{(vm.voucherPool.minValue | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) || 10 }} <span translate="vouchers.form.alert.typeamount.range2">to</span> {{(vm.voucherPool.maxValue | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) || 1000}}</small></div></div></form><div class="w3-center dialog-price-container" ng-show="vm.getVoucherInContext().totalRate.priceMin>0"><header class="w3-container voucher-class-0" style="text-align: center"><h3 class="w3-center" ng-show="vm.voucherPool.type==\'cash\' && (!vm.voucherPool.giftCard || !vm.voucherPool.giftCard.id)" style="display: inline-block; vertical-align: middle; line-height:\n\t\t\t\t\t\tnormal" translate="vouchers.cash.name">Cash Voucher</h3><h3 class="w3-center" ng-show="vm.voucherPool.type!=\'cash\' && (!vm.voucherPool.giftCard || !vm.voucherPool.giftCard.id)" style="display: inline-block; vertical-align: middle; line-height:\n\t\t\t\t\t\tnormal">{{vm.getVoucherInContext().voucherName }}</h3><h3 class="w3-center" ng-show="vm.giftCard && vm.giftCard.id" style="display: inline-block; vertical-align: middle; line-height: normal">{{$ctrl.giftCard.name}}</h3></header><p class="w3-small w3-center w3-padding-small w3-border-top w3-border-bottom w3-text-gray" style="border-top-style: dotted !important;border-bottom-style: dotted !important"><span translate="vouchers.headings.price.retail">Retail Value</span></p><span class="w3-tagx w3-jumbo w3-padding-largex" style="width: 100%"><span class="w3-medium">{{vm.currentCurrency.code}}</span> <span>{{(vm.getVoucherInContext().totalRate.priceMin | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberInteger}}</span><span class="w3-medium">{{(vm.getVoucherInContext().totalRate.priceMin | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberFraction:0:vm.currentCurrency.code}}</span></span></div></div><div class="clearfix"></div><div class="col-sm-12 col-md-6" style="min-height: 146px;padding-top: 36px;/*required for promo*/"><div style="text-align: center; color: red" ng-show="!vm.displayActionButtons.display"><span>Limit: {{vm.displayActionButtons.errorValue}}<br></span><span>{{vm.displayActionButtons.errorCode | translate}}</span></div><footer class="w3-container w3-center w3-padding-large" style="position: relative; /*required for promo-popover*/" ng-show="vm.voucherForm.$valid &&\n\t\t\t\t\tvm.getVoucherInContext().totalRate.priceMin>0 && vm.displayActionButtons.display"><div class="promo-popover top w3-pale-green w3-center w3-text-gray" style="display:block;top: -36px;width: 100%" ng-show="(vm.getVoucherInContext().totalRate.priceMin>vm.getVoucherInContext().totalRateAfterDiscount.priceMin)\n\t\t\t\t\t\t&& vm.appliedPromotionCode" aria-hidden="false"><div class="arrow"></div><div class="popover-content w3-small" style="padding: 3px 10px"><span ng-if="\'__AUTOMATIC__\'!=vm.appliedPromotionCode.code"><span translate="vouchers.promotioncode.name">Promotion code</span> <span translate="vouchers.promotioncode.applied">applied</span><span>: {{vm.appliedPromotionCode.code}}</span><br></span><span ng-show="vm.appliedPromotionCode.amountPercentage"><span translate="vouchers.promotioncode.save">Save</span> <span>{{vm.appliedPromotionCode.discountAmount}}</span>%</span> <span ng-show="!vm.appliedPromotionCode.amountPercentage"><span translate="vouchers.promotioncode.save">Save</span> <span>{{(vm.appliedPromotionCode.discountAmount | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberInteger}}</span><span class="w3-tiny">{{(vm.appliedPromotionCode.discountAmount | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberFraction:0:vm.currentCurrency.code}}</span> </span><span class="price-content w3-text-red w3-smaller" style="line-height: normal;text-decoration: line-through"><span class="w3-small">{{vm.currentCurrency.code}}</span> {{(vm.getVoucherInContext().totalRate.priceMin | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberInteger}}{{(vm.getVoucherInContext().totalRate.priceMin | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberFraction:0:vm.currentCurrency.code}}</span></div></div><button ng-click="vm.addItemToCartAndCheckout($event)" data-vobe-action="add_item_cart_checkout" class="in1-button w3-button w3-white w3-border w3-border-black w3-round btn-black-hover vobe-buy-button btn-block" ng-disabled="vm.addToCartProgress"><span class="pull-left flip" translate="vouchers.buttons.buynow">Buy Now</span> <span class="pull-right flip"><span class="glyphicon glyphicon-credit-card" aria-hidden="true"></span> <span>{{(vm.getVoucherInContext().totalRateAfterDiscount.priceMin | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberInteger}}{{(vm.getVoucherInContext().totalRateAfterDiscount.priceMin | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberFraction:0:vm.currentCurrency.code}}</span></span></button><hr style="margin-top: 10px;margin-bottom: 5px;border: 0;border-top: 1px solid #323232"><button ng-click="vm.addItemToCartAndRefresh($event)" data-vobe-action="add_item_cart_refresh" class="in1-button w3-button w3-white w3-border w3-border-dark-grey w3-text-dark-grey w3-round btn-black-hover vobe-addtocart-button btn-block" style="margin-top:15px" ng-disabled="vm.addToCartProgress"><span class="pull-left" translate="vouchers.buttons.addtocart">Add to Cart</span> <span class="pull-right"><span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span> <span>{{(vm.getVoucherInContext().totalRateAfterDiscount.priceMin | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberInteger}}{{(vm.getVoucherInContext().totalRateAfterDiscount.priceMin | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberFraction:0:vm.currentCurrency.code}}</span></span></button> <button ng-if="vm.isBulk" ng-click="vm.buyInBulk($event)" data-vobe-action="buy_in_bulk_button" ng-disabled="vm.addToCartProgress" class="in1-button w3-button w3-white w3-border w3-border-dark-grey w3-text-dark-grey w3-round btn-black-hover btn-block vobe-buy-bulk-button hidden-xs hidden-sm" style="display: block;margin-top:5px"><span class="pull-left" translate="vouchers.buttons.buyinbulk">Buy in Bulk</span> <span class="pull-right"><span class="glyphicon glyphicon-th-list" aria-hidden="true"></span> <span>{{(vm.getVoucherInContext().totalRateAfterDiscount.priceMin | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberInteger}}{{(vm.getVoucherInContext().totalRateAfterDiscount.priceMin | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberFraction:0:vm.currentCurrency.code}}</span></span></button></footer></div><div class="col-xs-12 col-sm-12"><div class="w3-container w3-text-grey w3-padding"><p ng-bind-html="vm.getSelectedVoucherDescription()"></p><p ng-bind-html="vm.getSelectedVoucherDescription2()"></p></div></div></div></div></div>');
$templateCache.put('app/site/property/vouchers/voucher-package-detail-dialog.html','<div class="row voucher-class-contrast" ng-if="vm.currentVoucher"><span class="w3-border w3-padding w3-circle w3-white w3-border-dark-grey" ng-click="vm.clear()" style="outline: none; float: right; top: -15px;\n\t\tposition: relative;z-index: 1000"><span class="w3-closebtn">&times;</span></span><div class="col-xs-12 voucher-class-contrast" style="padding-top: 0px !important"><div class="col-sm-12"><h2 class="w3-center w3-bottombar w3-border-dark-grey w3-padding-16" style="margin-top: 0px">{{vm.voucherProperty.hotelName}}</h2></div><div class="col-xs-12 col-xs-push-0 col-sm-6 col-sm-push-6 tilesgrid-three"><div class="voucher-bg-img" ng-style="{\'background-image\': vm.getImageFileName().includes(\'no-image\') ? \'\' :\n\t\t\t\'url(\\\'{{vm.getImageFileName()}}?fit=crop&h=300&min-w=500&crop=edges&q=70&auto=compress&cs=strip\\\')\'}" style="margin-bottom: 10px" alt="{{vm.currentVoucher.voucherName}}"></div></div><div class="col-xs-12 col-xs-pull-0 col-sm-6 col-sm-pull-6"><form name="vm.voucherForm"><div class="row"><div class="col-xs-12" ng-class="{\'col-md-12\' : !vm.voucherPool.enableTypedAmounts, \'col-md-6\' : vm.voucherPool.enableTypedAmounts}" ng-if="!vm.disableGeneratedAmounts && vm.currentVoucher.totalRate.increment> 0"><label translate="vouchers.form.label.cashamount">Choose your amount</label><select class="w3-select" name="option" ng-model="vm.selectedAmount" ng-options="(vm.currentCurrency.code +\' \'+(n | exchangenumber:vm.currentVoucher.currency:vm.currentCurrency.code:true)) for n in vm.range" ng-change="vm.updateSelectedAmountAfterDiscount()"></select></div><div class="col-xs-12 col-md-1" ng-if="!vm.disableGeneratedAmounts && vm.voucherPool.enableTypedAmounts && vm.currentVoucher.totalRate.increment> 0"><span style="padding: 10px 0px;display: inline-block" translate="vouchers.form.label.or">or</span></div><div class="col-xs-12 col-md-5" ng-class="{\'col-md-12\' : vm.disableGeneratedAmounts && vm.currentVoucher.totalRate.increment> 0}" ng-if="vm.voucherPool.enableTypedAmounts && vm.currentVoucher.totalRate.increment> 0"><label translate="vouchers.form.label.typeamount">Type Your Amount</label><div class="w3-row"><div class="w3-col" style="width:50px;padding: 10px 0px">{{vm.currentCurrency.code}}</div><div class="w3-rest"><input restrict-numeric allow-decimals="vm.isRefunds" type="number" class="w3-input" name="selectedTypedAmount" ng-model-options="{ debounce: 500 }" min="{{(vm.currentVoucher.totalRate.priceMin | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) || 10}}" max="{{(vm.currentVoucher.totalRate.priceMax | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) || 1000}}" ng-model="vm.selectedTypedAmount" ng-change="vm.updateSelectedTypedAmountAfterDiscount()"></div></div><div style="min-height:40px"><small class="w3-text-red ng-hide" ng-show="vm.voucherForm.selectedTypedAmount.$error.integer"><span translate="vouchers.form.alert.typeamount.invalid">The value is not valid</span>.</small> <small class="w3-text-red ng-hide" ng-show="vm.voucherForm.selectedTypedAmount.$error.min ||\n\t\t\t\t\t\t\t\tvm.voucherForm.selectedTypedAmount.$error.max"><span translate="vouchers.form.alert.typeamount.range1">The amount must be in range from</span> {{(vm.currentVoucher.totalRate.priceMin | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) || 10 }} <span translate="vouchers.form.alert.typeamount.range2">to</span> {{(vm.currentVoucher.totalRate.priceMax | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) || 1000}}</small></div></div></div></form><div class="w3-center dialog-price-container" ng-show="vm.currentVoucher.totalRate.priceMin>0"><div class="voucher-class-0" style="text-align: center"><h3 ng-if="vm.homogeneous" class="w3-center" style="display: inline-block; vertical-align: middle;\n\t\t\t\t\tline-height: normal">{{vm.currentVoucher.voucherName}}</h3><h3 ng-if="!vm.homogeneous && vm.poolCategory" class="w3-center" style="display: inline-block; vertical-align: middle;\n\t\t\t\t\tline-height: normal">{{vm.poolCategory.name}}</h3><div ng-if="!vm.homogeneous"><span class="vobe-choose-pool-text" translate="vouchers.form.label.choosepool">Please choose one of the following options:</span><select ng-change="vm.refresh()" ng-model="vm.currentVoucher" ng-options="voucherObject as voucherObject.variationName for voucherObject in vm.voucherPoolObjectVouchersArray | orderBy:\'sequence\' track by voucherObject.id" class="w3-select" style="text-align:center; text-align-last: center; outline: none; margin-bottom: 10px"></select></div></div><p class="w3-large w3-center w3-padding-small w3-border-top w3-border-bottom w3-text-gray" style="border-top-style: dotted !important;border-bottom-style: dotted !important"><span translate="vouchers.headings.price.retail">Retail Value</span>&nbsp;<span>{{vm.currentCurrency.code}} {{(vm.getSelectedAmountInContext() | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberInteger}}{{(vm.getSelectedAmountInContext() | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberFraction}}</span></p><span class="w3-tagx w3-jumbo w3-padding-largex" style="width: 100%"><span class="w3-medium">{{vm.currentCurrency.code}}</span> <span>{{(vm.getSelectedAmountAfterDiscountInContext() | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberInteger}}</span><span class="w3-medium">{{(vm.getSelectedAmountAfterDiscountInContext() | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberFraction:0:vm.currentCurrency.code}}</span></span></div></div><div class="clearfix"></div><div class="col-sm-12 col-md-6" style="min-height: 146px"><div style="text-align: center; color: red" ng-show="!vm.displayActionButtons.display"><span>Limit: {{vm.displayActionButtons.errorValue}}<br></span><span>{{vm.displayActionButtons.errorCode | translate}}</span></div><div ng-show="vm.displayActionButtons.display"><div class="promo-popover w3-pale-green w3-center w3-text-gray" style="display:block;width: 100%" ng-show="(vm.currentVoucher.totalRate.priceMin>vm.currentVoucher.totalRateAfterDiscount.priceMin)\n\t\t\t\t\t&& vm.appliedPromotionCode" aria-hidden="false"><div class="arrow"></div><div class="popover-content w3-large" style="padding: 3px 10px"><span ng-if="\'__AUTOMATIC__\'!=vm.appliedPromotionCode.code"><span translate="vouchers.promotioncode.name">Promotion code</span> <span translate="vouchers.promotioncode.applied">applied</span>: {{vm.appliedPromotionCode.code}}<br></span><span ng-show="vm.appliedPromotionCode.amountPercentage">Save <span>{{vm.appliedPromotionCode.discountAmount}}</span>%</span> <span ng-show="!vm.appliedPromotionCode.amountPercentage">Save <span>{{vm.appliedPromotionCode.discountAmount | numberInteger}}</span><span class="w3-tiny">{{vm.appliedPromotionCode.discountAmount | numberFraction}}</span> </span><span class="price-content w3-text-red w3-smaller" style="line-height: normal;text-decoration: line-through"><span class="w3-small">{{vm.currentVoucher.currency}}</span> {{(vm.getSelectedAmountInContext() | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberInteger}}{{(vm.getSelectedAmountInContext() | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberFraction}}</span></div></div><div class="row"><div class="col-md-12"><button ng-click="vm.addItemToCartAndCheckout($event)" data-vobe-action="add_item_cart_checkout" class="in1-button w3-button w3-white w3-border w3-border-black w3-round btn-black-hover btn-block vobe-buy-button" ng-disabled="vm.addToCartProgress"><span class="pull-left" translate="vouchers.buttons.buynow">Buy Now</span> <span class="pull-right"><span class="glyphicon glyphicon-credit-card" aria-hidden="true"></span> <span>{{(vm.getSelectedAmountAfterDiscountInContext() | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberInteger}}{{(vm.getSelectedAmountAfterDiscountInContext() | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberFraction}}</span></span></button></div><div class="col-md-12 col-sm-12"><button ng-click="vm.addItemToCartAndRefresh($event)" data-vobe-action="add_item_cart_refresh" class="in1-button w3-button w3-white w3-border w3-border-dark-grey w3-text-dark-grey w3-round btn-black-hover btn-block vobe-addtocart-button" style="margin-top:5px" ng-disabled="vm.addToCartProgress"><span class="pull-left" translate="vouchers.buttons.addtocart">Add to Cart</span> <span class="pull-right"><span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span> <span>{{(vm.getSelectedAmountAfterDiscountInContext() | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberInteger}}{{(vm.getSelectedAmountAfterDiscountInContext() | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberFraction}}</span></span></button></div><!-- CTA buttons --><div class="col-md-12 hidden-xs hidden-sm" ng-if="vm.isBulk"><button ng-click="vm.buyInBulk($event)" data-vobe-action="buy_in_bulk_button" ng-disabled="vm.addToCartProgress" class="in1-button w3-button w3-white w3-border w3-border-dark-grey w3-text-dark-grey w3-round btn-black-hover btn-block hidden-xs hidden-sm vobe-buy-bulk-button" style="display: block; margin-top:5px"><span class="pull-left" translate="vouchers.buttons.buyinbulk">Buy in Bulk</span> <span class="pull-right"><span class="glyphicon glyphicon-th-list" aria-hidden="true"></span> <span>{{(vm.getSelectedAmountAfterDiscountInContext() | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberInteger}}{{(vm.getSelectedAmountAfterDiscountInContext() | exchangenumber:vm.baseCurrency.code:vm.currentCurrency.code) | numberFraction}}</span></span></button></div></div></div></div><div class="col-sm-12"><div class="w3-text-grey w3-large" style="padding-top: 15px"><p ng-bind-html="vm.currentVoucher.voucherDescriptionTrustedHtml"></p><p ng-bind-html="vm.currentVoucher.voucherDescription2TrustedHtml"></p></div></div></div></div>');
$templateCache.put('app/site/shoppingcart/explain/explain-copy-modal.html','<div class="modal-body" id="modal-body"><dl><dt translate="vouchers.copy.explain.label"></dt><dd translate="vouchers.copy.explain.text"></dd></dl></div><div class="modal-footer"><button class="btn btn-warning" type="button" ng-click="$ctrl.cancel()" translate="vouchers.form.label.close">Close</button></div>');
$templateCache.put('app/site/shoppingcart/explain/explain-dedication-modal.html','<div class="modal-body" id="modal-body"><dl><dt translate="vouchers.dedication.explain.label"></dt><dd translate="vouchers.dedication.explain.text"></dd></dl></div><div class="modal-footer"><button class="btn btn-warning" type="button" ng-click="$ctrl.cancel()" translate="vouchers.form.label.close">Close</button></div>');
$templateCache.put('app/site/shoppingcart/explain/explain-delivery-modal.html','<div class="modal-body" id="modal-body"><dl ng-if="$ctrl.postalOption"><dt translate="vouchers.delivery.post.explain.customer.label"></dt><dd ng-bind-html="$ctrl.customExplain.post.customer ? $ctrl.customExplain.post.customer : \'vouchers.delivery.post.explain.customer.text\' | translate"></dd></dl><dl><dt translate="vouchers.delivery.email.explain.customer.label"></dt><dd ng-bind-html="$ctrl.customExplain.email.customer ? $ctrl.customExplain.email.customer : \'vouchers.delivery.email.explain.customer.text\' | translate"></dd></dl><dl ng-if="$ctrl.postalOption"><dt translate="vouchers.delivery.post.explain.recipient.label"></dt><dd ng-bind-html="$ctrl.customExplain.post.recipient ? $ctrl.customExplain.post.recipient : \'vouchers.delivery.post.explain.recipient.text\' | translate"></dd></dl><dl><dt translate="vouchers.delivery.email.explain.recipient.label"></dt><dd ng-bind-html="$ctrl.customExplain.email.recipient ? $ctrl.customExplain.email.recipient : \'vouchers.delivery.email.explain.recipient.text\' | translate"></dd></dl></div><div class="modal-footer"><button class="btn btn-warning" type="button" ng-click="$ctrl.cancel()" translate="vouchers.form.label.close">Close</button></div>');
$templateCache.put('app/site/shoppingcart/explain/explain-recipient-modal.html','<div class="modal-body" id="modal-body"><dl><dt translate="vouchers.recipient.explain.label">Header Label</dt><dd translate="vouchers.recipient.explain.text">Explain Text</dd></dl></div><div class="modal-footer"><button class="btn btn-warning" type="button" ng-click="$ctrl.cancel()" translate="vouchers.form.label.close">Close</button></div>');
$templateCache.put('app/site/shoppingcart/explain/explain-schedule-later-modal.html','<div class="modal-body" id="modal-body"><label translate="vouchers.form.label.value.scheduledDelivery"></label><dl><dt translate="vouchers.form.label.value.scheduledDeliveryLater"></dt><dd translate="vouchers.delivery.schedule.later.explain.email.longtext"></dd></dl><dl><dt translate="vouchers.form.label.recipient.scheduledZone"></dt><dd translate="vouchers.delivery.schedule.zone.explain.any.text"></dd></dl></div><div class="modal-footer"><button class="btn btn-warning" type="button" ng-click="$ctrl.cancel()" translate="vouchers.form.label.close">Close</button></div>');
$templateCache.put('app/site/shoppingcart/explain/explain-value-modal.html','<div class="modal-body" id="modal-body"><dl><dt translate="vouchers.value.explain.label"></dt><dd translate="vouchers.value.explain.text"></dd></dl></div><div class="modal-footer"><button class="btn btn-warning" type="button" ng-click="$ctrl.cancel()" translate="vouchers.form.label.close">Close</button></div>');
$templateCache.put('app/components/vouchers/card/default/card-cash-combined-default.html','<div style="position: relative;height:100%" class="no-outline" ng-click="$ctrl.openCashModal({voucherPool:$ctrl.currentVoucherPool,cashVoucherId: $ctrl.firstVoucher.id})"><div class="w3-card-2 w3-hover-shadow vobe-cart card-tile card-tiles-{{ $ctrl.tiles }} card-design-{{ $ctrl.viewLayoutTileDesign }}"><div class="reveal-content w3-white"><a class="ui right corner label vobe-bg-generic" ng-click="$ctrl.toggleDescription($event)" ng-style="{\'border-color\' :\n\t\t$ctrl.voucherObjectFirstCategory.isCategory ?\n\t\t$ctrl.voucherObjectFirstCategory.category.colour : \'\',\n\t\t\'color\' : $ctrl.voucherObjectFirstCategory.isCategory ?\n\t\t$ctrl.voucherObjectFirstCategory.category.colour : \'\'}"><span class="icon hand inverted"><span ng-show="!$ctrl.revealedDescription">+</span><span ng-show="$ctrl.revealedDescription">-</span></span></a><div ng-show="!$ctrl.revealedDescription" class="picture-content"><div class="voucher-bg-img" ng-class="{\'lazyload\' : true}" data-bg="{{$ctrl.getImageFileName().includes(\'no-image\') ? \'/content/images/voucher-class-cash.jpg\' :\n\t\t\t$ctrl.getImageFileName()+\'?fit=crop&h=300&min-w=500&crop=edges&q=70&auto=compress&cs=strip&lossless=true&format=webp\'}}" alt="Cash Voucher"></div></div><div ng-show="$ctrl.revealedDescription" class="description-content"><div class="w3-container w3-text-grey w3-center" style="overflow: hidden"><p ng-bind-html="$ctrl.currentVoucherPool.cashVoucherDescriptionTrustedHtml"></p></div><div class="ellipsis"></div><div class="ellipsis-more"><a class="w3-tiny w3-text-blue" ng-click="$ctrl.openCashModal({voucherPool:$ctrl.currentVoucherPool, cashVoucherId: $ctrl.firstVoucher.id})"><span translate="vouchers.headings.more">More...</span></a></div></div></div><header class="w3-container vobe-bg-generic name-content" ng-class="{\n\t\t\'smaller\' : $ctrl.settings.viewLayoutTileActive==\'six\',\n\t\t\'bigger\' : $ctrl.settings.viewLayoutTileActive==\'three\',\n\t    \'with-retail\' : ($ctrl.currentVoucherPool.minValue>$ctrl.currentVoucherPool.minValueAfterDiscount)}"><span class="w3-center" style="display: inline-block; vertical-align: middle; line-height: normal"><span class="small vobe-card-title-hn" ng-if="$ctrl.websiteType==\'group\'" style="display: inline-block">{{$ctrl.voucherProperty.hotelName}}</span> <span class="vobe-card-title-vn" ng-if="!$ctrl.giftCard && $ctrl.currentVoucherPool.type==\'cash\'" translate="vouchers.cash.name">Cash Voucher</span> <span class="vobe-card-title-vn" ng-if="!$ctrl.giftCard && $ctrl.currentVoucherPool.type!=\'cash\'">{{$ctrl.firstVoucher.voucherName }}</span> <span class="vobe-card-title-vn" ng-if="$ctrl.giftCard"><span>{{$ctrl.giftCard.name}}</span><br><span translate="vouchers.headings.bymail">By Mail</span></span> <span ng-if="$ctrl.currentVoucherPool.minValue>$ctrl.currentVoucherPool.minValueAfterDiscount" style="display: block"><span class="w3-small w3-padding-small w3-border-top w3-border-bottom w3-text-gray" style="display: block;border-top-style:dotted !important;border-bottom-style:dotted !important">Retail Price: <span ng-if="!$ctrl.singleMode" style="display:inline-block">{{$ctrl.currentCurrency.code}} {{($ctrl.currentVoucherPool.minValue | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}} - {{($ctrl.currentVoucherPool.maxValue | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0 }}</span> <span ng-if="$ctrl.singleMode" style="display:inline-block">{{$ctrl.currentCurrency.code}} {{($ctrl.currentVoucherPool.minValue | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}}</span></span></span></span></header><footer class="w3-container w3-white w3-padding-16 vobe-bg-generic footer-content"><div ng-style="{\'padding-top\':(($ctrl.currentVoucherPool.minValue>$ctrl.currentVoucherPool.minValueAfterDiscount) && $ctrl.appliedPromotionCode) ? \'30px\' : \'0px\'}"><div class="row"><div ng-class="$ctrl.settings.viewLayoutTileActive==\'six\' ? \'col-xs-12 w3-center\' : \'col-xs-6\'"><div class="promo-popover top w3-pale-green w3-center w3-text-gray" style="display:block" ng-class="{\'bigger\' : $ctrl.settings.viewLayoutTileActive==\'three\',\n\t           \t\t\t\t   \'smaller\' : $ctrl.settings.viewLayoutTileActive==\'six\'}" ng-show="($ctrl.currentVoucherPool.minValue>$ctrl.currentVoucherPool.minValueAfterDiscount) && $ctrl.appliedPromotionCode" aria-hidden="false"><div class="arrow"></div><div class="popover-content w3-small" style="padding: 0px 10px"><span ng-show="$ctrl.appliedPromotionCode.amountPercentage"><span translate="vouchers.promotioncode.save">Save</span> <span>{{$ctrl.appliedPromotionCode.discountAmount}}</span>%</span> <span ng-show="!$ctrl.appliedPromotionCode.amountPercentage"><span translate="vouchers.promotioncode.save">Save</span> <span>{{($ctrl.appliedPromotionCode.discountAmount | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberInteger}}</span><span class="w3-tiny">{{($ctrl.appliedPromotionCode.discountAmount | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberFraction:0:$ctrl.currentCurrency.code}}</span></span> <span class="price-content lighter w3-smaller" style="line-height: normal;text-decoration: line-through"><span class="w3-small">{{$ctrl.currentCurrency.code}}</span> <span ng-if="!$ctrl.singleMode"><span>{{($ctrl.currentVoucherPool.minValue | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}}</span> - <span>{{($ctrl.currentVoucherPool.maxValue | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0 }}</span></span> <span ng-if="$ctrl.singleMode">{{($ctrl.currentVoucherPool.minValue | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}}</span></span></div></div><span class="price-content"><span class="w3-small" style="display: block; line-height: 1">{{$ctrl.currentCurrency.code}}</span> <span ng-if="!$ctrl.singleMode"><span>{{($ctrl.currentVoucherPool.minValueAfterDiscount | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}}</span> - <span>{{($ctrl.currentVoucherPool.maxValueAfterDiscount | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0 }}</span></span> <span ng-if="$ctrl.singleMode">{{($ctrl.currentVoucherPool.minValueAfterDiscount | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}}</span></span></div><div ng-class="$ctrl.settings.viewLayoutTileActive==\'six\' ? \'col-xs-12 w3-center\' : \'col-xs-6\'"><span><button class="in1-button w3-button w3-white w3-border-0 w3-round w3-padding w3-hover-black vobe-buy-button" ng-class="$ctrl.settings.viewLayoutTileActive==\'six\' ? \'\' : \'pull-right\'" role="button"><span translate="vouchers.buttons.buy">Buy</span> <span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span></button></span></div></div></div></footer></div></div>');
$templateCache.put('app/components/vouchers/card/default/card-package-single-default.html','<div style="position: relative;height: 100%" class="no-outline" ng-click="$ctrl.openModal()"><div class="w3-card-2 w3-hover-shadow vobe-cart card-tile card-tiles-{{ $ctrl.tiles }} card-design-{{ $ctrl.viewLayoutTileDesign }}"><div class="reveal-content w3-white"><a class="ui right corner label vobe-bg-generic" ng-click="$ctrl.toggleDescription($event)" ng-style="{\'border-color\' :\n                $ctrl.voucherObjectFirstCategory.isCategory ?\n                $ctrl.voucherObjectFirstCategory.category.colour : \'\',\n                \'color\' : $ctrl.voucherObjectFirstCategory.isCategory ?\n                $ctrl.voucherObjectFirstCategory.category.colour : \'\'}"><span class="icon hand inverted"><span ng-show="!$ctrl.revealedDescription">+</span> <span ng-show="$ctrl.revealedDescription">-</span></span></a><div ng-show="!$ctrl.revealedDescription" class="picture-content"><div class="voucher-bg-img" alt="{{ $ctrl.voucherObject.voucherName }}" ng-class="{\'lazyload\' : true}" data-bg="{{ $ctrl.getImageFileName() }}?fit=crop&h=300&min-w=500&crop=edges&q=70&auto=compress&cs=strip&lossless=true&format=webp"></div></div><div ng-show="$ctrl.revealedDescription" class="description-content"><div class="w3-container w3-text-grey w3-center" style="overflow: hidden"><p ng-bind-html="$ctrl.voucherObject.voucherDescriptionTrustedHtml"></p></div><div class="ellipsis"></div><div class="ellipsis-more"><a class="w3-small w3-text-blue" ng-click="$ctrl.openModal()"><span translate="vouchers.headings.more">More...</span></a></div></div></div><header class="w3-container vobe-bg-generic name-content" ng-class="{\'bigger\' :\n            $ctrl.settings.viewLayoutTileActive==\'three\',\n            \'smaller\' : $ctrl.settings.viewLayoutTileActive==\'six\',\n            \'with-retail\' : ($ctrl.voucherObject.totalRate.priceMin>$ctrl.voucherObject.totalRateAfterDiscount.priceMin)}"><span class="w3-center" style="display: inline-block; vertical-align: middle; line-height: normal"><span class="small vobe-card-title-hn" ng-if="$ctrl.websiteType==\'group\'" style="display: inline-block">{{$ctrl.voucherProperty.hotelName}}</span> <span ng-if="$ctrl.homogeneous" class="vobe-card-title-vn">{{ $ctrl.voucherObject.voucherName }}</span><div ng-if="!$ctrl.homogeneous" class="vobe-card-title-vn" style="margin-bottom: 8px"><span class="vobe-choose-pool-text" translate="vouchers.form.label.choosepool">Please choose one of the following options:</span><select ng-model="$ctrl.voucherObject" ng-options="voucherObject as voucherObject.voucherName for voucherObject in $ctrl.voucherPoolObjectVouchersArray | orderBy:\'sequence\' track by voucherObject.id" ng-click="$ctrl.stopPropagation($event)" ng-change="$ctrl.onVoucherObjectChanged(voucherObject)" class="w3-select" style="text-align:center; text-align-last: center; outline: none"></select></div><span ng-if="($ctrl.voucherObject.totalRate.priceMin>$ctrl.voucherObject.totalRateAfterDiscount.priceMin)\n                && ($ctrl.voucherObject.totalRate.increment == 0)" style="display: block"><span class="w3-small w3-padding-small w3-border-top w3-border-bottom w3-text-gray" style="display: block;border-top-style:dotted !important;border-bottom-style:dotted !important"><span translate="vouchers.headings.price.retail">Retail Value</span>: <span style="display:inline-block">{{ $ctrl.currentCurrency.code }} {{($ctrl.voucherObject.totalRate.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberInteger }}{{($ctrl.voucherObject.totalRate.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberFraction:0:$ctrl.currentCurrency.code }}</span> </span></span><span ng-if="($ctrl.voucherObject.totalRate.priceMin>$ctrl.voucherObject.totalRateAfterDiscount.priceMin)\n                && ($ctrl.voucherObject.totalRate.increment > 0)" style="display: block"><span class="w3-small w3-padding-small w3-border-top w3-border-bottom w3-text-gray" style="display: block"><span translate="vouchers.headings.price.retail">Retail Value</span>: <span style="display:inline-block">{{ $ctrl.currentCurrency.code }} {{($ctrl.voucherObject.totalRate.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency: \'\':0 }} - {{($ctrl.voucherObject.totalRate.priceMax | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency: \'\':0 }}</span></span></span></span></header><div class="w3-container w3-white w3-padding vobe-bg-generic footer-content"><div><div class="row"><div ng-class="$ctrl.settings.viewLayoutTileActive==\'six\' ? \'col-xs-12 w3-center\' : \'col-xs-6\'"><div class="promo-popover top w3-pale-green w3-center w3-text-gray" style="display:block" ng-class="{\'bigger\' :\n                            $ctrl.settings.viewLayoutTileActive==\'three\',\n                            \'smaller\' : $ctrl.settings.viewLayoutTileActive==\'six\'}" ng-show="($ctrl.voucherObject.totalRate.priceMin>$ctrl.voucherObject.totalRateAfterDiscount.priceMin)\n                            && $ctrl.appliedPromotionCode" aria-hidden="false"><div class="arrow"></div><div class="popover-content w3-small" style="padding: 0px 10px"><span ng-show="$ctrl.appliedPromotionCode.amountPercentage"><span translate="vouchers.promotioncode.save">Save</span> <span>{{ $ctrl.appliedPromotionCode.discountAmount }}</span>%</span> <span ng-show="!$ctrl.appliedPromotionCode.amountPercentage"><span translate="vouchers.promotioncode.save">Save</span> <span>{{($ctrl.appliedPromotionCode.discountAmount | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberInteger }}</span><span class="w3-tiny">{{($ctrl.appliedPromotionCode.discountAmount | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberFraction:0:$ctrl.currentCurrency.code }}</span> </span><span class="price-content lighter w3-smaller" style="line-height: normal;text-decoration: line-through"><span class="w3-small">{{$ctrl.currentCurrency.code}}</span> <span ng-if="$ctrl.voucherObject.totalRate.increment > 0"><span>{{($ctrl.voucherObject.totalRate.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}}</span> - <span>{{($ctrl.voucherObject.totalRate.priceMax | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0 }}</span></span> <span ng-if="$ctrl.voucherObject.totalRate.increment == 0">{{($ctrl.voucherObject.totalRate.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}}</span></span></div></div><span class="price-content" ng-if="$ctrl.channel!=20"><div ng-if="$ctrl.voucherObject.totalRate.increment == 0"><span class="w3-small" style="display: block; line-height: 1">{{ $ctrl.currentCurrency.code }}</span> <span>{{($ctrl.voucherObject.totalRateAfterDiscount.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberInteger }}</span><span class="w3-small">{{ ($ctrl.voucherObject.totalRateAfterDiscount.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberFraction:0:$ctrl.currentCurrency.code }}</span></div><div ng-if="$ctrl.voucherObject.totalRate.increment> 0"><span>{{($ctrl.voucherObject.totalRateAfterDiscount.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency: \'\':0 }}</span> - <span>{{($ctrl.voucherObject.totalRateAfterDiscount.priceMax | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency: \'\':0 }}</span> <span class="w3-small" style="display: block; line-height: 1">{{ $ctrl.currentCurrency.code }}</span></div></span><span class="price-content" ng-if="$ctrl.channel==20"><span class="w3-small" style="display: block; line-height: 1">{{ $ctrl.currentCurrency.code }}</span> <span>{{($ctrl.voucherObject.totalRateChannel.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberInteger }}</span><span class="w3-small">{{($ctrl.voucherObject.totalRateChannel.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberFraction:0:$ctrl.currentCurrency.code }}</span></span></div><div ng-class="$ctrl.settings.viewLayoutTileActive==\'six\' ? \'col-xs-12 w3-center\' : \'col-xs-6\'"><span class="" ng-show="$ctrl.isPoolAvailableToBuy()"><button class="in1-button w3-button w3-white w3-border-0 w3-round w3-padding w3-hover-black vobe-buy-button" ng-class="$ctrl.settings.viewLayoutTileActive==\'six\' ? \'\' : \'pull-right\'" role="button"><span translate="vouchers.buttons.buy">Buy</span> <span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span></button></span></div></div></div></div></div></div>');
$templateCache.put('app/components/vouchers/card/text/card-cash-combined-text.html','<div style="position: relative;height:100%" class="no-outline" ng-click="$ctrl.openCashModal({voucherPool:$ctrl.currentVoucherPool, giftCard : $ctrl.giftCard, cashVoucherId: $ctrl.firstVoucher.id})"><div class="w3-card-2 w3-hover-shadow vobe-cart card-tile card-tiles-{{ $ctrl.tiles }} card-design-{{ $ctrl.viewLayoutTileDesign }}"><div class="reveal-content w3-white"><div class="picture-content"><div class="voucher-bg-img" ng-class="{\'lazyload\' : true}" data-bg="{{$ctrl.getImageFileName().includes(\'no-image\') ? \'/content/images/voucher-class-cash.jpg\' :\n\t\t\t$ctrl.getImageFileName()+\'?fit=crop&h=300&min-w=500&crop=edges&q=70&auto=compress&cs=strip&lossless=true&format=webp\'}}" alt="Cash Voucher"></div></div></div><header class="w3-container vobe-bg-generic name-content" ng-class="{\n\t\t\'smaller\' : $ctrl.settings.viewLayoutTileActive==\'six\',\n\t\t\'bigger\' : $ctrl.settings.viewLayoutTileActive==\'three\',\n\t    \'with-retail\' : ($ctrl.currentVoucherPool.minValue>$ctrl.currentVoucherPool.minValueAfterDiscount)}"><div class="w3-center title-text" ng-class="{\n                 \'has-retail-price\' :  ($ctrl.currentVoucherPool.minValue>$ctrl.currentVoucherPool.minValueAfterDiscount),\n                 \'is-group\' : $ctrl.websiteType==\'group\'}"><span class="small vobe-card-title-hn" ng-if="$ctrl.websiteType==\'group\'" style="display: inline-block">{{$ctrl.voucherProperty.hotelName}}</span> <span class="vobe-card-title-vn" ng-if="!$ctrl.giftCard && $ctrl.currentVoucherPool.type==\'cash\'" translate="vouchers.cash.name">Cash Voucher</span> <span class="vobe-card-title-vn" ng-if="!$ctrl.giftCard && $ctrl.currentVoucherPool.type!=\'cash\'">{{$ctrl.firstVoucher.voucherName }}</span><!--<span class="vobe-card-title-vn" ng-if="$ctrl.giftCard"><span>{{$ctrl.giftCard.name}}</span><br/><span translate="vouchers.headings.bymail">By Mail</span></span>--></div><div class="description-text" ellipsis-text="{\n\t\t\t\t\t\t\t        viewLayoutTileActive : $ctrl.settings.viewLayoutTileActive,\n\t\t\t\t\t\t\t        viewLayoutTileDesign : $ctrl.viewLayoutTileDesign,\n\t\t\t\t\t\t\t        descriptionLines : $ctrl.descriptionLines\n\t\t\t\t\t\t\t     }"><div class="w3-text-grey description-text-inner" ellipsis-text-inner style="overflow: hidden"><p ng-bind-html="$ctrl.currentVoucherPool.cashVoucherDescriptionTrustedHtml"></p></div><div class="ellipsis" style="display:none"></div><div class="ellipsis-more" style="display:none"><a class="w3-tiny w3-text-blue" ng-click="$ctrl.openCashModal({voucherPool:$ctrl.currentVoucherPool, giftCard : $ctrl.giftCard, cashVoucherId: $ctrl.firstVoucher.id})"><span translate="vouchers.headings.more">More...</span></a></div></div></header><footer class="w3-container w3-white w3-padding vobe-bg-generic footer-content"><div ng-if="$ctrl.currentVoucherPool.minValue>$ctrl.currentVoucherPool.minValueAfterDiscount" style="display: block; bottom: 40px; position: relative"><span class="w3-small w3-padding-small w3-border-top w3-border-bottom w3-center w3-text-gray" style="display: block;border-top-style:dotted !important;border-bottom-style:dotted !important">Retail Price: <span style="display:inline-block">{{$ctrl.currentCurrency.code}} {{($ctrl.currentVoucherPool.minValue | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}} - {{($ctrl.currentVoucherPool.maxValue | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0 }}</span></span></div><div><div class="row"><div ng-class="$ctrl.settings.viewLayoutTileActive==\'six\' ? \'col-xs-12 w3-center\' : \'col-xs-6\'"><div class="promo-popover top w3-pale-green w3-center w3-text-gray" style="display:block" ng-class="{\'bigger\' : $ctrl.settings.viewLayoutTileActive==\'three\',\n\t           \t\t\t\t   \'smaller\' : $ctrl.settings.viewLayoutTileActive==\'six\'}" ng-show="($ctrl.currentVoucherPool.minValue>$ctrl.currentVoucherPool.minValueAfterDiscount) && $ctrl.appliedPromotionCode" aria-hidden="false"><div class="arrow"></div><div class="popover-content w3-small" style="padding: 0px 10px"><span ng-show="$ctrl.appliedPromotionCode.amountPercentage"><span translate="vouchers.promotioncode.save">Save</span> <span>{{$ctrl.appliedPromotionCode.discountAmount}}</span>%</span> <span ng-show="!$ctrl.appliedPromotionCode.amountPercentage"><span translate="vouchers.promotioncode.save">Save</span> <span>{{$ctrl.appliedPromotionCode.discountAmount | numberInteger}}</span><span class="w3-tiny">{{$ctrl.appliedPromotionCode.discountAmount | numberFraction:0:$ctrl.currentCurrency.code}}</span></span> <span class="price-content lighter w3-smaller" style="line-height: normal;text-decoration: line-through"><span class="w3-small">{{$ctrl.currentCurrency.code}}</span> <span ng-if="!$ctrl.singleMode"><span>{{($ctrl.currentVoucherPool.minValue | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}}</span> - <span>{{($ctrl.currentVoucherPool.maxValue | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0 }}</span></span> <span ng-if="$ctrl.singleMode">{{($ctrl.currentVoucherPool.minValue | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}}</span></span></div></div><span class="price-content"><span class="w3-small" style="display: block; line-height: 1">{{$ctrl.currentCurrency.code}}</span> <span ng-if="!$ctrl.singleMode"><span>{{($ctrl.currentVoucherPool.minValueAfterDiscount | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}}</span> - <span>{{($ctrl.currentVoucherPool.maxValueAfterDiscount | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0 }}</span></span> <span ng-if="$ctrl.singleMode">{{($ctrl.currentVoucherPool.minValueAfterDiscount | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}}</span></span></div><div ng-class="$ctrl.settings.viewLayoutTileActive==\'six\' ? \'col-xs-12 w3-center\' : \'col-xs-6\'"><span><button class="in1-button w3-button w3-white w3-border-0 w3-round w3-padding w3-hover-black vobe-buy-button" ng-class="$ctrl.settings.viewLayoutTileActive==\'six\' ? \'\' : \'pull-right\'" role="button"><span translate="vouchers.buttons.buy">Buy</span> <span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span></button></span></div></div></div></footer></div></div>');
$templateCache.put('app/components/vouchers/card/text/card-package-single-text.html','<div style="position: relative;height:100%" class="no-outline" ng-click="$ctrl.openPackageModal({voucherPool:$ctrl.voucherPoolObject, voucherId: $ctrl.voucherObject.id})" data-vobe-action="item_card_click"><div class="w3-card-2 w3-hover-shadow vobe-cart card-tile card-tiles-{{ $ctrl.tiles }} card-design-{{ $ctrl.viewLayoutTileDesign }}"><div class="reveal-content w3-white"><div class="picture-content"><div class="voucher-bg-img" ng-class="{\'lazyload\' : true}" data-bg="{{$ctrl.getImageFileName()+\'?fit=crop&h=300&min-w=500&crop=edges&q=70&auto=compress&cs=strip&lossless=true&format=webp\'}}" alt="{{$ctrl.voucherObject.voucherName}}"></div></div></div><header class="w3-container vobe-bg-generic name-content" ng-class="{\'bigger\' :\n\t$ctrl.settings.viewLayoutTileActive==\'three\',\n\t\'smaller\' : $ctrl.settings.viewLayoutTileActive==\'six\',\n\t\'with-retail\' : ($ctrl.voucherObject.totalRate.priceMin>$ctrl.voucherObject.totalRateAfterDiscount.priceMin)}"><div class="w3-center title-text" ng-class="{\n                 \'has-retail-price\' : ($ctrl.voucherObject.totalRate.priceMin>$ctrl.voucherObject.totalRateAfterDiscount.priceMin),\n                 \'has-pool\' : (!$ctrl.homogeneous),\n                 \'has-category-pool\' : (!$ctrl.homogeneous  && $ctrl.poolCategory),\n                 \'is-group\' : $ctrl.websiteType==\'group\'}"><span class="small vobe-card-title-hn" ng-if="$ctrl.websiteType==\'group\'" style="display: inline-block">{{$ctrl.voucherProperty.hotelName}}</span> <span ng-if="$ctrl.homogeneous" class="vobe-card-title-vn">{{ $ctrl.voucherObject.voucherName }}</span> <span ng-if="!$ctrl.homogeneous && $ctrl.poolCategory" class="vobe-card-title-vn">{{ $ctrl.poolCategory.name }}</span><div ng-if="!$ctrl.homogeneous" class="vobe-card-title-vn variation-select"><span class="vobe-choose-pool-text" translate="vouchers.form.label.choosepool">Please choose one of the following options:</span><select ng-model="$ctrl.voucherObject" ng-options="voucherObject as voucherObject.variationName for voucherObject in $ctrl.voucherPoolObjectVouchersArray | orderBy:\'sequence\' track by voucherObject.id" ng-click="$ctrl.stopPropagation($event)" ng-change="$ctrl.onVoucherObjectChanged(voucherObject)" class="w3-select" style="text-align:center; text-align-last: center; outline: none"></select></div></div><div class="description-text" ellipsis-text="{\n\t\t\t\t\t\t\t        viewLayoutTileActive : $ctrl.settings.viewLayoutTileActive,\n\t\t\t\t\t\t\t        viewLayoutTileDesign : $ctrl.viewLayoutTileDesign,\n\t\t\t\t\t\t\t        descriptionLines : $ctrl.descriptionLines\n\t\t\t\t\t\t\t     }"><div class="w3-text-grey description-text-inner" ellipsis-text-inner style="overflow: hidden"><p ng-bind-html="$ctrl.voucherObject.voucherDescriptionTrustedHtml"></p><p ng-if="$ctrl.onlyFeatured" ng-bind-html="$ctrl.voucherObject.voucherDescription2TrustedHtml"></p></div><div class="ellipsis" style="display:none"></div><div class="ellipsis-more" style="display:none"><a class="w3-small w3-text-blue" ng-click="$ctrl.openPackageModal({voucherPool:$ctrl.voucherPoolObject, voucherId: vm.voucherObject.id})" data-vobe-action="more_text_click"><span translate="vouchers.headings.more">More...</span></a></div></div></header><footer class="w3-container w3-white w3-padding-16 vobe-bg-generic footer-content"><div ng-if="($ctrl.voucherObject.totalRate.priceMin>$ctrl.voucherObject.totalRateAfterDiscount.priceMin)" style="display: block; bottom: 40px; position: relative"><span class="w3-small w3-padding-small w3-border-top w3-border-bottom w3-center w3-text-gray" style="display: block;border-top-style:dotted !important;border-bottom-style:dotted !important"><span translate="vouchers.headings.price.retail">Retail Value</span>: <span style="display:inline-block">{{$ctrl.currentCurrency.code}} {{($ctrl.voucherObject.totalRate.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberInteger}}{{($ctrl.voucherObject.totalRate.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberFraction:0:$ctrl.currentCurrency.code}}</span></span></div><div><div class="row"><div ng-class="$ctrl.settings.viewLayoutTileActive==\'six\' ? \'col-xs-12 w3-center\' : \'col-xs-6\'"><div class="promo-popover top w3-pale-green w3-center w3-text-gray" style="display:block" ng-class="{\'bigger\' :\n\t\t\t\t\t$ctrl.settings.viewLayoutTileActive==\'three\',\n\t\t\t\t\t\'smaller\' : $ctrl.settings.viewLayoutTileActive==\'six\'}" ng-show="($ctrl.voucherObject.totalRate.priceMin>$ctrl.voucherObject.totalRateAfterDiscount.priceMin)\n\t\t\t\t\t&& $ctrl.appliedPromotionCode" aria-hidden="false"><div class="arrow"></div><div class="popover-content w3-small" style="padding: 0px 10px"><span ng-show="$ctrl.appliedPromotionCode.amountPercentage"><span translate="vouchers.promotioncode.save">Save</span> <span>{{$ctrl.appliedPromotionCode.discountAmount}}</span>%</span> <span ng-show="!$ctrl.appliedPromotionCode.amountPercentage"><span translate="vouchers.promotioncode.save">Save</span> <span>{{$ctrl.appliedPromotionCode.discountAmount | numberInteger}}</span><span class="w3-tiny">{{$ctrl.appliedPromotionCode.discountAmount | numberFraction:0:$ctrl.currentCurrency.code}}</span> </span><span class="price-content lighter w3-smaller" style="line-height: normal;text-decoration: line-through"><span class="w3-small">{{$ctrl.currentCurrency.code}}</span> <span ng-if="$ctrl.voucherObject.totalRate.increment > 0"><span>{{($ctrl.voucherObject.totalRate.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}}</span> - <span>{{($ctrl.voucherObject.totalRate.priceMax | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0 }}</span></span> <span ng-if="$ctrl.voucherObject.totalRate.increment == 0">{{($ctrl.voucherObject.totalRate.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}}</span></span></div></div><span class="price-content" ng-show="$ctrl.channel!=20"><div ng-if="$ctrl.voucherObject.totalRate.increment == 0"><span class="w3-small" style="display: block; line-height: 1">{{$ctrl.currentCurrency.code}}</span> <span>{{($ctrl.voucherObject.totalRateAfterDiscount.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberInteger}}</span><span class="w3-small">{{($ctrl.voucherObject.totalRateAfterDiscount.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberFraction:0:$ctrl.currentCurrency.code}}</span></div><div ng-if="$ctrl.voucherObject.totalRate.increment> 0"><span class="w3-small" style="display: block; line-height: 1">{{$ctrl.currentCurrency.code}}</span> <span>{{($ctrl.voucherObject.totalRateAfterDiscount.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0}}</span> - <span>{{($ctrl.voucherObject.totalRateAfterDiscount.priceMax | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | currency:\'\':0 }}</span></div></span><span class="price-content" ng-show="$ctrl.channel==20"><span class="w3-small" style="display: block; line-height: 1">{{$ctrl.currentCurrency.code}}</span> <span>{{($ctrl.voucherObject.totalRateChannel.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberInteger}}</span> <span class="w3-small">{{($ctrl.voucherObject.totalRateChannel.priceMin | exchangenumber:$ctrl.baseCurrency.code:$ctrl.currentCurrency.code) | numberFraction:0:$ctrl.currentCurrency.code}}</span></span></div><div ng-class="$ctrl.settings.viewLayoutTileActive==\'six\' ? \'col-xs-12 w3-center\' : \'col-xs-6\'"><span class="" ng-show="$ctrl.isPoolAvailableToBuy()"><button class="in1-button w3-button w3-white w3-border-0 w3-round w3-padding w3-hover-black vobe-buy-button" ng-class="$ctrl.settings.viewLayoutTileActive==\'six\' ? \'\' : \'pull-right\'" role="button" data-vobe-action="item_card_buy_button_click"><span translate="vouchers.buttons.buy">Buy</span> <span class="glyphicon glyphicon-shopping-cart" aria-hidden="true"></span></button></span></div></div></div></footer></div></div>');
$templateCache.put('app/site/property/vouchers/language/language-dropdown.html','<li ui-sref-active="active" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li>');}]);})();